const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Background Tsukuyomi",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Gagal dikeluarkan karena aset scene terlalu banyak. Mohon apus beberapa aset dan coba kembali.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Sekarang tidak memiliki izin untuk mengakses fitur terkait membership",
  T_12_I_GIFT_SENDER_BELL: "Bell",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "Sekarang kamu melihat dia, sekarang tidak. [FFB300](Tidak tertutup helm)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Old Man's Mask",
  T_12_L_COS_PINKMAN: "Pink Dino",
  T_12_L_COS_POLAR: "Polar Bear",
  T_12_L_COS_RENDER: "Rainbow Dino",
  T_12_L_COS_TIGER: "Tiger Suit",
  T_12_L_MALE_BOTTOM_COS_ELF: "Winter Elf (Celana)",
  T_12_L_MALE_COS_SANTA: "Grumpy Old Man",
  T_12_L_MALE_HAIR_COS_ELF: "Winter Elf (Kepala)",
  T_12_L_MALE_SHOE_COS_ELF: "Winter Elf (Sepatu)",
  T_12_L_MALE_TOP_COS_ELF: "Winter Elf (Baju)",
  T_12_O_CAT_NAME: "Kitty",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014-Winterlands",
  T_12_O_MACHETE_GOLD_NAME: "Golden Blade",
  T_12_O_PET_TITLE: "PET",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Jumping Shoes",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Sepatu yang terbuat dari teknologi modern. Membuat manusia dapat melompat 2x lipat.",
  T_12_Q_ITEM_FLYSHOE: "Jet Pack Shoes",
  T_12_Q_ITEM_FLYSHOE_DESC: "Sepatu yang dapat membuat penggunanya terbang. Pastikan kamu tidak kehabisan bahan bakar saat mengudara.",
  T_12_Q_ITEM_STOCK1: "Stock Lv 1",
  T_12_Q_ITEM_STOCK2: "Stock Lv 2",
  T_12_Q_ITEM_STOCK3: "Stock Lv 3",
  T_12_Q_ITEM_TREATMENTGUN: "Heal Pistol",
  T_12_Q_ITEM_VEST4: "Vest Lv4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Shoot Dance",
  T_12_R_EMOTE_WAVE_NAME: "Arm Wave",
  T_12_R_SKILL_NAME_GANGLEADER: "Gangster's Spirit",
  T_12_R_SKILL_NAME_MONKEYGOD: "Camouflage",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Amphibian Car",
  T_13_I_COLLECTION_V_JEEP: "Jeep",
  T_13_I_COLLECTION_V_MONSTER: "Monster Truck",
  T_13_I_COLLECTION_V_MOTOBIKE: "Motorbike",
  T_13_I_COLLECTION_V_ROADSTER: "Sports Car",
  T_13_I_COLLECTION_V_SUV: "Pickup Truck",
  T_13_I_COLLECTION_V_TUTU: "Tuk Tuk Car",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Arctic Blue (Mask)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Love in the Air (Bottom)",
  T_13_L_MALE_HAIR_COS_BJD: "Arctic Blue (Head)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Love in the Air (Top)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Weapon",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Pet Skin: Detective Kitty",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR- Cupid",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Baby Shark",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Push-up",
  T_13_R_EMOTE_EGYPT_NAME: "Mummy Dance",
  T_13_R_PVE_WEAPON_SLOT: "Slot Senjata",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Jarak Efektif",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Fire Rate",
  T_13_R_SKILL_DESC_HACKERGIRL: "Menandai musuh yang tertembak selama [FFB300]{0} detik[-]. Tanda dapat dilihat oleh rekan setim.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Hacker's Eye",
  T_13_Z_KICKOFF_BAN: "BAN",
  T_13_Z_ROOM_MORNING: "Siang",
  T_13_Z_ROOM_NIGHT: "Malam",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "SPLASH!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Cubic Bunny",
  T_14_L_COS_EASTER: "Observer 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Lady of Flame (Shoes)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Bunny Warrior (Mask)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47- Water Balloon",
  T_14_O_DOG_NAME: "Mechanical Pup",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Pet Skin: Full Steel Pup",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Pet Skin: Lightning Pup",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Pet Skin: Magnetic Pup",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Pet Skin: Night Kitty",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR-Blood Moon",
  T_14_O_SCAR_SHARK_NAME: "SCAR- Shark Attack",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "Dengan setiap penurunan [FFB300]{0}%[-] HP, penetrasi armor meningkat sebesar [FFB300]{1}%[-].",
  T_14_R_SKILL_NAME_SAMURAI: "Bushido",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Hunger Strkie (Mask)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Venom Touch (Mask)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Hunger Strkie (Bottom)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Venom Touch (Bottom)",
  T_15_L_MALE_SHOE_COS_FAIM: "Hunger Strkie (Shoes)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Venom Touch (Shoes)",
  T_15_L_MALE_TOP_COS_FAIM: "Hunger Strkie (Top)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Venom Touch (Top)",
  T_15_L_TOP_COS_MOTHERSDAY: "Best Mom",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94- Cataclysm",
  T_15_O_BASEBALLBAT_VIKING_NAME: "The Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014- Cataclysm",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1- Cataclysm",
  T_15_O_PANTHER_NAME: "Night Panther",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Pet Skin: Captain",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Pet Skin: Golden Leopard",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Pet Skin: Domination",
  T_15_O_SKS_DEATH_NAME: "SKS- Death Wish",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP- Cataclysm",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "GATLING",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Shake With Me",
  T_15_R_SKILL_DESC_AGENT: "Akurasi meningkat sebesar [FFB300]{0}%[-] ketika menggunakan scope.",
  T_15_R_SKILL_NAME_AGENT: "Sharp Shooter",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Purple Wings",
  T_16_B_ITEM_GRAPPLINGHOOK: "Hook",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Hook Gun",
  T_16_L_MALE_COS_LEGO: "Mad Brickman",
  T_16_L_MALE_SHOE_COS_SUMMER: "Summer Holidays (Shoes)",
  T_16_P_MANUAL_MONSTER: "Monster Truck",
  T_16_P_MANUAL_MUSHROOM1: "Mushroom Lv1",
  T_16_P_MANUAL_MUSHROOM2: "Mushroom Lv2",
  T_16_P_MANUAL_MUSHROOM3: "Mushroom Lv3",
  T_16_P_MANUAL_MUSHROOM4: "Mushroom Lv4",
  T_16_P_MANUAL_ROADSTER_DESC: "Mobil sport yang stylish. Renda HP tapi memiliki kecepatan yang tinggi. Bisa membawa hingga 2 pemain.",
  T_16_P_MANUAL_STROP: "Zip line",
  T_16_P_MANUAL_SUV: "Pickup Truck",
  T_16_P_MANUAL_SUV_DESC: "Kendaraan khas Free Fire. Medium armor dan kecepatan tinggi. Bisa membawa hingga 2 pemain.",
  T_16_P_MANUAL_TUTU_DESC: "Kendaraan dengan HP rendah dan movement yang pelan. Bisa membawa hingga 3 pemain.",
  T_16_P_MANUAL_WEAPON_AR: "Rifle",
  T_16_P_MANUAL_WEAPON_BOMB: "Grenades",
  T_16_P_MANUAL_WEAPON_PISTOL: "Pistol",
  T_16_P_MANUAL_WEAPON_SG: "Shotgun",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "Sniper",
  T_16_Q_MINISENTRY: "Mini Turret",
  T_16_Q_MINISENTRY_DESC: "Auto turret terbuat dari teknologi modern. Ini akan melakukan scan dan menyerang musuh terdekat.",
  T_16_R_EMOTE_DESERT_NAME: "Furious Slam",
  T_16_R_EMOTE_EPHUNTER_NAME: "Battle Dance",
  T_16_R_EMOTE_EPHUNTER2_NAME: "High Five",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Moon Flip",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Wiggle walk",
  T_16_W_AK_FIRE_NAME: "AK47- Flaming Red",
  T_16_W_SCAR_LLENN_NAME: "SCAR- Pink Devil",
  T_16_W_SCAR_WATER_NAME: "SCAR- Water Elemental",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Pet Skin: Wild Panda",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Pet Skin: Skull Panda",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Pet Skin: Lightning Panda",
  T_17_B_CS_MODE_NAME: "Clash Squad",
  T_17_C_SKILL_NAME_PLAYBOY: "Nutty Movement",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Royal Jester (Mask)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Bloody Mistress (Mask)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Bloody Mistress (Bottom)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Magical Fox (Head)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Bloody Mistress (Shoes)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Bloody Mistress (Top)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vampire's Revenge (Mask)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Street Thug (Bottom)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vampire's Revenge (Bottom)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Purple Shade (Head)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "The Gentleman (Shoes)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vampire's Revenge (Shoes)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vampire's Revenge (Top)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Golden Shade (Top)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Pet Skin: Meow Princess",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Pet Skin: Golden Tale",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Pet Skin: Deep Blue",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Pet Skin: Lucky Green",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Glider",
  T_17_Q_FOLDWINGS_DESC: "Memungkinkan kamu untuk meluncur turun dari dataran tinggi.",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Party Dance",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS- Vampire",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR- Phantom Assassin",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR- Old Fashioned",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Nama",
  T_17_Z_ROOM_JUMP_SWITCH: "Jump Height",
  T_17_Z_ROOM_SPEED_SWITCH: "Kecepatan Gerak",
  T_18_B_THROWINGKNIFE_NAME: "FF Knife",
  T_18_C_DUMMY_NAME: "Decoy Grenade",
  T_18_C_SKILL_DESC_DJMALE: "Membuat [FFB300]{1}m[-] aura yang bisa meningkatkan kecepatan berlari [FFB300]{3}%[-] dan memberikan [FFB300]{2}HP/dtk[-] selama [FFB300]{0} dtk[-]. Effect tidak menumpuk. Cooldown: [FFB300]{4} dtk[-].",
  T_18_C_SKILL_NAME_DJMALE: "Drop the Beat",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Gear Recycle",
  T_18_L_COS_INDIANEWYEAR: "Diwali Dino",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Frowny Face",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Flaming Red (Mask)",
  T_18_O_FOX_NAME: "Spirit Fox",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Pet Skin: Battle Fox",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Pet Skin: Blue Fox",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Pet Skin: Lava Pumpkin",
  T_18_O_PETSKIN_PINKFOX_NAME: "Pet Skin: Red Fox",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Pet Skin: Spirit",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1- Flaming Skull",
  T_18_W_UMP_GEISHA_N: "UMP- Art of War",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Electric Surfboard",
  T_19_C_ICE_GUN_NAME: "Ice Gun",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Damage senjata explosive meningkat [FFB300]{0}%[-], jarak serangan meningkat [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "Selama menyetir, berikan [FFB300]{1} HP[-] setiap [FFB300]{0} detik[-] untuk semua orang di kendaraan hingga maksimum [FFB300]{2}[-] HP.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Art of Demolition",
  T_19_C_SKILL_NAME_TOMBOY: "Racer's Blessing",
  T_19_I_EVENT_INFI_ITEM: "Unlimited",
  T_19_L_A_ICEFESTIVAL19_B: "Last Laugh",
  T_19_L_F_S_ICEFESTIVAL: "Snowy Servitude (Shoes)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disco Fiasco (Bottom)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disco Fiasco (Head)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disco Fiasco (Top)",
  T_19_O_PETSKIN_NAME: "Pet Skin: Default",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Pet Skin: Hiphop Panda",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Pet Skin: Polar Panda",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Pet Skin: Pharaoh's Robo",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Pet Skin: Spring Festival Robo",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Pet Skin: Snowy Robo",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Pet Skin: Hiphop Shiba",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "Team Deathmatch",
  T_19_R_EMOTE_MIGUEL_NAME: "Break dance",
  T_19_S_SECOND_WEAPON_TITLE: "Senjata kedua",
  T_19_S_VEST_TITLE: "Bulletproof Vest",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Double Magazine",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA- Tagger's Revolt",
  T_19_W_M60_ICEFESTIVAL_N: "M60- Santa's Choice",
  T_19_W_MP40_PARK_N: "MP40- Carnival Carnage",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR- Aurous Dragon",
  T_19_X_PVE_SAMURAINAME: "Guardian Samurai",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inhaler",
  T_20_C_SKILL_DESC_PARKOURGUY: "Ketika menggunakan senjata api, menembak musuh menyembuhkan sebagian HP untuk user, knock down musuh menyembuhkan [FFB300]{0}%[-] HP untuk user.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Painted Refuge",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Deadly Velocity",
  T_20_C_SKILL_NAME_PARKOURGUY: "Sustained Raids",
  T_20_L_A_APRILFOOL2020: "Doggo",
  T_20_L_F_A_METALHEAD_RED: "Ms. Fiery Imp-Head (Mask)",
  T_20_L_F_B_THAIGIRL: "Phoenix Accession (Bottom)",
  T_20_L_F_H_KILLERCUPID: "Sweetheart Cupid (Head)",
  T_20_L_F_H_THAIGIRL: "Phoenix Accession (Head)",
  T_20_L_F_S_THAIGIRL: "Phoenix Accession (Shoes)",
  T_20_L_F_T_METALHEAD_RED: "Ms. Fiery Imp-Head (Top)",
  T_20_L_F_T_THAIGIRL: "Phoenix Accession (Top)",
  T_20_L_JEANDINO: "Denim Dino",
  T_20_L_M_A_METALHEAD_RED: "Mr. Fiery Imp-Head (Mask)",
  T_20_L_M_T_METALHEAD_RED: "Mr. Fiery Imp-Head (Top)",
  T_20_L_M_T_STOCKING: "Gentle-man (Top)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Pet Skin: Valentine's Fox",
  T_20_P_CHANNEL_G: "Guild",
  T_20_P_WORLD_SSPEAKER: "Loudspeaker",
  T_20_S_CSROOM_COIN: "Default coin",
  T_20_U_SHIELD_GUN_NAME: "Shield Gun",
  T_20_W_AN94_METALHEAD_N: "AN94- Carrot Imp-Head",
  T_20_W_P90_EVILBONE_N: "P90- The Punishers",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly "the Swift"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Menghasilkan asap, bagus untuk menyamar dan mengelabui musuh",
  T_21_B_SMOKEGRENADE_NAME: "Smoke Grenade",
  T_21_C_AUTOPICKUP_AVERAGE: "Default",
  T_21_C_SKILL_DESC_KPOPSINGER: "Ketika membangunkan teman tim, memberikan teman tersebut [FFB300]{0} HP[-] shield dan [FFB300]{1}%[-] peningkatan kecepatan gerak. Peningkatan menurun dalam [FFB300]{2} detik[-] setelah berhasil membangunkan. Mengurangi kecepatan pengurangan darah teman yang jatuh sebesar [FFB300]{3}%[-]. Efek tidak menumpuk.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Setiap eliminasi meningkatkan maks HP sebesar [FFB300]{0}[-]. Peningkatan maks: [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "Healing Song",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Hat Trick",
  T_21_L_ANGELICAL: "Angel Dino",
  T_21_L_S_VNSLIPPER: "Vietnam Slippers",
  T_21_O_OTTER_NAME: "Ottero",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Pet Skin: Radioactive Ottero",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Pet Skin: Sakura Ottero",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Pet Skin: Neon Ottero",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Pet Skin: Master of Death",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Pet Skin: Lightning Bolt",
  T_21_R_EMOTE_SORROW_NAME: "Why? Oh Why?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Punkster Backpack",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Death's Final Strike",
  T_21_W_M79_RABBITKILLER_N: "M79- Hipster Bunny",
  T_21_W_PAN_VOLCANO_N: "Pan- Volcanic Fury",
  T_21_W_XM8_RAINBOW_N: "XM8- Abyssal",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Temukan posisi musuh dalam jarak [FFB300]{0}m[-] yang tidak dalam posisi tengkurap atau jongkok. Berlangsung selama [FFB300]{1}dtk[-]. Posisi musuh dibagi dengan rekan satu tim. Cooldown: [FFB300]{2} detik[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "Tracing Steps",
  T_22_C_SKILL_NAME_STREAMERGUY: "Limelight",
  T_22_L_F_H_COLLEGE: "Bloodshot Junior (Hair)",
  T_22_L_F_S_SUMMER20: "Summer Darling (Shoes)",
  T_22_L_M_A_GREENCOAT: "Lush Clubber (Mask)",
  T_22_L_M_A_PINKFUR: "Sakura Clubber (Mask)",
  T_22_L_M_A_PLAGUE2: "Plague Phantom (Mask)",
  T_22_L_M_B_FAIM2: "Famine Felon (Bottom)",
  T_22_L_M_B_GREENCOAT: "Lush Clubber (Bottom)",
  T_22_L_M_B_PINKFUR: "Sakura Clubber (Bottom)",
  T_22_L_M_B_PLAGUE2: "Plague Phantom (Bottom)",
  T_22_L_M_B_REDPANTS: "Trendy Clubber (Bottom)",
  T_22_L_M_B_TIGERSTRIPE: "Tiger Clubber (Bottom)",
  T_22_L_M_H_COLLEGE: "Bloodshot Senior (Hair)",
  T_22_L_M_H_FAIM2: "Famine Felon (Hair)",
  T_22_L_M_H_GREENCOAT: "Lush Clubber (Hair)",
  T_22_L_M_H_PINKFUR: "Sakura Clubber (Hair)",
  T_22_L_M_H_PLAGUE2: "Plague Phantom (Hair)",
  T_22_L_M_H_REDPANTS: "Trendy Clubber(Hair)",
  T_22_L_M_H_TIGERSTRIPE: "Tiger Clubber (Hair)",
  T_22_L_M_S_FAIM2: "Famine Felon (Shoes)",
  T_22_L_M_S_PLAGUE2: "Plague Phantom (Shoes)",
  T_22_L_M_T_FAIM2: "Famine Felon (Top)",
  T_22_L_M_T_GREENCOAT: "Lush Clubber (Top)",
  T_22_L_M_T_PINKFUR: "Sakura Clubber (Top)",
  T_22_L_M_T_PLAGUE2: "Plague Phantom (Top)",
  T_22_L_M_T_REDPANTS: "Trendy Clubber (Top)",
  T_22_L_M_T_TIGERSTRIPE: "Tiger Clubber (Top)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K- Rebel Academy",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Pan- Watermelon",
  T_22_LC_SCAR_HERMIT_N: "SCAR- Mystic Seeker",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Heal Pistol- Lifebeam",
  T_22_O_HAWK_NAME: "Falco",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Pet Skin: Apocalypse Fox",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Pet Skin: Hellfire Falco",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Pet Skin: Evergreen Falco",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Pet Skin: Sunshine Shiba",
  T_22_Q_BOMB_PLIERS: "Defusion Pliers",
  T_22_R_EMOTE_SHIMMY_NAME: "Shimmy",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Armor Penetration",
  T_22_U_WPNSKN_SPEED_RUN: "Kecepatan Gerak",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Horizaline",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Art of Blades",
  T_23_C_SKILL_NAME_SWATGUY: "Raging Reload",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Firebrand"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Big Bucks Vibe (Bottom)",
  T_23_L_F_B_MIKOGIRL: "Arcticfire Priestess (Bottom)",
  T_23_L_F_B_NAVYGIRL: "Navy Girl (Bottom)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Big Bucks Vibe (Head)",
  T_23_L_F_H_MIKOGIRL: "Arcticfire Priestess (Head)",
  T_23_L_F_H_NAVYGIRL: "Navy Girl (Head)",
  T_23_L_F_S_MIKOGIRL: "Arcticfire Priestess (Shoes)",
  T_23_L_F_S_ORDERCHALLENGER: "Heist Mastermind (Shoes)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Big Bucks Vibe (Top)",
  T_23_L_F_T_MIKOGIRL: "Arcticfire Priestess (Top)",
  T_23_L_F_T_NAVYGIRL: "Navy Girl (Top)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Big Bucks Rapper (Mask)",
  T_23_L_M_B_FOXGUY: "Arcticfire Priest (Bottom)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Big Bucks Rapper (Bottom)",
  T_23_L_M_H_FOXGUY: "Arcticfire Priest (Head)",
  T_23_LC_SKS_GEMINI_N: "SKS- Hysteria",
  T_23_O_PENGUIN_NAME: "Mr. Waggor",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Pet Skin: Party Waggor",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Pet Skin: Cyber Waggor",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Pet Skin: Gold Waggor",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Clash Squad",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Character",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "WARNING",
  T_24_C_FLAMETHROWER_NAME: "Flamethrower",
  T_24_C_SKILL_DESC_PROFESSOR: "Max EP meningkat sebesar [FFB300]{0}[-]. Mode Jiu-jitsu: Teman satu tim dalam jarak [FFB300]{2}m[-] mendapatkan peningkatan rasio konversi EP sebesar [FFB300]{1}%[-]. Mode Psikologi: Pulihkan [FFB300]{5} EP[-] setiap [FFB300]{4} detik[-], hingga [FFB300]{6} EP[-]. Cooldown tukar mode: [FFB300]{3} detik[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "Partying On",
  T_24_C_SKILL_NAME_PROFESSOR: "Master of All",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "MAX Pants",
  T_24_L_H_PUMPKIN2020_A: "Twisted Pumpkin (Head)",
  T_24_L_T_TSHIRT_COMEDIAN: "Last Shot Hero",
  T_24_LC_MP5_RICHBOXER_N: "MP5- Champion Boxer",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR- Party Animal",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- Swordsman Legends",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Total Skor",
  T_24_V_TRAINING_BOX_ATTACH: "Attachments",
  T_24_V_TRAINING_BOX_WEAPON: "Senjata",
  T_24_W_ARMORY: "Senjata",
  T_24_W_ARMOTY_MELEE: "Melee",
  T_24_W_ARMOTY_PISTOL: "Pistols",
  T_24_W_ARMOTY_RIFLE: "Rifles",
  T_24_W_ARMOTY_SHOTGUN: "Shotguns",
  T_24_W_ARMOTY_SNIPER: "Snipers",
  T_24_W_ARMOTY_SPECIAL: "Lainnya",
  T_24_W_ARMOTY_SUBMACHINE: "Sub-Machine Gun",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Petskin: Booyah Panda",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Petskin: Skeleton Rockie",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Petskin: Party Rockie",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Petskin: Undead Rockie",
  T_24_W_RACCOON_N: "Rockie",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Time Turner",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Preset 1",
  T_25_E_HUD_02: "Preset 2",
  T_25_L_F_B_DEMONKILLER: "Frenzy Junior (Bottom)",
  T_25_L_F_H_DEMONKILLER: "Frenzy Junior (Head)",
  T_25_L_F_S_DEMONKILLER: "Frenzy Junior (Shoes)",
  T_25_L_F_T_DEMONKILLER: "Frenzy Junior (Top)",
  T_25_L_HA_FP_EVIL: "Evil (Facepaint)",
  T_25_L_M_H_ANIMEHAIR: "Breezy (Hair)",
  T_25_L_S_MAXSNEAKERS: "MAX Sneakers",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "Gloo Wall- Winterlands 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887- Winterlands 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Cyber Blade",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90- Tune Blaster Green",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- Tune Blaster Red",
  T_25_LC_PAN_BOUNTY_N: "Pan- Cyber Bounty Hunter",
  T_25_R_LEGEND_REMIND: "Pengingat",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Scythe",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Beaston",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Petskin: Glacier Beaston",
  T_25_W_PETSKIN_BABOON_HELL_N: "Petskin: Blazing Beaston",
  T_25_W_PETSKIN_BABOON_PURE_N: "Petskin: Great White Beaston",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Petskin: Snow Panther",
  T_25_Z_R_SIMULATOR_OFF: "Disallow",
  T_26_C_SKILL_DESC_SUPERSTAR: "Melepaskan gelombang sonik ke depan dalam jarak [FFB300]{0}m[-]. Gelombang meledak dan memberikan damage ke Gloo Wall dalam radius [FFB300]{1}m[-] selama [FFB300]{2} detik[-]. Cooldown: [FFB300]{3} detik[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "Riptide Rhythm",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "UAV-Lite",
  T_26_L_A_FLAMING_PREM: "Infernal Soldier (Mask)",
  T_26_L_A_SANTAMODE: "Snowman Bob (Mask)",
  T_26_L_B_SANTAMODE: "Snowman Bob (Bottom)",
  T_26_L_F_B_WATERFEST21_A: "Summer Breeze (Bottom)",
  T_26_L_F_H_WATERFEST21_A: "Summer Breeze (Head)",
  T_26_L_F_S_WATERFEST21_A: "Summer Breeze (Shoes)",
  T_26_L_F_T_WATERFEST21_A: "Summer Breeze (Top)",
  T_26_L_M_A_EGGDAY2021: "Cyber Bunny (Mask)",
  T_26_L_M_B_EGGDAY2021: "Cyber Bunny (Bottom)",
  T_26_L_M_B_PAIRING: "Dynamic Duo M (Bottom)",
  T_26_L_M_B_WATERFEST21_A: "Summer Wave (Bottom)",
  T_26_L_M_H_EGGDAY2021: "Cyber Bunny (Head)",
  T_26_L_M_H_PAIRING: "Dynamic Duo M (Head)",
  T_26_L_M_H_WATERFEST21_A: "Summer Wave (Head)",
  T_26_L_M_S_EGGDAY2021: "Cyber Bunny (Shoes)",
  T_26_L_M_S_PAIRING: "Dynamic Duo M (Shoes)",
  T_26_L_M_S_WATERFEST21_A: "Summer Wave (Shoes)",
  T_26_L_M_T_EGGDAY2021: "Cyber Bunny (Top)",
  T_26_L_M_T_PAIRING: "Dynamic Duo M (Top)",
  T_26_L_M_T_WATERFEST21_A: "Summer Wave (Top)",
  T_26_L_S_SANTAMODE: "Snowman Bob (Shoes)",
  T_26_L_T_SANTAMODE: "Snowman Bob (Top)",
  T_26_LC_AWM_KOICARP_N: "AWM- Lucky Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana- Season of Pink",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Sports Car- Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "Damage Delivered",
  T_26_V_TRAINING_BHH: "Fancy Hammer",
  T_26_V_TRAINING_DICE: "Dadu Besar",
  T_26_W_DRAGON_N: "Dreki",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Petskin: Splashy Dreki",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Petskin: Zapping Dreki",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Petskin: Galaxy Dreki",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Pet Skin: Waggor in Love",
  T_26_XL_SETTING_TEAMMATE_INFO: "Info teman setim",
  T_26_YP_HISTORY_WIN: "Menang",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Wanita",
  T_26_YP_SOCIAL_GENDER_MALE: "Pria",
  T_26_YP_SOCIAL_NAME: "Nickname",
  T_27_C_SKILL_DESC__RACERGIRL: "Kecepatan mengemudi meningkat sebesar [FFB300]{0}%[-]. Selama di dalam kendaraan, karakter lebih sulit untuk dibidik, dan damage yang diterima berkurang sebesar [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Membuat medan gaya yang memblokir [FFB300]{0} damage[-]. Tidak bisa menyerang musuh dari dalam. Semua efek bertahan selama [FFB300]{1} detik[-]. Cooldown [FFB300]{2} detik[-].",
  T_27_C_SKILL_DESC_FALCONER: "Damage meningkat seiring jarak, hingga [FFB300]{0}%[-]. Damage pada musuh yang ditandai meningkat sebesar [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Awakening: Mengurangi damage dari depan sebesar [FFB300]{1}%[-] untuk setiap [FFB300]{0}%[-] pengurangan HP",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Awakening: Sprint selama [FFB300]{0} detik[-] untuk diaktifkan. Saat aktif, [FFB300]{2}[-] tembakan ke sasaran pertama menimbulkan [FFB300]{1}%[-] damage. Berlangsung selama [FFB300]{3} detik[-].",
  T_27_C_SKILL_NAME_FALCONER: "Falcon Fervor",
  T_27_C_SKILL_NAME_XTREME: "Xtreme Encounter",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "the Fierce"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "Battle in style!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "Tiger Papercut (Mask)",
  T_27_L_B_CARDBOARD_REG: "Grizzly Papercut (Bottom)",
  T_27_L_M_S_KAZAKHSTAN: "The Baghatur (Shoes)",
  T_27_L_S_CARDBOARD_REG: "Grizzly Papercut (Shoes)",
  T_27_L_T_CARDBOARD_REG: "Grizzly Papercut (Top)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector- FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Monster Truck- FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Motorbike- K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Sports Car- Emerald Flash",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Pickup Truck- Flame Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "Dead Silent",
  T_27_R_EMOTE_GREETING_NAME: "Greetings",
  T_27_R_VEHICLE_ACCELERATION: "Akselerasi",
  T_27_R_VEHICLE_HP: "Daya Tahan",
  T_27_R_VEHICLE_SPEED: "Top Speed",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Awakening: Pengurangan damage armor ditingkatkan sebesar [FFB300]{0}%[-]. Tambahan [FFB300]{1}%[-] pengurangan Damage dari setiap rekan tim dalam jarak [FFB300]{2}m[-].",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Wolf Pack",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Moony",
  T_27_W_ARMOTY_DMR: "Marksman Rifle",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Petskin: Crystal Moony",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Petskin: Gamer Moony",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Petskin: Hipster Moony",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Pet Skin: FFWS 2021 Pup",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Pet Skin: FFWS 2021 Panda",
  T_27_XC_REPLAY_DIE: "Mati",
  T_27_XC_REPLAY_KILL: "Eliminasi",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Perbaiki",
  T_28_C_G_ICE_NAME: "Flash Freeze",
  T_28_C_SKILL_DESC_STREETBEAT: "Saat menembak ketika bergerak, kecepatan bergerak meningkat sebesar [FFB300]{0}%[-], akurasi meningkat sebesar [FFB300]{1}%[-].",
  T_28_C_SKILL_NAME_STREETBEAT: "Bullet Beats",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "No.23 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_B: "No.10 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_C: "No.24 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_D: "No.30 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_E: "No.1 Soccer Jersey (Bottom)",
  T_28_L_B_BRJERSEY_F: "No.20 Soccer Jersey (Bottom)",
  T_28_L_F_B_FOURSYMBOLS_C: "Vermilion Whirlwind (Bottom)",
  T_28_L_F_H_FOURSYMBOLS_C: "Vermilion Whirlwind (Head)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Vermilion Whirlwind (Facepaint)",
  T_28_L_F_S_FOURSYMBOLS_C: "Vermilion Whirlwind (Shoes)",
  T_28_L_F_T_FOURSYMBOLS_C: "Vermilion Whirlwind (Top)",
  T_28_L_HA_THUNDER: "Lightning Eye (Facepaint)",
  T_28_L_M_A_SPORTSUIT: "Ballsy Skaterboi (Mask)",
  T_28_L_M_B_FOURSYMBOLS_D: "Shadow Earthshaker (Bottom)",
  T_28_L_M_B_SPORTSUIT: "Ballsy Skaterboi (Bottom)",
  T_28_L_M_H_FOURSYMBOLS_D: "Shadow Earthshaker (Head)",
  T_28_L_M_H_SPORTSUIT: "Ballsy Skaterboi (Head)",
  T_28_L_M_S_FOURSYMBOLS_D: "Shadow Earthshaker (Shoes)",
  T_28_L_M_S_SPORTSUIT: "Ballsy Skaterboi (Shoes)",
  T_28_L_M_T_FALLWINTER: "Sauce Swagger (Top)",
  T_28_L_M_T_FOURSYMBOLS_D: "Shadow Earthshaker (Top)",
  T_28_L_M_T_SPORTSUIT: "Ballsy Skaterboi (Top)",
  T_28_L_T_BRJERSEY_A: "No.23 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_B: "No.10 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_C: "No.24 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_D: "No.30 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_E: "No.1 Soccer Jersey (Top)",
  T_28_L_T_BRJERSEY_F: "No.20 Soccer Jersey (Top)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94- Ruby Bride",
  T_28_LC_GLOO_FALLWINTER_N: "Gloo Wall- Sauce Swagger",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Gloo Wall- Stormbringer",
  T_28_LC_KORD_SHINOBI_N: "Kord- Killspark Shinobi",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker- Merciless Necromancer",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - Lethal Finstooth",
  T_28_LC_PAN_FOURSYMBOLS_N: "Pan- Earthshaker Stomp",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep- Stormbringer",
  T_28_T_WS_ITEM1: "Kotak",
  T_28_T_WS_ITEM10: "Tenda",
  T_28_T_WS_ITEM11: "Menara Pengawas",
  T_28_T_WS_ITEM12: "Pos Depan",
  T_28_T_WS_ITEM13: "Rumah A",
  T_28_T_WS_ITEM14: "Rumah B",
  T_28_T_WS_ITEM15: "Rumah C",
  T_28_T_WS_ITEM16: "Struktur Pasir",
  T_28_T_WS_ITEM17: "Air mancur",
  T_28_T_WS_ITEM18: "Cherry Blossom",
  T_28_T_WS_ITEM19: "Pohon Pisang",
  T_28_T_WS_ITEM2: "Long Box",
  T_28_T_WS_ITEM20: "Kloset",
  T_28_T_WS_ITEM21: "Pagar",
  T_28_T_WS_ITEM3: "Semak-semak",
  T_28_T_WS_ITEM4: "Tumpukan jerami",
  T_28_T_WS_ITEM5: "Mobil",
  T_28_T_WS_ITEM6: "Bus",
  T_28_T_WS_ITEM7: "Container A",
  T_28_T_WS_ITEM8: "Container B",
  T_28_T_WS_ITEM9: "Container C",
  T_28_T_WS_TYPE1: "Objek",
  T_28_T_WS_TYPE4: "Dekorasi",
  T_28_W_DUCK_N: "Dr. Beanie",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Petskin: Mythos Dreki",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Petskin: Sgt. Beanie",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Petskin: Gangster Beanie",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Petskin: DJ Beanie",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Awakening: Tanda pada musuh yang terkena tembakan bertahan lebih lama ketika musuh bergerak, hingga [FFB300]{0} detik[-] lebih lama.",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Enigma's Eye",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Vital Vibes",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Healing Heartbeat",
  T_29_D_CHARACTER_AMOCO_N: 'Moco "Enigma"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Striped Soccer Jersey (Bottom)",
  T_29_L_M_A_FALCONER_C: "Moody Lavisher (Mask)",
  T_29_L_M_A_JUNGLE_GREEN: "Camou War-Turtle (Mask)",
  T_29_L_M_B_FALCONER_C: "Moody Lavisher (Bottom)",
  T_29_L_M_B_JUNGLE_GREEN: "Camou War-Turtle (Bottom)",
  T_29_L_M_H_FALCONER_C: "Moody Lavisher (Head)",
  T_29_L_M_H_JUNGLE_GREEN: "Camou War-Turtle (Head)",
  T_29_L_M_S_FALCONER_C: "Moody Lavisher (Shoes)",
  T_29_L_M_S_JUNGLE_GREEN: "Camou War-Turtle (Shoes)",
  T_29_L_M_T_FALCONER_C: "Moody Lavisher (Top)",
  T_29_L_M_T_JUNGLE_GREEN: "Camou War-Turtle (Top)",
  T_29_L_T_TRJERSEY: "Striped Soccer Jersey (Top)",
  T_29_M_WS_ITEM22: "Container keras",
  T_29_M_WS_ITEM23: "Pagar keras",
  T_29_M_WS_ITEM24: "Spawn Point A",
  T_29_M_WS_ITEM25: "Spawn Point B",
  T_29_M_WS_TYPE5: "Interaktif",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Pet Skin: Earth Sensei Tig",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Pet Skin: Fire Sensei Tig",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Pet Skin: Cyber Falco",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Pet Skin: Party Panda",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Pet Skin: Ice Sensei Tig",
  T_29_W_TIGER_NINJA_N: "Sensei Tig",
  T_29_YF_MACHETE_MUSICFEST_N: "Soundwave Thrasher",
  T_29_YF_MAGEZINE_CHAIN_N: "AR Magazine",
  T_29_YF_MUZZLE_CRASH_N: "SMG Muzzle",
  T_29_YF_MUZZLE_WIDE_N: "Shotgun Muzzle",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- Cosmic Teleportia",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi- Amber Megacypher",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Monster Truck- Gnawing Rager",
  T_30_AD_RP_ROUNDEND: "RONDE BERAKHIR",
  T_30_AD_TRAINING_SNOWBALL: "Bola Salju",
  T_30_AD_TRAINING_SNOWBALL_DES: "Ayo perang bola salju!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}dtk[-] setelah diserang, pulihkan [FFB300]{1}HP[-]/dtk selama [FFB300]{2}dtk[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Buzzer Beater",
  T_30_C_SKILL_NAME_MUERTOGUY: "Memory Mist",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Jai's Microchip",
  T_30_L_A_BRMASCOT_ADULT: "Angry Chick Head",
  T_30_L_A_BRMASCOT_KIDS: "Adorable Chick Head",
  T_30_L_A_SUGARSKULL21_BANDANA: "Death Bite Mask",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Bottom)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Bottom)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Bottom)",
  T_30_L_B_BRUNIFORM: "Little Canary (Bottom)",
  T_30_L_F_A_SUGARSKULL21: "Goldrim Queen (Mask)",
  T_30_L_F_B_SUGARSKULL21: "Goldrim Queen (Bottom)",
  T_30_L_F_B_THASIAN: "Coral Trouble (Bottom)",
  T_30_L_F_H_CATEARS: "Kawaii Ears",
  T_30_L_F_H_SUGARSKULL21: "Goldrim Queen (Head)",
  T_30_L_F_H_THASIAN: "Coral Trouble (Head)",
  T_30_L_F_S_SUGARSKULL21: "Goldrim Queen (Shoes)",
  T_30_L_F_S_THASIAN: "Coral Trouble (Shoes)",
  T_30_L_F_T_SUGARSKULL21: "Goldrim Queen (Top)",
  T_30_L_F_T_THASIAN: "Coral Trouble (Top)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Dolphin Head",
  T_30_L_H_CHILDRENSDAY_RED: "Elephant Head",
  T_30_L_H_CLOWNHAT: "Circus Hat - Yellow",
  T_30_L_H_ZASCARF: "Bold Gold Scarf",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Desi Gangster (Mask)",
  T_30_L_M_A_SUGARSKULL21: "Goldrim King (Mask)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Desi Gangster (Bottom)",
  T_30_L_M_B_PKCRICKET: "Champ In Green (Bottom)",
  T_30_L_M_B_SUGARSKULL21: "Goldrim King (Bottom)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Wind Racer (Bottom)",
  T_30_L_M_B_THASIAN: "Coral Rebel (Bottom)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Desi Gangster (Head)",
  T_30_L_M_H_SUGARSKULL21: "Goldrim King (Head)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Wind Racer (Head)",
  T_30_L_M_H_THASIAN: "Coral Rebel (Head)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Alpha Flameborn (Facepaint)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Desi Gangster (Shoes)",
  T_30_L_M_S_PKCRICKET: "Champ In Green (Shoes)",
  T_30_L_M_S_SUGARSKULL21: "Goldrim King (Shoes)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Wind Racer (Shoes)",
  T_30_L_M_S_THASIAN: "Coral Rebel (Shoes)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Desi Gangster (Top)",
  T_30_L_M_T_PKCRICKET: "Champ In Green (Top)",
  T_30_L_M_T_SUGARSKULL21: "Goldrim King (Top)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Wind Racer (Top)",
  T_30_L_M_T_THASIAN: "Coral Rebel (Top)",
  T_30_L_S_BRUNIFORM: "Little Canary (Shoes)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF Soccer Jersey - Black (Top)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF Soccer Jersey - Green (Top)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF Soccer Jersey - Gray (Top)",
  T_30_L_T_BRUNIFORM: "Little Canary (Top)",
  T_30_M_WS_PARTY_MODE: "Playground",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "Battle in Style",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Challenger",
  T_30_R_EMOTE_MAX_NAME: "Rap Swag",
  T_30_R_LEGEND_HALO_NAME: "Circle of Heat",
  T_30_T_WS_DEFAULTDESCRIPTION: "Sebuah map menarik di Free Fire Craftland",
  T_30_T_WS_ITEM26: "Tires",
  T_30_T_WS_ITEM27: "Messy Tires A",
  T_30_T_WS_ITEM28: "Messy Tires B",
  T_30_T_WS_ITEM29: "Messy Tires C",
  T_30_T_WS_ITEM30: "Bumper car",
  T_30_T_WS_ITEM31: "Amphibian Car",
  T_30_T_WS_ITEM32: "Jeep",
  T_30_T_WS_ITEM33: "Trash can",
  T_30_T_WS_ITEM34: "Shade",
  T_30_T_WS_ITEM35: "Medical Tent",
  T_30_T_WS_ITEM36: "Garage",
  T_30_T_WS_ITEM37: "Painted Walls",
  T_30_T_WS_ITEM38: "Torii",
  T_30_T_WS_ITEM39: "Iron Platform",
  T_30_T_WS_ITEM40: "Site Hut",
  T_30_T_WS_ITEM41: "Trailer",
  T_30_T_WS_ITEM42: "Wall A",
  T_30_T_WS_ITEM43: "Wall B",
  T_30_T_WS_ITEM44: "Wall C",
  T_30_T_WS_ITEM45: "Wall D",
  T_30_T_WS_ITEM46: "Wall E",
  T_30_T_WS_ITEM47: "Wall F",
  T_30_U_ATTACHMENT_1: "Shield Booster",
  T_30_U_ATTACHMENT_4: "Vest Enlarger",
  T_30_U_ATTACHMENT_5: "Helmet Thickener",
  T_30_U_ATTACHMENT_6: "Vest Thickener",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Pet Skin: Skull Beaston",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Pet Skin: Punk Waggor",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Pet Skin: Bullseye Agent Hop",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Pet Skin: Carnival Agent Hop",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Pet Skin: Cyber Agent Hop",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Pet Skin: Nazar Robo",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Pet Skin: Green Freeze Robo",
  T_30_W_RABBIT_N: "Agent Hop",
  T_30_XH_PCMAP_P17: "Factory",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Gloo Wall- BOOYAH DAY 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Grenade- BOOYAH DAY 2021",
  T_30_YF_Healinggun_Sniper_N: "Heal Sniper",
  T_30_YF_MINI_LIGHTFEST_N: "AC80- Royal Warrior",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL- Crimson Heir",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR- Royal Warrior",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Goldrim Tribute",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Sports Car- Skull Punker",
  T_31_C_SKILL_NAME_WINTERGUY: "Ice Iron",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Winter Basher",
  T_31_HQ_GLOO_EAGLE_N: "Gloo Wall- Heatbound Desert",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Heal Sniper- Ice Bones",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana- Snow Doom",
  T_31_HQ_PAN_WINTERFEST21_N: "Pan- Snow Doom",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Pet Skin: Snow Ottero",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Pet Skin: Waggor On Ice",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Pet Skin: Tribal Yeti",
  T_31_HQ_PETSKIN_YETI_RED_N: "Pet Skin: Fiery Yeti",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Scythe of Snow",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Motorbike- Ice Blossoms",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "Kotak Supply",
  T_31_KK_WINTER_SANJITOU: "Helm",
  T_31_L_A_BDCRICKET: "Victory Batter (Mask)",
  T_31_L_A_WINTERFEST21: "Reindeer Cover",
  T_31_L_B_BDCRICKET: "Victory Batter (Bottom)",
  T_31_L_B_MEJERSEY_10: "No. 10 Ruby Jersey (Bottom)",
  T_31_L_B_MEJERSEY_11: "No. 11 Red Jersey (Bottom)",
  T_31_L_B_MEJERSEY_13: "No. 13 White Jersey (Bottom)",
  T_31_L_B_MEJERSEY_18G: "No. 18 Green Jersey (Bottom)",
  T_31_L_B_MEJERSEY_18R: "No. 18 Maroon Jersey (Bottom)",
  T_31_L_B_MEJERSEY_7: "No. 7 Basil Jersey (Bottom)",
  T_31_L_F_B_RUMUSICIAN: "Strapped Trance (Bottom)",
  T_31_L_F_B_THAGENT: "Night Provocateur (Bottom)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Tie Dye Bucket",
  T_31_L_F_H_RUMUSICIAN: "Strapped Trance (Head)",
  T_31_L_F_H_THAGENT: "Night Provocateur (Head)",
  T_31_L_F_HA_RUMUSICIAN: "Strapped Trance (Facepaint)",
  T_31_L_F_S_RUMUSICIAN: "Strapped Trance (Shoes)",
  T_31_L_F_S_THAGENT: "Night Provocateur (Shoes)",
  T_31_L_F_T_RUMUSICIAN: "Strapped Trance (Top)",
  T_31_L_F_T_THAGENT: "Night Provocateur (Top)",
  T_31_L_HA_RUMUSICIAN_MU: "Strap Trap (Facepaint)",
  T_31_L_HA_WINTERFEST21_BLUE: "Frozen Clown Facepaint",
  T_31_L_HA_WINTERFEST21_PINK: "Pink Firesparks Facepaint",
  T_31_L_M_A_REGGAETON_B: "Neon Reggaeton (Mask)",
  T_31_L_M_A_REGGAETON_P: "Vibrant Vanity (Mask)",
  T_31_L_M_A_RUMUSICIAN: "Strapped Trap (Mask)",
  T_31_L_M_A_THAGENT: "Night Scouter (Mask)",
  T_31_L_M_B_PKCOSTUME: "Smart in Green (Bottom)",
  T_31_L_M_B_REGGAETON_B: "Neon Reggaeton (Bottom)",
  T_31_L_M_B_REGGAETON_P: "Vibrant Vanity (Bottom)",
  T_31_L_M_B_RUMUSICIAN: "Strapped Trap (Bottom)",
  T_31_L_M_B_THAGENT: "Night Scouter (Bottom)",
  T_31_L_M_H_GREENCAP: "Winner Cap",
  T_31_L_M_H_PKCOSTUME: "Smart in Green (Head)",
  T_31_L_M_H_REGGAETON_B: "Neon Reggaeton (Head)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Tie Dye Hat",
  T_31_L_M_H_REGGAETON_P: "Vibrant Vanity (Head)",
  T_31_L_M_H_RUMUSICIAN: "Strapped Trap (Head)",
  T_31_L_M_H_THAGENT: "Night Scouter (Head)",
  T_31_L_M_S_PKCOSTUME: "Smart in Green (Shoes)",
  T_31_L_M_S_REGGAETON_B: "Neon Reggaeton (Shoes)",
  T_31_L_M_S_REGGAETON_P: "Vibrant Vanity (Shoes)",
  T_31_L_M_S_RUMUSICIAN: "Strapped Trap (Shoes)",
  T_31_L_M_S_THAGENT: "Night Scouter (Shoes)",
  T_31_L_M_T_PKCOSTUME: "Smart in Green (Top)",
  T_31_L_M_T_REGGAETON_B: "Neon Reggaeton (Top)",
  T_31_L_M_T_REGGAETON_P: "Vibrant Vanity (Top)",
  T_31_L_M_T_REGGAETON_TATOO: "Familia Ink",
  T_31_L_M_T_RUMUSICIAN: "Strapped Trap (Top)",
  T_31_L_M_T_THAGENT: "Night Scouter (Top)",
  T_31_L_S_BDCRICKET: "Victory Batter (Shoes)",
  T_31_L_T_BDCRICKET: "Victory Batter (Top)",
  T_31_L_T_BRBANK: "Maroon Bomber",
  T_31_L_T_MEJERSEY_10: "No. 10 Ruby Jersey (Top)",
  T_31_L_T_MEJERSEY_11: "No. 11 Red Jersey (Top)",
  T_31_L_T_MEJERSEY_13: "No. 13 White Jersey (Top)",
  T_31_L_T_MEJERSEY_18G: "No. 18 Green Jersey (Top)",
  T_31_L_T_MEJERSEY_18R: "No. 18 Maroon Jersey (Top)",
  T_31_L_T_MEJERSEY_7: "No. 7 Basil Jersey (Top)",
  T_31_L_T_PKMOBILE: "Infinix T-shirt",
  T_31_L_T_REGGAETON_HOOD: "Gang Smile Hoodie",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Number 1",
  T_31_RW_COMBINEMACHINE_2: "Akimbo Activator (Advanced)",
  T_31_RW_VIBRATION_EXPLOSION: "Ledakan",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Senjata Melee",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Senjata lain",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Squad",
  T_31_T_WS_5PLAYERTEAM: "Versus 5",
  T_31_T_WS_6PLAYERTEAM: "Versus 6",
  T_31_T_WS_BUFFTIME_TITLE: "Waktu Refresh (dtk)",
  T_31_T_WS_BUFFTYPE_AMMO: "Ammo",
  T_31_T_WS_BUFFTYPE_ARMOR: "Armor",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "Random",
  T_31_T_WS_BUFFTYPE_TITLE: "Buff Type",
  T_31_T_WS_DESC48: "Membawamu ke tempat lain, dalam milisecond",
  T_31_T_WS_DESC49: "Membuat suara piano",
  T_31_T_WS_DESC51: "Membuat suara drum",
  T_31_T_WS_DESC53: "Membuat suara synthesizer",
  T_31_T_WS_DESC59: "Alat yang secara berkala menghasilkan buff. Ambil untuk mendapatkan kekuatan yang sesuai denganmu",
  T_31_T_WS_DRUMTYPE_CLAPS: "Clap",
  T_31_T_WS_DRUMTYPE_HIHATS: "Hi-hat",
  T_31_T_WS_DRUMTYPE_KICK: "Kick Drum",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Opening Hi-hat",
  T_31_T_WS_DRUMTYPE_RIDES: "Ride Cymbal",
  T_31_T_WS_DRUMTYPE_SNARES: "Snare Drum",
  T_31_T_WS_EARLYSHRINK: "Pengecilan Cepat",
  T_31_T_WS_ITEM48: "Portal",
  T_31_T_WS_ITEM49: "Piano Key",
  T_31_T_WS_ITEM51: "Drum Key",
  T_31_T_WS_ITEM53: "Combo Key A",
  T_31_T_WS_ITEM55: "Combo Key B",
  T_31_T_WS_ITEM57: "Combo Key C",
  T_31_T_WS_ITEM59: "Buff Generator",
  T_31_T_WS_LATESHRINK: "Pengecilan Lambat",
  T_31_T_WS_ME_DAMAGE: "Damage diberikan",
  T_31_T_WS_ME_DAMAGED: "Damage diterima",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Proporsi EP Awal",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Radius dari Safe Zone Pertama",
  T_31_T_WS_ME_EPQUICKRESTORE: "Konversi EP Cepat",
  T_31_T_WS_ME_FLOW: "Mode",
  T_31_T_WS_ME_GENERALSETTING: "General",
  T_31_T_WS_ME_INRANDOMSPAWN: "Point spawn random",
  T_31_T_WS_ME_KILLSCORE: "Kill Bonus",
  T_31_T_WS_ME_MAXEP: "Maksimum EP",
  T_31_T_WS_ME_MAXHP: "Maksimum HP",
  T_31_T_WS_ME_NEARTEAM: "Dekat teammate",
  T_31_T_WS_ME_REBIRTH: "Waktu Tunggu Respawn",
  T_31_T_WS_ME_REBIRTHLOCATION: "Lokasi Respawn",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Waktu Zona Mulai Mengecil",
  T_31_T_WS_ME_WINSCORE: "Score Menang",
  T_31_T_WS_MINIZONE: "Mini Zone",
  T_31_T_WS_MUSICTYPE_TITLE: "Music Type",
  T_31_T_WS_UNLIMITEDAMMO: "Ammo tidak terbatas",
  T_31_WT_WS_DESC1: "Kotak kayu persegi yang dapat ditumpuk",
  T_31_WT_WS_DESC10: "Gubug dengan tangga kayu",
  T_31_WT_WS_DESC11: "Dibangun dengan sejumlah jendela  dengan tujuan untuk menembak",
  T_31_WT_WS_DESC12: "Terbuat dari logam dan memiliki pintu serta jendela",
  T_31_WT_WS_DESC13: "Mengandung pintu dan jendela",
  T_31_WT_WS_DESC14: "Rumah dua lantai dengan teras",
  T_31_WT_WS_DESC15: "Rumah dua lantai dengan genteng tertutup",
  T_31_WT_WS_DESC16: "Decor - patung pasir berbentuk hari",
  T_31_WT_WS_DESC17: "Decor - air mancur dengan air jernih",
  T_31_WT_WS_DESC18: "Decor - pohon dengan bunga pink",
  T_31_WT_WS_DESC19: "Decor - pohon pisang kecil tanpa pisang",
  T_31_WT_WS_DESC2: "Kotak kayu persegi panjang yang dapat ditumpuk",
  T_31_WT_WS_DESC20: "Furnitur kamar mandi putih yang dapat diletakkan indoor",
  T_31_WT_WS_DESC21: "Pagar kecil yang dapat digunakan untuk membagi area",
  T_31_WT_WS_DESC22: "Sisi container dari papan kayu ini dapat dihancurkan dengan paksa",
  T_31_WT_WS_DESC23: "Pagar kecil yang dapat dirusak dengan paksa",
  T_31_WT_WS_DESC24: "Spawn area untuk Tim A (Hanya berlaku dalam mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_31_WT_WS_DESC25: "Spawn area untuk Tim B (Hanya berlaku dalam mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_31_WT_WS_DESC26: "Mementalkan player ke arah yang mereka hadap, untuk jarak yang dekat",
  T_31_WT_WS_DESC27: "Mementalkan player ke arah yang dituju, untuk jarak yang dekat",
  T_31_WT_WS_DESC28: "Mementalkan player ke arah yang dituju, untuk jarak yang sedang",
  T_31_WT_WS_DESC29: "Mementalkan player ke arah yang dituju, untuk jarak yang jauh",
  T_31_WT_WS_DESC3: "Dihiasi dengan bunga merah dan kuning yang dapat menyinari medan perang",
  T_31_WT_WS_DESC30: "Mobil bumper yang dapat disetir",
  T_31_WT_WS_DESC31: "Mobil amphibian yang dapat disetir",
  T_31_WT_WS_DESC32: "Jeep yang dapat disetir",
  T_31_WT_WS_DESC33: "Berisikan sampah. Lebih pendek dari manusia namun dapat menyediakan perlindungan",
  T_31_WT_WS_DESC34: "Shelter jalur balap terbuka",
  T_31_WT_WS_DESC35: "Tenda berukuran medium dengan dua pintu tapi tidak ada jendela",
  T_31_WT_WS_DESC36: "Garasi besar terbuat dari batu bata",
  T_31_WT_WS_DESC37: "Dinding batu bata besar digunakan untuk membagi area",
  T_31_WT_WS_DESC38: "Penanda yang berguna",
  T_31_WT_WS_DESC39: "Panggung logam yang dapat digunakan sebagai tempat bertarung utama",
  T_31_WT_WS_DESC4: "Lebih tinggi dari manusia, sehingga dapat menjadi sebuah cover",
  T_31_WT_WS_DESC40: "Terlihat seperti kendaraan rekreasi serta memiliki beberapa pintu dan jendela",
  T_31_WT_WS_DESC41: "Terlihat seperti kendaraan rekreasi memiliki satu pintu dan banyak jendela",
  T_31_WT_WS_DESC42: "Tembok satu sisi dengan pintu masuk",
  T_31_WT_WS_DESC43: "Dinding 1 sisi biasa",
  T_31_WT_WS_DESC44: "Sudut dinding",
  T_31_WT_WS_DESC45: "Sudut tembok tidak simetris",
  T_31_WT_WS_DESC46: "Sudut tembok tidak simetris",
  T_31_WT_WS_DESC47: "Sudut dinding dengan jendela",
  T_31_WT_WS_DESC5: "Mobil tidak terpakai yang sedikit lebih pendek dari manusia tetapi masih dapat memberikan cover",
  T_31_WT_WS_DESC6: "Lebih tinggi dari manusia sehingga dapat menjadi sebuah cover",
  T_31_WT_WS_DESC7: "Terbuka di kedua ujung dan dapat digunakan untuk membentuk jalan atau membagi area",
  T_31_WT_WS_DESC8: "Terbuka di satu ujung dan dapat digunakan untuk membagi area",
  T_31_WT_WS_DESC9: "Tertutup di kedua ujung dan dapat digunakan untuk membagi area",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Kendaraan",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "Lari ke depan dengan kecepatan tinggi selama [FFB300]{0}dtk[-]. Skill ini dapat diakumulasikan hingga [FFB300]{2} penggunaan[-], dengan cooldown [FFB300]{3}[-] detik di antara setiap penggunaan. Waktu pengisian: [FFB300]{1}dtk[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Rebel Rush",
  T_32_HQ_AUG_VNSTREET_N: "AUG- Roaring Gunfighter",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Dawnlit Drago Backpack",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- Vampire Malevolence",
  T_32_HQ_GLOO_DUNHUANG_N: "Gloo Wall- Frozen Platinum",
  T_32_HQ_GLOO_HURRICANE_2_N: "Gloo Wall- Aurora Core",
  T_32_HQ_GRENADE_HURRICANE_N: "Grenade- Brassy Mic",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10- Frozen Platinum",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Petskin: Red Beanie",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Pet Skin: Cyber Flash",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Pet Skin: Gamer Flash",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Pet Skin: Festive Flash",
  T_32_HQ_TORTOISE_N: "Flash",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Sports Car- Buried Purpledust",
  T_32_L_F_A_PHARAOH: "Goldcoated Cleo (Mask)",
  T_32_L_F_B_PHARAOH: "Goldcoated Cleo (Bottom)",
  T_32_L_F_H_PHARAOH: "Goldcoated Cleo (Head)",
  T_32_L_F_HA_PHARAOH: "Goldcoated Cleo (Facepaint)",
  T_32_L_F_S_PHARAOH: "Goldcoated Cleo (Shoes)",
  T_32_L_F_T_PHARAOH: "Goldcoated Cleo (Top)",
  T_32_L_M_A_JUNKFOOD: "Burger Lad (Mask)",
  T_32_L_M_A_PHARAOH: "Goldlined Mummy (Mask)",
  T_32_L_M_B_JUNKFOOD: "Burger Lad (Bottom)",
  T_32_L_M_B_PHARAOH: "Goldlined Mummy (Bottom)",
  T_32_L_M_H_JUNKFOOD: "Burger Lad (Head)",
  T_32_L_M_H_PHARAOH: "Goldlined Mummy (Head)",
  T_32_L_M_S_JUNKFOOD: "Burger Lad (Shoes)",
  T_32_L_M_S_PHARAOH: "Goldlined Mummy (Shoes)",
  T_32_L_M_T_JUNKFOOD: "Burger Lad (Top)",
  T_32_L_M_T_PHARAOH: "Goldlined Mummy (Top)",
  T_32_L_T_WHITESWEATER: "White Turtleneck",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "Zona Immortal",
  T_32_LO_WS_ITEM60: "Pipe",
  T_32_LO_WS_ITEM60_DESC: "Lorong yang dapat dijelajahi",
  T_32_LO_WS_ITEM61: "T Pipe",
  T_32_LO_WS_ITEM61_DESC: "Lorong T yang dapat dijelajahi",
  T_32_LO_WS_ITEM62: "Pipe Intersection",
  T_32_LO_WS_ITEM62_DESC: "Lorong berpotongan yang dapat dijelajahi",
  T_32_LO_WS_ITEM63: "Pipe Corner",
  T_32_LO_WS_ITEM63_DESC: "Lorong bersudut yang dapat dijelajahi",
  T_32_LO_WS_ITEM64: "Food Truck",
  T_32_LO_WS_ITEM64_DESC: "Berhenti di sini untuk mendapatkan snack",
  T_32_LO_WS_ITEM65: "Mush Shade",
  T_32_LO_WS_ITEM65_DESC: "Jamur besar yang dapat membawa manusia",
  T_32_LO_WS_ITEM66: "Hanger",
  T_32_LO_WS_ITEM66_DESC: "Sering kali dilihat di area perumahan",
  T_32_LO_WS_ITEM67: "Wooden Plank",
  T_32_LO_WS_ITEM67_DESC: "Digunakan untuk membuat jembatan kayu sederhana",
  T_32_LO_WS_ITEM68: "Lattice Screen",
  T_32_LO_WS_ITEM68_DESC: "Suasana oriental",
  T_32_LO_WS_ITEM69: "Pillar",
  T_32_LO_WS_ITEM69_DESC: "Seringkali dilihat di tempat konstruksi",
  T_32_LO_WS_ITEM70: "Cactus",
  T_32_LO_WS_ITEM70_DESC: "Sangat besar tetapi tidak menyengat",
  T_32_LO_WS_ITEM71: "Leafless Tree",
  T_32_LO_WS_ITEM71_DESC: "Pohon yang telah hidup selama ratusan tahun",
  T_32_LO_WS_ITEM72: "Stone Lantern",
  T_32_LO_WS_ITEM72_DESC: "Dekorasi pemandangan di taman kerajaan",
  T_32_LO_WS_ITEM73: "Streetlamp",
  T_32_LO_WS_ITEM73_DESC: "Sering terlihat di jalanan",
  T_32_LO_WS_ITEM74: "Solar Panel",
  T_32_LO_WS_ITEM74_DESC: "Menyerap energi dari matahari",
  T_32_LO_WS_ITEM75: "Air Conditioner A",
  T_32_LO_WS_ITEM75_DESC: "Tetap sejuk dalam panas",
  T_32_LO_WS_ITEM76: "Fan",
  T_32_LO_WS_ITEM77: "Fly Pan",
  T_32_LO_WS_ITEM78: "Cube",
  T_32_LO_WS_ITEM79: "Ring",
  T_32_LO_WS_ITEM80: "Hammer",
  T_32_LO_WS_ITEM81: "Board",
  T_32_LO_WS_ITEM82: "Shooting Target",
  T_32_LO_WS_ITEM83: "Flex Wall",
  T_32_LO_WS_ITEM84AMMO: "Ammo Loot Point",
  T_32_LO_WS_ITEM84AMMO_DESC: "Ketika diletakkan, tipe ammo yang dipilih akan muncul di sini",
  T_32_LO_WS_ITEM84AR: "Armor Loot Point",
  T_32_LO_WS_ITEM84AR_DESC: "Ketika dipasang, armor yang dipilih akan muncul di sini",
  T_32_LO_WS_ITEM84ARLV1: "Armor Lv. 1",
  T_32_LO_WS_ITEM84ARLV2: "Armor Lv. 2",
  T_32_LO_WS_ITEM84ARLV3: "Armor Lv. 3",
  T_32_LO_WS_ITEM84CO: "Consumables Loot Point",
  T_32_LO_WS_ITEM84CO_DESC: "Ketika dipasang, tipe consumable yang dipilih akan muncul di sini",
  T_32_LO_WS_ITEM84JA: "Throwables Loot Point",
  T_32_LO_WS_ITEM84JA_DESC: "Ketika dipasang, barang throwable yang dipilih akan muncul di sini",
  T_32_LO_WS_ITEM84TE: "Scopes Loot Point",
  T_32_LO_WS_ITEM84TE_DESC: "Ketika diletakkan, scope yang dipilih akan muncul di sini",
  T_32_LO_WS_ITEM84W: "Weapon Loot Point",
  T_32_LO_WS_ITEM84W_DESC: "Ketika dipasang, senjata dipilih akan muncul di sini",
  T_32_LO_WS_ITEM85: "Zona Immortal/Doom",
  T_32_LO_WS_ITEM85_DESC: "Saat ditempatkan, pemain yang memasuki zona pemicu akan mengalami efek tertentu seperti immortal atau kehancuran. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_32_LO_WS_ITEM85CP: "Checkpoint",
  T_32_LO_WS_ITEM85CP_DESC: "Item yang digunakan untuk membangun gameplay dalam mode Parkour. Agar checkpoint terakhir muncul, pemain harus melewati setiap checkpoint satu per satu. Saat tereliminasi dan respawn, pemain dapat memilih untuk respawn di pos pemeriksaan terakhir yang mereka lewati. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_32_LO_WS_ITEM85TM: "Finishing Point",
  T_32_LO_WS_ITEM85TM_DESC: "Item yang digunakan untuk membangun gameplay dalam mode Parkour. Pemain harus tiba di dalam garis finis agar gol dapat diselesaikan. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_32_LO_WS_ITEM86: "Spawn Point",
  T_32_LO_WS_ITEM86_DESC: "(Hanya di mode game custom) Tidak ada tim spesifik ditempatkan di tempat ini. Ketika diletakkan, team random akan spawn di sini. Jika terdapat lebih banyak team daripada spawn point, maka akan terdapat lebih dari 1 team yang spawn pada satu point.",
  T_32_LO_WS_ITEM86L: "Large Spawn Point",
  T_32_LO_WS_ITEM86L_DESC: "Titik spawn besar yang direkomendasikan untuk mode Parkour, di mana semua pemain akan muncul secara berurutan. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_32_LO_WS_ITEM87: "Block",
  T_32_LO_WS_ITEM87_DESC: "Aktifkan custom ukuran",
  T_32_LO_WS_ITEM88: "Cuboid & Slope",
  T_32_LO_WS_ITEM88_DESC: "Cuboid atau slope yang ukurannya bisa diatur",
  T_32_LO_WS_ITEMLINE: "Geser",
  T_32_LO_WS_ITEMMOVE: "Pengaturan Trigger",
  T_32_LO_WS_ITEMROT: "Berubah",
  T_32_LO_WS_ITEMSCALE: "Skala",
  T_32_LO_WS_KILLZONE: "Zona Doom",
  T_32_LO_WS_LOOT_AMMOTYPE: "Ammo",
  T_32_LO_WS_LOOT_ARTYPE: "Armor",
  T_32_LO_WS_LOOT_COTYPE: "Consumable",
  T_32_LO_WS_LOOT_JATYPE: "Throwable",
  T_32_LO_WS_LOOT_RANDOM: "Random",
  T_32_LO_WS_LOOT_TETYPE: "Scope",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Senjata",
  T_32_LO_WS_SCALEX: "Panjang",
  T_32_LO_WS_SCALEY: "Tinggi",
  T_32_LO_WS_SCALEZ: "Lebar",
  T_32_LO_WS_TRIGGERH: "Sembunyikan",
  T_32_LO_WS_TRIGGERHORP: "Tunjukkan/Sembuyikan Trigger",
  T_32_LO_WS_TRIGGERP: "Tampilkan",
  T_32_LO_WS_TRIGGERTYPE: "Trigger Type",
  T_32_M_WS_MODE_ANNIHILATE: "Wipe Out",
  T_32_M_WS_MODE_SCORE: "Points Grab",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "Multi-Team Combat",
  T_32_M_WS_ROUNDS: "Ronde",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Switching Steps",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Zona Bahaya",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Damage",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Zona Bahaya",
  T_32_T_WS_ME_CUSTOM: "Custom",
  T_32_T_WS_ME_ENDTYPE1: "Wipe Out",
  T_32_T_WS_ME_ENDTYPE2: "Points Grab",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "Jadilah team terakhir untuk bertahan hidup",
  T_32_T_WS_ME_ENDTYPEDESC2: `Team pertama mencapai target score menang.
Kamu bisa mengatur peraturan dan edit parameter bermain sesukamu, termasuk skor yang diberikan untuk setiap eliminasi.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `Team pertama yang seluruh membernya mencapai finish point pertama menang.
Kamu bisa mengatur peraturan bermain dan mengubah jalur serta garis finish sesukamu.`,
  T_32_T_WS_ME_MATCHTIME: "Waktu match",
  T_32_T_WS_ME_MECHANIC: "Mekanisme",
  T_32_T_WS_ME_NEARCHECKPOINT: "Dekat checkpoint",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Tidak dapat berisikan total lebih dari 12 player",
  T_32_T_WS_ME_PREGAMETIME: "Waktu persiapan",
  T_32_T_WS_ME_RESPAWN: "Respawn",
  T_32_T_WS_ME_RESPAWNSETTING: "Respawn",
  T_32_T_WS_ME_ROUNDNUM: "Jumlah round",
  T_32_T_WS_ME_ROUNDOPEN: "Aktifkan banyak ronde",
  T_32_T_WS_ME_ROUNDRESET: "Reset Ronde",
  T_32_T_WS_ME_ROUNDSETTING: "Ronde",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Durasi Pengecilan Zona",
  T_32_T_WS_ME_SCORESETTING: "Score",
  T_32_T_WS_ME_TEAMMATENUM: "Member per team",
  T_32_T_WS_ME_TEAMNUM: "Jumlah team",
  T_32_T_WS_ME_TEAMSETTING: "Team",
  T_32_U_ATTACHMENT_8: "Bag Pouch",
  "T_32_U_GOLD_FAMAS-I": "Famas-I",
  "T_32_U_GOLD_FAMAS-II": "Famas-II",
  "T_32_U_GOLD_FAMAS-III": "Famas-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Upgrade Chip",
  T_32_WT_WS_BARRIER: "Barriers",
  T_32_WT_WS_BDS: "Buildings",
  T_32_WT_WS_MMINVALIDERROR: "Kode map tidak valid",
  T_32_WT_WS_TRGS: "Triggers",
  T_32_YF_CHARGESHOT_N: "Charge Buster",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Damage Ekstra",
  T_32_YS_WEAPON_TAG_3: "Rate of Fire",
  T_32_YS_WEAPON_TAG_36: "Tembus Armor",
  T_32_YS_WEAPON_TAG_39: "Support Akimbo",
  T_32_YS_WEAPON_TAG_42: "Ice Wall",
  T_33_C_SKILL_DESC_GRAFFITIST: "Membuat area [FFB300]{0}m[-], tempat lemparan tidak valid. Sekutu di area tersebut akan memulihkan [FFB300]{1}%[-] daya tahan armor setiap detik dan damage dari amunisi akan berkurang sebesar [FFB300]{2}%[-]. Berlangsung selama [FFB300]{3}dtk[-]. Efek tidak menumpuk. Cooldown: [FFB300]{4}dtk[-].",
  T_33_C_SKILL_DESC_HITMAN: "Saat menggunakan Sniper dan Marksman Rifle, suara tembakan dibungkam dan musuh yang dijatuhkan oleh pengguna kehilangan HP [FFB300]{0}%[-] lebih cepat.",
  T_33_C_SKILL_DESC_KENTA: "Membentuk perisai dengan lebar [FFB300]{0}m[-] yang mengurangi [FFB300]{1}%[-] damage senjata yang datang dari depan. Ketika menembak, pengurangan damage berkurang sebanyak [FFB300]{2}%[-]. Berlangsung selama [FFB300]{3}dtk[-]. Cooldown: [FFB300]{4}dtk[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Melepaskan gelombang elektromagnetik dengan diameter [FFB300]{0}m[-] yang melumpuhkan aktivasi skill musuh, memberikan [FFB300]{3} damage[-] dan menyela hitungan mundur interaksi mereka. Berlangsung selama [FFB300]{1}dtk[-]. Cooldown: [FFB300]{2}dtk[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Firearms Expert",
  T_33_C_SKILL_NAME_KENTA: "Swordsman's Wrath",
  T_33_C_SKILL_NAME_MADEMANA: "Thrill of Battle",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Pet Skin: Fruity Zasil",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Pet skin: FFWS Beanie",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Pet skin: Blooming Falco",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Deadly Baguette",
  T_33_HQ_EMOTE_SONGKRAN_N: "Come and Dance",
  T_33_HQ_G18_CYBERTHIEF_N: "G18- Hypercore Blues",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Grenade- Hypercore Blues",
  T_33_HQ_M14_SPIDERLILY_N: "M14- Burning Lily",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7- Shadow Rogue",
  T_33_HQ_MP40_FFWS03_N: "MP40- Haven Warrior",
  T_33_HQ_SCAR_FFWS03_N: "SCAR- Haven Warrior",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Emerald Power Scythe",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Haven Warrior Dagger",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector- Hypercore Blues",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jeep- Emerald Shimmer",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Monster Truck- Bonebruiser Scorch",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Pickup Truck- Haven Guardian",
  T_33_LO_WS_BHPARA_A: "Aktif",
  T_33_LO_WS_BHPARA_ATKMODE: "Tipe serangan",
  T_33_LO_WS_BHPARA_GROUP: "Tim",
  T_33_LO_WS_BHPARA_NA: "Tidak ada penyerangan",
  T_33_LO_WS_BHPARA_P: "Pasif",
  T_33_LO_WS_DICE_DESC: "Dadu yang meningkatkan lompatanmu dan dapat digunakan dalam berbagai gameplay",
  T_33_LO_WS_DICEVXZ: "Kecepatan Horisontal",
  T_33_LO_WS_DICEVY: "Kecepatan vertikal",
  T_33_LO_WS_DTOWER: "Tower",
  T_33_LO_WS_DTOWER_DESC: "Secara otomatis menyerang musuh yang berada dalam jarak tertentu dari struktur pertahanan. Hancur jika HP-nya mencapai nol. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_33_LO_WS_FORT: "Fortress",
  T_33_LO_WS_FORT_DESC: "Secara otomatis menyerang musuh yang berada dalam jarak tertentu dari struktur kritis. Hancur jika HP-nya mencapai nol. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_33_LO_WS_ITEM89: "Refinery Tank",
  T_33_LO_WS_ITEM89_DESC: "Struktur penyimpan air",
  T_33_LO_WS_ITEM90: "Dog House",
  T_33_LO_WS_ITEM90_DESC: "Rumah untuk anak anjing",
  T_33_LO_WS_ITEM91: "Halte Bis",
  T_33_LO_WS_ITEM91_DESC: "Halte bus umum",
  T_33_LO_WS_ITEM92: "Graffiti Wall",
  T_33_LO_WS_ITEM92_DESC: "Sebuah tembok yang dihiasi dengan cat semprot",
  T_33_LO_WS_ITEM93: "kandang kuda",
  T_33_LO_WS_ITEM93_DESC: "Struktur dasar jerami",
  T_33_LO_WS_ITEM94: "Bangku",
  T_33_LO_WS_ITEM94_DESC: "Sebuah bangku taman",
  T_33_LO_WS_ITEM95: "Stone Bridge",
  T_33_LO_WS_ITEM95_DESC: "Sebuah jembatan yang dibangun dengan batu",
  T_33_LO_WS_ITEM96: "Sun Shade",
  T_33_LO_WS_ITEM96_DESC: "Cegah sengatan matahari di bawah payung",
  T_33_LO_WS_ITEM97: "Finish Line Arch",
  T_33_LO_WS_ITEM97_DESC: "Tunjukkan garis akhir",
  T_33_LO_WS_ITEM98: "Ad Board",
  T_33_LO_WS_ITEM98_DESC: "Banner biasa untuk promosi",
  T_33_LO_WS_PARA_DM: "Damage",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "Jarak scan musuh",
  T_33_LO_WS_PARA_SP: "Kecepatan",
  T_33_LO_WS_ZBPARA_AMOUNT: "Zombie per ronde",
  T_33_LO_WS_ZBPARA_INTERVAL: "Interval gelombang (dtk)",
  T_33_LO_WS_ZBPARA_ROUND: "# gelombang",
  T_33_LO_WS_ZBSPAWNER: "Spawn Zombie",
  T_33_LO_WS_ZBSPAWNER_DESC: "Secara otomatis memunculkan zombie sesuai dengan konfigurasi. Perilaku mereka dapat dikonfigurasi menggunakan menu drop-down. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Level up",
  T_33_RW_SKILL_DESC_GANGGIRL: "Meningkatkan fire rate sebesar [FFB300]{0}%[-]. Saat pengguna mengenai musuh, maksimum [FFB300]{1}%[-] dari fire rate diubah menjadi kecepatan gerak, dan konversi reset saat pengguna selamat dari pertempuran.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Fight-or-Flight",
  T_33_WT_WS_BASICSET1: "Basic",
  T_33_WT_WS_QCEPRTIP: "Ubah EP menjadi HP lebih cepat",
  T_33_WT_WS_SKILLSET_TAG: "Skill Unlimited",
  T_33_WT_WS_SKILLSET1: "Pengaturan Skill",
  T_33_WT_WS_SKILLSET10: "Time Turner (Chrono)",
  T_33_WT_WS_SKILLSET11: "Riptide Rhythm (Skyler)",
  T_33_WT_WS_SKILLSET12: "Xtreme Encounter (Xayne)",
  T_33_WT_WS_SKILLSET13: "Healing Heartbeat (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Skill Pasif",
  T_33_WT_WS_SKILLSET2_TIP: "Mengaktifkan/menonaktifkan Skill Pasif",
  T_33_WT_WS_SKILLSET3: "Skill Aktif (aktifkan untuk menyesuaikan waktu cooldown di bawah)",
  T_33_WT_WS_SKILLSET3_TIP: "Mengaktifkan/menonaktifkan skill  aktif. Jika aktif, waktu cooldown berbagai skill aktif dapat dikonfigurasi di bawah ini.",
  T_33_WT_WS_SKILLSET4: "Camouflage (Wukong)",
  T_33_WT_WS_SKILLSET5: "Thrill of Battle (A124)",
  T_33_WT_WS_SKILLSET6: "Drop the Beat (Alok)",
  T_33_WT_WS_SKILLSET7: "Painted Refuge (Steffie)",
  T_33_WT_WS_SKILLSET8: "Tracing Steps (Clu)",
  T_33_WT_WS_SKILLSET9: "Master of All (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "detik",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Raindoll (Bottom)",
  T_33_YS_H_ONIGIRI: "Onigiri Hood",
  T_33_YS_H_RAINCOAT: "Raindoll (Head)",
  T_33_YS_HA_CRYINGFACE: "Crying Emote (Facepaint)",
  T_33_YS_M_H_FROGKING: "Topi Raja Katak",
  T_33_YS_S_RAINCOAT: "Raindoll (Shoes)",
  T_33_YS_T_BLACKHOLE: "The Doppler Shift Hoodie",
  T_33_YS_T_RAINCOAT: "Raindoll (Top)",
  T_33_YS_T_SOCCER_GREEN: "Electrified Kick (Jersey)",
  T_33_YS_T_SOCCER_YELLOW: "Energized Kick (Jersey)",
  T_33_YS_T_WIFI: "Net n' Next T-shirt",
  T_34_C_SKILL_DESC_STREAMERGUY: "Setiap eliminasi atau penonton memberikan satu stack efek. Setiap stack mengurangi damage headshot yang diterima sebesar [FFB300]{0}%[-] (maks. [FFB300]{1}%[-] total) dan meningkatkan damage headshot ke musuh sebesar [FFB300]{2}%[-] (maks. [FFB300]{3}%[-] total).",
  T_34_C_SKILL_DESC_TRACKER: "Melepaskan drone ke arah musuh terdekat dalam jarak depan [FFB300]100m[-], menciptakan ledakan pulsa berdiameter [FFB300]{5}m[-] yang mengurangi kecepatan gerak [FFB300]{0}%[-] dan kecepatan menembak sebesar [FFB300]{1}%[-]. Berlangsung selama [FFB300]{3}dtk[-]. Memberikan [FFB300]{2} DMG[-]. Cooldown: [FFB300]{4}dtk[-].",
  T_34_C_SKILL_NAME_TRACKER: "Senses Shockwave",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Pet Skin: Angry Surfer Finn",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Pet Skin: Deep Ocean Finn",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Pet Skin: Thunderstorm Finn",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Pet Skin: Digital Tig",
  T_34_DY_SURFSHARK_N: "Finn",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Great Conductor",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Energetic",
  T_34_HQ_EMOTE_RIDICULE_N: "Ridicule",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Pickup Truck- Evil Engineer",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk- Husky Pup",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle- Hybrid Explosion",
  T_34_JL_G36_MADBIONIC_N: "G36- Flaring Bionica",
  T_34_JL_GRENADE_BIS_N: "Grenade- Soldier Pixel",
  T_34_JL_MACHETE_RAMPAGE4_N: "Night Blade",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Banana Dagger",
  T_34_JL_UMP45_BIS_N: "UMP- Digital Dasher",
  T_34_LY_WS_ABS_DESC: "Dapatkan nilai mutlak dari bilangan ini",
  T_34_LY_WS_ADD_DESC: "Tambahkan elemen baru ke akhir daftar",
  T_34_LY_WS_AUTO_A: "Auto Scan Musuh",
  T_34_LY_WS_BOT: "Regular",
  T_34_LY_WS_BOT_PATH: "Path",
  T_34_LY_WS_BOT_TYPE: "Tipe",
  T_34_LY_WS_BOT4: "Axe",
  T_34_LY_WS_BOT5: "Tossing",
  T_34_LY_WS_BOT6: "Meledak sendiri",
  T_34_LY_WS_BOT8: "Shielded",
  T_34_LY_WS_COL_DESC: "Pilih warna",
  T_34_LY_WS_DEL_DESC: "Hapus elemen yang sesuai dari indeks yang ditunjuk dalam daftar",
  T_34_LY_WS_DF_PER: "Betahan %",
  T_34_LY_WS_FORT_INTERVAL: "Attack interval time (dtk)",
  T_34_LY_WS_GET: "Dapatkan",
  T_34_LY_WS_GET_DESC: "Dapatkan elemen yang sesuai dari indeks yang ditunjuk dalam daftar",
  T_34_LY_WS_GLEN_ARR_DESC: "Dapatkan jumlah elemen dalam daftar saat ini",
  T_34_LY_WS_GLEN_DESC: "Dapatkan panjang string teks ini",
  T_34_LY_WS_GVX: "Dapatkan komponen vektor x",
  T_34_LY_WS_GVX_DESC: "Dapatkan komponen pertama dari sebuah vektor",
  T_34_LY_WS_GVY: "Dapatkan komponen vektor y",
  T_34_LY_WS_GVY_DESC: "Dapatkan komponen kedua dari vektor",
  T_34_LY_WS_GVZ: "Dapatkan komponen vektor z",
  T_34_LY_WS_GVZ_DESC: "Dapatkan komponen ketiga dari vektor",
  T_34_LY_WS_INDEX: "Index",
  T_34_LY_WS_JOIN: "Terhubung",
  T_34_LY_WS_NEG_DESC: "Dapatkan nilai negatif dari angka ini",
  T_34_LY_WS_PATH: "Path Setter",
  T_34_LY_WS_PATH_DESC: "Gunakan untuk menambah/menghapus jalur perjalanan item hidup khusus. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_34_LY_WS_POINT: "Marker",
  T_34_LY_WS_POINT_DESC: "Gunakan untuk menandai koordinat lokasi saat ini. (Tidak berlaku di mode Clash Squad, Team Deathmatch, dan mode Playground)",
  T_34_LY_WS_RANGE_F: "Jauh",
  T_34_LY_WS_RANGE_M: "Sedang",
  T_34_LY_WS_RANGE_N: "Dekat",
  T_34_LY_WS_RNDF_DESC: "Hasilkan desimal acak dari suatu interval",
  T_34_LY_WS_RNDI_DESC: "Hasilkan bilangan bulat acak dari suatu interval",
  T_34_LY_WS_SET: "Ubah",
  T_34_LY_WS_SET_DESC: "Atur elemen yang sesuai dari indeks yang ditunjuk dalam daftar",
  T_34_LY_WS_SQRT_DESC: "Dapatkan akar kuadrat dari bilangan ini",
  T_34_LY_WS_STRC_DESC: "Hubungkan dua string teks",
  T_34_LY_WS_SVX: "Komponen set x vector",
  T_34_LY_WS_SVX_DESC: "Tetapkan komponen pertama dari sebuah vektor",
  T_34_LY_WS_SVY: "Tetapkan komponen vektor y",
  T_34_LY_WS_SVY_DESC: "Tetapkan komponen kedua dari vektor",
  T_34_LY_WS_SVZ: "Tetapkan komponen vektor z",
  T_34_LY_WS_SVZ_DESC: "Tetapkan komponen ketiga dari vektor",
  T_34_LY_WS_VADD: "penambahan vektor",
  T_34_LY_WS_VADD_DESC: "Tambahkan dua vektor",
  T_34_LY_WS_VAL_DESC: "Masukkan bilangan bulat atau desimal sesuai dengan skenario",
  T_34_LY_WS_VANG_DESC: "Hitung sudut antara dua vektor",
  T_34_LY_WS_VCP: "Cross product",
  T_34_LY_WS_VCP_DESC: "Hitung perkalian silang dua buah vektor",
  T_34_LY_WS_VDIS_DESC: "Hitung jarak antara dua vektor",
  T_34_LY_WS_VDP: "Dot product",
  T_34_LY_WS_VDP_DESC: "Hitung hasil kali titik dua vektor",
  T_34_LY_WS_VFX1: "Spherical",
  T_34_LY_WS_VFX2: "Cylindrical",
  T_34_LY_WS_VFX3: "Ring",
  T_34_LY_WS_VFX4: "Boom",
  T_34_LY_WS_VFX5: "Pixel",
  T_34_LY_WS_VFX6: "Spark",
  T_34_LY_WS_VMOD_DESC: "Hitung besar vektor",
  T_34_LY_WS_VMUL: "Perkalian vektor",
  T_34_LY_WS_VMUL_DESC: "Kalikan dua vektor",
  T_34_LY_WS_VNOR_DESC: "Normalisasikan sebuah vektor",
  T_34_LY_WS_VSUB: "Pengurangan vektor",
  T_34_LY_WS_VSUB_DESC: "Subtract dua vector",
  T_34_M_WS_ANGLE: "Putar sudut",
  T_34_M_WS_ARRAY: "Daftar",
  T_34_M_WS_ATT: "Properti",
  T_34_M_WS_BOOL: "Boolean",
  T_34_M_WS_COLORARRAY: "Susunan warna",
  T_34_M_WS_COLOUR: "Warna",
  T_34_M_WS_CONFRONBANNER: "Battle banner",
  T_34_M_WS_COORDINATE: "Kordinasi",
  T_34_M_WS_CUSTOMINF: "Custom HUD",
  T_34_M_WS_CUSTOMMODEDESC: `Kustomisasi Lengkap. Buat dan mainkan sesuai aturan kamu.
Sedikit rumit untuk kreator map baru.`,
  T_34_M_WS_DAMAGETYPE: "Tipe Damage",
  T_34_M_WS_DAMAGETYPEDESC: "Jenis damage yang saat ini diatur oleh sistem",
  T_34_M_WS_DESCTEXT: "Teks deskriptif",
  T_34_M_WS_DURACTION: "Durasi",
  T_34_M_WS_ECAMODE: "Mode Customize",
  T_34_M_WS_ENDPHASEDESC: "Segera akhiri tahap saat ini dan lanjutkan ke tahap berikutnya",
  T_34_M_WS_ENTITY: "Entity",
  T_34_M_WS_FLOAT: "Desimal",
  T_34_M_WS_GAME: "Game",
  T_34_M_WS_GAMERESULTS: "Hasil pertandingan",
  T_34_M_WS_GETCONTROL2: "Dapatkan entitas kontrol dari halaman pemain untuk mengedit properti entitas (termasuk desain, warna, konten, dll.)",
  T_34_M_WS_HEIGHT: "Tinggi",
  T_34_M_WS_HUDBUTTONWIDGET: "Tombol kontrol",
  T_34_M_WS_HUDEMPTYWIDGET: "Pivot kosong",
  T_34_M_WS_HUDIMAGEWIDGET: "Image control",
  T_34_M_WS_HUDINPUTWIDGET: "Kontrol kotak teks",
  T_34_M_WS_HUDLABELWIDGET: "Teks kontrol",
  T_34_M_WS_ICON: "Icon",
  T_34_M_WS_ICON_AIM: "Aim",
  T_34_M_WS_ICON_ARROW: "Arrow",
  T_34_M_WS_ICON_BLAST: "Blast",
  T_34_M_WS_ICON_CIRCULAR: "Circle",
  T_34_M_WS_ICON_CLOTH: "Palm",
  T_34_M_WS_ICON_COLLIMATION: "Crosshair",
  T_34_M_WS_ICON_CORPSE: "Zombie",
  T_34_M_WS_ICON_CROSS: "Cross",
  T_34_M_WS_ICON_DAY: "Matahari",
  T_34_M_WS_ICON_DEFENSE: "Perisai",
  T_34_M_WS_ICON_DIALOGUE: "Dialog",
  T_34_M_WS_ICON_DIAMONDS: "Diamond",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Tanda seru",
  T_34_M_WS_ICON_FLAG: "Bendera",
  T_34_M_WS_ICON_FOLDER: "Folder",
  T_34_M_WS_ICON_GLASSES: "Mata",
  T_34_M_WS_ICON_GUN: "Senjata",
  T_34_M_WS_ICON_HEART: "Hati",
  T_34_M_WS_ICON_HEXAGON: "Hexagon",
  T_34_M_WS_ICON_HOURGLASS: "Jam pasir",
  T_34_M_WS_ICON_HOUSE: "Rumah",
  T_34_M_WS_ICON_KEY: "Kunci",
  T_34_M_WS_ICON_LIGHTNING: "Petir",
  T_34_M_WS_ICON_LOCK: "Lock",
  T_34_M_WS_ICON_LOOP: "Loop",
  T_34_M_WS_ICON_MAGNIFIER: "Kaca pembesar",
  T_34_M_WS_ICON_MONEY: "Uang",
  T_34_M_WS_ICON_MONTH: "Bulan",
  T_34_M_WS_ICON_OPENFOLDER: "Buka folder",
  T_34_M_WS_ICON_PLUS: "Plus",
  T_34_M_WS_ICON_QUADRI: "Quadrilateral",
  T_34_M_WS_ICON_QUESTIONMARK: "Tanda tanya",
  T_34_M_WS_ICON_RECYCLING: "Recycle",
  T_34_M_WS_ICON_REFRESH: "Refresh",
  T_34_M_WS_ICON_REST: "Istirahat",
  T_34_M_WS_ICON_RETURN: "Kembali",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Trapesium kanan",
  T_34_M_WS_ICON_SCISSORS: "Gunting",
  T_34_M_WS_ICON_SETUP: "Pengaturan",
  T_34_M_WS_ICON_SIGN: "Tanda",
  T_34_M_WS_ICON_SIGNOUT: "Exit",
  T_34_M_WS_ICON_SQUARE: "Kotak",
  T_34_M_WS_ICON_STAR: "Bintang",
  T_34_M_WS_ICON_STONE: "Batu",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Pelampung",
  T_34_M_WS_ICON_TAGGING: "Pin",
  T_34_M_WS_ICON_THESWORD: "Pedang",
  T_34_M_WS_ICON_TRAPEZOID: "Trapesium",
  T_34_M_WS_ICON_TRASHCAN: "Tempat sampah",
  T_34_M_WS_ICON_TRIANGLE: "Segi tiga",
  T_34_M_WS_ICON_TROPHY: "Trophy",
  T_34_M_WS_ICON_UP: "Like",
  T_34_M_WS_ICON_WRONG: "Salah",
  T_34_M_WS_ICON_YES: "Benar",
  T_34_M_WS_ICONNAME: "Nama Icon",
  T_34_M_WS_INT: "Bilangan bulat",
  T_34_M_WS_KILLZONE: "Doom Zone",
  T_34_M_WS_LEFTCOLOR: "Warna kiri",
  T_34_M_WS_LEFTTEAMINDEX: "Indeks tim kiri",
  T_34_M_WS_LEFTTEAMSCORE: "Skor tim kiri",
  T_34_M_WS_LOCSWITCH: "Ganti Localization",
  T_34_M_WS_MAX: "Maximum",
  T_34_M_WS_MIN: "Minimum",
  T_34_M_WS_NUMBER: "Nomor",
  T_34_M_WS_OBJECT: "Entity",
  T_34_M_WS_OPEN: "On",
  T_34_M_WS_OPENSATUS: "Nyalakan status",
  T_34_M_WS_PICTURE: "Grafik",
  T_34_M_WS_RANKARRAY: "Susunan peringkat",
  T_34_M_WS_RESULTS: "Hasil",
  T_34_M_WS_RIGHTCOLOR: "Warna yang tepat",
  T_34_M_WS_RIGHTTEAMINDEX: "Indeks tim yang tepat",
  T_34_M_WS_RIGHTTEAMSCORE: "Skor tim yang tepat",
  T_34_M_WS_ROUNDBANNER: "Banner ronde",
  T_34_M_WS_ROUNDDESC: "Deskripsi Ronde",
  T_34_M_WS_ROUNDHUD: "Nomor ronde",
  T_34_M_WS_ROUNDPARAMS: "Susunan bilangan bulat",
  T_34_M_WS_SAME_NAME: "Nama yang berulang. Silakan coba yang baru.",
  T_34_M_WS_SCOREARRAY: "Susunan skor",
  T_34_M_WS_SCORINGTYPE: "Tipe skor",
  T_34_M_WS_SCORINGTYPEDECS: "Jenis skor yang bisa didapatkan pemain. Mendukung kustomisasi skor.",
  T_34_M_WS_SCUFFLESCORING: "Skor Multi-tim",
  T_34_M_WS_SETATTRIBUTES: "Pengaturan properti",
  T_34_M_WS_SHUT: "Off",
  T_34_M_WS_SOUND: "Efek suara",
  T_34_M_WS_SOUNDCLICK: "Mengklik",
  T_34_M_WS_SOUNDDD: "hitung mundur",
  T_34_M_WS_SOUNDFEMALEA: "Terluka (Wanita)",
  T_34_M_WS_SOUNDM: "tembakan",
  T_34_M_WS_SOUNDMALEA: "Terluka (Pria)",
  T_34_M_WS_SOUNDUAV: "Ledakan",
  T_34_M_WS_ST_ASSISTCOUNT: "Assist",
  T_34_M_WS_ST_CHECKPROGRESS: "Progress Checkpoint",
  T_34_M_WS_ST_DAMAGESUM: "Damage",
  T_34_M_WS_ST_FINISHCOUNT: "Jumlah tujuan yang dicapai",
  T_34_M_WS_ST_FINISHORDER: "Urutan tujuan tercapai",
  T_34_M_WS_ST_FINISHTIME: "Waktu tujuan tercapai",
  T_34_M_WS_ST_KILLCOUNT: "Kill",
  T_34_M_WS_ST_MAINSCORE: "Skor target",
  T_34_M_WS_ST_RANKSCORE: "Skor Rank",
  T_34_M_WS_ST_SURVIVALDURACTION: "Waktu bertahan hidup",
  T_34_M_WS_ST_UNKOWN: "Tidak dikenal",
  T_34_M_WS_STARTBANNER: "Mulai banner",
  T_34_M_WS_STARTTIME: "Waktu mulai",
  T_34_M_WS_STRING: "Teks",
  T_34_M_WS_STUDIO: "STUDIO",
  T_34_M_WS_TEAMARRAY: "Susunan tim",
  T_34_M_WS_TEXTCONTENT: "Konten",
  T_34_M_WS_THEMECOLOR: "Warna tema",
  T_34_M_WS_TIME: "HUD Hitung Mundur",
  T_34_M_WS_TITLETEXT: "Judul Teks",
  T_34_M_WS_TYPE: "Tipe",
  T_34_M_WS_UODATETYPE: "Jenis update",
  T_34_M_WS_VARNAME: "Nama Variabel",
  T_34_M_WS_VECTOR: "Vector",
  T_34_M_WS_VFX: "Visual efek",
  T_34_M_WS_WIDTH: "Width",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "Api",
  T_34_SP_WS_BLOCK1_NAME: "Ubah tahap",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Beralih tahap pertandingan untuk masuk ke tahap yang diinginkan (atau putaran). Putaran juga memiliki indeks panggung dan merupakan jenis panggung khusus.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "Indeks tahap target",
  T_34_SP_WS_BLOCK10_NAME: "Buat visual efek",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Buat ikon menggunakan efek visual yang ditentukan. Lebih banyak properti efek visual dapat dikonfigurasi dengan menyesuaikan properti dari efek visual.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Visual efek",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Jenis efek visual yang dapat diterapkan",
  T_34_SP_WS_BLOCK12_NAME: "Hapus visual efek",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Hapus efek visual yang ditunjuk",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Entitas efek visual",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "Entitas efek visual yang akan dihapus",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Perintahkan klien untuk memainkan efek visual",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "List Pemain",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "Daftar pemain yang akan menerima pesan",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Jalur sumber daya",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "Jalur sumber daya sistem ada in:path. Jalur sumber daya khusus out:path. Kosong secara default.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "Channel RGBA, dengan setiap channel mengambil nilai antara 0 dan 255 disimpan di int32. Warna default adalah putih (255.255.255.255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Zoom",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "skala zoom; defaultnya adalah 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Posisi tampilan dinyatakan dalam koordinat global. Vektor3(0) secara default.",
  T_34_SP_WS_BLOCK14_NAME: "Main efek suara",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Perintahkan klien untuk memainkan efek suara",
  T_34_SP_WS_BLOCK15_NAME: "Output log",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Keluarkan konten ke halaman log",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Aktifkan untuk mengaktifkan damage pada pemain di luar Zona Aman",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "Titik pusat Zona Aman",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Radius",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "Radius Zona Aman",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "Hitung mundur untuk Zona Aman mulai menyusut",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "Durasi menyusut Zona Aman",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "Jumlah damage yang diterima saat berada di luar Zona Aman",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Saat Zona Bahaya dimatikan, pemain di luar Zona Aman tidak akan menerima damage",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Gunakan untuk menunda tindakan selanjutnya untuk waktu yang ditentukan",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "Durasi menunggu, diukur dalam milidetik",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Gunakan untuk menunda tindakan selanjutnya ke bingkai berikutnya",
  T_34_SP_WS_BLOCK6_NAME: "Buat HUD custom khusus",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Buat HUD khusus yang ditunjuk",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "Nama yang digunakan untuk membuat entitas HUD. Variabel lokal yang terkait dengannya adalah entitas HUD yang sedang dibuat.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Pemain",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "Entitas pemain tertentu. Hanya terlihat oleh pemain tersebut.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "Indeks unik dari HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Buat HUD default, yang hanya terlihat untuk pemain yang ditunjuk",
  T_34_SP_WS_BLOCK8_NAMEDESC: "Saat dihapus, HUD default tidak akan terlihat pada klien (baik disembunyikan atau dibuang)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD entity",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "Entitas HUD yang akan dihapus",
  T_34_SP_WS_BLOCK9_NAMEDESC: "Saat dihapus, HUD khusus tidak akan terlihat di klien (baik disembunyikan atau dibuang)",
  T_34_T_WS_BLOCK1_NAMEDESC: "Insiden dipicu saat match dimulai",
  T_34_T_WS_BLOCK10_NAMEDESC: "Insiden dipicu ketika seorang pemain yang tereliminasi",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "Pemain yang terelminasi yang akan memicu insiden",
  T_34_T_WS_BLOCK13_NAMEDESC: "Insiden dipicu ketika seorang pemain membantu pemain lain",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "Pemain yang tereleminasi",
  T_34_T_WS_BLOCK14_NAMEDESC: "Insiden dipicu ketika pemain memberikan damage",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "Pemain yang menerima damage",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "Jenis damage yang ditimbulkan",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "Jumlah damage yang ditimbulkan",
  T_34_T_WS_BLOCK15_NAMEDESC: "Insiden dipicu ketika seorang pemain menghabisi pemain lain",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "Pemain yang tereliminasi",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "Jenis damage yang menyebabkan eliminasi",
  T_34_T_WS_BLOCK16_NAMEDESC: "Insiden dipicu ketika seorang pemain bergabung dalam pertandingan",
  T_34_T_WS_BLOCK17_NAMEDESC: "Insiden dipicu saat pemain dihidupkan kembali",
  T_34_T_WS_BLOCK18_NAMEDESC: "Insiden dipicu ketika tim dihapus",
  T_34_T_WS_BLOCK19_NAMEDESC: "Insiden dipicu saat tim ditambahkan",
  T_34_T_WS_BLOCK2_NAMEDESC: "Insiden dipicu saat pertandingan berakhir",
  T_34_T_WS_BLOCK20_NAMEDESC: "Insiden dipicu saat tim dimusnahkan",
  T_34_T_WS_BLOCK3_NAMEDESC: "Insiden dipicu ketika setiap putaran dimulai",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "Angka bulat dimulai dari 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Round index",
  T_34_T_WS_BLOCK4_NAMEDESC: "Insiden dipicu ketika setiap putaran berakhir",
  T_34_T_WS_BLOCK5_NAMEDESC: "Insiden dipicu saat tahap dimulai",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "Nomor panggung dimulai dari 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Stage entity",
  T_34_T_WS_BLOCK6_NAMEDESC: "Insiden dipicu saat tahap berakhir",
  T_34_T_WS_BLOCK7_NAMEDESC: "Insiden terpicu saat pemain keluar dari pertandingan",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "Pemain yang akan memicu insiden",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Triggering pemain",
  T_34_T_WS_BLOCK8_NAMEDESC: "Insiden dipicu saat skor pemain berubah",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "Jenis skor yang diubah",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "Nilai skor setelah perubahan",
  T_34_T_WS_BLOCK9_NAMEDESC: "Insiden dipicu ketika skor tim berubah",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "Tim yang akan memicu insiden",
  T_34_WT_WS_BORNENTITY_PARAM1: "Titik Spawn",
  T_34_WT_WS_BORNENTITY_PARAM2: "Koordinat yang tersedia",
  T_34_WT_WS_BORNENTITY_PARAM3: "Tetapkan sebagai titik spawn default",
  T_34_WT_WS_BORNENTITY_PARAM4: "Batas bercahaya",
  T_34_WT_WS_BORNENTITY_PARAM5: "Digunakan atau tidak",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Checkpoint HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Status Buka",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Trigger Status",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Trigger Eliminasi atau tidak",
  T_34_WT_WS_ENTITY_PARAM1: "Game entity",
  T_34_WT_WS_ENTITY_PARAM10: "# tim",
  T_34_WT_WS_ENTITY_PARAM11: "# anggota tim",
  T_34_WT_WS_ENTITY_PARAM12: "Equipment direset setiap putaran",
  T_34_WT_WS_ENTITY_PARAM13: "Aktifkan kerusakan di luar zona",
  T_34_WT_WS_ENTITY_PARAM14: "Ukuran zona",
  T_34_WT_WS_ENTITY_PARAM15: "Waktu mulai zona mengecil",
  T_34_WT_WS_ENTITY_PARAM16: "Durasi zona mengecil",
  T_34_WT_WS_ENTITY_PARAM17: "Damage di luar zona",
  T_34_WT_WS_ENTITY_PARAM18: "Skor Target",
  T_34_WT_WS_ENTITY_PARAM19: "Skor Eliminasi",
  T_34_WT_WS_ENTITY_PARAM2: "Status invalid",
  T_34_WT_WS_ENTITY_PARAM20: "Tipe Revival",
  T_34_WT_WS_ENTITY_PARAM21: "Kriteria peringkat skor putaran (pemain)",
  T_34_WT_WS_ENTITY_PARAM22: "Kriteria penting (pemain)",
  T_34_WT_WS_ENTITY_PARAM23: "Kriteria peringkat skor putaran (tim)",
  T_34_WT_WS_ENTITY_PARAM24: "Kriteria penting (tim)",
  T_34_WT_WS_ENTITY_PARAM25: "Kriteria peringkat skor (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Kriteria penting (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Skor peringkat putaran",
  T_34_WT_WS_ENTITY_PARAM28: "Tampilkan kriteria di halaman hasil",
  T_34_WT_WS_ENTITY_PARAM29: "Total # dari ronde",
  T_34_WT_WS_ENTITY_PARAM3: "Waktu bermain",
  T_34_WT_WS_ENTITY_PARAM4: "Indeks putaran saat ini",
  T_34_WT_WS_ENTITY_PARAM5: "Indeks tahap saat ini",
  T_34_WT_WS_ENTITY_PARAM6: "Mode template ID",
  T_34_WT_WS_ENTITY_PARAM7: "Aktifkan revival pemain",
  T_34_WT_WS_ENTITY_PARAM8: "Aktifkan revival bot",
  T_34_WT_WS_ENTITY_PARAM9: "Waktu Revival",
  T_34_WT_WS_ENTITY1_NAME: "Entitas saat ini",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Kembali ke entitas saat ini",
  T_34_WT_WS_ENTITY10_NAME: "Hapus ikon",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Hapus ikon yang ditunjuk",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Pilih ikon yang ingin kamu hapus",
  T_34_WT_WS_ENTITY11_NAME: "Hapus teks",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Hapus entitas teks",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Pilih teks yang ingin kamu hapus",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Tambahkan item untuk pemain yang ditunjuk",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Pemain yang akan menerima item",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "ID item spesifik yang akan diperoleh",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "Jumlah barang yang akan diberikan",
  T_34_WT_WS_ENTITY12_PARAM3: "Jumlah",
  T_34_WT_WS_ENTITY13_PARAM1: "Tipe",
  T_34_WT_WS_ENTITY13_PARAM2: "Lokasi",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "Koordinat lokasi spawn objek",
  T_34_WT_WS_ENTITY13_PARAM4: "Objek",
  T_34_WT_WS_ENTITY14_NAME: "Hapus objek",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Hapus objek yang ditunjuk",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Hapus objek",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Dapatkan semua entitas pemain",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Dapatkan semua entitas tim",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Pulihkan jumlah HP yang ditentukan untuk pemain yang ditunjuk. Jika jumlah pemulihan melebihi HP maksimum, HP hanya akan pulih secara maksimal.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Pemain yang fluktuasi HPnya sedang dikonfigurasi",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "Jumlah HP yang ditentukan untuk dipulihkan",
  T_34_WT_WS_ENTITY18_NAME: "Dapatkan koordinat spawn acak",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Konfigurasikan lokasi untuk pemain yang ditunjuk untuk muncul dan kembali",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Pemain yang akan muncul secara acak dari lokasi ini",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Koordinat lokasi di mana pemain akan ditugaskan",
  T_34_WT_WS_ENTITY19_NAME: "Dapatkan skor pemain",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Dapatkan skor tertentu dari pemain yang ditunjuk",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Dapatkan entitas skor dari pemain ini",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Dapatkan jenis skor",
  T_34_WT_WS_ENTITY19_RETURNDESC: "Nilai skor spesifik yang akan diperoleh",
  T_34_WT_WS_ENTITY2_NAME: "Set properti",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Konfigurasikan nilai properti, di mana tipe properti telah dipilih",
  T_34_WT_WS_ENTITY2_PARAM1: "Entity",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "Nilai properti entitas game",
  T_34_WT_WS_ENTITY2_PARAM3: "Properti",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Properti tertentu dari entitas game ini",
  T_34_WT_WS_ENTITY2_PARAM4: "Nilai",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "Nilai tertentu dari sebuah properti. Pastikan tipe properti sejajar dengan yang dipilih dan cocok dengan tipe yang dikonfigurasi di blok terkait.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Konfigurasikan skor tertentu dari pemain yang ditunjuk",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Konfigurasikan entitas skor pemain ini",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Konfigurasikan jenis skor",
  T_34_WT_WS_ENTITY20_PARAM3: "Skor",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "Nilai skor spesifik sedang ditetapkan",
  T_34_WT_WS_ENTITY21_NAME: "Dapatkan total skor tim",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Dapatkan jenis skor total tertentu dari tim yang ditunjuk",
  T_34_WT_WS_ENTITY21_PARAM1: "Tim",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Dapatkan entitas skor dari tim ini",
  T_34_WT_WS_ENTITY22_NAME: "Tetapkan skor ronde tim saat ini",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Konfigurasikan jenis tertentu dari skor ronde saat ini dari tim yang ditunjuk",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Konfigurasikan skor tim ini",
  T_34_WT_WS_ENTITY23_NAME: "Dapatkan skor ronde pemain",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Dapatkan skor tertentu dari ronde tertentu untuk pemain yang ditunjuk",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Dapatkan ronde skor dari pemain ini",
  T_34_WT_WS_ENTITY23_PARAM2: "Ronde",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Dapatkan skor dari ronde ini",
  T_34_WT_WS_ENTITY24_NAME: "Dapatkanr ronde skor tim",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Dapatkan skor tertentu dari putaran tertentu untuk tim yang ditunjuk",
  T_34_WT_WS_ENTITY25_NAME: "Teleport",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Teleport pemain yang ditunjuk ke lokasi yang ditentukan",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Pemain yang akan diteleportasi",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Koordinat tempat pemain akan diteleportasi",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Aktifkan pemain yang ditunjuk untuk menyebabkan damage pada target yang ditentukan. Jika tidak ada pemain penyerang yang dipilih, target yang ditentukan akan menerima damage dari sistem.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entitas yang akan menerima damage",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "Jumlah damage yang diberikan",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Menghidupkan kembali pemain yang ditunjuk",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Entitas pemain yang dapat dihidupkan kembali",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Konfigurasikan jenis blok",
  T_34_WT_WS_ENTITY3_PARAM1: "sebagai",
  T_34_WT_WS_ENTITY4_NAME: "Dapatkan properti",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Dapatkan properti tertentu dari suatu entitas",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Dapatkan entity game tertentu dari nilai properti",
  T_34_WT_WS_ENTITY4_RETURNDESC: "Nilai properti spesifik yang akan diperoleh",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Konfigurasikan kemampuan bergerak untuk semua pemain",
  T_34_WT_WS_ENTITY6_NAME: "Buat Ikon",
  T_34_WT_WS_ENTITY6_PARAM1: "Icon",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "Gambar yang ditampilkan di HUD. Pilih dari berbagai desain.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Pilih ikon di mana desain harus diterapkan",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Buat ikon HUD untuk pemain yang ditunjuk. Jika tidak ada entitas pemain yang dipilih, HUD akan dibuat untuk semua pemain.",
  T_34_WT_WS_ENTITY7_PARAM1: "Pemain",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Buat ikon HUD untuk pemain tertentu",
  T_34_WT_WS_ENTITY8_NAME: "Buat teks",
  T_34_WT_WS_ENTITY8_PARAM1: "Teks",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "Konten teks spesifik yang akan dibuat dari perintah ini",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "Entitas teks yang sedang dibuat",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Tambahkan sebaris teks HUD untuk pemain yang ditunjuk. Jika tidak ada entitas pemain yang dipilih, teks akan dibuat di HUD semua pemain.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Tambahkan teks HUD untuk pemain tertentu",
  T_34_WT_WS_ICONENTITY_PARAM1: "Icon entity",
  T_34_WT_WS_ICONENTITY_PARAM2: "Design",
  T_34_WT_WS_ICONENTITY_PARAM3: "Warna",
  T_34_WT_WS_ICONENTITY_PARAM4: "Skala",
  T_34_WT_WS_ICONENTITY_PARAM5: "Posisi tampilan",
  T_34_WT_WS_ICONENTITY_PARAM6: "Ikuti target",
  T_34_WT_WS_ICONENTITY_PARAM7: "Terlihat melalui dinding",
  T_34_WT_WS_ICONENTITY_PARAM8: "Selalu di layar",
  T_34_WT_WS_ONETEAM_TAG: "Single Team",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Entitas tahap",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Stage index",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Waktu mulai",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Akhir waktu",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Durasi",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Entity pemain",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Titik Revival",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Rasio damage",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Model 3D karakter",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Identitas",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "HP saat ini",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Status Pemain",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Waktu bertahan hidup",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Kebal",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Tim",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "Target checkpoint ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Titik Spawn",
  T_34_WT_WS_PROCIRCLE_ICON: "Ikon",
  T_34_WT_WS_PVEDESC1: "Jika setidaknya satu pemain mencapai garis akhir sebelum waktu habis, tim menang. Jika semua pemain dieliminasi pada saat yang sama, game over.",
  T_34_WT_WS_PVEDESC2: "Bertahan untuk waktu yang ditentukan untuk menang. Jika semua pemain dieliminasi pada saat yang sama, game over.",
  T_34_WT_WS_PVENAME1: "Rush",
  T_34_WT_WS_PVENAME2: "Endurance",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "Checkpoint ID saat ini",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Nomor checkpoint mode parkour",
  T_34_WT_WS_SKILLSET14: "Swordsman's Wrath (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Tim entity",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Ace",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Semua member",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Regular trigger",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Tipe penampilan",
  T_34_WT_WS_TXTENTITY_PARAM1: "Entitas teks",
  T_34_WT_WS_TXTENTITY_PARAM2: "Konten",
  T_34_WT_WS_VFXENTITY_PARAM1: "Entitas efek visual",
  T_34_WZ_WS_LOGIC10_NAME: "Lanjutkan ke berikutnya",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Lewati iterasi loop saat ini dan jalankan yang berikutnya",
  T_34_WZ_WS_LOGIC11_NAME: "Kembali",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Mengakhiri eksekusi saat ini dan kembali ke program utama. Memungkinkan mengirim kembali data saat kembali.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Nilai kembali",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Data yang akan dikirim kembali ke program utama",
  T_34_WZ_WS_LOGIC2_NAME: "Bandingkan",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Bandingkan 2 nilai menggunakan operator yang ditunjuk",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Nilai kiri",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "Nilai sisi kiri yang digunakan untuk perbandingan",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Fungsi perbandingan",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Pilih bagaimana kamu ingin nilai dibandingkan. Operator yang didukung adalah: >, ≥, ==, ≠, ≤, <, AND (khusus Boolean), OR (khusus Boolean)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Nilai kanan",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "Nilai sisi kanan yang digunakan untuk perbandingan",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Hasil perbandingan",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Memberikan kebalikan dari nilai logis",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "Nilai yang ingin kamu gunakan operator NOT menyala",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Hasil dari operasi NOT",
  T_34_WZ_WS_LOGIC4_NAME: "Cek kosong",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Periksa apakah suatu entitas kosong/null",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entity",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "Entitas untuk memeriksa kekosongan untuk",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Apakah entitas itu kosong atau tidak",
  T_34_WZ_WS_LOGIC5_NAME: "If",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Dieksekusi sesuai dengan terpenuhi atau tidaknya kondisi. Sub-proses sama dengan cabang logika berikutnya.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Nilai",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "Jumlah kondisi dan jumlah subproses (cabang logika) harus sama",
  T_34_WZ_WS_LOGIC6_NAME: "Loop rentang bilangan bulat",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Loop dari x ke y dengan langkah z. Sub-proses adalah loop itu sendiri.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "Nama indeks loop yang dapat digunakan untuk mengekstrak nilai indeks loop variabel lokal",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Mulai Nilai",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "Nilai di mana loop dimulai",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Nilai akhir",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "Nilai di mana loop berakhir",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Step",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "Langkah setiap loop. Jika nilai awal lebih kecil dari nilai akhir, langkah harus lebih besar dari 0. Jika nilai awal lebih besar dari nilai akhir, langkah harus kurang dari 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Loop setiap element",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Memungkinkan traversal wadah data untuk mengekstrak setiap sub-elemen di dalamnya. Sub-proses adalah loop itu sendiri.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Element",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Melintasi nama ini akan mengekstrak nilai sub-elemen variabel lokal",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Wadah Data",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "Wadah data yang akan dilalui. Saat ini mendukung jenis daftar.",
  T_34_WZ_WS_LOGIC8_NAME: "Conditional loop",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "Sebuah conditional loop berulang sampai kondisi terpenuhi. Loop berhenti ketika kondisinya False.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Kondisi",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Mengulangi loop jika kondisi Benar dan berhenti sampai kondisi Salah",
  T_34_WZ_WS_LOGIC9_NAME: "Break loop",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Menghentikan proses loop saat ini dan melompat keluar dari loop",
  T_34_Y_B_DINOSAURS: "Dinosaur Illusion (Bottom)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Pure Angel (F)",
  T_34_YS_F_B_PANDACATTLE: "Moo Zoo (Bottom)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Aqua Rogue (Bottom)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Aqua Rogue (Head)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Aqua Rogue (Facepaint)",
  T_34_YS_F_S_PANDACATTLE: "Moo Zoo (Shoes)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Aqua Rogue (Shoes)",
  T_34_YS_F_T_PANDACATTLE: "Moo Zoo (Top)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Aqua Rogue (Top)",
  T_34_YS_M_B_ANGEL_BW: "Pure Angel (M)",
  T_34_YS_M_B_PANDACATTLE: "Panda Pyjamas (Bottom)",
  T_34_YS_M_H_PANDACATTLE: "Panda Pyjamas (Head)",
  T_34_YS_M_S_PANDACATTLE: "Panda Pyjamas (Shoes)",
  T_34_YS_M_T_PANDACATTLE: "Panda Pyjamas (Top)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Dapatkan [FFB300]{0} EP[-] dengan knock down musuh.",
  T_35_DY_PET_OWL_N: "Hoot",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Pet Skin: Spaceship Moony",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Pet Skin: Azulcrema Trace Zasil",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Pet Skin: Agui Blue",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Pet Skin: Hoot On Fire",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Pet Skin: Nocturnal Hoot",
  T_35_DY_PETSKIN_OWL_STORM_N: "Pet Skin: Frosty Hoot",
  T_35_JL_KNOCKEDDOWN: "sedang knock down",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "Selama [FFB300]{1}dtk[-], menembak Gloo Wall yang berhasil akan menandai musuh dalam jarak [FFB300]{3}m[-] darinya dan menembus Gloo Wall untuk menyebabkan damage pada musuh yang ditandai (damage yang ditimbulkan akan lebih rendah dari biasanya). Efektif pada [FFB300]{0}[-] Gloo Walls maks. Waktu tunggu: [FFB300]{2}dtk[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Wall Brawl",
  T_35_KY_INFECTION_MAPNAME: "Wasteland",
  T_35_M_WS_BUTTONCLICKDESC: "Dapat dipicu ketika tombol yang sesuai diklik, dan pemain yang diklik dapat diperoleh melalui parameter",
  T_35_M_WS_GETTEAMMATEPOS: "Dapatkan lokasi rekan tim terdekat",
  T_35_M_WS_ROUND2: "Gelombang saat ini",
  T_35_PD_Infection_HUMANSELECT: "Pilih senjata",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "Objek",
  T_35_QX_WS_ICONTYPE_NATURE: "Shapes of Nature",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geometric",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Simbol",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Senjata",
  T_35_R_EMOTE_TAG_MUSIC_N: "Musik",
  T_35_RW_SKILL_DESC_Singers: "Pengguna skill dan teman setim dalam jarak [FFB300]{0}m[-] dapat memblokir [FFB300]{1}%[-] damage menggunakan EP mereka. Dalam hal ini, jumlah EP yang dipotong dari teman setim akan ditambahkan ke EP pengguna skill.",
  T_35_RW_SKILL_NAME_Singers: "Silent Sentinel",
  T_35_SP_WS_COMMENTKEY_01: "Kesulitan yang sesuai",
  T_35_SP_WS_COMMENTKEY_02: "Kreatif",
  T_35_SP_WS_COMMENTKEY_03: "Gameplay menarik",
  T_35_SP_WS_COMMENTKEY_04: "Bisa dimainkan berulang kali",
  T_35_SP_WS_COMMENTKEY_05: "Alur cerita yang menarik",
  T_35_SP_WS_COMMENTKEY_06: "Seimbang",
  T_35_SP_WS_COMMENTKEY_07: "Pengalaman menyenangkan",
  T_35_SP_WS_COMMENTKEY_08: "Fleksibel",
  T_35_SP_WS_COMMENTKEY_09: "Estetik",
  T_35_SP_WS_COMMENTKEY_10: "Terlalu sulit",
  T_35_SP_WS_COMMENTKEY_11: "Terlalu mudah",
  T_35_SP_WS_COMMENTKEY_12: "Membosankan",
  T_35_SP_WS_COMMENTKEY_13: "Terlalu lama",
  T_35_SP_WS_COMMENTKEY_14: "Keseimbangan yang buruk",
  T_35_SP_WS_COMMENTKEY_15: "Pengalaman tidak menyenangkan",
  T_35_SP_WS_IMAGE03: "Texture",
  T_35_SP_WS_IMAGE04: "Frame",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buster- Lava Lustre",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Grenade- Crystal Eerie",
  T_35_SY_GRENADE_PIRATES_N: "Grenade- Rowdy Searuler",
  T_35_SY_GRENADE_RIDERS_N: "Grenade- Grim Rider",
  T_35_SY_M24_KUN_N: "M24- Riverdust Splasher",
  T_35_SY_SCAR_PARKOUR_N: "SCAR- Gusto Freerunner",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jeep- Monochrome Jigsaw",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Nikmati perayaannya!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Motorbike- Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Dekor Struktur",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Struktur",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Lainnya",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Arsitektur",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Gedung Besar",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Gedung Sedang",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Objek Fungsional",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Mode Essentials",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Musik",
  T_35_WT_WS_PVEMODE_TAG: "Mode Survival",
  T_35_WZY_WS_BECRE_NAMEDESC: "Dipicu saat entitas ini dibuat",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Dipicu saat entitas ini dieliminasi. Sumber serangan dapat diidentifikasi menggunakan "Trigger Entity" dan jenis serangan dapat diidentifikasi menggunakan "Jenis Damage".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "Entitas yang memicu insiden",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Buat jenis item atau satu set item di lokasi tertentu. Saat membuat satu jenis item, jumlahnya adalah jumlah item tersebut. Saat membuat satu set item, jumlah adalah daftar jumlah yang sesuai dengan daftar item. Item yang dibuat akan bergantung pada unit peta.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "Daftar yang berisi item-item yang akan dibuat. Itu juga dapat terdiri dari satu item.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "Daftar jumlah yang sesuai dengan daftar item. Ini mungkin hanya berisi jumlah satu jenis item.",
  T_35_WZY_WS_DAMTYPE_CAR: "Kendaraan",
  T_35_WZY_WS_DAMTYPE_FALL: "Fall",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Gun",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Grenade",
  T_35_WZY_WS_DAMTYPE_MELEE: "Melee",
  T_35_WZY_WS_DAMTYPE_ZONE: "Di luar zona",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Hapus sejumlah item tertentu dari pemain tertentu",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Masuk trigger area",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Dipicu saat "Trigger Entity" memasuki trigger area',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "Untuk mendapatkan entitas. Saat ditautkan dengan pemain, info entitas hanya akan diperbarui untuk pemain tersebut. Ketika tidak ada pemain yang terhubung, semua pemain akan menerima info entitas.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Battle Entity",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Dapatkan semua objek dari tipe tertentu. Hasilnya adalah sebuah daftar.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Tipe objek",
  T_35_WZY_WS_HUDWIDGET_NAME: "Kontrol UI",
  T_35_WZY_WS_HURT_NAMEDESC: 'Dipicu saat entitas ini menerima damage. Sumber serangan dapat diidentifikasi menggunakan "Entitas Pemicu".',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "Tipe Item",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Stage Object",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Dipicu saat entitas ini menghilangkan entitas lain. Jenis entitas yang dieliminasi dapat diidentifikasi menggunakan "Entitas yang Dieliminasi".',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "Entitas yang dieliminasi",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Terpicu ketika suatu entitas menyebabkan damage",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "Entitas yang menangani damage",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Entitas target",
  T_35_WZY_WS_PREFABID_NAME: "Template ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "EP Saat ini",
  T_35_WZY_WS_PROPERTY_JUMP: "Ketinggian lompatan",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Keluar trigger area",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Dipicu saat "Trigger Entity" keluar dari area pemicu',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Hapus elemen tertentu dari array. [Array] adalah tempat elemen itu berada. [Element] adalah elemen yang akan dihilangkan.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Element value",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "Nilai dari element ini telah dihilangkan",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Round Entity",
  T_35_WZY_WS_TOWER_PARAM1: "Menara dan Benteng",
  T_35_WZY_WS_TOWER_PARAM2: "ID Team",
  T_35_WZY_WS_TOWER_PARAM3: "HP saat ini",
  T_35_WZY_WS_TOWER_PARAM4: "Max. HP",
  T_35_WZY_WS_TOWER_PARAM5: "Damage",
  T_35_WZY_WS_TOWER_PARAM6: "Interval serangan",
  T_35_WZY_WS_TOWER_PARAM7: "Jangkauan serangan",
  T_35_WZY_WS_TOWER_PARAM8: "Bertahan %",
  T_35_XYL_PDM_REVENGE: "Dibalaskan",
  T_35_XYL_WS_BISPARTERRE: "Graffiti Flowerbed",
  T_35_XYL_WS_BISPARTERRE_DESC: "Sebuah petak bunga batu bertema Battle-In-Style",
  T_35_XYL_WS_BISWALL: "Graffiti Wall",
  T_35_XYL_WS_BISWALL_DESC: "Dinding bertema Battle-In-Style yang dapat digabungkan",
  T_35_XYL_WS_BOTDROP: "Nyala/ matikan loot drop",
  T_35_XYL_WS_CUSTOMTRIGGER: "Trigger khusus",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Tempatkan objek yang memicu efek khusus tertentu saat pemain mengaktifkannya. Efeknya harus dikonfigurasi dalam skrip. (Hanya dalam mode Customize.)",
  T_35_XYL_WS_DOUBLEDOOR: "Gerbang",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "Sebuah gerbang yang retak terbuka",
  T_35_XYL_WS_RESET: "Reset setiap ronde",
  T_35_XYL_WS_RESETN: "Tidak",
  T_35_XYL_WS_RESETY: "Iya",
  T_35_XYL_WS_ROADBLOCK: "Roadblock A",
  T_35_XYL_WS_ROADBLOCK_DESC: "Tahan agar tidak lewat",
  T_35_XYL_WS_STAIRS: "Tangga",
  T_35_XYL_WS_STAIRS_DESC: "Tangga yang dapat digabungkan dengan pendaratan",
  T_35_XYL_WS_STAIRSL: "Landing B",
  T_35_XYL_WS_STAIRSL_DESC: "Sebuah platform yang dapat dikombinasikan dengan tangga",
  T_35_XYL_WS_STAIRSZ: "Landing A",
  T_35_XYL_WS_STAIRSZ_DESC: "Sebuah platform yang dapat dikombinasikan dengan tangga",
  T_35_XYL_WS_TBOOTH: "Phone Booth",
  T_35_XYL_WS_TBOOTH_DESC: "Sering terlihat di jalanan",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Cub Mask",
  T_35_YS_F_A_PANTOMIME: "Two-toned Grief (Mask)",
  T_35_YS_F_A_RIDERS: "Fatal Rider (Mask)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Beauty Reuniter (Bottom)",
  T_35_YS_F_B_GOLDCHAIN: "Armor of Riches (Bottom)",
  T_35_YS_F_B_PANTOMIME: "Two-toned Grief (Bottom)",
  T_35_YS_F_B_RIDERS: "Fatal Rider (Bottom)",
  T_35_YS_F_H_BEAR_HW: "Cub Cap",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Beauty Reuniter (Head)",
  T_35_YS_F_H_GOLDCHAIN: "Armor of Riches (Head)",
  T_35_YS_F_H_PANTOMIME: "Two-toned Grief (Head)",
  T_35_YS_F_H_RIDERS: "Fatal Rider (Head)",
  T_35_YS_F_HA_GOLDCHAIN: "Armor of Riches (Facepaint)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Beauty Reuniter (Shoes)",
  T_35_YS_F_S_GOLDCHAIN: "Armor of Riches (Shoes)",
  T_35_YS_F_S_PANTOMIME: "Two-toned Grief (Shoes)",
  T_35_YS_F_S_RIDERS: "Fatal Rider (Shoes)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Beauty Reuniter (Top)",
  T_35_YS_F_T_GOLDCHAIN: "Armor of Riches (Top)",
  T_35_YS_F_T_PANTOMIME: "Two-toned Grief (Top)",
  T_35_YS_F_T_RIDERS: "Fatal Rider (Top)",
  T_35_YS_ITEM_SUPERFAK: "Super Med",
  T_35_YS_M_A_GOLDCHAIN: "Chainz of Lux (Mask)",
  T_35_YS_M_A_RIDERS: "Grim Rider (Mask)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz of Lux (Bottom)",
  T_35_YS_M_B_RIDERS: "Grim Rider (Bottom)",
  T_35_YS_M_H_BEAR_HW: "Cub Cap",
  T_35_YS_M_H_GOLDCHAIN: "Chainz of Lux (Head)",
  T_35_YS_M_H_RIDERS: "Grim Rider (Head)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz of Lux (Shoes)",
  T_35_YS_M_S_RIDERS: "Grim Rider (Shoes)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz of Lux (Top)",
  T_35_YS_M_T_RIDERS: "Grim Rider (Top)",
  T_35_YS_T_CHAMPION: "Champion Tee",
  T_35_YS_T_PAINTING: "Squeeze Tee",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Dapatkan koin saat pertandingan dimulai",
  T_36_JH_WS_CESAYCLOSE: "Nonaktifkan tutup manual atau tidak",
  T_36_JH_WS_CHOOSEEDITSHOP: "Pilih store untuk edit",
  T_36_JH_WS_CHOOSESHOP: "Pilih store",
  T_36_JH_WS_COINCOUNT: "Jumlah Currency",
  T_36_JH_WS_COINHUD: "Tampilkan jumlah koin atau tidak",
  T_36_JH_WS_CRAFTSHOP: "Edit store",
  T_36_JH_WS_CREATEGOLD: "Generator Koin",
  T_36_JH_WS_CSHOPENTITY: "Sesuaikan entitas toko store Bind",
  T_36_JH_WS_CSHOPHUD: "Store interface",
  T_36_JH_WS_CURRENTLIMIT: "Batas pembelian yang tersisa",
  T_36_JH_WS_ECONOMIC: "Ekonomi",
  T_36_JH_WS_INGAMEECONOMI: "Ekonomi dalam game",
  T_36_JH_WS_ITEMINDEXID: "Nomor Merchandise",
  T_36_JH_WS_KILLMONEY: "Dapatkan koin setiap eliminasi",
  T_36_JH_WS_KILLMONEYTIP: "Jumlah koin yang diperoleh untuk menghilangkan zombie dalam mode Rush dan mode Endurance",
  T_36_JH_WS_LISTINDEX: "Dafar tipe merchandise",
  T_36_JH_WS_NULL: "Null",
  T_36_JH_WS_NUMBER: "Jumlah",
  T_36_JH_WS_OPTIONNAME: "Droid Apocalypse Mode Exclusive",
  T_36_JH_WS_REALSHOPENTITY: "Entitas store",
  T_36_JH_WS_SEEORHIDE: "Display vending machine",
  T_36_JH_WS_SHOPFRONT: "Store",
  T_36_JH_WS_SHOPITEMLIST: "Tipe Merchandise",
  T_36_JH_WS_SHOPOPENCON: "Buka status",
  T_36_JH_WS_SSHOPNAME: "Nama Store",
  T_36_JH_WS_TOTALLIMIT: "Limit Pembelian",
  T_36_JH_WS_TRIGGERWIDE: "Jarak Pemicu",
  T_36_JH_WS_VENDMACHINE: "Vending Machine",
  T_36_JH_WS_WINMONEY: "Dapatkan koin dari kemenangan",
  T_36_JH_WS_WORTH: "Bernilai",
  T_36_JL_FOREGRIP_MR_N: "Marksman Grip",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Shotgun Stock",
  T_36_JL_STOCK_SR_N: "Sniper Stock",
  T_36_KK_WS_MONTSTERDES: "Truk 4 tempat duduk dengan daya tahan tinggi dan dapat melewati medan yang berat",
  T_36_M_WS_SETTEMPVAR: "Set variabel sementara",
  T_36_M_WS_TEMPVAR: "Variabel sementara",
  T_36_SY_AK47_MAMBAS_N: "AK47- Mamba Gnaw",
  T_36_SY_AN94_MAMBAS_N: "AN94- Mamba Gnaw",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher- Mamba Gnaw",
  T_36_SY_AUG_MAMBAS_N: "AUG- Mamba Gnaw",
  T_36_SY_AWM_MAMBAS_N: "AWM- Mamba Gnaw",
  T_36_SY_BLT_MAMBAS_N: "M82B- Mamba Gnaw",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster- Mamba Gnaw",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle- Mamba Gnaw",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS- Mamba Gnaw",
  T_36_SY_G18_MAMBAS_N: "G18- Mamba Gnaw",
  T_36_SY_G36_MAMBAS_N: "G36- Mamba Gnaw",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Grenade- Navy Festivity",
  T_36_SY_GROZA_MAMBAS_N: "Groza- Mamba Gnaw",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon- Mamba Gnaw",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Heal Sniper- Mamba Gnaw",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun- Mamba Gnaw",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k- Mamba Gnaw",
  T_36_SY_KORD_MAMBAS_N: "Kord- Mamba Gnaw",
  T_36_SY_M1014_MAMBAS_N: "M1014- Mamba Gnaw",
  T_36_SY_M14_MAMBAS_N: "M14- Mamba Gnaw",
  T_36_SY_M1873_MAMBAS_N: "M1873- Mamba Gnaw",
  T_36_SY_M1887_MAMBAS_N: "M1887- Mamba Gnaw",
  T_36_SY_M1917_MAMBAS_N: "M1917- Mamba Gnaw",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker- Mamba Gnaw",
  T_36_SY_M24_MAMBAS_N: "M24- Mamba Gnaw",
  T_36_SY_M249_MAMBAS_N: "M249- Mamba Gnaw",
  T_36_SY_M4A1_MAMBAS_N: "M4A1- Mamba Gnaw",
  T_36_SY_M500_MAMBAS_N: "M500- Mamba Gnaw",
  T_36_SY_M60_MAMBAS_N: "M60- Mamba Gnaw",
  T_36_SY_M79_MAMBAS_N: "M79- Mamba Gnaw",
  T_36_SY_MAC10_MAMBAS_N: "MAC10- Mamba Gnaw",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7- Mamba Gnaw",
  T_36_SY_MINI_MAMBAS_N: "AC80- Mamba Gnaw",
  T_36_SY_MP40_MAMBAS_N: "MP40- Mamba Gnaw",
  T_36_SY_MP5_MAMBAS_N: "MP5- Mamba Gnaw",
  T_36_SY_P90_MAMBAS_N: "P90- Mamba Gnaw",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL- Mamba Gnaw",
  T_36_SY_PP19_MAMBAS_N: "Bizon- Mamba Gnaw",
  T_36_SY_PP19_POLICEMAN_N: "Bizon- Wraith Patrol",
  T_36_SY_SCAR_MAMBAS_N: "SCAR- Mamba Gnaw",
  T_36_SY_SKS_MAMBAS_N: "SKS- Mamba Gnaw",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12- Mamba Gnaw",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA- Mamba Gnaw",
  T_36_SY_SVD_MAMBAS_N: "SVD- Mamba Gnaw",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson- Mamba Gnaw",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Mamba Dagger",
  T_36_SY_THROWINGKNIFE_MENA_N: "Boho Dagger",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Heal Pistol- Mamba Gnaw",
  T_36_SY_UMP45_MAMBAS_N: "UMP- Mamba Gnaw",
  T_36_SY_USP45_MAMBAS_N: "USP- Mamba Gnaw",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi- Mamba Gnaw",
  T_36_SY_VECTOR_MAMBAS_N: "Vector- Mamba Gnaw",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Monster Truck- Blinding Gold",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Motorbike- Spectral Ride",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Sports Car- Speed Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk- Netherworld Ride",
  T_36_SY_VSS_MAMBAS_N: "VSS- Mamba Gnaw",
  T_36_SY_XM8_MAMBAS_N: "XM8- Mamba Gnaw",
  T_36_WZY_AFTERACCUMULATOR: "Akumulator belakang",
  T_36_WZY_AVAILAB: "Diaktifkan",
  T_36_WZY_BACKANDFORTH: "Perjalanan pulang pergi",
  T_36_WZY_BASEMULTIPLIER: "Basic multiplier",
  T_36_WZY_BASIC: "Tipe dasar",
  T_36_WZY_BEFORACCUMULATOR: "Akumulator depan",
  T_36_WZY_CYLIC: "Circle-back",
  T_36_WZY_GUNPRO_PARAM1: "Damage dasar",
  T_36_WZY_GUNPRO_PARAM10: "Penyebaran peluru dimulai",
  T_36_WZY_GUNPRO_PARAM11: "Max. spread area",
  T_36_WZY_GUNPRO_PARAM12: "Burst",
  T_36_WZY_GUNPRO_PARAM2: "Peluru di magazine",
  T_36_WZY_GUNPRO_PARAM3: "Nomor majalah awal",
  T_36_WZY_GUNPRO_PARAM4: "Firing interval",
  T_36_WZY_GUNPRO_PARAM7: "Jarak untuk maks. damage",
  T_36_WZY_GUNPRO_PARAM8: "Jarak untuk min. damage",
  T_36_WZY_GUNPRO_PARAM9: "Minimum damage",
  T_36_WZY_MULTIPLIR: "Multiplier",
  T_36_WZY_PRICE: "Harga",
  T_36_WZY_SUMMULTIPLIER: "Multiplier accumulator",
  T_36_WZY_WS_3DZOOM: "3D Zoom",
  T_36_WZY_WS_ABSRES: "Hasil nilai mutlak",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Tambahkan semua elemen dari [Daftar sumber] ke bagian bawah [Daftar target]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "Daftar target untuk menambahkan elemen",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "Daftar sumber yang berisi elemen yang akan ditambahkan",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Tambahkan sejumlah currency yang ditunjuk ke dalam wallet yang ditunjuk",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Wallet",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "Wallet untuk menambahkan currency ke",
  T_36_WZY_WS_ADDSUB: "Tambah atau kurangi nilai",
  T_36_WZY_WS_AIENTITY: "entitas AI",
  T_36_WZY_WS_ALLSHOP_DESC: "Daftar yang terdiri dari entitas toko",
  T_36_WZY_WS_ANGLE_DESC: "Pengukuran angle",
  T_36_WZY_WS_ANYTYPE: "Tipe manapun",
  T_36_WZY_WS_ARILEFT: "Nilai dari suatu operasi",
  T_36_WZY_WS_ARIRES: "Hasil Operasi",
  T_36_WZY_WS_ARIRIGHT: "Nilai yang tepat dalam operasi",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 operasi aritmatika",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "Operasi bilangan bulat dasar mendukung penambahan, pengurangan, perkalian, pembagian, dan sisa. Operasi float mendukung penambahan, pengurangan, perkalian, dan pembagian.",
  T_36_WZY_WS_ARRAY_DESC: "Daftar Target",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Periksa apakah daftar berisi elemen yang ditunjuk. Nilai yang dikembalikan adalah Boolean.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "Daftar yang ditunjuk",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "Elemen yang harus dicari dalam daftar",
  T_36_WZY_WS_ARRCONELERES: "Hasil apakah elemen yang ditunjuk ada dalam daftar. Nilainya adalah Boolean.",
  T_36_WZY_WS_ATTACK: "Patroli dan serang",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Pemicu saat pemain diknock down",
  T_36_WZY_WS_BIGFLOAT: "desimal besar",
  T_36_WZY_WS_BIGTOYBALL: "Dadu",
  T_36_WZY_WS_BOOLLIST: "Daftar Boolean",
  T_36_WZY_WS_CEIL_NAME_DESC: "Bulatkan nilai ke bilangan bulat terkecil yang lebih besar dari dirinya sendiri",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "Nilai untuk dibulatkan",
  T_36_WZY_WS_CEILRES: "Hasil pembulatan",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "AI yang dipilih akan mengejar entitas ini terlepas dari jarak. [Entitas yang dikejar] dapat berupa entitas apa pun. Ketika [Entitas yang dikejar] tidak memiliki properti HP, maka entitas AI tidak akan menimbulkan damage apa pun.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "Entitas yang melakukan pengejaran",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "Entitas target yang dikejar. Bisa berupa entitas apa pun.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "Template untuk mengkloning objek. Pilih menggunakan kursor. Properti dan skrip klon akan sama dengan objek yang dipilih.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "Entitas objek yang akan dikloning",
  T_36_WZY_WS_CONDITION: "Kondisi",
  T_36_WZY_WS_CONDITIONLIST: "Daftar Kondisi",
  T_36_WZY_WS_CONOFHUD: "Entitas HUD tempat kontrol berada",
  T_36_WZY_WS_CONTROL_DESC: "Satu-satunya indeks kontrol",
  T_36_WZY_WS_COS_NAMEDESC: "Tentukan kosinus suatu sudut",
  T_36_WZY_WS_COSRES: "Cosinus sudut",
  T_36_WZY_WS_CREABLEOB: "Objek yang dapat dibuat",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Buat entitas objek di lokasi yang ditentukan. (Versi uji)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "Koordinat objek yang akan dibuat",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "Jenis objek yang akan dibuat",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "Entitas objek yang akan dibuat",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Currency",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Merchandise entity",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Buat Merchandise entity",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Buat wallet entity. [Bind pemain] adalah pemain yang dapat melihat dompet ini. [Pemilik] adalah pemain yang memiliki dompet tersebut. Tidak valid jika dompet sudah ada.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Bound pemain",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "Pemain yang walletnya terlihat. Jika tidak ada pengaturan yang dikonfigurasi, dompet akan terlihat oleh semua orang.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "Pemilik wallet",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Entitas wallet",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "Entitas wallet dibuat",
  T_36_WZY_WS_CURRAMT: "Jumlah Currency",
  T_36_WZY_WS_DATA_TYPE1: "Menambahkan parameter",
  T_36_WZY_WS_DATA_TYPE2: "Perhitungan dasar dan logika",
  T_36_WZY_WS_DATA_TYPE3: "Manipulasi daftar",
  T_36_WZY_WS_DATA_TYPE4: "Perhitungan vektor",
  T_36_WZY_WS_DESTITEM_NAME: "Hancurkan item pemain",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Hancurkan jenis item yang ditentukan untuk pemain yang ditunjuk",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Item yang bisa dihancurkan adalah senjata, vest, dan helm",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "Indeks slot dari jenis item yang dipilih. Indeks senjata adalah [1,3] dan Vest dan Helm adalah 1 secara default.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Kehilangan peralatan saat eliminasi",
  T_36_WZY_WS_DESTOBJ: "Benda yang bisa dihancurkan",
  T_36_WZY_WS_DIRPOINT: "Titik arah",
  T_36_WZY_WS_DIRPOINTDESC: "Titik arah yang akan dibuat",
  T_36_WZY_WS_ELEFINDRES: "Indeks posisi pertama elemen",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'Dapatkan indeks posisi pertama elemen dalam daftar. Jika elemen target tidak ada dalam daftar, hasilnya akan mengembalikan "-1".',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "Elemen yang harus dicari dalam daftar",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Dapatkan indeks posisi terakhir elemen dalam daftar. Jika elemen target tidak ada dalam daftar, hasilnya akan mengembalikan "-1".',
  T_36_WZY_WS_ELELINDRES: "Indeks posisi terakhir elemen",
  T_36_WZY_WS_ELEMENTSNUM: "# elemen dalam daftar",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Dipicu ketika [Entitas pemicu] bertabrakan dengan pemicu ini",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "Entitas tempat pemicu ini bertabrakan",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Dipicu ketika [Entitas pemicu] mengemudikan kendaraan",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "Entitas yang mengemudikan kendaraan",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Pemicu saat pemain terpicu",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "Pemicu untuk masuk",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Dipicu ketika [Entitas pemicu] keluar dari kendaraan",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "Entitas yang keluar dari kendaraan",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Dipicu ketika [Entitas pemicu] memasuki kendaraan",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "Entitas yang memasuki kendaraan",
  T_36_WZY_WS_ENTITY_TYPE1: "Biasa digunakan",
  T_36_WZY_WS_ENTITY_TYPE2: "Properti",
  T_36_WZY_WS_ENTITY_TYPE3: "Objek dan Item",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "Nilai elemen yang akan diubah",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Target pemain",
  T_36_WZY_WS_ENTITYLIST: "Daftar entitas",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Dipicu ketika [Entitas pemicu] memantul dari ban",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "Entitas yang memantul dari ban",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Dipicu ketika [Entitas pemicu] memasuki portal dan diteleportasi",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "Entitas yang diteleportasi",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "Jenis armor yang dilengkapi, termasuk vest, helm, dan backpack",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Dipicu saat pemain berhasil melengkapi senjata. [Pemain pemicu] adalah pemain yang berhasil melengkapi senjata. [Jenis senjata] adalah senjata yang digunakan pemain.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "Entitas senjata dilengkapi",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Tipe Senjata",
  T_36_WZY_WS_EULERANGLE: "Sudut Euler",
  T_36_WZY_WS_FACECAMERA: "Selalu menghadap kamera",
  T_36_WZY_WS_FLOATLIST: "Daftar Float",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Bulatkan nilai ke bilangan bulat terbesar yang lebih kecil dari dirinya sendiri",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "Nilai yang akan dibulatkan ke bawah",
  T_36_WZY_WS_FLOORRES: "Hasil pembulatan ke bawah",
  T_36_WZY_WS_FORMUENT: "Entitas yang mampu merumuskan properti",
  T_36_WZY_WS_FORMUFACT: "Jenis faktor rumus properti",
  T_36_WZY_WS_GAME_TYPE2: "Gameplay",
  T_36_WZY_WS_GAME_TYPE3: "Efek Spesial",
  T_36_WZY_WS_GENENT_NAMEDESC: "Dipicu saat generator memunculkan unit. [Daftar entitas unit] adalah daftar unit yang dihasilkan oleh generator. [# gelombang] adalah jumlah gelombang yang dihasilkan oleh generasi.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Unit entity",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "Daftar yang terdiri dari entitas unit yang dihasilkan oleh generator",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "Jumlah gelombang yang dihasilkan generator",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Dapatkan semua toko di pertandingan. Nilai yang dikembalikan adalah daftar yang terdiri dari entitas toko.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Gunakan RGB untuk mendapatkan warna",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Dapatkan jumlah currency tertentu di dompet tertentu",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "Wallet untuk mendapatkan jumlah currency",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "Jenis currency dari jumlah currency yang akan diperoleh",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Dapatkan tipe entitas dari entitas target",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "Entitas yang tipenya diperoleh",
  T_36_WZY_WS_GETENTTYPERES: "Jenis entitas dari entitas target",
  T_36_WZY_WS_GETFOR_NAME: "Dapatkan koordinat arah",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Dapatkan vektor dari titik arah yang ditentukan",
  T_36_WZY_WS_GETFORRES: "Vektor titik arah",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Dapatkan entitas currency dari jenis currency tertentu di wallet",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "Wallet tempat entitas currency berada",
  T_36_WZY_WS_GETPOS_NAME: "Dapatkan Kordinat",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Dapatkan koordinat titik arah yang ditentukan",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "Titik arah yang ditentukan",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Tipe item",
  T_36_WZY_WS_GETWALLET_NAME: "Dapatkan wallet",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Dapatkan wallet dari pemilik yang dipilih",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Kalau bind wallet tersedia",
  T_36_WZY_WS_GETWALLETRES: "Entitas dompet pemilik",
  T_36_WZY_WS_HUDCONTROL_DESC: "Entitas kontrol dari HUD",
  T_36_WZY_WS_HUDTYPE: "Tipe HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "Insiden global",
  T_36_WZY_WS_INCIDENT_TYPE2: "insiden entitas",
  T_36_WZY_WS_INDEX_DESC: "Nilai indeks daftar. Mulai dari 0.",
  T_36_WZY_WS_INTLIST: "Daftar bilangan bulat",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Periksa apakah tipe entitas termasuk dalam subkategori tertentu. Hasil yang dikembalikan adalah Boolean.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "Kategori utama untuk memeriksa apakah entitas itu miliknya",
  T_36_WZY_WS_JENTSUBCLRES: "Hasil pemeriksaan kategori utama",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Periksa apakah suatu entitas termasuk dalam tipe entitas tertentu. Hasil yang dikembalikan adalah Boolean.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "Entitas yang akan diperiksa",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Berarti sama dengan tipe entitas",
  T_36_WZY_WS_JENTTYPERES: "Hasil pemeriksaan entitas",
  T_36_WZY_WS_JUSTPATROL: "Patroli saja",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Terpicu saat pemain keluar dari pemicu",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "Pemicu untuk keluar",
  T_36_WZY_WS_LEVELOBLIST: "Daftar objek",
  T_36_WZY_WS_LEVOBJSLIST: "Daftar semua objek peta dalam pertandingan ini",
  T_36_WZY_WS_LEVOBTYPE: "Tipe objek",
  T_36_WZY_WS_LISTT: "List apapun",
  T_36_WZY_WS_LOGCONTEXT_DESC: "Konten yang akan dicetak",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "String kiri untuk dihubungkan",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "String yang tepat untuk dihubungkan",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "Nilai elemen yang akan ditambahkan",
  T_36_WZY_WS_LOGOPER: "Saat melakukan operasi logika (dan & atau): jika menggunakan operasi and dan kedua nilai Boolean adalah TRUE, hasilnya adalah TRUE, dan jika menggunakan operasi or dan kedua nilai Boolean tidak keduanya FALSE, hasilnya adalah TRUE.",
  T_36_WZY_WS_LOOTPOINT: "Loot point",
  T_36_WZY_WS_MAINWEAP: "Senjata saat ini",
  T_36_WZY_WS_MAX_DESC: "Rentang atas bilangan bulat yang dihasilkan (interval terbuka)",
  T_36_WZY_WS_MIN_DESC: "Rentang yang lebih rendah dari bilangan bulat yang dihasilkan (interval tertutup)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Entitas senjata",
  T_36_WZY_WS_MONENT: "Entitas currency",
  T_36_WZY_WS_MONTYPE: "Tipe currency",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Buat AI bergerak menuju titik target. Gunakan [Kembali atau tidak] untuk memilih apakah AI akan kembali ke posisi semula. Gunakan [Serang atau tidak] untuk memilih apakah AI akan memindai musuh dalam perjalanannya.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "Entitas AI yang akan bepergian",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "Tempat tujuan",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Gunakan untuk mengatur apakah AI akan kembali ke lokasi semula setelah tiba di tempat tujuan. TRUE berarti kembali; FALSE artinya jangan kembali.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Serang atau tidak",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Gunakan untuk mengatur apakah AI akan menyerang musuh terdekat di sepanjang jalan. BENAR berarti memindai musuh; SALAH berarti jangan memindai musuh.",
  T_36_WZY_WS_MULVALUE: "Scalar",
  T_36_WZY_WS_MULVEC: "Vektor perkalian skalar",
  T_36_WZY_WS_NEGRES: "Hasil nilai negatif",
  T_36_WZY_WS_NEUTRAL: "Netral",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Memaksa generator yang ditunjuk untuk menelurkan gelombang berikutnya. Generator termasuk Zombie Spawns dan item spawn.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Entitas Generator",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "Entitas generator yang ditunjuk, seperti Zombie Spawns dan item spawns",
  T_36_WZY_WS_OBJENT: "Objek entitas",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Dipicu saat item diperoleh. [Jenis item] adalah jenis item yang diperoleh.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Dipicu saat senjata diperoleh. [Entitas senjata] adalah senjata yang diperoleh.",
  T_36_WZY_WS_ONEWAY: "Satu Arah",
  T_36_WZY_WS_OPENSTATE: "Status",
  T_36_WZY_WS_OPERMETHOD_NAME: "Operasi",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Operasi aritmatika dasar. Saat ini, operasi bilangan bulat meliputi penambahan, pengurangan, perkalian, pembagian, dan sisa, dan operasi float meliputi penambahan, pengurangan, perkalian, dan pembagian.",
  T_36_WZY_WS_OWNERENT_DESC: "Entitas yang walletnya akan didapatkan",
  T_36_WZY_WS_PERCENTAGE: "Penyesuaian persentase",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Saat pemain bertabrakan dengan pemicu",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Memicu saat [Pemicu Pemain] bertabrakan dengan pemicu",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "Pemain yang bertabrakan dengan pemicu",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "Entitas objek tempat pemain bertabrakan",
  T_36_WZY_WS_PLADRIVEH_NAME: "Saat pemain mengendarai kendaraan",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Dipicu ketika [Picu Pemain] mengendarai kendaraan",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "Pemain yang mengemudikan kendaraan",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "Entitas kendaraan yang dikendarai pemain",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Saat pemain keluar dari kendaraan",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Dipicu ketika [Pemicu Pemain] keluar dari kendaraan",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "Pemain yang keluar dari kendaraan",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "Entitas kendaraan tempat pemain keluar",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Saat pemain memasuki kendaraan",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Dipicu ketika [Picu Pemain] memasuki kendaraan",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "Entitas kendaraan yang dimasuki pemain",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Saat pemain memantul dari ban",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Dipicu ketika [Picu pemain] memantul dari ban",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "Pemain yang memantul dari ban",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "Entitas objek tempat pemain memantul",
  T_36_WZY_WS_PLATP_NAME: "Setelah pemain diteleportasi",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "Pemain yang menggunakan portal",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "Entitas portal yang digunakan pemain",
  T_36_WZY_WS_PLAYERLIST_DESC: "Daftar semua pemain dalam pertandingan ini",
  T_36_WZY_WS_POINTPICKER: "Path pivot",
  T_36_WZY_WS_PORTALENT: "Entitas portal",
  T_36_WZY_WS_PREFAB: "Template",
  T_36_WZY_WS_PRODLIST: "List Merchandise",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Sort Order",
  T_36_WZY_WS_PROPMOD: "Metode perubahan properti",
  T_36_WZY_WS_RANKABLEE: "Entitas Rank-able",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Mengkonsumsi sejumlah currency yang ditunjuk dalam wallet yang ditunjuk",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "Wallet yang menghabiskan currency",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "Jenis currency yang dikonsumsi",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "Jumlah currency yang dikonsumsi",
  T_36_WZY_WS_RNDFRES: "Float acak yang dihasilkan",
  T_36_WZY_WS_RNDIRES: "Hasil dari pembangkitan bilangan bulat acak",
  T_36_WZY_WS_ROUND_NAME_DESC: "Bulatkan nilai ke bilangan bulat terdekat",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "Nilai yang akan dibulatkan",
  T_36_WZY_WS_ROUNDRES: "Hasil pembulatan",
  T_36_WZY_WS_RUNAI_NAMEDESC: "Cabang perilaku yang akan dijalankan oleh AI yang dipilih",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "Entitas unit yang menghentikan/menjalankan cabang perilaku default",
  T_36_WZY_WS_SCOREABLEE: "Entitas Score-able",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Dipicu saat skor berubah. [Jenis skor] adalah jenis skor yang diubah. [Skor] adalah skor baru.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Buat titik arah",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Dapatkan titik arah yang baru dibuat. Gunakan [Lokasi] untuk mengatur koordinat titik dan [Arah] untuk mengatur vektor arah.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "Koordinat titik arah",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Arah",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "Vektor titik arah",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Entitas AI akan melakukan perjalanan sesuai dengan urutan yang ditetapkan di sini. Jenis perjalanan yang tersedia adalah round-back, one-way, dan round-trip. Kamu juga dapat memilih apakah AI akan memindai musuh dalam perjalanannya.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "Daftar yang terdiri dari titik-titik yang harus dilalui AI",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Jenis perjalanan",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Ini adalah jenis perjalanan. Satu arah adalah AI berhenti bepergian begitu tiba di tempat tujuan. Circle-back adalah untuk AI untuk mencari jalan kembali setelah tiba di tujuan. Pulang pergi adalah untuk AI kembali ke lokasi semula sesuai dengan urutan mundur dari daftar jalur.",
  T_36_WZY_WS_SHOPECON: "Store dan ekonomi",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Gunakan untuk menampilkan notifikasi yang mengambang di layar. Konfigurasikan konten menggunakan [Teks], warna teks menggunakan [Warna], dan durasi tampilan menggunakan [Durasi] (satuan adalah milidetik).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "Konten floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "Warna floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "Durasi tampilan floating notification, dalam milidetik",
  T_36_WZY_WS_SIN_NAMEDESC: "Cari sinus sudut",
  T_36_WZY_WS_SINRES: "sinus sudut",
  T_36_WZY_WS_SKIPKNODOWN: "Apakah tereliminasi saat knockdown",
  T_36_WZY_WS_SQRTRES: "Hasil akar kuadrat",
  T_36_WZY_WS_STRCONRES: "Hasil koneksi string",
  T_36_WZY_WS_STRINGLIST: "Daftar string",
  T_36_WZY_WS_STRLEN: "Panjang string",
  T_36_WZY_WS_STRVAL: "Hasil string",
  T_36_WZY_WS_TAN_NAMEDESC: "Tentukan tangen suatu sudut",
  T_36_WZY_WS_TANRES: "Tangen sudut",
  T_36_WZY_WS_TEAMLIST: "List tim",
  T_36_WZY_WS_TEAMLIST_DESC: "Daftar semua tim dalam pertandingan ini",
  T_36_WZY_WS_TIMETWEENTIPS: "Entitas pemberitahuan hitung mundur",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Ubah nilai target menjadi string",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "Nilai target untuk diubah menjadi string",
  T_36_WZY_WS_TOSTRINGRES: "Hasil konversi string",
  T_36_WZY_WS_TOWERCAMP_DESC: "Nomor sisi dan nomor tim sama. Menara dan tower netral menyerang semua pemain dan AI dalam jangkauan.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Transfer sejumlah currency tertentu dari satu wallet ke wallet lainnya",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "Dompet untuk mentransfer currency dari",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "Jenis currency dalam transaksi",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "Jumlah currency dalam transaksi",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "Dompet untuk mentransfer currency ke",
  T_36_WZY_WS_TWEENTIPS: "Entitas floating notifikasi",
  T_36_WZY_WS_TYPEENUM: "Jenis enum",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Dipicu saat pemain menggunakan item. [Pemicu pemain] adalah pemain yang menggunakan item. [Jenis item] adalah item yang digunakan pemain.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "Jenis item yang digunakan oleh pemain",
  T_36_WZY_WS_VECADDLEFT: "Nilai kiri dari penjumlahan vektor",
  T_36_WZY_WS_VECADDRES: "Hasil penjumlahan vektor",
  T_36_WZY_WS_VECADDRIGHT: "Nilai kanan vektor tambahan",
  T_36_WZY_WS_VECANGLEFT: "Nilai kiri dari sudut vektor",
  T_36_WZY_WS_VECANGRES: "Sudut antara 2 vektor",
  T_36_WZY_WS_VECANGRIGHT: "Nilai sudut vektor yang tepat",
  T_36_WZY_WS_VECCROLEFT: "Nilai kiri dari produk silang",
  T_36_WZY_WS_VECCRORES: "Hasil silang produk",
  T_36_WZY_WS_VECCRORIGHT: "Nilai kanan dari produk silang",
  T_36_WZY_WS_VECDISLEFT: "Nilai kiri dari jarak vektor",
  T_36_WZY_WS_VECDISRES: "Jarak antara 2 vektor",
  T_36_WZY_WS_VECDISRIGHT: "Nilai kanan jarak vektor",
  T_36_WZY_WS_VECDOCLEFT: "Nilai kiri dari produk titik",
  T_36_WZY_WS_VECDOCRES: "Hasil dari produk titik",
  T_36_WZY_WS_VECDOCRIGHT: "Nilai produk titik yang tepat",
  T_36_WZY_WS_VECMULRES: "Hasil perkalian skalar",
  T_36_WZY_WS_VECNORRES: "Vektor yang dinormalisasi",
  T_36_WZY_WS_VECSIZERES: "Besaran vektor",
  T_36_WZY_WS_VECSUBLEFT: "Nilai kiri dari pengurangan vektor",
  T_36_WZY_WS_VECSUBRES: "Hasil pengurangan vektor",
  T_36_WZY_WS_VECSUBRIGHT: "Nilai yang tepat dari pengurangan vektor",
  T_36_WZY_WS_VECTORLIST: "Daftar Vector",
  T_36_WZY_WS_VECX: "Kompone x",
  T_36_WZY_WS_VECY: "Kompone y",
  T_36_WZY_WS_VECZ: "Kompone z",
  T_36_WZY_WS_VEHENT: "Entitas kendaraan",
  T_36_WZY_WS_WALLCONT: "Konten Waller",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Berkelanjutan",
  T_36_XYL_WS_AIBOT: "Unit",
  T_36_XYL_WS_AIGENERATOR: "Generator Unit",
  T_36_XYL_WS_AIGENERATOR_DESC: "Sebuah generator yang dapat terus menghasilkan unit yang ditunjuk (misalnya zombie)",
  T_36_XYL_WS_AIWAVE: "# unit per gelombang",
  T_36_XYL_WS_ARROW: "Tanda arah",
  T_36_XYL_WS_ARROW_DESC: "Sebuah tanda yang menunjuk ke suatu arah",
  T_36_XYL_WS_BREAKBOX: "Breakable Box",
  T_36_XYL_WS_BREAKBOX_DESC: "Kotak kayu yang bisa pecah saat diserang",
  T_36_XYL_WS_FENCE: "Pagar besi",
  T_36_XYL_WS_FENCE_DESC: "Pagar yang memungkinkan peluru terbang menembus",
  T_36_XYL_WS_STAIRI: "Landing C",
  T_36_XYL_WS_STAIRI_DESC: "Sebuah platform yang dapat dikombinasikan dengan tangga",
  T_36_XYL_WS_ZOMBIEAI: "Zombie",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Zombie yang dapat dikustomisasi dan menjadi subjek yang diperoleh dan diduplikasi di Unit Generator",
  T_36_YF_CORRODE_GRENADE_N: "Gloo Melter",
  T_36_YF_SETTING_TYPE3: "Preset 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Bottom)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Bottom)",
  T_36_YS_F_A_GHOSTHUNTER: "Fiendish Foxtail (Mask)",
  T_36_YS_F_B_GHOSTHUNTER: "Fiendish Foxtail (Bottom)",
  T_36_YS_F_H_GHOSTHUNTER: "Fiendish Foxtail (Head)",
  T_36_YS_F_S_GHOSTHUNTER: "Fiendish Foxtail (Shoes)",
  T_36_YS_SETTING_GRENADE: "Throwables",
  T_36_YS_SETTING_MOVE: "Movement",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Top)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Top)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Fang",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Pet skin: Purple Zasil",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Pet skin: Lightning Falco",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Pet skin: Lava Fang",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Pet skin: Spectral Guide",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Pet skin: Arctic Fang",
  T_37_B_WS_HIDE: "Hide N Seek",
  T_37_HZ_WS_CATMODEDESC1: "Hide N Seek",
  T_37_JH_WS_CREATEGOLD_DESC: "Vending Machine dimana pemain bisa membeli item. (Tidak valid di mode Clash Squad, Team Deathmatch, Playground dan Droid Apocalypse)",
  T_37_JH_WS_NAME1: "FF Knife (Droid Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droid Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droid Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droid Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droid Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droid Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droid Apocalypse)",
  T_37_JH_WS_NAME19: "SVD (Droid Apocalypse)",
  T_37_JH_WS_NAME2: "GROZA (Droid Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droid Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droid Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droid Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droid Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droid Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droid Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droid Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "Gold dapat diambil dari seluruh map. (Tidak valid di mode Clash Squad, Team Deathmatch, Playground dan Droid Apocalypse)",
  T_37_JH_WS_X: "Sumbu X",
  T_37_JH_WS_Y: "Sumbu Y",
  T_37_JH_WS_Z: "Sumbu Z",
  T_37_JL_FOOTBALL_TIE: "Seri",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Waggor Snowman",
  T_37_LC_BP_ENTRANCE_GIFT: "Hadiah!",
  T_37_M_WS_MISSING: "Sumber daya tidak ditemukan",
  T_37_M_WS_NAMEERROR: "Mengandung karakter sensitif. Silakan ubah.",
  T_37_PD_HuntingGround_BOSSTITLE: "The Butcher",
  T_37_QL_JUMPPAD_DES: "Membuat jump pad di tanah. Ini dapat digunakan untuk melompat tinggi di udara dan memungkinkan tembakan di udara.",
  T_37_QL_JUMPPAD_NAME: "Trampoline",
  T_37_R_TAILOR_LIMIT: "Waktu Terbatas",
  T_37_RW_LOADOUT_BORNFIRETAG: "Dapatkan 2 Api Unggun di awal match. Api Unggun [FFBA00]memulihkan 5 HP dan 20 EP per detik[-] (hingga 10 detik)",
  T_37_RW_PROPCATAPULT_DESC: "Ketika mengembang, launch pad dapat digunakan untuk melempar pemain ke udara. Namun pastikan untuk tetap di Zona Aman!",
  T_37_RW_PROPCATAPULT_NAME: "Launch Pad",
  T_37_SP_WS_COLOR_02: "Warna",
  T_37_SP_WS_COLOR_03: "Penampilan",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "Entitas adalah null saat memperoleh atau mengatur propertinya",
  T_37_SP_WS_LOG_PHASE_END: "Stage {0} berakhir.",
  T_37_SP_WS_LOG_PHASE_START: "Stage {0} dimulai",
  T_37_SP_WS_LOG_ROUND_END: "Ronde {0} berakhir.",
  T_37_SP_WS_LOG_ROUND_START: "Ronde {0} dimulai.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Tipe tidak cocok saat menetapkan nilai ke variabel. Tipe saat ini: {0}. Tipe yang diperlukan: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Variabel lokal tidak terdefinisi atau di luar cakupan {0}",
  T_37_SP_WS_MAPACCESS_08: "Edit",
  T_37_SP_WS_RACEMODE_01: "Mode Hitung Mundur",
  T_37_SP_WS_RACEMODE_02: "Waktu Hitung Mundur",
  T_37_SP_WS_RACEMODE_04: "Saat aktif, akan ada hitungan mundur ketika seluruh tim mencapai titik akhir. Permainan berakhir ketika hitungan mundur berakhir.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher- Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "Straw Hat Backpack",
  T_37_SY_GRENADE_FFWS2022_01_N: "Grenade- Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Black Hole",
  T_37_SY_M1216_MAMBAS_N: "Trogon- Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Pet Skin: Glamstar Beanie",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Pet skin: Ash Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Pet skin: Galaxy Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Pet skin: Firemyth Arvon",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Pet Skin: Footie Flash",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Pet Skin: Winterlands Yeti",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep- Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Pickup Truck- Starsea Beast",
  T_37_WT_WS_PVE2DESC: `Hilangkan jumlah target zombie dalam batas waktu atau bertahan sampai akhir.
Kamu bisa mengatur peraturan bermain dan mengubah pengaturan zombie sesukamu, termasuk jumlah zombie yang perlu dieliminasi.`,
  T_37_WT_WS_RULEDESC: "Eliminasi jumlah zombie sesuai target untuk menang.",
  T_37_WT_WS_RULETITLE: "Goal",
  T_37_WT_WS_TXT1: "Eliminasi zombies",
  T_37_WT_WS_TXT1DESC: "Ketika dinyalakan, pemain menang dengan cara mengalahkan jumlah zombie yang ditentukan. Ketika dimatikan, pemain menang dengan bertahan hidup hingga akhir.",
  T_37_WT_WS_TXT2: "Jumlah eliminasi",
  T_37_WZY_FRIDPLA: "Pemain teman",
  T_37_WZY_FRIDSIDE: "Faksi teman",
  T_37_WZY_FRIDTEAM: "Tim teman",
  T_37_WZY_HOSTPLA: "Pemain lawan",
  T_37_WZY_HOSTSIDE: "Faksi lawan",
  T_37_WZY_WS_ACCFRAMES: "Frame yang didapatkan",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Tambahkan item ke merchandise. Kamu dapat menambahkan satu item atau sekelompok item. Jumlahnya dapat berupa jumlah item individual atau daftar yang terdiri dari item dari jumlah ini.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "Entitas merchandise untuk menambahkan item ke",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Item untuk ditambahkan. Kamu dapat menambahkan satu item atau sekelompok item.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "Jumlah item individu untuk ditambahkan atau daftar yang terdiri dari item dari jumlah ini.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Tambahkan tag untuk entitas yang dipilih",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "Entitas yang akan ditambahkan tag",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "Konten teks untuk ditambahkan",
  T_37_WZY_WS_AIMABLEENT: "Entitas yang dapat membidik",
  T_37_WZY_WS_AIMASSISTTYPE: "Tipe aim assist",
  T_37_WZY_WS_ALLOWDROP_NAME: "Aktifkan/nonaktifkan item drop",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Apakah seorang pemain dapat menjatuhkan item",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "Entitas pemain untuk mengonfigurasi apakah akan menjatuhkan item",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Apakah seorang pemain dapat menjatuhkan item. Ini adalah nilai Boolean.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Aktifkan/nonaktifkan pengambilan item",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Apakah seorang pemain dapat mengambil item",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "Entitas pemain untuk mengonfigurasi apakah akan mengambil item",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Apakah seorang pemain dapat mengambil item. Ini adalah nilai Boolean.",
  T_37_WZY_WS_AMBIENTCOLOR: "Warna cahaya suasana",
  T_37_WZY_WS_AMRORTOOL: "Perbaiki armor",
  T_37_WZY_WS_ATTACK: "Serang",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Batalkan penyamaran pemain agar mereka kembali ke penampilan normal",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "Entitas pemain yang penyamarannya dibatalkan",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Meningkatkan kecepatan sepakbola",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "Football untuk meningkatkan speed",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "Vektor kecepatan dari boost",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Trigger ketika bola dikenai oleh Football Shooter. [Player entity] adalah pemain yang memiliki Football Shooter. [Speed boost] menambahkan kecepatan bola setelah dikenai.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "Pemain yang memiliki Football Shooter",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "Kecepatan vektor bola setelah dikenai",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Dipicu saat bola bertabrakan dengan entitas dan kecepatan bola meningkat. [Colliding entity] adalah entitas yang bertabrakan dengan bola. [Speed boost] adalah kecepatan tambahan sepak bola setelah tabrakan.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "Entitas yang bertabrakan dengan sepak bola",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "Vektor kecepatan yang ditambahkan ke bola saat tumbukan",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Dipicu saat entitas sedang dibidik oleh pemain",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "Pemain yang membidik entitas",
  T_37_WZY_WS_BEHAVIORSTAT: "Status perilaku pemain",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "Entitas senjata yang mengenai entitas ini",
  T_37_WZY_WS_BLOODBARENT: "Entitas bar kesehatan",
  T_37_WZY_WS_BOMBEND: "Sebelum ledakan",
  T_37_WZY_WS_BOMBSTART: "Indikasi bom",
  T_37_WZY_WS_CHANENT: "Channel entity",
  T_37_WZY_WS_CHEER: "Cheer",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Periksa apakah entitas yang dipilih berisi tag yang ditunjuk",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "Entitas untuk memeriksa apakah itu berisi tag",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "Tag untuk diperiksa",
  T_37_WZY_WS_CHELABELRES: "Hasil pemeriksaan tag. Ini adalah nilai Boolean.",
  T_37_WZY_WS_CJERSEY_NAME: "Ubah jersey",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "Pemain yang jerseynya harus diganti",
  T_37_WZY_WS_CJERSEY_PARAM2: "Jersey design",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "Desain yang akan diubah",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "Warna dari bagian 1 di jersey",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "Warna part 2 di jersey",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "Warna part 3 di jersey",
  T_37_WZY_WS_CJERSEYTYPE1: "Design 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Design 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Design 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Hapus semua elemen di list",
  T_37_WZY_WS_CREABLEOB_DESC: "Tipe objek yang bisa dibuat menggunakan block",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Buat list merchandise yang dapat disesuaikan dan kembalikan entitas list merchandise. Konten dari list ini dapat diganti melalui setting properti.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Buat list merchandise yang dapat disesuaikan dan kembalikan entitas list merchandise. Konten dari list ini dapat diganti melalui setting properti.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "Entitas list merchandise untuk dibuat",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Buat entitas faksi",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "Entitas faksi yang akan dibuat",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Buat toko yang dapat disesuaikan dan kembalikan entitas toko. Konten dari toko dapat diubah di setting properti.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "Entitas toko yang telah dibuat",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Ubah lingkungan langit dalam game. Pilihannya meliputi siang, senja, dan malam.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "Jenis langit yang akan diubah. Pilihannya meliputi siang, senja, dan malam.",
  T_37_WZY_WS_DARKNESS: "Kegelapan",
  T_37_WZY_WS_DELENT_NAMEDESC: "Hapus entitas yang ditunjuk. Saat ini mendukung entitas ikon, entitas teks, entitas HUD, entitas efek visual, entitas senjata, dan entitas objek lainnya.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "Entitas yang akan dihapus",
  T_37_WZY_WS_DROP: "Kesalahan",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Trigger saat pemain menjatuhkan item. [Item type] adalah ID dari tipe item yang dijatuhkan.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "Jenis ID dari item yang dijatuhkan",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Trigger saat pemain menjatuhkan senjata. [Weapon entity] adalah senjata yang dijatuhkan.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "Senjata yang dijatuhkan",
  T_37_WZY_WS_DUMMYLEOBJ: "Objek panggung biasa",
  T_37_WZY_WS_DUST: "Senja",
  T_37_WZY_WS_EMPTYCH: "Saluran kosong default",
  T_37_WZY_WS_EMPTYCH1: "Empty channel 1",
  T_37_WZY_WS_EMPTYCH2: "Empty channel 2",
  T_37_WZY_WS_EMPTYCH3: "Empty channel 3",
  T_37_WZY_WS_EMPTYCH4: "Empty channel 4",
  T_37_WZY_WS_EMPTYCH5: "Empty channel 5",
  T_37_WZY_WS_EMPTYCH6: "Empty channel 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Dapatkan list yang berisi semua entitas yang memuaskan 3 kondisi. Konten yang dimasukkan untuk "Termasuk semua", "Selain", and "Termasuk" adalah satu tipe komponen atau list dari tipe komponen. Hasil yang dikembalikan adalah daftar entitas yang memuaskan kondisi.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "Entitas yang difilter harus berisi setidaknya satu komponen dari larik ini",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "Entitas yang difilter tidak boleh berisi komponen dari larik ini",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "Entitas yang difilter harus berisi setidaknya satu komponen dari larik ini",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "Tipe properti dari entitas untuk diubah",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "Nilai properti diubah yang akan diubah",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Biarkan pemain meninggalkan channel saat ini sehingga mereka tidak akan berada di channel mana pun",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "Pemain yang akan keluar channel",
  T_37_WZY_WS_FAKEENT: "Entitas penyamaran",
  T_37_WZY_WS_FIND_STR_DESC: "Cari lokasi teks tertentu di dalam sebuah string",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "Karakter yang dicari",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Carilah string dari lokasi mulai, yang dimulai dari 0.",
  T_37_WZY_WS_FINDSTRRES: "Lokasi pertama dimana string muncul, Dimulai dari 0.",
  T_37_WZY_WS_FOGCOLOR: "Warna embun",
  T_37_WZY_WS_FRICTIONCON: "Regular friction multiplier",
  T_37_WZY_WS_FRICTIONIMP: "Collision friction multiplier",
  T_37_WZY_WS_FROMDEATH: "Revival",
  T_37_WZY_WS_FROMKNODOWN: "Bantu",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Dapatkan saluran tempat pemain yang ditunjuk berada",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "Entitas pemain yang channel akan diperoleh",
  T_37_WZY_WS_GETCHANRES: "Channel tempat pemain berada saat ini",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "Menurut ID saluran 1 hingga 8, dapatkan saluran kosong yang dibuat secara default di awal permainan",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID dari default channel kosong",
  T_37_WZY_WS_GETEMPTYCH_RES: "Entitas saluran yang diperoleh",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Dapatkan entitas penyamaran dari satu pemain",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "Objek yang akan dijadikan entitas peyamaran",
  T_37_WZY_WS_GETGAMEENT_NAME: "Dapatkan global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Dapatkan entitas game dari pertandingan ini",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Dapatkan pemain yang bisa diserang",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Faksi entitas",
  T_37_WZY_WS_GOAL_NAMEDESC: "Trigger saat bola masuk ke gawang. [Goal] adalah tujuan yang dimasuki sepakbola ini. [Scorer] adalah pemain terakhir yang melakukan kontak dengan bola. [Assist] adalah pemain kedua terakhir yang melakukan kontak dengan bola.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "Gol dimana sepakbola masuk",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "Pemain terakhir yang melakukan kontak dengan bola",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "Pemain terakhir kedua yang melakukan kontak dengan bola",
  T_37_WZY_WS_HEARTBEAT: "Heartbeat",
  T_37_WZY_WS_HEAVYWEAPON: "Heavy weapon",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Sudut volley terkecil",
  T_37_WZY_WS_HOSTPLA: "Daftar pemain yang dapat diserang",
  T_37_WZY_WS_HOSTSIDE: "Daftar faksi yang dapat diserang",
  T_37_WZY_WS_HOSTTEAM: "Daftar tim yang bisa diserang",
  T_37_WZY_WS_ICON_CLOCK: "Hitung mundur",
  T_37_WZY_WS_ICON_CLOTHES: "Pakaian",
  T_37_WZY_WS_ICON_QUIT: "Exit",
  T_37_WZY_WS_INSERT_ARR_DESC: "Masukkan elemen baru ke lokasi yang ditentukan dalam daftar",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Ekstrak string dengan panjang yang ditentukan, mulai dari lokasi indeks. Jika panjang ekstraksi melebihi panjang string, itu akan mengekstrak konten hingga akhir string.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Panjang ekstraksi",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "String yang diekstraksi",
  T_37_WZY_WS_INTORINTL: "Daftar bilangan bulat atau bilangan bulat",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Biarkan pemain bergabung dengan faksi yang ditunjuk",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "Faksi bagi pemain untuk bergabung",
  T_37_WZY_WS_JUMP: "Lompat",
  T_37_WZY_WS_LABEL: "Tag",
  T_37_WZY_WS_LENSFLARE: "Lens flare",
  T_37_WZY_WS_LENTH: "Panjang",
  T_37_WZY_WS_LIGHTATTACK: "Pukulan sukses",
  T_37_WZY_WS_LIGHTCOLOR: "Warna sumber cahaya",
  T_37_WZY_WS_LIGHTINTENSITY: "Kecerahan sumber cahaya",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Load pemandangan baru",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "Nama pemandangan yang akan diload",
  T_37_WZY_WS_MOROBJECT: "Objek penyamaran",
  T_37_WZY_WS_MOVEAXISX: "Bergerak sepanjang sumbu x",
  T_37_WZY_WS_MOVEAXISY: "Bergerak sepanjang sumbu y",
  T_37_WZY_WS_MOVEAXISZ: "Bergerak sepanjang sumbu z",
  T_37_WZY_WS_MOVEDISTITLE: "Jarak pergerakan",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Pesan cepat on-off",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Mengaktifkan atau menonaktifkan pesan cepat. Saat dimatikan, pesan cepat HUD tidak dapat digunakan dan pemain tidak akan dapat mengirim atau menerima pesan cepat.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "Pemain untuk mengaktifkan/menonaktifkan pesan cepat untuk",
  T_37_WZY_WS_MUTEVOICE_NAME: "Voice chat on-off",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Mengaktifkan atau menonaktifkan obrolan suara. Saat dimatikan, HUD suara tidak dapat digunakan dan pemain tidak akan dapat mengirim atau menerima pesan suara.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "Pemain untuk mengaktifkan/menonaktifkan obrolan suara",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boolean. Benar berarti mati; Salah berarti aktif.",
  T_37_WZY_WS_NIGHTMODE: "Night mode",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Trigger ketika pemain aim kepada entitas yang bisa di-aim. [Target entity] adalah entitas yang sedang di-aim. Ketika tidak ada entitas yang di-aim, maka nilai akan menjadi null.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Aimed entity",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "Entitas yang dikenai oleh senjata",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Trigger saat pemandangan berhasil dimuat",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "Nama pemandangan yang akan dimuat. Ini adalah sebuah string.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Trigger saat pemandangan berhasil beralih",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "Nama pemandangan baru. Ini adalah sebuah string.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Mengembalikan pakaian pemain kembali menjadi default",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "Pemain yang pakaian akan dikembalikan ke default",
  T_37_WZY_WS_PETSET: "Pengaturan Pet",
  T_37_WZY_WS_PETSKILL: "Skill Pet",
  T_37_WZY_WS_PETSWITCH2: "Apakah skill pet dapat digunakan",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Apakah akan mengaktifkan pergerakan pemain. Ini adalah nilai Boolean.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Status tipe pemain",
  T_37_WZY_WS_PRESS: "Klik lembut",
  T_37_WZY_WS_PROGRESS: "Progress saat ini",
  T_37_WZY_WS_PROGRESSBAR: "Progress entitas HUD",
  T_37_WZY_WS_RANKDOWN: "Rank turun",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Hilangkan tag dari entitas yang dipilih",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "Konten teks untuk dihapus",
  T_37_WZY_WS_REPLACE_STR_DESC: "Ubah konten string dengan konten yang ditentukan",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "Karakter perlu diganti",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "Karakter baru untuk diganti dengan",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Membalikkan semua elemen di list ini",
  T_37_WZY_WS_REVIVEHERE: "Pemain yang menghidupkan kembali rekan tim di revival point ini",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Dipicu ketika seorang pemain menghidupkan kembali rekan satu tim pada revival point ini",
  T_37_WZY_WS_REVIVEWAYDESC: "Metode dimana pemain hidup kembali atau dibantu dari eliminasi atau jatuh",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Konfigurasi status dari perilaku berbeda untuk pemain. Ketika dimatikan, tombol yang ada di HUD tidak bisa digunakan, dan gerakan manual dan otomatis tidak bisa digunakan. Ketika disembunyikan, tombo tidak akan ditunjukkan di HUD dan gerakan manual tidak bisa digunakan, namun gerakan otomatis bisa. Ketika dinyalakan, tombol akan muncul di HUD dan gerakan manual dan otomatis dapat digunakan.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "Pemain yang akan di set status perilaku",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "Perilaku pemain termasuk bergerak, menyerang, melompat dan berlari",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Status termasuk non-aktif, sembunyi dan aktif. Ketika disembunyikan, tombol tidak akan muncul di HUD dan gerakan manual tidak diperbolehkan namun gerakan otomatis diperbolehkan. Ketika aktif, tombol akan muncul di HUD dan gerakan manual dan otomatis diperbolehkan.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "Koordinat sepakbola",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Apakah sepakbola akan tetap bergerak sesuai dengan kecepatan konfigurasi. Ini merupakan nilai Boolean.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Setting serangan pemain",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Konfigurasikan apakah [Setting player] dapat menyerang [Target player]. Pengaturan default didasarkan pada apakah pemain target termasuk dalam tim dan faksi yang dapat diserang. Pengaturan ini memiliki prioritas yang lebih tinggi daripada pengaturan tim/fraksi.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "Pemain untuk mengonfigurasi musuh untuk",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "Pemain yang menjadi musuh",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Dapat diserang atau tidak",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Ya" berarti dapat diserang; "Tidak" berarti tidak bisa diserang. Pengaturan default didasarkan pada apakah pemain target termasuk dalam tim dan faksi yang dapat diserang.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Ya" berarti dapat diserang; "Tidak" berarti tidak bisa diserang',
  T_37_WZY_WS_SHADOWSTRENGTH: "Bayangan",
  T_37_WZY_WS_SHOOTANGLE: "Sudut shooting terkecil",
  T_37_WZY_WS_SKYBOX: "Langit",
  T_37_WZY_WS_SKYBOXENT: "Entitas langit",
  T_37_WZY_WS_SKYBOXTYPE: "Tipe langit dasar",
  T_37_WZY_WS_STEPPED: "Menginjak pemicu",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Ganti channel voice chat pemain",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "Pemain untuk mengganti chanel",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "Channel yang akan diganti ke",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Beralih ke pemandangan yang ditentukan",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "Nama pemandangan untuk beralih ke",
  T_37_WZY_WS_TARGETSTR_DESC: "Target string",
  T_37_WZY_WS_TEAMASIDE: "Tim dan Faksi",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automatic",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Bisa teleport atau tidak",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manual",
  T_37_WZY_WS_TELEPORTN_NO: "Tidak",
  T_37_WZY_WS_TELEPORTN_TITLE: "Metode teleport",
  T_37_WZY_WS_TELEPORTN_YES: "Ya",
  T_37_WZY_WS_TERRAINWET: "Kelembaban medan",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Menukar penampilan [Player entity] dengan penampilan [Scenery object]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "Entitas pemain yang penampilannya akan diubah",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "Pemain yang akan dijadikan entitas penyamaran",
  T_37_WZY_WS_TRANSP: "Transparency",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Uninstall pemandangan yang ditentukan",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "Nama pemandangan yang akan diuninstall",
  T_37_WZY_WS_VFX1: "Simbolis",
  T_37_WZY_WS_VFX2: "Smokey",
  T_37_WZY_WS_VFX3: "Curse Explosion",
  T_37_WZY_WS_VFX5: "Frozen",
  T_37_WZY_WS_VFX6: "Spotlight",
  T_37_WZY_WS_VFX7: "Upward Turbulence",
  T_37_WZY_WS_VFX8: "Atmosphere Explosion",
  T_37_WZY_WS_VISABLE: "Visibility",
  T_37_WZY_WS_WEAOPEN: "Tampilkan atau tidak",
  T_37_WZY_WS_WEAPONENT: "Entitas senjata",
  T_37_WZY_WS_WEATARGETED: "Apakah dapat ditargetkan dengan bantuan bidik",
  T_37_XYL_CUSTOMJERSEY: "Jersey Machine",
  T_37_XYL_CUSTOMJERSEY_DESC: "Gunakan Mesin Jersey untuk membuat jersey idealmu",
  T_37_XYL_FOOTGUN: "Football Shooter",
  T_37_XYL_SOCCER: "Football",
  "T_37_XYL_SOCCER_ RADIUS": "Radius",
  T_37_XYL_SOCCER_DESC: "Sebuah sepak bola yang propertinya bisa dikustomisasi",
  T_37_XYL_SOCCER_HIGHT1: "Angle Regular",
  T_37_XYL_SOCCER_HIGHT2: "Angle Volley",
  T_37_XYL_SOCCER_RESET: "Atur ulang waktu setelah gol (dtk)",
  T_37_XYL_SOCCER_RESIST1: "Friction (Kick Mode)",
  T_37_XYL_SOCCER_RESIST2: "Friction (Gun Mode)",
  T_37_XYL_SOCCERGOAL: "Goal",
  T_37_XYL_SOCCERGOAL_DESC: "Ini adalah tujuannya. Menembak sepak bola ke gawang untuk mencetak gol. (Hanya berlaku di Points Grab.)",
  T_37_XYL_SOCCERITEM: "Item Muncul",
  T_37_XYL_SOCCERITEM_DESC: "Saat ditempatkan, akan menghasilkan item yang dipilih",
  T_37_XYL_SPAWN_PEOPLE: "# dari pemain",
  T_37_XYL_WS_AIRCONDITIONER001: "AC B",
  T_37_XYL_WS_AMMUCHEST: "War Chest A",
  T_37_XYL_WS_BAFFLE001: "Barrier A",
  T_37_XYL_WS_BARREL001: "Barrels",
  T_37_XYL_WS_BARREL001_DES: "Tong kayu bundar yang biasa terlihat",
  T_37_XYL_WS_BOARD001: "Ad Board B",
  T_37_XYL_WS_BOOK001: "Tumpukan Buku A",
  T_37_XYL_WS_BOOK002: "Board Game A",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillea",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Dekorasi - mencerahkan tempat!",
  T_37_XYL_WS_BOX001: "Pile of Boxes A",
  T_37_XYL_WS_BOX002: "Small Box",
  T_37_XYL_WS_BUSHCOVER: "Semak",
  T_37_XYL_WS_BUSHCOVER_DES: "Semak yang bisa digunakan untuk bersembunyi",
  T_37_XYL_WS_CABINET001: "Drawers A",
  T_37_XYL_WS_CHAIR001: "Kursi A",
  T_37_XYL_WS_COCONUTTREE: "Pohon kelapa",
  T_37_XYL_WS_COCONUTTREE_DES: "Dekorasi - Untuk suasana pantai!",
  T_37_XYL_WS_COMPUTER001: "Komputer A",
  T_37_XYL_WS_DAMAGERATIO: "Damage Ratio",
  T_37_XYL_WS_FIREEX: "Pemadam Api",
  T_37_XYL_WS_GUIDEPOSE: "Pos Arahan",
  T_37_XYL_WS_HUGEHOUSE001: "Rumah 3 Lantai B",
  T_37_XYL_WS_HUGEHOUSE002: "Rumah 2 Lantai B",
  T_37_XYL_WS_JACKSTRAW: "orang-orangan sawah",
  T_37_XYL_WS_LADDER001: "Tangga A",
  T_37_XYL_WS_OILDRUM: "Jerry Can",
  T_37_XYL_WS_ORNAMENT001: "Vase A",
  T_37_XYL_WS_PACKBOX: "Supply Container",
  T_37_XYL_WS_PILLA001: "Concrete Pillar",
  T_37_XYL_WS_PRESENT: "Gift Box",
  T_37_XYL_WS_PRESENT_DES: "Berisi hadiah liburan",
  T_37_XYL_WS_PUMPKIN: "Square Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT: "Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT_DES: "Biasanya dekorasi untuk festival horor",
  T_37_XYL_WS_ROADBLOCK001: "Roadblock B",
  T_37_XYL_WS_SHELF001: "Bookshelf A",
  T_37_XYL_WS_SOFA001: "Sofa A",
  T_37_XYL_WS_SPAWNTEAM: "Semua tim",
  T_37_XYL_WS_SUPPLYBOX: "Ammo Crate",
  T_37_XYL_WS_TABLE001: "Meja A",
  T_37_XYL_WS_TABLE002: "Meja B",
  T_37_XYL_WS_TARGET001: "Target",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Portal Finish Point",
  T_37_XYL_WS_TELEPORTNEW: "Portal A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "Portal yang dapat memindahkan pemain ke titik akhir portal",
  T_37_XYL_WS_TIRES001: "Ban A",
  T_37_XYL_WS_TOOLRACK: "Rak Alat",
  T_37_XYL_WS_WALL001: "Tembok",
  T_37_XYL_WS_WOOD001: "Potongan Kayu",
  T_37_XYL_WS_YELLOWDUCK001: "Pelampung Bebek",
  T_37_XYL_WS_YELLOWDUCK001_DES: "Pelampung yang mengembang dalam bentuk bebek",
  T_37_YM_BOMBSQUAD_DEFUSER: "Defuser",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF White Jersey (Bottom)",
  T_37_YS_F_B_VN_STREET: "Crimson Auspicion (Bottom)",
  T_37_YS_F_H_VN_STREET: "Crimson Auspicion (Head)",
  T_37_YS_F_S_VN_STREET: "Crimson Auspicion (Shoes)",
  T_37_YS_F_T_VN_STREET: "Crimson Auspicion (Top)",
  T_37_YS_M_A_CRICKET_BLACK: "Bumblebee Cricketer (Mask)",
  T_37_YS_M_A_THKOL: "Blaze Banish (Mask)",
  T_37_YS_M_B_CRICKET_BLACK: "Bumblebee Cricketer (Bottom)",
  T_37_YS_M_B_SILVERERA: "Fearless Greyguard (Bottom)",
  T_37_YS_M_B_THKOL: "Blaze Banish (Bottom)",
  T_37_YS_M_H_SILVERERA: "Fearless Greyguard (Head)",
  T_37_YS_M_H_THKOL: "Blaze Banish (Head)",
  T_37_YS_M_S_CRICKET_BLACK: "Bumblebee Cricketer (Shoes)",
  T_37_YS_M_S_SILVERERA: "Fearless Greyguard (Shoes)",
  T_37_YS_M_S_THKOL: "Blaze Banish (Shoes)",
  T_37_YS_M_T_CRICKET_BLACK: "Bumblebee Cricketer (Top)",
  T_37_YS_M_T_SILVERERA: "Fearless Greyguard (Top)",
  T_37_YS_M_T_THKOL: "Blaze Banish (Top)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF White Jersey (Top)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Minimum pemain",
  T_38_BQ_SKILL_NAME_DUMMY1: "Stunt Double",
  T_38_BQ_SKILL_NAME_DUMMY2: "Shape Splitter",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Heartseeker (Bottom)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Heartseeker (Head)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Heartseeker (Shoes)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Heartseeker (Top)",
  T_38_JH_WS_CM1: "Hapus peraturan",
  T_38_JH_WS_CM2: "Peraturan tidak jelas",
  T_38_JH_WS_CM3: "Sering keluar match",
  T_38_JL_M79_AMMO_N: "M79 Ammo",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs's Microchip",
  T_38_M_WS_VECTOR2: "Vektor 2D",
  T_38_R_TACTICS_N: "Preset",
  T_38_RW_NIW_NIWNAME: "Gloo Maker",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Terlalu banyak lapisan blok. Kini: {0}. Max: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Jumlah item yang telah kamu buat ({0}) telah melebihi batas ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Jumlah insiden dalam satu frame ({0}) melebihi batas ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Batas pembuatan entitas dinamis per frame telah tercapai ({0}); {1} percobaan pembuatan ditolak.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Panjang dari daftar ({0}) melebihi batas ({1}). Membuat daftar maks kapasitas secara otomatis.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Jumlah loop ({0}) melebih batas ({1}). Loop terganggu.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "Jumlah concurrent coroutines ({0}) di coroutine scope telah melebih batas ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Gagal menambahkan elemen ke daftar. Daftar {0} kosong.",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Tipe value",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Definisi variable sementara berulang. Nama variabel: {0}",
  T_38_SP_WS_REVIEW_01: "Toxic",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Menghina",
  T_38_SP_WS_REVIEW_04: "Sangat Toxic",
  T_38_SP_WS_REVIEW_05: "Mengancam",
  T_38_SP_WS_REVIEW_06: "Tidak Sopan",
  T_38_SP_WS_REVIEW_07: "Dalam Review",
  T_38_SP_WS_REVIEW_08: "{0} nama {1} tidak mengikuti aturan. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Toko",
  T_38_SP_WS_REVIEW_11: "Variabel",
  T_38_SP_WS_REVIEW_12: "Fungsi",
  T_38_SP_WS_REVIEW_13: "Objek",
  T_38_SP_WS_REVIEW_14: "Pergi ke definisi.",
  T_38_SP_WS_REVIEW_15: "Pergi ke Kelola Objek.",
  T_38_SP_WS_REVIEW_16: "Tidak ada redireksi.",
  T_38_SP_WS_REVIEW_17: "Nama Map",
  T_38_SP_WS_REVIEW_18: "Deskripsi",
  T_38_SP_WS_REVIEW_19: "Cover Image",
  T_38_SP_WS_REVIEW_20: "Teks berisikan kata sensitif.",
  T_38_SP_WS_REVIEW_21: "Gagal save. Tidak bisa di-review.",
  T_38_SP_WS_REVIEW_22: "Review dalam cooldown.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Mayhem Bat",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Pet Skin: Ghost Kactus",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Pet Skin: Neon Kactus",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Pet Skin: Palm Dream Kactus",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Pet Skin: Party Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Pet Skin: Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR- Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "Pop-Pow Sickle",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "Multi-Level",
  T_38_WT_WS_SKILLSET15: "Thrill of Battle (A124)",
  T_38_WT_WS_SKILLSET16: "Senses Shockwave (Homer)",
  T_38_WT_WS_SKILLSET17: "Wall Brawl (Iris)",
  T_38_WT_WS_SKILLSET18: "Rebel Rush (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Bisa digunakan di pemandangan atau tidak",
  T_38_WZY_WS_ACTIVEB: "Nyalakan logika refresh atau tidak",
  T_38_WZY_WS_ACTIVEVALUE: "Status Aktivitas",
  T_38_WZY_WS_AIR: "Udara",
  T_38_WZY_WS_ALLOWMOVE: "Dapat digerakkan atau tidak",
  T_38_WZY_WS_AMMOAMOUNT: "Jumlah ammo",
  T_38_WZY_WS_AMMONAME: "Entitas Ammo",
  T_38_WZY_WS_ARMOR_DAMRED: "Multiplier reduksi DMG",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Multiplier reduksi DMG ledakan",
  T_38_WZY_WS_ARMOR_DURABILITY: "Durabilitas sekarang",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Durabilitas maksimum",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Bisa di-damage atau tidak",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Bisa dihancurkan atau tidak",
  T_38_WZY_WS_ARMOR_LEVEL: "Level",
  T_38_WZY_WS_ASSCONZOM: "Assist eliminasi zombie.",
  T_38_WZY_WS_BAGNAME: "Entitas Backpack",
  T_38_WZY_WS_BAGSPACEEX: "Ruang backpack tambahan",
  T_38_WZY_WS_BRIDGING: "Komponen bridge render",
  T_38_WZY_WS_BUBBLE: "Bubble",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Kosongi semua item di backpack [player entity's]",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Hapus item yang tidak diinginkan di sekitar map, seperti loot, loot boxes dan sisa throwable",
  T_38_WZY_WS_CLEARPRO: "Hapus faktor properti satuan",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Klon entitas [scenery object] di lokasi [player entity] dan dapatkan [disguise entity]",
  T_38_WZY_WS_COMPONENT: "Komponen",
  T_38_WZY_WS_COSTAMMO: "Menggunakan ammo",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Buat kamera dan dapatkan [camera entity], dimana propertinya dapat diubah melalui pengaturan properti.",
  T_38_WZY_WS_CYCLES: "Jumlah dimainkan",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Cek apakah [entity] berada di dalam circular pole. [Center] adalah pusat dari pole, [radius] adalah radius permukaan bulat, [tinggi] adalah tinggi dari pole dan [Euler angles] adalah sudut dari orientasi 3D pole.",
  T_38_WZY_WS_CYLINDERJUD_RES: "Hasil dari circular pole scope check, Ini adalah Boolean value.",
  T_38_WZY_WS_DAMSUMZOM: "DMG ke zombie",
  T_38_WZY_WS_DARKNESS: "Kegelapan",
  T_38_WZY_WS_DIFCOLOR: "Warna permukaan",
  T_38_WZY_WS_DIFTEXTURE: "Tekstur permukaan'",
  T_38_WZY_WS_DRUMMUSIC: "Tipe komponen: Drum",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "Pemain yang disconnect",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "Pemain sedang menyambung kembali",
  T_38_WZY_WS_EUIANCHOR: "Enumerasi tipe anchor HUD",
  T_38_WZY_WS_FEATHER: "Feather",
  T_38_WZY_WS_FLAMEAMMO: "Flamethrower Ammo",
  T_38_WZY_WS_FLOWER: "Bunga",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Atur agar [entity] selalu mengikuti [followed entity]. [Offset coordinates] adalah jarak diantar dua entitas.",
  T_38_WZY_WS_FOLLOWENT: "Entitas yang diikuti",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Dapatkan entitas kamera yang digunakan oleh [player entity]",
  T_38_WZY_WS_GETCURCAMDESC: "Kamera yang sedang digunakan pemain",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Dapatkan jumlah item dari [designated item type] yang dimiliki [player]",
  T_38_WZY_WS_GETITEMNUM_RES: "Jumlah dari item bersangkutan yang dimiliki pemain",
  T_38_WZY_WS_GETVEC_NAME: "Dapatkan vektor.",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Dapatkan vektor menggunakan komponen x, y dan z dari set koordinat",
  T_38_WZY_WS_GETVECRES: "Vektor yang didapatkan dari komponen x, y dan z",
  T_38_WZY_WS_GHOST: "Ghost",
  T_38_WZY_WS_GRENADEFROZENNAME: "Entitas Flash Freeze",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Radius zona freeze",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Durasi freeze.",
  T_38_WZY_WS_GRENADENAME: "Entitas Grenade",
  T_38_WZY_WS_GRENADEPARAM1: "Min. DMG",
  T_38_WZY_WS_GRENADEPARAM2: "Maks DMG",
  T_38_WZY_WS_GRENADEPARAM4: "Jarak ledakan",
  T_38_WZY_WS_GRENADEPARAM5: "Kecepatan melempar",
  T_38_WZY_WS_GRENADEPARAM6: "Penundaan ledakan",
  T_38_WZY_WS_GRENADEPARAM7: "Multiplier DMG sendiri",
  T_38_WZY_WS_GRENADEPARAM8: "Multiplier DMG teman",
  T_38_WZY_WS_GRENADEPARAM9: "Multiplier DMG kendaraan",
  T_38_WZY_WS_GUNFIRE: "Gunfire",
  T_38_WZY_WS_GUNPRO_PARAM2: "Reload Speed",
  T_38_WZY_WS_GUNPRO_PARAM3: "Body shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM4: "Headshots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM5: "Rasio DMG tembakan lengan",
  T_38_WZY_WS_GUNPRO_PARAM7: "DMG Ekstra",
  T_38_WZY_WS_HELMET_NAME: "Entitas Helmet",
  T_38_WZY_WS_ICON1: "Crown",
  T_38_WZY_WS_ICON2: "Duel",
  T_38_WZY_WS_INITPOS: "Lokasi Awal",
  T_38_WZY_WS_ISRESET: "Reciprocating Motion",
  T_38_WZY_WS_KILLCONZOM: "Jumlah zombie di-eliminasi",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Eliminasi [entity] yang dipilih, harus merupakan tipe entitas battle. Mengabaikan status kebal.",
  T_38_WZY_WS_LABELPARAM: "Daftar teks konten parameter",
  T_38_WZY_WS_LEADMUSICA: "Tipe komponen: Piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Tipe komponen: Piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Tipe komponen: piano (bass)",
  T_38_WZY_WS_LINE: "Line",
  T_38_WZY_WS_LIQUID: "Liquid",
  T_38_WZY_WS_LOCALKEY: "Key Lokal",
  T_38_WZY_WS_LOCALPOS: "Lokasi relatif",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Atur [entity] untuk selalu menghadapi [aimed entity]. [Offset coordinates] adalah perbedaan dari koordinat yang di-aim dan posisi entitas.",
  T_38_WZY_WS_MAINWEAPONA: "Senjata Utama 1",
  T_38_WZY_WS_MAINWEAPONB: "Senjata Utama 2",
  T_38_WZY_WS_MOTIONTIME: "Durasi gerakan",
  T_38_WZY_WS_MOTIONTYPE: "Metode gerakan",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "EP Dimodifikasi",
  T_38_WZY_WS_MUSHROOMNAME: "Entitas Jamur",
  T_38_WZY_WS_OBFACTION: "Tonton fraksi",
  T_38_WZY_WS_OBGLOBAL: "Tonton semua",
  T_38_WZY_WS_OBSERVER: "Opsi Spektator",
  T_38_WZY_WS_OBTEAM: "Tonton Tim",
  T_38_WZY_WS_OFFSETVEC: "Koordinate offset",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Trigger ketika pemain membeli item dari Vending Machine. [Player entity] adalah pemain yang membeli item. [Merchandise entity] adalah item yang dibeli.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Trigger ketika di-equip oleh [player entity]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Trigger ketika pemain melakukan aksi melompat.",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Trigger ketika pemain menyelesaikan posisi prone",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Trigger ketika reload senjata",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Trigger ketika pemain melakukan aksi berlari",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Trigger ketika pemain menyelesaikan aksi jongkok",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Trigger ketika senjata mengeliminasi unit. [Eliminated entity] adalah unit yang dieliminasi.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Trigger ketika senjata memberikan damage ke entitas battle. [Hit target] adalah entitas battle yang diberikan damage. [Damage] adalah damage yang diberikan.",
  T_38_WZY_WS_OWNER: "Pemilik",
  T_38_WZY_WS_PARAMLIST: "Daftar parameter",
  T_38_WZY_WS_PARTICALMAP: "Particle Mapping",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pause atau lanjutkan emote untuk [player entity]. [Pause or not] adalah nilai Boolean. "Ya" berarti pause. "Tidak" berarti lanjutkan.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Diaktivasi dengan pemain memasuki trigger",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Diaktivasi dengan pemain meninggalkan trigger",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Memaksa agar [player entity] memainkan [emote] sekali dan kembali ke posisi original setelah selesai",
  T_38_WZY_WS_PLAYSPEED: "Persentase kecepatan playback",
  T_38_WZY_WS_PREHUD_NAME: "Ikon preset",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Biarkan [player entity] meninggalkan fraksi sekarang",
  T_38_WZY_WS_RESETENT: "Reset komponen setiap ronde",
  T_38_WZY_WS_RESUUID: "UUID Sumber Daya",
  T_38_WZY_WS_RIMCOLOR: "Warna batas",
  T_38_WZY_WS_RIMTEXTURE: "Tekstur batas",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Cek apakah [entity] berada di dalam cone. [Center] dan [radius] adalah pusat dan radius dari cone tersebut. [Extracted radius] adalah radius di bagian terkecil dari cone. Tinggi merupakan tinggi dari struktur 3D tersebut. [Angle] adalah sudut pusat dari cone. [Direction angle] adalah arah vektor dari axis tengah.",
  T_38_WZY_WS_SECTORJUD_RES: "Hasil dari scope check berbentuk fan. Ini merupakan nilai Boolean.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Atur status aktivitas dari [target entity]. [Activity status] adalah nilai Boolean dan efek ke availability, visibility dan collidability dari entitas.",
  T_38_WZY_WS_SETROUNDSCORE: "Atur skor ronde pemain",
  T_38_WZY_WS_SHOOTANGMAX: "Sudut menembak maks.",
  T_38_WZY_WS_SHOWMAPINFO: "Tunjukkan info map untuk fraksi yang sama",
  T_38_WZY_WS_SHOWNAMEHUD: "Tunjukan HUD nama untuk fraksi sama",
  T_38_WZY_WS_SOUND1: "Acceleration",
  T_38_WZY_WS_SOUND10: "Stage Dimulai",
  T_38_WZY_WS_SOUND11: "Zombie",
  T_38_WZY_WS_SOUND12: "Horror",
  T_38_WZY_WS_SOUND13: "Transformasi",
  T_38_WZY_WS_SOUND14: "Hati Berdebar-debar",
  T_38_WZY_WS_SOUND15: "Detak Jantung Medium",
  T_38_WZY_WS_SOUND16: "Detak Jantung Pelan",
  T_38_WZY_WS_SOUND17: "Rush Time",
  T_38_WZY_WS_SOUND18: "Click",
  T_38_WZY_WS_SOUND19: "Pemulihan Skill",
  T_38_WZY_WS_SOUND2: "Hilangkan Notifikasi",
  T_38_WZY_WS_SOUND20: "Ikut Game",
  T_38_WZY_WS_SOUND3: "Efek Visual",
  T_38_WZY_WS_SOUND4: "Kicauan Malam",
  T_38_WZY_WS_SOUND5: "Hit (Blunt)",
  T_38_WZY_WS_SOUND6: "Reaksi",
  T_38_WZY_WS_SOUND7: "Surprise Find",
  T_38_WZY_WS_SOUND8: "Apparition",
  T_38_WZY_WS_SOUNDENT: "Entitas musik",
  T_38_WZY_WS_SPAWNPOS: "Spawn Point Lama",
  T_38_WZY_WS_SPHERENAME: "Bola dasar",
  T_38_WZY_WS_SPHERERADIUS: "Radius bola",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Cek apakah [entity] berada di dalam jarak spherical. [Center] dan [radius] adalah pusat dan radius dari struktur bola.",
  T_38_WZY_WS_SPHERICALJUD_RES: "Hasil dari spherical scope check. Ini merupakan nilai Boolean.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Cek apakah [entity] di dalam cakupan sebuah kubus. Jika [center] adalah tengah dari kubus, maka [panjang], [lebar] dan [tinggi] adalah panjang, lebar dan tinggi dari kubus dan [Euler angles] adalah sudut dari orientasi 3D kubus tersebut.",
  T_38_WZY_WS_SQUAREJUD_RES: "Hasil dari cubic scope check. Ini merupakan nilai Boolean.",
  T_38_WZY_WS_STARTGENTIME: "Waktu mulai spawn",
  T_38_WZY_WS_STAYTIME: "Durasi pause",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Ubah kamera pemain menjadi [camera entity]. [Switch mode] bisa diantara tanpa animasi atau gerakan progresif. [Switch time] adalah waktu perubahan dalam mode progresif.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Ubah mode kamera. Kamu bisa memilih di antara Tanpa Animasi dan Gerakan Progresif.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'Waktu pergantian saat mode pergerakan progresif. Ketika dipilih pengaturan "tanpa animasi", tidak berlaku.',
  T_38_WZY_WS_TEXTHUD: "Komponen text HUD",
  T_38_WZY_WS_TEXTTYPE: "Size Font",
  T_38_WZY_WS_TEXTUREID: "Tipe tekstur",
  T_38_WZY_WS_TRANDIST: "Jarak maks",
  T_38_WZY_WS_TWEENERENABLED: "Nyalakan skrip UITweener atau tidak",
  T_38_WZY_WS_TYPELIST: "Daftar tipe",
  T_38_WZY_WS_TYPELISTORLIST: "Tipe atau daftar tipe",
  T_38_WZY_WS_VEST_NAME: "Entitas Vest",
  T_38_WZY_WS_VFX1: "Hider Elimination",
  T_38_WZY_WS_VFX10: "Cyclic Combustion",
  T_38_WZY_WS_VFX11: "Poison Gas",
  T_38_WZY_WS_VFX13: "Heart",
  T_38_WZY_WS_VFX15: "Pintu",
  T_38_WZY_WS_VFX2: "Rampage",
  T_38_WZY_WS_VFX3: "Eliminasi klon",
  T_38_WZY_WS_VFX4: "Hit Feedback",
  T_38_WZY_WS_VFX5: "Klon",
  T_38_WZY_WS_VFX6: "Menyamar",
  T_38_WZY_WS_VFX7: "Flashbang Sparks",
  T_38_WZY_WS_VFX8: "Motion Trail",
  T_38_WZY_WS_VFX9: "Fire Charge",
  T_38_WZY_WS_VFXENT: "Instansi VFX",
  T_38_WZY_WS_VFXTYPEA_NAME: "Customizable mapping VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "Non-customizable mapping VFX",
  T_38_WZY_WS_VISIBILITY: "Tipe visibilitas",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Generator Senjata",
  T_38_WZY_WS_WHECYCLE: "Replay",
  T_38_XXJ_WS_BLOCKMODE: "Blocked Mode",
  T_38_XXJ_WS_CUSTOMCAMARA: "Kamera Cusotm",
  T_38_XXJ_WS_FFCLASSIC: "Classic FF (Shooting)",
  T_38_XXJ_WS_FOV: "Field of View",
  T_38_XXJ_WS_FOVDESC: "Field of view adalah jarak yang bisa dilihat oleh kamera.",
  T_38_XXJ_WS_FPS: "First Person (Shooting)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Sudut Horizontal",
  T_38_XXJ_WS_INVISICAM: "Semi-Transparent",
  T_38_XXJ_WS_OFFSET: "Offset",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Orthographic",
  T_38_XXJ_WS_PERSPECTIVE: "Perspektif",
  T_38_XXJ_WS_PROJECTIONMODE: "Mode Proyeksi",
  T_38_XXJ_WS_STABLE: "Fixed",
  T_38_XXJ_WS_STARTCAMERA: "Kamera Default",
  T_38_XXJ_WS_STARTCAMERAMODE: "Mode Kamera Default",
  T_38_XXJ_WS_THIRD: "Kejar Kamera",
  T_38_XXJ_WS_TOPVIEW: "Sudut Tinggi",
  T_38_XXJ_WS_TPS: "Third Person",
  T_38_XXJ_WS_TRANSVERSE: "Pergerakan Horizontal",
  T_38_XXJ_WS_VERTICALANGLE: "Sudut Vertikal",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Waktu mulai (dtk)",
  T_38_XYL_WS_ARMORDESTROY: "Armor DMG multiplier",
  T_38_XYL_WS_BONFIRE: "Api Unggun",
  T_38_XYL_WS_CANDLE01: "Lilin A",
  T_38_XYL_WS_CANNON01: "Mechanical Cannon",
  T_38_XYL_WS_CLIPAMMOSIZE: "Magazine Storage",
  T_38_XYL_WS_DAMAGEDTRUCK: "Damaged Truck",
  T_38_XYL_WS_DOLL01: "Eerie Doll",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Rumah Bata A",
  T_38_XYL_WS_FENCE002: "Pagar Besi B",
  T_38_XYL_WS_FIREWORK01: "Fireworks A",
  T_38_XYL_WS_GENERATOR: "Generator",
  T_38_XYL_WS_GRAVITY: "Gravitational Acceleration",
  T_38_XYL_WS_GRAVITYAREA: "Zona Abnormal Grav",
  T_38_XYL_WS_GRAVITYAREA_DESC: "Zona dimana pemain bisa mengubah gravitasi",
  T_38_XYL_WS_HOLDWEAPON: "Bawa Senjata",
  T_38_XYL_WS_INDOORFURNITURE: "Furnitur Indoor",
  T_38_XYL_WS_LIGHTTUBE001: "Tube Light A",
  T_38_XYL_WS_LOVEBALLOON01: "Valentine Balloon A",
  T_38_XYL_WS_LOVELAMP01: "Heart Streetlight",
  T_38_XYL_WS_LOVESIGN01: "Love Neonlights",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Rasio Damage Oil Barrel",
  T_38_XYL_WS_OUTDOORPROPS: "Item Outdoor",
  T_38_XYL_WS_PIPEANDBOX: "Pipa dan Kontainer",
  T_38_XYL_WS_PLANT: "Tumbuhan",
  T_38_XYL_WS_ROSE01: "Rose",
  T_38_XYL_WS_ROSEN: "Buket Mawar",
  T_38_XYL_WS_SMALLBUILDING: "Gedung Kecil",
  T_38_XYL_WS_SOFA002: "Sofa B",
  T_38_XYL_WS_TOWNHOUSE01: "Rumah 2 Lantai 2",
  T_38_XYL_WS_TV001: "TV Tua",
  T_38_ZP_CC_EXCHANGESTATUS: "Status",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "Victory Glintmark",
  T_39_HJ_WS_Arrow002: "Arrow 2",
  T_39_HJ_WS_LIKERATE2: "{0} menit",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} menit",
  T_39_HJ_WS_SOUND10: "Step",
  T_39_HJ_WS_SOUND11: "Misi Selesai 1",
  T_39_HJ_WS_SOUND13: "Sinyal Bahaya 1",
  T_39_HJ_WS_SOUND14: "Sinyal Bahaya 2",
  T_39_HJ_WS_SOUND15: "Hitung Mundur 3",
  T_39_HJ_WS_SOUND16: "Suara Tips",
  T_39_HJ_WS_SOUND17: "Crow Caw",
  T_39_HJ_WS_SOUND18: "Suara teleport ke area yang salah",
  T_39_HJ_WS_SOUND19: "Suara teleport ke area yang benar",
  T_39_HJ_WS_SOUND2: "Hitung Mundur 1",
  T_39_HJ_WS_SOUND20: "Teleport",
  T_39_HJ_WS_SOUND21: "Electric Shock",
  T_39_HJ_WS_SOUND23: "Dapatkan Item",
  T_39_HJ_WS_SOUND24: "BGM Elektronik Lucu",
  T_39_HJ_WS_SOUND25: "BGM Game Kasual",
  T_39_HJ_WS_SOUND4: "Gema Alat Mekanik",
  T_39_HJ_WS_SOUND5: "Nyamuk",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Mesin Dinyalakan",
  T_39_HJ_WS_SOUND9: "Charge 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Unlimited Gloo Wall",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Unlimited Throwables",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Suara Menembak Spesial",
  T_39_HQ_UGC_CUSTOMRES: "Sumber Daya Custom",
  T_39_M_ACCOUNTID: "Akun",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Mulai setelah klik dua kali",
  T_39_MF_SKILLTAG_4: "Gerakan",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "Setelah menjatuhkan musuh, tandai rekan tim-nya dalam jarak [FFB300]{0}m[-] dari musuh yang dijatuhkan dan memperlambat gerakan mereka sebesar [FFB300]{1}%[-]. Berlangsung selama [FFB300]{2}dtk[-]. Ketika dijatuhkan, tandai dan memperlambat musuh yang menjatuhkan serta rekan tim-nya.",
  T_39_QL_SKILL_WOLFRAHH_DES: "Setelah menjatuhkan musuh, memasuki mode Highlight. Rate of fire meningkat [FFB300]{0}%[-] dan kecepatan gerak meningkat [FFB300]{1}%[-] namun berkurang dengan cepat. Berlangsung selama [FFB300]{2}dtk[-]. Selama mode Highlight, menjatuhkan musuh akan mengulang countdown dan meningkatkan rate of fire sebesar [FFB300]{3}%[-] dan kecepatan gerak sebesar [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Mode Xtreme: Dapatkan [FFB300]{0} HP sementara[-] selama [FFB300]{1}dtk[-]. Selama waktu ini, efek healing ditingkatkan [FFB300]{2}%[-]. Cooldown: [FFB300]{3}dtk[-].",
  T_39_RW_GM_DEFEAT: "Gagal",
  T_39_RW_SKILL_DESC_FORD: "Saat terkena damage, pulihkan [FFB300]{1} HP/dtk[-] selama [FFB300]{0}dtk[-].  Skil Ford akan reset setelah menggunakan skill aktif. Cooldown: [FFB300]{2}dtk[-].",
  T_39_SP_WS_ITEMENTITY_01: "Entitas Item",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana- 1001 Malam",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Pet Skin: Siluman Hijau Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Pet Skin: Royal Tig",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Pet Skin: Scorpio Fang",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck- Raksasa Hijau",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Awakening: [FFB300]{0}dtk[-] sebelum meledak, granat akan membuat [FFB300]{1}[-] granat extra, yang akan memberikan [FFB300]{2}%[-] DMG dari original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Split Blitz",
  T_39_WT_WS_EMPTYMAP_TAG: "Area kosong",
  T_39_WT_WS_FEMAPMODE: "Judul Mode",
  T_39_WT_WS_FEMAPTAG: "Map Tag",
  T_39_WT_WS_MAPPLAYER: "Jumlah Pemain",
  T_39_WT_WS_MEDENTERNUM: "Batasan pemain masuk mid-game",
  T_39_WT_WS_MIDENTER: "Masuk mid-game",
  T_39_WT_WS_MIDENTERCOUNT: "Kuota masuk mid-game",
  T_39_WT_WS_MIDENTERTIME1: "Batasan waktu masuk mid-game",
  T_39_WT_WS_MIDENTERTIME2: "Durasi masuk mid-game",
  T_39_WT_WS_MIDENTERTIMETIP: "Saat tidak capai limit jumlah pemain, pemain bisa masuk N detik pertama setelah match mulai. Pemain tidak bisa masuk setelah N detik.",
  T_39_WT_WS_MIDENTERTIP: "Saat dinyalakan, pemain bisa masuk map mid-game",
  T_39_WT_WS_PLAYERCOUNT: "Jumlah pemain awal",
  T_39_WT_WS_PLAYERCOUNTTIP: "Jumlah pemain saat match mulai. Lebih banyak pemain bisa masuk mid-game hingga mencapai batas map.",
  T_39_WT_WS_TAG1: "Free For All",
  T_39_WT_WS_TAG10: "Mudah",
  T_39_WT_WS_TAG11: "Medium",
  T_39_WT_WS_TAG12: "Hard",
  T_39_WT_WS_TAG13: "Sangat Sulit",
  T_39_WT_WS_TAG14: "Escape",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Sumber Daya Kustom",
  T_39_WT_WS_TAG18: "Puzzles",
  T_39_WT_WS_TAG19: "Racing",
  T_39_WT_WS_TAG2: "Gun Fight",
  T_39_WT_WS_TAG20: "Musik",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Adventure",
  T_39_WT_WS_TAG23: "Zombie Hunt",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "Team Deathmatch",
  T_39_WT_WS_TAG27: "Turret Defense",
  T_39_WT_WS_TAG28: "Training",
  T_39_WT_WS_TAG3: "Gun King",
  T_39_WT_WS_TAG4: "Respawn",
  T_39_WT_WS_TAG5: "Sniper",
  T_39_WT_WS_TAG6: "Survival",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Horror",
  T_39_WT_WS_TAG9: "Kasual",
  T_39_WT_WS_TAGMAXTIP: "Pilih hingga {0} tag",
  T_39_WT_WS_TAGTYPE1: "Tipe Gameplay",
  T_39_WT_WS_TAGTYPE2: "Tipe Map",
  T_39_WT_WS_TAGTYPE3: "Tipe Mode",
  T_39_WT_WS_TAGTYPE4: "Team Size",
  T_39_WZY_WS_ACCSPEED: "Akselerasi",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Tambah script [Script Name] untuk [Entity]",
  T_39_WZY_WS_ASC: "Ascending",
  T_39_WZY_WS_ASCIGZERO: "Abaikan nol menggunakan Ascending",
  T_39_WZY_WS_BALLISTMOVENT: "Entitas Gerakan Balistik",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Trigger saat item digunakan oleh [Entitas Pemain]",
  T_39_WZY_WS_BODYSCALE: "Skala badan",
  T_39_WZY_WS_BRAKETORQUE: "Brake Horsepower",
  T_39_WZY_WS_CAMTRANTYPE: "Tipe transisi kamera",
  T_39_WZY_WS_CARVEHICLE: "4-Wheeler",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Cek jika script [Script Name] terdapat di [Entitas]. (Hasil yang dikembalikan seharusnya Boolean)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Cek jika ada entitas memiliki hasil script yang ditentukan (Boolean)",
  T_39_WZY_WS_COMBINEALL: "Dual-wield (Senjata berbeda)",
  T_39_WZY_WS_COMBINESELF: "Dual-wield (Senjata sama)",
  T_39_WZY_WS_CONENAME: "Kerucut Dasar",
  T_39_WZY_WS_COORSYS: "Sistem koordinat",
  T_39_WZY_WS_CRASHMAXD: "Damage Maksimum Tabrakan",
  T_39_WZY_WS_CRASHMIND: "Damage Minimum Tabrakan",
  T_39_WZY_WS_CRAWLSPEED: "Persentase kecepatan gerakan (Tiarap)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Membuat Gerakan Balistik untuk [Entitas Target]. Bisa mengedit [Kecepatan Awal], [Akselerasi] dan [Jarak Maks] diakumulasi di arah gerakan awal entitas target, dan mengembalikan [Entitas Gerakan Balistik].",
  T_39_WZY_WS_CRETWEEN_NAME: "Buat Gerakan Interpolasi",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Membuat Gerakan Interpolasi untuk [Entitas], dengan [Atribut] dari entitas yang bergerak dari [Nilai Awal] hingga [Nilai Target] dalam [Waktu]. [Metode] menunjukkan mode gerakan, termasuk [Satu Arah], [Cycle]. [Kurva] adalah kurva dari gerakan dan [Entitas Gerakan Interpolasi] akan dikembalikan setelah membuat gerakan.",
  T_39_WZY_WS_CURVE: "Kurva",
  T_39_WZY_WS_CUSTRESULT: "Hasil Match Cuastom",
  T_39_WZY_WS_CYLINDERNAME: "Silinder Dasar",
  T_39_WZY_WS_DEFAULT: "Tanpa animasi (default)",
  T_39_WZY_WS_DESC: "Descending",
  T_39_WZY_WS_DIFFUSEALPHA: "Transparansi Permukaan",
  T_39_WZY_WS_DISCONNECT: "Disconnect",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Pemulihan energi per detik",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Pakai Energy",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Tinggi maksimum lompatan kedua",
  T_39_WZY_WS_ENABLEJOIN: "Boleh gabung di pertengahan",
  T_39_WZY_WS_ENDPOS: "Koordinat titik akhir",
  T_39_WZY_WS_ENGINETORQUE: "Engine Horsepower",
  T_39_WZY_WS_EXPLODED: "Damage Ledakan",
  T_39_WZY_WS_FEELDSPEED: "Persentase kecepatan gerakan (Jatuh)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Waktu flash tengah",
  T_39_WZY_WS_FLASH_CRANGE: "Jarak tengah",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Waktu flash ujung",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Efek hit Flashbomb",
  T_39_WZY_WS_FLASH_RANGE: "Jarak ledakan",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Kecepatan menurun",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Ketinggian maks.",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Kecepatan meluncur horizontal",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Kecepatan meluncur vertikal",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Tinggi akhir minimum",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Tinggi terbang minimum",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Kecepatan menurun setelah sangat tinggi",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Kecepatan memutar",
  T_39_WZY_WS_FOLMOVENT: "Posisi Mengikuti Entitas Gerakan",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Dapatkan Daftar Skill [Pemain Entitas]",
  T_39_WZY_WS_HB_BOOSTCD: "Cooldown berlari",
  T_39_WZY_WS_HB_BOOSTDURATION: "Durasi berlari",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Cooldown berlari di Skyboard",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Cooldown berlari di Skyboard",
  T_39_WZY_WS_HB_BOOSTSPEED: "Kecepatan berlari",
  T_39_WZY_WS_HB_HOVERBCD: "Skyboard cooldown",
  T_39_WZY_WS_HB_JUMPCD: "Cooldown lompatan",
  T_39_WZY_WS_HB_JUMPH: "Tinggi lompatan skyboard",
  T_39_WZY_WS_HEADSCALE: "Skala kepala",
  T_39_WZY_WS_HEADSHOTDESCALE: "Penurunan DMG headshot",
  T_39_WZY_WS_INTITALSPEED: "Kecepatan Awal",
  T_39_WZY_WS_INVENTORYBASE: "Tipe item dasar",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Kebutuhan energi per detik",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Kecepatan horizontal dasar",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Kecepatan vertical dasar",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Energi untuk lari per detik",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Kecepatan berlari horizontal",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Jarak berlari",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Harga energy rush per detik",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Kecepatan berlari vertikal",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Harga energy upward per detik",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Dapat Diserang",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Bisa trigger sendiri",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Apakah bisa di trigger oleh rekan",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Trigger oleh kendaraan",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Durasi",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Waktu aktivasi",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Radius trigger",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Waktu trigger",
  T_39_WZY_WS_LEAVE: "Keluar",
  T_39_WZY_WS_LIMBSCALE: "Skala lengan",
  T_39_WZY_WS_LISTLOCSTR: "Daftar teks lokal",
  T_39_WZY_WS_LOADRESULT_NAME: "Upload hasil match",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Upload hasil match [Pemain], termasuk [Rank], [Hasil]. [Nama Skor], [Nilai Skor]. Tipe hasil merupakan integer. 1 untuk kemenangan, 2 untuk kalah, 3 untuk Booyah, 4 untuk seri.",
  T_39_WZY_WS_LOOKMOVENT: "Entitas Gerakan Mengikuti Penglihatan",
  T_39_WZY_WS_MAXCOUNT: "Kuantitas Maksimum",
  T_39_WZY_WS_MAXDISTANCE: "Jarak maks.",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Sudut Penurunan Turret",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Kecepatan Sudut Turret",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Sudut Elevasi Turret",
  T_39_WZY_WS_MINISENTRY_DAM: "Damage Turret",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Rate Pengurangan Damage",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Sudut Menembak",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Hit Rate Turret",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Interval Serangan Turret",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Jumlah Maksimum Turret",
  T_39_WZY_WS_MINISENTRY_RANGE: "Jarak Serangan Turret",
  T_39_WZY_WS_MOVEENT: "Entitas Gerakan",
  T_39_WZY_WS_NOCOMBINE: "Tidak bisa dual-wield",
  T_39_WZY_WS_ONCE: "Sekali",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Trigger saat item dibuang oleh [Entitas Pemain]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Trigger saat item di-equip oleh [Pemain Entitas]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Trigger saat Hook Gun menembak",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Trigger saat Landmine diaktivasi",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Trigger saat Landmine di-trigger oleh [Pemain Entitas]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Trigger saat entitas pause gerakan",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Trigger saat entitas gerak kembali setelah pause",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Trigger saat entitas mulai bergerak",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Trigger saat item diambil oleh [Pemain Entitas]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Trigger saat Throwable mengenai target",
  T_39_WZY_WS_OPENATTACK: "Apakah bisa serang atau tidak",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Entitas Pause Gerakan atau Daftar Entitas Gerakan",
  T_39_WZY_WS_PAUSESOUND_NAME: "Pause efek suara",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Pause Entitas Suara atau Daftar Entitas Suara",
  T_39_WZY_WS_PIANOTYPE: "Tipe Komponen Musik",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Daftar Entitas Gerakan",
  T_39_WZY_WS_PLAYINGSTATUE: "Status",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Pulihkan Entitas Gerakan atau Daftar Entitas Gerakan yang di pause. Bisa pilih untuk lanjutkan atau ulang kembali.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Mainkan efek suara",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Pulihkan Entitas Suara atau Daftar Entitas Suara yang di pause. Bisa pilih untuk lanjutkan atau ulang kembali.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Progress Circle",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Memunculkan cahaya ke [Arah] dari [Koordinat Awal], mendeteksi entitas pertama dalam [Jarak], dan engembalikan [Daftar Entitas Terkenai] dan [Daftar Koordinat Terkenai].",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Memunculkan cahaya ke [Arah] dari [Koordinat Awal], mendeteksi entitas pertama dalam [Jarak], dan engembalikan [Entitas Terkenai] dan [Koordinat Terkenai].",
  T_39_WZY_WS_REAHEALHP: "Nilai pemulihan armor",
  T_39_WZY_WS_REAHEALTIME: "Interval waktu efek",
  T_39_WZY_WS_RELATCOORSYS: "Sistem koordinat relatif",
  T_39_WZY_WS_REPAIRARM: "Repair Kit",
  T_39_WZY_WS_REVERSE: "Reverse",
  T_39_WZY_WS_RIMALPHA: "Transparansi ujung",
  T_39_WZY_WS_SCORENAME: "Nama Skor",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Kirimkan sinyal ke Target Entity, parameter yang di upload akan didefinisikan sebagai parameter sinyal. Seleksi tipe entitas pada saat itu akan membuat sinyal event yang sesuai.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Membuat posisi gerakan mengikuti untuk [Entitas Target]. [Entitas Target] mengikuti [Entitas Mengikuti]. [Koordinat Offset] adalah koordinat offset di antara [Entitas Target] dan [Entitas Mengikuti]. [Sistem Koordinat] bisa memilih Sistem Koordinat Dunia dan Sistem Koordinat Relatif berdasarkan orientasi Entitas Mengikuti. [Entitas Mengikuti Gerakan Posisi] akan kembali setelah membuat gerakan.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Membuat Gerakan Mengikuti Penglihatan untuk [Entitas Target]. [Entitas Target] mengikuti [Entitas Mengikuti]. [Sistem Koordinat] akan memilih Sistem Koordinat Dunia dan Sistem Koordinat Relatif berdasarkan orientasi dari Entitas Mengikuti. [Entitas Gerakan Mengikuti Penglihatan] akan kembali setelah membuat gerakan.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Persentase damage jatuh",
  T_39_WZY_WS_SHOE_MAXENERGY: "Energi maks.",
  T_39_WZY_WS_SKILLLIST: "Daftar Skill",
  T_39_WZY_WS_SKILLTYPE: "Skill karakter",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Durasi efek smoke",
  T_39_WZY_WS_SMOOTH: "Ganti kamera",
  T_39_WZY_WS_SOUNDENTL: "Daftar Entitas Efek Suara",
  T_39_WZY_WS_SOUNDENTLORSENT: "Entitas atau Daftar Efek Suara",
  T_39_WZY_WS_SPRINTSPEED: "Persentase kecepatan berlari",
  T_39_WZY_WS_SQUATSPEED: "Persentase kecepatan gerakan (Jongkok)",
  T_39_WZY_WS_STARTCOO: "Koordinat Awal",
  T_39_WZY_WS_STATE: "Status main",
  T_39_WZY_WS_TARGETVAL: "Nilai target",
  T_39_WZY_WS_THROWSPEED: "Kecepatan terbang hook",
  T_39_WZY_WS_TOWER_PARAM10: "Sudut rotasi",
  T_39_WZY_WS_TOWER_PARAM11: "Status turret",
  T_39_WZY_WS_TOWER_PARAM12: "ID Entitas",
  T_39_WZY_WS_TOWER_PARAM9: "Target Serangan",
  T_39_WZY_WS_TOWSPEED: "Kecepatan bergerak pemain",
  T_39_WZY_WS_TWEENCURVE_NAME: "Kurva Kustom",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Kurva Kustom bisa digunakan untuk Gerakan Interpolasi",
  T_39_WZY_WS_TWEENENT: "Enitas Gerakan Interpolasi",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Metode Gerakan",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Metode Gerakan Interpolasi",
  T_39_WZY_WS_TWEENSTYLE: "Metode",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Hapus script [Script Name] untuk [Entity]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Acak element terdaftar",
  T_39_WZY_WS_VISIBLEONBACK: "Terlihat di belakang",
  T_39_WZY_WS_WEAPCOMBINET: "Tipe Senjata Dual-wield",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Damage extra ke musuh yang jatuh",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Nomor peluru single shot",
  T_39_WZY_WS_WEAREPLAY: "Ulangi gerakan?",
  T_39_WZY_WS_WORLDCOORSYS: "Sistem Koordinat Dunia",
  T_39_XXJ_WS_ADDFRIEND: "Tambah teman",
  T_39_XXJ_WS_ALLOWZ: "Memungkinkan gerakan sumbu-x untuk pemain",
  T_39_XXJ_WS_BLOCKMODEDESC: "Gerakan kamera saat ada objek di antara kamera dan target",
  T_39_XXJ_WS_CAMERADISTANCE: "Jarak dari target",
  T_39_XXJ_WS_CAMERATYPEDESC: "Berbagai tipe preset dan kamera disediakan",
  T_39_XXJ_WS_CAMERAUSER: "Pengguna kamera",
  T_39_XXJ_WS_CURENTCAMERA: "Kamera digunakan",
  T_39_XXJ_WS_DETAILS: "Detail Match",
  T_39_XXJ_WS_FFECONOMY: "Ekonomi",
  T_39_XXJ_WS_FOCUSTARGET: "Target yang diobservasi",
  T_39_XXJ_WS_FOLLOWTARGET: "Target diikuti",
  T_39_XXJ_WS_GAMERESULT: "Hasil Match",
  T_39_XXJ_WS_GAMETITLE1: "Match 1",
  T_39_XXJ_WS_GAMETITLE2: "Match 2",
  T_39_XXJ_WS_GIFT: "Hadiah",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Sudut rotasi horizontal kamera",
  T_39_XXJ_WS_INVISICAM: "Tembus Cahaya",
  T_39_XXJ_WS_INVISICAMDESC: "Objek diantara kamera dan target menjadi tembus cahaya",
  T_39_XXJ_WS_LEFTSCORE: "Skor Tim Kiri",
  T_39_XXJ_WS_LIKE: "Like",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Nama Total Skor",
  T_39_XXJ_WS_MAINSCORENUM: "Jumlah Total Skor",
  T_39_XXJ_WS_MAPEVALUATE: "Penilaian Map",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Hasil dari berbagai tim",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Offset titik observasi",
  T_39_XXJ_WS_OFFSET2DESC: "Merujuk ke offset dari titik fokus kamera relatif ke posisi pemain (berdasarkan tipe kamera)",
  T_39_XXJ_WS_OFFSETDESC: "Merujuk ke offset dari posisi kamera relatif ke posisi pemain (berdasarkan tipe kamera)",
  T_39_XXJ_WS_ORTHOGONAL: "Orthogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "Kamera menunjukkan target dekat dan jauh dengan besar yang sama",
  T_39_XXJ_WS_PERSPECTIVE: "Perspektif",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Kamera menggunakan proyeksi perspektif untuk melihat target",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Formasi gambar kamera saat rendering",
  T_39_XXJ_WS_RANK1: "Rank Tim",
  T_39_XXJ_WS_RANK2: "Rank Pemain",
  T_39_XXJ_WS_REPORT: "Lapor",
  T_39_XXJ_WS_REVIEW: "Replay",
  T_39_XXJ_WS_RIGHTSCORE: "Skor Tim Kanan",
  T_39_XXJ_WS_SCORENUM1: "Skor 1",
  T_39_XXJ_WS_SCORENUM2: "Skor 2",
  T_39_XXJ_WS_SCORENUM3: "Skor 3",
  T_39_XXJ_WS_SCORENUM4: "Skor 4",
  T_39_XXJ_WS_SCORENUM5: "Skor 5",
  T_39_XXJ_WS_SCORETITLELIST: "Daftar Nama Skor",
  T_39_XXJ_WS_SHARE: "Share",
  T_39_XXJ_WS_SPECTATORSWITCH: "Spektator",
  T_39_XXJ_WS_STABLE: "Stable",
  T_39_XXJ_WS_STABLEDESC: "Kamera tetap stabil jika ada objek di antara kamera dan entitas yang diikuti",
  T_39_XXJ_WS_TEAMNAME1: "Nama Tim Kiri",
  T_39_XXJ_WS_TEAMNAME2: "Nama Tim Kanan",
  T_39_XXJ_WS_TEAMRANK: "Rank Tim",
  T_39_XXJ_WS_TRANSITIONTIME: "Waktu transisi kamera",
  T_39_XXJ_WS_TRANSITIONTYPE: "Tipe transisi kamera",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Hasil dari 2 tim",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Sudut rotasi vertikal kamera",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "Kamera zoom in jika ada objek di antara kamera dan entitas yang diikuti",
  T_39_XYL_WS_LIGHTINTENSITY: "Intensitas cahaya",
  T_39_XYL_WS_LIGHTRANGE: "Jarak cahaya",
  T_39_XYL_WS_POINTLIGHT: "Pointlight",
  T_39_XYL_WS_WATERZONE: "Zona air kustom",
  T_40_B_DISABLE_RECONNECT: "Matikan Auto-reconnection",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "Status Clear Coloring",
  T_40_HJ_WS_EFFECT32: "Sneaker",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Spawnpoint",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Ammo",
  T_40_HJ_WS_EFFECT37: "Hit Effect",
  T_40_HJ_WS_EFFECT38: "Efek Menembak",
  T_40_HJ_WS_EFFECT43: "Spider Web",
  T_40_HJ_WS_EFFECT44: "Menggunakan Skill",
  T_40_HJ_WS_SOUND69: "Membuka Box",
  T_40_HJ_WS_SOUND70: "Level Up",
  T_40_HJ_WS_SOUND71: "Level Max",
  T_40_HJ_WS_SOUND72: "Menekan Tombol",
  T_40_HJ_WS_SOUND73: "Countdown 1",
  T_40_HJ_WS_SOUND74: "Whistle",
  T_40_HJ_WS_SOUND75: "Game Over",
  T_40_HJ_WS_SOUND76: "Forward",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Checkpoint",
  T_40_HJ_WS_SOUND79: "Countdown 2",
  T_40_HJ_WS_SOUND80: "Game Mulai",
  T_40_HJ_WS_SOUND81: "Obtained Many Coins",
  T_40_HJ_WS_SOUND82: "Mendapatkan Koin",
  T_40_HJ_WS_SOUND83: "Mendapatkan Beberapa Koin",
  T_40_HJ_WS_SOUND84: "Masuk ke Game",
  T_40_HJ_WS_SOUND85: "Buka Supply Guild",
  T_40_HJ_WS_SOUND86: "Terompet",
  T_40_HJ_WS_SOUND87: "Eliminasi Boss",
  T_40_HJ_WS_SOUND88: "Buka War Chest",
  T_40_HJ_WS_SOUND89: "Explosive Paint Skill",
  T_40_HJ_WS_SOUND90: "Bullet Hitting",
  T_40_HJ_WS_SOUND91: "Paint Shield Skill",
  T_40_HJ_WS_SOUND92: "Menekan Tombol Disabled",
  T_40_HJ_WS_SOUND93: "Skill Charging Selesai",
  T_40_HJ_WS_SOUND95: "Laser Skill",
  T_40_HJ_WS_SOUND96: "Get Item 2",
  T_40_HJ_WS_SOUND97: "Game Over 2",
  T_40_HJ_WS_SOUND98: "Notifikasi Eliminasi",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Background Music",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "Efek Suara In-Match",
  T_40_HJ_WS_SOUNDTYPE_UI: "Efek Suara Widget UI",
  T_40_JH_WS_MAPTAG1: "Color Game",
  T_40_JH_WS_MAPTAG10: "Color Hide N Seek",
  T_40_JH_WS_MAPTAG11: "Anniversary",
  T_40_JH_WS_MAPTAG12: "Role Play",
  T_40_JH_WS_MAPTAG13: "Simulasi",
  T_40_JH_WS_MAPTAG14: "Asymmetrical",
  T_40_JH_WS_MAPTAG15: "Pertarungan Loot",
  T_40_JH_WS_MAPTAG16: "Mengawali Cart",
  T_40_JH_WS_MAPTAG17: "Map Resmi",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Tantangan Kecepatan",
  T_40_JH_WS_MAPTAG2: "Color Spray",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Color Fight",
  T_40_JH_WS_MAPTAG4: "Color Fight",
  T_40_JH_WS_MAPTAG5: "Color Playground",
  T_40_JH_WS_MAPTAG6: "Playground Color",
  T_40_JH_WS_MAPTAG7: "Color Party",
  T_40_JH_WS_MAPTAG8: "Color Parkour",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" Parkour',
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "Home-Wreck Havoc",
  T_40_JH_WS_TAG32: "Mystery Town",
  T_40_JH_WS_TAG33: "Dawn Crisis",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "Craftland Token",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "of",
  T_40_SP_WS_DYEING: "Warna",
  T_40_SP_WS_DYEING_AREA: "Area Coloring",
  T_40_SP_WS_DYEING_COLOR: "Warna angka",
  T_40_SP_WS_DYEING_COUNT: "Hitungan Mewarnai",
  T_40_SP_WS_DYEING_DIR: "Arah Mewarnai",
  T_40_SP_WS_DYEING_DIS: "Jarak Mewarnai",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Fixed Coloring Area",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Warna Area Pesawat",
  T_40_SP_WS_DYEING_POSITION: "Koordinat",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Pengurangan Kecepatan Mewarnai Random",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Random Coloring Rate",
  T_40_SP_WS_DYEING_RANGE: "Coloring Area",
  T_40_SP_WS_DYEING_STATE: "Status Mewarnai",
  T_40_SP_WS_FACTIONTIPS_11: "Ungu",
  T_40_SP_WS_SHOE_CURENERGY: "Energi Sekarang",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "AK47- Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok Awakened",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS- Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014- Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24- Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80- Waggor's Wonder",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Pet Skin: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Pet Skin: Electric Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Pet Skin: Laser Eyes Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Pet Skin: Aloha Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Pet Skin: Tigerstripe Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR- Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson- Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP- Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP- Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi- Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Aktivasi Konten Teks",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Konten Teks Placeholder",
  T_40_W_DJMALE_AWAKENING_D: "Awakening: Saat aura aktif, not musik yang berlangsung selama [FFB300]{2}dtk[-] akan dijatuhkan [FFB300]{1}m[-] dibelakang pengguna setiap [FFB300]{0}dtk[-]. Teman tim yang mengambil not musik akan mendapatkan efek yang sama seperti aura.",
  T_40_W_DJMALE_AWAKENING_N: "Party Remix",
  T_40_W_NURSE_D: "Bagikan [FFB300]{0}%[-] dari healing 1 target pengguna (skill, Med Kit, heal gun, dll) ke teman tim dalam jarak [FFB300]{1}m[-].",
  T_40_WH_MP_BOXING_NAME: "Boxing Match",
  T_40_WH_MP_C_PACK: "Tas Kriminal",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Uang Kriminal",
  T_40_WH_MP_PAYCHECK: "Upah",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "Tingkatkan kecepatan membantu teman sebesar [FFB300]{0}%[-]. Cooldown: [FFB300]{3}dtk[-]. Teman yang dibantu memulihkan [FFB300]{2} HP[-] selama [FFB300]{1}dtk[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Membuat zona healing sebesar [FFB300]{0}m[-]. Di dalam, pengguna dan teman tim memulihkan [FFB300]{1}HP/dtk[-]. Pemain bisa bangun secara otomatis jika dibutuhkan. Zona berlangsung selama [FFB300]{2}dtk[-]. Efek membantu teman bisa ditingkatkan oleh skill lainnya. Cooldown: [FFB300]{3}dtk[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Metode Display",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Tinggi",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radius",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Bulat",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Warna",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progresif",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Sumber Image",
  T_40_WZY_WS_ICONENTITY_NAME: "Objek Icon",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Metode display",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Tiles",
  T_40_WZY_WS_NEWMAPTAG: "Ikon Map Baru",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curse",
  T_40_WZY_WS_NEWVFX11: "Freeze Zone",
  T_40_WZY_WS_NEWVFX12: "Cold Air",
  T_40_WZY_WS_NEWVFX13: "Snowflake",
  T_40_WZY_WS_NEWVFX14: "Flame",
  T_40_WZY_WS_NEWVFX15: "Light Beam",
  T_40_WZY_WS_NEWVFX16: "Persebaran Poison Gas",
  T_40_WZY_WS_NEWVFX17: "Poison Gas",
  T_40_WZY_WS_NEWVFX18: "Explosive Blaze",
  T_40_WZY_WS_NEWVFX19: "Efek Cahaya",
  T_40_WZY_WS_NEWVFX2: "Bubble",
  T_40_WZY_WS_NEWVFX20: "Star",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Stone Splash",
  T_40_WZY_WS_NEWVFX5: "Line",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "Ring",
  T_40_WZY_WS_NEWVFX8: "Rising Particle",
  T_40_WZY_WS_NEWVFX9: "Smoke",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Ukuran Font",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Style Font",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Font",
  T_40_WZY_WS_TEXTENTITY_NAME: "Objek teks",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Komponen HUD tombol interaksi",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Apakah bisa digunakan di pemandangan. Ini adalah read only dan tergantung "Parent tersedia atau tidak" dan "Status aktivitas".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Saat semua utama aktif. Hanya dapat di-baca dan tidak terlihat oleh pemain.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Utama tersedia atau tidak",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Tunjukan apakah status open adalah true, jika tidak maka ditutup",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Apakah bisa aktivasi diri sendiri. Untuk menggunakannya di pemandangan, gunakan "Bisa digunakan di pemandangan atau tidak". Ini adalah read only dan di konfigurasi menggunakan API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Apakah cullingMask kamera terlihat kepada layer tertentu",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Membuat token di tempat tertentu",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "Item bisa di-loot yang akan diberikan ke pemain",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Orientasi Pemain",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Arah",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "AI menyerang entitas",
  T_40_XXJ_WS_AITARGET_DESCKEY: "AI yang menyerang",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "Style align",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Align horizontal",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Align vertikal",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparency",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "Jumlah ammo sisa",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Ammo tersisa",
  T_40_XXJ_WS_ANCHORMAX: "Anchor Maksimum",
  T_40_XXJ_WS_ANCHORMIN: "Jangkar Minimum",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Posisi terkini pemain",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Posisi",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Armor HUD switch",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "ID asset yang dikonfigurasi",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "ID asset",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Target serangan",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Throwable serangan",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "Entitas yang diserang oleh AI",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Target diserang",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "Koordinat spawnpoint yang tersedia",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Koordinat tersedia",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "Image di bawah",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Background",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Backpack",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Transparansi background",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Warna Background",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Warna background",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Apakah mengisi background",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Isi background",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Nama background",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Nama background",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Delta besar background",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Delta besar background",
  T_40_XXJ_WS_BLUE: "Biru",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Skala skeleton",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "Spawnpoint pemain",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Spawn point",
  T_40_XXJ_WS_BOTH: "Bebas",
  T_40_XXJ_WS_BUTTONNAME: "Nama komponen tombol",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Kamera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "Arah yang dihadapai kamera klien",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "Lokasi dari kamera klien",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Deteksi garis kamera klien",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Deteksi sinar kamera",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Berhenti menarik saat berpaspasan dengan viewport",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Keluar drag setelah cocok",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "Jarak dari tengah setengah lingkar di ujung bentuk pil. Tidak bisa lebih kecil daripada dua kali radius bola.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Besar cell",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Tingga child cell",
  T_40_XXJ_WS_CELLVALUE: "Membaca konten dari cell tertentu dan mengembalikan objek",
  T_40_XXJ_WS_CENTER_DESCKEY: "Koordinat dunia yang sesuai dengan tengah minimap. 0 secara default.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Pusat minimap",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "Offset dari posisi tombol",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Offset posisi",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "Tengah dari massa relatif dari koordinat lokal",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Pusat massa",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Apakah menunjukkan garis tengah",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Tunjukkan garis tengah atau tidak",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Posisi garis tengah [0, 1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Posisi garis tengah",
  T_40_XXJ_WS_CHASERANGE: "Daerah Pengejaran",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "Entitas yang dikejar oleh AI",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Target dikejar",
  T_40_XXJ_WS_CHILD_DESCKEY: "Child entity",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Parent's children",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "Titik yang dikenai oleh garis kamera",
  T_40_XXJ_WS_CHOOSECARHUD: "Pilih entitas HUD kartu",
  T_40_XXJ_WS_CLAMP_DESCKEY: "Jika parameter berada di antara nilai minimal dan maksimum, maka fungsi akan mengembalikan nilai parameter; jika parameter lebih tinggi, fungsi akan mengembalikan nilai maksimum; jika dibawah, maka fungsi akan mengembalikan nilai minimum",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Hanya mendukun entitas yang memiliki komponen Transform. Sekarang terbatas ke semua objek.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "Besar dari area tekanan",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Besar click",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Tipe klip",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Tipe Clipping",
  T_40_XXJ_WS_CLONEENT_D: "Copy entitas terpilih dan atributnya dan menyimpan utama awal. Jika Level Objek terpilih, maka akan berdasarkan Buat Level Objek.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "Daftar pakaian",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "ID pakaian",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "ID pakaian",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "ID pakaian",
  T_40_XXJ_WS_COL_DESC: "Kolom untuk dibaca.",
  T_40_XXJ_WS_COLNAME_DESC: "Nama kolom untuk dibaca",
  T_40_XXJ_WS_COLOR_DESCKEY: "Warna",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Nilai",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Tambahkan layer warna menggunakan channel warna RGBA. Nilai channel berada di antara 0 dan 255",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Warna dari progress bar",
  T_40_XXJ_WS_COLOR3_DESCKEY: "Tipe channel warna RGBA, diantara 0 dan 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "Warna teks",
  T_40_XXJ_WS_COLOR5_DESCKEY: "Warna HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "Warna cahaya",
  T_40_XXJ_WS_COLORA_DESCKEY: "Nilai warna A",
  T_40_XXJ_WS_COLORB_DESCKEY: "Nilai warna B",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Warna progress abr",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Color barrel",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Color Barrel",
  T_40_XXJ_WS_COLORG_DESCKEY: "Nilai waran G",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Dapatkan channel RGBA",
  T_40_XXJ_WS_COLORGUN: "Rainbow Spray Rifle",
  T_40_XXJ_WS_COLORGUN_01: "Rainbow Spray Rifle (Merah)",
  T_40_XXJ_WS_COLORGUN_02: "Rainbow Spray Rifle (Kuning)",
  T_40_XXJ_WS_COLORGUN_03: "Rainbow Spray Rifle (Biru)",
  T_40_XXJ_WS_COLORGUN_04: "Rainbow Spray Rifle (Hijau)",
  T_40_XXJ_WS_COLORGUN_05: "Rainbow Spray Rifle (Ungu)",
  T_40_XXJ_WS_COLORR_DESCKEY: "Nilai warna R",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Warna teks",
  T_40_XXJ_WS_COLVALUE: "Konten Kolom",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "Entitas HUD dari tombol HUD general",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "Entitas HUD untuk tombol HUD general",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Batasan",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "Jumlah pengikat",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Hitungan batasan",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Konten original",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Arah default",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "Titik mulai scroll. Di kiri atas secara default.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Membuat pixel statik untuk objek tertentu di map. Pixel tidak akan bergerak dengan objek.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Buat ikon minimap",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Mendefinisikan string lokalisasi dari timestamp",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Membuat komponen UI kustom di komponen parent dan HUD kustom yang ditentukan",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Merangkak",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Display saat true, jika tidak maka ditutup",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Jongkok",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "Merupakan layer render cullingMask kamera. Kamu bisa filter entitas render menggunakan level dari layer yang terlihat.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "ID atasan",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Atasan",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "ID facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "ID sepatu",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Sepatu",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "Head ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Head",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "ID facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mask",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "ID bottom",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bottom",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "ID bundle",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Onesie",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "Jumlah tarikan ke arah xy",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "Drag XY",
  T_40_XXJ_WS_DB: "Baca Nilai Tabel",
  T_40_XXJ_WS_DB_DESC: "Membaca nilai bersangkutan dari identifier tertentu dari tabel tertentu di database",
  T_40_XXJ_WS_DBDELETE_DESC: "Hapus nilai yang bersangkutan dari identifier tertentu di tabel di database",
  T_40_XXJ_WS_DBKEY_DESCKEY: "Nama kustom yang digunakan untuk mengidentifikasi data",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifier",
  T_40_XXJ_WS_DBTABLENAME: "Nama Table Database",
  T_40_XXJ_WS_DBTABLENAME_DESC: "Nama dari tabel di database",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "Nilai untuk ditulis",
  T_40_XXJ_WS_DBWRITE: "Tulis Nilai Tabel",
  T_40_XXJ_WS_DBWRITE_DESC: "Menulis nilai yang terkait dengan identifier tertentu dari tabel tertentu di database",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Throwable bertahan",
  T_40_XXJ_WS_DEFULT: "Default",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Hapus nilai terkait dari key tertentu dalam beberapa tabel leaderboard di database.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Hapus nilai bersangkutan dari rank tertentu dari tabel leaderboard di database",
  T_40_XXJ_WS_DEPTH: "Layer HUD",
  T_40_XXJ_WS_DEPTH_D: "Layer dasar dari HUD",
  T_40_XXJ_WS_DICTANDLIST: "Daftar dan Kamus",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "Nilai dari kamus yang ditargetkan",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "Transparansi permukaan",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "Titik yang diberikan dan bisa digunakan untuk revival point dan lain-lain.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Koordinat",
  T_40_XXJ_WS_DISABLEALL: "Tidak pilih semua",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Warna disabled",
  T_40_XXJ_WS_DISTANT_DESCKEY: "Jarak deteksi garis kamera",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Jarak proyeksi",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Bisa di pindahkan ke berbagai arah",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Efek drag",
  T_40_XXJ_WS_DRIVER_DESCKEY: "Penyetir kendaraan",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Pengemudi",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Ubah nilai",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Tunjukkan efek spesial",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Tunjukkan efek spesial",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Warna efek",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "Entitas efek spesial merepresentasikan efek spesial yang akan ditunjukkan",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "Objek efek spesial",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Tombol HUD Emoji",
  T_40_XXJ_WS_ENABLEALL: "Pilih semua",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Apakah mengaktifkan update logic. Jika di non-atkfikan, blok di entitas ini akan berhenti update setiap frame.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "Saat ditulis ke dalam atribut senjata, statistik dasar senjata akan terefek oleh skin",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Tulis atribut skin senjata",
  T_40_XXJ_WS_ENTITY_DESCKEY: "Entitas adalah tempat yang berisikan semua komponen yang mesti ditambahkan agar entitas bisa diaktivasikan",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Tipe entitas",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "Komponen dasar dari entitas. Semua komponn akan menggabungkan komponen ini.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "Entitas untuk berubah menjadi",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "Nama parameter di kode untuk menunjukkan entitas di UI kontrol custom. Nilai variabel lokal adalah entitas dari kontrol UI custom baru.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "Nama dari variabel entitas",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "Nama parameter yang digunakan di kode untuk merepresentasikan entitas untuk ikon yang dibuat. Nilai variable lokal bersangkutan adalah entitas dari ikon yang dibuat.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "Tombol HUD bar EP",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Sudut euler",
  T_40_XXJ_WS_FACINFECTION: "Fraksi (Droid Apocalyse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faksi pemain. 1 = Human, 2 = Droid",
  T_40_XXJ_WS_FEMALE: "Perempaun",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Arahan mengisi",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Atur arah",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fire",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "Nilai dari float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "Target entitas untuk diikuti. Kosong secara default.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "Ukuran dari text",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Ukuran font",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "Tipe font",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Football Gloo Wall",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "Gaya formatting.",
  T_40_XXJ_WS_FORWARD_DESCKEY: "Arah pemain",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "Arah teleport",
  T_40_XXJ_WS_FREE_DESCKEY: "Kamera yang bisa dikontrol oleh pemain dan bisa digerakkan secara bebas",
  T_40_XXJ_WS_FREE_NAMEKEY: "Kamera Bebas",
  T_40_XXJ_WS_GENDER: "Jenis kelamin",
  T_40_XXJ_WS_GENDER_DESCKEY: "Jenis Kelamin",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Gender enum",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Dapatkan cullingMask kamera",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Hanya mendukun entitas yang memiliki komponen Transform. Sekarang terbatas ke semua objek.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Hanya mendukung entitas yang memiliki komponen Transform. Sekarang terbatas ke semua objek.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Hanya mendukung entitas yang memiliki komponen Transform. Sekarang terbatas ke semua objek.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Dapatkan ID pakaian pemain",
  T_40_XXJ_WS_GETPLAYERRANK: "Dapatkan Rank Pemain",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Dapatkan Rank Total Pemain",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Dapatkan Rank Ronde Pemain",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Dapatkan Rank Ronde Spesifik Pemain",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Mencari data untuk token pemain",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Dapatkan skin senjata pemain",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Dapatkan sepasang koordinat yang belum diisi oleh spawnpoint random",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Dapatkan sky box pemandangan",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Dapatkan region server",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Dapatkan timestamp server",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Dapatkan lokasi dekat teman tim, menghindari area dimana pemain tidak bisa berdiri",
  T_40_XXJ_WS_GETTEAMRANK: "Dapatkan Rank Tim",
  T_40_XXJ_WS_GETTEAMRANK_D: "Dapatkan Total Rank Tim",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Dapatkan Rank Ronde Tim",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Dapatkan Rank Ronde Spesifik Tim",
  T_40_XXJ_WS_GREEN: "Hijau",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Setengah dari dimensi sebuah bentuk 3 dimensi",
  T_40_XXJ_WS_HEAD_DESCKEY: "Head",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Kepala",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "Entitas efek detak jantung",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Entitas efek heartbeat",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "Tinggi",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Tombol Hint",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tombol tips",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "Entitas untuk ditunjukkan pada lokasi target",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entitas yang ditargetkan",
  T_40_XXJ_WS_HITPOS_DESCKEY: "Spot yang tertembak",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "Tipe display horizontal",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Tipe display horizontal",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "Entitas yang diikuti entitas lainnya",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "Entitas yang melihat entitas lain",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Tombol HUD bar HP",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "Entitas insertion HUD. Merupakan HUD yang ubah dari editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Komponen HUD panel kosong",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "Entitas HUD yang dimiliki",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "Entitas masukan HUD. Merupaakan HUD yang diedit pemain ketika menggunakan editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "Komponen grid HUD",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "Entitas insertion HUD. Merupakan HUD yang diedit pemain saat menggunakan editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "Komponen panel HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "Entitas insertion HUD. Merupakan HUD yang di-edit pemain saat menggunakan editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "Komponen pengelihatan scroll HUD",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ID model manusia",
  T_40_XXJ_WS_ICON_DESCKEY: "Nama sumber dari ikon",
  T_40_XXJ_WS_ICON_NAMEKEY: "Ikon",
  T_40_XXJ_WS_ICON1_DESCKEY: "Pilih ikon",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "Entitas ikon merepresentasikan ikon untuk ditunjukkan",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Tempat sumber daya. Sumber daya dalam game adalah in:path. Sumber daya custom adalah out:path. Kosong secara default.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Nama ikon",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Nama ikon",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "Tempat sumber daya. Kosong secara default.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Apakah bisa scan untuk trigger",
  T_40_XXJ_WS_INDEX_DESCKEY: "Index child di bawah parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Nilai awal [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "Nilai integer",
  T_40_XXJ_WS_IS3D: "Efek suara 3D",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Selalu menghadap kamera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Bold",
  T_40_XXJ_WS_ISBYORDER_D: "Deteksi apakah pemain harus deteksi objek level di urutan kronologis",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor button",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Apakah garis kamera mengenai entitas",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Apakah terlihat hingga beberapa layer",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italic",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Apakah ditandai oleh scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Di-scan atau tidak",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Apakah akan ditandai dengan tombol pin",
  T_40_XXJ_WS_ISTRIGGER: "Adalah trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Underlined",
  T_40_XXJ_WS_ITEMID_DESCKEY: "Item ID entitas yang bersangkutan",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Item ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "Item ID (hanya ID senjata yang tersedia di versi terkini)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "Item ID senjata",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Item ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropolis area",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropolis area",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Jump",
  T_40_XXJ_WS_KEY_DESCKEY: "Nilai dari key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Key",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "Nama dari key. Kamu bisa gunakan ini untuk mendapatkan nilai key di variabel lokal.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Pengumuman eliminasi",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Warna teks",
  T_40_XXJ_WS_LANDMINEOBJ: "Entitas setelah pembuatan landmine",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "Mask dari layer bertabrakan. Layer yang tidak terpilih tidak termasuk di scan. Jika kosong, semua layer akan termasuk di scan.",
  T_40_XXJ_WS_LAYERSEDIT: "Edit Layer",
  T_40_XXJ_WS_LAYERSETTING: "Pengaturan layer terlihat",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "Layer colission dari deteksi garis kamera",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Layer",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Tipe layout",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Tipe layout",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Komponen HUD scoreboard",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "Entitas HUD scoreboard. Merubah properti entitas akan memengaruhi konten yang ditunjukan di UI tersebut.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Nama Leaderboard",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "Nama tabel leaderboard di database.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "Akselerasi saat mengayun",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Akselerasi meninggalkan",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Lengan kiri",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Lengan kiri",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "Warna kiri",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Warna kiri",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Apakah menunjukkan efek spesial di kiri",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Tunjukan efek kiri atau tidak",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Kaki kiri",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Kaki Kiri",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Tangan kiri",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Tangan kiri",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Ikon kiri",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Ikon kiri",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Kaki kiri",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Kaki kiri",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Teks skor kiri",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Teks skor kiri",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Teks kiri",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Teks kiri",
  T_40_XXJ_WS_LERP_DESCKEY: 't berada di antara 0 adn 1. Saat t=0, kembalikan "from". Saat t=1, kembalikan  "to". Saat t=0.5, kembalikan rata-rata dari nilai  "from" dan  "to".',
  T_40_XXJ_WS_LEVELOBJECT: "Level Objek",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Line spacing",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Bandingkan nilai di daftar dan kembalikan yang paling besar",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Bandingkan nilai di daftar dan kembalikan nilai terendah",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List atau Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Posisi lokal",
  T_40_XXJ_WS_LOCALROTA: "Sudut Euler lokal",
  T_40_XXJ_WS_LOCALROTATIONQ: "Rotasi quaternion lokal",
  T_40_XXJ_WS_LOCALSACLE: "Skala lokal",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Ubah lokalisasi",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "Container untuk dilewati",
  T_40_XXJ_WS_MALE: "Laki-laki",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Hapus kamus",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Dapatkan panjang kamus",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Dapatkan nilai dari key yang ditentukan dari elemen kamus",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Hilangkan pasangan key-value di kamus",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Konfigurasi key yang ditentukan di kamus",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "Besar minimap. Panjang dan lebar sama.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Besar map",
  T_40_XXJ_WS_MAPT: "Templat dict",
  T_40_XXJ_WS_MAPT_D: "Templat data untuk dict. Kamu bisa memberikan tipe konten T1 hingga T2.",
  T_40_XXJ_WS_MAPVALUE_D: "Kontainer data untuk dict. Element adalah sepasang yang berisikan key dan nilai.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "Kamus target",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "Tipe mask adalah nama image digunakan saat maskin",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Nama mask",
  T_40_XXJ_WS_MASS_DESCKEY: "Massa (dalam kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Massa (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Membandingkan 2 nilai dan mengembalikan yang paling tinggi",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Panjang maks.",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "Nilai maksimum",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "ID komponen terbesar",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "ID widget maks",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Healing item",
  T_40_XXJ_WS_MIN_DESCKEY: "Bandingkan 2 nilai dan kembalikan yang lebih kecil",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Komponen minimap",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Pixel minimap",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Ikon minimap",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimap",
  T_40_XXJ_WS_MINNUM_DESCKEY: "Nilai minimum",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "Faktor momentum. Semakin besar nilai, semakin besar momentum saat scrolling.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Faktor momentum",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Gerakan joystick",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Hasil match",
  T_40_XXJ_WS_NEWENTITY_D: "Entitas item baru setelah pembuatan (mungkin nul)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Buat kamus",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "Dict Baru",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "Normal dari tembakan",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "Posisi HUD [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "Posisi HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "Daftar untuk konverse indices menjadi angka",
  T_40_XXJ_WS_OBJECT_DESCKEY: "Objek yang dikenai oleh spray gun",
  T_40_XXJ_WS_OBSOLETE: "Dihapus, untuk alasan keamanan mohon ubah blok ini.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "Posisi display. Saat ada target yang diikuti, ada offset di antara posisi baru dan original. Saat tidak ada target yang diikuti, maka ia merupakan koordinat layar (default adalah Vector3(0))",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "Koordinat layar (default adlaah Vector3(0))",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "Posisi display. Jika ada target yang diikuti, maka merupakan offset antara posisi baru dan awal. Jika tidak ada target yang diikuti, maka merupakan koordinat layar (default adalah Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Posisi display (",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Offset horizontal",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Offset horizontal",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "Offset vertikal",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Offset vertikal",
  T_40_XXJ_WS_OK_DESCKEY: "Konversi berhasil",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Trigger event ini saat entitas masuk ke jarak serangan",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Trigger event ini ketika entitas memasuki jarak pengejaran",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Trigger event ini saat entitas keluar dari jarak serangan",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Trigger evenet ini saat entitas meninggalkan jarak pengejaran",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Trigger deteksi melalui klien",
  T_40_XXJ_WS_ONCOLLISION_D: "Hanya entitas dengan komponen Collider terpasang yang mendukung event ini",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Triger event ini saat spray gun mengenai entitas",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "Saat tembakan berhenti",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "Apakah pemain mengubah area pemandangan",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Display saat open status adalah true, jika tidak maka tutup.",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Buka status",
  T_40_XXJ_WS_ORANGE: "Oranye",
  T_40_XXJ_WS_ORDER_DESC: "Rank di leaderboard",
  T_40_XXJ_WS_ORDER1: "Rank Awal",
  T_40_XXJ_WS_ORDER2: "Rank Terakhir",
  T_40_XXJ_WS_ORIGINAL: "Simpan logic awal",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Metode overflow",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "Saat diprioritaskan, atribut senjata pemain akan menggantikan atribut original senjata",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Prioritaskan skin senjata pemain",
  T_40_XXJ_WS_OWNER_DESCKEY: "Pemain yang memiliki entitas ini",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "Global UID dari pemandangan child yang dimiliki",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID pemandangan child",
  T_40_XXJ_WS_PARENT_DESCKEY: "Enitas utama",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Utama",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "ID entitas komponen parent",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "ID file dari komponen parent",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "Semua penumpang di kendaraan",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Penumpang",
  T_40_XXJ_WS_PHYSICALLAYER: "Layer Fisik",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Matriks Layer Fisik",
  T_40_XXJ_WS_PHYSICALTIP1: "Nama Sudah Dipakai",
  T_40_XXJ_WS_PHYSICALTIP2: "Hapus nama layer dan buat menjadi tidak terlihat di Matriks Layer Fisik dan Layer Enum, namun objek entitas di dalam layer tidak akan terefek.",
  T_40_XXJ_WS_PHYSICS: "Physics",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Tombol HUD daftar loot",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "Entitas yang bisa dimainkan",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "Entitas yang selalu berhadapan dengan entitas lainnya",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "Enittas mengikut entitas lainnya",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "Animasi bullet trail adalah simulasi animasi dari jejak peluru",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "Pemain yang mendapatkan pesan",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "Avatar yang digunakan pemain",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "Pakaian yang digunakan pemain",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Pakaian pemain",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "Tipe HUD pemain",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Tipe HUD pemain",
  T_40_XXJ_WS_PLAYERIDINFAC: "No. Serial Fraksi",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "Pemain yang didata di log",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Konsumsi token pemain tertentu",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "Daftar skill pemain",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "Status pemain: Hidup, jatuh, atau tereliminasi",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Kecepatan playback",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Kecepatan playback",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "Contohnya, 1.25 berarti 25% lebih cepat dari kecepatan asli",
  T_40_XXJ_WS_POS_DESCKEY: "Koordinat lokasi teleport",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "Tipe stiker efek spesial",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Warna saat ditekan",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Melakukan traversal kontainer untuk mendapatkan pasangan key-value. Termasuk proses child, yang merupakan loop.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Loop dict visit",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "Tombol untuk progress skill",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Tombol progres skill",
  T_40_XXJ_WS_QUATERNION: "Rotasi quaternion",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Switch HUD pesan cepat",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Pesan di sebelah daftar tim",
  T_40_XXJ_WS_RADIUS_DESCKEY: "Radius dari kedua setengah lingkaran dari bentuk pil",
  T_40_XXJ_WS_READCELL: "Membaca Cell",
  T_40_XXJ_WS_READCSV: "Baca konten tabel",
  T_40_XXJ_WS_READCSV_DESC: "Baca konten seluruh tabel. Kembalikan array 2-D.",
  T_40_XXJ_WS_READCSVCELL: "Baca sesuai # baris dan nama kolom",
  T_40_XXJ_WS_READCSVCOL_DESC: "Baca kolum tertentu di tabel. Kembalikan array.",
  T_40_XXJ_WS_READCSVROW_DESC: "Membaca baris konten baris tertentu di tabel. Mengembalikan array.",
  T_40_XXJ_WS_READLEADERBOARD: "Baca Nilai Leaderboard",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Baca nilai yang terkait dari identifier tertentu dari tabel leaderboard di database.",
  T_40_XXJ_WS_READLEADERBOARD2: "Baca Sesuai Jarak Rank",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Membaca nilai dari perbedaan beberapa rank dari leaderboard di database.",
  T_40_XXJ_WS_RED: "Merah",
  T_40_XXJ_WS_RELOAD: "Reload",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Metode display",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Kembalikan pakaian default pemain",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Kembalikan skin senjata default pemain",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Apakah drag terbatas kepada viewport. Terpilih secara default.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Membatasi tarikan atau tidak",
  T_40_XXJ_WS_RESULT_DESCKEY: "Hasil membaca",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Hasil",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Apakah menemui angka tertinggi di daftar",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Apakah akan menemukan nilai terkecil di daftar",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Temukan angka terkecil dari daftra",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Temukan angka terbesar di daftar",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "Revival point pemain. Jika tidak ada checkpoint, maka gunakan spawnpoint. Jika tidak, gunakan checkpoint.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Revival point",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Tangan kanan",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Lengan kanan",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "Warna kanan",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Warna kanan",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Apakah menunjukkan efek spesial di kanan",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Tunjukkan efek kanan atau tidak",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Kaki kanan",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Kaki Kanan",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Tangan kanan",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Tangan kanan",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Ikon kanan",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Ikon kanan",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Kaki kanan",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Kaki kanan",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Teks skor kanan",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Teks skor kanan",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Teks kanan",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Teks kanan",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "Komponen dari tipe rigid body",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Komponen badan rigid",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "Enum dari tipe rigid body",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Rigid body type enum",
  T_40_XXJ_WS_ROW_DECS: "Baris untuk dibaca.",
  T_40_XXJ_WS_ROWVALUE: "Konten Baris",
  T_40_XXJ_WS_SCALE_DESCKEY: "Konfigurasi skala zoom dari objek",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Skala",
  T_40_XXJ_WS_SCALE0_DESCKEY: "Skala zoom dari seri koordinat di dunia",
  T_40_XXJ_WS_SCALE1_DESCKEY: "Skala zoom. 1 secara default.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "Nilai skala",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "Nama area",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Scorebar",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Score bar",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Mendukung scroll berbagai arah",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Arah scroll",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "Faktor scrolling. Semaking tinggi nilai, semakin cepat scrolling.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Faktor scroll",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Konfigurasi cullingMask kamera",
  T_40_XXJ_WS_SETGLOBAL: "Atur Global",
  T_40_XXJ_WS_SETPARENT_D: "Hanya mendukung entitas yang memiliki komponen Transform",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Konfigurasi ID pakaian pemain",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Ubah pakaian beberapa pemain",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Atur Arah Pemain",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Konfigurasi tombol HUD pemain",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Konfigurasi skin senjata pemain",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Apakah menunjukan entitas di lokasi target",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Display entitas di target",
  T_40_XXJ_WS_SHOWPLAYER: "Tunjukkan entitas",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Entitas HUD detil match single player",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "Entitas HUD untuk match single-player. Merubah properti entitas akan mengganti konten yang ditunjukkan di UI yang bersangkutan.",
  T_40_XXJ_WS_SIZEDELTA: "Besar delta anchor box dan komponen",
  T_40_XXJ_WS_SKELETON: "Skeleton",
  T_40_XXJ_WS_SKELETON_D: "Pivot bisa digunakan untuk mengakses mask skeleton",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Bagian skeleton",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Entitas HUD tombol skill",
  T_40_XXJ_WS_SLOT_DESCKEY: "Slot senjata",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "Saat dipilih, akan ada gerakan lambat saat menarik. Jika tidak dipilih, kecepatan menarik sesuai dengan kecepatan mouse.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Gerakan mulus atau tidak",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Softness",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Kelembutan",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Entitas suara",
  T_40_XXJ_WS_SPACE_DESCKEY: "Space",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Child cell spacing",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "Koordinat spawn point AI",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Koordinat spawn point",
  T_40_XXJ_WS_SPEED_DESCKEY: "Kecepatan",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Kecepatan",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Lari",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "Radius dari bola",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "Warna spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Warna spray",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "Hasil Spray",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Hasil spray",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "Senjata spray (assault rifle)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Spray Rifle",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Kecepatan Awal",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Balik stiker",
  T_40_XXJ_WS_SPRITEID: "ID aset sprite",
  T_40_XXJ_WS_SPRITEID_D: "ID untuk menggambarkan aset sprite",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Tipe stiker",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "Entitas target untuk diubah menjadi pixel statik",
  T_40_XXJ_WS_STARTPOSITION_D: "Koordinat dari titik pusat bentuk geometri",
  T_40_XXJ_WS_STAY_D: "Pertahankan posisi dunia, rotasi dan skala child? Ini biasanya diatur menjadi True, dan pengaturan UI tidak efektif untuk opsi ini.",
  T_40_XXJ_WS_STRING_NAMEKEY: "String",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Ubah string menjadi float",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Ubah string menjadi integer",
  T_40_XXJ_WS_STYLE_DESCKEY: "Metode mainkan interpolasi. Opsi termasuk mainkan sekali, loop dan mainkan kembali.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Ubah area pemain",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Ubah nilai",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Ubah senjata berdasarkan slot pemain",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Ubah slot item",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Tombol item",
  T_40_XXJ_WS_TABLENAME_DESC: "Tunjukan nama tabel tapi aslinya merupakan UID",
  T_40_XXJ_WS_TABLEVALUE: "Table content",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "Daftar tag",
  T_40_XXJ_WS_TARGET_DESCKEY: "Target entitas untuk membuat pixel peta. Kosong secara default.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entitas untuk membuat pixel map",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Serang target",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "Target entitas",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entitas",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "Entitas dimana fungsi mengubah berada",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "Entitas yang diserang oleh AI",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "Entitas target untuk diikuti",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "Entitas item (bisa kosong)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "Entitas target untuk dilihat",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "Entitas suara untuk di-pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "Entitas suara untuk dimainkan setelah pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "Entitas suara untuk dihapus",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Info teman tim",
  T_40_XXJ_WS_TELEPORTA_D: "Teleport pemain ke lokasi tertentu dengan arah yang diatur",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Teks tip",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Warna teks notifikasi",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "Entitas teks merepresentasikan teks untuk ditunjukkan",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "Teks key untuk ditunjukkan",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Teks key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "Timestamp",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "Gaya display string lokalisasi",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Gaya display timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "String yang sudah di localize untuk timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc string timestamp",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Hint",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tip",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "Jumlah item bisa di-loot",
  T_40_XXJ_WS_TOKENID_DESCKEY: "ID item bisa di-loot",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "Kecepatan menyeret pemain",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Tipe translation",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "Entitas animasi interpolasi",
  T_40_XXJ_WS_TYPE_DESCKEY: 'Ini adalah tipe deskripsi. Menggunakan "typeof" akan mengembalikan tipe-nya.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Tipe rigid body",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Tipe badan yang berbeda memiliki fungsi yang berbeda",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Hanya mata uang standar di-dukung di versi sekarang",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Apakah menyalakan display minimap depth",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Gunakan peta kedalaman",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Apakah mengikuti gravitasi",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitasional atau tidak",
  T_40_XXJ_WS_UUID_DESCKEY: "Identifikator unik pemain",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "Nilai",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Nilai",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Nilai [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "Nilai pertama",
  T_40_XXJ_WS_VALUE2_DESCKEY: "Nilai kedua",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Nilai [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "Nilai awal",
  T_40_XXJ_WS_VALUEB_DESCKEY: "Nilai target",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "Nama dari nilai untuk dilewati. Kamu bisa mendapatkan ini untuk mendapatkan nilai di variabel lokal.",
  T_40_XXJ_WS_VALUET_DESCKEY: "Progress interpolasi. Nilai di antara 0 dan 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Tipe variabel",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "Tipe display vertikal",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Tipe display vertikal",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "Level visibilitas objek",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Layer yang terlihat",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Pakaian termasuk bundle, kepala, mask, facepaint, atasan, celana dan sepatu.",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Tipe pakaian",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Slot bundle",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Senjata",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "ID skin senjata",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ID skin senjata",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "ID skin senjata",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "Skin senjata pemain",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Tipe komponen enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "Lebar",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "Tulis Nilai Leaderboard",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Tulis nilai terkait dari key tertentu dari tabel leaderboard tertentu di database.",
  T_40_XYL_WS_BUMPERFACTORY: "Bumper Car Factory",
  T_40_XYL_WS_BURNDAMAGE: "Damage Pembakaran",
  T_40_XYL_WS_BURNINTERVAL: "Interval Damage Combustion (dtk)",
  T_40_XYL_WS_BURNTIME: "Waktu Kebakaran Setelah Ledakan",
  T_40_XYL_WS_COLORFULSKY: "Colorful Sky",
  T_40_XYL_WS_CRANEMACHINE: "Claw Crane",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Damage Tabrakan Maksimum",
  T_40_XYL_WS_CRASHMAXSPEED: "Batas Kecepatan Damage Tabrakan Maksimum",
  T_40_XYL_WS_CRASHMESS: "Paramater Masa Saat Tabrakan",
  T_40_XYL_WS_CRASHMINDAMAGE: "Damage Tabrakan Minimum",
  T_40_XYL_WS_DISPLAYBOARD: "Billboard",
  T_40_XYL_WS_EXPLODEDAMAGE: "Damage Ledakan",
  T_40_XYL_WS_EXPLODEDELAY: "Waktu tunda ledakan",
  T_40_XYL_WS_EXPLODERANGE: "Jarak Ledakan",
  T_40_XYL_WS_FERRISWHEEL: "Bianglala",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Waktu Merubah Gear (dtk)",
  T_40_XYL_WS_ICAROUSEL001: "Merry-Go-Round Komponen A",
  T_40_XYL_WS_ICAROUSEL002: "Merry-Go-Round Komponen B",
  T_40_XYL_WS_ICAROUSEL003: "Merry-Go-Round",
  T_40_XYL_WS_ICEDANCEDOOL: "Boneka Biru",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Uncontrolled Parking Horsepower Ratio",
  T_40_XYL_WS_LOLLIPOP: "Lollipop Raksasa",
  T_40_XYL_WS_NEWHOOKGUN: "Super Hook Gun",
  T_40_XYL_WS_OPENSWING: "Tombol mengayun",
  T_40_XYL_WS_OPENTRACTION: "Tombol tow",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "City",
  T_40_XYL_WS_SKYSCRAPER_A001: "Skyscraper A Komponen A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Skyscraper A Komponen B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Skyscraper A Komponen C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Skyscraper B Komponen A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Skyscraper B Komponen B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Skyscraper B Komponen C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Skyscraper C Komponen A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Skyscraper C Komponen B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Skyscraper C Komponen C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Skyscraper D Komponen A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Skyscraper D Komponen B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Skyscraper D Komponen C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Skyscraper E Komponen A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Skyscraper E Komponen B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Skyscraper E Komponen C",
  T_40_XYL_WS_STEERANGLE: "Radoius Memutar Kecepatan Tinggi",
  T_40_XYL_WS_STEERSPEED: "Kecepatan memutar maksimum saat kecepatan tinggi",
  T_40_XYL_WS_SWINGSPEED: "Kecepatan ayunan",
  T_40_XYL_WS_TARGETOBJECT: "Motion Anchor",
  T_40_XYL_WS_TRACTIONSPEED: "Kecepatan tow",
  T_40_XYL_WS_TRIGGERCAPSULE: "Trigger Kapsul Kustom",
  T_40_XYL_WS_TRIGGERSPHERE: "Trigger Bulat Kustom",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Objek Kustom",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "Komponen objek kosong yang bisa digunakan untuk komponen render dan komponen tabrakan.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Komponen Render Kustom",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "Komponen rendering kustom, digunakan untuk sumber daya model kustom.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Musuh yang ditandai memiliki bounty. Siapapun di tim kamu yang mengeliminasi musuh yang ditandai akan mendapatkan [FFB300]{0} koin[-]. Kamu akan mendapatkan extra [FFB300]100[-] saat mengeliminasi musuh. Dapatkan [FFB300]{1} FF Coin[-] extra dari Coin Machine di BR.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Money Mark",
  T_41_CJ_A_ESPORTS_TH: "Sporty Ganteng (Mask)",
  T_41_CJ_B_ESPORTS_TH: "Sporty Ganteng (Bottom)",
  T_41_CJ_H_ESPORTS_TH: "Sporty Ganteng (Head)",
  T_41_CJ_S_ESPORTS_TH: "Sporty Ganteng (Shoes)",
  T_41_CJ_T_ESPORTS_TH: "Sporty Ganteng (Top)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey",
  T_41_CJ_T_FOOTBALL_EU01: "Sunburst Jersey",
  T_41_CJ_T_FOOTBALL_EU02: "Bold Red Jersey",
  T_41_CJ_T_FOOTBALL_EU03: "Majestic Crown Jersey",
  T_41_CJ_T_FOOTBALL_EU04: "Regal Titan Jersey",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Item",
  T_41_R_CD_COIL: "Pengecilan Zona",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Apakah aktivasi perangkat ini",
  T_41_SJ_WS_SPECIALITEM_NAME: "Perangkat",
  T_41_SW_SKILL_DESC_DELIVERY: "Saat ditembak oleh musuh dalam jarak [FFB300]{0}m[-], musuh tersebut akan ditandai selama [FFB300]{1}dtk[-] (info diberikan ke teman tim). Maks. [FFB300]{2} penandaan[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Dapatkan [FFB300]{0} Shield Point[-] extra di awal match. Memulihkan Shield Point setelah bertahan hidup dari pertarungan.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "Saat menggunakan skill aktif, memberikan [FFB300]{1} Shield Point[-] untuk teman tim dalam jarak [FFB300]{0}m[-]. Shield Point berkurang setelah [FFB300]{2}dtk[-], dimana setelah itu pemain bisa mendapatkan efek ini kembali. Cooldown: [FFB300]{3}dtk[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Gloo Wall yang dipakai memulihkan [FFB300]{0}[-] durabilitas per detik, dimana teman dalam jarak [FFB300]{1}m[-] akan memulihkan [FFB300]{2} HP/dtk[-]. Maks. [FFB300]{3} HP[-] per teman tim untuk setiap Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Pet Skin: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Pet Skin: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Tipe",
  T_41_WT_SKILL_DESC_FIREBOY: "Membuat tembok api sebesar [FFB300]{1}m[-] selama [FFB300]{0}dtk[-] yang maju secepat [FFB300]{2}m/dtk[-] selama [FFB300]{3}dtk[-]. Saat aktif, gunakan skill lagi untuk menghentikan tembok. [FFB300]Musuh (atau Gloo Wall)[-] yang terkena akan mendapatkan [FFB300]{4} (atau {5}) DMG[-], lalu mendapatkan [FFB300]{6} (atau {7}) DMG[-]/dtk. Berlangsung selama [FFB300]{8}dtk[-]. Cooldown: [FFB300]{9}dtk[-]. Hingga [FFB300]{10}[-] penggunaan skill bisa disimpan, dengan cooldown [FFB300]{11}dtk[-] di antara setiap penggunaan.",
  T_41_WT_SKILL_NAME_FIREBOY: "Flame Mirage",
  T_41_WZY_WS_CHARGEMAX: "Maks. charge Gloo Maker",
  T_41_WZY_WS_CROSSBOWNAME: "Crossbow",
  T_41_WZY_WS_DECELERATIONRATIO: "Perlambatan % di air",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radius area melt",
  T_41_WZY_WS_DEICEWALLPARAM2: "Durasi melt",
  T_41_WZY_WS_EXPPERCHIP: "EXP dari Gloo Chip",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP dari memberi DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP dari setiap meter kamu jalan",
  T_41_WZY_WS_EXPPERSECOND: "EXP per detik",
  T_41_WZY_WS_GRENADEEXPTIME: "Delay ledakan",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosive",
  T_41_WZY_WS_GRENADEMAX: "DMG maksimum",
  T_41_WZY_WS_GRENADEMIN: "DMG minimum",
  T_41_WZY_WS_GRENADERANGE: "Jarak ledakan",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "Koefisien DMG kendaraan",
  T_41_WZY_WS_GRENADERATIOSELF: "Koefisien DMG pada diri sendiri",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "Koefisien DMG pada teman tim",
  T_41_WZY_WS_GRENADTHROWSPEED: "Kecepatan ledakan",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "Akselerasi",
  T_41_XXJ_WS_ACCELERATION_D: "Membuat efek akselerasi",
  T_41_XXJ_WS_ACTION: "Node aksi",
  T_41_XXJ_WS_ACTION_D: "Action Pivot",
  T_41_XXJ_WS_ADDHP: "Item Healing",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Tambahkan HP maks.",
  T_41_XXJ_WS_AICASTSKILL_D: "AI mengeluarkan skill",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Offset tengah aim assist",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Jarak aim assist",
  T_41_XXJ_WS_AIMASSISTENTITY: "Entitas aim assist",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entitas yang bisa di-aim assist",
  T_41_XXJ_WS_AISKILLTYPE: "Tipe skill zombie",
  T_41_XXJ_WS_AISKILLTYPE_D: "Tipe skill zombie",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "Semua item",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "Semua Item",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Ubah ukuran magazine",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Peluru di magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "Koordinat anchor terkait dengan parent-nya",
  T_41_XXJ_WS_ANGLE_D: "Sudut rotasi z axis",
  T_41_XXJ_WS_ANGULARDRAG: "Angular drag",
  T_41_XXJ_WS_ANGULARVELOCITY: "Kecepatan sudut",
  T_41_XXJ_WS_ANIMATIONCLIP: "Fase animasi",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Kontroler Animasi",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Entitas animasi",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "File dan sumber daya digunakan untuk mengatur kontroler animasi",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "UUID sumber daya kontroler animasi",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Enum tipe loop",
  T_41_XXJ_WS_ANIMATIONSTATE: "Fase animasi",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operation, dimana semua tipe nilai didukung dan tipe digital juga mendukung penambahan, pengurangan, multiplikasi dan pembagian sendiri.",
  T_41_XXJ_WS_ATTACHMENT: "Attachment",
  T_41_XXJ_WS_ATTACHMENT_D: "Attachment",
  T_41_XXJ_WS_ATTACHTARGET: "Entitas yang dikatikan",
  T_41_XXJ_WS_BAG: "Backpack",
  T_41_XXJ_WS_BAG_D: "Komponen Tas",
  T_41_XXJ_WS_BANNERID: "ID banner",
  T_41_XXJ_WS_BANNERID_D: "ID Banner",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Entitas behavior-mountable tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "Entitas behavior tree yang bisa dipasang",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Node kustom behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Pivot Kustom Behavior Tree",
  T_41_XXJ_WS_BODY: "Body",
  T_41_XXJ_WS_BORDERLR: "Border (kiri & kanan)",
  T_41_XXJ_WS_BORDERLR_D: "Border kiri dan kanan",
  T_41_XXJ_WS_BORDERTB: "Border (atas & bawah)",
  T_41_XXJ_WS_BORDERTB_D: "Border atas dan bawah",
  T_41_XXJ_WS_BRPEAKRANK: "Rank BR tertinggi",
  T_41_XXJ_WS_BRPEAKRANK_D: "Rank BR Tertinggi",
  T_41_XXJ_WS_BRRANK: "Rank BR",
  T_41_XXJ_WS_BRRANK_D: "Rank BR",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Tipe behavior tree node",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Tipe Pivot Behavior Tree",
  T_41_XXJ_WS_BTREE: "Behavior tree",
  T_41_XXJ_WS_BTREENODESTATE: "Fase behavior tree node",
  T_41_XXJ_WS_BTREENODESTATE_D: "Status Operasional Behavior Tree Pivot",
  T_41_XXJ_WS_BUFFABLEENTITY: "Entitas buff-enabled",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Nyalakan penambahan buff, pengurangan buff dan dapatkan daftar buff",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Item fungsional",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Kamuflase...",
  T_41_XXJ_WS_CAPICITY_D: "Kapasitas Awal",
  T_41_XXJ_WS_CENTERINVISIBLE: "Transparan ke tengah",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Tidak terlihat di tengah",
  T_41_XXJ_WS_COLOR: "Warna",
  T_41_XXJ_WS_COLOR_D: "Warna",
  T_41_XXJ_WS_CONDITION: "Node kondisi",
  T_41_XXJ_WS_CONDITION_D: "Kondisi adalah tipe Boolean spesial",
  T_41_XXJ_WS_CONDITION1_D: "Condition Pivot",
  T_41_XXJ_WS_CONSTRAIN: "Pembatasan RigidBody",
  T_41_XXJ_WS_CONSTRAIN_D: "Menambahkan pembatasan pada RigidBody. Ini merupakan kompilasi dari Tipe Pembatasan RigidBody.",
  T_41_XXJ_WS_COUNT_D: "Jumlah",
  T_41_XXJ_WS_CROSSBOW_D: "Crossbow",
  T_41_XXJ_WS_CSPEAKRANK: "Rank CS tertinggi",
  T_41_XXJ_WS_CSPEAKRANK_D: "Rank CS Tertinggi",
  T_41_XXJ_WS_CSRANK: "Rank CS",
  T_41_XXJ_WS_CSRANK_D: "CS Rank",
  T_41_XXJ_WS_CSVNAME_D: "File csv di dalam SceneData akan berkorelasi dengan mode. Berkahiran .csv. Header akan ditulis dengan huruf kecil.",
  T_41_XXJ_WS_CURCAPACITY: "Kapasitas digunakan",
  T_41_XXJ_WS_CURPROGRESS: "Progress terkini",
  T_41_XXJ_WS_CURRENTCLIP: "Klip sekarang",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Progres klip ini",
  T_41_XXJ_WS_CURRENTSTATE: "Fase terkini",
  T_41_XXJ_WS_CUSTOMHUDID: "ID custom HUD",
  T_41_XXJ_WS_CUSTOMHUDID_D: "ID digunakan untuk menjelaskan aset custom HUD",
  T_41_XXJ_WS_DASHATTACK: "Dash attack",
  T_41_XXJ_WS_DEBUG: "Mulai debugging",
  T_41_XXJ_WS_DEBUG_D: "Betulkan",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "% perlambatan: Perlambatan saat obyek berada di air (terletak di antara 0-100)",
  T_41_XXJ_WS_DEPTH_D: "Kedalaman",
  T_41_XXJ_WS_DRAG: "Koefisien drag",
  T_41_XXJ_WS_DRAG_D: "Semakin besar koefisien, semakn cepat perlambatan kecepatan gerak",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Nyalakan mode grafik rendah",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "Saat fps rendah menyala, game akan berjalan dalam 15 fps; selain itu akan 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Kembalikan daftar entitas yang dibuat",
  T_41_XXJ_WS_ENTITYNAME: "Nama obyek",
  T_41_XXJ_WS_ENTITYNAME_D: "Nama obyek yang diubah oleh pemain",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "ID Entitas atau Prefab Logical",
  T_41_XXJ_WS_EQUIPANDBAG: "Armor dan Tas",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Enum slot equipment",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Enum Slot Equipment",
  T_41_XXJ_WS_EXPLODE: "Self-explode",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Senjata Explosive",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Kecepatan auto reload",
  T_41_XXJ_WS_FILEID: "ID internal",
  T_41_XXJ_WS_FILEID_D: "Internal ID dari kontrol di prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Jumlah fill",
  T_41_XXJ_WS_FILLAMOUNT_D: "Nilai fill",
  T_41_XXJ_WS_FILLDIR: "Arah fill",
  T_41_XXJ_WS_FILLDIR_D: "Arah dari fill",
  T_41_XXJ_WS_FILLDIR_D1: "Enum arah fill",
  T_41_XXJ_WS_FILLTYPE: "Tipe fill",
  T_41_XXJ_WS_FILLTYPE_D: "Tipe fill",
  T_41_XXJ_WS_FILLTYPE_D1: "Enum tipe fill",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Find path",
  T_41_XXJ_WS_FINISH: "Selesai",
  T_41_XXJ_WS_FIREINTERVAL: "Interval menembak",
  T_41_XXJ_WS_FIREINTERVAL_D: "Interval Menyerang",
  T_41_XXJ_WS_FLIP: "Metode flip",
  T_41_XXJ_WS_FLIP_D: "Metode fill",
  T_41_XXJ_WS_FLYBOMBBEE: "Flying Zombie",
  T_41_XXJ_WS_FORCE: "Gaya",
  T_41_XXJ_WS_FORCE_D: "Membuat gaya dengan intensitas tertentu",
  T_41_XXJ_WS_FORCETYPE: "Tipe gaya",
  T_41_XXJ_WS_FORCETYPE_D: "Jenis gaya berbeda pada RigidBody. Hanya efektif pada RigidBody tipe dinamik.",
  T_41_XXJ_WS_FREEZEALL: "Bekukan gerakan dan rotasi",
  T_41_XXJ_WS_FREEZEPOSITION: "Bekukan gerakan linear",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Bekukan x axis",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Bekukan axis y",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Bekukan z axis",
  T_41_XXJ_WS_FREEZEROTATION: "Bekukan semua rotasi",
  T_41_XXJ_WS_FREEZEROTATIONX: "Bekukan rotasi x",
  T_41_XXJ_WS_FREEZEROTATIONY: "Bekukan rotasi y",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Bekukan rotasi z",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Jarak untuk damage maksimal",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Jarak untuk damage maks.",
  T_41_XXJ_WS_GAMEID_D: "ID misi",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Berikan item Metropolis",
  T_41_XXJ_WS_GRADIENT: "Gradien",
  T_41_XXJ_WS_GRADIENT_D: "Gradien",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradien di bawah",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "Gradien di bawah",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparan di bawah",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Transparansi Bawah",
  T_41_XXJ_WS_GRADIENTTOP: "Gradien di atas",
  T_41_XXJ_WS_GRADIENTTOP_D: "Gradien di atas",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparan di atas",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Transparansi Atas",
  T_41_XXJ_WS_GRAPHID: "ID Script",
  T_41_XXJ_WS_GRAPHID_D: "ID digunakan untuk menjelaskan aset script",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Komponen Gloo Melter",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Delay Ledakan",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Throwable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Maks. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "DMG Min.",
  T_41_XXJ_WS_GRENADERANGE_D: "Jarak Ledakan",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Multiplier DMG sendiri",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Multiplier DMG teman",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Multiplier DMG kendaraan",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Kecepatan Melempar",
  T_41_XXJ_WS_GRENADEWEAPON: "Kategori throwable",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Tipe Throwable Dasar",
  T_41_XXJ_WS_HANDCANNON_D: "Throwable",
  T_41_XXJ_WS_HEAD: "Kepala",
  T_41_XXJ_WS_HEADID: "ID avatar",
  T_41_XXJ_WS_HEADID_D: "ID Avatar",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Heavy Weapon",
  T_41_XXJ_WS_HELMET_D: "Helmet terkini",
  T_41_XXJ_WS_HELMET1_D: "Helmet",
  T_41_XXJ_WS_HELMET2_D: "Entitas helmet",
  T_41_XXJ_WS_HITBODYPART_D: "Bagian tubuh yang ditembak",
  T_41_XXJ_WS_HITBPDYPART: "Bagian tubuh terkenai",
  T_41_XXJ_WS_HITENTITY_D: "Entitas Terkenai",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "Entitas HUD yang berkaitan",
  T_41_XXJ_WS_HUD3DCONTAINER: "Kontainer konten 3D",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "Entitas kontainer HUD 3D. Merupakan HUD yang diubah pemain dari editor.",
  T_41_XXJ_WS_HUDGRID: "Kontrol Custom Layout (Panel)",
  T_41_XXJ_WS_HUDLAYOUT: "Kontrol layout",
  T_41_XXJ_WS_HUDLAYOUT_D: "Entitas insertion HUD. Merupakan HUD yang ubah dari editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Kontrol avatar kustom",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "Entitas HUD info profil. Ini adalah HUD yang diubah pemain dari editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Kontrol tekstur",
  T_41_XXJ_WS_HUDTEXTURE_D: "Entitas HUD tekstur. Ini adalah HUD yang diubah pemain dari editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "Komponen kontrol UITransform",
  T_41_XXJ_WS_HUDTRANSFORM_D: "Entitas kontrol UITransform",
  T_41_XXJ_WS_IMPULSE: "Strike",
  T_41_XXJ_WS_IMPULSE_D: "Membuat strike dari intensitas tertentu",
  T_41_XXJ_WS_INITIALWORLDPOS: "Koordinat dunia awal",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Enum buff",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Berhubungan dengan kolom ID di BuffData.csv. Sebelum menambahkan konten baru, mohon cek kecocokan dengan GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invert fill",
  T_41_XXJ_WS_INVERTFILL_D: "Invert fill tersebut",
  T_41_XXJ_WS_ISLOOP: "Is loop",
  T_41_XXJ_WS_ISLOOP_D: "Apakah loop atau tidak. Default adalah false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Pembuatan Static NavMesh",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Hanya digunakan untuk mengecek pembuatan NavMesh statik saat loading obyek statik",
  T_41_XXJ_WS_ISSUCCESS_D: "Dihancurkan atau tidak",
  T_41_XXJ_WS_ITEMENTITY_D: "Entitas Item",
  T_41_XXJ_WS_ITEMID: "ID Item",
  T_41_XXJ_WS_ITEMID_D: "Item ID",
  T_41_XXJ_WS_ITEMID_D1: "Item ID dari attachment terkait",
  T_41_XXJ_WS_ITEMLIST: "Daftar item",
  T_41_XXJ_WS_ITEMTYPE_D: "Tipe Item",
  T_41_XXJ_WS_JUMPATTACK: "Jump attack",
  T_41_XXJ_WS_LANDMINE: "Landmine",
  T_41_XXJ_WS_LENGTH: "Durasi klip",
  T_41_XXJ_WS_LENGTH_D: "Panjang dari progress bar. Nilai defaultnya merupakan panjangnya di UI prefab.",
  T_41_XXJ_WS_LIMB: "Anggota badan",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Gagal menambah elemen karena panjang daftar melebih batas",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Daftar buff",
  T_41_XXJ_WS_LOOP: "Loop",
  T_41_XXJ_WS_LOOP_D: "Loop",
  T_41_XXJ_WS_MAXCAPACITY: "Kapasitas",
  T_41_XXJ_WS_MAXCAPACITY_D: "Kapasitas tas",
  T_41_XXJ_WS_MAXPROGRESS: "Progres maks.",
  T_41_XXJ_WS_MELEEWEAPON_D: "Senjata Melee",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Jarak untuk damage min.",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Jarak untuk damage min.",
  T_41_XXJ_WS_MINISENTRY: "Auto Turret",
  T_41_XXJ_WS_NAME: "Nama",
  T_41_XXJ_WS_NAME_D: "Nama dari tombol skill. Digunakan untuk mengirim parameter saat OnClick, jadi keunikan harus dipastikan.",
  T_41_XXJ_WS_NAME1_D: "Nama Merchandise",
  T_41_XXJ_WS_NAME2_D: "Nama Daftar Merchandise",
  T_41_XXJ_WS_NAME3_D: "Nama Vending Machine",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Nama Pemain",
  T_41_XXJ_WS_NOCHANGE: "Tidak ada perubahan",
  T_41_XXJ_WS_NONE: "Tanpa pembatasan",
  T_41_XXJ_WS_NONE1: "Tidak ada",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "Offset",
  T_41_XXJ_WS_OFFSET1_D: "Nilai Written Offset",
  T_41_XXJ_WS_ONCE: "Sekali",
  T_41_XXJ_WS_ONCE_D: "Sekali",
  T_41_XXJ_WS_ONHIDE: "Saat interface ditutup",
  T_41_XXJ_WS_ONHIDE_D: "Saat interface ditutup",
  T_41_XXJ_WS_ONNODEENTER_D: "Saat pivot masuk",
  T_41_XXJ_WS_ONSHOW: "Saat interface buka",
  T_41_XXJ_WS_ONSHOW_D: "Saat interface buka",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Trigger saat text box berubah",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "ID Pin",
  T_41_XXJ_WS_PINID_D: "ID pin",
  T_41_XXJ_WS_PLAYERBAG: "Entitas tas pemain",
  T_41_XXJ_WS_PLAYERBAG_D: "Entitas tas pemain",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Tas pemain",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Tas pemain",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Koefisien kecepatan saat menggunakan scope yang sudah diubah",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Efek dari kecepatan gerak saat menembak",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Efek kecepatan gerak pada menembak",
  T_41_XXJ_WS_PREFABID: "ID Prefab",
  T_41_XXJ_WS_PREFABID_D: "ID digunakan untuk menjelaskan aset prefab",
  T_41_XXJ_WS_PREFABID1_D: "Entitas template HUD yang direpresentasikan ID ini",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Senjata Utama 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Senjata Utama 2",
  T_41_XXJ_WS_PROFILEINFO: "Profil pemain",
  T_41_XXJ_WS_PROFILEINFO_D: "Bio pemain",
  T_41_XXJ_WS_PROGRESSICON_D: "Ikon progres",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Nama ikon progress",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Keluar minigame Metropolis",
  T_41_XXJ_WS_RANGE: "Jarak menembak",
  T_41_XXJ_WS_RANGE_D: "Jarak Serangan",
  T_41_XXJ_WS_RANGE_D1: "Jarak Ledakan",
  T_41_XXJ_WS_RANGE_D2: "Jarak Turret",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Baca konten dari seluruh tabel. Mengembalikan array 2 dimensi.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Baca konten cell tertentu",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Baca konten kolom tertentu. Mengembalikan array.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Baca konten baris tertentu. Mengembalikan array.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Baca database diakumulasi",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Baca nilai terkait dengan suatu key di tabel dalam database terakumulasi",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Terus memulihkan HP",
  T_41_XXJ_WS_RELOADSPEED: "Reload speed",
  T_41_XXJ_WS_RELOADSPEED_D: "Reload Speed (Kecepatan awal x Multiplier)",
  T_41_XXJ_WS_RESOURCEID: "UUID Sumber Daya",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "ID sumber daya",
  T_41_XXJ_WS_RESUUID_D: "UUID sumber daya terkait untuk di-render",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "Tipe pembatasan RigidBody",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Setiap pembatasan didefinisikan dengan penanda bit dan bisa digunakan sebagai kombinasi",
  T_41_XXJ_WS_ROTATION: "Rotasi",
  T_41_XXJ_WS_ROTATION_D: "Sudut rotasi di koordinat dunia. x, y, z berarti yaw, pitch dan roll.",
  T_41_XXJ_WS_ROTATION1_D: "Rotasi",
  T_41_XXJ_WS_RUNNING: "Berlari",
  T_41_XXJ_WS_SCALE: "Skala",
  T_41_XXJ_WS_SCALE_D: "Skala",
  T_41_XXJ_WS_SCALE1_D: "Skali dari axis tertentu. Bisa merupakan kombinasi dari ketiga axis.",
  T_41_XXJ_WS_SCATTERMAX: "Penyebaran peluru maks.",
  T_41_XXJ_WS_SCATTERMAX_D: "Nilai dimana penyebaran peluru dimulai",
  T_41_XXJ_WS_SCATTERMOVE1: "Ukuran penyebaran saat bergerak",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Kecepatan pemulihan penyebaran",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Kecepatan pemulihan penyebaran",
  T_41_XXJ_WS_SCATTERSPEED: "Kecepatan peningkatan penyebaran",
  T_41_XXJ_WS_SCATTERSPEED_D: "Kecepatan peningkatan penyebaran (0.1 = crosshair lebih besar 10% untuk setiap peningkatan burst)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Lebih sedikit penyebaran saat tiarap atau jongkong",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Senjata Kedua",
  T_41_XXJ_WS_SHADERNAME: "Nama shader",
  T_41_XXJ_WS_SHADERNAME_D: "Nama shader",
  T_41_XXJ_WS_SHIELDBROKEN: "Serangan penghancur shield",
  T_41_XXJ_WS_SHIELDUP: "Shield attack",
  T_41_XXJ_WS_SHOCKWAVE: "Shockwave",
  T_41_XXJ_WS_SHOWNAME: "Tunjukkan nickname",
  T_41_XXJ_WS_SHOWNAME_D: "Tunjukkan Nickname",
  T_41_XXJ_WS_SHOWPIN: "Tunjukkan pin",
  T_41_XXJ_WS_SHOWPIN_D: "Tunjukkan Pin",
  T_41_XXJ_WS_SHOWRANK: "Tunjukkan rank",
  T_41_XXJ_WS_SHOWRANK_D: "Tunjukkan Rank",
  T_41_XXJ_WS_SHOWTYPE: "Desain",
  T_41_XXJ_WS_SHOWTYPE_D: "Tipe",
  T_41_XXJ_WS_SHRINKSPEED: "Kecepatan pengecilan",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Nyalakan aim assist dalam scope",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Sensitivitas crosshair aim assist dengan jarak (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Koefisien saat memprioritaskan jarak aim assist (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Jarak maks. untuk prioritasi aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Jarak min. untuk prioritasi aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Jarak prioritas untuk aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Sensitivitas crosshair aim assist (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Faktor zoom in scope",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "Faktor zoom in FOV",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Koefisien sensitivitas rotasi scope",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Koefisien x diubah dari DMG min. saat menggunakan scope",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Waktu UI zoom ini saat menemak menggunakan scope",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Faktor UI zoom in untuk menembak menggunakan scope",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Waktu melanjutkan untuk UI menembak menggunakan scope",
  T_41_XXJ_WS_SPEED: "Kecepatan playback",
  T_41_XXJ_WS_SPEEQUIP: "Equipment fungsional",
  T_41_XXJ_WS_SPEITEM: "Perangkat",
  T_41_XXJ_WS_STATICGRAPHID: "ID script statik",
  T_41_XXJ_WS_STATICGRAPHID_D: "ID digunakan untuk menjelaskan aset script statik",
  T_41_XXJ_WS_STATICWAINING: "Gagal mengubah tipe Rigidbody statik",
  T_41_XXJ_WS_TARGETTREE: "Entitas behavior tree",
  T_41_XXJ_WS_TARGETTREE_D: "Entitas behavior tree",
  T_41_XXJ_WS_TEAMINDEX: "No. seri tim",
  T_41_XXJ_WS_TEAMINDEX_D: "Indeks tim, yang bersamaan dengan indeks tim di ruangan",
  T_41_XXJ_WS_TEAMINDEX_D1: "Nomor Tim Fraksi",
  T_41_XXJ_WS_TEMPLATEPREFABID: "ID templat prefab",
  T_41_XXJ_WS_TEXT_D: "Konten",
  T_41_XXJ_WS_TEXTURENAME: "Nama tekstur",
  T_41_XXJ_WS_TEXTURENAME_D: "Nama tekstur",
  T_41_XXJ_WS_THROWATTACK: "Granat",
  T_41_XXJ_WS_TICKINTERVAL: "Interval refresh",
  T_41_XXJ_WS_TICKINTERVAL_D: "Interval refresh. Semakin tinggi angkanya, semakin lama waktu refresh.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Nyalakan perangkat spesial di tas pemain",
  T_41_XXJ_WS_UVRECTWH: "Panjang dan lebar UV",
  T_41_XXJ_WS_UVRECTWH_D: "Lebar dan tinggi UV",
  T_41_XXJ_WS_UVRECTXY: "Offset UV",
  T_41_XXJ_WS_UVRECTXY_D: "Offset UV",
  T_41_XXJ_WS_VELOCITY: "Kecepatan",
  T_41_XXJ_WS_VELOCITY_D: "Hindari mengubah kecepatan RigidBody secara langsung. Kamu bisa mengubahnya menggunakan API terkait.",
  T_41_XXJ_WS_VEST_D: "Vest sekarang",
  T_41_XXJ_WS_VEST1_D: "Vest",
  T_41_XXJ_WS_WIDGETID: "ID kontrol",
  T_41_XXJ_WS_WIDGETID_D: "ID digunakan untuk menjelaskan kontrol di aset halaman. Harus digabungkan dengan ID HUD kustom untuk memastikan ia sesuai dengan ID kontrol unik.",
  T_41_XXJ_WS_WINDATTACK: "Serangan tornado",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Tulis offset database terakumulasi",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Tulis offset yang terkait dengan key di suatu tabel di database terakumulasi",
  T_41_XXJ_WS_ZONEDURATION_D: "Durasi pembekuan",
  T_41_XXJ_WS_ZONEDURATION1_D: "Durasi Gloo Melter",
  T_41_XXJ_WS_ZONERADIUS_D: "Radius zona pembekuan",
  T_41_XXJ_WS_ZONERADIUS1_D: "Radius Gloo Melter",
  T_41_XYL_WS_BOT12: "Earth Driller",
  T_41_XYL_WS_BOT9: "Mutated Tossing Zombie",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Frozen Container A",
  T_41_XYL_WS_ITEM264: "Frozen Supply Container",
  T_41_XYL_WS_ITEM265: "Frozen Metal Gate",
  T_41_XYL_WS_ITEM266: "Frozen Container B",
  T_41_XYL_WS_ITEM267: "Frozen Stone A",
  T_41_XYL_WS_ITEM268: "Frozen Stone B",
  T_41_XYL_WS_ITEM269: "Frozen Stone C",
  T_41_XYL_WS_ITEM270: "Frozen Stone D",
  T_41_XYL_WS_ITEM271: "Abandoned Subway Car",
  T_41_XYL_WS_MODELMATCHNAME: "Contest Canvas",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Play Cube",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (Bottom)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (Head)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (Shoes)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (Top)",
  T_42_CJ_HA_THUNDER_GOLD: "Lightning Facepaint",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bottom)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Head)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Shoes)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Top)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall- Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "Grenade- Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917- Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "Ink",
  T_42_JH_WS_BANMATCHMAKING: "Tidak bisa matchmaking di map ini",
  T_42_JH_WS_BANROOMCREATE: "Tidak bisa membuat room",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Party Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Wall of Flame (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Shape Splitter (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Lifeshield (Sonia)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "Infinity Racer",
  T_42_JH_WS_TAG11: "Race Rush",
  T_42_JH_WS_TAG12: "Car Racing",
  T_42_JH_WS_TAG13: "Tiadakan dari Populer",
  T_42_JH_WS_TAG14: "Frontline",
  T_42_JH_WS_TAG15: "Zombie War",
  T_42_JH_WS_TAG16: "Legacy Legend",
  T_42_JH_WS_TAG2: "Social Island 1.0",
  T_42_JH_WS_TAG3: "Social Island 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "Preying Party",
  T_42_JH_WS_TAG7: "Preying Party",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Bounty Hunting",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Taruh portal dimanapun dan teleport pergi!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Equip attachment",
  T_42_SJ_WS_AUTOPLAY: "Auto play",
  T_42_SJ_WS_CLIMB: "Memanjat",
  T_42_SJ_WS_CLOCK_EVENTS: "Kompilasi event",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Hitung mundur atau tidak",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Loops",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pause event",
  T_42_SJ_WS_CLOCK_START_EVENT: "Mulai event",
  T_42_SJ_WS_CLOCK_START_TIME: "Waktu mulai hitung mundur",
  T_42_SJ_WS_CLOCK_STATE: "Status stopwatch",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Hentikan event",
  T_42_SJ_WS_DAMRATIOHEAD: "Ubah koefisien DMG headshot",
  T_42_SJ_WS_DAMRATIOLIMB: "Ubah koefisien DMG anggota badan",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Pengurangan koefisien dari DMG ledakan",
  T_42_SJ_WS_DRIVE: "Menyetir",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Tunjukkan layer",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Kapasitas tas ekstra",
  T_42_SJ_WS_EXTRAHPRATIO: "Rasio HP",
  T_42_SJ_WS_GETOFF_DRIVE: "Keluar kendaraan",
  T_42_SJ_WS_GETON_DRIVE: "Masuk kendaraan",
  T_42_SJ_WS_KNIFEITEM: "Dagger",
  T_42_SJ_WS_KNIFEITEMPICK: "Dagger (loot)",
  T_42_SJ_WS_MARKBTNHUD: "Tombol pin di HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "Kamu bisa mengaktifkan tombol pin",
  T_42_SJ_WS_MAXDISTANCE: "Jarak maks.",
  T_42_SJ_WS_MAXDURARATIO: "Rasio durabilitas maks.",
  T_42_SJ_WS_MICBTNHUD: "Tombol mic di HUD",
  T_42_SJ_WS_MICBTNHUD_D: "Kamu bisa mengaktifkan tombol mic",
  T_42_SJ_WS_MINDISTANCE: "Jarak min.",
  T_42_SJ_WS_OPE_VEHICLE: "Gunakan kendaraan",
  T_42_SJ_WS_PLANE_DESC: "Mesh dasar yang ukurannya bisa diubah secara bebas",
  T_42_SJ_WS_PLANENAME: "Basic Plane",
  T_42_SJ_WS_PRIORITY: "Prioritas",
  T_42_SJ_WS_REPLACEPRIORITY: "Ubah prioritas",
  T_42_SJ_WS_SETBTNHUD: "Tombol pengaturan di HUD",
  T_42_SJ_WS_SETBTNHUD_D: "Kamu bisa mengaktifkan tombol pengaturan",
  T_42_SJ_WS_SIGNALBTNHUD: "Tombol jaringan di HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "Kamu bisa mengaktifkan tombol jaringan",
  T_42_SJ_WS_SPEAKERBTNHUD: "Tombol klakson pada HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "Kamu bisa mengaktifkan tombol klakson",
  T_42_SJ_WS_START_TIME: "Waktu mulai (dtk)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Dapatkan [FFB300]{0}[-] kapasitas tas tambahan untuk ammo, selain Grenade Launcher. ([FFB300]{1}[-] AR Ammo, [FFB300]{2}[-] SMG Ammo, [FFB300]{3}[-] Sniper Ammo, [FFB300]{4}[-] SG Ammo)",
  T_42_SW_SKILL_DESC_Bodyguard: "Kecepatan reload meningkat sebesar [FFB300]{0}%[-]. Setiap musuh yang dikenai oleh pengguna skill akan terkena [FFB300]{1}%[-] pengurangan healing selama [FFB300]{3}dtk[-] (maks. pengurangan: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Menjadi kebal dari efek mengganggu (marking, memperlambat, pelumpuhan skill, dll) dan mendapatkan [FFB300]{1}%[-] peningkatan kecepatan gerak selama [FFB300]{2}dtk[-]. Cooldown: [FFB300]{0}dtk[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "Setelah menjatuhkan musuh atau menggunakan skill aktif, [FFB300]{0}%[-] dari magazine senjata akan reload secara automatis.",
  T_42_SW_SKILL_NAME_Playboy: "Silver Spoon",
  T_42_SY_BACKPACK_EMPIRE_N: "Crowned Roar Backpack",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Pet Skin: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motorbike- Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Jumlah CS Cash didapatkan setelah kalah suatu ronde",
  T_42_TYC_CST_LOSE_MONEY_2: "Jumlah CS Cash didapatkan setelah kalah 2 ronde berturut",
  T_42_TYC_CST_LOSE_MONEY_3: "Jumlah CS Cash didapatkan setelah kalah 3 ronde berturut",
  T_42_WH_ITEM_HEALUAV: "Heal UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "Menggunakan UAV-Lite ke depan dan terus memulihkan HP teman tim dalam jarak",
  T_42_WH_ITEM_SKILLCARD: "Skill: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Gunakan untuk memakai skill aktif dari [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Tipe Ammo",
  T_42_XXJ_WS_AMMOTYPE_D: "Tipe Ammo",
  T_42_XXJ_WS_ASSETCONFIGID: "ID Skin",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: "Status serangan",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Komponen penampilan bisa dimodifikasi",
  T_42_XXJ_WS_AVATARABLE_D: "Ubah penampilan berdasarkan bagian",
  T_42_XXJ_WS_AVATARRESUUID: "UUID sumber daya penampilan",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Mengubah representasi sudut axis dari rotasi menjadi Quaternion",
  T_42_XXJ_WS_B_D: "Nilai warna B",
  T_42_XXJ_WS_BASEVALUE_D: "Dasar logaritma",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "Bézier curve",
  T_42_XXJ_WS_BOTDIFFICULTY: "Tingkat Kesulitan Bot",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Metode Kombinasi Pantulan",
  T_42_XXJ_WS_BOUNCINES: "Bounciness",
  T_42_XXJ_WS_BTREEID: "ID behavior tree",
  T_42_XXJ_WS_BTREEID_D: "ID behavior tree",
  T_42_XXJ_WS_CANPURCHAS: "Bisa Dibeli atau Tidak",
  T_42_XXJ_WS_CANPURCHAS_D: "Bisa dibeli atau tidak",
  T_42_XXJ_WS_CLIMBSTATUS: "Sikap mendaki",
  T_42_XXJ_WS_CLOCK: "Obyek Timer",
  T_42_XXJ_WS_CLOCK_D: "Obyek Timer",
  T_42_XXJ_WS_CLOCK_D1: "Timer",
  T_42_XXJ_WS_CONTAINER: "Kontainer",
  T_42_XXJ_WS_CONTROLPOINTS: "Poin kontrol",
  T_42_XXJ_WS_CONTROLPOINTS_D: "Poin kontrol",
  T_42_XXJ_WS_COROUTINEID: "Coroutine handle",
  T_42_XXJ_WS_COROUTINEID_D: "ID Coroutine adalah handle dari coroutine tertentu. Bisa melakukan operasi tertentu di handle.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Buat relatif sendiri",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Buat relatif sendiri",
  T_42_XXJ_WS_CREATESOUND: "Buat Efek Suara",
  T_42_XXJ_WS_CREATESOUND_D: "Mainkan efek suara. Jika ada properti untuk diatur, kamu bisa mengatur properti entitas.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Selesaikan misi khusus",
  T_42_XXJ_WS_DAMAGELIST_D: "Daftar kenaikan DMG",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Rasio DMG headshot",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Multiplier pengurangan DMG ledakan",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Materi Fisika Default",
  T_42_XXJ_WS_DEFAULTFIST_D: "Tinju default",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Interval logic frame",
  T_42_XXJ_WS_DELTATIME_D: "Interval di antara 2 update logic frame dari GS",
  T_42_XXJ_WS_DEPTH: "Layer",
  T_42_XXJ_WS_DEPTH_D: "Tunjukkan layer di ikon",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "Daftar loot yang dinon-aktifkan",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "Daftar item yang tidak ada sebagai loot",
  T_42_XXJ_WS_DRIVER: "Kursi pengendara",
  T_42_XXJ_WS_DRIVINGSTATUS: "Kendarai",
  T_42_XXJ_WS_DURATION_D1: "Durasi hitung mundur dalam detik",
  T_42_XXJ_WS_DURATION_D2: "Durasi dalam detik",
  T_42_XXJ_WS_DURATION_D3: "Durasi",
  T_42_XXJ_WS_DURATION_D4: "Durasi kebal dalam detik.",
  T_42_XXJ_WS_DURATIONTIMES: "Durasi Waktu",
  T_42_XXJ_WS_DURATIONTIMES_D: "Durasi dalam detik",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Friksi Dinamik",
  T_42_XXJ_WS_EASY: "Very Easy",
  T_42_XXJ_WS_ENDTIMES: "Waktu Berakhir",
  T_42_XXJ_WS_ENDTIMES_D: "Waktu akhir timer dalam detik",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Batas Energi Global",
  T_42_XXJ_WS_ENTITYVARNAME_D: "Entitas relatif sendiri",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equip attachment",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Ubah sudut Euler menjadi Quaternion",
  T_42_XXJ_WS_EXPONENTIATION_D: "Eksponensial",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Kapasitas tas tambahan",
  T_42_XXJ_WS_FIST: "Tinju",
  T_42_XXJ_WS_FONTTYPE: "Enum font",
  T_42_XXJ_WS_FONTTYPE_D: "Enum font",
  T_42_XXJ_WS_FORCESYNCVALUE: "Status GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "Nilai force sync",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "Info lokasi dari GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Info lokasi dari force sync",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "Entitas yang bisa membuat properti",
  T_42_XXJ_WS_FORWARD_D: "Arah vektor",
  T_42_XXJ_WS_FRICTION_COMBINE: "Metode Kombinasi Fleksibilitas",
  T_42_XXJ_WS_FUNCPOINT: "Pointer Function",
  T_42_XXJ_WS_FUNCPOINT_D: "Pointer yang menunjukan instansi sebuah fungsi. Digunakan untuk mengimplementasikan fungsi virtual atau delegasi mekanisme.",
  T_42_XXJ_WS_GETMAPID_D: "Dapatkan ID map",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Keluar kendaraan",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Masuk kendaraan (pengendara)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Masuk kendaraan (penumpang)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Cari data token pemain hari ini",
  T_42_XXJ_WS_GRAVITY: "Gravitasi Global",
  T_42_XXJ_WS_HANDHELDITEM: "Handheld sekarang",
  T_42_XXJ_WS_HANDHELDITEM_D: "Handheld sekarang",
  T_42_XXJ_WS_HARD: "Hard",
  T_42_XXJ_WS_HASCOMPONENT_D: "Apakah ada komponen",
  T_42_XXJ_WS_HEIGHTLIST_D: "Daftar kenaikan tinggi",
  T_42_XXJ_WS_INDEXLIST_D: "Akses daftar index dari string",
  T_42_XXJ_WS_INSCENE: "Dalam scene",
  T_42_XXJ_WS_INSCENE_D: "Dalam scene",
  T_42_XXJ_WS_IS3D_D: "Apakah 3D music atau bukan",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Hitung mundur atau stopwatch",
  T_42_XXJ_WS_ISLOOP: "Loop atau tidak",
  T_42_XXJ_WS_ISLOOP_D: "Command IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "Apakah mulai dari awal atau tidak",
  T_42_XXJ_WS_ISSWITCH_D: "Saat dijadikan true, bisa digabungkan dengan gerakan relatif. Saat false, bisa digabungkan dengan gerakan absolut.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Status lompatan",
  T_42_XXJ_WS_LEFTVALUE: "Nilai Kiri",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logaritma",
  T_42_XXJ_WS_LOOPABLE: "Bisa di-loop",
  T_42_XXJ_WS_LOOPABLE_D: "Bisa di-loop",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Dapatkan semua key dari dict",
  T_42_XXJ_WS_MAPVALUE_D: "Dict Target",
  T_42_XXJ_WS_MARKBTNHUD: "Tombol pin di HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "Jarak maksimum",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "Switch mic di HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "Jarak minimum",
  T_42_XXJ_WS_MISSIONID_D: "ID misi",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progres (Tidak bisa negatif)",
  T_42_XXJ_WS_MODERATE: "Moderate",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Motor Bike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Status gerakan",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplikasi dari dua quaternion (representasi superposisi rotasi)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Dibuang",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Nyalakan perspektif pemain",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Nyalakan perspektif pemain",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Tipe Senjata",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Tipe Senjata",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioritaskan Konfigurasi Pemain",
  T_42_XXJ_WS_PARAMSARRAY: "Array Parameter",
  T_42_XXJ_WS_PARAMSARRAY_D: "Array Parameter adalah daftar parameter yang ada di output. Harus sesuai dengan jumlah dari %v yang ada di deskripsi format.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "Daftar parameter asli diberikan kepada fungsi kustom.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Mask visibilitas bagian 4",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Mask visibilitas bagian 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Mask visibilitas bagian 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Mask visibilitas bagian 4",
  T_42_XXJ_WS_PASSENGER1: "Kursi penumpang 1",
  T_42_XXJ_WS_PASSENGER2: "Kursi penumpang 2",
  T_42_XXJ_WS_PASSENGER3: "Kursi penumpang 3",
  T_42_XXJ_WS_PHYMAT: "Materi Fisika",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entitas",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Gerakan relatif sendiri di setiap frame",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Gerakan relatif sendiri setiap frame",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Gerakan relative sendiri",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "Gerakan relatif sendiri",
  T_42_XXJ_WS_PLAYER_D: "Pemain yang perlu memasuki kendaraan",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entitas dari sync properti perilaku pemain",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "Entitas dari sync properti perilaku pemain",
  T_42_XXJ_WS_PRIORITY_D: "Prioritas",
  T_42_XXJ_WS_PROPID_D: "ID properti",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion adalah vektor empat dimensi untuk merepresentasikan rotasi",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Ubah Quaternion menjadi representasi sudut axis",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Ubah Quaternion menjadi sudut Euler. Jika Quaternion tidak sesuai standar, kembalikan (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "Jumlah dimainkan. Default adalah 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reset",
  T_42_XXJ_WS_RIGHTVALUE: "Nilai Kanan",
  T_42_XXJ_WS_RIGHTVALUE_D: "Power",
  T_42_XXJ_WS_SEATTYPE: "Enum kursi kendaraan",
  T_42_XXJ_WS_SEPSTR_D: "String untuk pemisahan",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Atur DMG jatuh pemain",
  T_42_XXJ_WS_SETTINGSBTNHUD: "Tombol pengaturan di HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Tunjukkan Lokasi",
  T_42_XXJ_WS_SHOWPOSITION_D: "Tunjukkan Lokasi",
  T_42_XXJ_WS_SIGNALICOHUD: "Tombol jaringan di HUD",
  T_42_XXJ_WS_SIMPLE: "Easy",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Interpolasi quaternion bola dari A ke B",
  T_42_XXJ_WS_SOUNDENTITY_D: "Entitas efek suara yang merepresentasikan suara yang dimainkan",
  T_42_XXJ_WS_SPEAKERBTNHUD: "Tombol klakson pada HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Gunakan string tertentu sebagai delimiter untuk membagi string menjadi slice",
  T_42_XXJ_WS_SPORTSCAR: "Sports Car",
  T_42_XXJ_WS_SPRINTSTATUS: "Status berlari",
  T_42_XXJ_WS_SRCVAL_D: "Nilai sumber daya",
  T_42_XXJ_WS_STARTTICKCOUNT: "Saat dimana GS mulai hitung mundur",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "Saat dimana GS mulai hitung mundur",
  T_42_XXJ_WS_STARTTIME_D: "Waktu mulai",
  T_42_XXJ_WS_STARTTIME_D1: "Waktu mulai",
  T_42_XXJ_WS_STATE_D: "Status pemain: Aktif, jatuh atau tereliminasi.",
  T_42_XXJ_WS_STATE_D1: "Cek apakah suara menyala atau tidak",
  T_42_XXJ_WS_STATIC_FRICTION: "Friksi Statik",
  T_42_XXJ_WS_STRELEMS_D: "Set string target",
  T_42_XXJ_WS_STRINGFINDAT_D: "Kembalikan string yang dikombinasikan sesuai daftar index",
  T_42_XXJ_WS_STRINGJOIN_D: "Gabungkan string untuk pengidentifikasi spesifik",
  T_42_XXJ_WS_STRINGLOWER_D: "Ubah semau karakter di string menjadi huruf kecil",
  T_42_XXJ_WS_STRINGSTRIP_D: "Hilangkan karakter whitespace dari kedua sisi string",
  T_42_XXJ_WS_STRINGUPPER_D: "Ubah semua karakter di string menjadi huruf kapital",
  T_42_XXJ_WS_STYLE_D: "Cara dimainkan",
  T_42_XXJ_WS_SUV: "Pickup Truck",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "Saat true, kamu bisa mengombinasikannya dengan gerakan relatif. Jika false, harus digabung dengan gerakan absolut, atau efek tidak akan berjalan lancar.",
  T_42_XXJ_WS_TARGETENTITY_D: "Entitas target",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Banner Skor Ronde Tim",
  T_42_XXJ_WS_TEAMSEQ_D: "No. seri tim yang sesuai dengan properti nomor seri dari entitas tim",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Shield point sementara",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Shield point sementara",
  T_42_XXJ_WS_TEXT_D: "Teksi original untuk dilakukan filter kata kasar",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Status Switch",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dagger (loot)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dagger",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Detil Match Tim",
  T_42_XXJ_WS_UNIQUEID: "ID unik",
  T_42_XXJ_WS_UNIQUEID_D: "ID unik",
  T_42_XXJ_WS_VALUE_D: "Nilai",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Arah vektor ke sudut Euler",
  T_42_XXJ_WS_VEHICLEID: "ID Kendaraan",
  T_42_XXJ_WS_VEHICLESKINID: "ID skin kendaraan",
  T_42_XXJ_WS_VERYHARD: "Very Hard",
  T_42_XXJ_WS_VOLUME_D: "Volume suara. Default adalah 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Tipe Utama Senjata",
  T_42_XXJ_WS_WORKSHOPCODE: "Kode map",
  T_42_XXJ_WS_WORKSHOPCODE_D: "Map code yang sesuai dengan data di database",
  T_42_XXJ_WS_WORLDPOSITION: "Koordinat dunia",
  T_42_XXJ_WS_WORLDPOSITION_D: "Koordinat dunia",
  T_42_XYL_WS_ITEM275: "Fuel Tank",
  T_42_XYL_WS_ITEM276: "Sand Bag A",
  T_42_XYL_WS_ITEM277: "Sand Bag B",
  T_42_XYL_WS_ITEM278: "Sand Bag C",
  T_42_XYL_WS_ITEM279: "Sand Bag",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "Arms Factory",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "Stone Wall B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "Military Supply Box A",
  T_42_XYL_WS_ITEM287: "Copper Coin",
  T_42_XYL_WS_ITEM288: "Silver Coin",
  T_42_XYL_WS_ITEM289: "Gold Coin",
  T_42_XYL_WS_ITEM290: "Diamond",
  T_42_XYL_WS_ITEM291: "Diamond Shards",
  T_42_XYL_WS_ITEM292: "Ruby",
  T_42_XYL_WS_ITEM293: "Emerald",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Warning Sign",
  T_42_XYL_WS_ITEM297: "Ruin",
  T_42_XYL_WS_ITEM297TRUE: "Control Device",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "High-tech Wall A",
  T_42_XYL_WS_ITEM301: "High-tech Wall B",
  T_42_XYL_WS_ITEM302: "Frozen Stone F",
  T_42_XYL_WS_ITEM303: "Frozen Stone E",
  T_42_XYL_WS_ITEM304: "High-tech Platform A",
  T_42_XYL_WS_ITEM305: "High-tech Staircase A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "Logika",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuristic",
  T_42_XYL_WS_THEMEICE: "Icy",
  T_42_XYL_WS_THEMEMILITARY: "Militer",
  T_42_XYL_WS_THEMEOBJECTS: "Obyek Bertema",
  T_42_XYL_WS_TIMERCONTINUE: "Insiden Lanjut Timer",
  T_42_XYL_WS_TIMERCYCLE: "Loop Count",
  T_42_XYL_WS_TIMERDOWN: "Hitung mundur",
  T_42_XYL_WS_TIMEREND: "Insiden Akhir Timer",
  T_42_XYL_WS_TIMEREVENT: "Insiden Timer Kustom",
  T_42_XYL_WS_TIMEREVENT1: "Timer Kontrol",
  T_42_XYL_WS_TIMEREVENT2: "Atur Insiden Timer",
  T_42_XYL_WS_TIMERORDER: "Metode Timing",
  T_42_XYL_WS_TIMERPAUSE: "Insiden Pause Timer",
  T_42_XYL_WS_TIMERSTART1: "Waktu Mulai Timer",
  T_42_XYL_WS_TIMERSTART2: "Insiden Mulai Timer",
  T_42_XYL_WS_TIMERUP: "Hitung maju",
  T_42_XYL_WS_TRIGGERTIME_MS: "Waktu Trigger (milidetik)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "Skywing yang bisa",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Skor Individu",
  T_42_ZZ_GUILDWAR_SCORE: "Skor",
  T_43_B_SKILL_DESC_MONKEYGOD: "Berubah menjadi semak selama [FFB300]{1}dtk[-]. Cooldown: [FFB300]{0}dtk[-]. Transformasi berhenti ketika Wukong menyerang. Cooldown reset saat Wukong mengalahkan musuh.",
  T_43_B_SKILL_DESC_Nanoscientist: "Setelah terkena damage fatal, memasuki fase tidak bisa di-damage dan bergerak selama [FFB300]{0}dtk[-]. Lalu, dapatkan [FFB300]{1} HP shield[-] selama [FFB300]{2}dtk[-]. Penguna skill akan tereliminasi setelah shield habis. Cooldown: [FFB300]{3}dtk[-].",
  T_43_B_SKILL_DESC_ORION: "EP akan digantikan dengan [FFB300]{0} Crimson Energy[-]. Konsumsi [FFB300]{1} Crimson Energy[-] untuk mengaktifkan perlindungan, dimana kamu tidak bisa menerima damage maupun menyerang musuh dan akan menyerap [FFB300]{4} HP[-] (mengabaikan Shield Point) dari semua musuh dalam jarak [FFB300]{3}m[-]. Berlangsung selama [FFB300]{2}dtk[-], dimana kecepatan gerak akan berkurang sebanyak [FFB300]{6}%[-]. Cooldown: [FFB300]{5}dtk[-].",
  T_43_CJ_F_A_RACER: "Velocity Racer (Mask)",
  T_43_CJ_F_B_RACER: "Velocity Racer (Bottom)",
  T_43_CJ_F_H_RACER: "Velocity Racer (Head)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (Facepaint)",
  T_43_CJ_F_S_RACER: "Velocity Racer (Shoes)",
  T_43_CJ_F_T_RACER: "Velocity Racer (Top)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Mask)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (Bottom)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bottom)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (Head)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Head)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (Facepaint)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (Shoes)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Shoes)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (Top)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Top)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "Lainnya",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Pantai",
  T_43_HJ_WS_TEXTURE_BRICK1: "Brick Wall A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Brick Wall B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Brick Wall C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Concrete Floor",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concrete",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Kristal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grass A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grass B",
  T_43_HJ_WS_TEXTURE_ICE: "Ice Block",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Floor",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Marble Floor",
  T_43_HJ_WS_TEXTURE_NONE: "Kosong",
  T_43_HJ_WS_TEXTURE_STONE: "Batu",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Tablecloth A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Tablecloth B",
  T_43_HJ_WS_TEXTURE_WOOD: "Kayu",
  T_43_HJ_WS_TEXTURE_WOODEN: "Wooden Floor A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Wooden Floor B",
  T_43_JH_WS_MAPTAG1: "Cocok untuk Newbie",
  T_43_JH_WS_MAPTAG10: "Konten baru membosankan",
  T_43_JH_WS_MAPTAG11: "Sedikit hadiah",
  T_43_JH_WS_MAPTAG12: "Hadiah tidak seimbang",
  T_43_JH_WS_MAPTAG13: "Sedikit progresi",
  T_43_JH_WS_MAPTAG14: "Tidak Ramah untuk Newbie",
  T_43_JH_WS_MAPTAG15: "Tutorial membingungkan",
  T_43_JH_WS_MAPTAG16: "Tidak ada tutorial",
  T_43_JH_WS_MAPTAG17: "Pemain sering keluar",
  T_43_JH_WS_MAPTAG18: "Kontrol rumit",
  T_43_JH_WS_MAPTAG19: "UI Berantakan",
  T_43_JH_WS_MAPTAG2: "Konten baru disukai",
  T_43_JH_WS_MAPTAG20: "Desain map buruk",
  T_43_JH_WS_MAPTAG21: "Shooter Seru",
  T_43_JH_WS_MAPTAG22: "Serba Cepat",
  T_43_JH_WS_MAPTAG23: "Open World",
  T_43_JH_WS_MAPTAG24: "Penuh Cerita",
  T_43_JH_WS_MAPTAG25: "Sistem Progres",
  T_43_JH_WS_MAPTAG26: "Simulasi Olahraga",
  T_43_JH_WS_MAPTAG27: "Misi Co-Op",
  T_43_JH_WS_MAPTAG28: "Sosial",
  T_43_JH_WS_MAPTAG29: "Beragam Skenario",
  T_43_JH_WS_MAPTAG3: "Pemain aktif",
  T_43_JH_WS_MAPTAG30: "Eksplorasi Bebas",
  T_43_JH_WS_MAPTAG31: "Tantangan Ranking",
  T_43_JH_WS_MAPTAG32: "Achievement",
  T_43_JH_WS_MAPTAG33: "Redeem Mata Uang",
  T_43_JH_WS_MAPTAG4: "Desain map bagus",
  T_43_JH_WS_MAPTAG40: "Banyak hadiah",
  T_43_JH_WS_MAPTAG41: "Progresi memuaskan",
  T_43_JH_WS_MAPTAG42: "Training Ground Populer",
  T_43_JH_WS_MAPTAG43: "Solo Tower Populer",
  T_43_JH_WS_MAPTAG44: "War Zone Populer",
  T_43_JH_WS_MAPTAG5: "Stuttering",
  T_43_JH_WS_MAPTAG6: "Co-op sulit",
  T_43_JH_WS_MAPTAG7: "Banyak Bug",
  T_43_JH_WS_MAPTAG8: "Sedikit Update",
  T_43_JH_WS_MAPTAG9: "Event dalam match membosankan",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Spider Trap (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Drop Item",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Mulai Waktu Jatuh",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Drop Item",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Auto-Play",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Posisi Tengah",
  T_43_SJ_WS_ANITRIGGER_CLIP: "ID Klip Animasi",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Is Loop",
  T_43_SJ_WS_ANITRIGGER_NAME: "HUD Trigger Animasi",
  T_43_SJ_WS_RESET_ROUND: "Reset setiap Ronde",
  T_43_SJ_WS_START_DROPTIME: "Mulai Waktu Jatuh (milidetik)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Trigger Animasi",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Pet Skin: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motorbike - Incarnational Speed",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Berisikan supply penting seperti ammo dan item healing",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Supply Box",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Munculkan manekin [FFB300]{1} HP[-] yang bergerak selama [FFB300]{0}dtk[-]. Saat manekin masih dalam jarak [FFB300]{3}m[-], gunakan skill lagi untuk bertukar posisi. Kamu bisa bertukar sekali setiap [FFB300]{4}dtk[-], hingga [FFB300]{2} kali[-] total. Pemain yang menghancurkan manekin akan ditandai selama [FFB300]{5}dtk[-]. Cooldown: [FFB300]{6}dtk[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Skill Aktif",
  T_43_XXJ_WS_AIRDROP: "Airdrop dan Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "Transparansi HUD, dari 0 hingga 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "ID Kontroler Animasi",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "ID untuk mendeskripsikan aset kontroler animasi",
  T_43_XXJ_WS_AUDIOID: "ID Audio",
  T_43_XXJ_WS_AUDIOID_D: "ID yang digunakan untuk mendeskripsikan aset audio",
  T_43_XXJ_WS_BACKGRCOLOR: "Warna Background",
  T_43_XXJ_WS_BACKGRCOLOR_D: "Warna dari border HP bar dan background yang blur",
  T_43_XXJ_WS_BURNING: "Terbakar",
  T_43_XXJ_WS_CSVID: "ID CSV",
  T_43_XXJ_WS_CSVID_D: "ID digunakan untuk mendeskripsikan aset tabel konfigurasi",
  T_43_XXJ_WS_CURRENTHP: "HP Sekarang",
  T_43_XXJ_WS_CURRENTHP_D: "Nilai HP sekarang",
  T_43_XXJ_WS_DAMAGEMAKER_D: "Entitas game yang memberikan damage",
  T_43_XXJ_WS_DAMAGEZONE: "Zona Damage",
  T_43_XXJ_WS_DEFAULT: "Default",
  T_43_XXJ_WS_DEFAULT_D: "Default",
  T_43_XXJ_WS_EFFECTID: "ID Efek",
  T_43_XXJ_WS_EFFECTID_D: "ID untuk mendeskripsikan aset efek spesial",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "Entitas yang bisa melawan (meluncurkan serangan, diserang, atau dileminiasi)",
  T_43_XXJ_WS_FOLLOWTARGET: "Ikuti Target",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Harus mengikuti entitas dengan komponen Transform",
  T_43_XXJ_WS_GAINHPCOLOR: "Warna Tambah HP",
  T_43_XXJ_WS_GAINHPCOLOR_D: "Bagian HP yang meningkat akan ditunjukkan dengan warna ini untuk waktu singkat",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Tanpa Damage Jatuh",
  T_43_XXJ_WS_ISOPENTWEEN: "Open Tween",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Aktifkan untuk menunjukkan perubahan HP dengan warna yang berbeda",
  T_43_XXJ_WS_KNOCKDOWN_D1: "Pemain dalam status knockdown",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Pengaturan untuk respon terhadap status knockdown saat tereliminasi",
  T_43_XXJ_WS_KNOCKDOWN_D3: "Tipe sumber daya revival.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Status Knockdown",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Tipe Status Knockdown",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "Reaksi terhadap status knockdown: ikuti logika default, melewati status knockdown, atau paksa knockdown.",
  T_43_XXJ_WS_LEVEL: "Level",
  T_43_XXJ_WS_LEVEL_D: "Level",
  T_43_XXJ_WS_LEVEL_D1: "Level zombie sekarang",
  T_43_XXJ_WS_LINESPACING: "Line Spacing",
  T_43_XXJ_WS_LINESPACING_D: "Tidak muncul saat HP berada di antara pemisah ≤  0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Warna Kehilangan HP",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "Bagian HP yang berkurang akan ditunjukan dengan warna ini untuk warna yang singkat",
  T_43_XXJ_WS_MAINCOLOR: "Warna Utama",
  T_43_XXJ_WS_MAINCOLOR_D: "Warna untuk HP, level dan outline",
  T_43_XXJ_WS_MINISENTRY: "Turret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "Enum untuk tipe target yang bisa diserang turret",
  T_43_XXJ_WS_MISSILEEXPLODE: "Ledakan Misil",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Harus Knockdown",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Knockdown paksa",
  T_43_XXJ_WS_OFFSET: "Offset",
  T_43_XXJ_WS_OFFSET_D: "Offset sesuai dengan target diikuti",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Ledakan Oil Drum",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Hanya trigger saat pengontrol menginisiasi gerakan",
  T_43_XXJ_WS_PLAYER_D: "Entitas pemain dalam game. Setiap pemain memiliki satu.",
  T_43_XXJ_WS_PLAYERHEADHUD: "HUD Kepala Pemain",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "Informasi yang ditunjukkan di atas pemain",
  T_43_XXJ_WS_PLAYERNAME: "Nama Pemain",
  T_43_XXJ_WS_PLAYERNAME_D: "Tunjukkan nama dari pemilik HP bar",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Pemain atau Kendaraan",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "Alias untuk entitas tipe pemain/kendaraan",
  T_43_XXJ_WS_SCALE: "Skala",
  T_43_XXJ_WS_SCALE_D: "Menentukan ukuran skala HUD, dengan font yang akan disesuaikan.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Tunjukkan Angka Damage",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "True secara default. Menunjukkan angka damage.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Skip Knockdown",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Melewati status knockdown dan langsung tereliminasi",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Skip Animasi Stagger",
  T_43_XXJ_WS_TEAM_D: "(Tidak digunakan. Mohon gunakan ID Tim.)",
  T_43_XXJ_WS_TERRAIN: "Medan",
  T_43_XXJ_WS_TERRAIN_D: "Komponen medan yang atributnya tidak bisa diubah. Bisa digunakan untuk testing saja.",
  T_43_XXJ_WS_TOTALHP: "Total HP",
  T_43_XXJ_WS_TOTALHP_D: "Total nilai HP",
  T_43_XXJ_WS_TWEENENTITY: "Entitas Tween",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Kendaraan Meledak",
  T_43_XXJ_WS_WIDTH: "Lebar",
  T_43_XXJ_WS_WIDTH_D: "Lebar dari HP bar yang ditunjukkan",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Tinju (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Gaya Jepang",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Ubah event log match. Digunakan untuk analisa pengalaman pemain.",
  T_43_YU_WS_AIRDROPSTATE: "Status Airdrop",
  T_43_YU_WS_AIRDROPSTATE_D: "Status Airdrop (1: siap, 2: sedang jatuh, 3: sudah jatuh)",
  T_43_YU_WS_ANIMATIONCLIPID: "ID Klip Animasi",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Ubah ID klip animasi",
  T_43_YU_WS_ASKBUYTARGET: "Target Permintaan Beli",
  T_43_YU_WS_ASKBUYTARGET_D: "Spesifikasi target dan memberikan permintaan membeli",
  T_43_YU_WS_ASKEDLIST: "Daftar Permintaan",
  T_43_YU_WS_ASKEDLIST_D: "Daftar item yang diminta",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Warna Background 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "Warna background atas",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Warna Background 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "Warna background bawah",
  T_43_YU_WS_BATCHCOMBINERENDER: "Batch Kombinasi Render",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Daftar Entitas Bind Money",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "Daftar entitas mata uang",
  T_43_YU_WS_BINDWALLETENTITYID: "ID Entitas Bind Wallet",
  T_43_YU_WS_BINDWALLETENTITYID_D: "ID dari entitas bound wallet",
  T_43_YU_WS_CENTEROFFSET: "Offset Center",
  T_43_YU_WS_CENTEROFFSET_D: "Nilai offset dari capsule collider",
  T_43_YU_WS_COLLECTIONID: "ID Collection",
  T_43_YU_WS_COLLECTIONID_D: "ID Koleksi untuk koleksi informasi aset",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Membuat airdorp",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Membuat angka damage",
  T_43_YU_WS_CROSSPLATFORM_D: "Saat terpilih, klien akan dipanggil di server atau sebaliknya",
  T_43_YU_WS_CSROUNDRESULTHUD: "HUD Hasil Ronde CS",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Hasil ditunjukkan di akhir setiap ronde",
  T_43_YU_WS_CURRENTEMOTECLIP: "Clip Emote Sekarang",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID dari klip emote sekarang",
  T_43_YU_WS_DAMAGE_D: "Damage luar zona",
  T_43_YU_WS_DICTIONARY: "Kamus",
  T_43_YU_WS_DIRECTIONRULERHUD: "HUD Arah Penggaris",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "Kompas di atas",
  T_43_YU_WS_DOTWEEN_D: "Apakah memainkan animasi tween",
  T_43_YU_WS_DROPITEMS_D: "Item di airdrop",
  T_43_YU_WS_DURATION: "Durasi",
  T_43_YU_WS_ENERGY: "Energi",
  T_43_YU_WS_ENERGY_D: "Nilai modifikasi EP",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Tiarap",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Jongkok",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Berlari",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Berdiri",
  T_43_YU_WS_EVENTID: "ID Event",
  T_43_YU_WS_EVENTID_D: "Merepresentasikan event",
  T_43_YU_WS_FACTION: "Fraksi",
  T_43_YU_WS_FACTION_D: "Entitas fraksi",
  T_43_YU_WS_FACTION_D1: "Gunakan fraksi untuk bantu membeli",
  T_43_YU_WS_FINALRADIUS_D: "Radius akhir Zona Aman",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Med Kit",
  T_43_YU_WS_FIRSTPERSONMODEL: "First Person Model",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "Kamera First Person",
  T_43_YU_WS_FONTCOLOR_D: "Warna font",
  T_43_YU_WS_FONTSIZE_D: "Ukuran font",
  T_43_YU_WS_FORBIDEN: "Terlarang",
  T_43_YU_WS_FORBIDEN_D: "Matikan HUD untuk permintaan membeli",
  T_43_YU_WS_FREEZINGTIME: "Waktu Beku",
  T_43_YU_WS_FREEZINGTIME_D: "Durasi dimana target yang terkena tetap beku",
  T_43_YU_WS_GRAVITY: "Gravitasi",
  T_43_YU_WS_GRAVITY_D: "Akselerasi gravitasi. Hanya mempengaruhi pemain yang mengontrol.",
  T_43_YU_WS_HANDCATAPULT: "Launch Pad",
  T_43_YU_WS_HANDCATAPULT_D: "Launch Pad",
  T_43_YU_WS_HEALTH: "HP",
  T_43_YU_WS_HEALTH_D: "Nilai pemulihan dari durabilitas armor",
  T_43_YU_WS_HEIGHT: "Tinggi",
  T_43_YU_WS_HELPEDPLAYER_D: "Pemain yang dibantu",
  T_43_YU_WS_HELPPLAYER_D: "Pemain yang membantu membeli",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Sudut Maks. Horizontal",
  T_43_YU_WS_HORIZONTALMINANGLE: "Sudut Min Horizontal",
  T_43_YU_WS_HUDTOGGLE: "Toggle HUD",
  T_43_YU_WS_HUDTOGGLE_D: "Enitas HudToggle yang pemain bisa edit di HUD editor",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "Radius awal zona aman",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "Integer 64-bit signed",
  T_43_YU_WS_ISAPPLYSHADOW: "Terapkan Bayangan",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Loop Emote Sekarang",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Apakah kamu ingin menaruh animasi Emote dalam loop",
  T_43_YU_WS_ISSIDECOLLIDING: "Is Side Colliding",
  T_43_YU_WS_ISSLIDING: "Adalah meluncur",
  T_43_YU_WS_ISTOPCOLLIDING: "Is Top Colliding",
  T_43_YU_WS_ITEM331: "Futuristic Device A",
  T_43_YU_WS_ITEM332: "Glowing Rock A",
  T_43_YU_WS_ITEM333: "Futuristic Screen A",
  T_43_YU_WS_ITEM334: "Futuristic Container A",
  T_43_YU_WS_ITEM335: "Futuristic Container A",
  T_43_YU_WS_ITEM336: "Stone Sofa A",
  T_43_YU_WS_ITEM337: "Futuristic Switch A",
  T_43_YU_WS_ITEM338: "Futuristic Pipe A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Futuristic Table A",
  T_43_YU_WS_ITEM341: "Futuristic Table B",
  T_43_YU_WS_ITEM342: "Futuristic Table C",
  T_43_YU_WS_ITEM343: "Futuristic Computer A",
  T_43_YU_WS_ITEM344: "Stone A",
  T_43_YU_WS_ITEM345: "Stone B",
  T_43_YU_WS_ITEM346: "Stone C",
  T_43_YU_WS_ITEM347: "Stone D",
  T_43_YU_WS_ITEM348: "Stone E",
  T_43_YU_WS_ITEM349: "Stone F",
  T_43_YU_WS_ITEM350: "Stone G",
  T_43_YU_WS_ITEM351: "Japanese-Style Curtain A",
  T_43_YU_WS_ITEM352: "Japanese-Style Curtain B",
  T_43_YU_WS_ITEM353: "Japanese-Style Curtain C",
  T_43_YU_WS_ITEM354: "Japanese-Style Stairs A",
  T_43_YU_WS_ITEM355: "Japanese-Style Fence A",
  T_43_YU_WS_ITEM356: "Japanese-Style Fence B",
  T_43_YU_WS_ITEM357: "Japanese-Style Fence C",
  T_43_YU_WS_ITEM358: "Japanese-Style Platform A",
  T_43_YU_WS_ITEM359: "Japanese-Style Wall B",
  T_43_YU_WS_ITEM360: "Japanese-Style Gate B",
  T_43_YU_WS_ITEM361: "Futuristic Wall D",
  T_43_YU_WS_ITEM362: "Futuristic Wall B",
  T_43_YU_WS_ITEM363: "Futuristic Angled Baseboard",
  T_43_YU_WS_LEFTCOLOR: "Warna Kiri",
  T_43_YU_WS_LEFTCOLOR_D: "Warna sisi kiri",
  T_43_YU_WS_LEFTPLAYERARRAY: "Array Pemain Kiri",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "Array pemain kiri",
  T_43_YU_WS_LEFTSCORE: "Skor Kiri",
  T_43_YU_WS_LEFTSCORE_D: "Skor sisi kiri",
  T_43_YU_WS_LEFTSCOREAFTER: "Skor Kiri Setelah",
  T_43_YU_WS_LEFTSCOREAFTER_D: "Skor akhir di sisi kiri. Gunakan di animasi transisi skor.",
  T_43_YU_WS_LEVELOBJECTID: "ID Obyek Level",
  T_43_YU_WS_LEVELOBJECTID_D: "Mendeskripsikan tipe obyek. Membutuhkan parsing melalui konfigurasi SceneEditPrefab sebelum loading.",
  T_43_YU_WS_LOCALPOSITION_D: "Koordinat di sistem koordinat lokal",
  T_43_YU_WS_LOCALPOSITION_D1: "Posisi relatif",
  T_43_YU_WS_LOCALPOSITION_D2: "Posisi sesuai dengan anchor bawah kanan",
  T_43_YU_WS_LOCALPOSITION_D3: "Posisi relatif terhadap anchor",
  T_43_YU_WS_LOCALROTATION_D: "Sudut rotasi di sistem koordinat lokal (X: yaw, Y: pitch, Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "Quaternion di sistem koordinat lokal",
  T_43_YU_WS_LOCALSCALE_D: "Ukuran skala di sistem koordinat global",
  T_43_YU_WS_MASS: "Berat",
  T_43_YU_WS_MATERIALS: "Material",
  T_43_YU_WS_MATERIALS_D: "Daftar bahan untuk rendering",
  T_43_YU_WS_MAXSPEED: "Kecepatan Maks.",
  T_43_YU_WS_MAXSPEED_D: "Tidak ada horsepower yang akan dibuat saat kecepatan maksimum tercapai, namun kecepatan bisa melibihi batas (contoh: saat akselerasi menuruni landaian, dll)",
  T_43_YU_WS_MESHID: "ID Mesh",
  T_43_YU_WS_MESHID_D: "Mendeskripsikan tipe mesh",
  T_43_YU_WS_MESHID1: "ID Mesh",
  T_43_YU_WS_MESHID1_D: "Mesh digunakan untuk rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "Jarak Gerak Min.",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Gerakan dengan jarak yang lebih pendek dari ini tidak akan dieksekusi. Direkomendasikan 0 kecuali ada syarat khusus.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animasi",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Atribut Dasar",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Behavior Tree",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Kamera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Channel Chat",
  T_43_YU_WS_MODULE_CHECKPOINT: "Checkpoint",
  T_43_YU_WS_MODULE_COLLECTION: "Koleksi",
  T_43_YU_WS_MODULE_COMBAT: "Pertarungan",
  T_43_YU_WS_MODULE_COMPONENT: "Komponen",
  T_43_YU_WS_MODULE_CONVERT: "Konversi",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Ubah Parameter Room",
  T_43_YU_WS_MODULE_DATABASE: "Penyimpanan Data",
  T_43_YU_WS_MODULE_DYEING: "Warnai",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dynamic NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Ekonomi",
  T_43_YU_WS_MODULE_FF_PLATFORM: "Platform FF",
  T_43_YU_WS_MODULE_FOOTBALL: "Sepakbola",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Mode Frame Rate",
  T_43_YU_WS_MODULE_GAMERESULT: "Perhitungan Poin",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Skrip Global",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Cheating",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Input",
  T_43_YU_WS_MODULE_ITEMS: "Item",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Obyek Level",
  T_43_YU_WS_MODULE_LIST: "Daftar",
  T_43_YU_WS_MODULE_MAP: "Map",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Parameter Mekanisme",
  T_43_YU_WS_MODULE_MINIMAP: "Minimap",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Lainnya",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Fisika",
  T_43_YU_WS_MODULE_PLAYABLE: "Bisa Dimainkan",
  T_43_YU_WS_MODULE_PLAYER: "Pemain",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Skrip Pemain",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Karakter Preset",
  T_43_YU_WS_MODULE_PROFILE: "Debug",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Formula Properti",
  T_43_YU_WS_MODULE_SAFEZONE: "Zona Aman",
  T_43_YU_WS_MODULE_SCENE: "Skenario",
  T_43_YU_WS_MODULE_SKILL: "Skill",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Skrip Statik",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Lapor",
  T_43_YU_WS_MODULE_STDLIBRARY: "Perpustakaan STD",
  T_43_YU_WS_MODULE_STRINGS: "String",
  T_43_YU_WS_MODULE_TEAM: "Tim",
  T_43_YU_WS_MODULE_WORKFLOW: "Workflow",
  T_43_YU_WS_MONEYICON: "Ikon Uang",
  T_43_YU_WS_MONEYICON_D: "Ikon mata uang",
  T_43_YU_WS_MONEYICONCOLOR: "Warna Ikon Uang",
  T_43_YU_WS_MONEYICONCOLOR_D: "Warna ikon mata uang",
  T_43_YU_WS_MOVESAFEZONE_D: "Menggerakan zona aman dengan mulus dari posisi awal hingga akhir. Pemain di luar zona akan menerima damage.",
  T_43_YU_WS_NEWVECTOR2: "Vector2 Baru",
  T_43_YU_WS_NEWVECTOR2_D: "Dapatkan vector 2D baru",
  T_43_YU_WS_OFFSET_D: "Posisi global offset sesuai dengan entitas target",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "Saat permintaan membeli pemain ditemukan",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "Saat pemain meminta bantuan untuk membeli di toko",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Trigger saat status komponen Toggle berubah",
  T_43_YU_WS_OPENSTATE: "Open State",
  T_43_YU_WS_OPENSTATE_D: "Tunjukkan saat dibuat true dan hilang jika tidak",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "Daftar parameter",
  T_43_YU_WS_PARENT_D: "ID entitas yang direkam saat serialisasi",
  T_43_YU_WS_PHYSICALCCT: "CCT Fisik",
  T_43_YU_WS_PHYSICALCCT_D: "Pemain pengontrol dengan efek fisik",
  T_43_YU_WS_PLAYER_D: "Pemain membeli",
  T_43_YU_WS_PLAYERDATAID: "ID Data Pemain",
  T_43_YU_WS_PLAYERDATAID_D: "ID kustomisasi aset karakter",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Tipe Pose PhysX Pemain",
  T_43_YU_WS_POSITION: "Posisi",
  T_43_YU_WS_POSITION_D: "Koordinasi di sistem koordinasi global",
  T_43_YU_WS_POSITION_D1: "Koordinat di sistem koordinat global. Hanya efektif untuk musik 3D.",
  T_43_YU_WS_PRESSEDSPRITE: "Sprite Ditekan",
  T_43_YU_WS_PRESSEDSPRITE_D: "Sprite yang ditekan",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Tipe Sprite Ditekan",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "Tipe sprite yang ditekan",
  T_43_YU_WS_PRETIME: "Pretime",
  T_43_YU_WS_RADIUS: "Radius",
  T_43_YU_WS_RANDOMRANGE_D: "Betulkan posisi berdasarkan jarak random",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Tipe Permintaan Membeli",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Permintaan membeli di toko",
  T_43_YU_WS_REQUESTTYPE: "Tipe Permintaan",
  T_43_YU_WS_REQUESTTYPE_D: "Tipe target yang diminta oleh pemain HUD sekarang",
  T_43_YU_WS_RESPLAYERUUID: "Tipe Preset Pemain",
  T_43_YU_WS_RESPLAYERUUID_D: "ID aset pemain",
  T_43_YU_WS_RESUUID: "UUID Aset",
  T_43_YU_WS_RESUUID_D: "Memberikan UUID untuk aset Batch yang akan di-render",
  T_43_YU_WS_RIGHTCOLOR: "Warna Kanan",
  T_43_YU_WS_RIGHTCOLOR_D: "Warna sisi kanan",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Array Pemain Kanan",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "Array pemain kanan",
  T_43_YU_WS_RIGHTSCORE: "Skor Kanan",
  T_43_YU_WS_RIGHTSCORE_D: "Skor sisi kanan",
  T_43_YU_WS_RIGHTSCOREAFTER: "Skor Kanan Setelah",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "Skor akhir di sisi kanan. Digunakan di animasi transisi skor.",
  T_43_YU_WS_ROTATIONQ_D: "Quaternion di sistem koordinat global",
  T_43_YU_WS_ROUNDINFOHUD: "HUD Info Ronde",
  T_43_YU_WS_ROUNDINFOHUD_D: "Informasi ditunjukkan di awal ronde",
  T_43_YU_WS_SELECTEDCOLOR: "Warna Terpilih",
  T_43_YU_WS_SELECTEDCOLOR_D: "Warna sprite yang dipilih",
  T_43_YU_WS_SELECTEDSPRITE: "Sprite Terpilih",
  T_43_YU_WS_SELECTEDSPRITE_D: "Sprite terpilih",
  T_43_YU_WS_SELECTEDTYPE: "Tipe Terpilih",
  T_43_YU_WS_SELECTEDTYPE_D: "Tipe sprite yang dipilih",
  T_43_YU_WS_SHADOWCOLOR: "Warna Bayangan",
  T_43_YU_WS_SHADOWOFFSET: "Offset Shadow",
  T_43_YU_WS_SHOWTAG: "Tunjukkan Tag",
  T_43_YU_WS_SHOWTAG_D: "Tunjukkan tanda tim/fraksi",
  T_43_YU_WS_SHRINKDURATION_D: "Durais mengecil zona aman",
  T_43_YU_WS_SIMPLERENDER_D: "Komponen rendering bridging digunakan untuk render model built-in",
  T_43_YU_WS_SKINWIDTH: "Lebar Skin",
  T_43_YU_WS_SKINWIDTH_D: "Kedalaman penetrasi ke dalam kapsul agar karakter tidak terjebak atau jitter",
  T_43_YU_WS_SLOPELIMIT: "Batasan Slope",
  T_43_YU_WS_SLOPELIMIT_D: "Obyek ditaruh di landaian melebihi sudut ini akan meluncur jatuh",
  T_43_YU_WS_SPEED: "Kecepatan",
  T_43_YU_WS_STARTDROPTIME_D: "Waktu sampai airdrop dalam milidetik",
  T_43_YU_WS_STARTPOS_D: "Posisi mulai zona aman",
  T_43_YU_WS_STATICICONCOLORS: "Warna Ikon Statik",
  T_43_YU_WS_STATICICONCOLORS_D: "Warna ikon yang ditunjukkan di penggaris",
  T_43_YU_WS_STATICICONS: "Ikon Statik",
  T_43_YU_WS_STATICICONS_D: "Ikon yang ditunjukkan di penggaris",
  T_43_YU_WS_STEPOFFSET: "Offset Langkah",
  T_43_YU_WS_STEPOFFSET_D: "Hanya rintangan yang melibihi tinggi ini akan memiliki efek memblokir",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "Subtitle",
  T_43_YU_WS_TARGET: "Target",
  T_43_YU_WS_TARGET_D: "Entitas target untuk angka damage yang ditunjukkan",
  T_43_YU_WS_TARGETICONCOLORS: "Warna Ikon Target",
  T_43_YU_WS_TARGETICONCOLORS_D: "Warna ikon ditunjukkan oleh target ditandai",
  T_43_YU_WS_TARGETICONS: "Ikon Target",
  T_43_YU_WS_TARGETICONS_D: "Ikon ditunjukkan oleh target ditandai",
  T_43_YU_WS_TARGETPOS_D: "Target posisi akhir zona aman",
  T_43_YU_WS_TEAM: "Tim",
  T_43_YU_WS_TEAM_D: "Entitas tim di dalam game. Setiap tim memiliki satu entitas.",
  T_43_YU_WS_TEAM_D1: "Minta tim untuk membantu membeli",
  T_43_YU_WS_TIMEOFSTAY_D: "Tunjukkan durasi di milisekon",
  T_43_YU_WS_TITLE: "Judul",
  T_43_YU_WS_TITLE_D: "Judul utama",
  T_43_YU_WS_TRANSFORM_D: "Rotasi, skala dan rekor parent-child",
  T_43_YU_WS_UNSELECTEDCOLOR: "Warna Tidak Terpilih",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "Warna sprite tidak dipilih",
  T_43_YU_WS_UNSELECTEDSPRITE: "Sprite Tidak Terpilih",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "Sprite tidak terpilih",
  T_43_YU_WS_UNSELECTEDTYPE: "Tipe Tidak Terpilih",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Tipe sprite tidak terpilih",
  T_43_YU_WS_USEPHYSICALCCT: "Gunakan CCT Fisik",
  T_43_YU_WS_VALUE_D: "Konten ditunjukkan",
  T_43_YU_WS_VECTOR2ADD: "Tambah Vector2",
  T_43_YU_WS_VECTOR2GETX: "Dapatkan X Vector2",
  T_43_YU_WS_VECTOR2GETY: "Dapatkan Y Vector2",
  T_43_YU_WS_VECTOR2SCALE: "Skala Vector2",
  T_43_YU_WS_VECTOR2SETX: "Atur X Vector2",
  T_43_YU_WS_VECTOR2SETY: "Atur Y Vector2",
  T_43_YU_WS_VECTOR2SUB: "Sub Vector2",
  T_43_YU_WS_VELOCITY: "Kecepatan",
  T_43_YU_WS_VERTICALMAXANGLE: "Sudut Maks Vertikal",
  T_43_YU_WS_VERTICALMINANGLE: "Sudut Min Vertikal",
  T_43_YU_WS_VISIBILITY_D: "Indikasikan apakah visibilitas bisa diatur",
  T_43_YU_WS_VISIBLE_D: "Pengaturan visibilitas. Jika dibuat tidak terlihat, klien akan berhenti render target.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "High-Tech Wall A",
  T_43_ZY_WS_ITEM320: "Futuristic Wall C",
  T_43_ZY_WS_ITEM321: "Futuristic Window",
  T_43_ZY_WS_ITEM322: "Futuristic Door",
  T_43_ZY_WS_ITEM323: "Futuristic Angled Roof",
  T_43_ZY_WS_ITEM324: "Futuristic Circular Roof",
  T_43_ZY_WS_ITEM325: "Futuristic Baseboard",
  T_43_ZY_WS_ITEM326: "Futuristic Circular Baseboard",
  T_43_ZY_WS_ITEM327: "Futuristic Stairs",
  T_43_ZY_WS_ITEM328: "Futuristic Decoration A",
  T_43_ZY_WS_ITEM329: "Futuristic Building A",
  T_43_ZY_WS_ITEM330: "Futuristic Building B",
  T_44_CJ_M_B_SPORT_TH: "Gym Uniform (Bottom)",
  T_44_CJ_M_H_SPORT_TH: "Gym Uniform (Head)",
  T_44_CJ_M_S_SPORT_TH: "Gym Uniform (Shoes)",
  T_44_CJ_M_T_SPORT_TH: "Gym Uniform (Top)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motorbike - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Mulai Paksa dengan Pemain Min.",
  T_44_JH_WS_HALFWAYKEY1: "Prioritaskan Mulai dengan Tim Penuh",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_QL_GRENADE_DRAGON: "Dragon Freeze",
  T_44_QL_GRENADE_DRAGON_DES: "Flash Freeze baru yang akan meledak tiga kali secara beruntun setelah penggunaan",
  T_44_QL_JUMPSHOESX: "Dragon Sprinters",
  T_44_QL_JUMPSHOESX_DES: "Sepatu spesial yang membuat pengguna bisa berjalan di udara saat double jump",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Waktu Tutup Zona Aman",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Waktu saat Zona aman hilang. Jika Waktu Tutup Zona Aman lebih pendek daripada Waktu Mulai Zona Aman, tidak akan ada Zona Aman yang muncul.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Warna Zona Aman",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Jarak Waktu Damage",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Jarak waktu damage",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Nilai Damage",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "Damage diberikan ke pemain di luar zona dalam satu instansi",
  T_44_SJ_WS_SAFEZONE_DESC: "Obyek yang bisa ditaruh di luar zona",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Radius Akhir Luar Zona",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "Radius akhir area luar zona",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Daftar Pemain Zona Aman",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Dapatkan daftar pemain di dalam Zona Aman",
  T_44_SJ_WS_SAFEZONE_NAME: "Area luar zona",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Durasi Pengecilan (dtk)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Waktu yang dibutuhkan untuk zona aman mengecil",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Radius Awal Luar Zona",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Radius awal area luar zona",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Waktu Mulai Pengecilan",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Waktu zona mulai mengecil",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Waktu Mulai Zona Aman",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Waktu saat zona aman muncul setiap ronde dalam match. Default adalah 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Alpha Aktif",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Alpha aktif",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "HUD Tombol Skill Aktif",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Tambahkan komponen ke entitas. Hanya mendukung komponen custom. (Komponen tidak akan ditambahkan lagi jika sudah ada.)",
  T_44_XXJ_WS_ALLMEMBERS: "Semua Anggota",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Bisa Ditekan Dari Luar",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Bisa trigger di luar area yang sudah dipilih",
  T_44_XXJ_WS_ARROWIMAGE: "Gambar Panah",
  T_44_XXJ_WS_ARROWIMAGE_D: "Gambar panah",
  T_44_XXJ_WS_ARROWOFFSET: "Offset Panah",
  T_44_XXJ_WS_ARROWOFFSET_D: "Offset panah",
  T_44_XXJ_WS_ARROWSIZE: "Ukuran Panah",
  T_44_XXJ_WS_ARROWSIZE_D: "Ukuran panah",
  T_44_XXJ_WS_AUTOPLAY_D: "Mainkan secara otomatis setelah pembuatan",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Gambar Background",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Gambar dasar",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Radius Background",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Radius awal",
  T_44_XXJ_WS_BAGSKINID: "ID Skin Backpack",
  T_44_XXJ_WS_BAGSKINID_D: "ID skin backpack",
  T_44_XXJ_WS_BONEPOSITION: "Posisi Bone",
  T_44_XXJ_WS_BONEPOSITION_D: "Koordinat global pada node bone",
  T_44_XXJ_WS_CCTMOVE: "Gerakkan CCT",
  T_44_XXJ_WS_COLLIDER: "Collider",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collider Collection",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "Komponen digunakan untuk mendeskripsikan bentuk collision",
  T_44_XXJ_WS_COLOR: "Warna",
  T_44_XXJ_WS_CONTENT: "Konten",
  T_44_XXJ_WS_CONTENT_D: "Konten wallet adalah kumpulan dari mata uang",
  T_44_XXJ_WS_CONTEXT_D: "Konten untuk di-print",
  T_44_XXJ_WS_CROSSHAIRSHUD: "HUD Crosshair",
  T_44_XXJ_WS_CURVE_D: "Kurva",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Warna dari tekstur permukaan",
  T_44_XXJ_WS_ENABLE: "Nyalakan",
  T_44_XXJ_WS_ENTITY_D: "Entitas",
  T_44_XXJ_WS_GETBAGSKINID_D: "Dapatkan konfigurasi skin backpack pemain",
  T_44_XXJ_WS_GETFACTION_D: "Dapatkan fraksi",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Dapatkan loaded scene yang belum di-uninstall",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Dapatkan pemain lokal",
  T_44_XXJ_WS_GROUPID: "ID Grup",
  T_44_XXJ_WS_GROUPID_D: "Untuk logik internal",
  T_44_XXJ_WS_HUDJOYSTICK: "Widget HUD Joystick",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Entitas joystick. Pemain bisa edit HUD ini di Editor HUD.",
  T_44_XXJ_WS_HUDTOUCHPAD: "Widget HUD Touchpad",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "Widget HUD Touchpad yang pemain bisa edit di editor HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "HUD Custom atau HUD Widget",
  T_44_XXJ_WS_ICON: "Ikon",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Selalu Tunjukkan Tanda",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Selalu tunjukkan tanda di kompas",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Alpha Tidak Aktif",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Alpha tidak aktif",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "Saat dipanggil, angka dari parametere asli tidak akan sesuai dengan parameter formal. Nomor yang keluar adalah {0}, namun aslinya adalah {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Adalah Rintangan Dinamis",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Adalah rintangan dinamis untuk NavMesh",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Adalah Server-Driven",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "Jika false, obyek kustom tidak bisa dikontrol oleh API.",
  T_44_XXJ_WS_ISSUC_D: "Dapatkan hasil eksekusi",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Radius Drag Joystick",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Radius drag joystick",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Gambar Joystick",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Gambar joystick",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Radius Joystick",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Radius joystick",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Daftar ID Skill Karakter",
  T_44_XXJ_WS_LOOPTYPE_D: "Tipe loop",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Konfigurasi Keluar Tengah Match",
  T_44_XXJ_WS_MOUNTABLE: "Hierarchical",
  T_44_XXJ_WS_MOUNTABLE_D: "Entitas yang bisa mount child node",
  T_44_XXJ_WS_MOVEMENT: "Gerakan",
  T_44_XXJ_WS_NAME_D: "Nama",
  T_44_XXJ_WS_NATURALCONST: "Konstan Natural",
  T_44_XXJ_WS_NATURALCONST_D: "Enum dari konstan natural untuk mengurangi definisi yang tidak dibutuhkan",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Animasi ikon play",
  T_44_XXJ_WS_OFFSET_D: "Offset base default",
  T_44_XXJ_WS_ONFIRE_D: "Trigger event setiap kali pemain menembak, menyerang dengan fist atau senjata melee.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Trigger event saat pemain berdiri dari posisi jongkok/tiarap",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Trigger event saat pemain menekan tombol menembak",
  T_44_XXJ_WS_OPTION: "Pengaturan",
  T_44_XXJ_WS_PASSIVESKILLHUD: "HUD Skill Pasif",
  T_44_XXJ_WS_PHYSICALMOVER: "Penggerak Fisik",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Pemain pada platform ini akan mengikuti gerakan dan rotasi secara otomatis",
  T_44_XXJ_WS_PHYSICALOBJECT: "Obyek Fisik",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Bisa memberikan gaya kepadanya",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "Konstan matematika π (Pi)",
  T_44_XXJ_WS_PLAYERS: "Daftar Pemain",
  T_44_XXJ_WS_PLAYERS_D: "Daftar pemain",
  T_44_XXJ_WS_PLAYERSKILLID: "ID Skill Karakter",
  T_44_XXJ_WS_PLAYERSKILLID_D: "ID skill karakter di AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "Pose sebelum pemain berdiri",
  T_44_XXJ_WS_PRINT: "Print",
  T_44_XXJ_WS_PRINTERROR: "Print Error",
  T_44_XXJ_WS_PRINTERROR_D: "Print data target sebagai error ke console",
  T_44_XXJ_WS_PRINTWARNING: "Cetak Peringatan",
  T_44_XXJ_WS_PRINTWARNING_D: "Print data target sebagai peringatan ke console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioritaskan Konfigurasi Skin Pemain",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioritaskan konfigurasi skin pemain di luar match",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Baca konten di cell sebuah row sesuai dengan nomor kolom dan key",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Hapus konfigurasi skin backpack pemain",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Hapus komponen dari entitas. Hanya mendukun komponen custom.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset konfigurasi skin backpack pemain ke konfigurasi luar match",
  T_44_XXJ_WS_SETBAGSKINID_D: "Atur konfigurasi skin backpack pemain",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entitas yang mendukung komponen Transform, SkeletonPart, Pemain dan MountPoint",
  T_44_XXJ_WS_SHOWBACKGROUND: "Tunjukkan Background",
  T_44_XXJ_WS_SKINID_D: "ID skin backpack dan konfigurasi skin",
  T_44_XXJ_WS_SPEED_D: "Kecepatan playback",
  T_44_XXJ_WS_TARGET: "Target",
  T_44_XXJ_WS_TARGET_D: "Obyek target",
  T_44_XXJ_WS_TITLE: "Judul",
  T_44_XXJ_WS_TYPEID_D: "ID tipe komponen. Hanya mendukung komponen custom.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Upload hasil custom match",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Tipe tidak sesuai. Tidak bisa membaca konten tabel.",
  T_44_XXJ_WS_X_D: "Koordinat x-axis",
  T_44_XXJ_WS_Y_D: "Koordinat y-axis",
  T_44_XYL_WS_CTZSAFEZONE: "Zona Aman Custom",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Membuat titik awal dan akhir Zona Aman berdasarkan posisi dan properti yang diatur",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Hemispherical Shell",
  T_44_XYL_WS_QUARTERCYLINDER: "Silinder Seperempat",
  T_44_XYL_WS_SQUAREPYRAMID: "Piramida Segi Empat",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Piramida Segitiga",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Tambahkan Peta Event Log Game",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Tambakan Log Event User",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "Log event custom match digunakan untuk analisis data UX",
  T_44_YU_WS_ITEM366: "Military Wall A",
  T_44_YU_WS_ITEM367: "Military Wall B",
  T_44_YU_WS_ITEM368: "Military Wall C",
  T_44_YU_WS_ITEM369: "Military Wall D",
  T_44_YU_WS_ITEM370: "Military Window A",
  T_44_YU_WS_ITEM371: "Military Window B",
  T_44_YU_WS_ITEM372: "Military Window C",
  T_44_YU_WS_ITEM373: "Military Door A",
  T_44_YU_WS_ITEM374: "Military Door B",
  T_44_YU_WS_ITEM375: "Military Angled Roof A",
  T_44_YU_WS_ITEM376: "Military Angled Roof B",
  T_44_YU_WS_ITEM377: "Military Stairs A",
  T_44_YU_WS_ITEM378: "Military Stairs B",
  T_44_YU_WS_ITEM379: "Military Pillar A",
  T_44_YU_WS_ITEM380: "Military Handrail A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Ubah",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Champion's Walk",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Periksa",
  T_45_HL_Moderation_fail_1: "Sayangnya, proyek yang kamu berikan tidak lulus pengecekan.",
  T_45_HL_Moderation_fail_2: "termasuk",
  T_45_HL_Moderation_fail_3: "Alasan termasuk:",
  T_45_HL_Moderation_fail_Location_1: "Konten Game",
  T_45_HL_Moderation_fail_reason_1: "Konten Toxic",
  T_45_HL_Moderation_fail_reason_10: "Pelanggaran Pedoman Komunitas",
  T_45_HL_Moderation_fail_reason_11: "Efek Negatif terhadap Ekonomi In-Game dan Pelanggaran Properti Virtual",
  T_45_HL_Moderation_fail_reason_2: "Konten Tidak Pantas",
  T_45_HL_Moderation_fail_reason_3: "Isu Politik",
  T_45_HL_Moderation_fail_reason_4: "Informasi Palsu",
  T_45_HL_Moderation_fail_reason_5: "Pelanggaran Hak Cipta",
  T_45_HL_Moderation_fail_reason_6: "Pelanggaran Pribadi",
  T_45_HL_Moderation_fail_reason_7: "Isu Keamanan",
  T_45_HL_Moderation_fail_reason_8: "Ucapan Kebencian",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Isu lainnya",
  T_45_JH_WS_CLEMPTYOBJECT: "Grup Obyek",
  T_45_JH_WS_PETSWITCH1: "Apakah menunjukkan pet di dalam match",
  T_45_QL_CSFPP_DES: "Eliminasi semua musuh melalui perspektif first-person di mode spesial CS ini!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "First-Person",
  T_45_SJ_WS_REVIEW_23: "Konten Game",
  T_45_SJ_WS_REVIEW_24: "{0} menyangkut {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} menyangkut {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Tekan untuk melihat detil >>[-]",
  T_45_SJ_WS_REVIEW_27: "Tidak Disetujui",
  T_45_SJ_WS_REVIEW_28: "Review Masukan",
  T_45_SJ_WS_REVIEW_29: "Konten mengandung {0} pelanggaran",
  T_45_SJ_WS_REVIEW_31: "Tidak Disetujui",
  T_45_SJ_WS_REVIEW_32: "Gagal review karena pengecualian server",
  T_45_SJ_WS_REVIEW_TITLE: "Detil Pelanggaran",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Trigger vaulting (melompati penghalang)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Jarak Vault",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Ubah jarak vaulting",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Tinggi Vault",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Kontrol ketinggian gerakan ke atas dan bawah saat vaulting",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Trigger Vault",
  T_45_TYC_CL_TEMPLATE_WS: `Eliminasi semua tim musuh di pertarungan ini untuk menang.
Kamu bisa mengatur peraturan dan mengedit parameter bermain sesukamu.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = auto attack, 1 = defensive attack, 2 = do not attack",
  T_45_XXJ_WS_ADDFRIEND: "Tambah Teman",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Data Dasar",
  T_45_XXJ_WS_BOTH: "Keduanya",
  T_45_XXJ_WS_BYHIERARCHY: "By Hierarchy",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "By Priority Low to High",
  T_45_XXJ_WS_CAMERA: "Kamera",
  T_45_XXJ_WS_CAMERATYPE: "Tipe Kamera",
  T_45_XXJ_WS_CENTERINVISIBLE: "Center Tidak Terlihat",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "ID Collider",
  T_45_XXJ_WS_COLLIDERID_D: "ID collider",
  T_45_XXJ_WS_COMPONENT: "Komponen",
  T_45_XXJ_WS_CURRENTCAMERA: "Kamera Sekarang",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Gaya Mendorong Custom",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Lempar",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Aktifkan Gerakan di Udara",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Aktifkan Rotasi dengan Gravitasi",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Event",
  T_45_XXJ_WS_FILLAMOUNT: "Jumlah Fill",
  T_45_XXJ_WS_FILLDIR: "Arah Fill",
  T_45_XXJ_WS_FIRETYPE: "Tipe Tembakan",
  T_45_XXJ_WS_FIRETYPE_D: "Tipe menembak",
  T_45_XXJ_WS_FIXEDDELTATIME: "Waktu Delta Tetap",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "Interval waktu tetap untuk frame update dalam milidetik",
  T_45_XXJ_WS_FORWARD: "Maju",
  T_45_XXJ_WS_FORWARD_D: "Arah axis-z di sistem koordinat lokal",
  T_45_XXJ_WS_FUNCTIONTYPE: "Tipe Function",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "Tipe fungsi",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "Arah aim untuk pemain lokal",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Dapatkan waktu lokal",
  T_45_XXJ_WS_GRADIENT: "Gradien",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradien Bawah",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Alpha Gradien Bawah",
  T_45_XXJ_WS_GRADIENTTOP: "Gradien Atas",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Alpha Gradien Atas",
  T_45_XXJ_WS_HITPOSITION_D: "Posisi global dari target yang terkena peluru",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "Widget UI Tombol Sosial",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "Adalah Grounded",
  T_45_XXJ_WS_ISSILENCE: "Is Silence",
  T_45_XXJ_WS_ISSILENCE_D: "Apakah silenced atau tidak",
  T_45_XXJ_WS_ISSINGLESHOT: "Is Single Shot",
  T_45_XXJ_WS_ISSINGLESHOT_D: "Apakah single shot atau tidak",
  T_45_XXJ_WS_JUMPHEIGHT: "Tinggi Lompatan",
  T_45_XXJ_WS_JUMPHEIGHT_D: "Ketinggian lompat",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Tipe Sortir Layout",
  T_45_XXJ_WS_LIGHT_D: "Cahaya",
  T_45_XXJ_WS_LOCAL: "Lokal",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Jumlah Lompatan Maks.",
  T_45_XXJ_WS_MODULE: "Modul",
  T_45_XXJ_WS_NONE: "Tidak Ada",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Lakukan perintah setiap kali entitas memberikan damage",
  T_45_XXJ_WS_ONDISABLE_D: "Jalankan saat entitas dimatikan",
  T_45_XXJ_WS_ONEACHLOOP_D: "Jalankan setiap Playable sedang loop. Hanya efektif di sisi klien untuk entitas seperti Efek Suara dan Efek Spesial.",
  T_45_XXJ_WS_ONENABLE_D: "Jalankan saat entitas diaktifkan",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "Saat memasuki frame dengan rate tetap 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Trigger event klien saat pemain menambah atau menghapus teman",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Trigger event saat game pause karena API terpanggil",
  T_45_XXJ_WS_ONGAMERESUME_D: "Trigger event saat game lanjut karena API yang dipanggil",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "Saat pemain berhenti berlari",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "Saat pemain berhenti berseluncur",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "Saat pemain berseluncur",
  T_45_XXJ_WS_PHYSICALLAYER_D: "Layer fisik custom dengan jarak 0 hingga 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Tipe Platform",
  T_45_XXJ_WS_PLATFORMTYPE_D: "Tipe platform",
  T_45_XXJ_WS_PLAYER: "Pemain",
  T_45_XXJ_WS_PLAYERCCT: "CCT Pemain",
  T_45_XXJ_WS_PLAYERCCT_D: "Kontroler karakter dengan efek fisik dan digunakan untuk karakter Free Fire saja",
  T_45_XXJ_WS_PRIORITY: "Prioritas",
  T_45_XXJ_WS_REMAINMULTINUM: "Jumlah Lompatan Tersisa",
  T_45_XXJ_WS_REPORT: "Lapor",
  T_45_XXJ_WS_RIGHT: "Kanan",
  T_45_XXJ_WS_RIGHT_D: "Arah axis-x di sistem koordinat lokal",
  T_45_XXJ_WS_SERVER: "Server",
  T_45_XXJ_WS_SINGLE: "Single",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Tipe Gaya Tombol Sosial",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "Gaya tombol sosial",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Tipe Tombol Sosial",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "Tipe tombol sosial",
  T_45_XXJ_WS_SORTTYPE_D: "Tipe sort: Ascending non-zero, descending dan ascending",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Kecepatan Gerak Saat ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "Kecepatan gerak saat melakukan scope dalam aim",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String atau Localized String",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Atas",
  T_45_XXJ_WS_UP_D: "Arah axis-y di sistem koordinat lokal",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Gunakan Gaya Dorong Custom",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Lempar sinyal ke area dipilih untuk memunculkan kendaraan random",
  T_45_ZD_VEHICLEDROP_R_NAME: "Kendaraan Misterius",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Waktu Bermain",
  T_46_HJ_WS_SHAREBY: "Dengan {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Mode Game",
  T_46_HJ_WS_SHARETEAM: "Tim",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "Top of Class (Bottom)",
  T_46_HX_H_SCHOOL_VN: "Top of Class (Head)",
  T_46_HX_S_SCHOOL_VN: "Top of Class (Shoes)",
  T_46_HX_T_SCHOOL_VN: "Top of Class (Top)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Lainnya",
  T_46_XXJ_WS_ACTUALPOSITION: "Posisi Asli",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Berikan obyek untuk dimonitor dengan sinkronisasi AOI melebihi garas pandang",
  T_46_XXJ_WS_APPEARANCE: "Penampilan",
  T_46_XXJ_WS_APPEARANCERES: "Sumber Penampilan",
  T_46_XXJ_WS_BECOME: "Aktifkan",
  T_46_XXJ_WS_BRAKETORQUE_D: "Horsepower diberikan untuk kendaraan saat Rem/Mundur digunakan",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Tipe Batasan Sudut Rotasi Kamera",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Hapus semua obyek yang dimonitor dari target",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "Damage tabrakan maksimum digunakan untuk perhitungan damage",
  T_46_XXJ_WS_CRASHMAXSPEED: "Kecepatan Tabrakan Maks.",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Digunakan untuk perhitungan damage tabrakan. Saat melewati kecepatan ini, tidak ada damage lebih yang ditambahkan.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Faktor Berat Tabrakan",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "Parameter digunakan di formula damage untuk perhitungan damage tabrakan",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "Damage tabrakan minimum digunakan untuk perhitungan damage",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Batas baca dan menulis penyimpanan data telah dicapai",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Pengecualian parameter",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Timeout penyimpanan data. Sekarang hanya digunakan untuk membaca dan menulis.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Edit Penampilan",
  T_46_XXJ_WS_ENDVALUE_D: "Nilai destinasi",
  T_46_XXJ_WS_ENGINETORQUE_D: "Horsepower diberikan ke kendaraan saaat gas digunakan",
  T_46_XXJ_WS_ERRORCODE_D: "Enum kode error",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Sudut Eular ke Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Ubah sudut Eular menjadi vektor 3D",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Karakter Perempuan",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Dapatkan Tanggal Expire Membership",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "Jika penonton monitor obyek atau tidak",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "Tipe kendaraan terbang",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "Batasan Setir Kecepatan Tinggi",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "Sudut setir maksimum saat di status kecepatan tinggi",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "Sudut Setir Kecepatan Tinggi pada Kecepatan",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "Batas kecepatan untuk sudut maksimum setir kecepatan tinggi",
  T_46_XXJ_WS_IDLE: "Animasi Idle",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Idle Brake INput",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "Saat tidak mengendarai kendaraan, perlambat dengan (Idle Brake Input) x (Brake Torque)",
  T_46_XXJ_WS_INTTOFLOAT: "Int ke Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Ubah integer menjadi angka floating-point",
  T_46_XXJ_WS_ISPREMIUM: "Adalah Membership",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "Nama leaderboard di database",
  T_46_XXJ_WS_MALEAVATAR: "Karakter Laki-Laki",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "Persona AI",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "Penampilan UMA Baru",
  T_46_XXJ_WS_NONE_D: "Tidak ada error",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "Obyek NPC",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Tips: NPC Humanoid memiliki model tebrakan dengan kapsul dengan tinggi 1.4m dan radius 0.25m. NPC Pet memiliki model tabrakan dengan tinggi 1m dan radius 0.4m.",
  T_46_XXJ_WS_OBSERVER_D: "Penonton yang sedang monitor obyek",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "Saat Memasuki Membership Craftland",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "Saat Keluar Membership Craftland",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Buka Membership Craftland",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Persona Center",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Pemain atau Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "Alias untuk entitas Pemain dan Transform",
  T_46_XXJ_WS_PREMIUM: "Membership",
  T_46_XXJ_WS_PREMIUMSTATUS: "Status Membership",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Observer",
  T_46_XXJ_WS_PROXYOBSERVER_D: "Penonton proxy",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Hapus obyek yang di-monitor dan batalkan sinkronisasi AOI melewati batas pandang",
  T_46_XXJ_WS_RENEWAL: "Perbarui",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotasi Vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotasi vektor berdasarkan quaternion",
  T_46_XXJ_WS_SKIN: "Gear",
  T_46_XXJ_WS_STARTVALUE_D: "Nilai sumber",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Ubah proxy penonton dari pengguna",
  T_46_XXJ_WS_TARGET_D: "Target yang sedang di-monitor",
  T_46_XXJ_WS_USER_D: "Pengguna",
  T_46_XXJ_WS_VALUE: "Nilai",
  T_46_XXJ_WS_VALUE_D: "Vektor",
  T_46_XYL_WS_CTZSAFEZONEEND: "Titik Akhir Zona Aman",
  T_46_XYL_WS_RESOURCETYPE1: "Struktur Dasar",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometric",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual & Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Item Suasana",
  T_46_XYL_WS_RESOURCETYPE2_2: "Battle Supply",
  T_46_XYL_WS_RESOURCETYPE3: "Alam",
  T_46_XYL_WS_RESOURCETYPE4: "Komponen Modular",
  T_46_XYL_WS_TYPEOTHERPROP: "Lainnya",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Kontainer & Box",
  T_47_CJ_FOREGRIP_SOFT_N: "Foregrip Ringan",
  T_47_CJ_MAGEZINE_FAST_N: "Fast Mag",
  T_47_CJ_STOCK_FAST_N: "Stock Kuat",
  T_47_GT_WS_USERMANUAL: "Panduan Pengguna",
  T_47_HJ_WS_VFX_FOG: "VFX Embun",
  T_47_HJ_WS_VFX_LIGHTING: "VFX Cahaya",
  T_47_HJ_WS_VFX_TRAILING: "VFX Jejak",
  T_47_HL_CL_CREATOR_LABEL1: "Bakat Komunitas",
  T_47_HL_CL_MAP_LABEL1: "Pilihan Terpilih dari Bakat Komunitas",
  T_47_JH_WS_MODERATION_REASON12: "Terkait perjudian",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "Kolaborasi NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "File material",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "Hasil Map AI",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "Kunai spesial yang menempel setelah dilempar, membuat ledakan kecil yang memberikan damage membakar.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Kunai Api",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "Kunai spesial yang menempel setelah dilempar, membuat petir kecil untuk melumpuhkan musuh.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Kunai Petir",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "Kunai spesial yang menempel setelah dilempar, membuat badai untuk memperlambat musuh yang bergerak ke pusatnya.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Kunai Angin",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "Tipe shuriken cocok untuk pertarungan jarak menengah hingga jauh. Satu lemparan melakukan lemparan jarak jauh yang memberikan damage tinggi.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Heavy Shuriken",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "Tipe shuriken cocok untuk pertarungan jarak dekat hingga menengah dengan dua mode serangan. Satu lemparan mengeluarkan tiga bagian yang memberikan sedikit damage.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Light Shuriken",
  T_47_XXJ_WS_ACTION: "Aksi",
  T_47_XXJ_WS_AOISETTING: "Pengaturan AOI",
  T_47_XXJ_WS_BAGSKINTYPE: "Tipe Skin Backpack",
  T_47_XXJ_WS_CLEARMEMORY: "Hapus Memory",
  T_47_XXJ_WS_CLNPC: "NPC Advanced",
  T_47_XXJ_WS_CLOTHTYPE: "Tipe Skin Bundle",
  T_47_XXJ_WS_COMMON_ERROR: "Error Common",
  T_47_XXJ_WS_CONTENT: "Konten",
  T_47_XXJ_WS_CREATERANDOMSEED: "Buat Seed Random",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Persentase Terlewat",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Aktifkan Fitur Embun",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Aktifkan Fitur Rotasi Cahaya",
  T_47_XXJ_WS_ERRORCODE: "Kode Error",
  T_47_XXJ_WS_EXPONENTIAL: "Eksponensial",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponential Squared",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Gagal membuat room: tidak ada ID Persona valid",
  T_47_XXJ_WS_FOG: "Embun",
  T_47_XXJ_WS_FOGDENSITY: "Densitas Embun",
  T_47_XXJ_WS_FOGENDDISTANCE: "Jarak Akhir Embun",
  T_47_XXJ_WS_FOGMODE: "Mode Embun",
  T_47_XXJ_WS_FOGMODETYPE: "Tipe Mode Embun",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Jarak Mulai Embun",
  T_47_XXJ_WS_HEIGHTSCALE: "Skala Tinggi",
  T_47_XXJ_WS_ISVISIBLE: "Is Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Gabung Tim Baru",
  T_47_XXJ_WS_JOINTEAM: "Gabung Tim",
  T_47_XXJ_WS_LIGHTROTATE: "Rotasi Cahaya",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "UI Chat Persona",
  T_47_XXJ_WS_NEWTEAM: "Tim Baru",
  T_47_XXJ_WS_NEXT: "Lanjut",
  T_47_XXJ_WS_NPC_TIP: "Kamu bisa mengedit penampilan NPC dan membuat animasi bermain NPC",
  T_47_XXJ_WS_OBSERVERS: "Penonton",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "Saat Pemain Mengirim Pesan via UI Chat Persona",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "Saat Status Membership Berubah",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "Saat Mendapatkan Aksi dari Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "Saat Mendapatkan Konten dari Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "Saat Mendapatkan Selesai dari Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "Saat Mendapatkan Status dari Persona",
  T_47_XXJ_WS_PARTICLESID: "ID Partikel",
  T_47_XXJ_WS_PERSONAAVATAR: "Avatar Persona",
  T_47_XXJ_WS_PERSONAID: "ID Persona",
  T_47_XXJ_WS_PERSONANICKNAME: "Nickname Persona",
  T_47_XXJ_WS_PLAYERORNPC: "Pemain atau NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Membership Tutup",
  T_47_XXJ_WS_RANDOM: "Random",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Pengirim",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Atur Persona Penonton",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Atur Pemain Bisa Keluar Tengah Match",
  T_47_XXJ_WS_SHOULDREPLY: "Perlu Reply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Tunjukkan Balasan Sistem",
  T_47_XXJ_WS_SPOTANGLE: "Sudut Spot",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Kirim Pesan Sistem ke Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream Pesan Sistem ke Person",
  T_47_XXJ_WS_TARGETTEAM: "Tim Target",
  T_47_XXJ_WS_THISENTITY: "Entitas Ini",
  T_47_XXJ_WS_USERAVATAR: "Avatar User",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Kirim Pesan User ke Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream Pesan User ke Person",
  T_47_XXJ_WS_USERNICKNAME: "Nickname User",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Tipe Skin Kendaraan",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Tipe Skin Senjata",
  T_47_XYL_NB_UGC_EFFECT001: "VFX Rasengan",
  T_47_XYL_NB_UGC_EFFECT002: "VFX Chidori",
  T_47_XYL_NB_UGC_EFFECT003: "VFX Okasho",
  T_47_XYL_NB_UGC_EFFECT004: "Katon: Gokakyu no Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Suiton: Suiryudan no Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Futon: Daitoppa VFX",
  T_47_XYL_NB_UGC_EFFECT007: "VFX Bola Biju",
  T_47_XYL_NB_UGC_EFFECT008: "VFK Segel Kutukan Edo Tensei",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Toko Aset",
  T_47_XYL_UGC_DONKEYCART: "Donkey Cart",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Sudut Spotlight",
  T_48_H_EMOTE_WATERFEST25_N: "Swift Steps",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motorbike - Sea Foam",
  T_48_HJ_AC_STATENOTEXIST: "Status {0} tidak ada di kontroler animasi",
  T_48_HL_CODESCRIPT: "Code Script",
  T_48_HL_GLOBAL_VAR: "Nama Variabel Global",
  T_48_HL_GRAPH: "Block",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Leaderboard",
  T_48_HL_LOCAL_VAR: "Nama Variabel Lokal",
  T_48_HL_LOCALIZATION: "Nama Lokalisasi",
  T_48_HL_OPEN_ATTRIBUTES: "Nama Atribut Terbuka",
  T_48_HX_A_WATERFEST25: "Sea Foam (Mask)",
  T_48_HX_B_WATERFEST25: "Sea Foam (Bottom)",
  T_48_HX_F_B_BLACKDRESS: "Antimatter (Bottom)",
  T_48_HX_F_H_BLACKDRESS: "Antimatter (Head)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatter (Facepaint)",
  T_48_HX_F_S_BLACKDRESS: "Antimatter (Shoes)",
  T_48_HX_F_T_BLACKDRESS: "Antimatter (Top)",
  T_48_HX_H_WATERFEST25: "Sea Foam (Head)",
  T_48_HX_HA_WATERFEST25: "Sea Foam (Facepaint)",
  T_48_HX_M_A_BLACKDRESS: "Dark Matter (Mask)",
  T_48_HX_M_B_BLACKDRESS: "Dark Matter (Bottom)",
  T_48_HX_M_H_BLACKDRESS: "Dark Matter (Head)",
  T_48_HX_M_HA_BLACKDRESS: "Dark Matter (Facepaint)",
  T_48_HX_M_S_BLACKDRESS: "Dark Matter (Shoes)",
  T_48_HX_M_T_BLACKDRESS: "Dark Matter (Top)",
  T_48_HX_S_WATERFEST25: "Sea Foam (Shoes)",
  T_48_HX_T_WATERFEST25: "Sea Foam (Top)",
  T_48_JH_WS_STRINGDESC: 'Masukkan paragraf teks atau string lainnya. Beberapa widget bisa menampilkan teks yang kaya. Tambahkan warna ke teks menggunakan format berikut: [#XXXXXX] teks teks [-]. "#XXXXXX" adalah warna yang ingin kamu tampilkan. Mohon catat bahwa warna teks dari widget yang terkait harus di atur menjadi putih.',
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Temukan Entitas Melalui ID",
  T_48_META_API_10001_P0: "ID Entitas",
  T_48_META_API_1098: "Batch Read Nilai Database Sheet",
  T_48_META_API_1098_D: "Baca banyak data entry secara batch dari sheet database yang ditentukan, dimana entry dari daftar ID pemain unik berhubungan satu per satu dengan daftar key yang ada.",
  T_48_META_API_1098_P1: "ID Akun",
  T_48_META_API_1098_P1_D: "Daftar ID pemain yang unik, yang membaca data sesuai dengan key dengan index yang sama dengan daftar key.",
  T_48_META_API_1098_P2: "Key",
  T_48_META_API_1098_P2_D: "Daftar keys, yang membaca data sesuai dengan ID pemain unik yang sama dengan daftar ID di index yang sama.",
  T_48_META_API_1098_P5: "Kode Status",
  T_48_META_API_1098_P5_D: "Daftar kode status",
  T_48_META_API_1105: "Notifikasi Plot Mulai",
  T_48_META_API_1105_D: "Mulai plot yang ditentukan untuk pemain yang trigger",
  T_48_META_API_1105_P1_D: "ID Plot",
  T_48_META_API_1108: "Dapatkan Bahasa Lokal",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Atur Berat Bagian Tubuh",
  T_48_META_API_3300_D: "Atur berat dari bagian tubuh target saat di blend dengan animasi prioritas lebih rendah lainnya",
  T_48_META_API_3300_P0_D: "Komponen kontroler animasi yang bisa ditambahkan ke bagian tubuh yang dimiliki",
  T_48_META_API_3300_P1: "Nama Bagian Tubuh",
  T_48_META_API_3300_P1_D: "Nama bagian tubuh",
  T_48_META_API_3300_P2: "Berat",
  T_48_META_API_3300_P2_D: "Berat dengan nilai diantara [0,1], merepresentasikan tingkat blending dengan animasi prioritas lebih rendah.",
  T_48_META_API_3315: "Mengesampingkan Mainkan Klip Animasi Karakter",
  T_48_META_API_3315_D: "Mainkan klip animasi karakter dengan opsi untuk mengesampingkan animasi default game",
  T_48_META_API_3315_P3: "Mengesampingkan Kontrol Gameplay",
  T_48_META_API_3315_P3_D: "Apakah mengesampingkan animasi default di game",
  T_48_META_API_3316: "Stop Animasi",
  T_48_META_API_3316_D: "Stop memainkan animasi untuk target di status yang ditentukan",
  T_48_META_API_90_P1: "Bisa Keluar Tengah Match",
  T_48_META_API_93: "Buat Sepanjang Path Motion",
  T_48_META_API_93_D: "Membuat gerakan interpolasi sepanjang path untuk membuat objek bergerak sepanjang path yang ditentukan",
  T_48_META_API_93_P1: "Path",
  T_48_META_API_93_P1_D: "Jalur gerakan",
  T_48_META_API_93_P3_D: "Besaran kecepatan",
  T_48_META_API_93_P4: "Menghadap Tangent",
  T_48_META_API_93_P4_D: "Apakah objek menghadap arah gerakan. Properti ini tidak akan diubah walaupun orientasi objek diubah paksa oleh cara lain.",
  T_48_META_API_96: "Instantiate Prefab",
  T_48_META_API_96_D: "Membuat instansi prefab dengan opsi untuk memprosesnya secara asinkron",
  T_48_META_API_96_P2: "Async Load",
  T_48_META_API_96_P2_D: "Apakah loading tidak sinkron",
  T_48_META_EVT_3140: "Saat Berubah Tim",
  T_48_META_EVT_3140_D: "Trigger saat tim dari entitas sekarang berubah",
  T_48_META_EVT_3140_P0: "Tim Sebelumnya",
  T_48_META_EVT_3140_P0_D: "Tim yang diikuti sebelum berubah",
  T_48_META_EVT_3140_P1: "Tim Sekarang",
  T_48_META_EVT_3140_P1_D: "Tim yang diikuti setelah berubah",
  T_48_META_EVT_3141: "Saat Plot Mulai",
  T_48_META_EVT_3141_D: "Trigger saat plot dimulai",
  T_48_META_EVT_3141_P1: "ID Plot",
  T_48_META_EVT_3141_P1_D: "ID Plot",
  T_48_META_EVT_3142: "Saat Plot Selesai",
  T_48_META_EVT_3142_D: "Trigger saat plot selesai",
  T_48_META_EVT_3142_P0_D: "Pemain yang trigger",
  T_48_META_EVT_3142_P1_D: "ID Plot",
  T_48_META_EVT_3143: "Saat Opsi Plot Trigger",
  T_48_META_EVT_3143_D: "Trigger saat opsi dipilih di plot",
  T_48_META_EVT_3143_P1_D: "ID Plot",
  T_48_META_EVT_3143_P2: "ID Opsi",
  T_48_META_EVT_3143_P2_D: "ID dari opsi dipilih",
  T_48_META_TYP_409_I10: "Gagal Ganti Tim_Tim Invalid",
  T_48_META_TYP_409_I11: "Gagal Ganti Tim_Tereliminasi",
  T_48_META_TYP_409_I12: "Gagal Ganti Tim_Dalam Kendaraan",
  T_48_META_TYP_409_I7: "Gagal Ganti Tim_Tidak Didukung",
  T_48_META_TYP_409_I8: "Gagal Ganti Tim_Sudah Dalam Tim",
  T_48_META_TYP_409_I9: "Gagal Ganti Tim_Target Invalid",
  T_48_META_TYP_41_I19: "Matikan Collider",
  T_48_META_TYP_417: "Partikel",
  T_48_META_TYP_428: "Perubahan Pemain atau Pakaian NPC",
  T_48_META_TYP_431: "Sesuai Path Motion",
  T_48_META_TYP_431_I1: "Path",
  T_48_META_TYP_432: "Waypoin Curve Path Custom",
  T_48_META_TYP_432_I0: "Roll",
  T_48_META_TYP_432_I1: "Tangent",
  T_48_META_TYP_433: "Tipe Curve Path Custom",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Smooth",
  T_48_META_TYP_433_I2: "Custom",
  T_48_META_TYP_434: "Curve Path Custom",
  T_48_META_TYP_434_I2: "Closed Loop",
  T_48_META_TYP_434_I3: "Waypoint",
  T_48_META_TYP_437_I5: "Nama Tipe Skor",
  T_48_META_TYP_437_I6: "Konten Skor Kiri",
  T_48_META_TYP_437_I7: "Konten Skor Kanan",
  T_48_META_TYP_438_I1: "Pemain",
  T_48_META_TYP_438_I2: "Rank",
  T_48_META_TYP_438_I3: "Skor Total",
  T_48_META_TYP_438_I4: "Nama Tipe Skor",
  T_48_META_TYP_438_I5: "Warna",
  T_48_META_TYP_438_I6: "Skor",
  T_48_META_TYP_439: "Grup",
  T_48_META_TYP_442_I1: "Skor Kiri",
  T_48_META_TYP_442_I10: "Ikon Eliminasi Kanan",
  T_48_META_TYP_442_I2: "Skor Kanan",
  T_48_META_TYP_442_I3: "Angka Pemain Hidup",
  T_48_META_TYP_442_I4: "Angka Hidup Kanan",
  T_48_META_TYP_442_I5: "Angka Eliminasi Hidup",
  T_48_META_TYP_442_I6: "Angka Eliminasi Kanan",
  T_48_META_TYP_442_I7: "Ikon Hidup Kiri",
  T_48_META_TYP_442_I8: "Ikon Hidup Kanan",
  T_48_META_TYP_442_I9: "Ikon Eliminasi Kiri",
  T_48_META_TYP_444: "Tipe Bahasa",
  T_48_META_TYP_444_I0: "English",
  T_48_META_TYP_444_I1: "Simplified Chinese",
  T_48_META_TYP_444_I10: "Prancis",
  T_48_META_TYP_444_I11: "Jerman",
  T_48_META_TYP_444_I12: "Turkish",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Jepang",
  T_48_META_TYP_444_I15: "Romanian",
  T_48_META_TYP_444_I16: "Arabic",
  T_48_META_TYP_444_I17: "Burmese",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Traditional Chinese",
  T_48_META_TYP_444_I3: "Thai",
  T_48_META_TYP_444_I4: "Vietnam",
  T_48_META_TYP_444_I5: "Indonesia",
  T_48_META_TYP_444_I6: "Portuguese",
  T_48_META_TYP_444_I7: "Spanish",
  T_48_META_TYP_444_I8: "Russian",
  T_48_META_TYP_444_I9: "Korea",
  T_48_SD_ERROR_DIVISOR: "Pembagi tidak bisa 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "Key tersebut tidak ada di map: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "Daftar index diluar jangkauan: {0}",
  T_48_SD_SK_WARNING: "Tidak menemukan {1} di {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Karena atribut "IsServerDriven" dari kontroler karakter Craftland {0} dimatikan, API server terkait tidak akan efektif.',
  T_48_XXJ_WS_PARENTERROR: "Gagal mengatur parent",
  T_48_XXJ_WS_PERFORMANCE: "Performa",
  T_48_XXJ_WS_TANGENT: "Tangent",
  T_48_XXJ_WS_WAYPOINT: "Waypoint",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "Daftar obyek",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Gunakan Minimap Custom",
  T_48_XYL_UGC_HIDEMINIMAP: "Sembunyikan HUD Minimap",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Permukaan Custom Dasar",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Cylinder Cutout",
  T_48_XYL_WS_BASICHEMISPHERE: "Hemisphere Dasar",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quarter Torus",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quarter Square Torus",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Torus",
  T_48_XYL_WS_BASICTRIANGLE: "Permukaan Segitiga",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Pemain match = Jumlah tim x Jumlah pemain per tim. Semakin banyak pemain, semakin banyak waktu matchmaking",
  T_48_XYL_WS_MAPPLAYERSWARNING: "Banyaknya jumlah pemain di match bisa membuat waktu matchmaking lama",
  T_49_HL_CL_CREATOR_LABEL2: "Craftland Community Talent",
  T_49_HL_CL_MAPS_LABEL2: "Pememang Map",
  T_49_HL_CL_MAPS_LABEL3: "Gameplay Winner",
  T_49_HX_T_TUNG: "Tung Tung Tung Sahur",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Jalur",
  T_49_JH_WS_SKILLKASSIE: "Electro Therapy (Kassie)",
  T_49_JH_WS_SKILLKODA: "Aurora Vision (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Valiant Dash (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Buat dengan AI",
  T_49_META_API_10065: "Ubah Kamera Custom",
  T_49_META_API_10067: "Dapatkan Kamera Kustom Sekarang",
  T_49_META_API_10069: "Buat Kamera Custom",
  T_49_META_API_10070: "Atur Culling Mask Kamera Kustom",
  T_49_META_API_10070_D: "Atur culling mask kamera target untuk mengontrol visibilitas di semua layer",
  T_49_META_API_10071: "Atur Layer Culling Mask Kamera Kustom",
  T_49_META_API_10071_D: "Ambil culling mask dari kamera target",
  T_49_META_API_10072: "Lakukan interpolasi sferis dari vektor 3D A ke vektor B untuk rotasi yang halus",
  T_49_META_API_10072_D: "Atur visibilitas kamera target untuk layer tertentu",
  T_49_META_API_10073: "Ambil Screenshot",
  T_49_META_API_10073_D: "Ambil screenshot (untuk testing internal)",
  T_49_META_API_106: "Ambil Timestamp Server (milidetik)",
  T_49_META_API_106_D: "Ambil stempel waktu server dengan presisi milidetik",
  T_49_META_API_107: "Timestamp ke String Localized (milidetik)",
  T_49_META_API_107_D: "Mengubah timestamp (milidetik) ke string berdasarkan format tertentu",
  T_49_META_API_107_P0: "Timestamp (milidetik)",
  T_49_META_API_107_P0_D: "Timestamp di milidetik",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Lakukan interpolasi linear dari vektor 3D A ke vektor B",
  T_49_META_API_1089_P2: "ID Request",
  T_49_META_API_109: "Update Konteks ke Persona",
  T_49_META_API_109_D: "Update konteks model dari persona tersebut di room saat ini dan timpa konteks asli setelah dijalankan. Konteks ini akan memengaruhi cara persona memahami latar belakang, sejarah, atau parameter tertentu dalam dialog saat ini.",
  T_49_META_API_109_P1: "Konteks",
  T_49_META_API_109_P1_D: "Detil dari konteks",
  T_49_META_API_110: "Umpan Balik terhadap Respons Persona",
  T_49_META_API_110_D: "Kirim umpan balik terhadap respons dari persona, yang akan digunakan untuk mengoptimalkan model kami",
  T_49_META_API_110_P1: "Is Liked",
  T_49_META_API_110_P1_D: "Tunjukkan apakah respon diberikan like atau tidak. True = like.",
  T_49_META_API_1109: "Atur Posisi Pemain Lokal",
  T_49_META_API_1109_D: "Saat pemain menggunakan karakter game klasik, API ini dapat mengatur posisi pemain.",
  T_49_META_API_1109_P0_D: "Posisi target",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Setiap respons lengkap akan memiliki ID unik",
  T_49_META_API_1110: "Atur Maju Pemain Lokal",
  T_49_META_API_1110_D: "Saat pemain menggunakan karakter game klasik, API ini bisa mengatur arah hadap pemain.",
  T_49_META_API_1110_P0_D: "Forward vector",
  T_49_META_API_112: "Kembalikan Memori Persona",
  T_49_META_API_112_D: "Kembalikan memori sebuah persona ke sebelum ID respons tertentu. Semua memori percakapan yang mencakup dan setelah respons tersebut akan dihapus.",
  T_49_META_API_113: "Mainkan Suara One-Shot",
  T_49_META_API_113_D: "Putar efek suara sekali pakai dengan volume yang dapat disesuaikan",
  T_49_META_API_113_P0_D: "ID sumber daya efek suara yang akan diputar",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "Volume pemutaran untuk efek suara, dengan rentang dari 0 hingga 1",
  T_49_META_API_97: "Buat Pengendali Look-at untuk Bagian Kerangka",
  T_49_META_API_97_D: "Setelah membuat entitas pengendali look-at untuk bagian kerangka, kamu bisa menggunakan entitas ini untuk mengatur bagian kerangka tertentu agar selalu menghadap ke target yang ditentukan.",
  T_49_META_API_97_P0_D: "Entitas pengendali look-at untuk bagian kerangka. Jika entitas ini dihancurkan, fungsi look-at akan berhenti.",
  T_49_META_API_97_P1_D: "Bagian kerangka yang sedang dikendalikan",
  T_49_META_API_97_P2_D: "Target yang sedang dilihat",
  T_49_META_API_98: "Proyeksi",
  T_49_META_API_98_D: "Hitung proyeksi vektor A ke vektor B",
  T_49_META_API_99: "Dapatkan Timestamp Lokal (milidetik)",
  T_49_META_API_99_D: "Ambil stempel waktu lokal dengan presisi milidetik",
  T_49_META_EVT_16_P1_D: "Dimulai dari 0, setiap permintaan keluar akan menggunakan ID numerik secara berurutan, seperti saat membuat ruangan atau membersihkan memori.",
  T_49_META_EVT_16_P2: "ID Respons",
  T_49_META_EVT_16_P2_D: "Bagian kerangka yang sedang dikendalikan",
  T_49_META_TYP_122_I19: "Material Custom",
  T_49_META_TYP_122_I19_D: "Izinkan penggantian skybox dengan material kustom.",
  T_49_META_TYP_14_I78_D: "Mengambil atau menetapkan entitas kamera yang saat ini merender adegan di sisi klien pemain. Catatan: Entitas kamera pada dasarnya mewakili data konfigurasi untuk mengontrol kamera di sisi klien.",
  T_49_META_TYP_335_I9: "Waktu Lewat (milidetik)",
  T_49_META_TYP_335_I9_D: "Durasi pemutaran efek suara dalam milidetik. Properti ini hanya dapat diakses di sisi klien.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "ID Performance",
  T_49_META_TYP_445: "ID Kontroler bisa Dimainkan",
  T_49_META_TYP_446: "Pengendali yang Dapat Dimainkan",
  T_49_META_TYP_446_I0: "Kontroler Bisa Dimainkan",
  T_49_META_TYP_447: "Pengendali Bagian Skeleton",
  T_49_META_TYP_448: "Skeleton Part Look-at Controller",
  T_49_META_TYP_448_I0: "Target Dikontrol",
  T_49_META_TYP_448_I1: "Target Melihat",
  T_49_META_TYP_449: "Kamera Custom",
  T_49_META_TYP_449_I2: "Ukuran Ortografis",
  T_49_META_TYP_449_I2_D: "Kontrol ukuran area yang terlihat di kamera",
  T_49_META_TYP_450: "Timestamp String Localized (milidetik)",
  T_49_META_TYPE_449_D: "Kamera kustom sepenuhnya dikendalikan oleh developer dan menentukan apa yang dilihat pemain selama gameplay.",
  T_49_META_TYPE_450_D: "Format timestamp level milidetik ke dalam format teks yang mudah dibaca",
  T_49_SD_SEARCH_ICONDESC: "Asosiasi Pintar",
  T_49_SD_SEARCHKEY_ACTION: "Aksi",
  T_49_SD_SEARCHKEY_ANICLIPID: "ID klip animasi",
  T_49_SD_SEARCHKEY_AS: "Sebagai",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "ID Attachment",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Tipe efek suara",
  T_49_SD_SEARCHKEY_BAGSKINID: "ID Skin Backpack",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier curve",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Break",
  T_49_SD_SEARCHKEY_BTREEID: "ID Behavior Tree",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "Saat tombol ditekan",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "Saat ditekan dua kali",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "Saat tombol ditahan",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "Saat tombol dilepas",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Tipe bundle",
  T_49_SD_SEARCHKEY_COLOR: "Warna",
  T_49_SD_SEARCHKEY_COMMENT: "Catatan komentar",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Komponen enum",
  T_49_SD_SEARCHKEY_CONCANT: "Sambungkan",
  T_49_SD_SEARCHKEY_CONTINUE: "Lanjut",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Custom HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Widget custom HUD",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "buat tipe objek level secara dinamis",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Tipe efek visual",
  T_49_SD_SEARCHKEY_ENTITY: "Pilih obyek scene",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "Untuk index",
  T_49_SD_SEARCHKEY_FOREACH: "Untuk setiap",
  T_49_SD_SEARCHKEY_FUNCTION: "Fungsi",
  T_49_SD_SEARCHKEY_GETCSV: "Dapatkan CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Ambil aset yang terdaftar berdasarkan key",
  T_49_SD_SEARCHKEY_GETVALUE: "Dapatkan nilai properti",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Dapatkan variabel global",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Atur Variabel Global",
  T_49_SD_SEARCHKEY_IF: "Jika",
  T_49_SD_SEARCHKEY_IFELSE: "Jika tidak",
  T_49_SD_SEARCHKEY_IMGENUM: "Tipe Sprite",
  T_49_SD_SEARCHKEY_INT: "Integer",
  T_49_SD_SEARCHKEY_INTERNALHUD: "Tipe HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "Tipe Item",
  T_49_SD_SEARCHKEY_LISTAPPEND: "Daftar append",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "Daftar append range",
  T_49_SD_SEARCHKEY_LISTCLEAR: "Daftar clear",
  T_49_SD_SEARCHKEY_LISTCLONE: "Daftar clone",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "Daftar contain",
  T_49_SD_SEARCHKEY_LISTCREATE: "Buat List",
  T_49_SD_SEARCHKEY_LISTDELETE: "Hapus Daftar",
  T_49_SD_SEARCHKEY_LISTGET: "Dapatkan daftar",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "Daftar index dari",
  T_49_SD_SEARCHKEY_LISTINSERT: "Daftar insert",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "Daftar index terakhir",
  T_49_SD_SEARCHKEY_LISTLENGTH: "Daftar length",
  T_49_SD_SEARCHKEY_LISTREVERSE: "Daftar reverse",
  T_49_SD_SEARCHKEY_LISTSET: "Atur daftar",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "Daftar shuffle",
  T_49_SD_SEARCHKEY_LOCALKEY: "Key Terlokalisasi",
  T_49_SD_SEARCHKEY_LOCALVAR: "Variabel lokal",
  T_49_SD_SEARCHKEY_LOGICAL: "Dan atau",
  T_49_SD_SEARCHKEY_LOGINFO: "Print info log",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict ambil semua key, map ambil semua key",
  T_49_SD_SEARCHKEY_MAPCLEAR: "bersihkan dict, bersihkan map",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict mengandung key, map mengandung key",
  T_49_SD_SEARCHKEY_MAPCREATE: "buat dict buat map",
  T_49_SD_SEARCHKEY_MAPGET: "ambil nilai dict berdasarkan key, ambil nilai map berdasarkan key",
  T_49_SD_SEARCHKEY_MAPLENGTH: "panjang dict, panjang map",
  T_49_SD_SEARCHKEY_MAPREMOVE: "hapus dict, hapus map",
  T_49_SD_SEARCHKEY_MAPSET: "atur nilai dict, atur nilai map",
  T_49_SD_SEARCHKEY_MATH: "tambah kurang kali bagi",
  T_49_SD_SEARCHKEY_NEWLIST: "Daftar baru",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Angka ke string",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Properti partikel",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "ID Data Pemain",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Tipe skill karakter",
  T_49_SD_SEARCHKEY_PREEFFECT: "Tipe stiker spesial",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "ID Raw",
  T_49_SD_SEARCHKEY_READSTATIS: "Baca data akumulatif",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "UUID Sumber Daya",
  T_49_SD_SEARCHKEY_RETURN: "Kembali",
  T_49_SD_SEARCHKEY_SCENEENUM: "File scene",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Atur nilai properti",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Tipe ID item spesial",
  T_49_SD_SEARCHKEY_TEXT: "Teks",
  T_49_SD_SEARCHKEY_TEXTUREID: "Tipe tekstur",
  T_49_SD_SEARCHKEY_THISENTITY: "Entitas Ini",
  T_49_SD_SEARCHKEY_TIMELINE: "Timeline",
  T_49_SD_SEARCHKEY_TYPEENUM: "Tipe apapun",
  T_49_SD_SEARCHKEY_V2VCREATE: "Buat Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Dapatkan komponen Vector2",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Operasi Vector2: tambah, kurang, dot product, cross product, jarak, sudut",
  T_49_SD_SEARCHKEY_V2VSET: "Atur komponen Vector2",
  T_49_SD_SEARCHKEY_V3VCREATE: "Buat Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Dapatkan komponen Vector3",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Operasi Vector3: tambah, kurang, dot product, cross product, jarak, sudut",
  T_49_SD_SEARCHKEY_V3VSET: "Atur komponen Vector3",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "ID skin kendaraan",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "ID Skin Senjata",
  T_49_SD_SEARCHKEY_WHILE: "Saat",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Tulis offset database yang terakumulasi",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Tulis offset database yang terakumulasi berdasarkan kode map",
  T_49_XXJ_WS_DURATIONS: "Durasi (dtk)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Edit Performa",
  T_49_XXJ_WS_PERFORMANCE: "Performa",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Hapu Performa",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Performa yang dihapus tidak bisa dipulihkan, tetap lanjut?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Mengedit {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "Nama sudah digunakan, mohon ubah dan coba kembali",
  T_49_XXJ_WS_PERFORMANCENAME: "Nama Performa",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Tambah Key Frame",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Tambah Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Tambah Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Hapus Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Actor Track",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Event Track",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Key Frame sudah ada",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "Actor track terkait sudah ada",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Konten",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Nama track terduplikasi terdeteksi. Silakan ubah terlebih dahulu lalu coba lagi.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Mohon mulai rekaman atau pilih key frame terlebih dahulu",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Merekam...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Hapus Key Frame",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Lihat Scene",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Pilih objek untuk membuat lintasan atau ketuk tombol tambah lintasan secara langsung.",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Tekan tombol tambah track untuk membuat track baru",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Lihat Track",
  T_49_XYL_WS_DAILYPROPS: "Dasar",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Trouble Academy",
  T_50_H_MACHETE_VA_N: "Parang - Trouble Academy",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Kolom Leaderboard",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Meluap",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Berkeliling",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Perkecil font",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Buat Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Dapatkan Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Atur Tuple",
  T_50_HJ_TEXTOBGJ_H: "Tinggi",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Opsi Overflow",
  T_50_HJ_TEXTOBGJ_W: "Lebar",
  T_50_HZY_REVIEW_TEXTOBJ: "Konten obyek teks",
  T_50_JH_WS_HIDEMAPERROR: "Tidak bisa menyembunyikan minimap tanpa image cover custom",
  T_50_JH_WS_HIDEMAPTIP: "Saat minimap disembunyikan, ia tidak akan lagi digunakan untuk cover image",
  T_50_JH_WS_HIDEMINIMAP: "Sembunyikan Minimap",
  T_50_META_API_10073_P0: "Nama File",
  T_50_META_API_10073_P0_D: "Nama file",
  T_50_META_API_10073_P1_D: "Hasil dari eksekusi. Cek enum Status Kode.",
  T_50_META_API_1102: "Baca Nilai Kolom Sheet Database",
  T_50_META_API_1102_D: "Baca nilai dari kolom tertentu berdasarkan key yang diberikan dari tabel database standar",
  T_50_META_API_1102_P3: "Indeks Kolom",
  T_50_META_API_1102_P3_D: "Indeks kolom dari tabel database (0 = kolom pertama)",
  T_50_META_API_1106: "Buat Performa",
  T_50_META_API_1106_D: "Buat entitas performa",
  T_50_META_API_1106_P0_D: "Aset performa",
  T_50_META_API_1111: "Baca Nilai Asosiasi Database Leaderboard",
  T_50_META_API_1111_D: "Membaca kombinasi nilai dari tabel leaderboard dan tabel terkaitnya di database",
  T_50_META_API_1111_P5: "Kode Status Association",
  T_50_META_API_1111_P5_D: "Kode Status Association",
  T_50_META_API_1112: "Baca Nilai Asosiasi Leaderboard dari Database Berdasarkan Rentang",
  T_50_META_API_1112_D: "Membaca nilai dari tabel papan peringkat dalam rentang peringkat tertentu, mengambil nilai terkait dari tabel terkait berdasarkan key yang didapat, lalu menggabungkannya.",
  T_50_META_API_1112_P6: "Kode Status Association",
  T_50_META_API_1112_P6_D: "Kode Status Association",
  T_50_META_API_1113: "Tulis Nilai Asosiasi Leaderboard ke Database",
  T_50_META_API_1113_D: "Tuliskan nilai untuk key tertentu ke dalam tabel leaderboard dan tabel terkaitnya di database",
  T_50_META_API_1113_P5: "Kode Status Association",
  T_50_META_API_1113_P5_D: "Kode Status Association",
  T_50_META_API_114_D: "Buat UI custom",
  T_50_META_API_114_P0_D: "Kode ini digunakan sebagai nama parameter untuk membuat entitas UI, dan nilai variabel lokal yang terkait merepresentasikan entitas UI yang telah dibuat.",
  T_50_META_API_114_P1_D: "Entitas pemain yang menjadi pemiliknya, hanya terlihat oleh pemain tersebut.",
  T_50_META_API_114_P2: "ID Aset UI",
  T_50_META_API_114_P2_D: "ID aset UI custom",
  T_50_META_API_115_D: "Buat UI custom yang di-spesifikasikan",
  T_50_META_API_116: "Atur Level Highlight Obyek",
  T_50_META_API_116_D: "Atur status highlight pada objek. Status ini bisa dipengaruhi oleh logika lain dalam game.",
  T_50_META_API_116_P0_D: "Obyek Target",
  T_50_META_API_116_P1_D: "Status highlight",
  T_50_META_API_117: "Bitwise Common",
  T_50_META_API_117_D: "Bitwise and/or/xor/left shift/right shift",
  T_50_META_API_117_P0_D: "Nilai kiri",
  T_50_META_API_117_P1_D: "Nilai kanan",
  T_50_META_API_117_P2_D: "Tipe Operasional",
  T_50_META_API_118: "Bitwise Not",
  T_50_META_API_118_D: "Bitwise NOT, juga dikenal sebagai bitwise complement.",
  T_50_META_API_118_P0_D: "Nilai",
  T_50_META_API_119: "Bitwise List ke Int",
  T_50_META_API_119_D: "Melakukan operasi OR bitwise pada semua elemen dalam list dan mengubah hasilnya menjadi nilai integer.",
  T_50_META_API_119_P0: "Bit Array",
  T_50_META_API_119_P0_D: "Bitwise array",
  T_50_META_API_120: "Bitwise Int ke List",
  T_50_META_API_120_D: "Ubah nilai desimal yang direpresentasikan oleh bit di posisi 1 dari bentuk biner sebuah integer menjadi daftar.",
  T_50_META_API_120_P0_D: "Integer",
  T_50_META_API_121: "Sudut Quaternion",
  T_50_META_API_121_D: "Hitung sudut dari dua quaternion",
  T_50_META_API_121_P0_D: "Quaternion 2",
  T_50_META_API_121_P1_D: "Quaternion 1",
  T_50_META_API_122: "Dot Quaternion",
  T_50_META_API_122_D: "Hitung produk dot dari dua quaternion",
  T_50_META_API_123: "Quaternion Inverse",
  T_50_META_API_123_D: "Hitung inverse dari quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion Dari Ke Rotasi",
  T_50_META_API_124_D: 'Hitung rotasi quaternion dari "dari" hingga "ke"',
  T_50_META_API_124_P0_D: "Titik mulai",
  T_50_META_API_124_P1_D: "Titik akhir",
  T_50_META_API_125: "Quaternion Rotasi Terhadap",
  T_50_META_API_125_D: 'Hitung rotasi quaternion dari "dari" ke "hingga". Max Degrees Delta adalah sudut rotasi maksimum.',
  T_50_META_API_125_P0: "Dari",
  T_50_META_API_125_P0_D: "Quaternion awal",
  T_50_META_API_125_P1: "Ke",
  T_50_META_API_125_P1_D: "Quaternion target",
  T_50_META_API_125_P2: "Delta Sudut Maks.",
  T_50_META_API_125_P2_D: "Sudut rotasi maks.",
  T_50_META_API_126: "Dapatkan Orientasi Gyroscope",
  T_50_META_API_126_D: "Orientasi perangkat secara 3D, merepresentasikan rotasi sudut terhadap ketiga axis",
  T_50_META_API_127: "Dapatkan Gravitasi Gyroscope",
  T_50_META_API_127_D: "Komponen gravitasi terdeteksi oleh sensor di perangkat kamu",
  T_50_META_API_128: "Dapatkan Rate Rotasi Gyroscope",
  T_50_META_API_128_D: "Ini mengacu pada kecepatan rotasi sebuah perangkat. Istilah ini berkaitan dengan sensor giroskop yang menggambarkan seberapa cepat perangkat bergerak secara rotasional dalam ruang tiga dimensi.",
  T_50_META_API_129: "Dapatkan Rotasi Gyroscope Tanpa Bias",
  T_50_META_API_129_D: "Menjelaskan kecepatan rotasi perangkat dan memberikan hasil yang lebih akurat dengan mengompensasi noise atau bias dari sensor perangkat.",
  T_50_META_API_130: "Dapatkan Akselerasi Gryoscope Pemain",
  T_50_META_API_130_D: "Bagian dari percepatan perangkat yang telah menghilangkan komponen gravitasi, yaitu percepatan yang disebabkan oleh tindakan pengguna atau gaya eksternal.",
  T_50_META_API_131: "Dapatkan Info Sentuh",
  T_50_META_API_131_D: "Dapatkan informasi sentuhan layar pada indeks tertentu (termasuk posisi, perpindahan, dan waktu perubahan).",
  T_50_META_API_131_P0_D: "Distribusikan ID titik sentuh, dimulai dari 0",
  T_50_META_API_131_P1_D: "Posisi tekan",
  T_50_META_API_131_P2: "Posisi Delta",
  T_50_META_API_131_P2_D: "Perubahan posisi dibandingkan dengan frame sebelumnya",
  T_50_META_API_131_P3: "Waktu Delta",
  T_50_META_API_131_P3_D: "Waktu yang terlewat sejak frame terakhir",
  T_50_META_API_132: "Dapatkan Hitungan Tekan Layar",
  T_50_META_API_132_D: "Dapat jumlah titik sentuh di layar sekarang",
  T_50_META_API_133: "Getaran Perangkat",
  T_50_META_API_133_D: "Membuat perangkat bergetar sekali",
  T_50_META_API_134_D: "Memberi notifikasi ke perangkat pemain target untuk memutar audio",
  T_50_META_API_134_P0_D: "Pemain target",
  T_50_META_API_134_P1_D: "Aset audio",
  T_50_META_API_134_P2_D: "Kecepatan pemutaran (rentang valid: 0.1~3.0; 1 = normal, <1 = diperlambat, >1 = dipercepat)",
  T_50_META_API_135_D: "Mainkan file audio satu kali",
  T_50_META_API_135_P0_D: "Sumber daya audio",
  T_50_META_API_135_P1_D: "Kecepatan Main",
  T_50_META_API_136: "Format String",
  T_50_META_API_136_D: "Format string",
  T_50_META_API_136_P0_D: "String terformat yang menggunakan kontrol format verb dari Go",
  T_50_META_API_136_P1: "Array Parameter",
  T_50_META_API_136_P1_D: "Daftar Parameter",
  T_50_META_API_137: "Komponen Paste",
  T_50_META_API_137_D: "Copy atau tambahkan data komponen",
  T_50_META_API_137_P0: "Sumber Daya",
  T_50_META_API_137_P0_D: "Entitas sumber",
  T_50_META_API_137_P1_D: "Entitas Target",
  T_50_META_API_137_P2: "Tipe Komponen",
  T_50_META_API_137_P2_D: "Tipe Komponen",
  T_50_META_API_137_P3: "Is Succes",
  T_50_META_API_137_P3_D: "Apakah berhasil atau tidak",
  T_50_META_API_138: "Revive di Frame Selanjutnya",
  T_50_META_API_138_D: "Revive di frame selanjutnya.",
  T_50_META_API_139: "Eliminasi di Frame Selanjutnya",
  T_50_META_API_139_D: "Eliminasi entitas battle di frame selanjutnya",
  T_50_META_API_139_P0_D: "Entitas battle",
  T_50_META_API_140: "Keluar Game di Frame Selanjutnya",
  T_50_META_API_140_D: "Keluar game di frame selanjutnya",
  T_50_META_API_141: "Dapatkan Volume Mikrofon",
  T_50_META_API_141_D: "Dapatkan volume mikrofon. Akan mengembalikan status jika mikrofon pemain sedang nonaktif atau tidak diberikan akses.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "Volume mikrofon",
  T_50_META_API_141_P1_D: "Mikrofon diaktifkan atau dimatikan",
  T_50_META_API_142: "Dapatkan Kualitas Render",
  T_50_META_API_142_D: "Dapatkan kualitas rendering saat ini (enum: Rendah/Sedang/Tinggi/Ultra)",
  T_50_META_API_143: "Dapatkan Resolusi Render",
  T_50_META_API_143_D: "Dapat resolusi render sekarang",
  T_50_META_API_144: "Bind Pemain Custom",
  T_50_META_API_144_D: "Atur target yang akan diikat oleh pemain ini secara dinamis, menggantikan ikatan yang sudah ada. Akan mengembalikan false jika gagal.",
  T_50_META_API_144_P0: "Pemain Custom",
  T_50_META_API_144_P0_D: "Setelah Pemain Custom ini diikat ke pemain, data seperti posisi dan arah akan tersinkronisasi secara otomatis.",
  T_50_META_API_144_P1_D: "Pemain Target",
  T_50_META_API_145: "Unbind Pemain Custom",
  T_50_META_API_145_D: "Membatalkan binding. Mengembalikan false jika gagal.",
  T_50_META_API_145_P0: "Pemain Custom",
  T_50_META_API_145_P0_D: "Hapus semua binding untuk target ini. Setelah dilepas, data seperti posisi dan arah tidak akan tersinkronisasi secara otomatis lagi.",
  T_50_META_API_146_P0_D: "Pemain custom",
  T_50_META_API_147: "Atur Status Pemain Custom",
  T_50_META_API_147_D: "Secara otomatis upload ke server dan menyinkronkannya dengan semua klien. Akan mengembalikan false jika gagal.",
  T_50_META_API_147_P0: "Pemain Custom",
  T_50_META_API_147_P1: "State",
  T_50_META_API_147_P1_D: "Biasanya digunakan untuk menyimpan status animasi. Dapatkan status yang tersinkronisasi dengan Dapatkan Status Pemain Custom.",
  T_50_META_API_148: "Dapatkan Status Pemain Custom",
  T_50_META_API_148_D: "Data status akan tersinkronisasi secara otomatis ke server. Akan mengembalikan false jika gagal.",
  T_50_META_API_148_P0: "Pemain Custom",
  T_50_META_API_148_P1: "State",
  T_50_META_API_148_P1_D: "Atur status dengan Atur Status Pemain Custom",
  T_50_META_API_149: "Atur Volume Jarak",
  T_50_META_API_149_D: "Atur rentang jarak antar pemain untuk menyesuaikan volume audio secara dinamis.",
  T_50_META_API_149_P0: "Daftar Jarak",
  T_50_META_API_149_P0_D: "Daftar rentang jarak, masing-masing sesuai dengan elemen dalam daftar volume.",
  T_50_META_API_149_P1: "Daftar Volume",
  T_50_META_API_149_P1_D: "Daftar volume, masing-masing sesuai dengan elemen yang ada di daftar jarak.",
  T_50_META_API_150: "Dapatkan Teman",
  T_50_META_API_150_D: "Dapat daftar ID teman pemain",
  T_50_META_API_151: "Dapatkan Info UI Default",
  T_50_META_API_151_D: "Dapat lokasi UI default pemain",
  T_50_META_API_151_P0_D: "Interface default",
  T_50_META_API_151_P1_D: "Status",
  T_50_META_API_151_P2_D: "Posisi UI",
  T_50_META_API_151_P3: "Ukuran",
  T_50_META_API_151_P3_D: "Ukuran UI",
  T_50_META_API_152: "Broadcast Event Custom",
  T_50_META_API_152_D: "Broadcast event custom untuk entitas manapun untuk menerima event ini",
  T_50_META_API_153: "Kirim Event ke Entitas",
  T_50_META_API_153_D: "Kirim event custom ke entitas target",
  T_50_META_EVT_17: "Saat Tekan Layar Selesai",
  T_50_META_EVT_17_D: "Mulai event saat layar ditekan",
  T_50_META_EVT_17_P0: "Index Sentuhan",
  T_50_META_EVT_17_P0_D: "Index titik sentuhan",
  T_50_META_EVT_17_P1_D: "Posisi tekan",
  T_50_META_EVT_18: "Saat Tekan Layar Mulai",
  T_50_META_EVT_18_D: "Akhiri event saat layar disentuh",
  T_50_META_EVT_18_P0: "Index Sentuhan",
  T_50_META_EVT_18_P0_D: "Index titik sentuhan",
  T_50_META_EVT_18_P1_D: "Sentuh posisi di layar",
  T_50_META_EVT_19: "Saat Menerima Hasil Pembuatan Room Persona",
  T_50_META_EVT_19_D: "Terima hasil yang sesuai saat gagal membuat chat room persona",
  T_50_META_EVT_19_P1: "ID Room",
  T_50_META_EVT_19_P1_D: "ID room",
  T_50_META_EVT_20: "Saat Pemain Keluar atau Match Selesai",
  T_50_META_EVT_20_D: "Trigger saat pemain keluar match atau saat match selesai",
  T_50_META_TYP_11_I44: "Volume Jarak",
  T_50_META_TYP_11_I44_D: "Sesuaikan volume audio secara dinamis berdasarkan jarak antar pemain",
  T_50_META_TYP_22_I9_D: "ID aset digunakan untuk membuat UI",
  T_50_META_TYP_244_I12_D: "Lebar text box",
  T_50_META_TYP_244_I13_D: "Tinggi text box",
  T_50_META_TYP_244_I14_D: "Tipe overflow",
  T_50_META_TYP_335_I10_D: "Kecepatan playback (nilai valid > 0, default = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "Operasi IO gagal: error terjadi saat pembuatan file.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "Operasi IO gagal. Nama file invalid.",
  T_50_META_TYP_448_I0_D: "Bagian skeleton yang di-kontrol",
  T_50_META_TYP_448_I1_D: "Target yang dilihat oleh skeleton part",
  T_50_META_TYP_451: "Tipe Overflow",
  T_50_META_TYP_451_D: "Metode untuk menangani overflow teks",
  T_50_META_TYP_452: "ID Aset UI Custom",
  T_50_META_TYP_452_D: "ID yang mendeskripsikan aset HUD custom",
  T_50_META_TYP_453: "Tipe Kualitas Render",
  T_50_META_TYP_453_D: "Enum kualitas rendering",
  T_50_META_TYPE_448_D: "Entitas yang digunakan untuk kontrol bagian skeleton untuk melihat target",
  T_50_SD_WS_MAPTAG_AI3DGEN: "Map Generasi Obyek 3D",
  T_50_SD_WS_MAPTAG_AIRACING: "Map Racing Buatan AI",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Enum nama status animasi",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Matikan Getaran",
  T_50_XXJ_WS_NOPERFORMANCE: "Belum ada file performa",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Versi beta",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Kepada para kreator, editor performa masih dalam tahap uji coba. Mungkin masih ada bug atau fitur penting yang belum tersedia. Harap digunakan dengan hati-hati.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Tambah Performa",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Tambahkan Key Clip",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Sepanjang Path Track",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animasi",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Track Animasi",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Track Audio",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Tahan",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Loop Selamanya",
  T_50_XXJ_WS_TIMELINE_DURATION: "Durasi: {0}dtk",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Ketidaksamaan antara animasi dan model",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Overlap key clip",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Entitas bound tidak ditemukan",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "Nama track tidak bisa kosong",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "Track NPC",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Property Track",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Hapus Key Clip",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}dtk",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Batas jumlah track dilebihi",
  T_50_XYL_WS_AIGETERATESHOW: "Building Blocks",
  T_50_YU_F_B_VA_WITCH: "Mystic Trouble (Bottom)",
  T_50_YU_F_H_VA_WITCH: "Mystic Trouble (Head)",
  T_50_YU_F_HA_VA_WITCH: "Mystic Trouble (Facepaint)",
  T_50_YU_F_S_VA_WITCH: "Mystic Trouble (Shoes)",
  T_50_YU_F_T_VA_WITCH: "Mystic Trouble (Top)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Event Khusus",
  T_51_GT_WS_BASIC: "Basic",
  T_51_GT_WS_GLOBALEVENT: "Event Global",
  T_51_GT_WS_PRIVATEEVENT: "Event Khusus",
  T_51_GT_WS_STORY: "Cerita",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "Pesan pengguna ke respon Persona suara",
  T_51_META_API_1114_D: "Kirim pesan persona pengguna dan dapatkan respons suara dari persona.",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "Pesan Sistem ke Respon Persona Suara",
  T_51_META_API_1115_D: "Kirim pesan sistem persona dan dapatkan respons suara dari persona",
  T_51_META_API_1116: "Putar Suara Tersimpan dari Persona",
  T_51_META_API_1116_D: "Putar ulang respons suara yang disimpan dari persona. Dapat menyimpan hingga 10 respons.",
  T_51_META_API_144_P2_D: "Bagaimanapun execution sukses dilakukan",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Kembalikan nama tipe objek target.",
  T_51_META_API_154_P0_D: "Objek target untuk mendapatkan nama tipe",
  T_51_META_API_155: "Dapat bounding box",
  T_51_META_API_155_D: "Dapatkan bounding box untuk  objek scene",
  T_51_META_API_155_P0_D: "Objek scene untuk mendapatkan bounding box",
  T_51_META_API_155_P1_D: "Titik tengah bounding box",
  T_51_META_API_155_P2: "Ukuran",
  T_51_META_API_155_P2_D: "Ukuran bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "Entitas target yang akan dibuat",
  T_51_META_API_156_P1_D: "Tipe dari komponen kustom yang dibuat",
  T_51_META_API_156_P2_D: "Pemilih entitas",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Atur properti material",
  T_51_META_API_157_D: "API ini memungkinkan Anda untuk mengubah beberapa properti dari material sebuah objek.",
  T_51_META_API_157_P0_D: "Objek target untuk mendapatkan properti material",
  T_51_META_API_157_P1: "Nama Value",
  T_51_META_API_157_P1_D: "Atur nama dari properti",
  T_51_META_API_157_P2: "Value Properti",
  T_51_META_API_157_P2_D: "Atur Value dari properti",
  T_51_META_API_157_P3: "Sukses",
  T_51_META_API_157_P3_D: "Setel baik sukses ataupun tidak",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "Objek target untuk menghapus properti material",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "Ketika properti kustom yang dipantau berubah, akan memicu event ini. Catatan: jika properti kustom diubah beberapa kali dalam satu frame, event ini hanya dipicu sekali. Ketika server mengubah properti kustom, event dikirim ke kedua endpoint; ketika klien mengubah properti kustom entitas lokal, event hanya dikirim secara lokal.",
  T_51_META_EVT_21_P0: "Indeks Properti",
  T_51_META_EVT_21_P0_D: "Indeks properti",
  T_51_META_EVT_21_P1_D: "Value baru dari properti",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "Event ini akan terpicu ketika status pemain kostum berubah",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "Status pemain kustom",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Memicu event ini ketika respon persona suara diterima",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Memicu event ini ketika respon Persona suara selesai diputar.",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "Ketika bound ke pemain kostum, model karakter klasik  disembunyikan, dan posisi, rotasi (arah hadap), serta data lainnya disingkronkan.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Tampilkan nama teman tim diatas kepala mereka",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Damage luar zona per detik",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Digunakan untuk mengatur properti material pada sebuah objek.",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "Flag properti untuk entitas tertentu, bisa digunakan secara kombinasi.",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Statis",
  T_51_META_TYP_455_I1_D: "Entitas Statis",
  T_51_META_TYP_455_I2: "Lokal",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Saja",
  T_51_META_TYP_455_I3_D: "Render Saja",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Hujan",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Buka Box",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Atur outline entitas",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value antara 0 dan 1 (0 = benar-benar transparan, 1 = benar-benar tidak tembus pandang)",
  T_51_TYC_API_OUTLINE_COLOR: "Warna outline",
  T_51_TYC_API_OUTLINE_COLOR_D: "Warna untuk menggambar outline",
  T_51_TYC_API_OUTLINE_D: "Menentukan entitas untuk menyorot bagian tepinya. Jenis yang disupport termasuk Pemain, Render kostum, NPC, Penampilan, dan Penampilan Basic .",
  T_51_TYC_API_OUTLINE_TARGET: "Entitas target",
  T_51_TYC_API_OUTLINE_TARGET_D: "Entitas yang akan diberi outline",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value antara 0 dan 1 (0 = tanpa garis tepi, 1 = ketebalan garis tepi maksimal)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Detik",
  T_51_XJ_WS_GMSTART_TIME: "Persiapan Sebelum Game dimulai",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Properti Read-Only",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Jaket kulit hitam (Wanita)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Celana Tukang Pipa",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Pakaian olahraga hitam (sepatu)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "Celana GW2018 (wanita)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "Rok GW2018 (wanita)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Pakaian olahraga hitam (hoodie)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Baju Songkran umum",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Baju Tukang Pipa",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "Singlet GW2018 (wanita)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "Prosperity putih (bawahan)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Black Trackpants (Laki-Laki)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Celana Skull King",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Celana Survivor",
  TXT_AVATAR_MALE_PANTS_MARIO: "Celana Tukang Pipa",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Sepatu Survivor",
  TXT_AVATAR_MALE_SHOE_RED: "Red Boots (Male)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "Prosperity putih (Baju)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Jersey Baseball Hitam (pria)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Rebel Hoodie",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Pakaian olahraga cool (hoodie)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Baju Skull King",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Baju Survivor",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Baju Tukang Pipa",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Racer Jacket (Female)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Night Clown (Head)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Racer Jacket (Male)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Sleeveless Jacket (Hijau)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Mr. Squido",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Zombified Samurai (Mask)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Full Arm Tattoo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Mendekap",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Stilish Retro",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Celana Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Sandal Kitsune",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Sepatu sport",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Celana denim",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Jubah Kitsune",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Celana Combat",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Celana Angel",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Celana Bushido",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Hoodie Zipper",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Sepatu kasual",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Sandal Bushido",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Sepatu Astro",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Celana denim",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Vest Combat",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Baju Selebriti",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Jalan Bushido!",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "White Hurricane",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Baseball tight",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Rider Jacket (Female)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Jaket Baseball",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Celana Cool Captain",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "The Streets (Kepala)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Sepatu Cool Captain",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Rider Jacket (Male)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Jaket Cool Captain",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Sepatu Perak",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Three Lions",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Tuxedo (Mask)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Tuxedo (Head)",
  TXT_AVATAR_PARACHUTE_8: "Parasut - Smiley",
  TXT_AVATAR_SHIRT_PLAID_2: "Favorit Programer (Red)",
  TXT_AVATAR_SHOES_1: "Sneakers (Putih)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Uniform (Begonia)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Seragam Sekolah (Merah)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Uniform (Chrysanthemum)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Uniform (Violet)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Uniform (Jasmine)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Schoolgirl (Dark)",
  TXT_AVATAR_TSHIRT_WEEK_007: "STARRY SUN",
  TXT_BANNER_NAME_MISHA: "Kecepatan",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Nama",
  TXT_COLLECTION_DESCRIPTION: "deskripsi",
  TXT_COLLECTION_HEADPORTRAIT: "Avatar",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Item",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "AR Ammo",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Tas Lv1",
  TXT_ITEM_BAG2: "Tas Lv2",
  TXT_ITEM_BAG3: "Tas Lv3",
  TXT_ITEM_BASEBALLPOLE: "Bat",
  TXT_ITEM_BOWAMMO: "Crossbow Bolt",
  TXT_ITEM_CHANGUO: "Panci",
  TXT_ITEM_CROSSBOW: "Crossbow",
  TXT_ITEM_DESC_FLASH: "Alat peledak yang bisa menghilangkan indera musuh untuk sementara.",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Med Kit",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Tinju",
  TXT_ITEM_FLASH: "Flashbang",
  TXT_ITEM_FOREGRIP1: "Foregrip Lv1",
  TXT_ITEM_FOREGRIP2: "Foregrip Lv2",
  TXT_ITEM_FOREGRIP3: "Foregrip Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Granat",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "Hand Cannon",
  TXT_ITEM_HEATSIGHT: "Thermal Scope",
  TXT_ITEM_HELMET1: "Helm Lv1",
  TXT_ITEM_HELMET2: "Helm Lv2",
  TXT_ITEM_HELMET3: "Helm Lv3",
  TXT_ITEM_HGAMMO: "HG Ammo",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Machete",
  TXT_ITEM_MAGEZINE1: "Magazine Lv1",
  TXT_ITEM_MAGEZINE2: "Magazine Lv2",
  TXT_ITEM_MAGEZINE3: "Magazine Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Muzzle Lv1",
  TXT_ITEM_MUZZLE2: "Muzzle Lv2",
  TXT_ITEM_MUZZLE3: "Muzzle Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "SG Ammo",
  TXT_ITEM_SIGHT2: "2x Scope",
  TXT_ITEM_SIGHT4: "4x Scope",
  TXT_ITEM_SILENCER1: "Peredam suara",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "SMG Ammo",
  TXT_ITEM_SNAMMO: "Sniper Ammo",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Vest Lv1",
  TXT_ITEM_VEST2: "Vest Lv2",
  TXT_ITEM_VEST3: "Vest Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Hasil",
  TXT_MESSAGEBOX_ERROR: "Error",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipod",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Oil Barrel",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Crazy Slayer",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Mexican Grilled Corn",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Jarak Ledak",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "The Executioner",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Landmine",
  TXT_OB11_HQW_LANDMINE_DESC: "Ranjau yang bisa ditanam di tanah. Peringatan, jangan diinjak sendiri!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Applause",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Chicken",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Hello!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provoke",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Saat menggunakan shotgun, kecepatan berlari bertambah [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Extremely Agile",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Cheetah: Fang",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Futuristic",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Repair Kit",
  TXT_OB5_HISTORY_HEADSHOOT: "Headshot",
  TXT_OB5_HISTORY_LIVE: "Survival",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Memakan jamur dan menggunakan med kit lebih cepat [FFB300]{0}%[-].",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Gluttony",
  TXT_OB7_ZC_CLAN_NICKNAME: "Nickname",
  TXT_OB7_ZJS_HISTORY_TIME: "Waktu",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Api Unggun",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Parasut - Bolt",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Damage tinju naik [FFB300]{0}%[-].",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Purple Meadows",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Atom Splitter",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Withered",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Skysplitter",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Snow Leopard",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Arms-dealing",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Green Star",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Gloo Wall",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Digital Camouflage",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Bloody Mary",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Desert Hunter",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Blueflame",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Purple Parade",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Lifestream",
  TXT_OB9_ZXR_M1873_NAME: "Deep Blue Sea",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Swordfish",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Harvester",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Purple Quartz",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Scorched Earth",
  TXT_OPTION_HIGH_BRIGHTNESS: "Terang",
  TXT_PLAYER_RANK: "Ranking",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Bermuda",
  TXT_SETTING_CHANGEWEAPON: "Tombol Ganti Senjata Cepat",
  TXT_SETTING_OB4_NOTREAL: "Hitam",
  TXT_SKILL_DESC_COP: "Kerapuhan vest berkurang [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "Kecepatan lari bertambah [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "Armor Specialist",
  TXT_SKILL_NAME_NURSE: "Healing Touch",
  TXT_SKILL_NAME_RACERGIRL: "Afterburn",
  TXT_SKILL_NAME_RUNNER: "Dash Run",
  TXT_SKILL_NAME_SEAMAN: "The Will of Iron",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "Lari",
  TXT_TUTORIAL_PICKUP_LABEL0: "Senjata",
  T_34_M_WS_VFXTYPE: "Jenis VFX",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Target Serangan",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Jenis UI Pemain",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Jenis Skill Monster",
  T_45_META_WS_DESCRIPTIVECOLOR: "Warna Deskriptif",
  T_45_META_WS_GAMETIME: "Waktu Game",
  T_45_META_WS_PROPERTY: "Properti",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "UI Tipe Gaya Tombol Sosial",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Jenis Tombol",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Akselerasi",
  T_46_META_WS_A_ACCOUNTID: "ID Akun",
  T_46_META_WS_A_ACTIONTYPE: "Jenis Aksi",
  T_46_META_WS_A_ACTIVE: "Aktif",
  T_46_META_WS_A_ANGLE: "Sudut",
  T_46_META_WS_A_ANY: "Apa pun",
  T_46_META_WS_A_APPEARANCEGROUP: "Grup Penampilan",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Ekspresi Asersi",
  T_46_META_WS_A_ATTACHMENT: "Lampiran",
  T_46_META_WS_A_ATTACHMENTS: "Lampiran-lampiran",
  T_46_META_WS_A_ATTACKABLE: "Bisa Diserang",
  T_46_META_WS_A_ATTACKER: "Penyerang",
  T_46_META_WS_A_ATTACKTARGET: "Target Serangan",
  T_46_META_WS_A_AUTOPLAY: "Putar Otomatis",
  T_46_META_WS_A_AXIS: "Sumbu",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Basis",
  T_46_META_WS_A_BOUNDTARGET: "Target Terikat",
  T_46_META_WS_A_BTREE: "Pohon Perilaku",
  T_46_META_WS_A_BUFF: "Buff",
  T_46_META_WS_A_CAMERA: "Kamera",
  T_46_META_WS_A_CAPICITY: "Kapasitas",
  T_46_META_WS_A_CENTER: "Pusat",
  T_46_META_WS_A_CHANGEROTATION: "Ubah Rotasi",
  T_46_META_WS_A_CHANNEL: "Saluran",
  T_46_META_WS_A_CHASEENEMY: "Kejar Musuh",
  T_46_META_WS_A_CHILD: "Anak",
  T_46_META_WS_A_COLOR: "Warna",
  T_46_META_WS_A_COLUMN: "Kolom",
  T_46_META_WS_A_COLUMNNAME: "Nama Kolom",
  T_46_META_WS_A_COMEBACK: "Kembali",
  T_46_META_WS_A_COMPONENT: "Komponen",
  T_46_META_WS_A_CONTENT: "Konten",
  T_46_META_WS_A_COORDINATESYSTEM: "Sistem Koordinat",
  T_46_META_WS_A_COUNT: "Jumlah",
  T_46_META_WS_A_COUNTS: "Jumlah",
  T_46_META_WS_A_CREATEDENTITY: "Entitas yang Diciptakan",
  T_46_META_WS_A_CROSSPLATFORM: "Lintas Platform",
  T_46_META_WS_A_CULLINGMASK: "Culling Mask",
  T_46_META_WS_A_CURVE: "Kurva",
  T_46_META_WS_A_CUSTOMTAG: "Tag Khusus",
  T_46_META_WS_A_CUTRADIUS: "Jari-jari Potong",
  T_46_META_WS_A_DAMAGE: "Kerusakan",
  T_46_META_WS_A_DAMAGESEGMENTS: "Segmen Kerusakan",
  T_46_META_WS_A_DEGREE: "Derajat",
  T_46_META_WS_A_DELTA: "Delta",
  T_46_META_WS_A_DEPTH: "Kedalaman",
  T_46_META_WS_A_DESTVAL: "Nilai Tujuan",
  T_46_META_WS_A_DIFFICULTY: "Kesulitan",
  T_46_META_WS_A_DIRECTION: "Arah",
  T_46_META_WS_A_DISABLE: "Dinonaktifkan",
  T_46_META_WS_A_DISPLACEMENT: "Pergeseran",
  T_46_META_WS_A_DISTANCE: "Jarak",
  T_46_META_WS_A_DIVINGMAXSPEED: "Kecepatan Maksimum Menyelam",
  T_46_META_WS_A_DOTWEEN: "Terapkan Tween",
  T_46_META_WS_A_DURATION: "Durasi (dalam detik)",
  T_46_META_WS_A_EMOTE: "Emote",
  T_46_META_WS_A_ENABLE: "Aktifkan",
  T_46_META_WS_A_ENDAREACENTER: "Pusat Area Akhir",
  T_46_META_WS_A_ENDAREARANGE: "Jangkauan Area Akhir",
  T_46_META_WS_A_ENDPOSITION: "Posisi Akhir",
  T_46_META_WS_A_ENDRANK: "Peringkat Akhir",
  T_46_META_WS_A_EQUIPMENTS: "Peralatan",
  T_46_META_WS_A_EVENTID: "ID Acara",
  T_46_META_WS_A_EXPONENT: "Eksponen",
  T_46_META_WS_A_FACTION: "Faksi",
  T_46_META_WS_A_FACTORTYPE: "Jenis Faktor",
  T_46_META_WS_A_FILTERTYPE: "Jenis Filter",
  T_46_META_WS_A_FINALRADIUS: "Jari-jari Akhir",
  T_46_META_WS_A_FINDVALUE: "Temukan Nilai",
  T_46_META_WS_A_FIXEDRANGE: "Jangkauan Tetap",
  T_46_META_WS_A_FOLLOWTARGET: "Ikuti Target",
  T_46_META_WS_A_FONTCOLOR: "Warna Font",
  T_46_META_WS_A_FONTSIZE: "Ukuran Font",
  T_46_META_WS_A_FOOTBALL: "Sepak Bola",
  T_46_META_WS_A_FORCE: "Gaya",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Ketinggian Terpaksa Terjun Payung",
  T_46_META_WS_A_FORCEMODE: "Mode Gaya",
  T_46_META_WS_A_FORWARD: "Maju",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "ID Permainan",
  T_46_META_WS_A_HALFEXTENTS: "Setengah Ekstensi",
  T_46_META_WS_A_HEIGHT: "Tinggi",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Segmen Tinggi",
  T_46_META_WS_A_HITDISTANCE: "Jarak Terdampak",
  T_46_META_WS_A_HITDISTANCES: "Jarak Terdeteksi",
  T_46_META_WS_A_HITENTITIES: "Entitas Terdeteksi",
  T_46_META_WS_A_HITENTITY: "Entitas Terdampak",
  T_46_META_WS_A_HITNORMAL: "Normal Terdampak",
  T_46_META_WS_A_HITNORMALS: "Normal Terdeteksi",
  T_46_META_WS_A_HITPOINTS: "Titik Terdeteksi",
  T_46_META_WS_A_HITPOSITION: "Posisi Terdampak",
  T_46_META_WS_A_INCLUDETRIGGER: "Sertakan Pemicu",
  T_46_META_WS_A_INDEX: "Indeks",
  T_46_META_WS_A_INDEXS: "Indeks",
  T_46_META_WS_A_INITIALVELOCITY: "Kecepatan Awal",
  T_46_META_WS_A_INITRADIUS: "Jari-jari Awal",
  T_46_META_WS_A_INWALLET: "Dompet Masuk",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Apakah Bagian Bawah Terdeteksi",
  T_46_META_WS_A_ISEXIST: "Ada",
  T_46_META_WS_A_ISLOOP: "Apakah Loop",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Terpeta di Layar",
  T_46_META_WS_A_ISPAUSE: "Berhenti sejenak",
  T_46_META_WS_A_ISSIDECOLLIDING: "Apakah Sisi Terdeteksi",
  T_46_META_WS_A_ISSUCCESS: "Apakah Berhasil",
  T_46_META_WS_A_ISTOPCOLLIDING: "Apakah Bagian Atas Terdeteksi",
  T_46_META_WS_A_ITEM: "Barang",
  T_46_META_WS_A_ITEMID: "ID Barang",
  T_46_META_WS_A_ITEMS: "Barang",
  T_46_META_WS_A_ITEMTYPE: "Jenis Barang",
  T_46_META_WS_A_JERSEYTYPE: "Jenis Jersey",
  T_46_META_WS_A_KEEPVELOCITY: "Pertahankan Kecepatan",
  T_46_META_WS_A_KEY: "Kunci",
  T_46_META_WS_A_KEYCOLUMN: "Kunci Kolom",
  T_46_META_WS_A_KEYS: "Kunci",
  T_46_META_WS_A_LAYER: "Lapisan",
  T_46_META_WS_A_LAYERMASK: "Masker Lapisan",
  T_46_META_WS_A_LEFT: "Kiri",
  T_46_META_WS_A_LEFTVALUE: "Nilai Kiri",
  T_46_META_WS_A_LENGTH: "Panjang",
  T_46_META_WS_A_LEVELOBJECT: "Objek Tingkat",
  T_46_META_WS_A_LOG: "Log",
  T_46_META_WS_A_LOOKATTARGET: "Lihat ke Target",
  T_46_META_WS_A_LOOPTYPE: "Jenis Loop",
  T_46_META_WS_A_MAINCOLOR1: "Warna Utama1",
  T_46_META_WS_A_MAINCOLOR2: "Warna Utama2",
  T_46_META_WS_A_MAPCODE: "Kode Map",
  T_46_META_WS_A_MAPPEDPOSITION: "Posisi Terpeta",
  T_46_META_WS_A_MAX: "Maksimum",
  T_46_META_WS_A_MAXDISPLACEMENT: "Perpindahan Maksimal",
  T_46_META_WS_A_MAXDISTANCE: "Jarak Maksimal",
  T_46_META_WS_A_MIN: "Min",
  T_46_META_WS_A_MISSIONID: "ID Misi",
  T_46_META_WS_A_MISSIONPROGRESS: "Kemajuan Misi",
  T_46_META_WS_A_MODIFYTYPE: "Jenis Modifikasi",
  T_46_META_WS_A_MONEYTYPE: "Jenis Uang",
  T_46_META_WS_A_MUST: "Harus",
  T_46_META_WS_A_NAME: "Nama",
  T_46_META_WS_A_NEWVALUE: "Nilai Baru",
  T_46_META_WS_A_NODE: "Node",
  T_46_META_WS_A_NORMAL: "Normal",
  T_46_META_WS_A_NOT: "Tidak",
  T_46_META_WS_A_OBSERVER: "Pengamat",
  T_46_META_WS_A_OFFSET: "Offset",
  T_46_META_WS_A_OLDVALUE: "Nilai Lama",
  T_46_META_WS_A_OPERATIOMETHOD: "Metode Operasi",
  T_46_META_WS_A_OPTIONS: "Opsi",
  T_46_META_WS_A_OTHERCOLOR: "Warna Lain",
  T_46_META_WS_A_OUTFIT: "Pakaian",
  T_46_META_WS_A_OUTFITS: "Pakaian-pakaian",
  T_46_META_WS_A_OUTWALLET: "Dompet Keluar",
  T_46_META_WS_A_OWNER: "Pemilik",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Kecepatan Maksimum Terjun Payung",
  T_46_META_WS_A_PARAMS: "Param",
  T_46_META_WS_A_PARENT: "Induk",
  T_46_META_WS_A_PARENTWIDGET: "Induk Widget",
  T_46_META_WS_A_PATH: "Jalur",
  T_46_META_WS_A_PATHPOINTS: "Titik Jalur",
  T_46_META_WS_A_PHASEINDEX: "Indeks Fase",
  T_46_META_WS_A_PLATFORM: "Platform",
  T_46_META_WS_A_PLAYER: "Pemain",
  T_46_META_WS_A_PLAYSPEED: "Kecepatan Putar",
  T_46_META_WS_A_POSITION: "Posisi",
  T_46_META_WS_A_POSITIONS: "Posisi",
  T_46_META_WS_A_POSTION: "Posisi",
  T_46_META_WS_A_PREFAB: "Prefab",
  T_46_META_WS_A_PROPERTY: "Properti",
  T_46_META_WS_A_PROPERTYID: "ID Properti",
  T_46_META_WS_A_PURSUITTARGET: "Target Pengejaran",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Jari-jari",
  T_46_META_WS_A_RANDOMDECAY: "Peluruhan Acak",
  T_46_META_WS_A_RANDOMRANGE: "Rentang Acak",
  T_46_META_WS_A_RANDOMRATIO: "Rasio Acak",
  T_46_META_WS_A_RANGE: "Jangkauan",
  T_46_META_WS_A_RANK: "Peringkat",
  T_46_META_WS_A_REALCOIN: "Koin Nyata",
  T_46_META_WS_A_REALNUMBER: "Bilangan Real",
  T_46_META_WS_A_RESET: "Setel Ulang",
  T_46_META_WS_A_RESOURCE: "Sumber Daya",
  T_46_META_WS_A_RESULT: "Hasil",
  T_46_META_WS_A_RIGHT: "Kanan",
  T_46_META_WS_A_RIGHTVALUE: "Nilai Kanan",
  T_46_META_WS_A_ROTATION: "Rotasi",
  T_46_META_WS_A_ROW: "Baris",
  T_46_META_WS_A_SAMPLEPOINT: "Titik Sampel",
  T_46_META_WS_A_SCALE: "Skala",
  T_46_META_WS_A_SCENEID: "ID Pemandangan",
  T_46_META_WS_A_SCORE: "Skor",
  T_46_META_WS_A_SCORENAME: "Nama Skor",
  T_46_META_WS_A_SCREENPOSITION: "Posisi Layar",
  T_46_META_WS_A_SCRIPT: "Skrip",
  T_46_META_WS_A_SEAT: "Kursi",
  T_46_META_WS_A_SEP: "Pemisah",
  T_46_META_WS_A_SEPSTR: "Pemisah",
  T_46_META_WS_A_SHEETNAME: "Nama Lembar",
  T_46_META_WS_A_SHOPITEM: "Barang Toko",
  T_46_META_WS_A_SHOWBACKGROUND: "Tampilkan Latar Belakang",
  T_46_META_WS_A_SHOWMATCHRESULT: "Tampilkan Hasil Permainan",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Tampilkan Pesan Saat Dibatalkan",
  T_46_META_WS_A_SKILL: "Keterampilan",
  T_46_META_WS_A_SKILLS: "Skill",
  T_46_META_WS_A_SKILLTARGET: "Target Skill",
  T_46_META_WS_A_SKIN: "Skin Backpack",
  T_46_META_WS_A_SLOT: "Slot",
  T_46_META_WS_A_SRCVAL: "Nilai Sumber",
  T_46_META_WS_A_SRCVALUE: "Nilai Sumber",
  T_46_META_WS_A_STARTAREACENTER: "Pusat Area Awal",
  T_46_META_WS_A_STARTAREARANGE: "Jangkauan Area Awal",
  T_46_META_WS_A_STARTINDEX: "Indeks Awal",
  T_46_META_WS_A_STARTPOSITION: "Posisi Awal",
  T_46_META_WS_A_STARTRANK: "Peringkat Awal",
  T_46_META_WS_A_STATE: "Status",
  T_46_META_WS_A_STATUS: "Status",
  T_46_META_WS_A_STATUSCODE: "Kode Status",
  T_46_META_WS_A_STYLE: "Gaya",
  T_46_META_WS_A_SURFINGMAXSPEED: "Kecepatan Maksimum Selancar",
  T_46_META_WS_A_TARGET: "Target",
  T_46_META_WS_A_TARGETPOSITION: "Posisi Target",
  T_46_META_WS_A_TEAMSEQ: "Urutan Tim",
  T_46_META_WS_A_THRESHOLD: "Ambang",
  T_46_META_WS_A_TIMESTAMP: "Stempel Waktu",
  T_46_META_WS_A_TIPS: "Tips",
  T_46_META_WS_A_TITLE: "Judul",
  T_46_META_WS_A_TOKENCOUNT: "Jumlah Token",
  T_46_META_WS_A_TOKENID: "ID Token",
  T_46_META_WS_A_TORQUE: "Torsi",
  T_46_META_WS_A_TOUCHPOINT: "Titik Sentuh",
  T_46_META_WS_A_TRANSITIONTIME: "Waktu Transisi (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "Jenis Transisi",
  T_46_META_WS_A_TRIGGER: "Pemicu",
  T_46_META_WS_A_TYPE: "Jenis",
  T_46_META_WS_A_UI: "Antarmuka Pengguna (UI)",
  T_46_META_WS_A_UIID: "ID UI",
  T_46_META_WS_A_UPWARD: "Ke Atas",
  T_46_META_WS_A_VALUE: "Nilai",
  T_46_META_WS_A_VALUEA: "Nilai A",
  T_46_META_WS_A_VALUEB: "Nilai B",
  T_46_META_WS_A_VALUES: "Nilai",
  T_46_META_WS_A_VALUET: "NilaiT",
  T_46_META_WS_A_VALUETYPE: "Tipe Nilai",
  T_46_META_WS_A_VEHICLE: "Kendaraan",
  T_46_META_WS_A_VEHICLESKIN: "Skin Kendaraan",
  T_46_META_WS_A_VELOCITY: "Kecepatan",
  T_46_META_WS_A_VELOCITYXZ: "Kecepatan XZ",
  T_46_META_WS_A_VELOCITYY: "Kecepatan Y",
  T_46_META_WS_A_VISIBLE: "Terlihat",
  T_46_META_WS_A_WAITTIME: "Waktu Tunggu (dalam detik)",
  T_46_META_WS_A_WALLET: "Dompet",
  T_46_META_WS_A_WEAPON: "Senjata",
  T_46_META_WS_A_WEAPONSKIN: "Skin Senjata",
  T_46_META_WS_A_WIDGETID: "ID Widget",
  T_46_META_WS_A_WIDGETTYPE: "Jenis Widget",
  T_46_META_WS_A_WIDTH: "Lebar",
  T_46_META_WS_A_WORLDPOSITION: "Posisi Dunia",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Posisi Dunia Tetap",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Nilai Mutlak",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Tambahkan Ikuti Khusus AOI",
  T_46_META_WS_ADDATTACHMENTS: "Tambahkan Lampiran",
  T_46_META_WS_ADDBUFF: "Tambahkan Buff",
  T_46_META_WS_ADDCOMPONENT: "Tambah Komponen",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Tambah Kecepatan Bola",
  T_46_META_WS_ADDFORCE: "Tambahkan Gaya",
  T_46_META_WS_ADDFORCEATPOSITION: "Tambahkan Gaya di Posisi",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Tambah Faktor Properti Formula",
  T_46_META_WS_ADDGAMEEVENTLOG: "Tambahkan Log Acara Game",
  T_46_META_WS_ADDHP: "Tambah HP",
  T_46_META_WS_ADDITEM: "Tambahkan Item",
  T_46_META_WS_ADDITEMINSCENE: "Buat Item di Scene",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Tambah Item ke Item Toko",
  T_46_META_WS_ADDMONEY: "Tambah Uang",
  T_46_META_WS_ADDSCRIPT: "Tambah Skrip",
  T_46_META_WS_ADDTAG: "Tambah Tag",
  T_46_META_WS_ADDTOKEN: "Tambah Token",
  T_46_META_WS_ADDTORQUE: "Tambahkan Torsi",
  T_46_META_WS_ADDUSEREVENTLOG: "Tambahkan Log Acara Pengguna",
  T_46_META_WS_ANGEL: "Angel",
  T_46_META_WS_APPEND: "Tambah",
  T_46_META_WS_APPENDRANGE: "Tambah Rentang",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Terapkan Konfigurasi Keluar di Tengah",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "Tegaskan",
  T_46_META_WS_ASSISTPLAYER: "Pemain Asist",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Penyerang",
  T_46_META_WS_ATTACKTARGET: "Target Serangan",
  T_46_META_WS_AXISANGLETOQUATERNION: "Sudut Sumbu ke Quaternion",
  T_46_META_WS_BOXCAST: "Box Cast",
  T_46_META_WS_BOXOVERLAP: "Box Overlap",
  T_46_META_WS_BUTTONNAME: "Nama Tombol",
  T_46_META_WS_C_ACTIONTYPE: "Jenis Tindakan",
  T_46_META_WS_C_AIMABLE: "Komponen yang Dapat Ditargetkan",
  T_46_META_WS_C_AIMASSISTABLE: "Komponen yang Dapat Dibantu",
  T_46_META_WS_C_AIMASSISTTYPE: "Jenis Bantuan Bidik",
  T_46_META_WS_C_AIRDROP: "Jatuhan Udara",
  T_46_META_WS_C_AMMO: "Amunisi",
  T_46_META_WS_C_AMMOTYPE: "Jenis Amunisi",
  T_46_META_WS_C_AMPHIBIAN: "Amfibi",
  T_46_META_WS_C_ANIMATIONCLIP: "Klip Animasi",
  T_46_META_WS_C_ANIMATIONCLIPID: "ID Klip Animasi",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Pengendali Animasi",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Controlador de Animación Acoplable",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "ID Pengendali Animasi",
  T_46_META_WS_C_ANIMATIONSTATE: "Status Animasi",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Pemicu Animasi",
  T_46_META_WS_C_APPEARENCE: "Tampilan",
  T_46_META_WS_C_ASSETCONFIGID: "ID Konfigurasi Aset",
  T_46_META_WS_C_ASSETID: "ID Aset",
  T_46_META_WS_C_ATTACHMENT: "Aksesori",
  T_46_META_WS_C_ATTACKABLETYPE: "Jenis yang Dapat Diserang",
  T_46_META_WS_C_AUDIOID: "ID Audio",
  T_46_META_WS_C_BACKPACK: "Ransel",
  T_46_META_WS_C_BACKPACKSKINID: "ID Kulit Ransel",
  T_46_META_WS_C_BASEDATAALIAS: "Alias Data Dasar",
  T_46_META_WS_C_BASICAPPEARANCE: "Penampilan Dasar",
  T_46_META_WS_C_BASICCYLINDER: "Silinder atau Kerucut Dasar",
  T_46_META_WS_C_BASICSCALABLE: "Dasar yang Dapat Diperbesar",
  T_46_META_WS_C_BASICSPHERE: "Bola Dasar",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Komponen Gabungan Batch",
  T_46_META_WS_C_BEVTREE: "Pohon Perilaku",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Entitas yang Dapat Ditempelkan ke Pohon Perilaku",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Node Kustom Pohon Perilaku",
  T_46_META_WS_C_BEVTREEID: "ID Pohon Perilaku",
  T_46_META_WS_C_BEVTREENODESTATUS: "Status Node Pohon Perilaku",
  T_46_META_WS_C_BEVTREENODETYPE: "Jenis Node Pohon Perilaku",
  T_46_META_WS_C_BEZIERCURVE: "Kurva Bezier",
  T_46_META_WS_C_BOOL: "Bool",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Jenis Kesulitan Bot",
  T_46_META_WS_C_BOUNCINGTIRE: "Ban Lompat",
  T_46_META_WS_C_BUFFABLE: "Buffable",
  T_46_META_WS_C_BUFFGENERATOR: "Pembuat Buff",
  T_46_META_WS_C_BUFFTYPE: "Jenis Buff",
  T_46_META_WS_C_BUILTINRENDER: "Render Bawaan",
  T_46_META_WS_C_BUILTINUI: "UI Bawaan",
  T_46_META_WS_C_BUILTINUITYPE: "Jenis UI Bawaan",
  T_46_META_WS_C_CAMERA: "Kamera",
  T_46_META_WS_C_CAMERABLOCKMODE: "Mode Pemblokiran Kamera",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Mode Proyeksi Kamera",
  T_46_META_WS_C_CAMERARAYCASTUI: "UI RayCast Kamera",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Jenis Transisi Kamera",
  T_46_META_WS_C_CAMERATYPE: "Jenis Kamera",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Jenis Pembatasan Sudut Pandang Kamera",
  T_46_META_WS_C_CAPSULETRIGGER: "Pemicu Kapsul",
  T_46_META_WS_C_CAR: "Mobil",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Pengontrol Karakter",
  T_46_META_WS_C_CHATCHANNEL: "Saluran Obrolan",
  T_46_META_WS_C_CHATCHANNELTYPE: "Jenis Saluran Obrolan",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Pemicu Titik Cek",
  T_46_META_WS_C_COINGENERATOR: "Pembuat Koin",
  T_46_META_WS_C_COLLECTIONID: "ID Koleksi",
  T_46_META_WS_C_COLLIDER: "Penahan",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Bentuk Collider",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ID Koleksi Kolider",
  T_46_META_WS_C_COLORDRUM: "Drum Warna",
  T_46_META_WS_C_COMBATABLE: "Combatible",
  T_46_META_WS_C_COMPONENT: "Komponen",
  T_46_META_WS_C_CONDITION: "Kondisi",
  T_46_META_WS_C_CONTAINER: "Kontainer",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Jenis Sistem Koordinat",
  T_46_META_WS_C_CROSSBOW: "Busur Granat",
  T_46_META_WS_C_CSVID: "ID CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Pemicu Kustom",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Objek Kustom",
  T_46_META_WS_C_CUSTOMPATH: "Jalur Kustom",
  T_46_META_WS_C_CUSTOMUI: "UI Kustom",
  T_46_META_WS_C_CUSTOMUIID: "UI ID Kustom",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "UI Kustom atau Widget",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "ID Widget Kustom",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Jenis Bagian Tubuh yang Rusak",
  T_46_META_WS_C_DAMAGETYPE: "Jenis Kerusakan",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Pemicu Kematian atau Kekebalan",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Objek yang Dapat Dirusak",
  T_46_META_WS_C_DICE: "Dadu",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Sepatu Lompat Ganda",
  T_46_META_WS_C_DRUMMUSIC: "Musik Drum",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Jenis Senjata Ganda",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Objek Level Umum",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Jenis Objek yang Dapat Dibuat Secara Dinamis",
  T_46_META_WS_C_DYNAMICFENCE: "Pagar Dinamis",
  T_46_META_WS_C_EFFECT: "Efek",
  T_46_META_WS_C_EFFECTCONTAINER: "Kontainer Efek",
  T_46_META_WS_C_EFFECTID: "ID Efek",
  T_46_META_WS_C_EMOTETYPE: "Jenis Emote",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Pemicu Titik Akhir",
  T_46_META_WS_C_ENTITY: "Entitas",
  T_46_META_WS_C_ENTITYORPREFABID: "Entitas atau ID Prefab",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Aksesori Peralatan",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Jenis Slot Perlengkapan",
  T_46_META_WS_C_EQUIPMENTTYPE: "Jenis Perlengkapan",
  T_46_META_WS_C_EVENTID: "ID Acara",
  T_46_META_WS_C_FACTION: "Fraksi",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Jenis Arah Pengisian",
  T_46_META_WS_C_FILLTYPE: "Jenis Pengisian",
  T_46_META_WS_C_FIRETYPE: "Jenis Api",
  T_46_META_WS_C_FLOAT: "Float",
  T_46_META_WS_C_FOLDWING: "Sayap Lipat",
  T_46_META_WS_C_FOLLOW: "Mengikuti",
  T_46_META_WS_C_FONTTYPE: "Jenis Font",
  T_46_META_WS_C_FOOTBALL: "Sepak Bola",
  T_46_META_WS_C_FORCETYPE: "Jenis Gaya",
  T_46_META_WS_C_FORMULABLE: "Dapat Diformulasikan",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Gerakan Relatif Sendiri per Frame",
  T_46_META_WS_C_GAMERESULTTYPE: "Jenis Hasil Permainan",
  T_46_META_WS_C_GENDERTYPE: "Jenis Kelamin",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Titik Spawn Umum",
  T_46_META_WS_C_GRENADEDEICEWALL: "Granat DeIce Wall",
  T_46_META_WS_C_GRENADEFLASHBANG: "Granat Penyilau",
  T_46_META_WS_C_GRENADEFROZEN: "Granat Pembeku",
  T_46_META_WS_C_GRENADELAUNCHER: "Peluncur Granat",
  T_46_META_WS_C_GRENADESMOKE: "Granat Asap",
  T_46_META_WS_C_GRENADEWEAPON: "Dasar Granat",
  T_46_META_WS_C_GRID: "Grid",
  T_46_META_WS_C_HANDCANNON: "Granat Handcannon",
  T_46_META_WS_C_HELMET: "Helm",
  T_46_META_WS_C_HIERARCHICAL: "Hierarkis",
  T_46_META_WS_C_HOOKGUN: "Senjata Hook",
  T_46_META_WS_C_HORIZALINE: "Garis Horisontal",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "Transformasi UI",
  T_46_META_WS_C_HUMANMODELID: "ID Model Manusia",
  T_46_META_WS_C_ICEWALL: "Dinding Es",
  T_46_META_WS_C_ICEWALLCREATED: "Dinding Es yang Dibuat",
  T_46_META_WS_C_ICEWALLMAKER: "Pembuat Dinding Es",
  T_46_META_WS_C_ICON: "Entitas Ikon",
  T_46_META_WS_C_ICONTYPE: "Jenis Ikon",
  T_46_META_WS_C_INHALER: "Inhaler",
  T_46_META_WS_C_INT: "Bilangan Bulat",
  T_46_META_WS_C_INT64: "Bilangan Bulat 64-bit",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Template Peta Integer",
  T_46_META_WS_C_INTORINTLIST: "Bilangan Bulat atau Daftar Bilangan",
  T_46_META_WS_C_INVENTORYTYPE: "Jenis Inventaris",
  T_46_META_WS_C_ITEMBASE: "Basis Barang",
  T_46_META_WS_C_ITEMCONTAINER: "Kontainer Barang",
  T_46_META_WS_C_ITEMID: "ID Barang",
  T_46_META_WS_C_ITEMIDTYPE: "Jenis ID Barang",
  "T_46_META_WS_C_JERSEY STYLE": "Gaya Jersey",
  T_46_META_WS_C_JERSEYMACHINE: "Mesin Jersey",
  T_46_META_WS_C_JETSHOES: "Sepatu Jet",
  T_46_META_WS_C_KEYBOARD: "Keyboard",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Jenis Knock-down",
  T_46_META_WS_C_LANDMINE: "Ranjau Tanah",
  T_46_META_WS_C_LANDMINECREATED: "Landmine yang Dibuat",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Objek Level Peluncur",
  T_46_META_WS_C_LAUNCHPAD: "Peluncur Roket",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Jenis Pengurutan Tata Letak",
  T_46_META_WS_C_LEAD1MUSIC: "Musik Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "Musik Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "Musik Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "ID Objek Level",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Jenis Objek Level",
  T_46_META_WS_C_LIST: "Daftar",
  T_46_META_WS_C_LISTORMAP: "Daftar atau Peta",
  T_46_META_WS_C_LISTT: "Template Daftar",
  T_46_META_WS_C_LISTT_BOOL: "Daftar Bool",
  T_46_META_WS_C_LISTT_CONDITION: "Daftar Kondisi",
  T_46_META_WS_C_LISTT_ENTITY: "Daftar Entitas",
  T_46_META_WS_C_LISTT_FLOAT: "Daftar float",
  T_46_META_WS_C_LISTT_INT: "Daftar Integer",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Daftar Item",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Daftar Objek Level",
  T_46_META_WS_C_LISTT_LOCKEY: "Daftar kunci lokal",
  T_46_META_WS_C_LISTT_PLAYABLE: "Daftar yang Dapat Dimainkan",
  T_46_META_WS_C_LISTT_PLAYER: "Daftar Pemain",
  T_46_META_WS_C_LISTT_SKILLID: "Daftar ID keterampilan",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Daftar Efek Suara",
  T_46_META_WS_C_LISTT_STRING: "Daftar string",
  T_46_META_WS_C_LISTT_TEAM: "Daftar Tim",
  T_46_META_WS_C_LISTT_TYPE: "Daftar Tipe",
  T_46_META_WS_C_LISTT_VECTOR3: "Daftar Vector3",
  T_46_META_WS_C_LOCKEY: "Kunci Lokalisasi",
  T_46_META_WS_C_LOOKAT: "Melihat ke",
  T_46_META_WS_C_LOOPABLE: "Dapat Diputar",
  T_46_META_WS_C_LOOPTYPE: "Jenis Loop",
  T_46_META_WS_C_LOOTAMMOTYPE: "Jenis Amunisi Loot",
  T_46_META_WS_C_LOOTARMOR: "Armor Loot",
  T_46_META_WS_C_LOOTARMORTYPE: "Jenis Armor Loot",
  T_46_META_WS_C_LOOTCONSUMABLE: "Konsumable Loot",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Jenis Konsumable Loot",
  T_46_META_WS_C_LOOTIAMMO: "Amunisi Loot",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Kotak Loot Sepak Bola",
  T_46_META_WS_C_LOOTSCOPE: "Scope Loot",
  T_46_META_WS_C_LOOTSCOPETYPE: "Jenis Scope Loot",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Jenis Loot Sepak Bola",
  T_46_META_WS_C_LOOTTHROWABLE: "Barang Lempar Loot",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Jenis Barang Lempar Loot",
  T_46_META_WS_C_LOOTWEAPON: "Senjata Loot",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Jenis Senjata Loot",
  T_46_META_WS_C_LOWGRAVITY: "Area Gravitasi Rendah",
  T_46_META_WS_C_MAP: "Peta",
  T_46_META_WS_C_MAPT: "Template Peta",
  T_46_META_WS_C_MATERIALID: "ID Material",
  T_46_META_WS_C_MEDKIT: "Kot Pertolongan Pertama",
  T_46_META_WS_C_MESHID: "ID Jaring",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Konfigurasi Keluar Pertengahan Permainan",
  T_46_META_WS_C_MINIMAP: "Mini Peta",
  T_46_META_WS_C_MINIMAPICON: "Ikon Mini Peta",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Renderer Piksel Mini Map",
  T_46_META_WS_C_MINISENTRY: "Mini Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Jenis Jangkauan Serangan Mini Sentry",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini Sentry yang Dibuat",
  T_46_META_WS_C_MONEY: "Uang",
  T_46_META_WS_C_MONEYTYPE: "Jenis Uang",
  T_46_META_WS_C_MONSTER: "Monster",
  T_46_META_WS_C_MONSTERSPAWN: "Spawn Monster",
  T_46_META_WS_C_MONSTERTYPE: "Jenis Monster",
  T_46_META_WS_C_MORPHABLEOBJECT: "Objek yang Dapat Dimorf",
  T_46_META_WS_C_MORPHOBJECT: "Objek Morf",
  T_46_META_WS_C_MOTOBIKE: "Sepeda Motor",
  T_46_META_WS_C_MOVEPLATFORM: "Platform Gerak",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Jenis Platform Gerak",
  T_46_META_WS_C_MUSHROOM: "Jamur",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Konstanta Alam",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Angka",
  T_46_META_WS_C_OBJECT: "Objek",
  T_46_META_WS_C_OILDRUM: "Drum Minyak",
  T_46_META_WS_C_OUTFITID: "ID Pakaian",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Jenis Slot Pakaian",
  T_46_META_WS_C_PATHPOINT: "Titik Jalur",
  T_46_META_WS_C_PATROLSTYLETYPE: "Jenis Gaya Patroli",
  T_46_META_WS_C_PATROLTYPE: "Jenis Patroli",
  T_46_META_WS_C_PERSONA: "Persona",
  T_46_META_WS_C_PHASE: "Fase",
  T_46_META_WS_C_PHYSICALMOVER: "Penggerak Fisik",
  T_46_META_WS_C_PHYSICALOBJECT: "Objek Fisik",
  T_46_META_WS_C_PLATFORMTYPE: "Jenis Platform",
  T_46_META_WS_C_PLAYABLE: "Dapat Dimainkan",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Playable atau Array Playables",
  T_46_META_WS_C_PLAYER: "Pemain",
  T_46_META_WS_C_PLAYERBACKPACK: "Ransel Pemain",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Jenis Status Perilaku Pemain",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Jenis Perilaku Pemain",
  T_46_META_WS_C_PLAYERCCT: "CCT Pemain",
  T_46_META_WS_C_PLAYERDATAID: "Tipe Karakter Praaturan",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Pemain atau Transformasi",
  T_46_META_WS_C_PLAYERORVEHICLE: "Pemain atau Kendaraan",
  T_46_META_WS_C_PLAYEROUTFIT: "Pakaian Pemain",
  T_46_META_WS_C_PLAYERPOSETYPE: "Tipe Pose Pemain",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Jenis Sumber Revival Pemain",
  T_46_META_WS_C_PLAYERSTATETYPE: "Tipe Status Pemain",
  T_46_META_WS_C_POINTLIGHT: "Lampu Titik",
  T_46_META_WS_C_PORTAL: "Portal",
  T_46_META_WS_C_PREFABID: "ID Prefab",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Generator Efek Presentasi",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Jenis Tekstur Efek",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Widget Foto Profil",
  T_46_META_WS_C_PROPERTY: "Properti",
  T_46_META_WS_C_PROPERTYFORMULA: "Rumus Properti",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Jenis Faktor Rumus Properti",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Jenis Modifikasi Properti",
  T_46_META_WS_C_QUATERNION: "Kuaternion",
  T_46_META_WS_C_RANKABLE: "Clasificable",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Jenis Lapisan Ray Cast",
  T_46_META_WS_C_REPAIRKIT: "Kit Perbaikan",
  T_46_META_WS_C_RESETABLE: "Dapat Direset",
  T_46_META_WS_C_RIGIDBODY: "Rigidbody",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Jenis Pembatas Rigidbody",
  T_46_META_WS_C_RIGIDBODYTYPE: "Jenis Rigidbody",
  T_46_META_WS_C_ROUND: "Putaran",
  T_46_META_WS_C_SAFEZONE: "Zona Aman",
  T_46_META_WS_C_SCOREABLE: "Puntuable",
  T_46_META_WS_C_SCRIPTID: "ID Skrip",
  T_46_META_WS_C_SEATTYPE: "Jenis Kursi",
  T_46_META_WS_C_SELFRELATIVE: "Relatif Sendiri",
  T_46_META_WS_C_SHOP: "Toko",
  T_46_META_WS_C_SHOPITEM: "Item Toko",
  T_46_META_WS_C_SHOPSHELF: "Rak Toko",
  T_46_META_WS_C_SKATEBOARD: "Skateboard",
  T_46_META_WS_C_SKELETON: "Kerangka",
  T_46_META_WS_C_SKELETONPART: "Bagian Tulang",
  T_46_META_WS_C_SKILLID: "ID Keterampilan",
  T_46_META_WS_C_SKYBLASTER: "Skyblaster",
  T_46_META_WS_C_SKYBOX: "Kotak Langit",
  T_46_META_WS_C_SKYBOXTYPE: "Jenis Kotak Langit",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Bola Salju Pulau Sosial",
  T_46_META_WS_C_SORTTYPE: "Jenis Penyortiran",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Jenis Suara Drum",
  T_46_META_WS_C_SOUNDEFFECT: "Efek Suara",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Efek Suara atau Daftar Efek Suara",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Jenis Efek Suara",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Jenis Suara Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Jenis Suara Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Jenis Suara Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Jenis Suara Piano",
  T_46_META_WS_C_SPAWN: "Spawn",
  T_46_META_WS_C_SPAWNABLE: "Spawnable",
  T_46_META_WS_C_SPAWNBOX: "Zona Spawn",
  T_46_META_WS_C_SPAWNPOSITION: "Titik Spawn",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Jenis ID Barang Khusus",
  T_46_META_WS_C_SPHERETRIGGER: "Pemicu Bola",
  T_46_META_WS_C_SPORTSCAR: "Mobil Sport",
  T_46_META_WS_C_SPRAYCOLOR: "Warna Semprot",
  T_46_META_WS_C_SPRAYGUN: "Senapan Semprot",
  T_46_META_WS_C_SPRAYRESULTUI: "UI Hasil Spray",
  T_46_META_WS_C_SPRAYRIFLE: "Senapan Semprot",
  T_46_META_WS_C_SPRITEID: "ID Sprite",
  T_46_META_WS_C_STATICSCRIPTID: "ID Skrip Statis",
  T_46_META_WS_C_STRING: "String",
  T_46_META_WS_C_STRINGORLOCSTRING: "String atau String Lokalisasi",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Pemicu Kotak Pasokan",
  T_46_META_WS_C_SWINGGUN: "Senjata Ayun",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Beralih Slot Perlengkapan",
  T_46_META_WS_C_TEAM: "Tim",
  T_46_META_WS_C_TERRAIN: "Medan",
  T_46_META_WS_C_TEXT: "Entitas Teks",
  T_46_META_WS_C_TEXTUREID: "ID Tekstur",
  T_46_META_WS_C_TEXTURETYPE: "Tekstur Objek",
  T_46_META_WS_C_TIMER: "Penghitung Waktu",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Jenis Gaya Format Timestamp",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "String Lokalisasi Cap Waktu",
  T_46_META_WS_C_TRAJECTORY: "Trajektori",
  T_46_META_WS_C_TRANSFORM: "Transformasi",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Menara",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Kurva Tween",
  T_46_META_WS_C_TWEENSTYLE: "Jenis Gaya Tween",
  T_46_META_WS_C_TYPE: "Jenis",
  T_46_META_WS_C_TYPEENUM: "Enum Tipe",
  T_46_META_WS_C_TYPEORTYPELIST: "Jenis atau Daftar Tipe",
  T_46_META_WS_C_UIADDSCORE: "UI Tambah Skor",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI Pemicu Animasi HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "Sakelar Bawaan UI",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI Kontrol Sakelar Bawaan",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI Panel Pemilihan Kartu",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI Indikator Check Point",
  T_46_META_WS_C_UICOMPASS: "UI Kompas",
  T_46_META_WS_C_UICOUNTDOWN5: "UI Hitung Mundur 5 Detik",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI Petunjuk Hitung Mundur",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI Pengingat Hitung Mundur",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Bar Health di atas Kepala Karakter",
  T_46_META_WS_C_UIHEALTHBAR: "UI Health Bar",
  T_46_META_WS_C_UIHEARTBEAT: "UI Detak Jantung",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI Notifikasi Ikon",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI Notifikasi Identitas",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI Tombol Interaksi",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI Leaderboard",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI Subtitle Pertandingan",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI Level Monster",
  T_46_META_WS_C_UIMONSTERUI: "UI Monster",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI Leaderboard Multi-Tim",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI Panel Hasil Multi-Tim",
  T_46_META_WS_C_UIOPENINGBANNER: "UI Banner Pembukaan",
  T_46_META_WS_C_UIPANEL: "UI Panel",
  T_46_META_WS_C_UIPANELEMPTY: "UI Panel Kosong",
  T_46_META_WS_C_UIPHASETIMER: "UI Penghitung Waktu Fase",
  T_46_META_WS_C_UIPROGRESSBAR: "UI Bar Progress",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI Lingkaran Progres",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI Tombol Progress Skill",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI Jenis Permintaan Pembelian",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI Info Ronde",
  T_46_META_WS_C_UIROUNDNUMBER: "UI Nomor Ronde",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI Banner Hasil Ronde",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI Banner Awal Ronde",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI Transisi Ronde",
  T_46_META_WS_C_UISCOREBAR: "UI Score Bar",
  T_46_META_WS_C_UISCROLLPANEL: "UI Panel Scroll",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI Banner Skor Ronde Tim",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI Banner Awal Ronde Sederhana",
  T_46_META_WS_C_UISIMPLETIP: "UI Tip Sederhana",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI Banner Versus Sederhana",
  T_46_META_WS_C_UISKILLBUTTON: "UI Tombol Skill",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "UI Widget Tombol Sosial",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI Papan Peringkat Solo",
  T_46_META_WS_C_UISTORE: "UI Toko",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI Info Pertandingan Tim",
  T_46_META_WS_C_UITEXTTIP: "UI Tips Teks",
  T_46_META_WS_C_UITIMERINFO: "UI Penghitung Waktu",
  T_46_META_WS_C_UITIPBUTTON: "UI Tombol Tip",
  T_46_META_WS_C_UITITLEBANNER: "UI Banner Title",
  T_46_META_WS_C_UITWEENTIP: "UI Tip Animasi",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI Info Singkat Dua Tim",
  T_46_META_WS_C_UITWOTEAMINFO: "UI Info Dua Tim",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI Leaderboard Dua Tim",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI Panel Hasil Dua Tim",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI Banner Skor Ronde Dua Tim",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI Panel Skor Dua Tim",
  T_46_META_WS_C_UIVERSUSBANNER: "UI Banner Versus",
  T_46_META_WS_C_UIWIDGET: "UI Widget",
  T_46_META_WS_C_UIWIDGETBUTTON: "Tombol Widget UI",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI Kontainer Widget",
  T_46_META_WS_C_UIWIDGETEMPTY: "UI Widget Kosong",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI Gambar Widget",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI Label Input Widget",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI Joystick Widget",
  T_46_META_WS_C_UIWIDGETLABEL: "UI Label Widget",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI Tata Letak Widget",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI Profile Widget",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI Tekstur Widget",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI Sakelar Widget",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI Widget Touchpad",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI Banner Menang atau Kalah",
  T_46_META_WS_C_UNITSPAWN: "Pembuat Unit",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Objek Logika Pendakian Jendela",
  T_46_META_WS_C_VECTOR2: "Vektor2",
  T_46_META_WS_C_VECTOR3: "Vektor3",
  T_46_META_WS_C_VEHICLE: "Kendaraan",
  T_46_META_WS_C_VEHICLEIDTYPE: "Jenis ID Kendaraan",
  T_46_META_WS_C_VEHICLESKINID: "ID Kulit Kendaraan",
  T_46_META_WS_C_VENDINGMACHINE: "Mesin Penjual",
  T_46_META_WS_C_VEST: "Rompi",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Entitas Tekstur VFX yang Dapat Diganti",
  T_46_META_WS_C_VFXTEXTURE: "Tekstur VFX",
  T_46_META_WS_C_VISIBILITY: "Visibilitas",
  T_46_META_WS_C_WALLET: "Dompet",
  T_46_META_WS_C_WALLETHUD: "UI Dompet",
  T_46_META_WS_C_WATERZONE: "Zona Air",
  T_46_META_WS_C_WAVECOUNTTYPE: "Jenis Hitung Gelombang",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Jenis Interval Gelombang",
  T_46_META_WS_C_WEAPON: "Senjata",
  T_46_META_WS_C_WEAPONGENERATOR: "Generator Senjata",
  T_46_META_WS_C_WEAPONSKINID: "ID Kulit Senjata",
  T_46_META_WS_C_WEAPONTYPE: "Jenis Senjata",
  T_46_META_WS_C_WIDGETTYPE: "Jenis Widget",
  T_46_META_WS_C_ZIPLINE: "Tali Zip",
  T_46_META_WS_CAMERADIRECTION: "Arah Kamera",
  T_46_META_WS_CAMERAPOSITION: "Posisi Kamera",
  T_46_META_WS_CAPSULECAST: "Capsule Cast",
  T_46_META_WS_CAPSULEOVERLAP: "Capsule Overlap",
  T_46_META_WS_CEIL: "Langit-langit",
  T_46_META_WS_CHATCHANNEL: "Saluran Obrolan",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Periksa Trigger Berdasarkan Urutan",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "Kosongkan",
  T_46_META_WS_CLEARALLCHILDREN: "Hapus Semua Anak",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Bersihkan Ikuti Khusus AOI",
  T_46_META_WS_CLEARBACKPACK: "Kosongkan Backpack",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Hapus Faktor Properti Formula",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Hapus Objek Level Sisa",
  T_46_META_WS_CLIPNAME: "Nama Klip",
  T_46_META_WS_CLONE: "Kloning",
  T_46_META_WS_COLLIDEDENTITY: "Entitas Bertabrakan",
  T_46_META_WS_COLORGET: "Dapatkan Warna",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Selesaikan Misi Kustom",
  T_46_META_WS_CONNECT: "Sambungkan",
  T_46_META_WS_CONSUMABLEID: "ID Item",
  T_46_META_WS_CONTAIN: "Mengandung",
  T_46_META_WS_CONTAINKEY: "Mengandung Key",
  T_46_META_WS_COPYTOMORPH: "Salin ke Perubahan",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Biaya Uang",
  T_46_META_WS_COSTTOKEN: "Gunakan Token",
  T_46_META_WS_CREATEAIRDROP: "Buat Drop Udara",
  T_46_META_WS_CREATEBOT: "Buat Bot",
  T_46_META_WS_CREATEBUILTINUI: "Buat UI Bawaan",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Buat UI Bawaan",
  T_46_META_WS_CREATECAMERA: "Buat Kamera",
  T_46_META_WS_CREATECURVE: "Buat Kurva",
  T_46_META_WS_CREATECUSTOMUI: "Buat UI Kustom",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Buat UI Kustom",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Buat Widget UI Kustom",
  T_46_META_WS_CREATEDAMAGENUM: "Buat Angka Kerusakan",
  T_46_META_WS_CREATEEFFECT: "Buat Efek",
  T_46_META_WS_CREATEEFFECTCLIENT: "Buat Efek",
  T_46_META_WS_CREATEFACTION: "Buat Fraksi",
  T_46_META_WS_CREATEFOLLOW: "Buat Ikuti",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Buat Relatif Diri Per Frame",
  T_46_META_WS_CREATEFROMPREFAB: "Buat dari Prefab",
  T_46_META_WS_CREATELEVELOBJECT: "Buat Objek Level",
  T_46_META_WS_CREATELOOKAT: "Buat Pandangan",
  T_46_META_WS_CREATEMINIMAPICON: "Buat Ikon Mini Map",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Buat Piksel Mini Map",
  T_46_META_WS_CREATEMONSTER: "Buat Monster",
  T_46_META_WS_CREATEMORPH: "Buat Perubahan",
  T_46_META_WS_CREATESELFRELATIVE: "Buat Relatif Diri",
  T_46_META_WS_CREATESHOP: "Buat Toko",
  T_46_META_WS_CREATESHOPITEM: "Buat Item Toko",
  T_46_META_WS_CREATESHOPSHELF: "Buat Rak Toko",
  T_46_META_WS_CREATESOUND: "Buat Suara",
  T_46_META_WS_CREATESOUNDCLIENT: "Buat Suara",
  T_46_META_WS_CREATETOKENINSCENE: "Buat Token di Scene",
  T_46_META_WS_CREATETRAJECTORY: "Buat Trajektori",
  T_46_META_WS_CREATETWEEN: "Buat Tween",
  T_46_META_WS_CREATEWALLET: "Buat Dompet",
  T_46_META_WS_CROSS: "Silang",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "Nama Kolom CSV ke Integer",
  T_46_META_WS_CURRENTAMMOCOUNT: "Jumlah Amunisi Saat Ini",
  T_46_META_WS_DAMAGE: "Damage",
  T_46_META_WS_DAMAGEDBODYPART: "Bagian Tubuh yang Ter-damage",
  T_46_META_WS_DAMAGEDPLAYERS: "Pemain yang Ter-damage",
  T_46_META_WS_DAMAGETYPE: "Tipe Kerusakan",
  T_46_META_WS_DEALDAMAGE: "Berikan Kerusakan",
  T_46_META_WS_DELETE: "Hapus",
  T_46_META_WS_DELETEAT: "Hapus di",
  T_46_META_WS_DELETECUSTOMUI: "Hapus UI Kustom",
  T_46_META_WS_DELETEFROMDATABASE: "Hapus dari Database",
  T_46_META_WS_DELETEFROMDATASTORE: "Hapus Dari Penyimpanan Data",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Hapus dari Database Leaderboard Berdasarkan Kunci",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Hapus dari Database Leaderboard Berdasarkan Rank",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Hapus Dari Penyimpanan Data Leaderboard Berdasarkan Kunci",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Hapus Dari Penyimpanan Data Leaderboard Berdasarkan Rank",
  T_46_META_WS_DELETETAG: "Hapus Tag",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Hancurkan",
  T_46_META_WS_DESTROYBOT: "Hancurkan Bot",
  T_46_META_WS_DESTROYBUILTINUI: "Hapus UI Bawaan",
  T_46_META_WS_DESTROYEQUIPMENT: "Hancurkan Peralatan",
  T_46_META_WS_DESTROYITEM: "Hancurkan Item",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Arah ke Sudut Euler",
  T_46_META_WS_DISABLESAFEZONE: "Nonaktifkan Zona Aman",
  T_46_META_WS_DISPATCHEVENT: "Dispatch Event",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Kirim Acara dengan Platform",
  T_46_META_WS_DISTANCE: "Jarak",
  T_46_META_WS_DOT: "Titik",
  T_46_META_WS_DROPITEM: "Jatuhkan Item",
  T_46_META_WS_DYEATAREA: "Warnai di Area",
  T_46_META_WS_DYEATPLANE: "Warnai di Bidang",
  T_46_META_WS_DYEATPOSITION: "Warnai di Posisi",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Area gravitasi rendah",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Akselerasi",
  T_46_META_WS_E_ACTIONNODE: "NodeAksi",
  T_46_META_WS_E_ACTIVE: "Aktif",
  T_46_META_WS_E_ACTIVESKILL: "Keterampilan Aktif",
  T_46_META_WS_E_ADBOARD: "Billboard",
  T_46_META_WS_E_ADD: "Tambah",
  T_46_META_WS_E_ADDFRIEND: "Tambah Teman",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Bidik",
  T_46_META_WS_E_AIR: "Udara",
  T_46_META_WS_E_AIRCONDITIONERA: "AC",
  T_46_META_WS_E_AIRDROP: "Jatuhan, Bunuh Diri Zombie",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Hidup",
  T_46_META_WS_E_AMMO: "Efek Peluru",
  T_46_META_WS_E_AMPHIBIANCAR: "Kendaraan Amphibi",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Anak-Anak Bermain",
  T_46_META_WS_E_AR: "Senapan",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "Amunisi AR",
  T_46_META_WS_E_ARMAGAZINE: "Magazen untuk AR",
  T_46_META_WS_E_ARMOR: "Baju Zirah",
  T_46_META_WS_E_ARMORBUFF: "Buff Armor",
  T_46_META_WS_E_ARMORLV1: "Armor Lv1",
  T_46_META_WS_E_ARMORLV2: "Armor Lv2",
  T_46_META_WS_E_ARMORLV3: "Armor Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Hancurkan Armor",
  T_46_META_WS_E_ARMORSPECIALIST: "Keterampilan 1",
  T_46_META_WS_E_ARROW: "Panah",
  T_46_META_WS_E_ASC: "Urutan Menaik",
  T_46_META_WS_E_ASCIGNOREZERO: "Urutan Menaik Tanpa Nol",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Ledakan Gas",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Aksesoris1 untuk Kompatibilitas",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Aksesoris4 untuk Kompatibilitas",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Aksesoris5 untuk Kompatibilitas",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Aksesoris6 untuk Kompatibilitas",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Aksesoris8 untuk Kompatibilitas",
  T_46_META_WS_E_ATTACK: "Serang",
  T_46_META_WS_E_ATTACKGRENADE: "Granat Serang",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Otomatis",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Kembali",
  T_46_META_WS_E_BACKANDFORTH: "Bolak-Balik",
  T_46_META_WS_E_BAG: "Tas",
  T_46_META_WS_E_BAG1: "Tas1",
  T_46_META_WS_E_BAG2: "Tas2",
  T_46_META_WS_E_BAG3: "Tas3",
  T_46_META_WS_E_BAMBOOA: "Bambu A",
  T_46_META_WS_E_BANANATREE: "Pohon Pisang",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Koefisien Dasar",
  T_46_META_WS_E_BASIC: "Dasar",
  T_46_META_WS_E_BASICCONE: "Kerucut dasar",
  T_46_META_WS_E_BASICCYLINDER: "Silinder dasar",
  T_46_META_WS_E_BASICSPHERE: "Esfera básica",
  T_46_META_WS_E_BATTLEINSTYLE: "Pertarungan Bergaya",
  T_46_META_WS_E_BELL: "Bel",
  T_46_META_WS_E_BENCH: "Bangku",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "Layar besar",
  T_46_META_WS_E_BIPOD: "Bipod",
  T_46_META_WS_E_BISGRAFFITIWALL: "Dinding bertema BIS",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "Efek Ledakan Lubang Hitam",
  T_46_META_WS_E_BLACKHOLEBOOM: "Efek Bola Kristal",
  T_46_META_WS_E_BLAST: "Ledakan",
  T_46_META_WS_E_BLOCK: "Kotak",
  T_46_META_WS_E_BLOODBALL: "Efek Lubang Hitam",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Biru",
  T_46_META_WS_E_BLUEDOLL: "Boneka es",
  T_46_META_WS_E_BOARD: "Platform Bergerak",
  T_46_META_WS_E_BODY: "Tubuh",
  T_46_META_WS_E_BOMBINDICATION: "Peringatan Bom",
  T_46_META_WS_E_BOMBPLIERS: "Tang Bomba",
  T_46_META_WS_E_BONFIRE: "Api Unggun",
  T_46_META_WS_E_BOOM: "Ledakan",
  T_46_META_WS_E_BOOYAH: "Kemenangan",
  T_46_META_WS_E_BOTH: "Keduanya",
  T_46_META_WS_E_BOUNCETIRE: "Ban",
  T_46_META_WS_E_BOWAMMO: "Amunisi Busur",
  T_46_META_WS_E_BREAKABLEBOX: "Kotak kayu yang dapat dihancurkan",
  T_46_META_WS_E_BREAKABLECONTAINER: "Kontainer yang Dapat Hancur",
  T_46_META_WS_E_BREAKABLEFENCE: "Pagar yang Dapat Hancur",
  T_46_META_WS_E_BRICKA: "Batu A",
  T_46_META_WS_E_BRICKB: "Batu B",
  T_46_META_WS_E_BRICKC: "Batu C",
  T_46_META_WS_E_BRICKHOUSEA: "Rumah kecil A",
  T_46_META_WS_E_BRIGHT: "Terang",
  T_46_META_WS_E_BUBBLE: "Gelembung",
  T_46_META_WS_E_BUFFGENERATOR: "Generator Buff",
  T_46_META_WS_E_BULLETBUFF: "Buff Peluru",
  T_46_META_WS_E_BULLETHITTING: "Hantaman Peluru",
  T_46_META_WS_E_BUMPERCAR: "Mobil Derak",
  T_46_META_WS_E_BUMPERCARFACTORY: "Pabrikan mobil bumper",
  T_46_META_WS_E_BURNING: "Kerusakan Terbakar pada Ledakan Kendaraan",
  T_46_META_WS_E_BUSHES: "Semak",
  T_46_META_WS_E_BUSSTOP: "Halte Bus",
  T_46_META_WS_E_BUTTOM: "Pakaian Bawah",
  T_46_META_WS_E_BUTTONWIDGET: "Widget tombol",
  T_46_META_WS_E_BYHIERARCHY: "Berdasarkan hierarki",
  T_46_META_WS_E_CABINET: "Lemari",
  T_46_META_WS_E_CACTUS: "Kaktus",
  T_46_META_WS_E_CAMOUFLAGE: "Keterampilan 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Pemicu kapsul",
  T_46_META_WS_E_CARDIOTONIC: "Kardiotonik",
  T_46_META_WS_E_CASUALGAMEBGM: "Musik Latar Permainan Santai",
  T_46_META_WS_E_CEMENTA: "Semen A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Kanal A",
  T_46_META_WS_E_CHANNELB: "Kanal B",
  T_46_META_WS_E_CHANNELC: "Kanal C",
  T_46_META_WS_E_CHANNELD: "Kanal D",
  T_46_META_WS_E_CHANNELE: "Kanal E",
  T_46_META_WS_E_CHANNELF: "Kanal F",
  T_46_META_WS_E_CHARACTERSKILL: "Keterampilan Karakter",
  T_46_META_WS_E_CHARACTOR: "Karakter",
  T_46_META_WS_E_CHARGE: "Pengisian 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Titik pemeriksaan",
  T_46_META_WS_E_CHEER: "Sorakan",
  T_46_META_WS_E_CHERRYBLOSSOM: "Bunga Sakura",
  T_46_META_WS_E_CIRCLE: "Lingkaran",
  T_46_META_WS_E_CIRCLEBACK: "Siklus",
  T_46_META_WS_E_CIRCLEOFHEAT: "Sinar Kaki",
  T_46_META_WS_E_CITY: "Kota",
  T_46_META_WS_E_CLAPS: "Tepuk tangan",
  T_46_META_WS_E_CLEAR: "Bersihkan",
  T_46_META_WS_E_CLIENT: "Klien",
  T_46_META_WS_E_CLONE: "Pengubah Tampilan",
  T_46_META_WS_E_CLONEKILL: "Kematian Klon",
  T_46_META_WS_E_CLOSE: "Tutup",
  T_46_META_WS_E_CLOTHES: "Pakaian",
  T_46_META_WS_E_COINGENERATOR: "Generator emas",
  T_46_META_WS_E_COLDAIR: "Kabut",
  T_46_META_WS_E_COLORBLOCK: "Blok berwarna",
  T_46_META_WS_E_COLOROILBARREL: "Drum berwarna",
  T_46_META_WS_E_COMBINEALL: "Gabungkan Semua",
  T_46_META_WS_E_COMBINESELF: "Gabungkan Diri",
  T_46_META_WS_E_COMBOKEYA1: "Catatan Musik - Synthesizer A",
  T_46_META_WS_E_COMBOKEYA2: "Catatan Musik - Synthesizer A",
  T_46_META_WS_E_COMBOKEYB1: "Catatan Musik - Synthesizer B",
  T_46_META_WS_E_COMBOKEYB2: "Catatan Musik - Synthesizer B",
  T_46_META_WS_E_COMBOKEYC1: "Catatan Musik - Synthesizer C",
  T_46_META_WS_E_COMBOKEYC2: "Catatan Musik - Synthesizer C",
  T_46_META_WS_E_CONCRETEPILLAR: "Pilar beton",
  T_46_META_WS_E_CONDITIONNODE: "NodeKondisi",
  T_46_META_WS_E_CONTAINERA: "Kontainer A",
  T_46_META_WS_E_CONTAINERB: "Kontainer B",
  T_46_META_WS_E_CONTAINERC: "Kontainer C",
  T_46_META_WS_E_CONTAINERWIDGET: "Widget kontainer",
  T_46_META_WS_E_CONTINUOUS: "Berkelanjutan",
  T_46_META_WS_E_COUNTDOWN: "Hitung Mundur",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Hitung Mundur",
  T_46_META_WS_E_COUNTDOWNDIDI: "Bunyi Hitung Mundur",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Hitung Mundur",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Hitung Mundur 3",
  T_46_META_WS_E_CROSS: "Salib",
  T_46_META_WS_E_CROSSBOW: "Busur silang",
  T_46_META_WS_E_CROSSHAIR: "Bidikan",
  T_46_META_WS_E_CROSSHAIRS: "Bidikan",
  T_46_META_WS_E_CROUCH: "Jongkok",
  T_46_META_WS_E_CROUCHING: "Jongkok",
  T_46_META_WS_E_CROWCAW: "Suara Burung Gagak",
  T_46_META_WS_E_CROWN: "Mahkota",
  T_46_META_WS_E_CUBE: "Mekanisme Blok",
  T_46_META_WS_E_CURSE: "Jimat",
  T_46_META_WS_E_CURSEEXPLOSION: "Ledakan Jimat",
  T_46_META_WS_E_CUSTOM: "Kamera Kustom",
  T_46_META_WS_E_CUSTOMTRIGGER: "Pemicu khusus",
  T_46_META_WS_E_CUSTOMWATERZONE: "Badan air khusus",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Terbakar Berulang",
  T_46_META_WS_E_CYLIC: "Siklus",
  T_46_META_WS_E_DAGGER: "Pisau Lempar",
  T_46_META_WS_E_DAMAGEDTRUCK: "Truk rusak",
  T_46_META_WS_E_DAMAGEZONE: "Zona Kerusakan",
  T_46_META_WS_E_DANGERALARM: "Bahaya 2",
  T_46_META_WS_E_DANGERVIBRATING: "Bahaya 1",
  T_46_META_WS_E_DARK: "Gelap",
  T_46_META_WS_E_DARKNESS: "Kegelapan",
  T_46_META_WS_E_DASHATTACK: "Serangan Dash",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Batas Penyimpanan Data Terlampaui",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Kesalahan Parameter Penyimpanan Data",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Waktu Tunggu Penyimpanan Data",
  T_46_META_WS_E_DATETIME: "Tanggal dan Waktu",
  T_46_META_WS_E_DAY: "Siang",
  T_46_META_WS_E_DEAD: "Mati",
  T_46_META_WS_E_DEATH: "Mati",
  T_46_META_WS_E_DEFAULT: "Default",
  T_46_META_WS_E_DEFAULTFIST: "Tinju",
  T_46_META_WS_E_DEFENCEGRENADE: "Granat Bertahan",
  T_46_META_WS_E_DESC: "Urutan Menurun",
  T_46_META_WS_E_DIALOGUE: "Dialog",
  T_46_META_WS_E_DIAMOND: "Berlian",
  T_46_META_WS_E_DIRECTIONSIGN: "Tanda",
  T_46_META_WS_E_DIRVEVEHICLE: "Kendarai Kendaraan",
  T_46_META_WS_E_DISABLE: "Nonaktifkan",
  T_46_META_WS_E_DISABLED: "Dinonaktif",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Prompt Menghilang",
  T_46_META_WS_E_DISCONNECT: "Terputus",
  T_46_META_WS_E_DISGUISE: "Klon",
  T_46_META_WS_E_DOGHOUSE: "Rumah anjing",
  T_46_META_WS_E_DOOR: "Pintu",
  T_46_META_WS_E_DOUBLE: "Ganda",
  T_46_META_WS_E_DOUBLEDOOR: "Pintu ganda",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Sepatu Loncat Ganda",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Magazen Ganda",
  T_46_META_WS_E_DRAW: "Seri",
  T_46_META_WS_E_DRILLZOMBIE: "Zombie Bor",
  T_46_META_WS_E_DRIVE: "Mengemudi",
  T_46_META_WS_E_DRIVER: "Pengemudi",
  T_46_META_WS_E_DROPBEAT: "Keterampilan 4",
  T_46_META_WS_E_DRUMKEY1: "Catatan Musik - Drum",
  T_46_META_WS_E_DRUMKEY2: "Catatan Musik - Drum",
  T_46_META_WS_E_DUEL: "Pertarungan",
  T_46_META_WS_E_DUMMY: "Boneka",
  T_46_META_WS_E_DUMMYGRENADE: "Granat Palsu",
  T_46_META_WS_E_DUMP: "Buang",
  T_46_META_WS_E_DUSK: "Senja",
  T_46_META_WS_E_DUST: "Asap dan Debu",
  T_46_META_WS_E_DYNAMIC: "Dinamis",
  T_46_META_WS_E_E: "Konstanta Alam",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Mudah",
  T_46_META_WS_E_ELECTRICSHOCK: "Kejut Listrik",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Papan Selancar Listrik",
  T_46_META_WS_E_ELECTRICZONE: "Zona Listrik",
  T_46_META_WS_E_ELECTRONICBGM: "Musik Latar Fantasi Elektronik Lucu",
  T_46_META_WS_E_ELIMINATEDBOSS: "Menggulingkan Pemimpin Guild",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Peringatan Pembunuhan",
  T_46_META_WS_E_EMOTE: "Emote",
  T_46_META_WS_E_ENABLE: "Aktifkan",
  T_46_META_WS_E_ENERGETIC: "Enerjik",
  T_46_META_WS_E_ENTERVEHICLE: "Masuk Kendaraan",
  T_46_META_WS_E_EP: "Energi (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "Tanda Seru",
  T_46_META_WS_E_EXIT: "Keluar",
  T_46_META_WS_E_EXITVEHICLE: "Keluar Kendaraan",
  T_46_META_WS_E_EXPLODE: "Ledakan Sendiri",
  T_46_META_WS_E_EXPLOSION: "Efek Ledakan",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Nyala Ledakan",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Keterampilan Orb Energi",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Zombie Peledak",
  T_46_META_WS_E_EYE: "Kacamata",
  T_46_META_WS_E_FACEPAINT: "Rias Wajah",
  T_46_META_WS_E_FACTION: "Fraksi",
  T_46_META_WS_E_FALLING: "Jatuh",
  T_46_META_WS_E_FALLINGSTAR: "Dapatkan Barang Konsumsi",
  T_46_META_WS_E_FALSE: "Tidak",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Mekanisme Propeller",
  T_46_META_WS_E_FAR: "Jauh",
  T_46_META_WS_E_FEATHER: "Bulu",
  T_46_META_WS_E_FEMALE: "Perempuan",
  T_46_META_WS_E_FENCE: "Pagar",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "EntitasPertarungan",
  T_46_META_WS_E_FILLED: "Terisi",
  T_46_META_WS_E_FINISH: "Selesai",
  T_46_META_WS_E_FINISHINGPOINT: "Titik akhir",
  T_46_META_WS_E_FINISHLINEARCH: "Spanduk finish",
  T_46_META_WS_E_FIRE: "Api",
  T_46_META_WS_E_FIRECHARGE: "Bola Api",
  T_46_META_WS_E_FIREWORK: "Kembang Api",
  T_46_META_WS_E_FIRINGEFFECT: "Efek Penembakan",
  T_46_META_WS_E_FIRSTPERSON: "Kamera Orang Pertama",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Kamera Orang Pertama (Klasik)",
  T_46_META_WS_E_FIST: "Tinju",
  T_46_META_WS_E_FIT: "Cocok",
  T_46_META_WS_E_FLAG: "Bendera",
  T_46_META_WS_E_FLAME: "Api",
  T_46_META_WS_E_FLAMEGUN: "Senapan Api",
  T_46_META_WS_E_FLAMETHROWER: "Senapan Api",
  T_46_META_WS_E_FLASH: "Flashbang",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Asap Granat Flashbang",
  T_46_META_WS_E_FLASHFREEZE: "Pembekuan Cepat",
  T_46_META_WS_E_FLEXWALL: "Dinding yang Dapat Ditarik",
  T_46_META_WS_E_FLICKER: "Berkedip",
  T_46_META_WS_E_FLOWER: "Bunga",
  T_46_META_WS_E_FLYBOMBBEE: "Lebah Bom Terbang",
  T_46_META_WS_E_FLYPAN: "Mekanisme Penggorengan",
  T_46_META_WS_E_FLYSHOE: "Sepatu Terbang",
  T_46_META_WS_E_FOLDER: "Folder",
  T_46_META_WS_E_FOLDWINGS: "Sayap Lipat",
  T_46_META_WS_E_FOODTRUCK: "Truk makanan",
  T_46_META_WS_E_FOODTRUCKB: "Truk makanan B",
  T_46_META_WS_E_FOOTBALL: "Sepak bola",
  T_46_META_WS_E_FOOTBALLGUN: "Senapan Sepak Bola",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Penembak Sepak Bola",
  T_46_META_WS_E_FORCE: "Kekuatan",
  T_46_META_WS_E_FOREGRIP_MR: "Pegangan Depan MR",
  T_46_META_WS_E_FOREGRIP1: "Pegangan Depan1",
  T_46_META_WS_E_FOREGRIP2: "Pegangan Depan2",
  T_46_META_WS_E_FOREGRIP3: "Pegangan Depan3",
  T_46_META_WS_E_FORWARD: "Maju",
  T_46_META_WS_E_FOUNTAIN: "Air Mancur",
  T_46_META_WS_E_FREE: "Kamera Bebas",
  T_46_META_WS_E_FREEZEALL: "Bekukan Semua",
  T_46_META_WS_E_FREEZEPOSITION: "Bekukan Posisi",
  T_46_META_WS_E_FREEZEPOSITIONX: "Bekukan Posisi X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Bekukan Posisi Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Bekukan Posisi Z",
  T_46_META_WS_E_FREEZEROTATION: "Bekukan Rotasi",
  T_46_META_WS_E_FREEZEROTATIONX: "Bekukan Rotasi X",
  T_46_META_WS_E_FREEZEROTATIONY: "Bekukan Rotasi Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Bekukan Rotasi Z",
  T_46_META_WS_E_FREEZEZONE: "Area Beku",
  "T_46_META_WS_E_FROST GALAXY": "Galaksi Beku",
  T_46_META_WS_E_FROZEN: "Membeku",
  T_46_META_WS_E_FROZENGRENADE: "Granat Beku",
  T_46_META_WS_E_FUNCTIONALITEMS: "Item Fungsional",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Permainan",
  T_46_META_WS_E_GAMEOVER: "Permainan Selesai 2",
  T_46_META_WS_E_GAMESTART: "Mulai Permainan",
  T_46_META_WS_E_GARAGE: "Garasi",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Mekanisme Aktif",
  T_46_META_WS_E_GENTLETAP: "Ketukan Lembut",
  T_46_META_WS_E_GETITEM: "Dapatkan Barang Konsumsi 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Hantu",
  T_46_META_WS_E_GIANTDICE: "Dadu",
  T_46_META_WS_E_GIANTLOLLIPOP: "Lolipop raksasa",
  T_46_META_WS_E_GIFT: "Hadiah",
  T_46_META_WS_E_GLOOWALL: "Dinding Gel",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "Tempat tidur bunga bertema BIS",
  T_46_META_WS_E_GRAFFITIWALL: "Dinding grafiti",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Senapan Kait",
  T_46_META_WS_E_GREATCONDUCTOR: "Konduktor Hebat",
  T_46_META_WS_E_GREEN: "Hijau",
  T_46_META_WS_E_GRENADE: "Grenade",
  T_46_META_WS_E_GRID: "Jaringan",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Menara Pengawas",
  T_46_META_WS_E_GUILD: "Guild",
  T_46_META_WS_E_GUN: "Senjata",
  T_46_META_WS_E_GUNFIRE: "Tembakan",
  T_46_META_WS_E_HALO: "Aura",
  T_46_META_WS_E_HAMMER: "Mekanisme Palu Raksasa",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Rak Pengering",
  T_46_META_WS_E_HARD: "Sulit",
  T_46_META_WS_E_HATTRICK: "Keterampilan 8",
  T_46_META_WS_E_HAYSTACK: "Tumpukan Jerami",
  T_46_META_WS_E_HEAD: "Hiasan Kepala",
  T_46_META_WS_E_HEADSHOOT: "Headshot",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "Senapan Penyembuh",
  T_46_META_WS_E_HEART: "Jantung",
  T_46_META_WS_E_HEARTBEAT: "Detak Jantung",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "Senjata Berat",
  T_46_META_WS_E_HELL: "Sangat keras",
  T_46_META_WS_E_HELMET: "Helm",
  T_46_META_WS_E_HELMET1: "Helm1",
  T_46_META_WS_E_HELMET2: "Helm2",
  T_46_META_WS_E_HELMET3: "Helm3",
  T_46_META_WS_E_HEXAGON: "Segi Enam",
  T_46_META_WS_E_HGAMMO: "Amunisi HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Senapan Api untuk Petak Umpet",
  T_46_META_WS_E_HIDERKILL: "Pembunuh Tersembunyi",
  T_46_META_WS_E_HIHATS: "Hi-Hat",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Pukulan Membosankan",
  T_46_META_WS_E_HITEFFECT: "Efek Kena Peluru",
  T_46_META_WS_E_HITFEEDBACK: "Umpan Balik Penembakan",
  T_46_META_WS_E_HOOK: "Kait",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "Amunisi untuk Senapan Kait",
  T_46_META_WS_E_HORIZALINE: "Garis Horisontal",
  T_46_META_WS_E_HORIZONTAL: "Horizontal",
  T_46_META_WS_E_HORN: "Speaker",
  T_46_META_WS_E_HORROR: "Horor",
  T_46_META_WS_E_HOURGLASS: "Jam Pasir",
  T_46_META_WS_E_HOUSE: "Rumah",
  T_46_META_WS_E_HOUSEA: "Rumah Satu Lantai",
  T_46_META_WS_E_HOUSEB: "Rumah Dua Lantai",
  T_46_META_WS_E_HOUSEC: "Rumah Tiga Lantai",
  T_46_META_WS_E_HP: "Kesehatan (HP)",
  T_46_META_WS_E_HPBUFF: "Buff HP",
  T_46_META_WS_E_HUT: "Kabin",
  T_46_META_WS_E_ICEA: "Es A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "Pembuat Tembok Es",
  T_46_META_WS_E_ICONOBJECT: "Ikon",
  T_46_META_WS_E_IMAGEWIDGET: "Widget gambar",
  T_46_META_WS_E_IMPULSE: "Dorongan",
  T_46_META_WS_E_INHALER: "Inhaler",
  T_46_META_WS_E_INJUREDFEMALE: "Jeritan Wanita Saat Terkena",
  T_46_META_WS_E_INJUREDMALE: "Jeritan Pria Saat Terkena",
  T_46_META_WS_E_INK: "Efek Tinta",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Widget label input",
  T_46_META_WS_E_INSECTCHIRPING: "Suara Serangga",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 Detik",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 Detik",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 Detik",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 Detik",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 Detik",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 Detik",
  T_46_META_WS_E_INVISIBLE: "Tidak Terlihat",
  T_46_META_WS_E_IPIPE: "Pipa I",
  T_46_META_WS_E_IRONFENCE: "Pagar",
  T_46_META_WS_E_IRONFENCEB: "Pagar B",
  T_46_META_WS_E_IRONPLATFORM: "Platform Besi",
  T_46_META_WS_E_ITEMENTITY: "Generator barang konsumsi",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Drum minyak",
  T_46_META_WS_E_JERSEYMACHINE: "Mesin jersi",
  T_46_META_WS_E_JOINEDGAMEDULL: "Bergabung dalam Pertempuran",
  T_46_META_WS_E_JOINGAME: "Bergabung dengan Permainan",
  T_46_META_WS_E_JOYSTICKWIDGET: "Widget joystick",
  T_46_META_WS_E_JUMP: "Lompat",
  T_46_META_WS_E_JUMPATTACK: "Serangan Lompat",
  T_46_META_WS_E_JUSTPATROL: "Hanya Patroli",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Kunci",
  T_46_META_WS_E_KICK: "Kick",
  T_46_META_WS_E_KILLINGTIPS: "Tips Pembunuhan",
  T_46_META_WS_E_KILLZONE: "Zona Kematian",
  T_46_META_WS_E_KINEMATIC: "Kinematik",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "Tersungkur",
  T_46_META_WS_E_KNOCKEDDOWN: "Terjatuh",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Widget de etiqueta",
  T_46_META_WS_E_LANDINGA: "Pendaratan tangga A",
  T_46_META_WS_E_LANDINGB: "Pendaratan tangga B",
  T_46_META_WS_E_LANDINGC: "Pendaratan tangga C",
  T_46_META_WS_E_LANDMINE: "Ranjau Darat",
  T_46_META_WS_E_LANUNCHERAMMO: "Amunisi Peluncur",
  T_46_META_WS_E_LASER: "Efek Laser",
  T_46_META_WS_E_LASERSKILL: "Keterampilan Laser",
  T_46_META_WS_E_LATTICESCREEN: "Layar Kisi",
  T_46_META_WS_E_LAWNA: "Rumput A",
  T_46_META_WS_E_LAWNB: "Rumput B",
  T_46_META_WS_E_LAYOUTWIDGET: "Widget de diseño",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Kayu Mati",
  T_46_META_WS_E_LEVELMAXED: "Level Maksimum",
  T_46_META_WS_E_LEVELUP: "Naik Pangkat",
  T_46_META_WS_E_LEVELUPDISCARDED: "Naik Peringkat",
  T_46_META_WS_E_LIGHTBEAM: "Sinar Cahaya",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Sinar Cahaya",
  T_46_META_WS_E_LIGHTEFFECT: "Efek Cahaya",
  T_46_META_WS_E_LIGHTNING: "Petir",
  T_46_META_WS_E_LIMB: "Anggota Tubuh",
  T_46_META_WS_E_LINE: "Garis",
  T_46_META_WS_E_LIQUID: "Cair",
  T_46_META_WS_E_LOCAL: "Lokal",
  T_46_META_WS_E_LOCALPOSITION: "Posisi Lokal",
  T_46_META_WS_E_LOCK: "Kunci",
  T_46_META_WS_E_LONGBOX: "Kotak Kayu Panjang",
  T_46_META_WS_E_LOOP: "Loop",
  T_46_META_WS_E_LOOTITEMBOX: "Senjata Loot",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Peluru Loot",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Armor Loot",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Barang Konsumsi Loot",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Barang Lempar Loot",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Teleskop Loot",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "Granat Es",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Rampasan Sepak Bola Acak",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Perisai Sepak Bola",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Loot Senjata Acak",
  T_46_META_WS_E_LOSE: "Kekalahan",
  T_46_META_WS_E_LOUDSPEAKER: "Speaker",
  T_46_META_WS_E_LOWFALLING: "Jatuh Rendah",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "Granat M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "Granat Khusus M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Magazen1",
  T_46_META_WS_E_MAGEZINE2: "Magazen2",
  T_46_META_WS_E_MAGEZINE3: "Magazen3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Kaca Pembesar",
  T_46_META_WS_E_MALE: "Laki-laki",
  T_46_META_WS_E_MARK: "Markah",
  T_46_META_WS_E_MARKER: "Tanda",
  T_46_META_WS_E_MASK: "Aksesori Wajah",
  T_46_META_WS_E_MAXVALUE: "Nilai Maksimum",
  T_46_META_WS_E_MECHANICAL: "Klik Cepat 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Gema Perangkat Mekanis",
  T_46_META_WS_E_MEDICALPROPS: "Alat Medis",
  T_46_META_WS_E_MEDICALTENT: "Tenda Medis",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Denyut Jantung Sedang",
  T_46_META_WS_E_MEDKIT: "Kot Medis",
  T_46_META_WS_E_MELEE: "Senjata Tempur Jarak Dekat",
  T_46_META_WS_E_MELEEWEAPONS: "Senjata Jarak Dekat",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Mikrofon",
  T_46_META_WS_E_MIDDLE: "Tengah",
  T_46_META_WS_E_MINIHANDLE: "Mini Pegangan",
  T_46_META_WS_E_MINIMAP: "Peta Mini",
  T_46_META_WS_E_MINISENTRY: "Mini sentry",
  T_46_META_WS_E_MINVALUE: "Nilai Minimum",
  T_46_META_WS_E_MISSILEEXPLODE: "Senjata Jenis Rudal",
  T_46_META_WS_E_MISSIONCOMPLETE: "Keberhasilan Misi 1",
  T_46_META_WS_E_MISTAKE: "Kesalahan",
  T_46_META_WS_E_MODERATE: "Sedang",
  T_46_META_WS_E_MONEY: "Uang",
  T_46_META_WS_E_MONSTER: "Monster",
  T_46_META_WS_E_MONSTERSPAWN: "Titik Spawn Monster",
  T_46_META_WS_E_MONSTERTRUCK: "Truk monster",
  T_46_META_WS_E_MOON: "Bulan",
  T_46_META_WS_E_MOSQUITO: "Nyamuk",
  T_46_META_WS_E_MOTIONTRAIL: "Tabrakan Belakang",
  T_46_META_WS_E_MOTOBIKE: "Sepeda motor",
  T_46_META_WS_E_MOTORBIKE: "Sepeda Motor",
  T_46_META_WS_E_MOVE: "Bergerak",
  T_46_META_WS_E_MOVEMENT: "Bergerak",
  T_46_META_WS_E_MOVINGJOYSTICK: "Joystick Gerakan",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Mr. V",
  T_46_META_WS_E_MULTIPLIER: "Pengganda",
  T_46_META_WS_E_MULTIPLY: "Kalikan",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Kalikan dan Kumpulkan",
  T_46_META_WS_E_MUSHROOM1: "Jamur1",
  T_46_META_WS_E_MUSHROOM2: "Jamur2",
  T_46_META_WS_E_MUSHROOM3: "Jamur3",
  T_46_META_WS_E_MUSHROOM4: "Jamur4",
  T_46_META_WS_E_MUSHSHADE: "Kelompok Jamur Raksasa",
  T_46_META_WS_E_MUSIC: "Musik",
  T_46_META_WS_E_MUZZLE1: "Moncong1",
  T_46_META_WS_E_MUZZLE2: "Moncong2",
  T_46_META_WS_E_MUZZLE3: "Moncong3",
  T_46_META_WS_E_NEAR: "Dekat",
  T_46_META_WS_E_NIGHT: "Malam",
  T_46_META_WS_E_NOATTACK: "Tidak Menyerang",
  T_46_META_WS_E_NODUALWIELDING: "Tidak Bisa Menggunakan Dua Senjata",
  T_46_META_WS_E_NOERROR: "Tanpa Kesalahan",
  T_46_META_WS_E_NONE: "Tidak ada",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Tidak Lewati Jatuh",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Keterampilan 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Dapatkan Emas Sedang",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Dapatkan Emas Besar",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Dapatkan Emas Kecil",
  T_46_META_WS_E_OILDRUMEXPLODE: "Ledakan Drum Minyak",
  T_46_META_WS_E_ONCE: "Sekali",
  T_46_META_WS_E_ONEWAY: "Satu Arah",
  T_46_META_WS_E_OPENFOLDER: "Folder Terbuka",
  T_46_META_WS_E_OPENHIHATS: "Hi-Hat Terbuka",
  T_46_META_WS_E_OPENINGBOX: "Buka Kotak",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Supply Guild",
  T_46_META_WS_E_OPENINGWARCHEST: "Simpan Gudang",
  T_46_META_WS_E_ORANGE: "Jeruk",
  T_46_META_WS_E_ORTHOGONAL: "Ortogonal",
  T_46_META_WS_E_OUTPOST: "Pos Keamanan",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Dinding Berwarna",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Keterampilan Kolam Darah",
  T_46_META_WS_E_PALM: "Kertas",
  T_46_META_WS_E_PANEL: "Panel",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Penumpang A",
  T_46_META_WS_E_PASSENGERB: "Penumpang B",
  T_46_META_WS_E_PASSENGERC: "Penumpang C",
  T_46_META_WS_E_PASSIVE: "Pasif",
  T_46_META_WS_E_PASSIVESKILL: "Keterampilan Pasif",
  T_46_META_WS_E_PATROLWHILEATTACK: "Patroli Sambil Menyerang",
  T_46_META_WS_E_PERSONALUAV: "UAV Pribadi",
  T_46_META_WS_E_PERSPECTIVE: "Perspektif",
  T_46_META_WS_E_PETTABBG: "Peliharaan",
  T_46_META_WS_E_PHASESTART: "Mulai Fase",
  T_46_META_WS_E_PHONEBOOTH: "Bilik Telepon",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Catatan Musik - Piano",
  T_46_META_WS_E_PIANOKEY2: "Catatan Musik - Piano",
  T_46_META_WS_E_PICKUPS: "Pengambilan Item",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Kolom Beton",
  T_46_META_WS_E_PIN: "Panggilan",
  T_46_META_WS_E_PINGPONG: "Tenis Meja",
  T_46_META_WS_E_PIPECORNER: "Pipa Siku",
  T_46_META_WS_E_PIPEINTERSECTION: "Pipa Silang",
  T_46_META_WS_E_PISTOL: "Pistol",
  T_46_META_WS_E_PISTOLAMMO: "Amunisi Pistol",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Blok taman hiburan kotak-kotak",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Pemain",
  T_46_META_WS_E_PLUS: "Plus",
  T_46_META_WS_E_PODIUM: "Podium",
  T_46_META_WS_E_POISONGAS: "Gas Beracun",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Gas Beracun",
  T_46_META_WS_E_PORTAL: "Portal",
  T_46_META_WS_E_POSTACCUMULATOR: "Pasca-Akumulasi",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Denyut Jantung Cepat",
  T_46_META_WS_E_PREACCUMULATOR: "Pra-Akumulasi",
  T_46_META_WS_E_PRIMARYWEAPONA: "Senjata Utama A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Senjata Utama B",
  T_46_META_WS_E_PRIOREXPLOSION: "Sebelum Ledakan Bom",
  T_46_META_WS_E_PROFILEWIDGET: "Widget de perfil",
  T_46_META_WS_E_PRONE: "Tengkurap",
  T_46_META_WS_E_PUMPKIN: "Labu",
  T_46_META_WS_E_PURPLE: "Ungu",
  T_46_META_WS_E_QUADRILATERAL: "Segi Empat",
  T_46_META_WS_E_QUESTIONMARK: "Tanda Tanya",
  T_46_META_WS_E_QUICKCHAT: "Obrolan Cepat",
  T_46_META_WS_E_QUICKCHATSHOW: "Tampilkan Obrolan Cepat",
  T_46_META_WS_E_RADIAL180: "Radial 180°",
  T_46_META_WS_E_RADIAL360: "Radial 360°",
  T_46_META_WS_E_RADIAL90: "Radial 90°",
  T_46_META_WS_E_RAMPAGE: "Keganasan",
  T_46_META_WS_E_RANDOM: "Acak",
  T_46_META_WS_E_RANDOMBUFF: "Buff Acak",
  T_46_META_WS_E_RANKDOWN: "Turun Peringkat",
  T_46_META_WS_E_REACTION: "Tanggapan",
  T_46_META_WS_E_RECOVER: "Pemulihan",
  T_46_META_WS_E_RECYCLE: "Daur Ulang",
  T_46_META_WS_E_RED: "Merah",
  T_46_META_WS_E_REFINERYTANK: "Tangki Air",
  T_46_META_WS_E_REFLECTIVECUBE: "Blok warna solid reflektif 1",
  T_46_META_WS_E_REFRESH: "Segarkan",
  T_46_META_WS_E_RELEASINGSKILL: "Efek Penggunaan Keterampilan",
  T_46_META_WS_E_RELOAD: "Isi Ulang",
  T_46_META_WS_E_REMINDER: "Pengingat",
  T_46_META_WS_E_REPAIR: "Perbaikan",
  T_46_META_WS_E_REPAIREQUIP: "Perbaiki Peralatan",
  T_46_META_WS_E_REPAIRKIT: "Kit Perbaikan",
  T_46_META_WS_E_REPLACER: "Pengganti",
  T_46_META_WS_E_REPORT: "Laporkan",
  T_46_META_WS_E_REST: "Istirahat",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Ride",
  T_46_META_WS_E_RIDICULE: "Mengejek",
  T_46_META_WS_E_RIDICULEFUNNY: "Mengejek Lucu",
  T_46_META_WS_E_RIFLE: "Senapan",
  T_46_META_WS_E_RIFLEAMMO: "Amunisi Senapan",
  T_46_META_WS_E_RIGHT: "Benar",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Trapesium Siku-Siku",
  T_46_META_WS_E_RING: "Mekanisme Cincin",
  T_46_META_WS_E_RINGPREDISCARDED: "Cincin",
  T_46_META_WS_E_RIPTIDERHYTHM: "Keterampilan 9",
  T_46_META_WS_E_RISINGPARTICLE: "Partikel Naik",
  T_46_META_WS_E_ROADBLOCK: "Barrikade",
  T_46_META_WS_E_ROTATE: "Rotasi",
  T_46_META_WS_E_RUNNING: "Sedang Berjalan",
  T_46_META_WS_E_RUSHTIME: "Kemarahan",
  T_46_META_WS_E_SAMURAI: "Samurai",
  T_46_META_WS_E_SANDA: "Pasir A",
  T_46_META_WS_E_SANDSTRUCTURE: "Patung Pasir",
  T_46_META_WS_E_SCALE: "Skala",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Penghuni",
  T_46_META_WS_E_SCISSORS: "Gunting",
  T_46_META_WS_E_SCOPE2X: "2x Alcance",
  T_46_META_WS_E_SCOPE4X: "4x Alcance",
  T_46_META_WS_E_SCROLLPANEL: "Panel de desplazamiento",
  T_46_META_WS_E_SECONDARYWEAPON: "Senjata Sekunder",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Keterampilan 10",
  T_46_META_WS_E_SERVER: "Server",
  T_46_META_WS_E_SET: "Pakaian Terusan",
  T_46_META_WS_E_SETTING: "Pengaturan",
  T_46_META_WS_E_SETTINGS: "Pengaturan",
  T_46_META_WS_E_SG: "Senapan Pompa",
  T_46_META_WS_E_SGAMMO: "Amunisi SN",
  T_46_META_WS_E_SHARPMECHANICAL: "Klik Cepat 1",
  T_46_META_WS_E_SHIELD: "Pertahanan",
  T_46_META_WS_E_SHIELDBROKEN: "Perisai Pecah",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "Angkat Perisai",
  T_46_META_WS_E_SHOCKWAVE: "Gelombang Kejut",
  T_46_META_WS_E_SHOES: "Sepatu",
  T_46_META_WS_E_SHOOTINGTARGET: "Sasaran Bergerak",
  T_46_META_WS_E_SHORTDATE: "Tanggal Singkat",
  T_46_META_WS_E_SHORTDATETIME: "Tanggal dan Waktu Singkat",
  T_46_META_WS_E_SHORTTIME: "Waktu Singkat",
  T_46_META_WS_E_SHOTGUN: "Senapan Scatter",
  T_46_META_WS_E_SHOTGUNAMMO: "Amunisi Senapan",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Moncong untuk Shotgun",
  T_46_META_WS_E_SHOW: "Tampilkan",
  T_46_META_WS_E_SHRUB: "Kotak Kayu Panjang Berpohon",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "Kamera Gulir Samping",
  T_46_META_WS_E_SIGNAL: "Sinyal",
  T_46_META_WS_E_SIGNOUT: "Keluar",
  T_46_META_WS_E_SILENCER: "Peredam Suara",
  T_46_META_WS_E_SIMPLE: "Sederhana",
  T_46_META_WS_E_SIMPLEWIDGET: "Widget simple",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Tunggal",
  T_46_META_WS_E_SITEHUT: "Rumah Kontainer",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Pengisian Keterampilan Selesai",
  T_46_META_WS_E_SKILLRECOVER: "Pemulihan Keterampilan",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Lewati Jatuh",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Irisan",
  T_46_META_WS_E_SLOPE: "Kemiringan",
  T_46_META_WS_E_SLOWHEARTBEAT: "Denyut Jantung Lambat",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "Amunisi SMG",
  T_46_META_WS_E_SMGMUZZLE: "Moncong untuk SMG",
  T_46_META_WS_E_SMILEY: "Wajah Tersenyum",
  T_46_META_WS_E_SMOKE: "Asap",
  T_46_META_WS_E_SMOKEGRENADE: "Granat Asap",
  T_46_META_WS_E_SMOKEY: "Asap",
  T_46_META_WS_E_SMOOTH: "Halus",
  T_46_META_WS_E_SNAMMO: "Amunisi SN",
  T_46_META_WS_E_SNARES: "Snare",
  T_46_META_WS_E_SNEAKERS: "Efek Sepatu Lari",
  T_46_META_WS_E_SNIPER: "Senapan Sniper",
  T_46_META_WS_E_SNIPERAMMO: "Amunisi Senapan Sniper",
  T_46_META_WS_E_SNOWA: "Salju A",
  T_46_META_WS_E_SNOWFLAKE: "Serpihan Salju",
  T_46_META_WS_E_SOCCER: "Sepak Bola",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Widget social",
  T_46_META_WS_E_SOLARPANEL: "Panel Surya",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "Berdasarkan prioritas tinggi ke rendah",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "Berdasarkan prioritas rendah ke tinggi",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Efek Titik Muncul",
  T_46_META_WS_E_SPEAKER: "Speaker",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Suara Senjata Khusus",
  T_46_META_WS_E_SPECIALGUN: "Senjata Khusus",
  T_46_META_WS_E_SPHERE: "Bola",
  T_46_META_WS_E_SPHERETRIGGER: "Pemicu tabrakan bola",
  T_46_META_WS_E_SPIDERWEB: "Efek Keterampilan",
  T_46_META_WS_E_SPORTSCAR: "Mobil Sport",
  T_46_META_WS_E_SPOTLIGHT: "Cahaya",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Penyebaran Gas Beracun",
  T_46_META_WS_E_SPRINT: "Berlari Kencang",
  T_46_META_WS_E_SQUARE: "Kotak",
  T_46_META_WS_E_SQUAREBOX: "Kotak Kayu Persegi",
  T_46_META_WS_E_SR: "Senapan Penembak Jitu",
  T_46_META_WS_E_STABLE: "Kandang",
  T_46_META_WS_E_STAIRS: "Tangga",
  T_46_META_WS_E_STANDING: "Berdiri",
  T_46_META_WS_E_STAR: "Bintang",
  T_46_META_WS_E_STATIC: "Statik",
  T_46_META_WS_E_STATUSTRIGGER: "Pemicu Kematian atau Kewalahan",
  T_46_META_WS_E_STEP: "Jejak Langkah",
  T_46_META_WS_E_STEPTRIGGER: "Aktifkan Mekanisme",
  T_46_META_WS_E_STOCK_S: "Popor S",
  T_46_META_WS_E_STOCK_SR: "Popor SR",
  T_46_META_WS_E_STOCK1: "Popor1",
  T_46_META_WS_E_STOCK2: "Popor2",
  T_46_META_WS_E_STOCK3: "Popor3",
  T_46_META_WS_E_STONE: "Batu",
  T_46_META_WS_E_STONEBRIDGE: "Jembatan lengkung batu",
  T_46_META_WS_E_STONELANTERN: "Lentera Batu",
  T_46_META_WS_E_STONESPLASH: "Puing Terbang",
  T_46_META_WS_E_STORE: "Toko",
  T_46_META_WS_E_STREETLAMP: "Lampu Jalan",
  T_46_META_WS_E_STYLEA: "Gaya A",
  T_46_META_WS_E_STYLEB: "Gaya B",
  T_46_META_WS_E_STYLEC: "Gaya C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "Amunisi SMG",
  T_46_META_WS_E_SUCCESSFULHIT: "Terkena",
  T_46_META_WS_E_SUN: "Matahari",
  T_46_META_WS_E_SUNSHADE: "Set patio dengan payung",
  T_46_META_WS_E_SUPERCAR: "Mobil sport",
  T_46_META_WS_E_SUPERMARKET: "Supermarket",
  T_46_META_WS_E_SURPRISEFIND: "Temukan Kejutan",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Ganti Senjata Cepat",
  T_46_META_WS_E_SWIMRING: "Pelampung",
  T_46_META_WS_E_SWORD: "Pedang",
  T_46_META_WS_E_SYMBOLIC: "Penanda Tanah",
  T_46_META_WS_E_TANKZOMBIE: "Zombie Tank",
  T_46_META_WS_E_TAP: "Ketuk",
  T_46_META_WS_E_TAPPINGBUTTON: "Tombol Ketuk",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Ketuk Tombol Nonaktif",
  T_46_META_WS_E_TEAM: "Tim",
  T_46_META_WS_E_TEAMMATESINFO: "Info Rekan Tim",
  T_46_META_WS_E_TELEPORT: "Teleport",
  T_46_META_WS_E_TELEPORTCORRECT: "Beacon Tujuan Benar",
  T_46_META_WS_E_TELEPORTWRONG: "Beacon Tujuan Salah",
  T_46_META_WS_E_TEXT: "Teks",
  T_46_META_WS_E_TEXTOBJECT: "Teks",
  T_46_META_WS_E_TEXTUREWIDGET: "Widget tekstur",
  T_46_META_WS_E_THERMALSCOPE: "Cermin Termal",
  T_46_META_WS_E_THIRDPERSON: "Kamera Orang Ketiga",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Kamera Orang Ketiga (Klasik)",
  T_46_META_WS_E_THIRDPERSONLOCK: "Kamera Orang Ketiga Terkunci",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "Pisau Lempar2 untuk Kompatibilitas",
  T_46_META_WS_E_THRILLBATTLE: "Keterampilan 5",
  T_46_META_WS_E_THROWATTACK: "Lempar Granat",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Zombie Lempar Merah",
  T_46_META_WS_E_THROWZOMBIE: "Zombie Lempar",
  T_46_META_WS_E_THUMBSUP: "Suka",
  T_46_META_WS_E_THUNDER: "Guncangan Listrik",
  T_46_META_WS_E_TILEA: "Keramik A",
  T_46_META_WS_E_TILEB: "Keramik B",
  T_46_META_WS_E_TILEC: "Keramik C",
  T_46_META_WS_E_TILED: "Berlapis",
  T_46_META_WS_E_TIPSSOUND: "Tampilkan Tips",
  T_46_META_WS_E_TOGGLEWIDGET: "Widget de alternancia",
  T_46_META_WS_E_TOILETBOWL: "Toilet",
  T_46_META_WS_E_TONEA: "Nada A",
  T_46_META_WS_E_TOP: "Pakaian Atas",
  T_46_META_WS_E_TOPDOWN: "Kamera Tampak Atas",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Widget touchpad",
  T_46_META_WS_E_TOWER: "Benteng",
  T_46_META_WS_E_TPIPE: "Pipa T",
  T_46_META_WS_E_TRACINGSTEPS: "Keterampilan 3",
  T_46_META_WS_E_TRAILER: "Trailer",
  T_46_META_WS_E_TRANSFORMATION: "Pengubah Tampilan",
  T_46_META_WS_E_TRANSPARENT: "Transparan",
  T_46_META_WS_E_TRAPEZOID: "Trapesium",
  T_46_META_WS_E_TRASHCAN: "Tempat Sampah",
  T_46_META_WS_E_TRIANGLE: "Segitiga",
  T_46_META_WS_E_TRIGGERS: "Pemicu",
  T_46_META_WS_E_TRIPLE: "Tiga Kali Tembakan",
  T_46_META_WS_E_TROPHY: "Piala",
  T_46_META_WS_E_TRUE: "Ya",
  T_46_META_WS_E_TUKTUK: "Tuk Tuk",
  T_46_META_WS_E_TUTUCAR: "Tuk-tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Zombie Tiran",
  T_46_META_WS_E_UAVLITE: "UAV Ringan",
  T_46_META_WS_E_UIFINISH: "Akhir",
  T_46_META_WS_E_UITAP: "UI Tap",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Generator unit",
  T_46_META_WS_E_UPWARDTURBULENCE: "Aliran Naik",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Memanjat",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Kendaraan",
  T_46_META_WS_E_VEHICLEEXPLODE: "Ledakan Kendaraan",
  T_46_META_WS_E_VELOCITY: "Kecepatan",
  T_46_META_WS_E_VENDINGMACHINE: "Mesin penjual otomatis",
  T_46_META_WS_E_VERTICAL: "Vertikal",
  T_46_META_WS_E_VEST: "Rompi",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Rompi4",
  T_46_META_WS_E_VISUALEFFECTS: "Efek Visual",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Dinding A",
  T_46_META_WS_E_WALLBRAWL: "Keterampilan 2",
  T_46_META_WS_E_WARNING: "Peringatan",
  T_46_META_WS_E_WATERRING: "Percikan Air",
  T_46_META_WS_E_WAVE1: "Gelombang1",
  T_46_META_WS_E_WAVE2: "Gelombang2",
  T_46_META_WS_E_WAVE3: "Gelombang3",
  T_46_META_WS_E_WEAPONGENERATOR: "Senjata",
  T_46_META_WS_E_WEAPONSLOT: "Slot Senjata",
  T_46_META_WS_E_WHISTLE: "Kalahkan Musuh",
  T_46_META_WS_E_WIDERANGE: "Rentang Luas",
  T_46_META_WS_E_WIN: "Kemenangan",
  T_46_META_WS_E_WINDATTACK: "Serangan Angin",
  T_46_META_WS_E_WOODA: "Kayu A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Zombie Penebang Kayu",
  T_46_META_WS_E_WOODENPLANK: "Jembatan Kayu",
  T_46_META_WS_E_WORLDPOSITION: "Koordinat Dunia",
  T_46_META_WS_E_WRECKEDBUS: "Bus Rusak",
  T_46_META_WS_E_WRECKEDCAR: "Mobil Rusak",
  T_46_META_WS_E_WRONG: "Salah",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zombie",
  T_46_META_WS_E_ZOMBIES: "Zombie",
  T_46_META_WS_E_ZOOM: "Zoom",
  T_46_META_WS_ELIMINATE: "Hapus",
  T_46_META_WS_ELIMINATEDENTITY: "Entitas Tereliminasi",
  T_46_META_WS_ELIMINATEDPLAYER: "Pemain Tereliminasi",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Aktifkan Pohon Perilaku Default",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Aktifkan Zona Aman Bergerak",
  T_46_META_WS_ENABLESAFEZONE: "Aktifkan Zona Aman",
  T_46_META_WS_ENDCURRENTPHASE: "Akhiri Fase Saat Ini",
  T_46_META_WS_ENDMORPH: "Akhiri Perubahan",
  T_46_META_WS_ENDPOSITION: "Posisi Akhir",
  T_46_META_WS_ENTERVEHICLE: "Masuk Kendaraan",
  T_46_META_WS_ENTITY: "Entitas",
  T_46_META_WS_EQUIPMENTID: "ID Equipment",
  T_46_META_WS_EULERANGLETOQUATERNION: "Sudut Euler ke Quaternion",
  T_46_META_WS_EXITVEHICLE: "Keluar dari Kendaraan",
  T_46_META_WS_EXPONENTIATION: "Eksponen",
  T_46_META_WS_FILTERENTITY: "Filter Entitas",
  T_46_META_WS_FILTERLEVELOBJECTS: "Saring Objek Level",
  T_46_META_WS_FIND: "Temukan",
  T_46_META_WS_FINDAT: "Temukan di",
  T_46_META_WS_FINDPATH: "Temukan Jalur",
  T_46_META_WS_FLOOR: "Lantai",
  T_46_META_WS_FOOTBALLGOAL: "Gol Sepak Bola",
  T_46_META_WS_FORMAT: "Format",
  T_46_META_WS_GETALLKEYS: "Dapatkan Semua Kunci",
  T_46_META_WS_GETALLPLAYERS: "Dapatkan Semua Pemain",
  T_46_META_WS_GETALLSHOPS: "Dapatkan Semua Toko",
  T_46_META_WS_GETALLTEAMS: "Dapatkan Semua Tim",
  T_46_META_WS_GETATTACKABLEENTITY: "Dapatkan Entitas yang Bisa Diserang",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Dapatkan Faaksi yang Dapat Diserang",
  T_46_META_WS_GETBACKPACKSKIN: "Dapatkan Skin Backpack",
  T_46_META_WS_GETBLACKBOARDVALUE: "Dapatkan Nilai Blackboard",
  T_46_META_WS_GETBUFFS: "Dapatkan Buff",
  T_46_META_WS_GETCHATCHANNEL: "Dapatkan Kanal Chat",
  T_46_META_WS_GETCHILDBYINDEX: "Dapatkan Anak Berdasarkan Indeks",
  T_46_META_WS_GETCHILDBYNAME: "Dapatkan Anak Berdasarkan Nama",
  T_46_META_WS_GETCHILDREN: "Dapatkan Anak",
  T_46_META_WS_GETCOLORCHANNEL: "Dapatkan Saluran Warna",
  T_46_META_WS_GETCONSUMABLES: "Dapatkan Consumable",
  T_46_META_WS_GETCULLINGMASK: "Dapatkan Masker Culling",
  T_46_META_WS_GETCURRENTCAMERA: "Dapatkan Kamera Saat Ini",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Dapatkan Kanal Chat Saat Ini",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Dapatkan Kemajuan Misi Kustom",
  T_46_META_WS_GETDYEDCOUNT: "Dapatkan Jumlah Pewarnaan",
  T_46_META_WS_GETDYEDSTATUS: "Dapatkan Status Pewarnaan",
  T_46_META_WS_GETEQUIPMENTS: "Dapatkan Perlengkapan",
  T_46_META_WS_GETFACTION: "Dapatkan Faksi",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Dapatkan Ambang Tidur Global",
  T_46_META_WS_GETITEMCOUNT: "Dapatkan Jumlah Item",
  T_46_META_WS_GETLOADEDSCENES: "Dapatkan Adegan yang Dimuat",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Dapatkan Arah Bidikan Lokal",
  T_46_META_WS_GETLOCALPLAYER: "Dapatkan Pemain Lokal",
  T_46_META_WS_GETLOCALTIMESTAMP: "Dapatkan Timestamp Lokal",
  T_46_META_WS_GETMAPID: "Dapatkan ID Peta",
  T_46_META_WS_GETMINIMAP: "Dapatkan Mini Map",
  T_46_META_WS_GETMONEY: "Dapatkan Uang",
  T_46_META_WS_GETMONEYCOUNT: "Dapatkan Jumlah Uang",
  T_46_META_WS_GETMORPH: "Dapatkan Perubahan",
  T_46_META_WS_GETNODEVARIABLE: "Dapatkan Variabel Node",
  T_46_META_WS_GETOUTFIT: "Dapatkan Outfit",
  T_46_META_WS_GETOWNER: "Dapatkan Pemilik",
  T_46_META_WS_GETPARENT: "Dapatkan Parent",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Dapatkan Posisi Dekat Rekan Tim",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Dapatkan Posisi Spawn Acak",
  T_46_META_WS_GETRESULTFROMCURVE: "Dapatkan Hasil dari Kurva",
  T_46_META_WS_GETSCENESKYBOX: "Dapatkan Kotak Langit Adegan",
  T_46_META_WS_GETSERVERREGION: "Dapatkan Wilayah Server",
  T_46_META_WS_GETSERVERTIMESTAMP: "Dapatkan Timestamp Server",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Dapatkan Bagian Kerangka Berdasarkan Nama",
  T_46_META_WS_GETSKILLS: "Dapatkan Skill",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Dapatkan Ambang Tidur",
  T_46_META_WS_GETTOKENCOUNT: "Dapatkan Jumlah Token",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Dapatkan Jumlah Token Hari Ini",
  T_46_META_WS_GETTYPE: "Dapatkan Tipe",
  T_46_META_WS_GETVEHICLESKIN: "Dapatkan Kulit Kendaraan",
  T_46_META_WS_GETWALLET: "Dapatkan Dompet",
  T_46_META_WS_GETWEAPONSKIN: "Dapatkan Skin Senjata",
  T_46_META_WS_GETWIDGETBYPATH: "Dapatkan Widget Berdasarkan Jalur",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Dapatkan Widget Dari UI Kustom",
  T_46_META_WS_GIVEJAILBREAKITEM: "Berikan Item Penjara",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Berikan Hadiah Jail Break",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Apakah Ada Ikuti Khusus AOI",
  T_46_META_WS_HASCOMPONENT: "Memiliki Komponen",
  T_46_META_WS_HASSCRIPT: "Memiliki Skrip",
  T_46_META_WS_HASTAG: "Memiliki Tag",
  T_46_META_WS_HELPEDPLAYER: "Pemain yang Dibantu",
  T_46_META_WS_HELPPLAYER: "Pemain Asist",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Sembunyikan Group Appearance",
  T_46_META_WS_HITENTITY: "Entitas yang Terkena",
  T_46_META_WS_HITFLY: "Hitung Terbang",
  T_46_META_WS_HITNORMAL: "Normal Hit",
  T_46_META_WS_HITOBJECT: "Objek yang Terkena",
  T_46_META_WS_HITPOSITION: "Posisi Hit",
  T_46_META_WS_INDEXOF: "Indeks Dari",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Infeksi Zombie Berkembang",
  T_46_META_WS_INSERT: "Sisipkan",
  T_46_META_WS_ISATTACKABLE: "Apakah Bisa Diserang",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Apakah Kanal Chat Kosong",
  T_46_META_WS_ISEQUAL: "Sama Dengan",
  T_46_META_WS_ISFRIEND: "Apakah Teman",
  T_46_META_WS_ISHIT: "Apakah Terkena",
  T_46_META_WS_ISINSIDEBOX: "Di Dalam Kotak",
  T_46_META_WS_ISINSIDECYLINDER: "Di Dalam Silinder",
  T_46_META_WS_ISINSIDESECTOR: "Di Dalam Sektor",
  T_46_META_WS_ISINSIDESPHERE: "Di Dalam Bola",
  T_46_META_WS_ISSLEEPING: "Apakah Tidur",
  T_46_META_WS_ISSUBTYPEOF: "Adalah Sub Tipe Dari",
  T_46_META_WS_ITEM: "Entitas",
  T_46_META_WS_ITEMID: "ID Item",
  T_46_META_WS_JOIN: "Gabungkan",
  T_46_META_WS_JOINCHATCHANNEL: "Bergabung dengan Kanal Chat",
  T_46_META_WS_JOINFACTION: "Bergabung dengan Fraksi",
  T_46_META_WS_LASTINDEXOF: "Indeks Terakhir Dari",
  T_46_META_WS_LENGTH: "Panjang",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "Muat Adegan",
  T_46_META_WS_LOGARITHM: "Logaritma",
  T_46_META_WS_LOGERROR: "Log Kesalahan",
  T_46_META_WS_LOGINFO: "Catat Info",
  T_46_META_WS_LOGWARNING: "Log Peringatan",
  T_46_META_WS_LOOKROTATION: "Buat Rotasi Menuju Arah Target",
  T_46_META_WS_MAGNITUDE: "Magnitudo",
  T_46_META_WS_MAKER: "Pembuat",
  T_46_META_WS_MAX: "Maks",
  T_46_META_WS_MECHANISM: "Mekanisme",
  T_46_META_WS_MIN: "Min",
  T_46_META_WS_MONSTERUSESKILL: "Gunakan Skill",
  T_46_META_WS_MORPHOBJECT: "Objek Morph",
  T_46_META_WS_MORPHTO: "Berubah Menjadi",
  T_46_META_WS_MORPHTOBYITEMID: "Berubah Menjadi Berdasarkan ID Item",
  T_46_META_WS_MOVECCT: "Pindahkan CCT",
  T_46_META_WS_MOVEPOSITION: "Pindahkan Posisi",
  T_46_META_WS_MOVEROTATION: "Pindahkan Rotasi",
  T_46_META_WS_MULTIPLYQUATERNION: "Kalikan Kuaternion",
  T_46_META_WS_MULTIRAYCAST: "Raycast Multi",
  T_46_META_WS_NEGATE: "Negasi",
  T_46_META_WS_NEW: "Baru",
  T_46_META_WS_NODENAME: "Nama Node",
  T_46_META_WS_NORMALIZE: "Normalisasi",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Notifikasi Mainkan Efek",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Beri Notifikasi Animasi Ikon",
  T_46_META_WS_NOTIFYPLAYSOUND: "Notifikasi Mainkan Suara",
  T_46_META_WS_NOTIFYSHOWTIPS: "Notifikasi Tampilkan Tips",
  T_46_META_WS_NUMTOSTRING: "Ubah Angka ke String",
  T_46_META_WS_ONACCESSEQUIPMENT: "Saat Mengakses Perlengkapan",
  T_46_META_WS_ONACCESSITEM: "Saat Mengakses Barang",
  T_46_META_WS_ONACCESSWEAPON: "Saat Mengakses Senjata",
  T_46_META_WS_ONACE: "Saat ACE",
  T_46_META_WS_ONAIMED: "Saat Di-Aim",
  T_46_META_WS_ONAIMING: "Saat Aiming",
  T_46_META_WS_ONASSIST: "Saat Assist",
  T_46_META_WS_ONATTACK: "Saat Menyerang",
  T_46_META_WS_ONATTACKSTOP: "Saat Serangan Dihentikan",
  T_46_META_WS_ONAWAKE: "Saat Terbangun",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Saat Knock Down",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Saat Dilempar oleh Ban",
  T_46_META_WS_ONBOUNCEENTITY: "Saat Memantul Entitas",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Saat Tombol UI Bawaan Ditekan",
  T_46_META_WS_ONBULLETHIT: "Saat Dihantam Peluru",
  T_46_META_WS_ONCAMERARAYCAST: "Saat Kamera Raycast",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Saat Kontrol Karakter Terkena",
  T_46_META_WS_ONCHASE: "Saat Mengejar",
  T_46_META_WS_ONCHASESTOP: "Saat Mengejar Dihentikan",
  T_46_META_WS_ONCLIPEND: "Saat Klip Berakhir",
  T_46_META_WS_ONCOLLISIONENTER: "Saat Tabrakan Dimulai",
  T_46_META_WS_ONCOLLISIONEXIT: "Saat Tabrakan Berakhir",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Saat Hitungan Mundur Selesai",
  T_46_META_WS_ONCREEP: "Saat Merayap",
  T_46_META_WS_ONCROUCH: "Saat Jongkok",
  T_46_META_WS_ONDEALDAMAGE: "Saat Memberikan Kerusakan",
  T_46_META_WS_ONDESTROY: "Saat Dihancurkan",
  T_46_META_WS_ONDISABLE: "Saat Dinonaktifkan",
  T_46_META_WS_ONDISCONNECT: "Saat Terputus",
  T_46_META_WS_ONDOUBLETAPPED: "Saat Ditekan Dua Kali",
  T_46_META_WS_ONDRAG: "Saat Menarik",
  T_46_META_WS_ONDRAGEND: "Saat Drag Berakhir",
  T_46_META_WS_ONDRAGSTART: "Saat Drag Dimulai",
  T_46_META_WS_ONDRIVED: "Saat Dikemudikan",
  T_46_META_WS_ONDRIVEVEHICLE: "Saat Mengemudi Kendaraan",
  T_46_META_WS_ONDROPCONSUMABLE: "Saat Menjatuhkan Barang Konsumsi",
  T_46_META_WS_ONDROPPED: "Saat Dijatuhkan",
  T_46_META_WS_ONDROPWEAPON: "Saat Drop Senjata",
  T_46_META_WS_ONEACHLOOP: "Saat Setiap Putaran",
  T_46_META_WS_ONELIMINATE: "Saat Mengeliminasi",
  T_46_META_WS_ONELIMINATED: "Saat Dieliminasi",
  T_46_META_WS_ONENABLE: "Saat Diaktifkan",
  T_46_META_WS_ONEND: "Saat Berakhir",
  T_46_META_WS_ONENTERED: "Saat Memasuki",
  T_46_META_WS_ONENTERVEHICLE: "Saat Memasuki Kendaraan",
  T_46_META_WS_ONENTITYENTER: "Saat Trigger Masuk",
  T_46_META_WS_ONENTITYEXIT: "Saat Trigger Keluar",
  T_46_META_WS_ONEQUIPARMOR: "Saat Armor Dipakai",
  T_46_META_WS_ONEQUIPED: "Saat Dipakai",
  T_46_META_WS_ONEQUIPWEAPON: "Saat Senjata Dipakai",
  T_46_META_WS_ONEXPLODE: "Saat Meledak",
  T_46_META_WS_ONFALL: "Saat Jatuh",
  T_46_META_WS_ONFALLSTOP: "Saat Jatuh Berhenti",
  T_46_META_WS_ONFIRE: "Saat Menembak",
  T_46_META_WS_ONFIXEDUPDATE: "Saat Update Tetap",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Saat Bola Sepak Bertabrakan",
  T_46_META_WS_ONFRIENDSUPDATE: "Saat Status Pertemanan Diperbarui",
  T_46_META_WS_ONGAMEEND: "Saat Game Berakhir",
  T_46_META_WS_ONGAMEPAUSE: "Saat Permainan Dijeda",
  T_46_META_WS_ONGAMERESUME: "Saat Permainan Dilanjutkan",
  T_46_META_WS_ONGAMESTART: "Saat Game Dimulai",
  T_46_META_WS_ONGOAL: "Saat Gol",
  T_46_META_WS_ONHITBYBULLET: "Saat Terkena Peluru",
  T_46_META_WS_ONHITFLY: "Saat Hit saat Terbang",
  T_46_META_WS_ONHITFLYENTITY: "Saat Mengenai Entitas yang Terbang",
  T_46_META_WS_ONHOOKGUNFIRE: "Saat Tembakan Pistol Kait",
  T_46_META_WS_ONIDLE: "Saat Diam",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Saat Area Pelarian Penjara Dimulai",
  T_46_META_WS_ONJAILBREAKAREAEND: "Saat Area Jail Break Berakhir",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Saat Pemain Jail Break Bergabung",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Saat Pemain Pelarian Penjara Keluar",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Saat Bergabung dengan Channel Chat Berhasil",
  T_46_META_WS_ONJOYSTICKMOVE: "Saat Joystick Digerakkan",
  T_46_META_WS_ONJOYSTICKPRESSED: "Saat Ditekan",
  T_46_META_WS_ONJOYSTICKRELEASED: "Saat Dilepas",
  T_46_META_WS_ONJUMP: "Saat Melompat",
  T_46_META_WS_ONJUMPSTOP: "Saat Lompat Berhenti",
  T_46_META_WS_ONLANDMINEACTIVE: "Saat Landmine Aktif",
  T_46_META_WS_ONLANDMINETRIGGER: "Saat Landmine Terpicu",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Saat Keluar dari Channel Chat",
  T_46_META_WS_ONLEAVEVEHICLE: "Saat Keluar dari Kendaraan",
  T_46_META_WS_ONLEFT: "Saat Keluar",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Saat Objek Level Berubah",
  T_46_META_WS_ONMOVE: "Saat Bergerak",
  T_46_META_WS_ONNODEENTER: "Saat Node Dimasuki",
  T_46_META_WS_ONNODEEXIT: "Saat Node Keluar",
  T_46_META_WS_ONPAUSE: "Saat Pause",
  T_46_META_WS_ONPHASEEND: "Saat Tahap Berakhir",
  T_46_META_WS_ONPHASESTART: "Saat Tahap Dimulai",
  T_46_META_WS_ONPICKEDUP: "Saat Diambil",
  T_46_META_WS_ONPLAYERASSIST: "Saat Pemain Assist",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Saat Pemain Dieliminasi",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Saat Pemain Ter-Knock Down",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Saat Pemain Memberikan Damage",
  T_46_META_WS_ONPLAYERELIMINATE: "Saat Pemain Mengeliminasi",
  T_46_META_WS_ONPLAYERENTER: "Saat Pemain Masuk",
  T_46_META_WS_ONPLAYERJOIN: "Saat Pemain Bergabung",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Saat Gagal Bergabung dengan Channel Chat",
  T_46_META_WS_ONPLAYERLEAVE: "Saat Pemain Keluar",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Saat Pemain Meminta Pembelian",
  T_46_META_WS_ONPLAYERQUIT: "Saat Pemain Keluar Tengah Match",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Saat Rank Pemain Berubah",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Saat Request Beli Pemain Terpenuhi",
  T_46_META_WS_ONPLAYERREVIVED: "Saat Pemain Direvive",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Saat Pemain Dihidupkan Kembali di Posisi Muncul",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Saat Skor Pemain Berubah",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Saat Pemain Beralih Adegan",
  T_46_META_WS_ONPREDEALDAMAGE: "Saat Sebelum Memberikan Damage",
  T_46_META_WS_ONPREPURCHASE: "Saat Sebelum Membeli",
  T_46_META_WS_ONPRESSED: "Saat Ditekan",
  T_46_META_WS_ONPRETAKEDAMAGE: "Saat Sebelum Mendapatkan Damage",
  T_46_META_WS_ONPURCHASE: "Saat Membeli",
  T_46_META_WS_ONRANKCHANGED: "Saat Rank Entitas Berubah",
  T_46_META_WS_ONRECONNECT: "Saat Terhubung Kembali",
  T_46_META_WS_ONRELEASED: "Saat Dilepas",
  T_46_META_WS_ONRELOAD: "Saat Reload",
  T_46_META_WS_ONRESUME: "Saat Dilanjutkan",
  T_46_META_WS_ONREVIVED: "Saat Dihidupkan Kembali",
  T_46_META_WS_ONROUNDEND: "Saat Ronde Berakhir",
  T_46_META_WS_ONROUNDSTART: "Saat Ronde Dimulai",
  T_46_META_WS_ONSCENELOAD: "Saat Adegan Dimuat",
  T_46_META_WS_ONSCENESWITCH: "Saat Adegan Berubah",
  T_46_META_WS_ONSCORECHANGE: "Saat Skor Entitas Berubah",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Saat Ditembak oleh Pemain Sepak Bola",
  T_46_META_WS_ONSLEEP: "Saat Tidur",
  T_46_META_WS_ONSPAWN: "Saat Spawn",
  T_46_META_WS_ONSPRAY: "Saat Penyemprotan",
  T_46_META_WS_ONSPRAYED: "Saat Disemprotkan",
  T_46_META_WS_ONSPRINT: "Saat Berlari Cepat",
  T_46_META_WS_ONSPRINTSTOP: "Saat Sprint Dihentikan",
  T_46_META_WS_ONSTANDUP: "Saat Berdiri",
  T_46_META_WS_ONSTART: "Saat Dimulai",
  T_46_META_WS_ONSTARTFIRE: "Saat Menyerang",
  T_46_META_WS_ONSTATEEND: "Saat Status Berakhir",
  T_46_META_WS_ONSURFING: "Saat Berselancar",
  T_46_META_WS_ONSURFINGSTOP: "Saat Berselancar Dihentikan",
  T_46_META_WS_ONSWITCHHANDHELD: "Saat Perangkat Tangan Diubah",
  T_46_META_WS_ONTAKEDAMAGE: "Saat Mendapatkan Damage",
  T_46_META_WS_ONTAPPED: "Saat Ditekan",
  T_46_META_WS_ONTEAMACE: "Saat Tim Dieliminasi Sepenuhnya",
  T_46_META_WS_ONTEAMADD: "Saat Tim Ditambahkan",
  T_46_META_WS_ONTEAMREMOVE: "Saat Tim Dihapus",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Saat Peringkat Round Tim Berubah",
  T_46_META_WS_ONTEAMSCORECHANGE: "Saat Skor Tim Berubah",
  T_46_META_WS_ONTELEPORTENTITY: "Saat Teleport Entitas",
  T_46_META_WS_ONTEXTCHANGE: "Saat Teks Berubah",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Saat Throwable Meledak",
  T_46_META_WS_ONTOGGLE: "Saat Toggle",
  T_46_META_WS_ONTOUCHDOWN: "Saat Touchdown",
  T_46_META_WS_ONTOUCHUP: "Saat Menyentuh Atas",
  T_46_META_WS_ONUIHIDE: "Saat UI Disembunyikan",
  T_46_META_WS_ONUISHOW: "Saat UI Ditampilkan",
  T_46_META_WS_ONUPDATE: "Saat Memperbarui",
  T_46_META_WS_ONUSEAVATARSKILL: "Saat Menggunakan Keterampilan Avatar",
  T_46_META_WS_ONUSECONSUMABLE: "Saat Menggunakan Consumable",
  T_46_META_WS_ONUSED: "Saat Digunakan",
  T_46_META_WS_ONUSEPORTAL: "Saat Menggunakan Portal",
  T_46_META_WS_ONWAKEUP: "Saat Bangun",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Saat Senjata Dipakai",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Saat Senjata Memberikan Damage",
  T_46_META_WS_ONWEAPONELIMINATE: "Saat Senjata Mengeliminasi",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Saat Senjata Berhenti Menembak",
  T_46_META_WS_OWNER: "Pemilik",
  T_46_META_WS_P_ACCELERATE: "Akselerasi",
  T_46_META_WS_P_ACCELERATION: "Akselerasi",
  T_46_META_WS_P_ACCOUNTID: "ID Akun",
  T_46_META_WS_P_ACCURACY: "Akurasi",
  T_46_META_WS_P_ACTIONTYPE: "Jenis Aksi",
  T_46_META_WS_P_ACTIVATEDALPHA: "Alfa Aktif",
  T_46_META_WS_P_ACTIVE: "Aktif",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Aktif di Hirarki",
  T_46_META_WS_P_ACTIVESELF: "Aktif Diri",
  T_46_META_WS_P_ACTIVETEXT: "Teks Aktif",
  T_46_META_WS_P_ACTUALPOSITION: "Posisi Aktual",
  T_46_META_WS_P_AFTERACCUMULATOR: "Akumulator Setelah",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Offset Pusat Bantuan Bidik",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Jarak Aim Assist",
  T_46_META_WS_P_AIMASSISTTYPE: "Bantuan Membidik",
  T_46_META_WS_P_AIRDROPSTATE: "Status Jatuh Udara",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Penyelarasan Horizontal",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Penyelarasan Vertikal",
  T_46_META_WS_P_ALLITEMS: "Semua Item",
  T_46_META_WS_P_ALLMEMBERS: "Semua Anggota",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Memungkinkan Kunci dengan Bantuan",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Izinkan Tekan di Luar",
  T_46_META_WS_P_ALLPLAYERS: "Semua Pemain",
  T_46_META_WS_P_ALLTEAMMATES: "Semua Rekan Tim",
  T_46_META_WS_P_ALPHA: "Alpha",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Selalu Tampilkan Tandai",
  T_46_META_WS_P_AMBIENTCOLOR: "Warna Ambient",
  T_46_META_WS_P_AMMOCLIPSIZE: "Ukuran Klip Peluru",
  T_46_META_WS_P_AMMOMAGSIZE: "Ukuran Mag Ammunisi",
  T_46_META_WS_P_AMMOPERSHOT: "Peluru per Tembakan",
  T_46_META_WS_P_AMMOTYPE: "Jenis Amunisi",
  T_46_META_WS_P_ANCHORMAX: "Jangkar Maksimum",
  T_46_META_WS_P_ANCHORMIN: "Jangkar Minimum",
  T_46_META_WS_P_ANCHOROBJECT: "Objek Jangkar",
  T_46_META_WS_P_ANCHORPOSITION: "Posisi Jangkar",
  T_46_META_WS_P_ANCHORTYPE: "Tipe Jangkar",
  T_46_META_WS_P_ANGLE: "Sudut",
  T_46_META_WS_P_ANGLEDOWN: "Sudut Bawah",
  T_46_META_WS_P_ANGLEUP: "Sudut Atas",
  T_46_META_WS_P_ANGULARDRAG: "Gesekan Sudut",
  T_46_META_WS_P_ANGULARSPEED: "Kecepatan Sudut",
  T_46_META_WS_P_ANGULARVELOCITY: "Kecepatan Sudut (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Nama Animasi",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Pengendali Animasi",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "ID Sumber Pengontrol Animasi",
  T_46_META_WS_P_ARMORPENETRATION: "Penetrasi Armor",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Faktor Penetrasi Armor",
  T_46_META_WS_P_ARMORTYPE: "Jenis Armor",
  T_46_META_WS_P_ARROWOFFSET: "Offset Panah",
  T_46_META_WS_P_ARROWSIZE: "Ukuran Panah",
  T_46_META_WS_P_ARROWSPRITE: "Sprite Panah",
  T_46_META_WS_P_ASKBUYTARGET: "Target Meminta Pembelian",
  T_46_META_WS_P_ATTACHTARGET: "Target Terpasang",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Faksi yang Bisa Diserang",
  T_46_META_WS_P_ATTACKDAMAGE: "Kerusakan Serangan",
  T_46_META_WS_P_ATTACKINTERVAL: "Interval Serangan",
  T_46_META_WS_P_ATTACKRANGE: "Jangkauan Serangan",
  T_46_META_WS_P_ATTACKTARGET: "Target Serangan",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Sasaran yang Bisa Diserang",
  T_46_META_WS_P_AUTOPLAY: "Status pemutaran otomatis",
  T_46_META_WS_P_AVAILABLEPOINT: "Titik Tersedia",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "ID Avatar",
  T_46_META_WS_P_BACKGROUND: "Latar Belakang",
  T_46_META_WS_P_BACKGROUNDALPHA: "Alfa Latar Belakang",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Warna Latar Belakang",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Warna Latar Belakang 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Warna Latar Belakang 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Pengisian Latar Belakang",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Nama Ikon Latar Belakang",
  T_46_META_WS_P_BACKGROUNDNAME: "Nama Latar Belakang",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Offset Latar Belakang",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Radius Latar Belakang",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Delta Ukuran Latar Belakang",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Sprite Latar Belakang",
  T_46_META_WS_P_BACKPACK: "Backpack",
  T_46_META_WS_P_BACKPACKSKINID: "ID kulit ransel",
  T_46_META_WS_P_BACKWARDSPEED: "Kecepatan Mundur",
  T_46_META_WS_P_BANNERID: "ID Spanduk",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Kecepatan Horizontal Dasar",
  T_46_META_WS_P_BASEMULTIPLIER: "Pengali Dasar",
  T_46_META_WS_P_BASETIME: "Waktu Dasar",
  T_46_META_WS_P_BASEVERTICALSPEED: "Kecepatan Vertikal Dasar",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Akumulator Sebelumnya",
  T_46_META_WS_P_BEVTREEID: "ID Pohon Perilaku",
  T_46_META_WS_P_BINDPROPERTYID: "ID Properti Tautan",
  T_46_META_WS_P_BODY: "Torso",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Faktor Damage Tubuh",
  T_46_META_WS_P_BONEPOSITION: "Posisi Tulang",
  T_46_META_WS_P_BONESCALE: "Skala Kerangka",
  T_46_META_WS_P_BOOSTCD: "CD Boost",
  T_46_META_WS_P_BOOSTDURATION: "Durasi Boost",
  T_46_META_WS_P_BOOSTSPEED: "Kecepatan Boost",
  T_46_META_WS_P_BORDERLR: "Border Kiri Kanan",
  T_46_META_WS_P_BORDERTB: "Border Atas Bawah",
  T_46_META_WS_P_BOTTOMALPHA: "Alfa Bawah",
  T_46_META_WS_P_BOUNDWALLET: "Jenis Titik Jangkar HUD",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Tenaga Rem",
  T_46_META_WS_P_BRAKETORQUE: "Torsi Rem",
  T_46_META_WS_P_BRRANK: "Peringkat BR",
  T_46_META_WS_P_BUFFTYPE: "Jenis Buff",
  T_46_META_WS_P_BURNDAMAGE: "Kerusakan Terbakar",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Interval Kerusakan Terbakar",
  T_46_META_WS_P_BURNTIME: "Waktu Terbakar",
  T_46_META_WS_P_BUTTOM: "Bawah",
  T_46_META_WS_P_BUTTONCOLORS: "Warna Tombol",
  T_46_META_WS_P_BUTTONNAMES: "Nama Tombol",
  T_46_META_WS_P_BUTTONSTYLE: "Gaya Tombol",
  T_46_META_WS_P_CAMERABLOCKMODE: "Mode Pemblokiran Kamera",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Mode Proyeksi Kamera",
  T_46_META_WS_P_CAMERATYPE: "Tipe Kamera",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Batalkan Tarik Jika Cocok",
  T_46_META_WS_P_CANCOSTDURABILITY: "Bisa Mengurangi Durabilitas",
  T_46_META_WS_P_CANDAMAGED: "Bisa Men-Damage",
  T_46_META_WS_P_CANDESTROY: "Bisa Dihancurkan",
  T_46_META_WS_P_CANDESTROYED: "Bisa Hancur",
  T_46_META_WS_P_CANSELFTRIGGER: "Dapat memicu sendiri",
  T_46_META_WS_P_CANTEAMTRIGGER: "Dapat dipicu oleh tim",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Bisa Dipicu oleh Diri Sendiri",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Bisa Dipicu oleh Tim",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Bisa Dipicu oleh Kendaraan",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Dapat Dipicu Kendaraan",
  T_46_META_WS_P_CELLSIZE: "Ukuran Sel",
  T_46_META_WS_P_CELLSPACE: "Jarak Sel",
  T_46_META_WS_P_CENTER: "Pusat",
  T_46_META_WS_P_CENTERINVISIBLE: "Tengah Tidak Terlihat",
  T_46_META_WS_P_CENTEROFFSET: "Offset Pusat",
  T_46_META_WS_P_CENTEROFMASS: "Titik Berat",
  T_46_META_WS_P_CENTERRANGE: "Jarak Pusat",
  T_46_META_WS_P_CENTRALFLASHTIME: "Waktu Flash Tengah",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Garis Tengah Aktif",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Posisi Garis Tengah",
  T_46_META_WS_P_CHANNELID: "ID Saluran Chat",
  T_46_META_WS_P_CHARGEMAX: "Batas Maksimum Muatan",
  T_46_META_WS_P_CHASETARGET: "Sasaran Kejar",
  T_46_META_WS_P_CHATCHANNEL: "Saluran Obrolan",
  T_46_META_WS_P_CHECKPOINTID: "ID Titik Pemeriksaan",
  T_46_META_WS_P_CHILDINDEX: "Indeks Anak",
  T_46_META_WS_P_CHIPEXP: "Pengalaman Per Cip",
  T_46_META_WS_P_CLICKSIZE: "Ukuran Klik",
  T_46_META_WS_P_CLIPLENGTH: "Panjang Klip",
  T_46_META_WS_P_CLIPPINGTYPE: "Jenis Pemangkasan",
  T_46_META_WS_P_COLLIDERID: "ID Collider",
  T_46_META_WS_P_CONSTRAIN: "Pembatas",
  T_46_META_WS_P_CONSTRAINT: "Kendala",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Jumlah Kendala",
  T_46_META_WS_P_CONSUMABLETYPE: "Jenis Konsumabel",
  T_46_META_WS_P_CONTENT: "Konten",
  T_46_META_WS_P_CONTENTORIGIN: "Asal Konten",
  T_46_META_WS_P_CONTROLPOINTS: "Titik Kontrol",
  T_46_META_WS_P_COORDINATESYSTEM: "Sistem Koordinat",
  T_46_META_WS_P_COUNT: "Jumlah",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Waktu Akhir Hitung Mundur (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Kunci Hitung Mundur",
  T_46_META_WS_P_COUNTDOWNTIME: "Waktu Hitung Mundur",
  T_46_META_WS_P_COUNTPERWAVE: "Jumlah per Gelombang",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Kerusakan Maksimum Benturan",
  T_46_META_WS_P_CRASHMAXSPEED: "Kecepatan Maksimum Benturan",
  T_46_META_WS_P_CRASHMESSFACTOR: "Faktor Kualitas Benturan",
  T_46_META_WS_P_CRASHMINDAMAGE: "Kerusakan Minimum Benturan",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Skala kecepatan gerak saat merangkak",
  T_46_META_WS_P_CREATEDENTITY: "Entitas yang Dibuat",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Skala kecepatan gerakan saat jongkok",
  T_46_META_WS_P_CSRANK: "Peringkat CS",
  "T_46_META_WS_P_CURRENT AMMO": "Ammo Saat Ini",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Sumber Animasi Saat Ini",
  T_46_META_WS_P_CURRENTCLIP: "Klip Saat Ini",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Kemajuan Klip Saat Ini",
  T_46_META_WS_P_CURRENTDURABILITY: "Durabilitas Saat Ini",
  T_46_META_WS_P_CURRENTENERGY: "Energi Saat Ini",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Item yang Sedang Digenggam",
  T_46_META_WS_P_CURRENTHP: "HP Saat Ini",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Indeks Tahap Saat Ini",
  T_46_META_WS_P_CURRENTPROGRESS: "Kemajuan Saat Ini",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Indeks Ronde Saat Ini",
  T_46_META_WS_P_CURRENTSTATE: "Status Saat Ini",
  T_46_META_WS_P_CURRENTVALUE: "Nilai Saat Ini",
  T_46_META_WS_P_CURRENTWAVE: "Gelombang Saat Ini",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Sumber Karakter Kustom",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Hasil Permainan Kustom",
  T_46_META_WS_P_CUSTOMGRAVITY: "Gravitasi Kustom",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Gaya Dorong Kustom",
  T_46_META_WS_P_CUSTOMXY: "XY Kustom",
  T_46_META_WS_P_DAMAGE: "Kerusakan",
  "T_46_META_WS_P_DAMAGE RANGE": "Jangkauan",
  T_46_META_WS_P_DAMAGEFACTOR: "Faktor Kerusakan",
  T_46_META_WS_P_DAMAGEINTERVAL: "Interval Kerusakan (dtk)",
  T_46_META_WS_P_DAMAGERADIUS: "Jari-Jari Kerusakan",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Rasio Damage Kepala",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Rasio Damage Limb",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Faktor Pengurangan Damage",
  T_46_META_WS_P_DAMAGETAKENPCT: "Persentase Kerusakan Diterima",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Persentase Damage yang Diterima",
  T_46_META_WS_P_DAMAGEVALUE: "Nilai Kerusakan",
  T_46_META_WS_P_DARKNESS: "Kegelapan",
  T_46_META_WS_P_DECELERATIONPERCENT: "Persentase Deselerasi",
  T_46_META_WS_P_DEFAULTTEXT: "Teks Default",
  T_46_META_WS_P_DEFENSE: "Tingkat Pertahanan",
  T_46_META_WS_P_DEFENSERATE: "Tingkat Pengurangan Damage",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Waktu Delta",
  T_46_META_WS_P_DELTAVALUE: "Nilai Delta",
  T_46_META_WS_P_DEPTH: "Kedalaman",
  T_46_META_WS_P_DESC: "Deskripsi",
  T_46_META_WS_P_DESCRIPTION: "Deskripsi",
  T_46_META_WS_P_DESCRIPTIONKEY: "Kunci Deskripsi",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Parameter Deskripsi",
  T_46_META_WS_P_DESTVAL: "Nilai Tujuan",
  T_46_META_WS_P_DETECTRANGE: "Area Kejar",
  T_46_META_WS_P_DIFFUSEALPHA: "Difusi Alpha",
  T_46_META_WS_P_DIFFUSECOLOR: "Warna Difusi",
  T_46_META_WS_P_DIFFUSETEXTURE: "Tekstur Difusi",
  T_46_META_WS_P_DISABLECOLOR: "Warna Dinonaktifkan",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Tidak ada Damage Jatuh",
  T_46_META_WS_P_DISABLEITEMDROP: "Nonaktifkan Drop Item",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Nonaktifkan Pengambilan Item",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Nonaktifkan Penutupan Manual",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Nonaktifkan Pesan Cepat",
  T_46_META_WS_P_DISABLERECIPROCATING: "Nonaktifkan Gerakan Bolak-Balik",
  T_46_META_WS_P_DISABLEVOICECHAT: "Nonaktifkan Voice Chat",
  T_46_META_WS_P_DISTANCE: "Jarak",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Jenis Senjata Ganda",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Skala kecepatan gerakan saat merangkak",
  T_46_META_WS_P_DOWNSPEED: "Kecepatan Turun",
  T_46_META_WS_P_DRAG: "Gesekan",
  T_46_META_WS_P_DRIVER: "Pengemudi",
  T_46_META_WS_P_DROPITEMS: "Barang Jatuh",
  T_46_META_WS_P_DURABILITY: "Daya Tahan",
  T_46_META_WS_P_DURABILITYRECOVERY: "Pemulihan Durabilitas",
  T_46_META_WS_P_DURATION: "Durasi",
  T_46_META_WS_P_EDGEFLASHTIME: "Saklar Efek Flashbang",
  T_46_META_WS_P_EFFECTACTIVE: "Efek Aktif",
  T_46_META_WS_P_EFFECTCOLOR: "Warna Efek",
  T_46_META_WS_P_EFFECTDURATION: "Durasi Efek",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Interval Waktu Efektif",
  T_46_META_WS_P_EFFECTRESID: "Jalur Efek Sumber Daya",
  T_46_META_WS_P_ENABLE: "Aktifkan",
  T_46_META_WS_P_ENABLEATTACK: "Aktifkan Serangan",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Aktifkan Revive Bot",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Aktifkan Peta Kedalaman",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Aktifkan Jatuh Saat Kematian",
  T_46_META_WS_P_ENABLELOCALIZATION: "Aktifkan Lokalisasi",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Apakah Dapat Bergerak di Udara",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Aktifkan Revive Pemain",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Aktifkan Tampilan Pemain",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Mengaktifkan Putar dengan Gravitasi",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Aktifkan Atribut Skin",
  T_46_META_WS_P_ENABLESWINGING: "Aktifkan Ayunan",
  T_46_META_WS_P_ENABLETRACTION: "Aktifkan Tarikan",
  T_46_META_WS_P_ENDPOSITION: "Posisi Akhir",
  T_46_META_WS_P_ENDRADIUS: "Jari-Jari Akhir",
  T_46_META_WS_P_ENDTIME: "Waktu Akhir (dtk)",
  T_46_META_WS_P_ENDTIMES: "Waktu Akhir S",
  T_46_META_WS_P_ENDVALUE: "Nilai Akhir",
  T_46_META_WS_P_ENERGY: "Energi",
  T_46_META_WS_P_ENERGYCOST: "Biaya Energi",
  T_46_META_WS_P_ENERGYRECOVERY: "Pemulihan Energi",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Tenaga Mesin",
  T_46_META_WS_P_ENGINETORQUE: "Torsi Mesin",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "EP Maksimum",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "Jumlah Pemulihan EP",
  T_46_META_WS_P_EVENTS: "Acara",
  T_46_META_WS_P_EXPLODEDAMAGE: "Kerusakan Ledakan",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Faktor Pengurangan Damage Ledakan",
  T_46_META_WS_P_EXPLODEDELAY: "Penundaan Ledakan",
  T_46_META_WS_P_EXPLODERANGE: "Jangkauan Ledakan",
  T_46_META_WS_P_EXPLOSIONDELAY: "Waktu Kilatan Pusat",
  T_46_META_WS_P_EXPLOSIONRANGE: "Jangkauan Ledakan",
  T_46_META_WS_P_EXPLOSIONTIME: "Penundaan Ledakan",
  T_46_META_WS_P_EXPPERDAMAGE: "Exp per Damage",
  T_46_META_WS_P_EXPPERMOVEMILE: "Exp per Mil yang Ditempuh",
  T_46_META_WS_P_EXPPERSECOND: "EXP per Detik",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Kapasitas Tambahan Backpack",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Ruang Ransel Ekstra",
  T_46_META_WS_P_EXTRAHPRATIO: "Rasio HP Tambahan",
  T_46_META_WS_P_FACEPAINT: "Facepaint",
  T_46_META_WS_P_FACTION: "Faksi",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Rasio Kerusakan Jatuh",
  T_46_META_WS_P_FALLSPEED: "Kecepatan Jatuh",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Kecepatan Reload Otomatis",
  T_46_META_WS_P_FILEID: "ID File",
  T_46_META_WS_P_FILL: "Isi",
  T_46_META_WS_P_FILLAMOUNT: "Nilai Pengisian",
  T_46_META_WS_P_FILLDIRECTION: "Arah Pengisian",
  T_46_META_WS_P_FILLTYPE: "Jenis Pengisian",
  T_46_META_WS_P_FIREANGLELIMIT: "Batas Sudut Tembakan",
  T_46_META_WS_P_FIRETYPE: "Jenis Tembakan",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Parameter Skor Pertama",
  T_46_META_WS_P_FIRSTSCORETITLE: "Judul Skor Pertama",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Nilai Skor Pertama",
  T_46_META_WS_P_FIXEDDELTATIME: "Delta Tetap",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Sakelar Efek Hit Flashbang",
  T_46_META_WS_P_FLIP: "Pembalik",
  T_46_META_WS_P_FLIPTYPE: "Jenis Balik",
  T_46_META_WS_P_FLYMAXHEIGHT: "Ketinggian Terbang Maksimal",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Kecepatan Horizontal Glide",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Kecepatan Terbang Vertikal",
  T_46_META_WS_P_FOGCOLOR: "Warna Kabut",
  T_46_META_WS_P_FOLLOWTARGET: "Ikuti Target",
  T_46_META_WS_P_FONT: "Font",
  T_46_META_WS_P_FONTSIZE: "Ukuran Font",
  T_46_META_WS_P_FONTSTYLE: "Gaya Font",
  T_46_META_WS_P_FONTTYPE: "Jenis Font",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Paksa Sinkronisasi ke Klien",
  T_46_META_WS_P_FORWARD: "Maju",
  T_46_META_WS_P_FORWARDSPEED: "Kecepatan Maju",
  T_46_META_WS_P_FOV: "Ruang Pandang",
  T_46_META_WS_P_FREEZEDURATION: "Durasi Beku (detik)",
  T_46_META_WS_P_FRIENDFACTIONS: "Faksi Teman",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Pemain Teman",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Jarak Kerusakan Penuh",
  T_46_META_WS_P_FUNCTIONTYPE: "Jenis Fungsi",
  T_46_META_WS_P_GAINHPCOLOR: "Warna Penambahan HP",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Jumlah Frame",
  T_46_META_WS_P_GAMETIMECOUNT: "Waktu Permainan",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Keterlambatan Pergeseran Gear",
  T_46_META_WS_P_GENDER: "Jenis",
  T_46_META_WS_P_GETONBOOSTCD: "CD Naik Boost",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Tombol CD untuk Boost Naik",
  T_46_META_WS_P_GETONSKATEBOARDCD: "CD untuk Naik Skateboard",
  T_46_META_WS_P_GRADIENT: "Gradien",
  T_46_META_WS_P_GRADIENTBOTTOM: "Gradien Bawah",
  T_46_META_WS_P_GRADIENTTOP: "Gradien Atas",
  T_46_META_WS_P_GRAVITY: "Gravitasi",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Kerusakan Maksimum Granat",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Kerusakan Minimum Granat",
  T_46_META_WS_P_GRENADERANGE: "Jangkauan Granat",
  T_46_META_WS_P_GROUPID: "ID Grup",
  T_46_META_WS_P_HEAD: "Kepala",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Faktor Damage Kepala",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Pengurangan Kerusakan Kepala",
  T_46_META_WS_P_HEIGHT: "Tinggi",
  T_46_META_WS_P_HELMET: "Helm",
  T_46_META_WS_P_HIGHESTBRRANK: "Peringkat BR Tertinggi",
  T_46_META_WS_P_HIGHESTCSRANK: "Peringkat CS Tertinggi",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Sudut Elevasi Minimum",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Batas Kemudi Kecepatan Tinggi",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Ambang Batas Kemudi Kecepatan Tinggi",
  T_46_META_WS_P_HITPOINTEFFECT: "Efek Titik Tabrakan",
  T_46_META_WS_P_HORIZONTALBAR: "Bar Horizontal",
  T_46_META_WS_P_HORIZONTALOFFSET: "Offset Horizontal",
  T_46_META_WS_P_HOSTILETEAMS: "Tim Musuh",
  T_46_META_WS_P_HOSTTEAM: "Tim Tuan Rumah",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "HP Maks",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "Jumlah Pemulihan HP",
  T_46_META_WS_P_HPRECOVERYSPEED: "Kecepatan Pemulihan HP (ms)",
  T_46_META_WS_P_ICON: "Ikon",
  T_46_META_WS_P_ICONCOLOR: "Warna Ikon",
  T_46_META_WS_P_ICONNAME: "Nama Ikon",
  T_46_META_WS_P_ICONRESOURCE: "Sumber Ikon",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Interval Kerusakan (d)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Rasio Rem Idle",
  T_46_META_WS_P_INACTIVATEDALPHA: "Alfa Tidak Aktif",
  T_46_META_WS_P_INDEX: "Indeks",
  T_46_META_WS_P_INITIALMAGCOUNT: "Jumlah Peluru Awal",
  T_46_META_WS_P_INITIALSPEED: "Kecepatan Awal",
  T_46_META_WS_P_INITIALVALUE: "Nilai Awal",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Posisi Dunia Awal",
  T_46_META_WS_P_INSCENE: "Dalam Adegan",
  T_46_META_WS_P_INSTANCEID: "ID instance",
  T_46_META_WS_P_INTENSITY: "Intensitas",
  T_46_META_WS_P_INVERTFILL: "Balik Pengisian",
  T_46_META_WS_P_INVINCIBLE: "Tak Terkalahkan",
  "T_46_META_WS_P_IS SHOW": "Apakah Ditampilkan",
  T_46_META_WS_P_IS3D: "Apakah 3D",
  T_46_META_WS_P_ISACE: "Apakah itu ACE?",
  T_46_META_WS_P_ISACED: "Apakah Terhapus",
  T_46_META_WS_P_ISAI: "Adalah AI",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Selalu di Layar",
  T_46_META_WS_P_ISAPPLYSHADOW: "Terapkan Bayangan",
  T_46_META_WS_P_ISATTACKABLE: "Bisa diserang",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Otomatis Mengejar Musuh",
  T_46_META_WS_P_ISAUTOPLAY: "Putar Otomatis",
  T_46_META_WS_P_ISAUTOTELEPORT: "Apakah Teleport Otomatis",
  T_46_META_WS_P_ISBILLBOARD: "Selalu Menghadap Kamera",
  T_46_META_WS_P_ISBOLD: "Tebal",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Apakah Terjadi Tabrakan Bawah",
  T_46_META_WS_P_ISCENTERPOS: "Apakah Posisi Pusat",
  T_46_META_WS_P_ISCONSUMEAMMO: "Konsumsi Amunisi",
  T_46_META_WS_P_ISCONTINUOUS: "Apakah Berkelanjutan",
  T_46_META_WS_P_ISCOUNTDOWN: "Apakah Hitung Mundur",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Apakah Animasi Saat Ini Berulang?",
  T_46_META_WS_P_ISDEADDROP: "Dukungan Kematian",
  T_46_META_WS_P_ISDEATHTRIGGER: "Apakah Pemicu Kematian",
  T_46_META_WS_P_ISDEBUG: "Aktifkan Debug BTree",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Apakah Titik Spawn Default",
  T_46_META_WS_P_ISDROPONELIMINATED: "Hilang saat dieliminasi",
  T_46_META_WS_P_ISEND: "Apakah Akhir",
  T_46_META_WS_P_ISFEBUTTON: "Apakah Tombol FE",
  T_46_META_WS_P_ISGREY: "Apakah Abu-Abu",
  T_46_META_WS_P_ISGROUNDED: "Apakah Berada di Tanah",
  T_46_META_WS_P_ISIGNOREDEPTH: "Abaikan Kedalaman",
  T_46_META_WS_P_ISINVINCIBLE: "Invincible",
  T_46_META_WS_P_ISITALIC: "Miring",
  T_46_META_WS_P_ISLASTROUND: "Apakah Putaran Terakhir",
  T_46_META_WS_P_ISLOCALPOS: "Apakah Posisi Lokal",
  T_46_META_WS_P_ISLOOP: "Apakah Berulang",
  T_46_META_WS_P_ISMATCHPOINT: "Apakah Titik Pertandingan",
  T_46_META_WS_P_ISMOVEABLE: "Dapat Bergerak",
  T_46_META_WS_P_ISOCCUPIED: "Apakah Sudah Digunakan",
  T_46_META_WS_P_ISOPENTWEEN: "Apakah OpenTween",
  T_46_META_WS_P_ISPLAYING: "Sedang Diputar",
  T_46_META_WS_P_ISPURCHASABLE: "Item Toko",
  T_46_META_WS_P_ISREVERSE: "Balik",
  T_46_META_WS_P_ISSERVERDRIVEN: "Apakah Didorong Server",
  T_46_META_WS_P_ISSHOW: "Tampilkan",
  T_46_META_WS_P_ISSHOWHUDNAME: "Tampilkan Nama HUD",
  T_46_META_WS_P_ISSHOWMAPINFO: "Tampilkan Informasi Peta",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Tampilkan Pesan Cepat",
  T_46_META_WS_P_ISSHOWSCAN: "Tampilkan Pindai",
  T_46_META_WS_P_ISSHOWTAG: "Tampilkan Tag",
  T_46_META_WS_P_ISSIDECOLLIDING: "Apakah Terjadi Tabrakan Samping",
  T_46_META_WS_P_ISSILENCE: "Apakah Senyap",
  T_46_META_WS_P_ISSINGLESHOT: "Apakah Tembakan Tunggal",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Lewati Animasi Jatuh",
  T_46_META_WS_P_ISSLIDING: "Apakah Selip",
  T_46_META_WS_P_ISTOPCOLLIDING: "Apakah Terjadi Tabrakan Atas",
  T_46_META_WS_P_ISUNDERLINE: "Garis Bawah",
  T_46_META_WS_P_ISVISIBLE: "Terlihat",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Warna Latar Belakang Kartu",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Latar Belakang Kartu",
  T_46_META_WS_P_ITEMCOUNTS: "Dapat Dibeli",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Deskripsi Kartu",
  T_46_META_WS_P_ITEMICONS: "Ikon Kartu",
  T_46_META_WS_P_ITEMID: "ID Senjata",
  T_46_META_WS_P_ITEMIDS: "ID Item",
  T_46_META_WS_P_ITEMNAMES: "Nama Kartu",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Daftar Item yang Diban",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Radius Tarik Cap Joystick",
  T_46_META_WS_P_JOYSTICKIMAGE: "Gambar Cap Joystick",
  T_46_META_WS_P_JOYSTICKRADIUS: "Radius Cap Joystick",
  T_46_META_WS_P_JUMPCD: "CD Lompat",
  T_46_META_WS_P_JUMPHEIGHT: "Tinggi Lonjakan",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Skala Tinggi Lompat",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Bonus Kerusakan Knockdown",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Status Knockdown",
  T_46_META_WS_P_LABEL: "Label",
  T_46_META_WS_P_LABELCOLOR: "Warna Label",
  T_46_META_WS_P_LABELKEY: "Kunci Label",
  T_46_META_WS_P_LABELPARAMS: "Parameter Label",
  T_46_META_WS_P_LASTCHECKPOINTID: "ID Checkpoint Saat Ini",
  T_46_META_WS_P_LASTSURVIVALTIME: "Waktu Bertahan Terakhir",
  T_46_META_WS_P_LAYERTYPE: "Jenis Lapisan",
  T_46_META_WS_P_LAYOUTTYPE: "Jenis Layout",
  T_46_META_WS_P_LEFTARM: "Lengan Kiri",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Warna Latar Belakang Kiri",
  T_46_META_WS_P_LEFTCOLOR: "Warna Kiri",
  T_46_META_WS_P_LEFTDESCRIPTION: "Deskripsi Tim Kiri",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Efek Kiri Aktif",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Sudut Tembak Kiri",
  T_46_META_WS_P_LEFTFOOT: "Kaki Kiri Bawah",
  T_46_META_WS_P_LEFTHAND: "Tangan Kiri",
  T_46_META_WS_P_LEFTICON: "Ikon Kiri",
  T_46_META_WS_P_LEFTICONNAME: "Nama Ikon Kiri",
  T_46_META_WS_P_LEFTLEG: "Kaki Kiri",
  T_46_META_WS_P_LEFTPLAYERS: "Pemain Kiri",
  T_46_META_WS_P_LEFTSCORE: "Skor Kiri",
  T_46_META_WS_P_LEFTSCOREAFTER: "Skor Akhir Kiri",
  T_46_META_WS_P_LEFTSCORETEXT: "Skor Kiri",
  T_46_META_WS_P_LEFTTEAM: "Tim Kanan",
  T_46_META_WS_P_LEFTTEAMINDEX: "Indeks Tim Kiri",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Jumlah Pemain Hidup Kiri",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Jumlah Bendera Teman Tim Kiri",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Status Teman Tim Kiri",
  T_46_META_WS_P_LEFTTEAMNAME: "Nama Tim Kiri",
  T_46_META_WS_P_LEFTTEAMSCORE: "Skor Tim Kiri",
  T_46_META_WS_P_LEFTTEXT: "Teks Kiri",
  T_46_META_WS_P_LENGTH: "Panjang",
  T_46_META_WS_P_LENSFLARE: "Lens Flare",
  T_46_META_WS_P_LEVEL: "Level",
  T_46_META_WS_P_LIFETIME: "Waktu Hidup (d)",
  T_46_META_WS_P_LIGHTCOLOR: "Warna Cahaya",
  T_46_META_WS_P_LIGHTINTENSITY: "Intensitas Cahaya",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Faktor Damage Limb",
  T_46_META_WS_P_LINESPACING: "Jarak Baris",
  T_46_META_WS_P_LOCALPOSITION: "Posisi Lokal",
  T_46_META_WS_P_LOCALROTATION: "Rotasi Lokal",
  T_46_META_WS_P_LOCALROTATIONQ: "Kuaternion Lokal",
  T_46_META_WS_P_LOCALSCALE: "Skala Lokal",
  T_46_META_WS_P_LOCKEY: "Kunci Lokalisasi",
  T_46_META_WS_P_LOOPCOUNT: "Jumlah Putaran",
  T_46_META_WS_P_LOOTSOCCER: "Loot Sepakbola",
  T_46_META_WS_P_LOSEHPCOLOR: "Warna Kehilangan HP",
  T_46_META_WS_P_LOSEMVPS: "MVP Kekalahan",
  T_46_META_WS_P_LOSETEXT: "Teks Kekalahan",
  "T_46_META_WS_P_MAIN CAMERA": "Kamera Utama",
  T_46_META_WS_P_MAINCOLOR: "Warna Utama",
  T_46_META_WS_P_MAINSCORELIST: "Skor Utama",
  T_46_META_WS_P_MAINSCORETITLE: "Judul Skor Utama",
  T_46_META_WS_P_MAINWEAPON: "Senjata Utama",
  T_46_META_WS_P_MAPSIZE: "Ukuran Peta",
  T_46_META_WS_P_MASK: "Mask",
  T_46_META_WS_P_MASKNAME: "Nama Masker",
  T_46_META_WS_P_MASS: "Massa (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Judul Pertandingan Kiri",
  T_46_META_WS_P_MATCHTITLERIGHT: "Judul Pertandingan Kanan",
  T_46_META_WS_P_MAXCAPACITY: "Kapasitas Maksimum",
  T_46_META_WS_P_MAXCOUNT: "Jumlah Maksimum",
  T_46_META_WS_P_MAXDAMAGE: "Damage Maksimum",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Sudut Depresi Maksimum",
  T_46_META_WS_P_MAXDISPLACEMENT: "Displacement Maks",
  T_46_META_WS_P_MAXDISTANCE: "Jarak Maksimum",
  T_46_META_WS_P_MAXDURABILITY: "Daya Tahan Maksimum",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Rasio Ketahanan Maksimum",
  T_46_META_WS_P_MAXENERGY: "Energi Maksimum",
  T_46_META_WS_P_MAXEP: "EP Maksimum",
  T_46_META_WS_P_MAXHP: "HP Maksimum",
  T_46_META_WS_P_MAXJUMPCOUNT: "Jumlah Lonjakan Maksimum",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Tinggi Lompatan Maksimal",
  T_46_META_WS_P_MAXLENGTH: "Panjang Maksimum",
  T_46_META_WS_P_MAXPROGRESS: "Kemajuan Maksimum",
  T_46_META_WS_P_MAXSCATTERRATIO: "Rasio Penyebaran Maksimal",
  T_46_META_WS_P_MAXSPEED: "Kecepatan Maksimum",
  T_46_META_WS_P_MAXTURRETCOUNT: "Jumlah Turret Maks",
  T_46_META_WS_P_MAXVALUE: "Nilai Maksimum",
  T_46_META_WS_P_MAXWIDGETID: "ID Widget Maksimum",
  T_46_META_WS_P_MINDAMAGE: "Kerusakan Minimum",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Jarak Kerusakan Minimum",
  T_46_META_WS_P_MINDISTANCE: "Jarak Minimum",
  T_46_META_WS_P_MINELEVATIONANGLE: "Sudut Elevasi Minimum",
  T_46_META_WS_P_MINENDHEIGHT: "Ketinggian Akhir Minimum",
  T_46_META_WS_P_MINFLYHEIGHT: "Ketinggian Terbang Minimum",
  T_46_META_WS_P_MINMOVEDISTANCE: "Jarak Gerak Minimum",
  T_46_META_WS_P_MINVALUE: "Nilai Minimum",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Damage Maksimum Rudal",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Damage Minimum Rudal",
  T_46_META_WS_P_MISSILERANGE: "Jangkauan Rudal",
  T_46_META_WS_P_MODEL: "Model",
  T_46_META_WS_P_MODELVISIBILITY: "Visibilitas Model",
  T_46_META_WS_P_MODELVISIBLE: "Model Terlihat",
  T_46_META_WS_P_MONEY: "Uang",
  T_46_META_WS_P_MONEYLIST: "Daftar Uang",
  T_46_META_WS_P_MONEYS: "Dompet Terikat",
  T_46_META_WS_P_MONEYTYPE: "Jenis Uang",
  T_46_META_WS_P_MONSTERTYPE: "Jenis Monster",
  T_46_META_WS_P_MOTIONTYPE: "Jenis Gerakan",
  T_46_META_WS_P_MOTIONVALUEX: "Nilai Gerakan X",
  T_46_META_WS_P_MOTIONVALUEY: "Nilai Gerakan Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Nilai Gerakan Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Durasi Gerakan",
  T_46_META_WS_P_MULTIPLIER: "Pengali",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Jenis Elemen Musik",
  T_46_META_WS_P_MUZZLEVELOCITY: "Kecepatan Muzzle",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Nama",
  T_46_META_WS_P_NEXTROUNDINDEX: "Indeks Putaran Berikutnya",
  T_46_META_WS_P_NICKNAME: "Nama Panggilan",
  T_46_META_WS_P_NORMALCOLOR: "Warna Normal",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Posisi Dinormalisasi",
  T_46_META_WS_P_NUMBERINFACTION: "Nomor dalam Faksi",
  T_46_META_WS_P_OBJECTID: "ID Objek",
  T_46_META_WS_P_OFFSET: "Offset",
  T_46_META_WS_P_OPTIONS: "Opsi",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Faktor Damage Lainnya",
  T_46_META_WS_P_OUTFIT: "Pakaian",
  T_46_META_WS_P_OVERFLOW: "Overflow Teks",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Kecepatan Jatuh Setelah Ketinggian Berlebih",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Prioritas Konfigurasi Pemain",
  T_46_META_WS_P_OWNER: "Pemilik",
  T_46_META_WS_P_PARAMS: "Parameter",
  T_46_META_WS_P_PARENT: "Orang tua",
  T_46_META_WS_P_PARENTID: "ID Induk",
  T_46_META_WS_P_PARENTUI: "UI Induk",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "ID Entitas Widget Induk",
  T_46_META_WS_P_PARENTWIDGETFILEID: "ID File Widget Induk",
  T_46_META_WS_P_PARTMASKA: "Masker Bagian 1",
  T_46_META_WS_P_PASSENGERS: "Penumpang",
  T_46_META_WS_P_PATHID: "ID Jalur",
  T_46_META_WS_P_PAUSEEVENT: "Jeda Acara",
  T_46_META_WS_P_PERSONAID: "ID Persona",
  T_46_META_WS_P_PHASEDURATION: "Durasi (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Waktu Selesai (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Tingkat Fisik",
  T_46_META_WS_P_PINID: "ID Pin",
  T_46_META_WS_P_PITCH: "Sudut Vertikal",
  T_46_META_WS_P_PIVOT: "Pivot",
  T_46_META_WS_P_PLAYER: "Pemain",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Faktor Kecepatan Aim Pemain",
  T_46_META_WS_P_PLAYERLIST: "Daftar Pemain",
  T_46_META_WS_P_PLAYERNAME: "Nama Pemain",
  T_46_META_WS_P_PLAYERRANK: "Peringkat Pemain",
  T_46_META_WS_P_PLAYERRANKS: "Peringkat Pemain",
  T_46_META_WS_P_PLAYERS: "Pemain",
  T_46_META_WS_P_PLAYERSCORETYPES: "Jenis Skor Pemain",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Faktor Kecepatan Pemain",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Faktor Kecepatan Pemain Saat Menembak",
  T_46_META_WS_P_PLAYERSTATUS: "Status Pemain",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Kecepatan Tarikan Pemain",
  T_46_META_WS_P_PLAYINGSTATUS: "Status pemutaran",
  T_46_META_WS_P_PLAYSPEED: "Kecepatan Putar",
  T_46_META_WS_P_POINTPOSITION: "Posisi Titik",
  T_46_META_WS_P_POINTS: "Poin",
  T_46_META_WS_P_POSITION: "Posisi",
  T_46_META_WS_P_PREFABID: "ID Prefab",
  T_46_META_WS_P_PRESSEDCOLOR: "Warna Ditekan",
  T_46_META_WS_P_PRESSEDSPRITE: "Sprite Ditekan",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Jenis Sprite Ditekan",
  T_46_META_WS_P_PRICE: "Harga",
  T_46_META_WS_P_PRIORITY: "Prioritas",
  T_46_META_WS_P_PROFILEINFO: "Info Profil",
  T_46_META_WS_P_PROGRESS: "Progres [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Ikon Kemajuan",
  T_46_META_WS_P_PROGRESSICONNAME: "Nama Ikon Kemajuan",
  T_46_META_WS_P_PROPID: "ID Properti",
  T_46_META_WS_P_PURCHASELIMIT: "Batas Pembelian",
  T_46_META_WS_P_RADIUS: "Jari-jari",
  T_46_META_WS_P_RANGE: "Jangkauan",
  T_46_META_WS_P_RANK: "Peringkat",
  T_46_META_WS_P_RATIOSELFFACTOR: "Rasio Self-Damage",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Faktor Damage Friendly Fire",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Rasio Faktor Kendaraan",
  T_46_META_WS_P_REFRESHTIME: "Waktu Refresh (s)",
  T_46_META_WS_P_RELOADSPEED: "Kecepatan Reload",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Faktor Kecepatan Pengisian Ulang",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Sisa Jumlah Lonjakan",
  T_46_META_WS_P_REMAINQUANTITY: "Kuantitas Tersisa",
  T_46_META_WS_P_RENDERTYPE: "Jenis Render",
  T_46_META_WS_P_REPEATTIMES: "Jumlah Pengulangan",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Prioritas Penggantian",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ID Pemain Pemicu",
  T_46_META_WS_P_REQUESTTYPE: "Daftar Item yang Diminta",
  T_46_META_WS_P_RESETPERROUND: "Reset setiap Putaran",
  T_46_META_WS_P_RESETPOSITION: "Posisi Reset",
  T_46_META_WS_P_RESETTIME: "Waktu Reset",
  T_46_META_WS_P_RESOURCE: "Sumber Daya",
  T_46_META_WS_P_RESOURCEID: "ID Sumber",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Batasi Dalam Panel",
  T_46_META_WS_P_RESULT: "Hasil",
  T_46_META_WS_P_RESULTTYPE: "Jenis Hasil",
  T_46_META_WS_P_REVIVALPOINT: "Titik Kebangkitan",
  T_46_META_WS_P_REVIVECD: "Tiempo de recuperación",
  T_46_META_WS_P_RIGHT: "Kanan",
  T_46_META_WS_P_RIGHTARM: "Lengan Kanan",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Warna Latar Belakang Kanan",
  T_46_META_WS_P_RIGHTCOLOR: "Warna Kanan",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Deskripsi Tim Kanan",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Efek Kanan Aktif",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Sudut Tembak Kanan",
  T_46_META_WS_P_RIGHTFOOT: "Kaki Kanan Bawah",
  T_46_META_WS_P_RIGHTHAND: "Tangan Kanan",
  T_46_META_WS_P_RIGHTICON: "Ikon Kanan",
  T_46_META_WS_P_RIGHTICONNAME: "Nama Ikon Kanan",
  T_46_META_WS_P_RIGHTLEG: "Kaki Kanan",
  T_46_META_WS_P_RIGHTPLAYERS: "Pemain Kanan",
  T_46_META_WS_P_RIGHTSCORE: "Skor Kanan",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Skor Akhir Kanan",
  T_46_META_WS_P_RIGHTSCORETEXT: "Skor Kanan",
  T_46_META_WS_P_RIGHTTEAM: "Judul",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Indeks Tim Kanan",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Jumlah Pemain Hidup Kanan",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Jumlah Bendera Teman Kanan",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Status Teman Tim Kanan",
  T_46_META_WS_P_RIGHTTEAMNAME: "Nama Tim Kanan",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Skor Tim Kanan",
  T_46_META_WS_P_RIGHTTEXT: "Teks Kanan",
  T_46_META_WS_P_RIMALPHA: "Alpha Pinggir",
  T_46_META_WS_P_RIMCOLOR: "Warna Pinggir",
  T_46_META_WS_P_RIMTEXTURE: "Tekstur Pinggir",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Koefisien Gesekan Gulir",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Pengali Gesekan (Tabrakan)",
  T_46_META_WS_P_ROTATION: "Rotasi",
  T_46_META_WS_P_ROTATIONANGLE: "Sudut Putar",
  T_46_META_WS_P_ROTATIONQ: "Rotasi Kuaternion",
  T_46_META_WS_P_ROUNDINCOME: "Pendapatan Putaran",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Detail Penghasilan per Ronde",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Judul Detail Penghasilan per Ronde",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Judul Pendapatan Putaran",
  T_46_META_WS_P_ROUNDNUM: "Nomor Putaran",
  T_46_META_WS_P_ROUNDNUMKEY: "Kunci Putaran",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Parameter Kunci Putaran",
  T_46_META_WS_P_RUNSPEED: "Kecepatan Berlari",
  T_46_META_WS_P_RUNSPEEDSCALE: "Skala Kecepatan Sprint",
  T_46_META_WS_P_RUSHDISTANCE: "Jarak Sprint",
  T_46_META_WS_P_RUSHENERGYCOST: "Biaya Energi Rush",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Kecepatan Vertikal Rush",
  T_46_META_WS_P_SCALE: "Skala",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Kecepatan Peningkatan Penyebaran",
  T_46_META_WS_P_SCATTERMAX: "Penyebaran Maksimum",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Pengganda Penyebaran saat Bergerak",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Kecepatan Pemulihan Penyebaran",
  T_46_META_WS_P_SCATTERSPEED: "Kecepatan Penyebaran",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Kecepatan Penyebaran Saat Jongkok/Tiarap",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Batas Penyebaran",
  T_46_META_WS_P_SCOPETYPE: "Jenis Scope",
  T_46_META_WS_P_SCORE: "Skor",
  T_46_META_WS_P_SCORES1: "Daftar Skor 1",
  T_46_META_WS_P_SCORES2: "Daftar Skor 2",
  T_46_META_WS_P_SCORES3: "Daftar Skor 3",
  T_46_META_WS_P_SCORES4: "Daftar Skor 4",
  T_46_META_WS_P_SCORES5: "Daftar Skor 5",
  T_46_META_WS_P_SCORETEXTKEY: "Kunci Teks Skor",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Parameter Teks Skor",
  T_46_META_WS_P_SCROLLCONTINUITY: "Kontinuitas Scroll",
  T_46_META_WS_P_SCROLLDIRECTION: "Arah Gulir",
  T_46_META_WS_P_SCROLLEFFECT: "Efek Gulir",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Kecepatan Gulir",
  T_46_META_WS_P_SECONDSCORETITLE: "Judul Skor Kedua",
  T_46_META_WS_P_SECONDSCOREVALUE: "Nilai Skor Kedua",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Parameter Nilai Skor Kedua",
  T_46_META_WS_P_SELECTEDCOLOR: "Warna Terpilih",
  T_46_META_WS_P_SELECTEDINDEX: "Indeks Terpilih",
  T_46_META_WS_P_SELECTEDSPRITE: "Sprite Terpilih",
  T_46_META_WS_P_SELECTEDTYPE: "Jenis Terpilih",
  T_46_META_WS_P_SELF: "Diri",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Faktor Kerusakan Diri",
  T_46_META_WS_P_SET: "Setelan",
  T_46_META_WS_P_SHADERNAME: "Nama Shader",
  T_46_META_WS_P_SHADOWCOLOR: "Warna Bayangan",
  T_46_META_WS_P_SHADOWOFFSET: "Offset Bayangan",
  T_46_META_WS_P_SHADOWSTRENGTH: "Kekuatan Bayangan",
  T_46_META_WS_P_SHELFS: "Nonaktifkan Penutupan Manual",
  T_46_META_WS_P_SHOES: "Sepatu",
  T_46_META_WS_P_SHOOTANGLEMAX: "Sudut Tembak Maksimum",
  T_46_META_WS_P_SHOOTANGLEMIN: "Sudut Tembak Minimum",
  T_46_META_WS_P_SHOP: "Toko",
  T_46_META_WS_P_SHOPITEMS: "Rak",
  T_46_META_WS_P_SHOWADDFRIEND: "Tampilkan Tambah Teman",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Tampilkan Granat Serangan",
  T_46_META_WS_P_SHOWBACKGROUND: "Tampilkan Latar Belakang",
  T_46_META_WS_P_SHOWCROUCH: "Tampilkan Jongkok",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Tampilkan nomor kerusakan",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Tampilkan Granat Pertahanan",
  T_46_META_WS_P_SHOWECCONOMY: "Tampilkan Ekonomi Eksternal",
  T_46_META_WS_P_SHOWECONOMY: "Tampilkan Ekonomi Eksternal",
  T_46_META_WS_P_SHOWFIRE: "Tampilkan Tembak",
  T_46_META_WS_P_SHOWFRAME: "Tampilkan Bingkai",
  T_46_META_WS_P_SHOWGIFT: "Tampilkan Hadiah",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Tampilkan Efek Titik Tabrakan",
  T_46_META_WS_P_SHOWJUMP: "Tampilkan Lompat",
  T_46_META_WS_P_SHOWLIKE: "Tampilkan Suka",
  T_46_META_WS_P_SHOWLOBBY: "Tampilkan Kembali ke Lobi",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Tampilkan Evaluasi Peta",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Tampilkan Detail Pertandingan",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Tampilkan Joystick Bergerak",
  T_46_META_WS_P_SHOWNAME: "Tampilkan Nama Panggilan",
  T_46_META_WS_P_SHOWPIN: "Tampilkan Pin",
  T_46_META_WS_P_SHOWPRONE: "Tampilkan Merangkak",
  T_46_META_WS_P_SHOWRANK: "Tampilkan Peringkat",
  T_46_META_WS_P_SHOWREPLAY: "Tampilkan Replay",
  T_46_META_WS_P_SHOWREPORT: "Tampilkan Laporan",
  T_46_META_WS_P_SHOWSHARE: "Tampilkan Bagikan",
  T_46_META_WS_P_SHOWSPRINT: "Tampilkan Sprint",
  T_46_META_WS_P_SHOWTAG: "Tampilkan Label",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Tampilkan Info Teman",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Tampilkan Status Teman Tim",
  T_46_META_WS_P_SHOWTEAMSCORE: "Tampilkan Skor Tim",
  T_46_META_WS_P_SHOWTIMETYPE: "Jenis Tampilan",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Tampilkan Skor Dua Tim",
  T_46_META_WS_P_SHRINKDURATION: "Durasi Mengecil (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Waktu Akhir Mengecil (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Laju Penyusutan",
  T_46_META_WS_P_SHRINKSTARTTIME: "Waktu Mulai Mengecil (dtk)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Izinkan ADS Aim Assist",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Koefisien Reduksi Jarak Bantuan Membidik (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Koefisien Dampak Prioritas Jarak Aim Assist (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Jarak Maksimum Prioritas Bantuan Membidik",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Jarak Minimum Prioritas Aim Assist",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Izinkan Prioritas Jarak Bantuan Membidik",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Rasio Daya Tarik Bidikan Bantuan pada Layar (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Rasio Zoom Scope",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "Pembesaran FOV",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "Sensitivitas Putaran ADS",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "Koefisien Koreksi Jarak Kerusakan Minimum ADS",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "Waktu Pembesaran ADS (detik)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "Pembesaran ADS",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "Waktu Pemulihan ADS (detik)",
  T_46_META_WS_P_SIZE: "Ukuran",
  T_46_META_WS_P_SIZEDELTA: "Selisih Ukuran",
  T_46_META_WS_P_SKELETON: "Kerangka",
  T_46_META_WS_P_SKIN: "Kulit",
  T_46_META_WS_P_SKINID: "ID Skin",
  T_46_META_WS_P_SKINWIDTH: "Ketebalan Kulit",
  T_46_META_WS_P_SKYBOXENV: "Kotak Langit",
  T_46_META_WS_P_SKYBOXRESOURCE: "Sumber Kotak Langit",
  T_46_META_WS_P_SLOPELIMIT: "Kemiringan Maksimum",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Gulir Halus Saat Mulai",
  T_46_META_WS_P_SOFTNESS: "Kelembutan",
  T_46_META_WS_P_SORTTYPE: "Jenis Pengurutan",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Jumlah Spawn per Gelombang",
  T_46_META_WS_P_SPAWNPOINT: "Titik Spawn",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Jumlah Titik Spawn",
  T_46_META_WS_P_SPAWNPOSITION: "Posisi Spawn",
  T_46_META_WS_P_SPEED: "Kecepatan",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Faktor Sensitivitas ADS",
  T_46_META_WS_P_SPRAYCOLOR: "Warna Semprot",
  T_46_META_WS_P_SPRINTENERGYCOST: "Biaya Energi Sprint",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Kecepatan Horizontal Sprint",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Skala Kecepatan Sprint",
  T_46_META_WS_P_SPRITENAME: "Bentuk Sprite",
  T_46_META_WS_P_SPRITERESOURCE: "Sumber Sprite",
  T_46_META_WS_P_SRCVAL: "Nilai Sumber",
  T_46_META_WS_P_STARTDROPTIME: "Waktu Mulai Jatuh (ms)",
  T_46_META_WS_P_STARTEVENT: "Mulai Acara",
  T_46_META_WS_P_STARTPOSITION: "Posisi Awal",
  T_46_META_WS_P_STARTRADIUS: "Jari-Jari Mulai",
  T_46_META_WS_P_STARTSPAWNTIME: "Waktu Mulai Spawn (s)",
  T_46_META_WS_P_STARTTIME: "Waktu Mulai (s)",
  T_46_META_WS_P_STARTVALUE: "Nilai Awal",
  T_46_META_WS_P_STATICICONCOLORS: "Warna Ikon Statis",
  T_46_META_WS_P_STATICICONS: "Ikon Statis",
  T_46_META_WS_P_STATUS: "Status Menara Mini",
  T_46_META_WS_P_STEPOFFSET: "Offset Langkah",
  T_46_META_WS_P_STOPDURATION: "Durasi Berhenti",
  T_46_META_WS_P_STOPEVENT: "Hentikan Acara",
  T_46_META_WS_P_STORE: "Toko",
  T_46_META_WS_P_STROPID: "ID Strop",
  T_46_META_WS_P_STYLE: "Gaya",
  T_46_META_WS_P_SUBTITLE: "Subjudul",
  T_46_META_WS_P_SUMMULTIPLIER: "Akumulator Jumlah",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Akselerasi Keluar dari Ayunan",
  T_46_META_WS_P_SWINGINGSPEED: "Kecepatan Ayunan",
  T_46_META_WS_P_TAGS: "Tag",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ID Target Checkpoint",
  T_46_META_WS_P_TARGETICONCOLORS: "Warna Ikon Target",
  T_46_META_WS_P_TARGETICONS: "Ikon Target",
  T_46_META_WS_P_TARGETID: "ID Target",
  T_46_META_WS_P_TARGETITEMID: "ID Item Target",
  T_46_META_WS_P_TARGETROTATION: "Rotasi Target",
  T_46_META_WS_P_TARGETSCALE: "Skala Target",
  T_46_META_WS_P_TEAMCOLOR: "Warna Tim",
  T_46_META_WS_P_TEAMCOLORS: "Warna Tim",
  T_46_META_WS_P_TEAMINDEXS: "Indeks Tim",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Faktor Damage Teman",
  T_46_META_WS_P_TEAMMEMBERNUM: "Jumlah Anggota Tim",
  T_46_META_WS_P_TEAMNUM: "Jumlah Tim",
  T_46_META_WS_P_TEAMRANK: "Peringkat Tim",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Tampilkan Peringkat Tim",
  T_46_META_WS_P_TEAMRANKS: "Peringkat Tim",
  T_46_META_WS_P_TEAMSCORES: "Skor Tim",
  T_46_META_WS_P_TEAMSEQ: "Urutan Tim",
  T_46_META_WS_P_TEMPLATEENTITY: "Entitas Template",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Poin Perisai Sementara",
  T_46_META_WS_P_TERRAINWETNESS: "Kelembapan Tanah",
  T_46_META_WS_P_TEXT: "Teks",
  T_46_META_WS_P_TEXTCOLOR: "Warna Teks",
  T_46_META_WS_P_TEXTKEY: "Kunci Teks",
  T_46_META_WS_P_TEXTKEYPARAMS: "Parameter Kunci Teks",
  T_46_META_WS_P_TEXTURERESOURCE: "Sumber Tekstur",
  T_46_META_WS_P_THEMECOLOR: "Warna Tema",
  T_46_META_WS_P_THROWABLETYPE: "Jenis Lemparan",
  T_46_META_WS_P_THROWINGSPEED: "Kecepatan Lempar",
  T_46_META_WS_P_THROWSPEED: "Kecepatan Lempar",
  T_46_META_WS_P_TICKINTERVAL: "Interval Detik",
  T_46_META_WS_P_TIMEREQUIRED: "Waktu yang Diperlukan (ms)",
  T_46_META_WS_P_TIPSTYPE: "Jenis Tips",
  T_46_META_WS_P_TITLE: "Judul",
  T_46_META_WS_P_TITLELIST: "Judul",
  T_46_META_WS_P_TITLES: "Skor1",
  T_46_META_WS_P_TOP: "Atasan (Baju)",
  T_46_META_WS_P_TOPALPHA: "Alfa Atas",
  T_46_META_WS_P_TOTALHP: "HP Total",
  T_46_META_WS_P_TOTALLEVEL: "Total Level",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Jumlah Total Ronde",
  T_46_META_WS_P_TOWSPEED: "Kecepatan Tarikan",
  T_46_META_WS_P_TRANSITIONSTAGE: "Tahap Transisi",
  T_46_META_WS_P_TRANSITIONTYPE: "Jenis Transisi",
  T_46_META_WS_P_TRIGGERPLAYERID: "Uang",
  T_46_META_WS_P_TRIGGERRADIUS: "Jangkauan Pemicu",
  T_46_META_WS_P_TRIGGERRANGE: "Jangkauan Pemicu",
  T_46_META_WS_P_TRIGGERTIME: "Waktu Pemicu",
  T_46_META_WS_P_TURNSPEED: "Kecepatan Belok",
  T_46_META_WS_P_TWEENERENABLED: "Tim Kiri",
  T_46_META_WS_P_TWEENSTYLE: "Gaya Transisi",
  T_46_META_WS_P_TYPE: "Tipe",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Warna Tidak Terpilih",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Sprite Tidak Terpilih",
  T_46_META_WS_P_UNSELECTEDTYPE: "Jenis Tidak Terpilih",
  T_46_META_WS_P_UP: "Atas",
  T_46_META_WS_P_UPDATETYPE: "Jenis Pembaruan",
  T_46_META_WS_P_UPENERGYCOST: "Biaya Energi Naik",
  T_46_META_WS_P_UPSPEED: "Kecepatan Naik",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Menggunakan Gaya Dorong Kustom",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Gunakan Sumber Kustom",
  T_46_META_WS_P_USEDCAPACITY: "Kapasitas Terpakai",
  T_46_META_WS_P_USEGRAVITY: "Menggunakan Gravitasi",
  T_46_META_WS_P_USEPHYSICALCCT: "Menggunakan CCT Fisik",
  T_46_META_WS_P_USERUID: "UID User",
  T_46_META_WS_P_UVOFFSET: "Offset UV",
  T_46_META_WS_P_UVSIZE: "Ukuran UV",
  T_46_META_WS_P_VALUE: "Nilai",
  T_46_META_WS_P_VAULTDISTANCE: "Jarak Vault",
  T_46_META_WS_P_VAULTHEIGHT: "Tinggi Vault",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Faktor Kerusakan Kendaraan",
  T_46_META_WS_P_VEHICLESKINID: "ID Kulit Kendaraan",
  T_46_META_WS_P_VEHICLESKINIDS: "ID Kulit Kendaraan",
  T_46_META_WS_P_VELOCITY: "Kecepatan (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Kecepatan XZ",
  T_46_META_WS_P_VELOCITYY: "Kecepatan Y",
  T_46_META_WS_P_VERTICALBAR: "Bar Vertikal",
  T_46_META_WS_P_VERTICALOFFSET: "Offset Vertikal",
  T_46_META_WS_P_VEST: "Rompi",
  T_46_META_WS_P_VFXTEXTURETYPE: "Jenis Tekstur VFX",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Pembatasan Sudut Pandang",
  T_46_META_WS_P_VISIBILITYLAYER: "Lapisan Visibilitas",
  T_46_META_WS_P_VISIBLE: "Terlihat",
  T_46_META_WS_P_VISIBLEONBACK: "Terlihat di Punggung",
  T_46_META_WS_P_VISIBLEPLAYERS: "Pemain Terlihat",
  T_46_META_WS_P_VOLUME: "Volume",
  T_46_META_WS_P_WALLETID: "ID Dompet",
  T_46_META_WS_P_WANDERRANGE: "Jangkauan Berkeliaran",
  T_46_META_WS_P_WAVECOUNT: "Jumlah Gelombang",
  T_46_META_WS_P_WAVEINTERVAL: "Interval Gelombang",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Rasio Damage Senjata",
  T_46_META_WS_P_WEAPONSKINIDS: "ID Skin Senjata",
  T_46_META_WS_P_WEAPONSUBTYPE: "Tipe Senjata",
  T_46_META_WS_P_WEAPONTYPE: "Jenis Senjata",
  T_46_META_WS_P_WIDTH: "Lebar",
  T_46_META_WS_P_WINMVPS: "MVP Kemenangan",
  T_46_META_WS_P_WINTEXT: "Teks Kemenangan",
  T_46_META_WS_P_WORDWRAP: "Pembungkusan Kata",
  T_46_META_WS_P_WORLDPOSITION: "Posisi Dunia",
  T_46_META_WS_P_YAW: "Kemiringan",
  T_46_META_WS_PATROLALONG: "Patroli Sepanjang",
  T_46_META_WS_PATROLTO: "Patroli ke",
  T_46_META_WS_PAUSE: "Pause",
  T_46_META_WS_PAUSEEMOTE: "Jeda Emote",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Jeda Pembaruan Tetap",
  T_46_META_WS_PHASE: "Fase",
  T_46_META_WS_PLAY: "Play",
  T_46_META_WS_PLAYANIMATION: "Putar Animasi",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Putar Klip Animasi Karakter",
  T_46_META_WS_PLAYEMOTE: "Mainkan Emote",
  T_46_META_WS_PLAYER: "Pemain",
  T_46_META_WS_PORTAL: "Portal",
  T_46_META_WS_POSE: "Pose",
  T_46_META_WS_POSITION: "Posisi",
  T_46_META_WS_PREPOSE: "Pose Sebelumnya ",
  T_46_META_WS_PROFANITYFILTER: "Filter Kata Kasar",
  T_46_META_WS_PURSUITTARGET: "Target Pengejaran",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Quaternion ke Sudut Sumbu",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Quaternion ke Sudut Euler",
  T_46_META_WS_QUITCHATCHANNEL: "Keluar dari Kanal Chat",
  T_46_META_WS_QUITFACTION: "Keluar dari Faksi",
  T_46_META_WS_QUITGAME: "Keluar Game",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Keluar dari Mini Game Penjara",
  T_46_META_WS_RANDOMFLOAT: "Float Acak",
  T_46_META_WS_RANDOMINT: "Bilangan Acak",
  T_46_META_WS_RANK: "Rank",
  T_46_META_WS_READCSV: "Baca CSV",
  T_46_META_WS_READCSVCELL: "Baca Sel CSV",
  T_46_META_WS_READCSVCELLBYNAME: "Baca Sel CSV Berdasarkan Nama",
  T_46_META_WS_READCSVCELLFROMSERVER: "Baca Sel CSV dari Server",
  T_46_META_WS_READCSVCOLUMN: "Baca Kolom CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Baca Kolom CSV dari Server",
  T_46_META_WS_READCSVFROMSERVER: "Baca CSV dari Server",
  T_46_META_WS_READCSVROW: "Baca Baris CSV",
  T_46_META_WS_READCSVROWBYKEY: "Baca Baris CSV Berdasarkan Kunci",
  T_46_META_WS_READCSVROWFROMSERVER: "Baca Baris CSV dari Server",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Baca Dari Penyimpanan Data Terakumulasi",
  T_46_META_WS_READFROMDATASTORE: "Baca Dari Penyimpanan Data",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Baca Dari Penyimpanan Data Papan Peringkat",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Baca Dari Penyimpanan Data Papan Peringkat Berdasarkan Peringkat",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Hapus Ikuti Khusus AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Hapus Skin Backpack",
  T_46_META_WS_REMOVEBUFF: "Hapus Buff",
  T_46_META_WS_REMOVECOMPONENT: "Hapus Komponen",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Hapus Faktor Properti Formula",
  T_46_META_WS_REMOVEOUTFIT: "Hapus Outfit",
  T_46_META_WS_REMOVESCRIPT: "Hapus Skrip",
  T_46_META_WS_REMOVEVEHICLESKIN: "Hapus Skin Kendaraan",
  T_46_META_WS_REMOVEWEAPONSKIN: "Hapus Skin Senjata",
  T_46_META_WS_REPLACE: "Ganti",
  T_46_META_WS_REQUESTMATCHMAKING: "Minta Pencocokan",
  T_46_META_WS_RESET: "Reset",
  T_46_META_WS_RESETBACKPACKSKIN: "Reset Kulit Ransel",
  T_46_META_WS_RESETDYEING: "Reset Pewarnaan",
  T_46_META_WS_RESETJERSEY: "Reset Jersey",
  T_46_META_WS_RESETOUTFIT: "Reset Outfit",
  T_46_META_WS_RESETVEHICLESKIN: "Reset Kulit Kendaraan",
  T_46_META_WS_RESETWEAPONSKIN: "Reset Skin Senjata",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Lanjutkan Pembaruan Tetap",
  T_46_META_WS_REVERSE: "Balikkan",
  T_46_META_WS_REVIVALSOURCE: "Sumber Revive",
  T_46_META_WS_REVIVE: "Revive",
  T_46_META_WS_ROUND: "Pembulatan",
  T_46_META_WS_ROUNDINDEX: "Indeks Ronde",
  T_46_META_WS_SAMPLEONCURVE: "Sampling pada Kurva",
  T_46_META_WS_SCENENAME: "Nama Adegan",
  T_46_META_WS_SCORE: "Skor",
  T_46_META_WS_SCORER: "Pencetak Gol",
  T_46_META_WS_SCORETYPE: "Tipe Skor",
  T_46_META_WS_SCREENMULTIRAYCAST: "Raycast Multi Sentuhan Layar",
  T_46_META_WS_SCREENSINGLERAYCAST: "Raycast Satu Sentuhan Layar",
  T_46_META_WS_SCREENTOUCHRAY: "Sinar Sentuh Layar",
  T_46_META_WS_SCREENTOWORLDPOINT: "Layar ke Dunia",
  T_46_META_WS_SENDEVENT: "Kirim Acara",
  T_46_META_WS_SETACTIVE: "Atur Aktif",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Atur Status Gerak Semua Pemain",
  T_46_META_WS_SETATTACKABLEENTITY: "Atur Entitas yang Bisa Diserang",
  T_46_META_WS_SETATTACKABLEFACTION: "Atur Faaksi yang Dapat Diserang",
  T_46_META_WS_SETATTACKABLETEAM: "Atur Tim yang Dapat Diserang",
  T_46_META_WS_SETBACKPACKSKIN: "Atur Skin Backpack",
  T_46_META_WS_SETBEHAVIORSTATUS: "Atur Status Perilaku",
  T_46_META_WS_SETBLACKBOARDVALUE: "Atur Nilai Blackboard",
  T_46_META_WS_SETBUNDLE: "Atur Bundle",
  T_46_META_WS_SETCAMERAFOCUS: "Atur Fokus Kamera",
  T_46_META_WS_SETCAMERAFOLLOW: "Atur Kamera Mengikuti",
  T_46_META_WS_SETCHARACTER: "Atur Karakter",
  T_46_META_WS_SETCULLINGMASK: "Atur Masker Culling",
  T_46_META_WS_SETCULLINGMASKLAYER: "Atur Layer Masker Culling",
  T_46_META_WS_SETDEFAULTUISTATUS: "Atur Status UI Default",
  T_46_META_WS_SETDROPSTATUS: "Atur Status Drop",
  T_46_META_WS_SETFALLINGDAMAGE: "Atur Kerusakan Jatuh",
  T_46_META_WS_SETFOOTBALLPOSITION: "Atur Posisi Bola",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Atur Properti Formula Absolut",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Atur Properti Formula Relatif",
  T_46_META_WS_SETFORWARD: "Atur Arah",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Atur Ambang Tidur Global",
  T_46_META_WS_SETINVINCIBILITY: "Atur Kekebalan",
  T_46_META_WS_SETJERSEY: "Atur Jersey",
  T_46_META_WS_SETOUTFIT: "Atur Outfit",
  T_46_META_WS_SETPARENT: "Atur Parent",
  T_46_META_WS_SETPARENTCLIENT: "Atur Parent",
  T_46_META_WS_SETPICKUPSTATUS: "Atur Status Pengambilan",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Atur Status Pesan Cepat Pemain",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Atur Status Suara Pemain",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Atur Properti Secara Halus",
  T_46_META_WS_SETSKILLS: "Atur Skill",
  T_46_META_WS_SETSKYBOX: "Atur Kotak Langit",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Atur Ambang Tidur",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Atur Status Item Khusus",
  T_46_META_WS_SETVEHICLESKIN: "Atur Skin Kendaraan",
  T_46_META_WS_SETWEAPONSKIN: "Atur Skin Senjata",
  T_46_META_WS_SETWIDGETPARENT: "Atur Widget Parent",
  T_46_META_WS_SHOPITEM: "Item Toko",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Tampilkan Kelompok Penampilan",
  T_46_META_WS_SHUFFLE: "Acak",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Raycast Tunggal",
  T_46_META_WS_SKILL: "Skill",
  T_46_META_WS_SLEEP: "Tidur",
  T_46_META_WS_SLERPQUATERNION: "Interpolasi Kuaternion",
  T_46_META_WS_SPAWNABLES: "Item yang Dapat Muncul",
  T_46_META_WS_SPAWNEDITEM: "Item yang Muncul",
  T_46_META_WS_SPAWNNEXTWAVE: "Spawn Gelombang Berikutnya",
  T_46_META_WS_SPHERECAST: "Sphere Cast",
  T_46_META_WS_SPHEREOVERLAP: "Sphere Overlap",
  T_46_META_WS_SPLIT: "Pisahkan",
  T_46_META_WS_SQRT: "Sqrt",
  T_46_META_WS_STARTPARACHUTE: "Mulai Terjun Payung",
  T_46_META_WS_STARTPOSITION: "Posisi Awal",
  T_46_META_WS_STATENAME: "Nama Status",
  T_46_META_WS_STATUS: "Status",
  T_46_META_WS_STRINGTOFLOAT: "String ke Float",
  T_46_META_WS_STRINGTOINT: "String ke Integer",
  T_46_META_WS_STRIP: "Hapus",
  T_46_META_WS_SUB: "Kurangi",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Beralih Pengamat AOI Proxy",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Ganti Kelompok Penampilan",
  T_46_META_WS_SWITCHAREA: "Ganti Area",
  T_46_META_WS_SWITCHCAMERA: "Ganti Kamera",
  T_46_META_WS_SWITCHPHASE: "Beralih Fase",
  T_46_META_WS_SWITCHSCENE: "Ganti Adegan",
  T_46_META_WS_SWITCHWEAPON: "Ganti Senjata",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Target",
  T_46_META_WS_TEAM: "Tim",
  T_46_META_WS_TELEPORT: "Teleportasi",
  T_46_META_WS_TELEPORTCCT: "Teleport CCT",
  T_46_META_WS_TEXT: "Teks",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Timestamp ke String Lokalisasi",
  T_46_META_WS_TIRE: "Roda",
  T_46_META_WS_TOLOWER: "Ubah Menjadi Huruf Kecil",
  T_46_META_WS_TOSTRING: "Menjadi String",
  T_46_META_WS_TOUPPER: "Ubah Jadi Huruf Besar",
  T_46_META_WS_TRANSFERMONEY: "Transfer Uang",
  T_46_META_WS_TRIGGER: "Pemicu",
  T_46_META_WS_TYPEIS: "Tipe Adalah",
  T_46_META_WS_UNLOADSCENE: "Buang Adegan",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Perbarui Misi Jail Break",
  T_46_META_WS_UPLOADGAMERESULT: "Upload Hasil Game",
  T_46_META_WS_VALUE: "Kerusakan",
  T_46_META_WS_VECTOR2ANGLE: "Sudut Vector2",
  T_46_META_WS_VECTOR2DISTANCE: "Jarak Vector2",
  T_46_META_WS_VECTOR2DOT: "Dot Vector2",
  T_46_META_WS_VECTOR2MAGNITUDE: "Magnitudo Vector2",
  T_46_META_WS_VECTOR2NORMALIZE: "Normalisasi Vector2",
  T_46_META_WS_VECTOR2REFLECT: "Refleksi Vector2",
  T_46_META_WS_VECTOR2TOVECTOR3: "Vector2 ke Vector3",
  T_46_META_WS_VECTOR3REFLECT: "Refleksi Vector3",
  T_46_META_WS_VECTOR3TOVECTOR2: "Vector3 ke Vector2",
  T_46_META_WS_VEHICLE: "Kendaraan",
  T_46_META_WS_VELOCITY: "Kecepatan",
  T_46_META_WS_WAITFORMILESECOND: "Tunggu Milidetik",
  T_46_META_WS_WAITFORNEXTFRAME: "Tunggu Frame Berikutnya",
  T_46_META_WS_WAKEUP: "Bangun",
  T_46_META_WS_WAVES: "Gelombang",
  T_46_META_WS_WEAPON: "Senjata",
  T_46_META_WS_WORLDTOSCREENPOINT: "Dunia ke Layar",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Tulis Ke Penyimpanan Data Terakumulasi",
  T_46_META_WS_WRITETODATASTORE: "Tulis Ke Penyimpanan Data",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Tulis Ke Penyimpanan Data Papan Peringkat",
  T_48_META_API_1_D: "Dapatkan semua pemain di game saat ini dan kembali ke daftar pemain.",
  T_48_META_API_1_R_D: "daftar pemain",
  T_48_META_API_10_D: "Dapatkan objek adegan",
  T_48_META_API_10_P0_D: "Jenis objek pemandangan apa yang akan difilter",
  T_48_META_API_10_R_D: "Daftar objek adegan",
  T_48_META_API_100_D: "Memuat adegan tidak akan secara otomatis membongkar adegan yang sudah dimuat.",
  T_48_META_API_100_P0_D: "ID Adegan untuk dimuat",
  T_48_META_API_10000_D: "Mengembalikan entitas yang terikat pada skrip saat ini",
  T_48_META_API_10000_R_D: "Entitas yang terikat pada skrip saat ini",
  T_48_META_API_10001_D: "Gunakan ID entitas untuk menemukan entitas yang sesuai. API ini hanya digunakan oleh editor. Penggunaan API ini di sisi pengguna tidak dapat menjamin kompatibilitasnya, seperti penghapusan atau penyesuaian.",
  T_48_META_API_10001_P0_D: "ID entitas target",
  T_48_META_API_10001_R_D: "kesatuan",
  T_48_META_API_10002_D: "Dapatkan entitas global dari game tersebut",
  T_48_META_API_10002_R_D: "entitas global",
  T_48_META_API_10003_D: "Teleportasi pemain ke koordinat tertentu (usang, silakan gunakan Teleportasi)",
  T_48_META_API_10003_P0_D: "Pemain yang diteleportasi",
  T_48_META_API_10003_P1_D: "Koordinat titik yang diteleportasi",
  T_48_META_API_10004_D: "Posisikan di dekat rekan satu tim dan hindari posisi pemain yang tidak tahan (usang, silakan gunakan GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "pemain sasaran",
  T_48_META_API_10004_R_D: "Berkoordinasi di dekat rekan satu tim",
  T_48_META_API_10005_D: "Dapatkan pemain yang memiliki entitas",
  T_48_META_API_10005_P0_D: "Entitas target, entitas tersebut hanya akan disinkronkan dengan pemain miliknya",
  T_48_META_API_10005_R_D: "Pemain milik entitas target",
  T_48_META_API_10006_D: "Jadikan pemain tak terkalahkan",
  T_48_META_API_10006_P0_D: "pemain sasaran",
  T_48_META_API_10006_P1_D: "Durasi efek tak terkalahkan, dalam hitungan detik",
  T_48_META_API_10007_D: "Kloning entitas yang dipilih dan semua propertinya di lokasi aslinya",
  T_48_META_API_10007_P0_D: "Entitas dibuat",
  T_48_META_API_10007_P1_D: "Entitas yang akan dikloning",
  T_48_META_API_10008_D: "Menyebabkan kerusakan pada pemain. Jika tidak ada sumber kerusakan yang dipilih, target akan menerima kerusakan dari sistem.",
  T_48_META_API_10008_P0_D: "Entitas game yang rusak",
  T_48_META_API_10008_P1_D: "Entitas game yang menyebabkan kerusakan",
  T_48_META_API_10008_P2_D: "Jenis kerusakan",
  T_48_META_API_10008_P3_D: "Kerusakan",
  T_48_META_API_10009_D: "Kebangkitan pemain yang ditunjuk",
  T_48_META_API_10009_P0_D: "Pemain yang dibangkitkan",
  T_48_META_API_1001_D: "Jika kondisi terpenuhi, node di bawah IF akan dijalankan. Jika kondisi tidak terpenuhi, jika ada ELSE, jalankan node di bawah ELSE, jika tidak, akhiri pernyataan IF.",
  T_48_META_API_1001_P0_D: "Daftar kondisi harus konsisten dengan jumlah daftar sub-proses (daftar cabang logis)",
  T_48_META_API_10010_D: "Membuat item atau daftar item di lokasi tertentu.",
  T_48_META_API_10010_P0_D: "Lokasi pembuatan item",
  T_48_META_API_10010_P1_D: "Item yang dibuat atau daftar item",
  T_48_META_API_10010_P2_D: "Jumlah item yang dibuat. Saat membuat daftar item, Anda perlu mengisi daftar jumlah item yang sesuai dengan urutan daftar item.",
  T_48_META_API_10011_D: "Entitas AI berpatroli ke titik target",
  T_48_META_API_10011_P0_D: "target entitas AI",
  T_48_META_API_10011_P1_D: "titik sasaran bergerak",
  T_48_META_API_10011_P2_D: "Apakah akan kembali ke titik awal",
  T_48_META_API_10011_P3_D: "Apakah akan mendeteksi dan menyerang target musuh saat berpatroli",
  T_48_META_API_10012_D: "Entitas AI berpatroli secara berurutan sesuai daftar koordinat",
  T_48_META_API_10012_P0_D: "target entitas AI",
  T_48_META_API_10012_P1_D: "Memindahkan daftar titik koordinat",
  T_48_META_API_10012_P2_D: "Jenis patroli, Anda dapat memilih perjalanan tunggal, pulang pergi, atau bersepeda",
  T_48_META_API_10012_P3_D: "Apakah akan mendeteksi dan menyerang target musuh saat berpatroli",
  T_48_META_API_10013_D: "Generator segera menyegarkan gelombang entitas unit berikutnya",
  T_48_META_API_10013_P0_D: "entitas pembangkit",
  T_48_META_API_10014_D: "Menambahkan faktor perhitungan untuk atribut yang dapat dihitung. Atribut yang dapat dihitung akan menghitung hasil akhir melalui rumus yang terdiri dari faktor-faktor.",
  T_48_META_API_10014_P0_D: "entitas sasaran",
  T_48_META_API_10014_P1_D: "Tipe properti yang dapat dihitung",
  T_48_META_API_10014_P2_D: "Hitung jenis faktor",
  T_48_META_API_10014_P3_D: "Hitung nilai faktor",
  T_48_META_API_10015_D: "Hapus faktor penghitungan untuk properti terhitung",
  T_48_META_API_10015_P0_D: "entitas sasaran",
  T_48_META_API_10015_P1_D: "Tipe properti yang dapat dihitung",
  T_48_META_API_10016_D: "Menghapus semua faktor terhitung untuk semua properti terhitung entitas target",
  T_48_META_API_10016_P0_D: "entitas sasaran",
  T_48_META_API_10017_D: "Ubah properti",
  T_48_META_API_10017_P0_D: "entitas sasaran",
  T_48_META_API_10017_P1_D: "Jenis properti",
  T_48_META_API_10017_P2_D: "Metode modifikasi",
  T_48_META_API_10017_P3_D: "nilai",
  T_48_META_API_10018_D: "Tetapkan nilai properti yang dihitung",
  T_48_META_API_10018_P0_D: "entitas sasaran",
  T_48_META_API_10018_P1_D: "Jenis properti",
  T_48_META_API_10018_P2_D: "nilai",
  T_48_META_API_10019_D: "Hapus satu modifikasi properti yang dihitung",
  T_48_META_API_10019_P0_D: "entitas sasaran",
  T_48_META_API_10019_P1_D: "Jenis properti",
  T_48_META_API_1002_D: "Parameter i dimulai dari nilai minimum, dan setiap kali node terbawah dijalankan, i meningkatkan nilai langkah hingga i lebih besar atau sama dengan nilai maksimum.",
  T_48_META_API_1002_P0_D: "Nama indeks perulangan, yang dapat digunakan untuk memperoleh nilai indeks perulangan pada variabel lokal",
  T_48_META_API_1002_P1_D: "loop nilai awal",
  T_48_META_API_1002_P2_D: "nilai akhir lingkaran",
  T_48_META_API_1002_P3_D: "Ukuran langkah perulangan, bila nilai awal lebih kecil dari nilai akhir, ukuran langkah harus lebih besar dari 0; bila nilai awal lebih besar dari nilai akhir, ukuran langkah harus kurang dari 0",
  T_48_META_API_10020_D: "Dapatkan semua entitas dalam game yang memenuhi ketentuan filter",
  T_48_META_API_10020_P0_D: "Hasil filter harus berisi tipe yang dimasukkan pada parameter ini",
  T_48_META_API_10020_P1_D: "Hasil filter tidak boleh berisi tipe yang dimasukkan dalam parameter ini",
  T_48_META_API_10020_P2_D: "Hasil filter berisi setidaknya satu jenis yang dimasukkan dalam parameter ini",
  T_48_META_API_10020_R_D: "Filter daftar entitas hasil",
  T_48_META_API_10021_D: "Tambahkan kecepatan pada sepak bola. Kecepatan akan berubah karena percepatan dalam arah yang sama.",
  T_48_META_API_10021_P0_D: "sepak bola gol",
  T_48_META_API_10021_P1_D: "Menambahkan kecepatan ruang 3D",
  T_48_META_API_10022_D: "Hancurkan entitas yang ditentukan",
  T_48_META_API_10022_P0_D: "Entitas target yang akan dihancurkan",
  T_48_META_API_10023_D: "Tambahkan tag ke entitas",
  T_48_META_API_10023_P0_D: "entitas sasaran",
  T_48_META_API_10023_P1_D: "Label khusus",
  T_48_META_API_10024_D: "Hapus label dari entitas",
  T_48_META_API_10024_P0_D: "entitas sasaran",
  T_48_META_API_10024_P1_D: "Label khusus",
  T_48_META_API_10025_D: "Tentukan apakah entitas target berisi tag yang ditentukan",
  T_48_META_API_10025_P0_D: "entitas sasaran",
  T_48_META_API_10025_P1_D: "Label khusus",
  T_48_META_API_10025_R_D: "Apakah akan menyertakan tag yang ditentukan",
  T_48_META_API_10026_D: "Atur posisi sepak bola",
  T_48_META_API_10026_P0_D: "entitas sepak bola",
  T_48_META_API_10026_P1_D: "Lokasi",
  T_48_META_API_10026_P2_D: "menjaga kecepatan",
  T_48_META_API_10027_D: "Dapatkan entitas kamera yang saat ini digunakan oleh pemain target",
  T_48_META_API_10027_P0_D: "pemain sasaran",
  T_48_META_API_10027_R_D: "Entitas kamera yang saat ini digunakan",
  T_48_META_API_10028_D: "Alihkan kamera pemain target ke kamera target,",
  T_48_META_API_10028_P0_D: "pemain sasaran",
  T_48_META_API_10028_P1_D: "kamera sasaran",
  T_48_META_API_10028_P2_D: "Beralih mode, Anda dapat memilih untuk mempertahankan logika asli atau progresif",
  T_48_META_API_10028_P3_D: "Switching time adalah waktu untuk berpindah kamera dalam mode progresif",
  T_48_META_API_10029_D: "Buat kamera",
  T_48_META_API_10029_P0_D: "Jenis kamera dibuat",
  T_48_META_API_10029_P1_D: "Entitas kamera yang dibuat",
  T_48_META_API_1003_D: "Menerapkan traversal wadah data, mendapatkan setiap sub-elemen, dan memuat sub-proses. Badan perulangan adalah sub-proses.",
  T_48_META_API_1003_P0_D: "Melintasi nama elemen anak, Anda bisa menggunakannya untuk mendapatkan nilai elemen anak pada variabel lokal",
  T_48_META_API_1003_P1_D: "Nama indeks perulangan, yang dapat digunakan untuk memperoleh nilai indeks perulangan pada variabel lokal",
  T_48_META_API_1003_P2_D: "Kontainer data yang akan dilintasi saat ini mendukung tipe berikut: tipe array",
  T_48_META_API_10030_D: "Bunuh entitas yang dapat dilawan",
  T_48_META_API_10030_P0_D: "Entitas sasaran, harus merupakan entitas yang dapat diperangi",
  T_48_META_API_10031_D: "Tetapkan status aktivitas entitas target dan node turunannya. Ketersediaan, visibilitas, tabrakan, dll. dari objek tidak aktif akan dimatikan.",
  T_48_META_API_10031_P0_D: "entitas sasaran",
  T_48_META_API_10031_P1_D: "Apakah itu aktif?",
  T_48_META_API_10032_D: "Atur posisi entitas kamera agar selalu mengikuti entitas target",
  T_48_META_API_10032_P0_D: "entitas kamera target",
  T_48_META_API_10032_P1_D: "entitas target untuk diikuti",
  T_48_META_API_10032_P2_D: "offset dari koordinat entitas target",
  T_48_META_API_10032_P3_D: "sistem koordinat offset",
  T_48_META_API_10033_D: "Atur entitas kamera agar selalu menghadap entitas target",
  T_48_META_API_10033_P0_D: "entitas kamera target",
  T_48_META_API_10033_P1_D: "entitas sasaran",
  T_48_META_API_10033_P2_D: "Pergeseran titik fiksasi dari koordinat target",
  T_48_META_API_10033_P3_D: "sistem koordinat offset",
  T_48_META_API_10034_D: "Buat remaja",
  T_48_META_API_10034_P0_D: "entitas sasaran",
  T_48_META_API_10034_P1_D: "ID Properti",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "Val Tujuan",
  T_48_META_API_10034_P4_D: "Gaya",
  T_48_META_API_10034_P5_D: "Melengkung",
  T_48_META_API_10034_P6_D: "Lamanya",
  T_48_META_API_10034_P7_D: "dua belas entitas",
  T_48_META_API_10035_D: "Tetapkan node induk, yang mengharuskan induk dan anak memiliki komponen Transform",
  T_48_META_API_10035_P0_D: "simpul induk",
  T_48_META_API_10035_P1_D: "simpul anak",
  T_48_META_API_10035_P2_D: "Apakah akan mempertahankan posisi dunia saat ini, rotasi dan penskalaan node anak. Item ini tidak valid saat mengatur UI.",
  T_48_META_API_10036_D: "NewCurve (tidak digunakan lagi, harap gunakan CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "Titik Kontrol",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Mencoba memainkan entitas target, yang harus memiliki komponen yang dapat dimainkan",
  T_48_META_API_10037_P0_D: "entitas target yang dapat dimainkan",
  T_48_META_API_10037_P1_D: `Apakah akan memutar ulang
Benar: Memutar ulang
Salah: Melanjutkan pemutaran`,
  T_48_META_API_10038_D: "Jeda entitas yang dapat diputar",
  T_48_META_API_10038_P0_D: "entitas target yang dapat dimainkan",
  T_48_META_API_10039_D: "Buat gerakan balistik, yang akan memberikan kecepatan awal dan percepatan pada entitas target sesuai arah",
  T_48_META_API_10039_P0_D: "entitas sasaran",
  T_48_META_API_10039_P1_D: "kecepatan awal gerak",
  T_48_META_API_10039_P2_D: "percepatan gerak",
  T_48_META_API_10039_P3_D: "Jarak perpindahan maksimum",
  T_48_META_API_10039_P4_D: "Menciptakan entitas gerak balistik",
  T_48_META_API_10039_P5_D: "Apakah akan mulai memutar secara otomatis setelah pembuatan",
  T_48_META_API_1004_D: "Interupsi proses loop saat ini dan keluar dari loop",
  T_48_META_API_10040_D: "Buat posisi mengikuti gerak, entitas target akan mengikuti pergerakan objek yang ditentukan",
  T_48_META_API_10040_P0_D: "entitas sasaran",
  T_48_META_API_10040_P1_D: "Entitas benda yang mengikuti gerak",
  T_48_META_API_10040_P2_D: "Jaraknya mengikuti offset koordinat target",
  T_48_META_API_10040_P3_D: "Sistem koordinat yang digunakan",
  T_48_META_API_10040_P4_D: "Dibuat entitas gerak berikut",
  T_48_META_API_10040_P5_D: "Apakah akan mulai memutar secara otomatis setelah pembuatan",
  T_48_META_API_10041_D: "Buat gerakan mengikuti tatapan dimana entitas target akan tetap menghadap objek yang ditentukan",
  T_48_META_API_10041_P0_D: "entitas sasaran",
  T_48_META_API_10041_P1_D: "entitas objek yang sedang diawasi",
  T_48_META_API_10041_P2_D: "Pergeseran titik pandangan dari entitas objek",
  T_48_META_API_10041_P3_D: "Sistem koordinat yang digunakan",
  T_48_META_API_10041_P4_D: "Menciptakan entitas gerak yang mengikuti tatapan",
  T_48_META_API_10041_P5_D: "Apakah akan mulai memutar secara otomatis setelah pembuatan",
  T_48_META_API_10042_D: "Tidak digunakan lagi",
  T_48_META_API_10042_P0_D: "entitas pemain",
  T_48_META_API_10042_P1_D: "hasil pertandingan",
  T_48_META_API_10042_P2_D: "Tidak digunakan lagi",
  T_48_META_API_10042_P3_D: "Tidak digunakan lagi",
  T_48_META_API_10042_P4_D: "Tidak digunakan lagi",
  T_48_META_API_10043_D: "Mengatur properti entitas target dengan lancar. Properti akan segera berubah, tetapi klien akan memainkan kinerja transisi yang lancar.",
  T_48_META_API_10043_P0_D: "entitas sasaran",
  T_48_META_API_10043_P1_D: "atribut dari entitas target",
  T_48_META_API_10043_P2_D: "Nilai target harus sesuai dengan tipe yang diperlukan saat atribut ditentukan.",
  T_48_META_API_10044_D: "Lakukan deteksi sinar dan kembalikan entitas pertama yang terkena pada arah sinar. Entitas yang terkena memerlukan komponen tabrakan. Jika parameter level diisi pada bagian yang kosong, maka medan dapat dideteksi.",
  T_48_META_API_10044_P0_D: "Koordinat posisi awal",
  T_48_META_API_10044_P1_D: "Arah deteksi sinar",
  T_48_META_API_10044_P2_D: "Jarak deteksi sinar, hanya nilai positif yang diterima",
  T_48_META_API_10044_P3_D: "Masker lapisan pendeteksi sinar, hanya level yang terisi yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua level akan berpartisipasi dalam pemindaian",
  T_48_META_API_10044_P4_D: "Apakah mungkin untuk memindai pemicunya?",
  T_48_META_API_10044_P5_D: "entitas yang terkena",
  T_48_META_API_10044_P6_D: "koordinat titik sasaran",
  T_48_META_API_10044_P7_D: "Jarak dari titik pukul ke titik awal",
  T_48_META_API_10044_P8_D: "Pukul permukaan normal",
  T_48_META_API_10045_D: "Lakukan deteksi sinar dan kembalikan semua entitas yang terkena arah sinar dari dekat hingga jauh. Jika parameter level diisi pada bagian yang kosong, medan dapat dideteksi.",
  T_48_META_API_10045_P0_D: "Koordinat posisi awal",
  T_48_META_API_10045_P1_D: "Arah deteksi sinar",
  T_48_META_API_10045_P2_D: "Jarak deteksi sinar, hanya nilai positif yang diterima",
  T_48_META_API_10045_P3_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_10045_P4_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_10045_P5_D: "daftar entitas yang terkena dampak",
  T_48_META_API_10045_P6_D: "daftar sasaran",
  T_48_META_API_10045_P7_D: "Daftar jarak titik awal jarak hit",
  T_48_META_API_10045_P8_D: "Pukul permukaan normal",
  T_48_META_API_10046_D: "Buat entitas untuk templat menggunakan cetakan",
  T_48_META_API_10046_P0_D: "Entitas dibuat",
  T_48_META_API_10046_P1_D: "ID Prefabrikasi",
  T_48_META_API_10047_D: "pencelupan",
  T_48_META_API_10047_P0_D: "Atur objek normal",
  T_48_META_API_10047_P1_D: "Tetapkan titik pewarnaan",
  T_48_META_API_10047_P2_D: "warna",
  T_48_META_API_10048_D: "status pewarnaan",
  T_48_META_API_10048_P0_D: "Tetapkan titik pewarnaan",
  T_48_META_API_10048_P1_D: "Tetapkan arah",
  T_48_META_API_10048_P2_D: "Tetapkan jarak",
  T_48_META_API_10048_R_D: "WarnaDesc",
  T_48_META_API_10049_D: "Statistik pewarnaan",
  T_48_META_API_10049_P0_D: "warna",
  T_48_META_API_10049_R_D: "Kuantitas pewarnaan",
  T_48_META_API_1005_D: "Lewati konten perulangan yang tersisa dan langsung ke perulangan berikutnya",
  T_48_META_API_10050_D: "Pewarnaan rentang planar",
  T_48_META_API_10050_P0_D: "Atur objek normal",
  T_48_META_API_10050_P1_D: "Tetapkan titik pewarnaan",
  T_48_META_API_10050_P2_D: "Atur rentang pewarnaan",
  T_48_META_API_10050_P3_D: "warna",
  T_48_META_API_10050_P4_D: "Kuantitas pewarnaan",
  T_48_META_API_10051_D: "pewarnaan daerah",
  T_48_META_API_10051_P0_D: "Atur objek normal",
  T_48_META_API_10051_P1_D: "Tetapkan titik pewarnaan",
  T_48_META_API_10051_P2_D: "Atur rentang pewarnaan",
  T_48_META_API_10051_P3_D: "warna",
  T_48_META_API_10051_P4_D: "Memperbaiki area yang bernoda",
  T_48_META_API_10051_P5_D: "koefisien acak",
  T_48_META_API_10051_P6_D: "Koefisien atenuasi acak",
  T_48_META_API_10051_P7_D: "Kuantitas pewarnaan",
  T_48_META_API_10052_D: "Dapatkan semua simpul anak dari entitas simpul induk target",
  T_48_META_API_10052_P0_D: "entitas simpul induk",
  T_48_META_API_10052_R_D: "Daftar node anak",
  T_48_META_API_10053_D: "Dapatkan simpul anak tertentu dari entitas simpul induk target berdasarkan indeks",
  T_48_META_API_10053_P0_D: "entitas simpul induk",
  T_48_META_API_10053_P1_D: "Indeks simpul anak",
  T_48_META_API_10053_R_D: "entitas simpul anak",
  T_48_META_API_10054_D: "Dapatkan simpul induk dari entitas simpul anak target",
  T_48_META_API_10054_P0_D: "entitas simpul anak",
  T_48_META_API_10054_R_D: "entitas simpul induk",
  T_48_META_API_10055_D: "Hapus semua node anak di bawah entitas node induk yang ditentukan. Node tersebut harus memiliki komponen Transform",
  T_48_META_API_10055_P0_D: "entitas simpul induk",
  T_48_META_API_10056_D: "Teleportasi target ke lokasi tertentu",
  T_48_META_API_10056_P0_D: "Unit sedang diteleportasi",
  T_48_META_API_10056_P1_D: "Koordinat titik teleportasi",
  T_48_META_API_10056_P2_D: "Orientasi unit setelah teleportasi",
  T_48_META_API_10057_D: "Dapatkan lokasi di dekat rekan satu tim secara acak, kembalikan koordinat di dekat Anda ketika tidak ada rekan satu tim, dan hindari lokasi pemain yang tidak tahan.",
  T_48_META_API_10057_P0_D: "pemain sasaran",
  T_48_META_API_10057_R_D: "Berkoordinasi di dekat rekan satu tim pemain target",
  T_48_META_API_10058_D: "Hapus status pewarnaan",
  T_48_META_API_10059_D: "Mainkan efek suara yang ditentukan. Jika ada lebih banyak atribut yang perlu diatur, atur lebih lanjut atribut entitasnya melalui entitas.",
  T_48_META_API_10059_P0_D: "Kode tersebut digunakan untuk mewakili nama parameter formal yang menciptakan entitas efek suara, dan nilai variabel lokal terkait adalah entitas yang menciptakan efek suara.",
  T_48_META_API_10059_P1_D: "Entitas pemain yang dimilikinya, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_10059_P2_D: "Jenis efek suara, jenis efek suara yang dapat dipilih pemain",
  T_48_META_API_1006_D: "Akhiri proses eksekusi saat ini dan kembali langsung ke lokasi panggilan.",
  T_48_META_API_1006_P0_D: "Data diharapkan dikembalikan ke lokasi panggilan",
  T_48_META_API_10060_D: "Tendang pemain target dari permainan",
  T_48_META_API_10060_P0_D: "pemain sasaran",
  T_48_META_API_10060_P1_D: "Apakah akan menampilkan informasi penagihan",
  T_48_META_API_10061_D: "Pemain target meminta untuk mencocokkan peta yang ditentukan",
  T_48_META_API_10061_P0_D: "pemain sasaran",
  T_48_META_API_10061_P1_D: "kode medan perang",
  T_48_META_API_10061_P2_D: "Apakah jendela pop-up meminta Anda untuk kembali ke game asli saat membatalkan pertandingan",
  T_48_META_API_10062_D: "Interupsi entitas efek suara yang diputar",
  T_48_META_API_10062_P0_D: "Entitas efek suara yang perlu dijeda",
  T_48_META_API_10063_D: "Lanjutkan memainkan efek suara, Anda dapat memilih apakah akan mulai memutar dari awal",
  T_48_META_API_10063_P0_D: "Entitas efek suara yang perlu terus diputar setelah dijeda",
  T_48_META_API_10063_P1_D: "Apakah akan memulai dari awal",
  T_48_META_API_10064_D: "Membuat airdrop. Airdrop memiliki tiga tahap: 1. Persiapan, 2. Jatuh, 3. Mendarat. Atribut airdrop hanya dapat diubah di status 1.",
  T_48_META_API_10064_P0_D: "Entitas kotak airdrop dibuat",
  T_48_META_API_1007_D: "Implementasikan perulangan yang terus dieksekusi berdasarkan apakah kondisinya benar, hingga kondisinya salah dan perulangan berakhir.",
  T_48_META_API_1007_P0_D: "Bila kondisi benar maka perulangan dilanjutkan, dan bila kondisi salah maka perulangan berakhir.",
  T_48_META_API_1008_D: `Tunggu hingga awal frame logis berikutnya
Di server, jika mode kecepatan frame rendah diaktifkan, waktu tunggu akan lebih lama
Di klien, waktu tunggu dipengaruhi oleh kinerja perangkat dan kompleksitas logika frame saat ini
Gunakan API ini Fungsinya pe`,
  T_48_META_API_1009_D: "Setelah menunggu jangka waktu tertentu, fungsi yang menggunakan API ini perlu dideklarasikan sebagai async.",
  T_48_META_API_1009_P0_D: "Waktu tunggu, dalam milidetik",
  T_48_META_API_101_D: "Copot pemasangan adegan yang ditentukan",
  T_48_META_API_101_P0_D: "ID Adegan yang akan dihapus",
  T_48_META_API_1010: "Panggilan Balik Acara",
  T_48_META_API_1010_D: "Suatu tindakan yang dipicu ketika suatu peristiwa terjadi",
  T_48_META_API_1010_P0: "Nama Parameter Peristiwa",
  T_48_META_API_1010_P0_D: "Nama parameter formal dari parameter peristiwa, yang melaluinya nilai parameter aktual dapat diperoleh pada variabel lokal",
  T_48_META_API_1011: "Blok Kode",
  T_48_META_API_1011_D: "Blok kode yang membawa kombinasi API",
  T_48_META_API_1011_P0: "Nama Parameter",
  T_48_META_API_1011_P0_D: "Nama parameter formal ketika blok kode adalah fungsi khusus",
  T_48_META_API_1012: "Temukan dan Panggil API Kustom dengan Serial",
  T_48_META_API_1012_D: "Panggil fungsi kustom secara serial. Jika ada menunggu di fungsi kustom, lokasi pemanggilan juga akan menunggu.",
  T_48_META_API_1012_P0_D: "Entitas tempat fungsi kustom berada",
  T_48_META_API_1012_P1: "ID Grafik",
  T_48_META_API_1012_P1_D: "ID skrip tempat fungsi khusus berada",
  T_48_META_API_1012_P2: "ID Fungsi",
  T_48_META_API_1012_P2_D: "ID fungsi yang dipanggil oleh target",
  T_48_META_API_1012_P3_D: "Daftar argumen yang diteruskan ke fungsi kustom",
  T_48_META_API_1013: "Temukan dan Panggil API Kustom dengan Parallel",
  T_48_META_API_1013_D: "Panggil fungsi khusus secara paralel. Terlepas dari apakah ada waktu tunggu di fungsi khusus, fungsi tersebut akan segera kembali ke lokasi pemanggilan dan melanjutkan eksekusi.",
  T_48_META_API_1013_P0_D: "Entitas tempat fungsi kustom berada",
  T_48_META_API_1013_P1: "ID Grafik",
  T_48_META_API_1013_P1_D: "ID skrip tempat fungsi khusus berada",
  T_48_META_API_1013_P2: "ID Fungsi",
  T_48_META_API_1013_P2_D: "ID fungsi yang dipanggil oleh target",
  T_48_META_API_1013_P3_D: "Daftar argumen yang diteruskan ke fungsi kustom",
  T_48_META_API_1014: "Temukan dan Panggil API Kustom Sendiri dengan Serial",
  T_48_META_API_1014_D: "Panggil fungsi khusus dalam skrip saat ini dalam mode serial. Jika ada waktu tunggu di fungsi khusus, lokasi panggilan juga akan menunggu.",
  T_48_META_API_1014_P0: "ID Fungsi",
  T_48_META_API_1014_P0_D: "ID fungsi yang dipanggil oleh target",
  T_48_META_API_1014_P1_D: "Daftar argumen yang diteruskan ke fungsi kustom",
  T_48_META_API_1015: "Temukan dan Panggil API Kustom Sendiri dengan Parallel",
  T_48_META_API_1015_D: "Panggil fungsi khusus secara paralel. Terlepas dari apakah ada waktu tunggu di fungsi khusus, fungsi tersebut akan segera kembali ke lokasi pemanggilan dan melanjutkan eksekusi.",
  T_48_META_API_1015_P0: "Tetapkan Variabel Lokal berdasarkan Indeks",
  T_48_META_API_1015_P0_D: "ID fungsi yang dipanggil oleh target",
  T_48_META_API_1015_P1_D: "Daftar argumen yang diteruskan ke fungsi kustom",
  T_48_META_API_1016_D: "Mendapatkan tipe target saat memanggil API ini",
  T_48_META_API_1016_P0_D: "Targetnya sedang ditanyakan",
  T_48_META_API_1016_R_D: "Tipe variabel",
  T_48_META_API_1017_D: "Tentukan apakah variabel target adalah tipe yang ditentukan",
  T_48_META_API_1017_P0_D: "Target yang sedang ditanyakan",
  T_48_META_API_1017_P1_D: "tipe yang dibandingkan",
  T_48_META_API_1017_R_D: "Apakah ini konsisten?",
  T_48_META_API_1018_D: "Tentukan apakah variabel target adalah subkelas dari tipe tertentu, dan nilai yang dikembalikan adalah nilai Boolean",
  T_48_META_API_1018_P0_D: "Variabel target sedang ditanyakan",
  T_48_META_API_1018_P1_D: "tipe yang dibandingkan",
  T_48_META_API_1018_R_D: "Apakah itu subkelas",
  T_48_META_API_1019_D: "Menyebabkan entitas target memicu peristiwa khusus yang ditentukan",
  T_48_META_API_1019_P0_D: "ID peristiwa khusus dikirim",
  T_48_META_API_1019_P1_D: "entitas sasaran",
  T_48_META_API_1019_P2_D: "Daftar parameter",
  T_48_META_API_102_D: "Beralih ke adegan tertentu akan membongkar adegan lain yang dimuat.",
  T_48_META_API_102_P0_D: "ID Adegan untuk beralih ke",
  T_48_META_API_1020_D: "Terapkan traversal kontainer dan dapatkan setiap pasangan nilai kunci, termasuk subproses. Badan perulangan adalah subproses.",
  T_48_META_API_1020_P0_D: "Melintasi nama kunci, Anda bisa menggunakannya untuk mendapatkan nilai kunci pada variabel lokal",
  T_48_META_API_1020_P1_D: "Lintasi ke nama nilai, yang dapat digunakan untuk mendapatkan nilai pada variabel lokal",
  T_48_META_API_1020_P2_D: "wadah yang akan dilintasi",
  T_48_META_API_1021_D: "Hancurkan Bot yang ditentukan",
  T_48_META_API_1021_P0_D: "Pemain bot yang perlu dihancurkan",
  T_48_META_API_1022_D: "Paksa pemain target untuk meninggalkan kendaraan",
  T_48_META_API_1022_P0_D: "pemain sasaran",
  T_48_META_API_1023_D: "Buat kata lompat kerusakan",
  T_48_META_API_1023_P0_D: "Lewati konten kata",
  T_48_META_API_1023_P1_D: "ukuran font",
  T_48_META_API_1023_P2_D: "Warna huruf",
  T_48_META_API_1023_P3_D: "Durasi tinggal dalam milidetik",
  T_48_META_API_1023_P4_D: "Entitas yang dirugikan",
  T_48_META_API_1023_P5_D: "Perimbangan kata lompatan kerusakan relatif terhadap koordinat dunia entitas target",
  T_48_META_API_1023_P6_D: "Ukuran jangkauan koreksi posisi acak lagi pada posisi lompatan kerusakan",
  T_48_META_API_1023_P7_D: "Apakah akan melakukan animasi tween",
  T_48_META_API_1024_D: "Tidak digunakan lagi",
  T_48_META_API_1024_P0_D: "Tidak digunakan lagi",
  T_48_META_API_1024_P1_D: "entitas sasaran",
  T_48_META_API_1024_P2_D: "Setelah dipilih, jika dipanggil di server akan dikirim ke klien, jika dipanggil di klien akan dikirim ke server.",
  T_48_META_API_1024_P3_D: "Daftar parameter",
  T_48_META_API_1025_D: "Kueri kemajuan tugas khusus",
  T_48_META_API_1025_P0_D: "pemain sasaran",
  T_48_META_API_1025_P1_D: "ID tugas khusus",
  T_48_META_API_1025_R_D: "Kemajuan tugas",
  T_48_META_API_1026_D: "Dapatkan skin ransel pemain target",
  T_48_META_API_1026_P0_D: "pemain sasaran",
  T_48_META_API_1026_R_D: "ID kulit ransel",
  T_48_META_API_1027_D: "Tetapkan kulit ransel pemain target",
  T_48_META_API_1027_P0_D: "pemain sasaran",
  T_48_META_API_1027_P1_D: "ID kulit ransel",
  T_48_META_API_1028_D: "Kembalikan skin ransel pemain target ke konfigurasi eksternal default",
  T_48_META_API_1028_P0_D: "pemain sasaran",
  T_48_META_API_1029_D: "Bersihkan kulit ransel pemain target",
  T_48_META_API_1029_P0_D: "pemain sasaran",
  T_48_META_API_103_D: "Ubah gaya lingkungan skybox permainan, Anda dapat memilih siang, senja, malam, dll.",
  T_48_META_API_103_P0_D: "Tipe skybox",
  T_48_META_API_1030_D: "Dapatkan lokasi titik gantung tulang berdasarkan nama",
  T_48_META_API_1030_P0_D: "entitas sasaran",
  T_48_META_API_1030_P1_D: "Nama titik gantung tulang",
  T_48_META_API_1030_R_D: "Titik Kerangka",
  T_48_META_API_1031_D: "Tetapkan simpul induk dari entitas objek, entitas pendukung yang dipasang dengan komponen Transform, SkeletonPart, Player, dan MountPoint.",
  T_48_META_API_1031_P0_D: "simpul induk",
  T_48_META_API_1031_P1_D: "simpul anak",
  T_48_META_API_1031_P2_D: "Apakah akan mempertahankan posisi dunia saat ini, rotasi dan penskalaan node anak. Item ini tidak valid jika disetel oleh UI.",
  T_48_META_API_1032_D: "Mainkan efek animasi ikon, ikon diterjemahkan dari posisi awal ke posisi akhir dengan kecepatan pemutaran",
  T_48_META_API_1032_P0_D: "ID sumber daya ikon",
  T_48_META_API_1032_P1_D: "warna",
  T_48_META_API_1032_P2_D: "Perbesar ikon",
  T_48_META_API_1032_P3_D: "posisi awal tengah",
  T_48_META_API_1032_P4_D: "Kisaran area awal",
  T_48_META_API_1032_P5_D: "posisi akhir tengah",
  T_48_META_API_1032_P6_D: "rentang posisi akhir",
  T_48_META_API_1032_P7_D: "Kecepatan pemutaran adalah jarak per detik pergerakan ikon",
  T_48_META_API_1033_D: "Lakukan operasi arctangent untuk mendapatkan sudut",
  T_48_META_API_1033_P0_D: "Koordinat sumbu Y",
  T_48_META_API_1033_P1_D: "Koordinat sumbu X",
  T_48_META_API_1033_R_D: "Sudut, rentang (-180, 180]",
  T_48_META_API_1034_D: "Tambahkan komponen ke entitas hanya komponen kustom buatan pengguna yang didukung.",
  T_48_META_API_1034_P0_D: "entitas sasaran",
  T_48_META_API_1034_P1_D: "ID jenis komponen, hanya mendukung komponen khusus yang dibuat pengguna",
  T_48_META_API_1034_P2_D: "Apakah berhasil ditambahkan, komponen yang ada atau komponen non-kustom akan gagal ditambahkan.",
  T_48_META_API_1035_D: "Hapus komponen dari entitas dan hanya dukung komponen khusus",
  T_48_META_API_1035_P0_D: "entitas sasaran",
  T_48_META_API_1035_P1_D: "ID jenis komponen, hanya mendukung komponen khusus yang dibuat pengguna",
  T_48_META_API_1035_P2_D: "Apakah penghapusan berhasil atau tidak. Komponen yang tidak ada atau komponen non-kustom akan gagal dihapus.",
  T_48_META_API_1036_D: "Sesuaikan antarmuka keluar pemain di tengah jalan",
  T_48_META_API_1036_P0_D: "judul",
  T_48_META_API_1036_P1_D: "isi",
  T_48_META_API_1036_P2_D: "Pilihan",
  T_48_META_API_1036_P3_D: "Apakah akan menampilkan latar belakang",
  T_48_META_API_1037_D: "Dapatkan semua adegan yang sedang dimuat",
  T_48_META_API_1037_R_D: "daftar adegan",
  T_48_META_API_1038_D: "Dapatkan arah bidik lokal pemain",
  T_48_META_API_1038_R_D: "arah tujuan",
  T_48_META_API_1039_D: "Dapatkan stempel waktu lokal",
  T_48_META_API_1039_R_D: "Stempel waktu",
  T_48_META_API_104_D: "Pindahkan pemutar ke posisi tertentu dari adegan yang ditentukan. Adegan yang tidak dimuat akan dimuat secara otomatis, dan adegan yang dimuat tidak akan dibongkar secara otomatis.",
  T_48_META_API_104_P0_D: "pemain",
  T_48_META_API_104_P1_D: "ID Adegan untuk dimuat",
  T_48_META_API_104_P2_D: "Posisi pemain di adegan baru",
  T_48_META_API_104_P3_D: "Orientasi pemain di adegan baru",
  T_48_META_API_1040_D: "Jeda pembaruan bingkai tetap pada platform saat ini. Setelah jeda, peristiwa pembaruan bingkai tetap pada platform tidak akan lagi terpicu.",
  T_48_META_API_1041_D: "Melanjutkan pembaruan bingkai tetap pada platform saat ini. Setelah pemulihan, peristiwa pembaruan bingkai tetap pada platform mulai terpicu lagi.",
  T_48_META_API_1042_D: "Tentukan hubungan pertemanan antara pemain target dan pemain klien saat ini. Klien saat ini sendiri bukanlah teman dari klien saat ini.",
  T_48_META_API_1042_P0_D: "pemain sasaran",
  T_48_META_API_1042_R_D: "Apakah Anda berteman dengan klien saat ini",
  T_48_META_API_1043_D: "Memicu acara khusus",
  T_48_META_API_1043_P0_D: "ID peristiwa khusus",
  T_48_META_API_1043_P1_D: "entitas sasaran",
  T_48_META_API_1043_P2_D: "Platform yang dijalankan adalah server atau client",
  T_48_META_API_1043_P3_D: "Daftar parameter",
  T_48_META_API_1044_D: "Mulai terjun payung",
  T_48_META_API_1044_P0_D: "pemain sasaran",
  T_48_META_API_1044_P1_D: "Di bawah ketinggian tersebut, parasut akan dipaksa terbuka",
  T_48_META_API_1044_P2_D: "Kecepatan saat meluncur, komponen X melambangkan kecepatan horizontal, dan komponen Y melambangkan kecepatan vertikal; bila komponen Y negatif, pemain mendarat ke bawah",
  T_48_META_API_1044_P3_D: "Kecepatan saat menyelam, komponen X melambangkan kecepatan horizontal, dan komponen Y melambangkan kecepatan vertikal; bila komponen Y negatif, pemain terjatuh ke bawah",
  T_48_META_API_1044_P4_D: "Kecepatan saat membuka payung, komponen X melambangkan kecepatan horizontal, dan komponen Y melambangkan kecepatan vertikal; bila komponen Y negatif, pemain mendarat ke bawah",
  T_48_META_API_1045_D: "Baca nilai yang sesuai dengan pengidentifikasi yang ditentukan dalam tabel data",
  T_48_META_API_1045_P0_D: "nama tabel dalam database",
  T_48_META_API_1045_P1_D: "ID unik pemain",
  T_48_META_API_1045_P2_D: "Tentukan pengidentifikasi",
  T_48_META_API_1045_P3_D: "Baca hasilnya",
  T_48_META_API_1045_P4_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1045_P5_D: "kode kesalahan",
  T_48_META_API_1046_D: "Baca nilai yang sesuai dengan pengidentifikasi yang ditentukan dalam tabel data peringkat",
  T_48_META_API_1046_P0_D: "Nama tabel peringkat dalam database",
  T_48_META_API_1046_P1_D: "Tentukan pengidentifikasi",
  T_48_META_API_1046_P2_D: "Baca hasilnya",
  T_48_META_API_1046_P3_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1046_P4_D: "kode kesalahan",
  T_48_META_API_1047_D: "Baca nilai interval pemeringkatan yang ditentukan pada tabel data pemeringkatan",
  T_48_META_API_1047_P0_D: "Nama tabel peringkat dalam database",
  T_48_META_API_1047_P1_D: "Peringkat awal harus kurang dari atau sama dengan peringkat akhir, dan peringkat dimulai dari 1",
  T_48_META_API_1047_P2_D: "peringkat akhir",
  T_48_META_API_1047_P3_D: "Baca hasilnya",
  T_48_META_API_1047_P4_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1047_P5_D: "kode kesalahan",
  T_48_META_API_1048_D: "Baca nilai yang sesuai dengan pengidentifikasi yang ditentukan dalam tabel data kumulatif",
  T_48_META_API_1048_P0_D: "Nama tabel data terakumulasi dalam database",
  T_48_META_API_1048_P1_D: "Tentukan pengidentifikasi",
  T_48_META_API_1048_P2_D: "Baca hasilnya",
  T_48_META_API_1048_P3_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1048_P4_D: "kode kesalahan",
  T_48_META_API_1049_D: "Tulis nilai yang sesuai dengan pengidentifikasi yang ditentukan di tabel data",
  T_48_META_API_1049_P0_D: "nama tabel dalam database",
  T_48_META_API_1049_P1_D: "ID unik pemain",
  T_48_META_API_1049_P2_D: "Tentukan pengidentifikasi",
  T_48_META_API_1049_P3_D: "nilai tertulis",
  T_48_META_API_1049_P4_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1049_P5_D: "kode kesalahan",
  T_48_META_API_105_D: "Dapatkan skybox dari tempat kejadian",
  T_48_META_API_105_P0_D: "ID Adegan",
  T_48_META_API_105_R_D: "skybox",
  T_48_META_API_1050_D: "Dapatkan jumlah elemen dalam daftar",
  T_48_META_API_1050_P0_D: "daftar sasaran",
  T_48_META_API_1050_R_D: "Jumlah elemen",
  T_48_META_API_1051_D: "Dapatkan nilai elemen pada indeks yang ditentukan dalam daftar",
  T_48_META_API_1051_P0_D: "daftar sasaran",
  T_48_META_API_1051_P1_D: "Nilai indeks, mulai dari 0",
  T_48_META_API_1051_R_D: "nilai elemen",
  T_48_META_API_1052_D: "Menetapkan nilai elemen yang sesuai dengan indeks yang ditentukan dalam daftar",
  T_48_META_API_1052_P0_D: "daftar sasaran",
  T_48_META_API_1052_P1_D: "Nilai indeks, mulai dari 0",
  T_48_META_API_1052_P2_D: "nilai elemen",
  T_48_META_API_1053_D: "Tambahkan elemen ke akhir daftar",
  T_48_META_API_1053_P0_D: "daftar sasaran",
  T_48_META_API_1053_P1_D: "elemen untuk ditambahkan",
  T_48_META_API_1054_D: "Menghapus elemen yang sesuai dengan indeks yang ditentukan dari daftar",
  T_48_META_API_1054_P0_D: "daftar sasaran",
  T_48_META_API_1054_P1_D: "Nilai indeks, mulai dari 0",
  T_48_META_API_1055_D: "Hapus semua elemen dalam daftar",
  T_48_META_API_1055_P0_D: "daftar sasaran",
  T_48_META_API_1056_D: "Membalikkan daftar yang ditentukan. Urutan elemen dalam daftar akan dibalik.",
  T_48_META_API_1056_P0_D: "daftar sasaran",
  T_48_META_API_1057_D: "menyalin daftar",
  T_48_META_API_1057_P0_D: "daftar sasaran",
  T_48_META_API_1057_R_D: "Menyalin daftar baru",
  T_48_META_API_1058_D: "Menyisipkan elemen baru pada posisi indeks yang ditentukan dalam daftar. Elemen pada posisi indeks asli dan setelahnya akan dipindahkan mundur satu posisi secara bergantian.",
  T_48_META_API_1058_P0_D: "daftar sasaran",
  T_48_META_API_1058_P1_D: "Posisi indeks yang akan disisipkan, indeks dihitung dari 0",
  T_48_META_API_1058_P2_D: "nilai elemen baru untuk dimasukkan",
  T_48_META_API_1059_D: "Susun ulang elemen-elemen dalam daftar secara acak",
  T_48_META_API_1059_P0_D: "daftar sasaran",
  T_48_META_API_1060_D: "Bandingkan parameter di kedua sisi dan kembalikan benar atau salah",
  T_48_META_API_1060_P0_D: "nilai yang digunakan untuk perbandingan",
  T_48_META_API_1060_P1_D: "Metode perbandingan mendukung metode berikut: >,>=,==,!=,<=,<,And (tipe bool terbatas), Atau (tipe bool terbatas)",
  T_48_META_API_1060_P2_D: "nilai yang digunakan untuk perbandingan",
  T_48_META_API_1060_R_D: "Bandingkan hasilnya",
  T_48_META_API_1061_D: "Empat operasi aritmatika dasar meliputi penjumlahan, pengurangan, perkalian, pembagian, dan sisa. Operasi sisanya hanya mendukung bilangan bulat, dan operasi lainnya mendukung bilangan bulat atau desimal.",
  T_48_META_API_1061_P0_D: "nilai operasi",
  T_48_META_API_1061_P1_D: "Empat jenis operasi aritmatika, termasuk penjumlahan, pengurangan, perkalian, pembagian dan sisa, tidak mendukung desimal.",
  T_48_META_API_1061_P2_D: "nilai operasi",
  T_48_META_API_1061_R_D: "Hasil perhitungan",
  T_48_META_API_1062_D: "Secara acak menghasilkan bilangan bulat antara bilangan bulat terkecil (inklusif) dan bilangan bulat terbesar (eksklusif)",
  T_48_META_API_1062_P0_D: "Interval kiri rentang acak, dimungkinkan untuk mencapai nilai yang diisi secara acak",
  T_48_META_API_1062_P1_D: "Interval yang tepat dari rentang acak tidak akan acak terhadap nilai yang diisi.",
  T_48_META_API_1062_R_D: "hasil acak, bilangan bulat",
  T_48_META_API_1063_D: "Secara acak menghasilkan desimal antara nilai desimal terkecil (inklusif) dan nilai desimal terbesar (eksklusif)",
  T_48_META_API_1063_P0_D: "Interval kiri rentang acak, kecil kemungkinan nilai yang diisi akan acak.",
  T_48_META_API_1063_P1_D: "Interval yang tepat dari rentang acak tidak akan acak terhadap nilai yang diisi.",
  T_48_META_API_1063_R_D: "Hasil acak, desimal, akurat hingga 7 tempat desimal",
  T_48_META_API_1064_D: "Tentukan apakah objek tersebut kosong",
  T_48_META_API_1064_P0_D: "Benda yang akan dinilai kosong",
  T_48_META_API_1064_R_D: "Apakah itu kosong",
  T_48_META_API_1065_D: "Negasi logis, nilai masukan: benar atau salah, nilai kembalian: salah atau benar",
  T_48_META_API_1065_P0_D: "Perlu mencari nilai non",
  T_48_META_API_1065_R_D: "Hasil negatif",
  T_48_META_API_1066_D: "Ambil nilai absolut, dukung bilangan bulat dan desimal",
  T_48_META_API_1066_P0_D: "Perlu menemukan nilai absolut dari nilai tersebut",
  T_48_META_API_1066_R_D: "Hasil pengambilan nilai absolut",
  T_48_META_API_1067_D: "Hitung akar kuadrat",
  T_48_META_API_1067_P0_D: "Perlu mencari akar kuadrat dari nilainya",
  T_48_META_API_1067_R_D: "Hasil mencari akar kuadrat",
  T_48_META_API_1068_D: "Hitung nilai negatif",
  T_48_META_API_1068_P0_D: "Perlu menemukan nilai negatif",
  T_48_META_API_1068_R_D: "hasil negatif",
  T_48_META_API_1069_D: "Gabungkan dua string menjadi satu",
  T_48_META_API_1069_P0_D: "nilai string",
  T_48_META_API_1069_P1_D: "nilai string",
  T_48_META_API_1069_R_D: "Hasil penggabungan string",
  T_48_META_API_1070_D: "Dapatkan panjang string",
  T_48_META_API_1070_P0_D: "rangkaian",
  T_48_META_API_1070_R_D: "panjang tali",
  T_48_META_API_1071_D: "Membulatkan nilai yang ditentukan ke bilangan bulat terdekat",
  T_48_META_API_1071_P0_D: "Nilai yang perlu dibulatkan ke bawah",
  T_48_META_API_1071_R_D: "Hasil pembulatan ke bawah",
  T_48_META_API_1072_D: "Membulatkan nilai yang ditentukan ke bilangan bulat terdekat",
  T_48_META_API_1072_P0_D: "Nilai yang perlu dibulatkan",
  T_48_META_API_1072_R_D: "Hasil pembulatan",
  T_48_META_API_1073_D: "Membulatkan nilai yang ditentukan menjadi bilangan bulat",
  T_48_META_API_1073_P0_D: "Nilai yang perlu dibulatkan",
  T_48_META_API_1073_R_D: "Hasil bulat",
  T_48_META_API_1074_D: "Setelah mengganti semua string yang ditentukan dalam string target, keluarkan string baru",
  T_48_META_API_1074_P0_D: "rangkaian sasaran",
  T_48_META_API_1074_P1_D: "Senar lama yang harus diganti",
  T_48_META_API_1074_P2_D: "string baru untuk diganti",
  T_48_META_API_1074_R_D: "Ganti string yang sudah selesai",
  T_48_META_API_1075_D: "Cari string target untuk kemunculan pertama dari string tertentu.",
  T_48_META_API_1075_P0_D: "rangkaian sasaran",
  T_48_META_API_1075_P1_D: "String yang ditentukan untuk ditemukan",
  T_48_META_API_1075_P2_D: "Cari senar dari posisi awal, posisi senar dihitung dari 0",
  T_48_META_API_1075_R_D: "Menentukan posisi kemunculan string pertama dalam string target. Posisi string dihitung dari 0.",
  T_48_META_API_1076_D: "Setelah mencegat string dengan panjang tertentu mulai dari posisi tertentu, keluarkan string baru",
  T_48_META_API_1076_P0_D: "rangkaian sasaran",
  T_48_META_API_1076_P1_D: "Posisi di mana intersepsi dimulai. Posisi string dihitung dari 0.",
  T_48_META_API_1076_P2_D: "Potong panjangnya. Secara default, itu dipotong sampai ke ujung tali.",
  T_48_META_API_1076_R_D: "String yang dicegat",
  T_48_META_API_1077_D: "Membandingkan apakah elemen dari dua daftar sama persis. Kapasitas daftar tidak mempengaruhi hasil perbandingan.",
  T_48_META_API_1077_P0_D: "Daftar nilai yang digunakan untuk perbandingan",
  T_48_META_API_1077_P1_D: "Daftar nilai yang digunakan untuk perbandingan",
  T_48_META_API_1077_R_D: "Membandingkan hasil, jika isinya konsisten maka akan dikembalikan True; jika isinya tidak konsisten maka akan dikembalikan False.",
  T_48_META_API_1078_D: "Dengan menggunakan string yang ditentukan sebagai pembatas, potong string target menjadi beberapa bagian dan keluaran string baru. Pembatas N berturut-turut akan dipotong menjadi spasi setengah lebar N-1 dan dikeluarkan sebagai elemen daftar string.",
  T_48_META_API_1078_P0_D: "rangkaian sasaran",
  T_48_META_API_1078_P1_D: "tali pembatas",
  T_48_META_API_1078_R_D: "Daftar string keluaran selalu diakhiri dengan elemen spasi setengah lebar.",
  T_48_META_API_1079_D: "Ekstrak karakter sesuai dengan daftar posisi string dan gabungkan menjadi keluaran string baru",
  T_48_META_API_1079_P0_D: "rangkaian sasaran",
  T_48_META_API_1079_P1_D: "Daftar posisi string, posisi string dihitung mulai dari 0",
  T_48_META_API_1079_R_D: "rangkaian keluaran",
  T_48_META_API_1080_D: "Ubah karakter string target menjadi huruf besar semua",
  T_48_META_API_1080_P0_D: "rangkaian sasaran",
  T_48_META_API_1080_R_D: "rangkaian keluaran",
  T_48_META_API_1081_D: "Ubah semua karakter string target menjadi huruf kecil",
  T_48_META_API_1081_P0_D: "rangkaian sasaran",
  T_48_META_API_1081_R_D: "rangkaian keluaran",
  T_48_META_API_1082_D: "Hapus semua spasi sebelum karakter non-spasi pertama dan setelah karakter non-spasi terakhir dari string target",
  T_48_META_API_1082_P0_D: "rangkaian sasaran",
  T_48_META_API_1082_R_D: "rangkaian keluaran",
  T_48_META_API_1083_D: "Menghasilkan string baru setelah ditautkan dengan pengidentifikasi yang ditentukan",
  T_48_META_API_1083_P0_D: "daftar string target",
  T_48_META_API_1083_P1_D: "Pengidentifikasi tertentu yang digunakan untuk menggabungkan string",
  T_48_META_API_1083_R_D: "rangkaian keluaran",
  T_48_META_API_1084_D: "Tuliskan nilai yang sesuai dengan pengidentifikasi yang ditentukan dalam tabel data peringkat",
  T_48_META_API_1084_P0_D: "Nama tabel peringkat dalam database",
  T_48_META_API_1084_P1_D: "Tentukan pengidentifikasi",
  T_48_META_API_1084_P2_D: "nilai tertulis",
  T_48_META_API_1084_P3_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1084_P4_D: "kode kesalahan",
  T_48_META_API_1085_D: "Tulis nilai offset yang sesuai dengan pengidentifikasi yang ditentukan dalam tabel data kumulatif",
  T_48_META_API_1085_P0_D: "Nama tabel data terakumulasi dalam database",
  T_48_META_API_1085_P1_D: "Tentukan pengidentifikasi",
  T_48_META_API_1085_P2_D: "Empat jenis operasi aritmatika",
  T_48_META_API_1085_P3_D: "Nilai offset ditulis",
  T_48_META_API_1085_P4_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1085_P5_D: "kode kesalahan",
  T_48_META_API_1086_D: "Hapus nilai yang sesuai dengan pengidentifikasi yang ditentukan dalam tabel data",
  T_48_META_API_1086_P0_D: "nama tabel dalam database",
  T_48_META_API_1086_P1_D: "ID unik pemain",
  T_48_META_API_1086_P2_D: "Tentukan pengidentifikasi",
  T_48_META_API_1086_P3_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1086_P4_D: "kode kesalahan",
  T_48_META_API_1087_D: "Hapus nilai yang sesuai dengan pengidentifikasi yang ditentukan dalam tabel data peringkat",
  T_48_META_API_1087_P0_D: "Nama tabel peringkat dalam database",
  T_48_META_API_1087_P1_D: "Tentukan pengidentifikasi",
  T_48_META_API_1087_P2_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1087_P3_D: "kode kesalahan",
  T_48_META_API_1088_D: "Hapus nilai yang sesuai dengan peringkat yang ditentukan dalam tabel data peringkat",
  T_48_META_API_1088_P0_D: "Nama tabel peringkat dalam database",
  T_48_META_API_1088_P1_D: "Tentukan peringkat",
  T_48_META_API_1088_P2_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_1088_P3_D: "kode kesalahan",
  T_48_META_API_1089_D: "Kirim pesan pengguna ke Persona",
  T_48_META_API_1089_P0_D: "Targetkan PersonaID",
  T_48_META_API_1089_P1_D: "Isi pesan",
  T_48_META_API_1090_D: "Kirim pesan sistem ke Persona",
  T_48_META_API_1090_P0_D: "Targetkan PersonaID",
  T_48_META_API_1090_P1_D: "Isi pesan",
  T_48_META_API_1091_D: "Hapus Memori Persona",
  T_48_META_API_1091_P0_D: "kode kesalahan",
  T_48_META_API_1092_D: "Bangkitkan Pusat Anggota",
  T_48_META_API_1092_P0_D: "kode kesalahan",
  T_48_META_API_1093_D: "Dapatkan stempel waktu berakhirnya keanggotaan",
  T_48_META_API_1093_P0_D: "pemain sasaran",
  T_48_META_API_1093_P1_D: "Stempel waktu",
  T_48_META_API_1093_P2_D: "kode kesalahan",
  T_48_META_API_1094_D: "Tentukan apakah pemain tersebut adalah anggota",
  T_48_META_API_1094_P0_D: "kode kesalahan",
  T_48_META_API_1094_P1_D: "Apakah Anda anggota?",
  T_48_META_API_1095_D: "Dapatkan stempel waktu berakhirnya keanggotaan",
  T_48_META_API_1095_P0_D: "Stempel waktu",
  T_48_META_API_1095_P1_D: "kode kesalahan",
  T_48_META_API_1096_D: "Tentukan apakah pemain tersebut adalah anggota",
  T_48_META_API_1096_P0_D: "pemain sasaran",
  T_48_META_API_1096_P1_D: "kode kesalahan",
  T_48_META_API_1096_P2_D: "Apakah Anda anggota?",
  T_48_META_API_1097_D: "Bangkitkan Pusat Anggota",
  T_48_META_API_1097_P0_D: "pemain sasaran",
  T_48_META_API_1097_P1_D: "kode kesalahan",
  T_48_META_API_1099_D: "Siapkan pengamat Persona, dan percakapan selanjutnya dengan Persona juga akan dikirim ke pengamat.",
  T_48_META_API_1099_P0_D: "Targetkan PersonaID",
  T_48_META_API_1099_P1_D: "daftar pengamat",
  T_48_META_API_11_D: "Akhiri fase saat ini dan masuki fase berikutnya",
  T_48_META_API_1100_D: "Kirim pesan pengguna ke Persona menggunakan streaming",
  T_48_META_API_1100_P0_D: "Targetkan PersonaID",
  T_48_META_API_1100_P1_D: "Isi pesan",
  T_48_META_API_1101_D: "Kirim pesan sistem ke Persona menggunakan streaming",
  T_48_META_API_1101_P0_D: "Targetkan PersonaID",
  T_48_META_API_1101_P1_D: "Isi pesan",
  T_48_META_API_1101_P2_D: "Apakah membalas atau tidak",
  T_48_META_API_1103_D: "Buat benih acak",
  T_48_META_API_1103_P0_D: "benih",
  T_48_META_API_1103_R_D: "penghasil angka acak",
  T_48_META_API_1104_D: "Dapatkan nomor acak berikutnya dari generator nomor acak yang ditentukan, nilai maksimalnya adalah 32767",
  T_48_META_API_1104_P0_D: "penghasil angka acak",
  T_48_META_API_1104_P1_D: "rentang minimum",
  T_48_META_API_1104_P2_D: "Jangkauan maksimum",
  T_48_META_API_1104_R_D: "nomor acak",
  T_48_META_API_1108_D: "Dapatkan bahasa klien yang digunakan oleh pemain",
  T_48_META_API_12_D: "Cetak log ke konsol",
  T_48_META_API_12_P0_D: "Apa yang perlu dicetak",
  T_48_META_API_13_D: "Keluarkan string dengan parameter",
  T_48_META_API_13_P0_D: "Gunakan placeholder %v untuk mewakili parameter. Jumlah %v dan jumlah parameter harus konsisten.",
  T_48_META_API_13_P1_D: "Daftar parameter yang berpartisipasi dalam keluaran harus konsisten dengan jumlah %v dalam deskripsi format.",
  T_48_META_API_13_R_D: "rangkaian keluaran",
  T_48_META_API_14_D: "Membersihkan sisa-sisa objek peta, termasuk kotak kematian, objek yang dibuat, objek yang ditempatkan, sisa proyektil, dll.",
  T_48_META_API_15_D: "Sesuaikan log poin kompetisi untuk analisis data pengalaman pengguna",
  T_48_META_API_15_P0_D: "Daftar nama bidang yang akan dilaporkan",
  T_48_META_API_15_P1_D: "Daftar nilai bidang yang akan dilaporkan",
  T_48_META_API_1500_D: "Dapatkan komponen X dari vektor tiga dimensi",
  T_48_META_API_1500_P0_D: "Vector3",
  T_48_META_API_1500_R_D: "Komponen vektor X tiga dimensi",
  T_48_META_API_1501_D: "Dapatkan komponen Y dari vektor tiga dimensi",
  T_48_META_API_1501_P0_D: "vektor 3D",
  T_48_META_API_1501_R_D: "Komponen vektor Y tiga dimensi",
  T_48_META_API_1502_D: "Dapatkan komponen Z dari vektor tiga dimensi",
  T_48_META_API_1502_P0_D: "vektor 3D",
  T_48_META_API_1502_R_D: "Komponen vektor Z tiga dimensi",
  T_48_META_API_1503_D: "Menetapkan komponen X dari vektor tiga dimensi",
  T_48_META_API_1503_P0_D: "vektor 3D",
  T_48_META_API_1503_P1_D: "komponen X",
  T_48_META_API_1504_D: "Mengatur komponen Y dari vektor tiga dimensi",
  T_48_META_API_1504_P0_D: "vektor 3D",
  T_48_META_API_1504_P1_D: "komponen Y",
  T_48_META_API_1505_D: "Mengatur komponen Z dari vektor tiga dimensi",
  T_48_META_API_1505_P0_D: "vektor 3D",
  T_48_META_API_1505_P1_D: "komponen Z",
  T_48_META_API_1506_D: "Tambahkan dua vektor tiga dimensi",
  T_48_META_API_1506_P0_D: "Kiri",
  T_48_META_API_1506_P1_D: "Kanan",
  T_48_META_API_1506_R_D: "Hasil penjumlahan vektor tiga dimensi",
  T_48_META_API_1507_D: "Kurangi dua vektor tiga dimensi",
  T_48_META_API_1507_P0_D: "Kiri",
  T_48_META_API_1507_P1_D: "Kanan",
  T_48_META_API_1507_R_D: "Hasil pengurangan nilai r dari nilai l suatu vektor tiga dimensi",
  T_48_META_API_1508_D: "Penskalaan vektor tiga dimensi",
  T_48_META_API_1508_P0_D: "Vektor 3D yang akan diskalakan",
  T_48_META_API_1508_P1_D: "Jumlah penskalaan vektor 3D",
  T_48_META_API_1508_R_D: "Hasil penskalaan vektor 3D",
  T_48_META_API_1509_D: "Perkalian titik dua vektor tiga dimensi, hasil perkalian titiknya adalah skalar",
  T_48_META_API_1509_P0_D: "Kiri",
  T_48_META_API_1509_P1_D: "Kanan",
  T_48_META_API_1509_R_D: "Hasil perkalian titik",
  T_48_META_API_1510_D: "Kalikan silang dua buah vektor tiga dimensi. Hasil perkalian silang tersebut adalah sebuah vektor yang tegak lurus terhadap bidang tempat kedua vektor tersebut berada.",
  T_48_META_API_1510_P0_D: "Kiri",
  T_48_META_API_1510_P1_D: "Kanan",
  T_48_META_API_1510_R_D: "Hasil perkalian silang, arahnya tegak lurus terhadap bidang tempat kedua vektor yang terlibat dalam operasi tersebut berada.",
  T_48_META_API_1511_D: "Menormalkan vektor tiga dimensi",
  T_48_META_API_1511_P0_D: "vektor 3D",
  T_48_META_API_1511_R_D: "Mengembalikan vektor baru yang dinormalisasi. Panjang cetakan adalah 1",
  T_48_META_API_1512_D: "Modulo vektor tiga dimensi",
  T_48_META_API_1512_P0_D: "vektor 3D",
  T_48_META_API_1512_R_D: "Hasil modulonya adalah panjang modulus vektor",
  T_48_META_API_1513_D: "Hitung jarak Euclidean dari dua vektor tiga dimensi",
  T_48_META_API_1513_P0_D: "Kiri",
  T_48_META_API_1513_P1_D: "Kanan",
  T_48_META_API_1513_R_D: "Setelah mengurangkan dua vektor, modulus panjang vektor yang dihasilkan",
  T_48_META_API_1514_D: "Hitung sudut antara dua vektor tiga dimensi",
  T_48_META_API_1514_P0_D: "Kiri",
  T_48_META_API_1514_P1_D: "Kanan",
  T_48_META_API_1514_R_D: "Sudut vektor, rentang sudut 0-180",
  T_48_META_API_1515_D: "Buat vektor 3D",
  T_48_META_API_1515_P0_D: "Komponen X dari vektor tiga dimensi",
  T_48_META_API_1515_P1_D: "Komponen Y dari vektor tiga dimensi",
  T_48_META_API_1515_P2_D: "Komponen Z dari vektor tiga dimensi",
  T_48_META_API_1515_R_D: "Vektor tiga dimensi dibuat",
  T_48_META_API_1516_D: "Dapatkan titik arah yang baru dibuat (tidak digunakan lagi, jangan digunakan)",
  T_48_META_API_1516_P0_D: "Lokasi",
  T_48_META_API_1516_P1_D: "terhadap",
  T_48_META_API_1516_R_D: "Titik Langsung",
  T_48_META_API_1517_D: "Dapatkan posisi titik arah (usang, mohon jangan gunakan)",
  T_48_META_API_1517_P0_D: "titik arah",
  T_48_META_API_1517_R_D: "Posisi",
  T_48_META_API_1518_D: "Dapatkan orientasi titik arah (usang, mohon jangan gunakan)",
  T_48_META_API_1518_P0_D: "titik arah",
  T_48_META_API_1518_R_D: "Maju",
  T_48_META_API_1519_D: "Buat daftar",
  T_48_META_API_1519_P0_D: "Panjang awal daftar harus kurang dari atau sama dengan kapasitas awal",
  T_48_META_API_1519_P1_D: "Kapasitas awal daftar harus lebih besar atau sama dengan panjang awal. Kapasitas dapat diperluas secara dinamis, namun akan menghabiskan sejumlah kinerja tertentu. Disarankan untuk menetapkan nilai yang sesuai saat membangun.",
  T_48_META_API_1519_R_D: "Daftar yang dibuat",
  T_48_META_API_1520_D: "Memeriksa apakah daftar berisi elemen tertentu",
  T_48_META_API_1520_P0_D: "daftar sasaran",
  T_48_META_API_1520_P1_D: "Elemen tertentu untuk diperiksa",
  T_48_META_API_1520_R_D: "Apakah akan memuat elemen tertentu",
  T_48_META_API_1521_D: "Tambahkan beberapa elemen ke akhir daftar target",
  T_48_META_API_1521_P0_D: "daftar sasaran",
  T_48_META_API_1521_P1_D: "tambahkan daftar",
  T_48_META_API_1522_D: "Menghapus elemen tertentu dari daftar",
  T_48_META_API_1522_P0_D: "daftar sasaran",
  T_48_META_API_1522_P1_D: "nilai elemen yang akan dihapus",
  T_48_META_API_1523_D: "Dapatkan indeks posisi tempat elemen dalam daftar pertama kali muncul. Jika tidak ada elemen target dalam daftar, -1 dikembalikan.",
  T_48_META_API_1523_P0_D: "daftar sasaran",
  T_48_META_API_1523_P1_D: "nilai elemen",
  T_48_META_API_1523_R_D: "indeks lokasi",
  T_48_META_API_1524_D: "Mendapatkan indeks kemunculan terakhir elemen dalam daftar. Jika tidak ada elemen target dalam daftar, -1 dikembalikan.",
  T_48_META_API_1524_P0_D: "daftar sasaran",
  T_48_META_API_1524_P1_D: "nilai elemen",
  T_48_META_API_1524_R_D: "indeks lokasi",
  T_48_META_API_1525_D: "Temukan sinus suatu sudut",
  T_48_META_API_1525_P0_D: "Sudut, 360 mewakili 360 derajat",
  T_48_META_API_1525_R_D: "nilai sinus",
  T_48_META_API_1526_D: "Temukan kosinus suatu sudut",
  T_48_META_API_1526_P0_D: "Sudut, 360 mewakili 360 derajat",
  T_48_META_API_1526_R_D: "kosinus",
  T_48_META_API_1527_D: "Temukan garis singgung suatu sudut",
  T_48_META_API_1527_P0_D: "Sudut, 360 mewakili 360 derajat",
  T_48_META_API_1527_R_D: "garis singgung",
  T_48_META_API_1528_D: "Buatlah nilai warna dengan transparansi tetap pada desimal 255. Pertama ubah saluran menjadi bilangan biner. Setiap 8 bit mewakili saluran. Sambungkan menurut R, G, B dan transparansi mengembalikannya.",
  T_48_META_API_1528_P0_D: "Nilai saluran merah warnanya, rentang nilainya adalah [0,255]. Jika melebihi rentang tersebut, maka akan dijepit ke nilai yang sah.",
  T_48_META_API_1528_P1_D: "Nilai saluran hijau warnanya, rentang nilainya adalah [0,255]. Jika melebihi rentang tersebut, maka akan dijepit ke nilai legal.",
  T_48_META_API_1528_P2_D: "Nilai saluran biru warnanya, rentang nilainya adalah [0,255]. Jika melebihi rentang tersebut, maka akan dijepit ke nilai yang sah.",
  T_48_META_API_1528_R_D: "nilai warna yang dibangun",
  T_48_META_API_1529_D: "Lakukan operasi arcsinus untuk mendapatkan sudut",
  T_48_META_API_1529_P0_D: "Nilai untuk operasi arcsinus, rentang nilainya adalah [-1,1]",
  T_48_META_API_1529_R_D: "sudut",
  T_48_META_API_1530_D: "Lakukan operasi arc cosinus untuk mendapatkan sudut",
  T_48_META_API_1530_P0_D: "Nilai untuk operasi arc cosinus, rentang nilainya adalah [-1,1]",
  T_48_META_API_1530_R_D: "sudut",
  T_48_META_API_1531_D: "Lakukan operasi arctangent untuk mendapatkan sudut",
  T_48_META_API_1531_P0_D: "Nilai untuk melakukan operasi arctangent",
  T_48_META_API_1531_R_D: "sudut",
  T_48_META_API_1532_D: "Tentukan apakah entitas target berada dalam rentang lingkup yang ditentukan. Jika entitas tidak memiliki atribut posisi, false akan dikembalikan.",
  T_48_META_API_1532_P0_D: "entitas sasaran",
  T_48_META_API_1532_P1_D: "Menentukan pusat bola",
  T_48_META_API_1532_P2_D: "Menentukan radius bola",
  T_48_META_API_1532_R_D: "Hasil penilaian",
  T_48_META_API_1533_D: "Tentukan apakah entitas target berada dalam rentang silinder yang ditentukan. Jika entitas tidak memiliki atribut posisi, false akan dikembalikan.",
  T_48_META_API_1533_P0_D: "entitas sasaran",
  T_48_META_API_1533_P1_D: "Menentukan titik pusat silinder",
  T_48_META_API_1533_P2_D: "Menentukan radius penampang silinder",
  T_48_META_API_1533_P3_D: "Menentukan ketinggian silinder",
  T_48_META_API_1533_P4_D: "Menentukan sudut rotasi Euler tiga dimensi silinder di sekitar titik pusat",
  T_48_META_API_1533_R_D: "Hasil penilaian",
  T_48_META_API_1534_D: "Tentukan apakah entitas target berada dalam rentang kubus yang ditentukan",
  T_48_META_API_1534_P0_D: "entitas sasaran",
  T_48_META_API_1534_P1_D: "Menentukan titik pusat kubus",
  T_48_META_API_1534_P2_D: "Menentukan panjang kubus",
  T_48_META_API_1534_P3_D: "Menentukan lebar kubus",
  T_48_META_API_1534_P4_D: "Menentukan tinggi kubus",
  T_48_META_API_1534_P5_D: "Menentukan sudut rotasi Euler tiga dimensi kubus di sekitar titik pusat",
  T_48_META_API_1534_R_D: "Hasil penilaian",
  T_48_META_API_1535_D: "Tentukan apakah entitas target berada dalam rentang silinder sektor yang ditentukan",
  T_48_META_API_1535_P0_D: "entitas sasaran",
  T_48_META_API_1535_P1_D: "Menentukan pusat bagian tengah silinder berbentuk sektor",
  T_48_META_API_1535_P2_D: "Menentukan radius bagian tengah silinder berbentuk sektor",
  T_48_META_API_1535_P3_D: "Jari-jari penampang silinder berbentuk sektor yang tidak diuji, dengan titik pusat sebagai titik pusat lingkaran, maka luas silinder berbentuk sektor kecil tidak akan diuji, hanya selisih antara silinder berbentuk sektor yang ditentukan dan tema berbentuk",
  T_48_META_API_1535_P4_D: "Menentukan ketinggian silinder sektor",
  T_48_META_API_1535_P5_D: "Sudut tengah bagian silinder berbentuk sektor untuk pendeteksian. Jika lebih besar dari 360, maka akan dideteksi dalam bentuk silinder. Jika kurang dari 0, ukuran area pendeteksian akan menjadi 0.",
  T_48_META_API_1535_P6_D: "Menentukan sudut rotasi Euler tiga dimensi dari silinder sektor di sekitar titik pusat",
  T_48_META_API_1535_R_D: "Hasil penilaian",
  T_48_META_API_1536_D: "Membandingkan nilai dua angka dan mengembalikan nilai yang lebih besar",
  T_48_META_API_1536_P0_D: "Kiri",
  T_48_META_API_1536_P1_D: "Kanan",
  T_48_META_API_1536_R_D: "jumlah yang lebih besar",
  T_48_META_API_1537_D: "Mengembalikan nilai maksimum dalam daftar",
  T_48_META_API_1537_P0_D: "Daftar target, hanya menerima tipe elemen daftar sebagai nomor",
  T_48_META_API_1537_P1_D: "Hasil perbandingan. Jika ada non-digit dalam daftar, perbandingan gagal dan menghasilkan false.",
  T_48_META_API_1537_P2_D: "Mengembalikan nilai terbesar dalam daftar jika perbandingan berhasil, dan mengembalikan 0 jika perbandingan gagal.",
  T_48_META_API_1538_D: "Membandingkan nilai dua angka dan mengembalikan nilai yang lebih kecil",
  T_48_META_API_1538_P0_D: "Kiri",
  T_48_META_API_1538_P1_D: "Kanan",
  T_48_META_API_1538_R_D: "jumlah yang lebih kecil",
  T_48_META_API_1539_D: "Mengembalikan nilai minimum dalam daftar.",
  T_48_META_API_1539_P0_D: "Daftar target, hanya menerima tipe elemen daftar sebagai nomor",
  T_48_META_API_1539_P1_D: "Hasil perbandingan. Jika ada non-digit dalam daftar, perbandingan gagal dan menghasilkan false.",
  T_48_META_API_1539_P2_D: "Mengembalikan nilai terkecil dalam daftar jika perbandingan berhasil, dan mengembalikan 0 jika perbandingan gagal.",
  T_48_META_API_1540_D: "Interpolasi linier, mengembalikan nilai yang sesuai dengan kemajuan interpolasi antara nilai awal dan nilai target, koefisien interpolasi [0,1]",
  T_48_META_API_1540_P0_D: "Nilai awal interpolasi linier. Nilai ini dikembalikan ketika kemajuan interpolasi adalah 0.",
  T_48_META_API_1540_P1_D: "Nilai target interpolasi linier, nilai ini dikembalikan ketika kemajuan interpolasi adalah 1",
  T_48_META_API_1540_P2_D: "Kemajuan interpolasi, rentang nilai [0,1], bila nilainya 0, nilai awal dikembalikan, bila nilainya 1, nilai target dikembalikan, bila nilainya 0,5, rata-rata nilai awal dan target nilai dikembalikan",
  T_48_META_API_1540_R_D: "nilai pengembalian interpolasi linier",
  T_48_META_API_1541_D: "Batasi rentang nilai target dan dapatkan nilai tengah di antara ketiga parameter masukan; fungsinya untuk membatasi nilai target ke rentang yang ditentukan. Jika nilai target lebih kecil dari nilai minimum, nilai minimum akan dikembalikan nilai target leb",
  T_48_META_API_1541_P0_D: "nilai sasaran",
  T_48_META_API_1541_P1_D: "Nilai minimum rentang terbatas",
  T_48_META_API_1541_P2_D: "Nilai maksimum dari rentang terbatas",
  T_48_META_API_1541_R_D: "Nilai kembalian setelah pembatasan",
  T_48_META_API_1542_D: "Dapatkan nilai saluran dari warna target",
  T_48_META_API_1542_P0_D: "warna sasaran",
  T_48_META_API_1542_P1_D: "Nilai R warna, rentang [0, 255]",
  T_48_META_API_1542_P2_D: "Nilai G warna, rentang [0, 255]",
  T_48_META_API_1542_P3_D: "Nilai B warna, rentang [0, 255]",
  T_48_META_API_1542_P4_D: "Nilai A warna, rentang [0, 255]",
  T_48_META_API_1543_D: "eksponen",
  T_48_META_API_1543_P0_D: "dasar",
  T_48_META_API_1543_P1_D: "indeks",
  T_48_META_API_1543_R_D: "Hasil perhitungan",
  T_48_META_API_1544_D: "Operasi logaritma",
  T_48_META_API_1544_P0_D: "dasar",
  T_48_META_API_1544_P1_D: "bilangan real",
  T_48_META_API_1544_R_D: "Hasil perhitungan",
  T_48_META_API_1545_D: "Vektor arah ke sudut Euler",
  T_48_META_API_1545_P0_D: "vektor arah",
  T_48_META_API_1545_R_D: "Sudut Euler",
  T_48_META_API_1546_D: "Vektor arah putaran sudut Euler",
  T_48_META_API_1546_P0_D: "Sudut Euler",
  T_48_META_API_1546_R_D: "vektor arah",
  T_48_META_API_1547_D: "Bilangan bulat ke bilangan floating point",
  T_48_META_API_1547_P0_D: "bilangan bulat",
  T_48_META_API_1547_R_D: "nomor titik mengambang",
  T_48_META_API_1548_D: "Putar vektor target menurut angka empat",
  T_48_META_API_1548_P0_D: "vektor sasaran",
  T_48_META_API_1548_P1_D: "Putar Kuarter",
  T_48_META_API_1548_R_D: "vektor diputar",
  T_48_META_API_1549_D: "Ubah nomor target menjadi string",
  T_48_META_API_1549_P0_D: "Nomor target yang akan diubah menjadi string",
  T_48_META_API_1549_P1_D: "Format string numerik keluaran",
  T_48_META_API_1549_R_D: "rangkaian",
  T_48_META_API_1598_D: "Dapatkan stempel waktu server",
  T_48_META_API_1598_R_D: "Mengembalikan jumlah detik sejak 0:00:00 pada tanggal 1 Januari 1970",
  T_48_META_API_1599_D: "Dapatkan area server",
  T_48_META_API_1599_R_D: "Mengembalikan singkatan wilayah (BR, SAC, ID, NA, US, IND, SG, BD, VN, TH, ME, RU, EU, PK, TW)",
  T_48_META_API_16_D: "Log pelacakan pengguna yang disesuaikan untuk analisis data pengalaman pengguna",
  T_48_META_API_16_P0_D: "Pemain yang akan dilaporkan",
  T_48_META_API_16_P1_D: "Daftar nama bidang yang akan dilaporkan",
  T_48_META_API_16_P2_D: "Daftar nilai bidang yang akan dilaporkan",
  T_48_META_API_1601_D: "Buat kamus",
  T_48_META_API_1601_R_D: "kamus yang dibuat",
  T_48_META_API_1602_D: "Dapatkan nilai yang sesuai dengan kunci yang ditentukan dalam kamus",
  T_48_META_API_1602_P0_D: "kamus sasaran",
  T_48_META_API_1602_P1_D: "Kunci",
  T_48_META_API_1602_R_D: "Nilai",
  T_48_META_API_1603_D: "Menetapkan nilai yang sesuai dengan kunci yang ditentukan dalam kamus",
  T_48_META_API_1603_P0_D: "kamus sasaran",
  T_48_META_API_1603_P1_D: "Kunci",
  T_48_META_API_1603_P2_D: "Nilai",
  T_48_META_API_1604_D: "Hapus pasangan nilai kunci yang ditentukan dari kamus",
  T_48_META_API_1604_P0_D: "kamus sasaran",
  T_48_META_API_1604_P1_D: "Kunci",
  T_48_META_API_1605_D: "Hapus semua pasangan nilai kunci dalam kamus",
  T_48_META_API_1605_P0_D: "kamus sasaran",
  T_48_META_API_1606_D: "Dapatkan jumlah pasangan nilai kunci dalam kamus",
  T_48_META_API_1606_P0_D: "kamus sasaran",
  T_48_META_API_1606_R_D: "Panjang kamus",
  T_48_META_API_1607_D: "Tentukan apakah kunci ada dalam kamus",
  T_48_META_API_1607_P0_D: "kamus sasaran",
  T_48_META_API_1607_P1_D: "Kunci",
  T_48_META_API_1607_R_D: "Apakah itu ada",
  T_48_META_API_1608_D: "Mendapatkan semua kunci kamus, dikembalikan sebagai daftar",
  T_48_META_API_1608_P0_D: "kamus sasaran",
  T_48_META_API_1608_R_D: "Daftar semua nilai kunci",
  T_48_META_API_17_D: "Gunakan area gerak linier berbentuk kotak untuk mendeteksi, dan kembalikan semua entitas yang ditemui pada rute area berbentuk kotak dari dekat hingga jauh. Jika awalnya berada dalam jangkauan berbentuk kotak, mereka tidak akan terdeteksi; jika parameter hierarki diisi, maka medan dapat dideteksi",
  T_48_META_API_17_P0_D: "Setengah panjang ketiga sisi luas kotak, hanya nilai positif yang diterima",
  T_48_META_API_17_P1_D: "titik tengah luas kotak",
  T_48_META_API_17_P2_D: "Rotasi area kotak",
  T_48_META_API_17_P3_D: "Arah perjalanan area kotak",
  T_48_META_API_17_P4_D: "Jarak tempuh area kotak, hanya nilai positif yang diterima",
  T_48_META_API_17_P5_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_17_P6_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_17_P7_D: "daftar entitas yang terkena dampak",
  T_48_META_API_1700_D: "Ubah string yang ditentukan menjadi bilangan bulat",
  T_48_META_API_1700_P0_D: "rangkaian sasaran",
  T_48_META_API_1700_P1_D: "Hasil bilangan bulat",
  T_48_META_API_1700_P2_D: "Apakah konversi berhasil?",
  T_48_META_API_1701_D: "Ubah string yang ditentukan menjadi angka floating point",
  T_48_META_API_1701_P0_D: "rangkaian sasaran",
  T_48_META_API_1701_P1_D: "Hasil melayang",
  T_48_META_API_1701_P2_D: "Apakah konversi berhasil?",
  T_48_META_API_18_D: "Gunakan area bola bergerak garis lurus untuk mendeteksi, dan kembalikan semua entitas yang ditemukan pada rute area bola dari dekat ke jauh. Jika awalnya berada di area bola, mereka tidak akan terdeteksi jika parameter level diisi di bagian yang kosong , medan dapat dideteksi",
  T_48_META_API_18_P0_D: "Radius luas bola, hanya nilai positif yang diterima",
  T_48_META_API_18_P1_D: "Titik pusat bidang bola",
  T_48_META_API_18_P2_D: "Arah perjalanan daerah bola",
  T_48_META_API_18_P3_D: "Jarak yang ditempuh luas bola, hanya nilai positif yang diterima",
  T_48_META_API_18_P4_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_18_P5_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_18_P6_D: "daftar entitas yang terkena dampak",
  T_48_META_API_19_D: "Gunakan area kapsul yang bergerak secara linier untuk mendeteksi, dan kembalikan semua entitas yang ditemui pada rute area kapsul dari dekat hingga jauh. Jika awalnya berada di dalam area kapsul, mereka tidak akan terdeteksi jika parameter level diisi, itu dapat dideteksi medannya",
  T_48_META_API_19_P0_D: "Jari-jari belahan di kedua ujung area kapsul, hanya nilai positif yang diterima",
  T_48_META_API_19_P1_D: "Jarak antara pusat belahan bumi di kedua ujung luas kapsul. Nilai ini harus lebih besar dari dua kali jari-jari belahan bumi di kedua ujungnya.",
  T_48_META_API_19_P2_D: "Titik tengah area kapsul",
  T_48_META_API_19_P3_D: "Rotasi area kapsul",
  T_48_META_API_19_P4_D: "Arah perjalanan area kapsul",
  T_48_META_API_19_P5_D: "Jarak yang ditempuh di wilayah kapsul, hanya menerima nilai positif.",
  T_48_META_API_19_P6_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_19_P7_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_19_P8_D: "daftar entitas yang terkena dampak",
  T_48_META_API_2_D: "Dapatkan semua tim dalam permainan saat ini dan kembali ke daftar tim.",
  T_48_META_API_2_R_D: "Daftar tim",
  T_48_META_API_20_D: "Gunakan area berbentuk kotak statis untuk mendeteksi dan mengembalikan semua entitas dalam area berbentuk kotak. Jika parameter level diisi pada bagian yang kosong, medan dapat dideteksi.",
  T_48_META_API_20_P0_D: "Setengah panjang ketiga sisi luas kotak, hanya nilai positif yang diterima",
  T_48_META_API_20_P1_D: "titik tengah luas kotak",
  T_48_META_API_20_P2_D: "Rotasi area kotak",
  T_48_META_API_20_P3_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_20_P4_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_20_P5_D: "daftar entitas yang terkena dampak",
  T_48_META_API_2000_D: "Tetapkan nilai atribut entitas target, yang mengharuskan atribut tersebut telah ditentukan",
  T_48_META_API_2000_P0_D: "entitas sasaran",
  T_48_META_API_2000_P1_D: "atribut dari entitas target",
  T_48_META_API_2000_P2_D: "Nilai target harus sesuai dengan tipe yang diperlukan saat atribut ditentukan.",
  T_48_META_API_2000_P3_D: "Mode operasi, semua tipe mendukung penugasan, dan tipe numerik juga mendukung penjumlahan mandiri, pengurangan mandiri, perkalian mandiri, pembagian mandiri, dan sisa mandiri.",
  T_48_META_API_2001_D: "Dapatkan nilai atribut suatu entitas",
  T_48_META_API_2001_P0_D: "entitas sasaran",
  T_48_META_API_2001_P1_D: "ID atribut entitas",
  T_48_META_API_2001_R_D: "nilai atribut",
  T_48_META_API_2002: "Tetapkan Properti Grafik",
  T_48_META_API_2002_D: "Tetapkan variabel skrip",
  T_48_META_API_2002_P0_D: "entitas sasaran",
  T_48_META_API_2002_P1: "ID Grafik",
  T_48_META_API_2002_P1_D: "ID skrip target",
  T_48_META_API_2002_P2: "ID Properti",
  T_48_META_API_2002_P2_D: "ID atribut anggota ditentukan dalam skrip",
  T_48_META_API_2002_P3: "Nilai Properti",
  T_48_META_API_2002_P3_D: "Nilai target harus sesuai dengan tipe yang diperlukan saat atribut ditentukan.",
  T_48_META_API_2002_P4_D: "Mode operasi, semua tipe mendukung penugasan, dan tipe numerik juga mendukung penjumlahan mandiri, pengurangan mandiri, perkalian mandiri, pembagian mandiri, dan sisa mandiri.",
  T_48_META_API_2003: "Dapatkan Properti Grafik",
  T_48_META_API_2003_D: "Dapatkan variabel skrip",
  T_48_META_API_2003_P0_D: "entitas sasaran",
  T_48_META_API_2003_P1: "ID Grafik",
  T_48_META_API_2003_P1_D: "ID skrip target",
  T_48_META_API_2003_P2: "ID Properti",
  T_48_META_API_2003_P2_D: "ID atribut target",
  T_48_META_API_2003_R_D: "nilai atribut",
  T_48_META_API_2004_D: "Definisikan dan inisialisasi variabel lokal. Cakupan variabel lokal adalah dari posisi deklarasi hingga akhir blok pernyataan.",
  T_48_META_API_2004_P0_D: "nama variabel",
  T_48_META_API_2004_P1_D: "nilai awal variabel",
  T_48_META_API_2004_P2_D: "Tipe deklarasi variabel. Saat menetapkan nilai, nilai tersebut harus sesuai dengan tipe yang dideklarasikan.",
  T_48_META_API_2005_D: "Tetapkan nilai variabel lokal. Cakupan variabel lokal adalah dari posisi deklarasi hingga akhir blok pernyataan.",
  T_48_META_API_2005_P0_D: "nama variabel",
  T_48_META_API_2005_P1: "Nilai Variabel",
  T_48_META_API_2005_P1_D: "nilai variabel",
  T_48_META_API_2005_P2_D: "Mode operasi, semua tipe mendukung penugasan, dan tipe numerik juga mendukung penjumlahan mandiri, pengurangan mandiri, perkalian mandiri, pembagian mandiri, dan sisa mandiri.",
  T_48_META_API_2006: "Dapatkan Variabel Lokal",
  T_48_META_API_2006_D: "Dapatkan nilai variabel lokal. Cakupan variabel lokal adalah dari posisi deklarasi hingga akhir blok pernyataan.",
  T_48_META_API_2006_P0: "Nama Variabel",
  T_48_META_API_2006_P0_D: "nama variabel",
  T_48_META_API_2006_R_D: "nilai variabel",
  T_48_META_API_2009: "Temukan dan Panggil API Kustom Global dengan Serial",
  T_48_META_API_2009_D: "Panggil fungsi kustom global secara serial. Jika ada waktu tunggu di fungsi kustom, lokasi panggilan juga akan menunggu.",
  T_48_META_API_2009_P0: "ID Grafik",
  T_48_META_API_2009_P0_D: "ID skrip tempat fungsi khusus berada",
  T_48_META_API_2009_P1: "ID Fungsi",
  T_48_META_API_2009_P1_D: "ID fungsi khusus dipanggil",
  T_48_META_API_2009_P2_D: "Daftar parameter yang diteruskan ke fungsi kustom",
  T_48_META_API_2010: "Temukan dan Panggil API Kustom Global dengan Parallel",
  T_48_META_API_2010_D: "Panggil fungsi kustom global secara paralel. Terlepas dari apakah ada waktu tunggu di fungsi kustom, fungsi tersebut akan segera kembali ke lokasi pemanggilan dan melanjutkan eksekusi.",
  T_48_META_API_2010_P0: "ID Grafik",
  T_48_META_API_2010_P0_D: "ID skrip tempat fungsi khusus berada",
  T_48_META_API_2010_P1: "ID Fungsi",
  T_48_META_API_2010_P1_D: "ID fungsi khusus dipanggil",
  T_48_META_API_2010_P2_D: "Daftar parameter yang diteruskan ke fungsi kustom",
  T_48_META_API_2013: "Tetapkan Properti Grafik Diri",
  T_48_META_API_2013_D: "Tetapkan variabel untuk skrip saat ini",
  T_48_META_API_2013_P0: "ID Properti",
  T_48_META_API_2013_P0_D: "ID atribut target",
  T_48_META_API_2013_P1: "Nilai Properti",
  T_48_META_API_2013_P1_D: "nilai sasaran",
  T_48_META_API_2013_P2_D: "Mode operasi, semua tipe mendukung penugasan, dan tipe numerik juga mendukung penjumlahan mandiri, pengurangan mandiri, perkalian mandiri, pembagian mandiri, dan sisa mandiri.",
  T_48_META_API_2014: "Dapatkan Properti Grafik Mandiri",
  T_48_META_API_2014_D: "Dapatkan variabel skrip saat ini",
  T_48_META_API_2014_P0: "ID Properti",
  T_48_META_API_2014_P0_D: "ID atribut target",
  T_48_META_API_2014_R_D: "nilai atribut",
  T_48_META_API_21_D: "Gunakan area bola statis untuk mendeteksi dan mengembalikan semua entitas dalam area bola. Jika parameter level diisi pada bagian yang kosong, medan dapat dideteksi.",
  T_48_META_API_21_P0_D: "Radius luas bola, hanya nilai positif yang diterima",
  T_48_META_API_21_P1_D: "Titik pusat bidang bola",
  T_48_META_API_21_P2_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_21_P3_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_21_P4_D: "daftar entitas yang terkena dampak",
  T_48_META_API_22_D: "Gunakan area kapsul statis untuk mendeteksi dan mengembalikan semua entitas di dalam area kapsul. Jika parameter level diisi, medan dapat dideteksi.",
  T_48_META_API_22_P0_D: "Jari-jari belahan di kedua ujung area kapsul, hanya nilai positif yang diterima",
  T_48_META_API_22_P1_D: "Jarak antara pusat belahan bumi di kedua ujung luas kapsul. Nilai ini harus lebih besar dari dua kali jari-jari belahan bumi di kedua ujungnya.",
  T_48_META_API_22_P2_D: "Titik tengah area kapsul",
  T_48_META_API_22_P3_D: "Rotasi area kapsul",
  T_48_META_API_22_P4_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_22_P5_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_22_P6_D: "daftar entitas yang terkena dampak",
  T_48_META_API_23_D: "Tetapkan status item spesial untuk pemain.",
  T_48_META_API_23_P0_D: "pemain",
  T_48_META_API_23_P1_D: "ID barang",
  T_48_META_API_23_P2_D: "Apakah akan mengaktifkan item ini",
  T_48_META_API_23_P3_D: "entitas item khusus",
  T_48_META_API_24_D: "Menerapkan gaya pada target, yang harus berupa benda fisik",
  T_48_META_API_24_P0_D: "sasaran objek fisik",
  T_48_META_API_24_P1_D: "vektor gaya",
  T_48_META_API_24_P2_D: "jenis kekuatan",
  T_48_META_API_25_D: "Berikan gaya satu kali pada titik tertentu, sasarannya harus berupa benda tegar",
  T_48_META_API_25_P0_D: "sasaran benda tegar",
  T_48_META_API_25_P1_D: "vektor gaya",
  T_48_META_API_25_P2_D: "Paksa posisi lamaran",
  T_48_META_API_25_P3_D: "jenis kekuatan",
  T_48_META_API_26_D: "Terapkan torsi ke target, yang harus berupa benda kaku",
  T_48_META_API_26_P0_D: "sasaran benda tegar",
  T_48_META_API_26_P1_D: "Torsi",
  T_48_META_API_26_P2_D: "Tipe kekuatan",
  T_48_META_API_27_D: "Pindahkan benda kaku target ke posisi yang ditentukan",
  T_48_META_API_27_P0_D: "sasaran benda tegar",
  T_48_META_API_27_P1_D: "Tentukan lokasi",
  T_48_META_API_28_D: "Memutar benda kaku target",
  T_48_META_API_28_P0_D: "sasaran benda tegar",
  T_48_META_API_28_P1_D: "Putar Kuarter",
  T_48_META_API_29_D: "Buat gerakan interpolasi, dan atribut yang ditentukan dari entitas target akan bergerak dengan lancar sesuai pengaturan",
  T_48_META_API_29_P0_D: "entitas sasaran",
  T_48_META_API_29_P1_D: "ID atribut yang perlu diubah",
  T_48_META_API_29_P2_D: "nilai awal atribut",
  T_48_META_API_29_P3_D: "nilai akhir atribut",
  T_48_META_API_29_P4_D: `Anda dapat memilih gerakan tunggal, berulang, dan resiprokal. 
 Berulang berarti bahwa setelah setiap gerakan selesai, entitas akan bergerak lagi dari nilai awal. Berulang berarti bahwa setelah gerakan dari nilai awal ke nilai target selesai, entitas akan bergerak lagi dari nilai target ke nilai awal, dan kemudian mengulangi proses tersebut.`,
  T_48_META_API_29_P5_D: "Titik kendali kurva Bezier",
  T_48_META_API_29_P6_D: "Durasi perubahan, dalam milidetik",
  T_48_META_API_29_P7_D: "Menciptakan entitas gerak yang diinterpolasi",
  T_48_META_API_29_P8_D: "Apakah akan mulai memutar secara otomatis setelah pembuatan",
  T_48_META_API_3_D: "Alihkan permainan ke fase target, dan putaran juga merupakan fase khusus. Saat beralih ke fase dalam satu putaran, jumlah putarannya adalah 0.",
  T_48_META_API_3_P0_D: "Indeks putaran atau fase target",
  T_48_META_API_30_D: "Paksa pemain target untuk memasuki kendaraan yang ditunjuk",
  T_48_META_API_30_P0_D: "pemain sasaran",
  T_48_META_API_30_P1_D: "entitas kendaraan",
  T_48_META_API_30_P2_D: "Nomor kursi",
  T_48_META_API_30_P3_D: "Apakah pemain berhasil diizinkan memasuki kendaraan",
  T_48_META_API_3001_D: "Menyebabkan pemain target menjatuhkan item",
  T_48_META_API_3001_P0_D: "pemain sasaran",
  T_48_META_API_3001_P1_D: "Entitas barang",
  T_48_META_API_3002_D: "Dapatkan koordinat yang tersedia dalam titik spawn acak yang tersedia saat ini yang tidak terisi penuh (usang, silakan gunakan GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "Pemain yang perlu menetapkan area spawn",
  T_48_META_API_3002_R_D: "Koordinat titik acak yang ditetapkan secara acak",
  T_48_META_API_3003_D: "Dapatkan nilai total poin dari jenis poin yang ditentukan pemain",
  T_48_META_API_3003_P0_D: "pemain",
  T_48_META_API_3003_P1_D: "Tipe titik",
  T_48_META_API_3003_R_D: "Nilai poin",
  T_48_META_API_3004_D: "Tetapkan nilai poin bulat untuk jenis poin yang ditentukan pemain",
  T_48_META_API_3004_P0_D: "entitas pemain",
  T_48_META_API_3004_P1_D: "Tipe titik",
  T_48_META_API_3004_P2_D: "Nilai poin",
  T_48_META_API_3005_D: "Dapatkan nilai total poin dari jenis poin yang ditentukan untuk tim",
  T_48_META_API_3005_P0_D: "Entitas tim",
  T_48_META_API_3005_P1_D: "Tipe titik",
  T_48_META_API_3005_R_D: "Nilai poin",
  T_48_META_API_3006_D: "Tetapkan nilai poin bulat untuk jenis poin yang ditentukan tim",
  T_48_META_API_3006_P0_D: "Entitas tim",
  T_48_META_API_3006_P1_D: "Tipe titik",
  T_48_META_API_3006_P2_D: "Nilai poin",
  T_48_META_API_3007_D: "Dapatkan poin pemain untuk putaran dan jenis poin yang ditentukan",
  T_48_META_API_3007_P0_D: "entitas pemain",
  T_48_META_API_3007_P1_D: "indeks bulat",
  T_48_META_API_3007_P2_D: "Tipe titik",
  T_48_META_API_3007_R_D: "Nilai poin",
  T_48_META_API_3008_D: "Dapatkan poin tim untuk putaran dan jenis poin yang ditentukan",
  T_48_META_API_3008_P0_D: "Entitas tim",
  T_48_META_API_3008_P1_D: "indeks bulat",
  T_48_META_API_3008_P2_D: "Tipe titik",
  T_48_META_API_3008_R_D: "Nilai poin",
  T_48_META_API_3009_D: "Dapatkan total peringkat permainan pemain",
  T_48_META_API_3009_P0_D: "entitas pemain",
  T_48_META_API_3009_R_D: "Peringkat",
  T_48_META_API_3011_D: "Dapatkan peringkat keseluruhan permainan tim",
  T_48_META_API_3011_P0_D: "Tidak digunakan lagi",
  T_48_META_API_3011_R_D: "Peringkat",
  T_48_META_API_3013_D: "Dapatkan peringkat putaran yang ditentukan pemain",
  T_48_META_API_3013_P0_D: "entitas pemain",
  T_48_META_API_3013_P1_D: "indeks bulat",
  T_48_META_API_3013_R_D: "Peringkat",
  T_48_META_API_3014_D: "Dapatkan peringkat putaran yang ditentukan tim",
  T_48_META_API_3014_P0_D: "Tidak digunakan lagi",
  T_48_META_API_3014_P1_D: "indeks bulat",
  T_48_META_API_3014_R_D: "Peringkat",
  T_48_META_API_3015_D: "Dapatkan dompet entitas target",
  T_48_META_API_3015_P0_D: "entitas sasaran",
  T_48_META_API_3015_P1_D: "Apakah dompetnya ada?",
  T_48_META_API_3015_P2_D: "Entitas dompet yang diperoleh",
  T_48_META_API_3016_D: "Membuat dompet untuk pemain target. Jika pemain sudah memiliki dompet, maka tidak valid.",
  T_48_META_API_3016_P0_D: "pemain sasaran",
  T_48_META_API_3016_P1_D: "Entitas yang terikat pada dompet, pemilik dompet",
  T_48_META_API_3016_P2_D: "entitas dompet",
  T_48_META_API_3017_D: "Tambahkan mata uang ke dompet tertentu",
  T_48_META_API_3017_P0_D: "dompet sasaran",
  T_48_META_API_3017_P1_D: "Menambahkan jenis mata uang",
  T_48_META_API_3017_P2_D: "Peningkatan jumlah mata uang",
  T_48_META_API_3018_D: "Kurangi mata uang untuk dompet tertentu",
  T_48_META_API_3018_P0_D: "dompet sasaran",
  T_48_META_API_3018_P1_D: "Jenis mata uang berkurang",
  T_48_META_API_3018_P2_D: "Mengurangi jumlah uang",
  T_48_META_API_3019_D: "Transfer mata uang dari satu dompet ke dompet lainnya",
  T_48_META_API_3019_P0_D: "Dompet untuk mentransfer mata uang",
  T_48_META_API_3019_P1_D: "Jenis mata uang yang ditransfer",
  T_48_META_API_3019_P2_D: "Jumlah mata uang yang ditransfer",
  T_48_META_API_3019_P3_D: "Dompet untuk mentransfer mata uang",
  T_48_META_API_3020_D: "Dapatkan jumlah jenis mata uang tertentu di dompet yang ditentukan",
  T_48_META_API_3020_P0_D: "dompet sasaran",
  T_48_META_API_3020_P1_D: "Jenis mata uang kueri",
  T_48_META_API_3020_R_D: "kuantitas mata uang",
  T_48_META_API_3021_D: "Dapatkan entitas dari jenis mata uang tertentu di dompet yang ditentukan",
  T_48_META_API_3021_P0_D: "dompet sasaran",
  T_48_META_API_3021_P1_D: "Jenis mata uang kueri",
  T_48_META_API_3021_R_D: "entitas moneter",
  T_48_META_API_3022_D: "Dapatkan semua toko dalam game, dikembalikan sebagai daftar",
  T_48_META_API_3022_R_D: "Daftar entitas toko",
  T_48_META_API_3023_D: "Ganti tampilan pemain target dengan tampilan objek adegan yang ditentukan",
  T_48_META_API_3023_P0_D: "pemain sasaran",
  T_48_META_API_3023_P1_D: "Penggantian objek adegan target",
  T_48_META_API_3023_P2_D: "Komponen penyamaran transformasi pemain dibuat setelah penggantian",
  T_48_META_API_3024_D: "Batalkan status penyamaran pemain",
  T_48_META_API_3024_P0_D: "pemain sasaran",
  T_48_META_API_3025_D: "Buat tiruan entitas adegan di pemain target",
  T_48_META_API_3025_P0_D: "pemain sasaran",
  T_48_META_API_3025_P1_D: "Entitas adegan yang digunakan untuk avatar",
  T_48_META_API_3025_P2_D: "Entitas kloning yang dibuat",
  T_48_META_API_3026_D: "Dapatkan entitas penyamaran pemain",
  T_48_META_API_3026_P0_D: "pemain",
  T_48_META_API_3026_R_D: "Entitas pemain yang menyamar",
  T_48_META_API_3027_D: "Dapatkan entitas saluran obrolan berdasarkan indeks",
  T_48_META_API_3027_P0_D: "Indeks saluran obrolan, rentang [1,8]",
  T_48_META_API_3027_R_D: "Entitas saluran obrolan",
  T_48_META_API_3028_D: "Dapatkan entitas saluran obrolan tempat pemain tertentu berada saat ini",
  T_48_META_API_3028_P0_D: "pemain sasaran",
  T_48_META_API_3028_R_D: "Entitas saluran obrolan",
  T_48_META_API_3029_D: "Biarkan pemain bergabung ke saluran obrolan yang ditentukan. Jika pemain sudah berada di saluran obrolan lain, dia akan beralih ke saluran target.",
  T_48_META_API_3029_P0_D: "pemain sasaran",
  T_48_META_API_3029_P1_D: "Entitas saluran obrolan",
  T_48_META_API_3030_D: "Menyebabkan pemain keluar dari saluran saat ini dan kemudian berada dalam keadaan tidak berada di saluran obrolan mana pun",
  T_48_META_API_3030_P0_D: "pemain sasaran",
  T_48_META_API_3031_D: "Tidak digunakan lagi",
  T_48_META_API_3031_P0_D: "Entitas saluran obrolan, kosong bila tidak ada pemain di saluran tersebut",
  T_48_META_API_3032_D: "Atur status perilaku pemain",
  T_48_META_API_3032_P0_D: "pemain sasaran",
  T_48_META_API_3032_P1_D: "Tipe perilaku pemain",
  T_48_META_API_3032_P2_D: `Diaktifkan: Terdapat tombol HUD dan dapat digunakan secara normal
Dinonaktifkan: Tombol HUD dinonaktifkan dan tidak dapat secara aktif atau pasif memasuki status perilaku
Perisai: Tombol HUD tersembunyi dan tidak dapat aktif memasuki status perilaku, te`,
  T_48_META_API_3033_D: "Pemain berubah menjadi objek adegan tertentu",
  T_48_META_API_3033_P0_D: "pemain sasaran",
  T_48_META_API_3033_P1_D: "Objek yang akan diubah",
  T_48_META_API_3033_P2_D: "Entitas yang dibuat setelah transformasi",
  T_48_META_API_3034_D: "Pemain membuat tiruan dari diri mereka sendiri",
  T_48_META_API_3034_P0_D: "pemain sasaran",
  T_48_META_API_3034_P1_D: "Entitas kloning yang dibuat",
  T_48_META_API_3035_D: "Buat toko khusus dengan tingkat toko berikutnya adalah rak",
  T_48_META_API_3035_P0_D: "Entitas toko yang dibuat",
  T_48_META_API_3036_D: "Buat rak khusus. Rak tingkat atas adalah toko dan tingkat berikutnya adalah produk.",
  T_48_META_API_3036_P0_D: "Entitas rak yang dibuat",
  T_48_META_API_3037_D: "Buat produk khusus yang dapat menambahkan item",
  T_48_META_API_3037_P0_D: "Entitas produk yang dibuat",
  T_48_META_API_3038_D: "Tambahkan item ke suatu produk. Beberapa item dapat ditambahkan ke satu produk dengan menggunakan primitif ini beberapa kali.",
  T_48_META_API_3038_P0_D: "Entitas komoditas",
  T_48_META_API_3038_P1_D: "Item untuk ditambahkan",
  T_48_META_API_3038_P2_D: "Kuantitas barang",
  T_48_META_API_3039_D: "Berikan hadiah jailbreak",
  T_48_META_API_3039_P0_D: "entitas pemain",
  T_48_META_API_3039_P1_D: "kuantitas",
  T_48_META_API_3039_P2_D: "uang sungguhan",
  T_48_META_API_3040_D: "Tugas jailbreak yang diperbarui",
  T_48_META_API_3040_P0_D: "entitas pemain",
  T_48_META_API_3040_P1_D: "ID Tugas",
  T_48_META_API_3040_P2_D: "nilai",
  T_48_META_API_3041_D: "Perolehan koordinat titik spawn secara acak hanya akan dilakukan secara acak dari titik spawn yang tersedia dan tidak terisi penuh.",
  T_48_META_API_3041_P0_D: "pemain sasaran",
  T_48_META_API_3041_R_D: "Koordinat titik lahir acak. Jika tidak ada titik lahir yang memenuhi syarat, maka posisinya mendekati (0, 0, 0) akan dikembalikan.",
  T_48_META_API_3042_D: "Keluar dari mini-game jailbreak",
  T_48_META_API_3042_P0_D: "entitas pemain",
  T_48_META_API_3042_P1_D: "ID Tugas",
  T_48_META_API_3043_D: "Berdasarkan alat peraga jailbreak",
  T_48_META_API_3043_P0_D: "entitas pemain",
  T_48_META_API_3043_P1_D: "Jenis penyangga",
  T_48_META_API_3043_P2_D: "ID pendukung",
  T_48_META_API_31_D: "Buat gerakan diri relatif, dan entitas target berubah relatif terhadap nilai atributnya saat ini setiap saat",
  T_48_META_API_31_P0_D: "entitas sasaran",
  T_48_META_API_31_P1_D: "Atribut yang memerlukan perubahan gerak",
  T_48_META_API_31_P2_D: "jumlah perubahan per gerakan",
  T_48_META_API_31_P3_D: "Titik kendali kurva Bezier",
  T_48_META_API_31_P4_D: `Tunggal: Berhenti ketika atribut mengubah jumlah Delta
Loop: Ulangi gerakan tersebut, setiap kali atribut mengubah jumlah Delta`,
  T_48_META_API_31_P5_D: "Durasi perubahan, dalam milidetik",
  T_48_META_API_31_P6_D: "Entitas relatif yang dapat bergerak sendiri",
  T_48_META_API_31_P7_D: "Apakah akan mulai memutar secara otomatis setelah pembuatan",
  T_48_META_API_3100_D: "Target memutar animasi dalam keadaan yang ditentukan",
  T_48_META_API_3100_P0_D: "Komponen entitas yang dapat dipasang dengan pengontrol animasi untuk memutar animasi",
  T_48_META_API_3100_P1_D: "Status pengontrol animasi yang ditentukan",
  T_48_META_API_3100_P2_D: "Penskalaan kecepatan pemutaran animasi",
  T_48_META_API_3100_P3_D: "Jenis loop, Anda dapat mempertahankan logika asli animasi, memutarnya hanya sekali atau memutarnya dalam satu putaran",
  T_48_META_API_3101_D: "Mainkan animasi karakter dan dukung sumber daya animasi khusus",
  T_48_META_API_3101_P0_D: "pemain sasaran",
  T_48_META_API_3101_P1_D: "ID sumber daya animasi khusus",
  T_48_META_API_3101_P2_D: "Apakah akan mengulang",
  T_48_META_API_3102_D: "Tetapkan sumber daya karakter pemain yang ditentukan",
  T_48_META_API_3102_P0_D: "pemain sasaran",
  T_48_META_API_3102_P1_D: "ID sumber daya peran khusus",
  T_48_META_API_3109_D: "Nyalakan area aman yang akan bergerak lancar menuju titik akhir",
  T_48_META_API_3109_P0_D: "Posisi awal zona aman",
  T_48_META_API_3109_P1_D: "Posisi akhir zona aman",
  T_48_META_API_3109_P2_D: "Radius awal zona aman",
  T_48_META_API_3109_P3_D: "radius akhir zona aman",
  T_48_META_API_3109_P4_D: "Waktu yang dibutuhkan zona aman untuk mencapai kondisi akhirnya, dalam hitungan detik",
  T_48_META_API_3109_P5_D: "Jumlah kerusakan yang terjadi per detik di luar zona aman",
  T_48_META_API_3110_D: "Ganti grup penampilan karakter",
  T_48_META_API_3110_P0_D: "Target",
  T_48_META_API_3110_P1_D: "kelompok penampilan",
  T_48_META_API_3111_D: "Tampilkan grup penampilan karakter",
  T_48_META_API_3111_P0_D: "Target",
  T_48_META_API_3111_P1_D: "kelompok penampilan",
  T_48_META_API_3112_D: "Sembunyikan grup penampilan karakter",
  T_48_META_API_3112_P0_D: "Target",
  T_48_META_API_3112_P1_D: "kelompok penampilan",
  T_48_META_API_3121_D: "Kirim hasil pernyataan ke penggunaan statistik PC Craftland Studio",
  T_48_META_API_3121_P0_D: "ekspresi penegasan",
  T_48_META_API_3121_P1_D: "petunjuk",
  T_48_META_API_32_D: "Dapatkan data token pemain hari ini",
  T_48_META_API_32_P0_D: "pemain sasaran",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Jumlah token",
  T_48_META_API_32_P3_D: "Apakah primitif berhasil dipanggil",
  T_48_META_API_3200_D: "Tambahkan item ke pemain dan kembalikan daftar item yang dikeluarkan",
  T_48_META_API_3200_P0_D: "pemain",
  T_48_META_API_3200_P1_D: "ID barang",
  T_48_META_API_3200_P2_D: "Kuantitas barang",
  T_48_META_API_3200_P3_D: "Daftar item yang ditambahkan untuk pemain, dikembalikan sebagai daftar meskipun hanya satu item yang ditambahkan",
  T_48_META_API_3201_D: "Mengembalikan volume darah pemain yang ditentukan tanpa melebihi batas atas volume darah.",
  T_48_META_API_3201_P0_D: "pemain sasaran",
  T_48_META_API_3201_P1_D: "Nilai penambahan darah pada pemain. Hanya angka positif yang diterima.",
  T_48_META_API_3202_D: "Tetapkan daftar keterampilan pemain target",
  T_48_META_API_3202_P0_D: "pemain sasaran",
  T_48_META_API_3202_P1_D: "Daftar keterampilan",
  T_48_META_API_3203_D: "Dapatkan daftar keterampilan pemain target",
  T_48_META_API_3203_P0_D: "pemain sasaran",
  T_48_META_API_3203_R_D: "Daftar keterampilan",
  T_48_META_API_3205_D: "Hapus sejumlah item tertentu dari pemain",
  T_48_META_API_3205_P0_D: "pemain sasaran",
  T_48_META_API_3205_P1_D: "Jenis item yang akan dihapus",
  T_48_META_API_3205_P2_D: "Jumlah yang akan dihapus, jika melebihi jumlah yang dimiliki pemain, hanya item yang disimpan yang akan dihapus.",
  T_48_META_API_3206_D: "Dapatkan jumlah item tertentu yang dipegang oleh pemain",
  T_48_META_API_3206_P0_D: "pemain sasaran",
  T_48_META_API_3206_P1_D: "Jenis barang",
  T_48_META_API_3206_R_D: "Jumlah yang dipegang oleh pemain",
  T_48_META_API_3207_D: "Periksa apakah pemain dapat memicu pos pemeriksaan saat ini",
  T_48_META_API_3207_P0_D: "pemain sasaran",
  T_48_META_API_3207_P1_D: "Pemicu",
  T_48_META_API_3207_R_D: "Benar: dapat dipicu, Salah: tidak dapat dipicu",
  T_48_META_API_3208_D: "Evolusi zombie mode infeksi",
  T_48_META_API_3208_P0_D: "pemain sasaran",
  T_48_META_API_3209_D: "Entitas AI menghentikan/menjalankan pohon perilaku default",
  T_48_META_API_3209_P0_D: "Untuk mengaktifkan tujuan pohon perilaku",
  T_48_META_API_3209_P1_D: "Apakah akan menjalankan pohon perilaku default",
  T_48_META_API_3210_D: "Entitas AI mengejar target yang ditentukan",
  T_48_META_API_3210_P0_D: "Entitas AI yang melakukan pengejaran",
  T_48_META_API_3210_P1_D: "Target yang dikejar",
  T_48_META_API_3211_D: "Hancurkan item pemain (tidak digunakan lagi, gunakan DeleteEquipment)",
  T_48_META_API_3211_P0_D: "Pemain yang itemnya dihancurkan",
  T_48_META_API_3211_P1_D: "Jenis barang yang hancur",
  T_48_META_API_3211_P2_D: "Slot senjata, hanya efektif untuk senjata",
  T_48_META_API_3212_D: "Ganti baju kaos",
  T_48_META_API_3212_P0_D: "pemain sasaran",
  T_48_META_API_3212_P1_D: "Gaya pakaian",
  T_48_META_API_3212_P2_D: "warna utama satu",
  T_48_META_API_3212_P3_D: "Warna utama dua",
  T_48_META_API_3212_P4_D: "Konfigurasi",
  T_48_META_API_3213_D: "Mengembalikan jersey pemain ke keadaan semula",
  T_48_META_API_3213_P0_D: "pemain sasaran",
  T_48_META_API_3214_D: "Mengaktifkan dan menonaktifkan obrolan suara pemutar",
  T_48_META_API_3214_P0_D: "pemain sasaran",
  T_48_META_API_3214_P1_D: "Apakah akan mematikan obrolan suara, Benar: mematikan Salah: menghidupkan",
  T_48_META_API_3215_D: "Ganti obrolan cepat pemain",
  T_48_META_API_3215_P0_D: "pemain sasaran",
  T_48_META_API_3215_P1_D: "Apakah akan menutup obrolan cepat, Benar: tutup Salah: terbuka",
  T_48_META_API_3216_D: "Atur apakah pemain target dapat mengambil item",
  T_48_META_API_3216_P0_D: "pemain sasaran",
  T_48_META_API_3216_P1_D: "Apakah akan melarang pengambilan barang, Benar: Dilarang mengambil barang, Salah: Dapat diambil",
  T_48_META_API_3217_D: "Atur apakah pemain target dapat menjatuhkan item",
  T_48_META_API_3217_P0_D: "pemain sasaran",
  T_48_META_API_3217_P1_D: "Apakah melarang menjatuhkan barang, benar: dilarang mengambil, salah: dapat diambil",
  T_48_META_API_3218_D: "Hancurkan senjata di slot yang ditentukan pemain",
  T_48_META_API_3218_P0_D: "pemain sasaran",
  T_48_META_API_3218_P1_D: "Slot senjata untuk dihancurkan",
  T_48_META_API_3218_P2_D: "kuantitas yang harus dimusnahkan",
  T_48_META_API_3218_P3_D: "Berhasil atau tidaknya dihancurkan. Jika tidak ada senjata yang dipasang di slot senjata, penghancurannya akan gagal.",
  T_48_META_API_3219_D: "Hapus semua item dari ransel pemain target, termasuk item yang dilengkapi",
  T_48_META_API_3219_P0_D: "pemain sasaran",
  T_48_META_API_3220_D: "Atur orientasi pemain",
  T_48_META_API_3220_P0_D: "pemain sasaran",
  T_48_META_API_3220_P1_D: "Arah pemain",
  T_48_META_API_3221_D: "(Tidak digunakan lagi, mohon jangan digunakan. Untuk informasi terkait, lihat atribut <Player>:Skeleton)",
  T_48_META_API_3221_P0_D: "entitas pemain",
  T_48_META_API_3221_P1_D: "bagian pembesaran",
  T_48_META_API_3221_P2_D: "nilai zoom",
  T_48_META_API_3222_D: "Berikan efek penghambat kepada pemain, pemain target akan jatuh dengan akselerasi yang tetap, dan efek penghambat akan dihentikan secara paksa saat tabrakan di udara",
  T_48_META_API_3222_P0_D: "pemain sasaran",
  T_48_META_API_3222_P1_D: "Arah terbang",
  T_48_META_API_3222_P2_D: "Durasi knock-up",
  T_48_META_API_3222_P3_D: "Kecepatan awal sumbu Y saat terbang",
  T_48_META_API_3222_P4_D: "Kecepatan awal pesawat XZ saat terbang",
  T_48_META_API_3222_P5_D: "Apakah akan mengubah orientasi pemain",
  T_48_META_API_3223_D: "Dapatkan ID pakaian pemain atau NPC target",
  T_48_META_API_3223_P0_D: "Pemain target atau NPC",
  T_48_META_API_3223_P1_D: "jenis pakaian",
  T_48_META_API_3223_R_D: "ID Pakaian",
  T_48_META_API_3224_D: "Tetapkan ID pakaian pemain atau NPC target",
  T_48_META_API_3224_P0_D: "Pemain target atau NPC",
  T_48_META_API_3224_P1_D: "ID Pakaian",
  T_48_META_API_3225_D: "Mengembalikan pakaian default pemain target, yang tidak dapat diterapkan pada NPC.",
  T_48_META_API_3225_P0_D: "pemain sasaran",
  T_48_META_API_3226_D: "Entitas AI menyerang target yang ditentukan",
  T_48_META_API_3226_P0_D: "Entitas AI yang melakukan serangan",
  T_48_META_API_3226_P1_D: "sasaran serangan",
  T_48_META_API_3227_D: "Ganti senjata pemain ke senjata di slot yang ditentukan",
  T_48_META_API_3227_P0_D: "pemain sasaran",
  T_48_META_API_3227_P1_D: "Slot senjata untuk beralih",
  T_48_META_API_3227_P2_D: "Apakah peralihannya berhasil atau tidak. Jika tidak ada senjata yang dipasang di slot senjata, peralihannya akan gagal.",
  T_48_META_API_3228_D: "Dapatkan skin senjata pemain atau NPC target",
  T_48_META_API_3228_P0_D: "Pemain target atau NPC",
  T_48_META_API_3228_P1_D: "ID kulit senjata",
  T_48_META_API_3228_R_D: "ID kulit senjata",
  T_48_META_API_3229_D: "Atur skin senjata pemain atau NPC target",
  T_48_META_API_3229_P0_D: "Pemain target atau NPC",
  T_48_META_API_3229_P1_D: "ID kulit senjata",
  T_48_META_API_3230_D: "Mengembalikan skin senjata default pemain target, yang tidak dapat diterapkan ke NPC.",
  T_48_META_API_3230_P0_D: "pemain sasaran",
  T_48_META_API_3230_P1_D: "ID senjata",
  T_48_META_API_3231_D: "Siapkan pakaian pemain",
  T_48_META_API_3231_P0_D: "pemain sasaran",
  T_48_META_API_3231_P1_D: "Daftar pakaian",
  T_48_META_API_3232_D: "Menghapus semua pakaian dengan jenis pakaian tertentu dari pemain atau NPC target",
  T_48_META_API_3232_P0_D: "Pemain target atau NPC",
  T_48_META_API_3232_P1_D: "jenis pakaian",
  T_48_META_API_3233_D: "Hapus skin senjata yang ditentukan pemain atau NPC",
  T_48_META_API_3233_P0_D: "Pemain target atau NPC",
  T_48_META_API_3233_P1_D: "ID senjata",
  T_48_META_API_3234_D: "Tambahkan buff ke target",
  T_48_META_API_3234_P0_D: "Entitas target harus merupakan entitas yang dapat menambahkan Buff",
  T_48_META_API_3234_P1_D: "ID penggemar",
  T_48_META_API_3235_D: "Hapus buff dari target",
  T_48_META_API_3235_P0_D: "Entitas target harus merupakan entitas yang dapat menambahkan Buff",
  T_48_META_API_3235_P1_D: "ID penggemar",
  T_48_META_API_3236_D: "Dapatkan Buff target saat ini",
  T_48_META_API_3236_P0_D: "Entitas target harus merupakan entitas yang dapat menambahkan Buff",
  T_48_META_API_3236_R_D: "Daftar penggemar",
  T_48_META_API_3237_D: "Dapatkan item di inventaris ransel pemain target",
  T_48_META_API_3237_P0_D: "pemain sasaran",
  T_48_META_API_3237_P1_D: "Daftar alat peraga",
  T_48_META_API_3238_D: "Tambahkan aksesori ke senjata di slot yang ditentukan. Aksesori yang tidak cocok dengan slot tidak akan ditambahkan; aksesori yang cocok tetapi aksesori duplikat akan menggantikan aksesori asli. Aksesori asli akan dikirim ke ransel pemain saat ransel pema",
  T_48_META_API_3238_P0_D: "pemain sasaran",
  T_48_META_API_3238_P1_D: "Slot peralatan",
  T_48_META_API_3238_P2_D: "Aksesoris",
  T_48_META_API_3238_P3_D: `Apakah aksesori berhasil ditambahkan
Benar: Aksesori telah dipasang pada senjata di slot yang sesuai
Salah: Aksesori gagal ditambahkan dan tidak akan muncul di ransel pemain`,
  T_48_META_API_3238_P4_D: "Aksesori ditambahkan, kosongkan jika gagal",
  T_48_META_API_3239_D: "Dapatkan perlengkapannya di kolom perlengkapan ransel",
  T_48_META_API_3239_P0_D: "pemain sasaran",
  T_48_META_API_3239_P1_D: "Slot peralatan",
  T_48_META_API_3239_P2_D: "Peralatan di slot yang ditentukan. Jika tidak ada peralatan, maka akan kosong.",
  T_48_META_API_3239_P3_D: "Semua aksesori untuk peralatan ini",
  T_48_META_API_3240_D: "Ambil komponen X dari vektor dua dimensi",
  T_48_META_API_3240_P0_D: "vektor 2D",
  T_48_META_API_3240_R_D: "Komponen vektor X dua dimensi",
  T_48_META_API_3241_D: "Ambil komponen Y dari vektor dua dimensi",
  T_48_META_API_3241_P0_D: "vektor 2D",
  T_48_META_API_3241_R_D: "Komponen vektor Y dua dimensi",
  T_48_META_API_3242_D: "Vektor 2D menetapkan komponen X",
  T_48_META_API_3242_P0_D: "vektor 2D",
  T_48_META_API_3242_P1_D: "Komponen vektor X dua dimensi",
  T_48_META_API_3243_D: "Vektor 2D menetapkan komponen Y",
  T_48_META_API_3243_P0_D: "vektor 2D",
  T_48_META_API_3243_P1_D: "Komponen vektor Y dua dimensi",
  T_48_META_API_3244_D: "Tambahkan dua vektor 2D",
  T_48_META_API_3244_P0_D: "Kiri",
  T_48_META_API_3244_P1_D: "Kanan",
  T_48_META_API_3244_R_D: "Hasil penjumlahan vektor dua dimensi",
  T_48_META_API_3245_D: "Kurangi dua vektor 2D",
  T_48_META_API_3245_P0_D: "Kiri",
  T_48_META_API_3245_P1_D: "Kanan",
  T_48_META_API_3245_R_D: "Hasil pengurangan vektor dua dimensi",
  T_48_META_API_3246_D: "Kalikan vektor dua dimensi",
  T_48_META_API_3246_P0_D: "vektor 2D",
  T_48_META_API_3246_P1_D: "Nilai penskalaan vektor 2D",
  T_48_META_API_3246_R_D: "Hasil perkalian vektor dua dimensi",
  T_48_META_API_3247_D: "Perkalian titik dua vektor dua dimensi. Hasil perkalian titik adalah skalar yang menyatakan sudut antara dua vektor.",
  T_48_META_API_3247_P0_D: "Kiri",
  T_48_META_API_3247_P1_D: "Kanan",
  T_48_META_API_3247_R_D: "Hasil perkalian titik",
  T_48_META_API_3248_D: "Hitung jarak Euclidean dari dua vektor 2D",
  T_48_META_API_3248_P0_D: "Kiri",
  T_48_META_API_3248_P1_D: "Kanan",
  T_48_META_API_3248_R_D: "Setelah mengurangkan dua vektor, modulus panjang vektor yang dihasilkan",
  T_48_META_API_3249_D: "Hitung sudut antara dua vektor dua dimensi",
  T_48_META_API_3249_P0_D: "Kiri",
  T_48_META_API_3249_P1_D: "Kanan",
  T_48_META_API_3249_R_D: "Sudut vektor, rentang sudut 0-180",
  T_48_META_API_3250_D: "Menormalkan vektor 2D",
  T_48_META_API_3250_P0_D: "vektor 2D",
  T_48_META_API_3250_R_D: "Hasil normalisasinya berupa vektor dengan panjang 1 meter searah.",
  T_48_META_API_3251_D: "Modulo vektor dua dimensi",
  T_48_META_API_3251_P0_D: "vektor 2D",
  T_48_META_API_3251_R_D: "Hasil modulonya adalah panjang vektor",
  T_48_META_API_3252_D: "Hitung vektor vektor dua dimensi yang dipantulkan oleh garis lurus vertikal normal",
  T_48_META_API_3252_P0_D: "Vektor 2D insiden",
  T_48_META_API_3252_P1_D: "Vektor 2D biasa",
  T_48_META_API_3252_R_D: "Refleksi vektor 2D",
  T_48_META_API_3253_D: "Hitung vektor vektor tiga dimensi yang dipantulkan oleh bidang yang tegak lurus garis normal",
  T_48_META_API_3253_P0_D: "Insiden vektor tiga dimensi",
  T_48_META_API_3253_P1_D: "Vektor 3D biasa",
  T_48_META_API_3253_R_D: "Refleksi vektor 3D",
  T_48_META_API_3254_D: "Ubah vektor tiga dimensi menjadi vektor dua dimensi dan hapus komponen Z dari vektor tiga dimensi",
  T_48_META_API_3254_P0_D: "Targetkan vektor 3D",
  T_48_META_API_3254_R_D: "Mengonversi vektor dua dimensi",
  T_48_META_API_3255_D: "Ubah vektor dua dimensi menjadi vektor tiga dimensi, dan atur komponen Z dari vektor tiga dimensi menjadi 0",
  T_48_META_API_3255_P0_D: "Targetkan vektor 2D",
  T_48_META_API_3255_R_D: "Mengonversi vektor tiga dimensi",
  T_48_META_API_3256_D: "Buat vektor 2D",
  T_48_META_API_3256_P0_D: "Komponen X dari vektor dua dimensi",
  T_48_META_API_3256_P1_D: "Komponen Y dari vektor dua dimensi",
  T_48_META_API_3256_R_D: "Vektor dua dimensi dibuat",
  T_48_META_API_3257_D: "Sesuaikan log poin kompetisi untuk analisis data pengalaman pengguna",
  T_48_META_API_3257_P0_D: "mencatat",
  T_48_META_API_3258_D: "Sesuaikan log poin kompetisi untuk analisis data pengalaman pengguna",
  T_48_META_API_3258_P0_D: "Pemain yang akan dilaporkan",
  T_48_META_API_3258_P1_D: "mencatat",
  T_48_META_API_33_D: "Filter kata kotor",
  T_48_META_API_33_P0_D: "Teks asli yang perlu disaring kata-kata kotor",
  T_48_META_API_33_R_D: "teks yang difilter",
  T_48_META_API_3301_D: "Buat entitas kamp",
  T_48_META_API_3301_P0_D: "Entitas faksi",
  T_48_META_API_3302_D: "Entitas target bergabung dengan kubu yang ditentukan",
  T_48_META_API_3302_P0_D: "entitas sasaran",
  T_48_META_API_3302_P1_D: "Entitas faksi",
  T_48_META_API_3303_D: "Dapatkan kamp yang bisa diserang di kamp",
  T_48_META_API_3303_P0_D: "Menyerang kamp",
  T_48_META_API_3303_R_D: "Daftar entitas faksi",
  T_48_META_API_3304_D: "Tetapkan kamp yang bisa diserang",
  T_48_META_API_3304_P0_D: "Menyerang kamp",
  T_48_META_API_3304_P1_D: "kamp sasaran",
  T_48_META_API_3304_P2_D: "Apakah itu bisa diserang?",
  T_48_META_API_3305_D: "Bersiaplah untuk menyerang pemain",
  T_48_META_API_3305_P0_D: "pemain",
  T_48_META_API_3305_P1_D: "Dapat menyerang pemain",
  T_48_META_API_3305_P2_D: "Apakah itu bisa diserang?",
  T_48_META_API_3306_D: "Tetapkan tim tim yang dapat diserang",
  T_48_META_API_3306_P0_D: "tim penyerang",
  T_48_META_API_3306_P1_D: "tim sasaran",
  T_48_META_API_3306_P2_D: "Apakah itu bisa diserang?",
  T_48_META_API_3307_D: "Tidak digunakan lagi",
  T_48_META_API_3307_P0_D: "Tidak digunakan lagi",
  T_48_META_API_3307_R_D: "Daftar entitas pemain",
  T_48_META_API_3308_D: "Entitas tertentu keluar dari kamp saat ini",
  T_48_META_API_3308_P0_D: "entitas sasaran",
  T_48_META_API_3309_D: "Dapatkan faksi target",
  T_48_META_API_3309_P0_D: "entitas sasaran",
  T_48_META_API_3309_R_D: "Entitas faksi",
  T_48_META_API_3310_D: "Tentukan apakah target dapat diserang",
  T_48_META_API_3310_P0_D: "penyerang",
  T_48_META_API_3310_P1_D: "entitas sasaran",
  T_48_META_API_3310_R_D: "Apakah itu bisa diserang?",
  T_48_META_API_3311_D: "Tetapkan target yang dapat diserang untuk entitas",
  T_48_META_API_3311_P0_D: "penyerang",
  T_48_META_API_3311_P1_D: "entitas sasaran",
  T_48_META_API_3311_P2_D: "Apakah itu bisa diserang?",
  T_48_META_API_3312_D: "Mendapatkan target yang dapat diserang dari suatu entitas",
  T_48_META_API_3312_P0_D: "penyerang",
  T_48_META_API_3312_R_D: "Daftar entitas yang dapat diserang",
  T_48_META_API_34_D: "Tentukan apakah entitas target memiliki komponen",
  T_48_META_API_34_P0_D: "entitas sasaran",
  T_48_META_API_34_P1_D: "Jenis komponen",
  T_48_META_API_34_R_D: "Apakah itu ada",
  T_48_META_API_35_D: "Tambahkan Bot",
  T_48_META_API_35_P0_D: "Tingkat kesulitan bot",
  T_48_META_API_35_P1_D: "Tim milik Bot",
  T_48_META_API_35_P2_D: "Entitas pemain Bot yang dibuat",
  T_48_META_API_3500_D: "Dapatkan data token pemain",
  T_48_META_API_3500_P0_D: "pemain sasaran",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Jumlah token",
  T_48_META_API_3500_P3_D: "Apakah ini berhasil?",
  T_48_META_API_3501_D: "Tambahkan data token ke pemain",
  T_48_META_API_3501_P0_D: "pemain sasaran",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Jumlah token",
  T_48_META_API_3501_P3_D: "Apakah primitif berhasil dipanggil",
  T_48_META_API_3502_D: "Konsumsi token pemain target",
  T_48_META_API_3502_P0_D: "pemain sasaran",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Jumlah token",
  T_48_META_API_3502_P3_D: "Apakah primitif berhasil dipanggil",
  T_48_META_API_3503_D: "Tambahkan token di lokasi yang ditentukan",
  T_48_META_API_3503_P0_D: "Lokasi",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Jumlah token",
  T_48_META_API_3503_P3_D: "Apakah primitif berhasil dipanggil",
  T_48_META_API_3504_D: "Target AI melepaskan keterampilan tertentu",
  T_48_META_API_3504_P0_D: "Sasaran AI",
  T_48_META_API_3504_P1_D: "Keahlian",
  T_48_META_API_3504_P2_D: "Sasaran keterampilan",
  T_48_META_API_3504_P3_D: "Apakah skill tersebut berhasil dilepaskan",
  T_48_META_API_3505_D: "Buat jalur pencarian jalan dari titik awal hingga titik akhir, yang akan melewati rintangan dan dapat digunakan untuk pencarian jalur AI.",
  T_48_META_API_3505_P0_D: "Koordinat titik awal",
  T_48_META_API_3505_P1_D: "Koordinat titik akhir",
  T_48_META_API_3505_P2_D: "Apakah jalur perintisan berhasil dilakukan",
  T_48_META_API_3505_P3_D: "pengumpulan titik pencarian jalan",
  T_48_META_API_3506_D: "Tetapkan variabel papan tulis pohon perilaku",
  T_48_META_API_3506_P0_D: "pohon perilaku target",
  T_48_META_API_3506_P1_D: "nama variabel",
  T_48_META_API_3506_P2_D: "nilai variabel",
  T_48_META_API_3507_D: "Dapatkan variabel papan tulis pohon perilaku",
  T_48_META_API_3507_P0_D: "pohon perilaku target",
  T_48_META_API_3507_P1_D: "nama variabel",
  T_48_META_API_3507_P2_D: "nilai variabel",
  T_48_META_API_3508_D: "Dapatkan parameter simpul pohon perilaku",
  T_48_META_API_3508_P0_D: "simpul pohon perilaku target",
  T_48_META_API_3508_P1_D: "Nama parameter",
  T_48_META_API_3508_P2_D: "Nilai parameter",
  T_48_META_API_3509_D: "Dapatkan skin kendaraan pemain incaran",
  T_48_META_API_3509_P0_D: "pemain sasaran",
  T_48_META_API_3509_P1_D: "ID Kendaraan",
  T_48_META_API_3509_R_D: "kulit kendaraan",
  T_48_META_API_3510_D: "Atur skin kendaraan pemain target",
  T_48_META_API_3510_P0_D: "pemain sasaran",
  T_48_META_API_3510_P1_D: "ID kulit kendaraan",
  T_48_META_API_3511_D: "Bersihkan kulit kendaraan yang ditentukan oleh pemain target",
  T_48_META_API_3511_P0_D: "pemain sasaran",
  T_48_META_API_3511_P1_D: "ID Kendaraan",
  T_48_META_API_3512_D: "Kembalikan skin kendaraan default pemain target",
  T_48_META_API_3512_P0_D: "pemain sasaran",
  T_48_META_API_3512_P1_D: "ID Kendaraan",
  T_48_META_API_36_D: "Target tidur, hanya dapat digunakan untuk benda tegar tipe Dinamis",
  T_48_META_API_36_P0_D: "sasaran benda tegar",
  T_48_META_API_37_D: "Bangunkan target, hanya dapat digunakan untuk objek tipe Rigid Body",
  T_48_META_API_37_P0_D: "sasaran benda tegar",
  T_48_META_API_38_D: "Periksa apakah tubuh kaku target sedang tidur",
  T_48_META_API_38_P0_D: "sasaran benda tegar",
  T_48_META_API_38_R_D: "Apakah itu sedang tidur",
  T_48_META_API_39_D: "Tetapkan ambang batas tidur",
  T_48_META_API_39_P0_D: "sasaran benda tegar",
  T_48_META_API_39_P1_D: "Ambang batas tidur. Benda tegar memasuki kondisi tidur setelah pergerakan dan rotasinya kurang dari nilai ini selama jangka waktu tertentu. Benda tegar dalam keadaan tidur tidak lagi melakukan perhitungan fisik.",
  T_48_META_API_4_D: "Atur apakah semua pemain bisa bergerak",
  T_48_META_API_4_P0_D: `Benar: dapat dipindahkan
Salah: tidak dapat dipindahkan`,
  T_48_META_API_40_D: "Dapatkan ambang batas tidur",
  T_48_META_API_40_P0_D: "sasaran benda tegar",
  T_48_META_API_40_R_D: "Ambang batas tidur. Benda tegar memasuki kondisi tidur setelah pergerakan dan rotasinya kurang dari nilai ini selama jangka waktu tertentu. Benda tegar dalam keadaan tidur tidak lagi melakukan perhitungan fisik.",
  T_48_META_API_4000_D: "Baca isi seluruh tabel dan kembalikan array dua dimensi dalam urutan baris.",
  T_48_META_API_4000_P0_D: "nama tabel",
  T_48_META_API_4000_R_D: "isi tabel",
  T_48_META_API_4001_D: "Baca konten baris tabel dan kembalikan array",
  T_48_META_API_4001_P0_D: "nama tabel",
  T_48_META_API_4001_P1_D: "Jumlah baris yang akan dibaca, mulai dari 1",
  T_48_META_API_4001_R_D: "Tabel menentukan isi suatu baris",
  T_48_META_API_4002_D: "Baca isi kolom tabel dan kembalikan array",
  T_48_META_API_4002_P0_D: "nama tabel",
  T_48_META_API_4002_P1_D: "Jumlah kolom yang akan dibaca, mulai dari 1",
  T_48_META_API_4002_R_D: "Tabel menentukan isi kolom",
  T_48_META_API_4003_D: "Membaca isi sel tabel",
  T_48_META_API_4003_P0_D: "nama tabel",
  T_48_META_API_4003_P1_D: "Jumlah baris yang akan dibaca, mulai dari 1",
  T_48_META_API_4003_P2_D: "Jumlah kolom yang akan dibaca, mulai dari 1",
  T_48_META_API_4003_R_D: "Isi sel tertentu dalam tabel",
  T_48_META_API_4004_D: "Membaca isi sel tertentu dalam tabel berdasarkan nomor baris dan nama kolom",
  T_48_META_API_4004_P0_D: "nama tabel",
  T_48_META_API_4004_P1_D: "Jumlah baris yang akan dibaca, mulai dari 1",
  T_48_META_API_4004_P2_D: "Nama kolom untuk dibaca",
  T_48_META_API_4004_R_D: "Isi sel tertentu dalam tabel",
  T_48_META_API_4005_D: "Baca isi seluruh tabel dan kembalikan array dua dimensi",
  T_48_META_API_4005_P0_D: "nama tabel",
  T_48_META_API_4005_R_D: "Isi tabel, array dua dimensi",
  T_48_META_API_4006_D: "Baca konten baris tertentu dari seluruh tabel dan kembalikan array",
  T_48_META_API_4006_P0_D: "nama tabel",
  T_48_META_API_4006_P1_D: "Jumlah baris yang akan dibaca, mulai dari 1",
  T_48_META_API_4006_R_D: "Tabel menentukan isi baris, array",
  T_48_META_API_4007_D: "Baca konten kolom dari seluruh tabel dan kembalikan array",
  T_48_META_API_4007_P0_D: "nama tabel",
  T_48_META_API_4007_P1_D: "Jumlah kolom yang akan dibaca, mulai dari 1",
  T_48_META_API_4007_R_D: "Tabel menentukan isi kolom, array",
  T_48_META_API_4008_D: "Membaca isi sel tabel",
  T_48_META_API_4008_P0_D: "nama tabel",
  T_48_META_API_4008_P1_D: "Jumlah baris yang akan dibaca, mulai dari 1",
  T_48_META_API_4008_P2_D: "Jumlah kolom yang akan dibaca, mulai dari 1",
  T_48_META_API_4008_R_D: "Isi sel tertentu dalam tabel",
  T_48_META_API_4009_D: "Temukan baris yang ditentukan berdasarkan nomor kolom dan nilai sel",
  T_48_META_API_4009_P0_D: "nama tabel",
  T_48_META_API_4009_P1_D: "Jumlah kolom yang akan dibaca",
  T_48_META_API_4009_P2_D: "Nilai sel yang ingin ditemukan",
  T_48_META_API_4009_R_D: "Isi baris yang ditemukan, larik",
  T_48_META_API_4010_D: "Dapatkan nomor kolom berdasarkan nama kolom",
  T_48_META_API_4010_P0_D: "nama tabel",
  T_48_META_API_4010_P1_D: "Nama kolom untuk memeriksa nomor seri",
  T_48_META_API_4010_R_D: "Jumlah kolom, dihitung dari 1",
  T_48_META_API_41_D: "Tetapkan ambang batas tidur global, yang hanya berlaku untuk benda tegar tipe Dinamis yang baru dibuat.",
  T_48_META_API_41_P0_D: "Ambang batas tidur. Benda tegar memasuki kondisi tidur setelah pergerakan dan rotasinya kurang dari nilai ini selama jangka waktu tertentu. Benda tegar dalam keadaan tidur tidak lagi melakukan perhitungan fisik.",
  T_48_META_API_42_D: "Dapatkan ambang batas tidur global",
  T_48_META_API_42_R_D: "Ambang batas tidur, defaultnya adalah 0,005. Benda tegar akan memasuki kondisi tidur setelah gerakan dan rotasi kurang dari nilai ini untuk jangka waktu tertentu.",
  T_48_META_API_43_D: "Ubah angka empat yang diberikan menjadi sudut Euler. Urutan rotasi sudut Euler adalah YXZ. Jika angka empat yang diteruskan tidak sah, kembalikan (0,0,0)",
  T_48_META_API_43_P0_D: "Masukkan angka empat",
  T_48_META_API_43_R_D: "Sudut Euler yang dikembalikan",
  T_48_META_API_44_D: "Ubah sudut Euler yang diberikan menjadi angka empat",
  T_48_META_API_44_P0_D: "Masukkan sudut Euler",
  T_48_META_API_44_R_D: "Angka empat kembali",
  T_48_META_API_45_D: "Ubah rotasi yang diwakili oleh sudut sumbu menjadi angka empat",
  T_48_META_API_45_P0_D: "sumbu rotasi",
  T_48_META_API_45_P1_D: "Sudut putaran searah jarum jam pada sumbu putaran",
  T_48_META_API_45_R_D: "Angka empat kembali",
  T_48_META_API_46_D: "Ubah angka empat menjadi representasi sudut sumbu",
  T_48_META_API_46_P0_D: "Masukkan angka empat",
  T_48_META_API_46_P1_D: "sumbu rotasi",
  T_48_META_API_46_P2_D: "Sudut putaran searah jarum jam pada sumbu putaran",
  T_48_META_API_47_D: "Tetapkan kemajuan penyelesaian tugas khusus",
  T_48_META_API_47_P0_D: "pemain sasaran",
  T_48_META_API_47_P1_D: "ID Tugas",
  T_48_META_API_47_P2_D: "Kemajuan penyelesaian, angka negatif tidak diperbolehkan",
  T_48_META_API_48_D: "Buat kurva Bezier yang dapat digunakan untuk menginterpolasi gerakan",
  T_48_META_API_48_P0_D: "titik kendali kurva",
  T_48_META_API_48_R_D: "Kurva Bezier",
  T_48_META_API_49_D: "Dapatkan ID peta pemandangan",
  T_48_META_API_49_P0_D: "ID Adegan",
  T_48_META_API_49_R_D: "ID Peta",
  T_48_META_API_5_D: "Hapus objek yang ditempatkan di tempat kejadian (usang, silakan gunakan DeleteEntity)",
  T_48_META_API_5_P0_D: "Entitas objek yang akan dihapus",
  T_48_META_API_50_D: "Buat gerakan relatif terhadap dirinya sendiri setiap frame. Entitas target mengubah atributnya sendiri setiap kali frame, dan setiap kali berubah relatif terhadap nilai atributnya saat ini.",
  T_48_META_API_50_P0_D: "entitas sasaran",
  T_48_META_API_50_P1_D: "Atribut yang memerlukan perubahan gerak",
  T_48_META_API_50_P2_D: "jumlah perubahan per gerakan",
  T_48_META_API_50_P3_D: `Konfigurasi bila digunakan bersamaan dengan mode gerakan lain
Benar: Dapat digunakan bersamaan dengan gerakan relatif
Salah: Dapat digunakan bersamaan dengan gerakan absolut`,
  T_48_META_API_50_P4_D: "Relatif Entitas Bergerak PerFrame Diciptakan",
  T_48_META_API_50_P5_D: "Apakah akan mulai memutar secara otomatis setelah pembuatan",
  T_48_META_API_5000_D: "Baca nilai yang sesuai dengan Kunci dalam tabel di database",
  T_48_META_API_5000_P0_D: "nama tabel dalam database",
  T_48_META_API_5000_P1_D: "Tandai pemain dan tangani situasi konkurensi",
  T_48_META_API_5000_P2_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5000_P3_D: "Kembalikan hasil baca",
  T_48_META_API_5000_P4_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5001_D: "Tulis nilai yang sesuai dengan Kunci dalam tabel di database",
  T_48_META_API_5001_P0_D: "nama tabel dalam database",
  T_48_META_API_5001_P1_D: "Tandai pemain dan tangani situasi konkurensi",
  T_48_META_API_5001_P2_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5001_P3_D: "nilai tertulis",
  T_48_META_API_5001_P4_D: "Kode medan perang yang sesuai dengan database, yang dapat diisi kosong, mewakili kode medan perang peta saat ini",
  T_48_META_API_5002_D: "Hapus nilai yang sesuai dengan Kunci tertentu dalam tabel tertentu di database",
  T_48_META_API_5002_P0_D: "nama tabel dalam database",
  T_48_META_API_5002_P1_D: "Tandai pemain dan tangani situasi konkurensi",
  T_48_META_API_5002_P2_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5002_P3_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5003_D: "Baca nilai yang sesuai dengan Kunci dalam tabel peringkat di database",
  T_48_META_API_5003_P0_D: "Nama tabel peringkat dalam database",
  T_48_META_API_5003_P1_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5003_P2_D: "Kembalikan hasil baca",
  T_48_META_API_5003_P3_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5004_D: "Tuliskan nilai yang sesuai dengan Kunci dalam tabel peringkat di database",
  T_48_META_API_5004_P0_D: "Nama tabel peringkat dalam database",
  T_48_META_API_5004_P1_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5004_P2_D: "nilai tertulis",
  T_48_META_API_5004_P3_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5005_D: "Hapus nilai yang sesuai dengan Kunci dalam tabel peringkat di database",
  T_48_META_API_5005_P0_D: "nama tabel dalam database",
  T_48_META_API_5005_P1_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5005_P2_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5006_D: "Hapus nilai yang sesuai dengan peringkat tertentu dalam tabel peringkat di database",
  T_48_META_API_5006_P0_D: "nama tabel dalam database",
  T_48_META_API_5006_P1_D: "Posisi di papan peringkat",
  T_48_META_API_5006_P2_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5007_D: "Baca nilai dari rangking tertentu ke rangking tertentu pada tabel rangking di database",
  T_48_META_API_5007_P0_D: "nama tabel dalam database",
  T_48_META_API_5007_P1_D: "Peringkat awal",
  T_48_META_API_5007_P2_D: "peringkat akhir",
  T_48_META_API_5007_P3_D: "Kembalikan hasil baca",
  T_48_META_API_5007_P4_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5008_D: "Baca nilai yang sesuai dengan Kunci dalam tabel di database kumulatif",
  T_48_META_API_5008_P0_D: "nama tabel dalam database",
  T_48_META_API_5008_P1_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5008_P2_D: "Kembalikan hasil baca",
  T_48_META_API_5008_P3_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_5009_D: "Tulis nilai offset yang sesuai dengan kunci dalam tabel di database kumulatif",
  T_48_META_API_5009_P0_D: "nama tabel dalam database",
  T_48_META_API_5009_P1_D: "Nama khusus yang digunakan untuk mengidentifikasi data",
  T_48_META_API_5009_P2_D: "Empat jenis operasi aritmatika saat ini mendukung tipe berikut: Tipe Int mendukung penjumlahan, pengurangan, perkalian, pembagian, dan sisa; Tipe float mendukung penjumlahan, pengurangan, perkalian, dan pembagian;",
  T_48_META_API_5009_P3_D: "Nilai offset ditulis",
  T_48_META_API_5009_P4_D: "Kode medan pertempuran yang sesuai dengan basis data",
  T_48_META_API_51_D: "Setel ulang entitas yang dapat diputar dan pulihkan entitas yang dapat diputar ke bentuk awalnya tanpa mengubah status pemutaran.",
  T_48_META_API_51_P0_D: "entitas target yang dapat dimainkan",
  T_48_META_API_52_D: "Mengalikan dua angka empat. A*B berarti memutar A terlebih dahulu lalu memutar B. Urutan rotasi yang berbeda akan menghasilkan hasil yang berbeda.",
  T_48_META_API_52_P0_D: "nilai angka empat",
  T_48_META_API_52_P1_D: "nilai angka empat",
  T_48_META_API_52_R_D: "Hasil Quaternion",
  T_48_META_API_53_D: "Membuat angka empat berputar menghadap ke arah yang ditentukan",
  T_48_META_API_53_P0_D: "Tentukan arah",
  T_48_META_API_53_P1_D: "arah ke atas",
  T_48_META_API_53_R_D: "Jumlah rotasi yang diperlukan untuk menyelaraskan ke arah yang ditentukan",
  T_48_META_API_54_D: "Interpolasi bola kuarter dari A ke B",
  T_48_META_API_54_P0_D: "Sebuah nilai",
  T_48_META_API_54_P1_D: "nilai B",
  T_48_META_API_54_P2_D: "Kemajuan interpolasi, rentang nilai [0,1], jika nilainya 0, nilai awal dikembalikan, jika nilainya 1, nilai target dikembalikan",
  T_48_META_API_54_R_D: "angka empat hasil",
  T_48_META_API_57_D: "Cetak data target ke konsol sebagai peringatan",
  T_48_META_API_57_P0_D: "Apa yang perlu dicetak",
  T_48_META_API_58_D: "Cetak data target ke konsol dalam bentuk kesalahan",
  T_48_META_API_58_P0_D: "Apa yang perlu dicetak",
  T_48_META_API_59_D: "Dapatkan nilai pada kurva",
  T_48_META_API_59_P0_D: "melengkung",
  T_48_META_API_59_P1_D: "Titik pengambilan sampel, rentang nilai [0,1]",
  T_48_META_API_59_R_D: "hasil",
  T_48_META_API_6_D: "Buat objek pemandangan ke koordinat yang ditentukan",
  T_48_META_API_6_P0_D: "Entitas objek adegan dibuat",
  T_48_META_API_6_P1_D: "Lokasi di mana objek dihasilkan",
  T_48_META_API_6_P2_D: "Saat menggunakan ID tipe objek yang dibuat dalam skrip kode, Anda perlu mendaftarkan enumerasi objek level dalam pendaftaran aset terlebih dahulu.",
  T_48_META_API_60_D: "Interpolasi dari kurva",
  T_48_META_API_60_P0_D: "tipe nilai",
  T_48_META_API_60_P1_D: "nilai awal",
  T_48_META_API_60_P2_D: "nilai sasaran",
  T_48_META_API_60_P3_D: "melengkung",
  T_48_META_API_60_P4_D: "Titik pengambilan sampel, rentang nilai [0,1]",
  T_48_META_API_60_R_D: "hasil",
  T_48_META_API_6000_D: "Tambahkan skrip untuk entitas target",
  T_48_META_API_6000_P0_D: "entitas sasaran",
  T_48_META_API_6000_P1_D: "ID Skrip",
  T_48_META_API_6001_D: "Copot pemasangan skrip untuk entitas target",
  T_48_META_API_6001_P0_D: "entitas sasaran",
  T_48_META_API_6001_P1_D: "ID Skrip",
  T_48_META_API_6002_D: "Periksa apakah skrip yang ditentukan ada di entitas target",
  T_48_META_API_6002_P0_D: "entitas sasaran",
  T_48_META_API_6002_P1_D: "ID Skrip",
  T_48_META_API_6002_R_D: "Apakah skrip yang ditentukan ada",
  T_48_META_API_61_D: "Tetapkan node induk dari kontrol UI",
  T_48_META_API_61_P0_D: "Node induk, Anda dapat menentukan kontrol UI atau UI khusus",
  T_48_META_API_61_P1_D: "simpul anak",
  T_48_META_API_62_D: "Tidak digunakan lagi",
  T_48_META_API_62_P0_D: "Tidak digunakan lagi",
  T_48_META_API_62_P1_D: "Tidak digunakan lagi",
  T_48_META_API_62_P2_D: "Tidak digunakan lagi",
  T_48_META_API_62_P3_D: "Tidak digunakan lagi",
  T_48_META_API_62_P4_D: "Tidak digunakan lagi",
  T_48_META_API_63_D: "Menciptakan sinar dari kamera saat ini ke titik sentuh layar",
  T_48_META_API_63_P0_D: "titik sentuh layar",
  T_48_META_API_63_P1_D: "titik awal",
  T_48_META_API_63_P2_D: "Arah sinar",
  T_48_META_API_64_D: "Unggah informasi penagihan khusus",
  T_48_META_API_64_P0_D: "entitas pemain",
  T_48_META_API_64_P1_D: "hasil pertandingan",
  T_48_META_API_64_P2_D: "Judul poin",
  T_48_META_API_64_P3_D: "Nilai poin",
  T_48_META_API_65_D: "Mainkan efek suara yang ditentukan. Jika ada lebih banyak properti yang perlu diatur, Anda dapat mengatur properti entitasnya.",
  T_48_META_API_65_P0_D: "Entitas efek suara yang dibuat",
  T_48_META_API_65_P1_D: "Pemain target, hanya pemain target yang dapat mendengar efek suara",
  T_48_META_API_65_P2_D: "Jenis efek suara",
  T_48_META_API_65_P3_D: "Jenis lingkaran",
  T_48_META_API_65_P4_D: "Apakah akan segera diputar",
  T_48_META_API_66_D: "Buat efek visual tertentu. Jika ada lebih banyak properti yang perlu diatur, Anda dapat mengatur properti entitasnya.",
  T_48_META_API_66_P0_D: "Menciptakan entitas efek khusus",
  T_48_META_API_66_P1_D: "Pemain target, hanya pemain target yang terlihat",
  T_48_META_API_66_P2_D: "Jenis efek khusus",
  T_48_META_API_66_P3_D: "Jenis lingkaran",
  T_48_META_API_66_P4_D: "Apakah akan segera diputar",
  T_48_META_API_67_D: "Buat efek suara yang ditentukan. Jika ada lebih banyak properti yang perlu diatur, Anda dapat mengatur properti entitasnya.",
  T_48_META_API_67_P0_D: "Entitas efek suara yang dibuat",
  T_48_META_API_67_P1_D: "Jenis efek suara",
  T_48_META_API_67_P2_D: "Jenis lingkaran",
  T_48_META_API_67_P3_D: "Apakah akan segera diputar",
  T_48_META_API_68_D: "Ubah koordinat dunia menjadi koordinat layar",
  T_48_META_API_68_P0_D: "koordinat dunia",
  T_48_META_API_68_P1_D: "Apakah akan memetakan di layar",
  T_48_META_API_68_P2_D: "Lokasi peta",
  T_48_META_API_69_D: "Ubah koordinat layar menjadi koordinat dunia",
  T_48_META_API_69_P0_D: "koordinat layar",
  T_48_META_API_69_P1_D: "Jarak dari layar",
  T_48_META_API_69_P2_D: "koordinat dunia",
  T_48_META_API_7_D: "Ubah nilai target menjadi string",
  T_48_META_API_7_P0_D: "Nilai target yang akan diubah menjadi string",
  T_48_META_API_7_R_D: "rangkaian",
  T_48_META_API_70_D: "Lakukan deteksi sinar melalui sentuhan layar dan kembalikan entitas hit pertama",
  T_48_META_API_70_P0_D: "Sentuhan layar beranda",
  T_48_META_API_70_P1_D: "Jarak deteksi",
  T_48_META_API_70_P2_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_70_P3_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_70_P4_D: "entitas yang terkena",
  T_48_META_API_70_P5_D: "koordinat titik sasaran",
  T_48_META_API_70_P6_D: "Jarak dari titik pukul ke titik awal",
  T_48_META_API_70_P7_D: "Pukul permukaan normal",
  T_48_META_API_71_D: "Deteksi sinar melalui sentuhan layar, mengembalikan semua entitas yang terkena",
  T_48_META_API_71_P0_D: "Sentuhan layar beranda",
  T_48_META_API_71_P1_D: "Jarak deteksi",
  T_48_META_API_71_P2_D: "Layer mask, hanya lapisan yang terisi saja yang akan berpartisipasi dalam pemindaian, membiarkannya kosong berarti semua lapisan akan berpartisipasi dalam pemindaian",
  T_48_META_API_71_P3_D: "Apakah mungkin untuk mendeteksi pemicunya",
  T_48_META_API_71_P4_D: "daftar entitas yang terkena dampak",
  T_48_META_API_71_P5_D: "Daftar koordinat titik tekan",
  T_48_META_API_71_P6_D: "Daftar jarak antara titik hit dan titik awal",
  T_48_META_API_71_P7_D: "Tekan daftar normal permukaan",
  T_48_META_API_72_D: "Buat efek visual tertentu. Jika ada lebih banyak properti yang perlu diatur, Anda dapat mengatur properti entitasnya.",
  T_48_META_API_72_P0_D: "Menciptakan entitas efek khusus",
  T_48_META_API_72_P1_D: "Jenis efek khusus",
  T_48_META_API_72_P2_D: "Jenis lingkaran",
  T_48_META_API_72_P3_D: "Aktifkan Putar Segera",
  T_48_META_API_73_D: "Buat UI bawaan yang tidak disinkronkan ke klien lain",
  T_48_META_API_73_P0_D: "Membuat entitas UI bawaan",
  T_48_META_API_73_P1_D: "Tipe UI bawaan",
  T_48_META_API_74_D: "Buat UI khusus yang tidak akan disinkronkan ke klien lain",
  T_48_META_API_74_P0_D: "Membuat entitas UI khusus",
  T_48_META_API_74_P1_D: "Indeks UI khusus",
  T_48_META_API_75_D: "Dapatkan pemain yang sesuai dengan klien saat ini",
  T_48_META_API_75_R_D: "entitas pemain",
  T_48_META_API_76_D: "Buat monster AI",
  T_48_META_API_76_P0_D: "Sasaran AI",
  T_48_META_API_76_P1_D: "Buat lokasi",
  T_48_META_API_76_P2_D: "Tipe AI",
  T_48_META_API_76_P3_D: "Tim",
  T_48_META_API_76_P4_D: "Apakah akan mencari musuh secara otomatis",
  T_48_META_API_76_P5_D: "modus serangan",
  T_48_META_API_76_P6_D: "jalur perjalanan",
  T_48_META_API_77_D: "Tetapkan komponen pertama dari vektor",
  T_48_META_API_77_P0_D: "vektor",
  T_48_META_API_77_P1_D: "nilai komponen pertama",
  T_48_META_API_77_R_D: "Vektor setelah memodifikasi komponen pertama",
  T_48_META_API_78_D: "Menetapkan komponen kedua dari vektor",
  T_48_META_API_78_P0_D: "vektor",
  T_48_META_API_78_P1_D: "nilai komponen kedua",
  T_48_META_API_78_R_D: "Vektor setelah memodifikasi komponen kedua",
  T_48_META_API_79_D: "Menetapkan komponen ketiga dari vektor",
  T_48_META_API_79_P0_D: "vektor",
  T_48_META_API_79_P1_D: "Nilai komponen ketiga",
  T_48_META_API_79_R_D: "Vektor setelah memodifikasi komponen ketiga",
  T_48_META_API_8_D: "Nyalakan area aman yang akan menyusut ke titik koordinat pusat",
  T_48_META_API_8_P0_D: "titik tengah zona aman",
  T_48_META_API_8_P1_D: "radius zona aman",
  T_48_META_API_8_P2_D: "Waktu tunggu, dalam hitungan detik, setelah itu zona aman akan mulai mengecil menuju titik tengah",
  T_48_META_API_8_P3_D: "Waktu yang dibutuhkan area aman untuk menyusut ke titik pusat, dalam hitungan detik",
  T_48_META_API_8_P4_D: "Jumlah kerusakan yang terjadi per detik di luar zona aman",
  T_48_META_API_80_D: "Menetapkan komponen pertama dari vektor dua dimensi",
  T_48_META_API_80_P0_D: "vektor 2D",
  T_48_META_API_80_P1_D: "nilai komponen pertama",
  T_48_META_API_80_R_D: "Vektor dua dimensi setelah memodifikasi komponen pertama",
  T_48_META_API_81_D: "Menetapkan komponen kedua dari vektor 2D",
  T_48_META_API_81_P0_D: "vektor 2D",
  T_48_META_API_81_P1_D: "nilai komponen kedua",
  T_48_META_API_81_R_D: "Vektor dua dimensi setelah memodifikasi komponen kedua",
  T_48_META_API_82_D: "Pindahkan pengontrol karakter ke posisi yang ditentukan. Jika mempengaruhi pemain, pemain harus mengaktifkan pengontrol pemain yang menggunakan efek fisik agar dapat diterapkan.",
  T_48_META_API_82_P0_D: "pengontrol karakter target",
  T_48_META_API_82_P1_D: "Tentukan lokasi",
  T_48_META_API_83_D: "Dapatkan simpul anak tertentu dari entitas simpul induk target berdasarkan namanya",
  T_48_META_API_83_P0_D: "entitas simpul induk",
  T_48_META_API_83_P1_D: "Nama simpul anak",
  T_48_META_API_83_R_D: "entitas simpul anak",
  T_48_META_API_84_D: "Tambahkan perhatian khusus AOI, selalu tersinkronisasi tanpa memandang jarak",
  T_48_META_API_84_P0_D: "Sasaran yang menjadi perhatian khusus",
  T_48_META_API_84_P1_D: "pengamat",
  T_48_META_API_85_D: "Hapus perhatian khusus AOI dan batalkan sinkronisasi AOI yang tidak terlihat",
  T_48_META_API_85_P0_D: "Sasaran yang menjadi perhatian khusus",
  T_48_META_API_85_P1_D: "pengamat",
  T_48_META_API_86_D: "Hapus semua AOI dari target yang ditentukan",
  T_48_META_API_86_P0_D: "Sasaran yang menjadi perhatian khusus",
  T_48_META_API_87_D: "Tentukan apakah ada perhatian khusus AOI",
  T_48_META_API_87_P0_D: "Sasaran yang menjadi perhatian khusus",
  T_48_META_API_87_P1_D: "Tidak digunakan lagi",
  T_48_META_API_87_R_D: "Apakah itu ada",
  T_48_META_API_88_D: "Alihkan pengamat proksi pemain",
  T_48_META_API_88_P0_D: "pemain",
  T_48_META_API_88_P1_D: "pengamat proksi",
  T_48_META_API_89_D: "Mengganti pengontrol karakter satu kali. Jika memengaruhi pemain, pemain harus mengaktifkan pengontrol pemain yang menggunakan efek fisik agar dapat diterapkan.",
  T_48_META_API_89_P0_D: "Objek target, jika itu adalah pemain, pemain harus menyalakan pengontrol pemain menggunakan fisika agar efeknya dapat diterapkan",
  T_48_META_API_89_P1_D: "vektor perpindahan",
  T_48_META_API_9_D: "Matikan mekanisme zona aman. Ketika zona aman dikurangi menjadi minimum, pemain di luar zona aman akan terus dirugikan. Setelah mematikan mekanisme zona aman, pemain akan aman kembali.",
  T_48_META_API_90_D: "Atur apakah pemain dapat keluar dengan bebas",
  T_48_META_API_90_P0_D: "pemain sasaran",
  T_48_META_API_90_P1_D: "Apakah mungkin untuk keluar dengan bebas?",
  T_48_META_API_9000_D: "Buat UI bawaan yang hanya dapat dilihat oleh pemain yang ditunjuk",
  T_48_META_API_9000_P0_D: "Membuat entitas UI bawaan",
  T_48_META_API_9000_P1_D: "Entitas pemain yang memiliki UI, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_9000_P2_D: "Tipe UI bawaan",
  T_48_META_API_9001_D: "Hapus UI game bawaan",
  T_48_META_API_9001_P0_D: "Entitas UI bawaan untuk dihapus",
  T_48_META_API_9002_D: "Buat ikon menggunakan jenis ikon yang ditentukan. Jika ada lebih banyak properti yang perlu diatur, atur lebih lanjut properti entitasnya melalui entitas (usang, silakan gunakan CreateLevelObject)",
  T_48_META_API_9002_P0_D: "Kode tersebut digunakan untuk mewakili nama parameter formal yang membuat entitas ikon, dan nilai variabel lokal terkait adalah entitas yang membuat ikon.",
  T_48_META_API_9002_P1_D: "Entitas pemain yang dimilikinya, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_9002_P2_D: "Jalur sumber daya, jalur sumber daya yang sesuai dengan ikon yang dipilih oleh pemain",
  T_48_META_API_9003_D: "Hapus ikon yang ditentukan (tidak digunakan lagi, harap gunakan DeleteEntity)",
  T_48_META_API_9003_P0_D: "Entitas ikon yang akan dihapus",
  T_48_META_API_9004_D: "Buat teks menggunakan konten teks yang ditentukan. Jika ada lebih banyak properti yang perlu diatur, atur lebih lanjut properti entitasnya melalui entitas (usang, silakan gunakan CreateLevelObject)",
  T_48_META_API_9004_P0_D: "Kode ini digunakan untuk mewakili nama parameter formal yang membuat entitas teks, dan nilai variabel lokal terkait adalah entitas yang membuat teks.",
  T_48_META_API_9004_P1_D: "Entitas pemain yang dimilikinya, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_9004_P2_D: "Konten teks yang akan dirender",
  T_48_META_API_9005_D: "Hapus teks tertentu (tidak digunakan lagi, harap gunakan DeleteEntity)",
  T_48_META_API_9005_P0_D: "entitas teks yang akan dihapus",
  T_48_META_API_9006_D: "Buat ikon menggunakan jenis efek yang ditentukan. Jika ada lebih banyak properti yang perlu diatur, atur lebih lanjut properti entitasnya melalui entitas (usang, silakan gunakan CreateEffect)",
  T_48_META_API_9006_P0_D: "Kode tersebut digunakan untuk mewakili nama parameter formal yang menciptakan entitas efek khusus, dan nilai variabel lokal terkait adalah entitas yang menciptakan efek khusus.",
  T_48_META_API_9006_P1_D: "Entitas pemain yang dimilikinya, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_9006_P2_D: "Jenis efek khusus, jenis efek khusus yang dapat dipilih pemain",
  T_48_META_API_9007_D: "Hapus efek yang ditentukan (tidak digunakan lagi, harap gunakan DeleteEntity)",
  T_48_META_API_9007_P0_D: "Entitas efek yang akan dihapus",
  T_48_META_API_9008_D: "Buat UI khusus yang hanya dapat dilihat oleh pemain yang ditunjuk",
  T_48_META_API_9008_P0_D: "Membuat entitas UI khusus",
  T_48_META_API_9008_P1_D: "Entitas pemain yang memiliki UI, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_9008_P2_D: "Indeks UI khusus",
  T_48_META_API_9009_D: "Hapus UI game khusus",
  T_48_META_API_9009_P0_D: "Entitas UI khusus yang akan dihapus",
  T_48_META_API_9010_D: "Dapatkan kontrol UI dari UI khusus",
  T_48_META_API_9010_P0_D: "Entitas pemain yang memiliki UI",
  T_48_META_API_9010_P1_D: "Entitas UI khusus",
  T_48_META_API_9010_P2_D: "mengontrol indeks unik",
  T_48_META_API_9010_R_D: "Entitas kontrol UI",
  T_48_META_API_9011_D: "Mainkan efek suara yang ditentukan. Jika ada lebih banyak properti yang perlu diatur, atur lebih lanjut properti entitasnya melalui entitas (usang, silakan gunakan CreateSound)",
  T_48_META_API_9011_P0_D: "Kode tersebut digunakan untuk mewakili nama parameter formal yang menciptakan entitas efek suara, dan nilai variabel lokal terkait adalah entitas yang menciptakan efek suara.",
  T_48_META_API_9011_P1_D: "Entitas pemain yang dimilikinya, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_9011_P2_D: "Jenis efek suara, jenis efek suara yang dapat dipilih pemain",
  T_48_META_API_9012_D: "Hapus efek suara yang ditentukan (tidak digunakan lagi, harap gunakan DeleteEntity)",
  T_48_META_API_9012_P0_D: "Entitas suara yang akan dihapus",
  T_48_META_API_9013_D: "Dapatkan kontrol UI menggunakan jalur dari UI khusus",
  T_48_META_API_9013_P0_D: "Entitas pemain yang memiliki UI",
  T_48_META_API_9013_P1_D: "UI khusus",
  T_48_META_API_9013_P2_D: "Jalur kendali",
  T_48_META_API_9013_R_D: "Entitas kontrol UI",
  T_48_META_API_9014_D: "Mengganggu entitas suara yang diputar (tidak digunakan lagi, harap gunakan PauseSound)",
  T_48_META_API_9014_P0_D: "Entitas efek suara yang perlu dijeda",
  T_48_META_API_9015_D: "Lanjutkan memutar efek suara, Anda dapat memilih apakah akan mulai memutar dari awal (usang, silakan gunakan ResumeSound)",
  T_48_META_API_9015_P0_D: "Entitas efek suara yang perlu terus diputar setelah dijeda",
  T_48_META_API_9015_P1_D: "Apakah akan memulai dari awal",
  T_48_META_API_9016_D: "Buat kontrol UI khusus",
  T_48_META_API_9016_P0_D: "Entitas kontrol kustom dibuat",
  T_48_META_API_9016_P1_D: "Jenis kontrol yang dibuat",
  T_48_META_API_9016_P2_D: "Milik entitas UI",
  T_48_META_API_9016_P3_D: "Kontrol induk tempatnya. Jika dibiarkan kosong, entitas UI tempatnya akan menjadi simpul induk.",
  T_48_META_API_9017_D: "Tetapkan masker lapisan kamera target",
  T_48_META_API_9017_P0_D: "entitas kamera target",
  T_48_META_API_9017_P1_D: "Layer mask, hanya layer yang terisi saja yang akan ditampilkan di kamera target, membiarkan kosong berarti semua layer akan ditampilkan.",
  T_48_META_API_9018_D: "Dapatkan layer mask kamera target",
  T_48_META_API_9018_P0_D: "entitas kamera target",
  T_48_META_API_9018_R_D: "Layer mask, hanya lapisan di dalam layer mask yang akan ditampilkan di kamera target",
  T_48_META_API_9019_D: "Atur apakah level yang ditentukan terlihat oleh kamera target",
  T_48_META_API_9019_P0_D: "entitas kamera target",
  T_48_META_API_9019_P1_D: "tingkat visibilitas",
  T_48_META_API_9019_P2_D: "terlihat atau tidak",
  T_48_META_API_9020_D: "Tetapkan status visibilitas antarmuka default pemain target",
  T_48_META_API_9020_P0_D: "pemain sasaran",
  T_48_META_API_9020_P1_D: "Tipe antarmuka pemutar. Tipe antarmuka pemutar adalah elemen UI yang digunakan untuk mengontrol pemutar dan konten terkait pemutar.",
  T_48_META_API_9020_P2_D: "Nilai sakelar menentukan visibilitas antarmuka pemutar.",
  T_48_META_API_9021_D: "Buat string lokal stempel waktu",
  T_48_META_API_9021_P0_D: "Stempel waktu",
  T_48_META_API_9021_P1_D: "Gaya pemformatan",
  T_48_META_API_9021_R_D: "String pelokalan stempel waktu",
  T_48_META_API_9022_D: "Buat ikon peta mini",
  T_48_META_API_9022_P0_D: "Membuat entitas ikon minimap",
  T_48_META_API_9022_P1_D: "Milik pemain. Ikon minimap yang dibuat hanya dapat dilihat oleh pemain tersebut.",
  T_48_META_API_9022_P2_D: "Jalur sumber daya ikon peta mini",
  T_48_META_API_9023_D: "Buat ikon menggunakan jenis efek khusus yang ditentukan. Jika ada lebih banyak properti yang perlu diatur, atur lebih lanjut properti entitasnya melalui entitas.",
  T_48_META_API_9023_P0_D: "Kode tersebut digunakan untuk mewakili nama parameter formal yang menciptakan entitas efek khusus, dan nilai variabel lokal terkait adalah entitas yang menciptakan efek khusus.",
  T_48_META_API_9023_P1_D: "Entitas pemain yang dimilikinya, hanya dapat dilihat oleh pemain ini",
  T_48_META_API_9023_P2_D: "Jenis efek khusus, jenis efek khusus yang dapat dipilih pemain",
  T_48_META_API_9024_D: "Hapus efek yang ditentukan (tidak digunakan lagi, harap gunakan DeleteEntity)",
  T_48_META_API_9024_P0_D: "Entitas efek yang akan dihapus",
  T_48_META_API_9025_D: "Hasilkan piksel statis pada peta untuk objek target. Piksel statis tidak akan berpindah bersama objek target.",
  T_48_META_API_9025_P0_D: "Membuat entitas piksel statis",
  T_48_META_API_9025_P1_D: "Milik pemain, piksel statis yang dibuat hanya dapat dilihat oleh pemain",
  T_48_META_API_9025_P2_D: "entitas objek target",
  T_48_META_API_9026_D: "Dapatkan entitas minimap pemain target",
  T_48_META_API_9026_P0_D: "pemain sasaran",
  T_48_META_API_9026_R_D: "Peta mini pemain saat ini",
  T_48_META_API_9027_D: "Atur kerusakan jatuh pemain. Kerusakan yang berbeda dapat diatur berdasarkan ketinggian.",
  T_48_META_API_9027_P0_D: "pemain sasaran",
  T_48_META_API_9027_P1_D: "Daftar yang sangat tersegmentasi",
  T_48_META_API_9027_P2_D: "Daftar segmen kerusakan",
  T_48_META_API_91_D: "Menambahkan target ke tim yang ditentukan akan menyebabkan target meninggalkan tim asli.",
  T_48_META_API_91_P0_D: "Gol yang perlu ditambahkan ke tim",
  T_48_META_API_91_P1_D: "Tim untuk bergabung",
  T_48_META_API_91_P2_D: "Apakah ini berhasil?",
  T_48_META_API_92_D: "Menambahkan target ke tim baru akan menyebabkan target meninggalkan tim asli.",
  T_48_META_API_92_P0_D: "Gol yang perlu ditambahkan ke tim",
  T_48_META_API_92_P1_D: "Nama tim baru",
  T_48_META_API_92_P2_D: "Apakah ini berhasil?",
  T_48_META_API_94_D: "Tetapkan nilai variabel lokal berdasarkan indeks; sebelum mengatur, variabel harus didefinisikan dalam proses panggilan saat ini",
  T_48_META_API_94_P0: "Indeks",
  T_48_META_API_94_P0_D: "Dapatkan variabel berdasarkan indeks",
  T_48_META_API_94_P1: "Nilai Variabel",
  T_48_META_API_94_P1_D: "Nilai variabel target",
  T_48_META_API_94_P2: "Tipe Aritmatika",
  T_48_META_API_94_P2_D: "Metode operasi; semua tipe mendukung penugasan, dan tipe numerik juga mendukung operasi penambahan, pengurangan, perkalian, pembagian, dan modulus.",
  T_48_META_API_94_P3: "Nama Variabel",
  T_48_META_API_94_P3_D: "Nama variabel target. Hanya digunakan untuk keluaran kesalahan",
  T_48_META_API_95: "Dapatkan Variabel Lokal berdasarkan Indeks",
  T_48_META_API_95_D: "Dapatkan nilai variabel lokal; sebelum mendapatkannya, variabel harus didefinisikan dalam proses panggilan saat ini",
  T_48_META_API_95_P0: "Indeks",
  T_48_META_API_95_P0_D: "indeks variabel",
  T_48_META_API_95_P1: "Nama Variabel",
  T_48_META_API_95_P1_D: "Nama variabel target. Hanya digunakan untuk keluaran kesalahan",
  T_48_META_API_9500_D: "Beritahu klien pemain target untuk memainkan efek khusus",
  T_48_META_API_9500_P0_D: "pemain sasaran",
  T_48_META_API_9500_P1_D: "Jalur sumber daya efek khusus",
  T_48_META_API_9500_P2_D: "warna",
  T_48_META_API_9500_P3_D: "Ukuran zoom, defaultnya adalah 1",
  T_48_META_API_9500_P4_D: "Mengikat objek, efek khusus akan dilampirkan sebagai node turunannya",
  T_48_META_API_9500_P5_D: "Offset koordinat dunia relatif terhadap objek terikat",
  T_48_META_API_9501_D: "Memberi tahu klien pemain target untuk memainkan efek suara",
  T_48_META_API_9501_P0_D: "pemain sasaran",
  T_48_META_API_9501_P1_D: "Jenis efek suara",
  T_48_META_API_9502_D: 'Beritahu klien pemain target untuk menampilkan kata "mengambang"',
  T_48_META_API_9502_P0_D: "pemain sasaran",
  T_48_META_API_9502_P1_D: "konten piaozi",
  T_48_META_API_9502_P2_D: "Warna kata mengambang, tipe adalah warna",
  T_48_META_API_9502_P3_D: "Durasi karakter mengambang dalam milidetik",
  T_48_META_API_9503_D: "Menyebabkan unit target memainkan ekspresi tindakan Emote satu kali",
  T_48_META_API_9503_P0_D: "Tujuan bermain Emote",
  T_48_META_API_9503_P1_D: "Tipe emosi",
  T_48_META_API_9504_D: "Menjeda/melanjutkan ekspresi tindakan Emote unit",
  T_48_META_API_9504_P0_D: "Jeda/lanjutkan target Emote",
  T_48_META_API_9504_P1_D: "Benar: menjeda pemutaran, Salah: melanjutkan pemutaran",
  T_48_META_EVT_1_D: "Dipicu saat permainan dimulai, server akan siap beberapa waktu lebih awal dari klien",
  T_48_META_EVT_10_D: "Dipicu sebelum entitas saat ini mengalami kerusakan",
  T_48_META_EVT_10_P0_D: "Entitas penyerang, mungkin kosong",
  T_48_META_EVT_10_P1_D: "Jenis kerusakan",
  T_48_META_EVT_10_P2_D: "Jumlah kerusakan yang ditimbulkan",
  T_48_META_EVT_10_P3_D: "Bagian yang terluka",
  T_48_META_EVT_1000_D: "Dipicu ketika poin pemain berubah",
  T_48_META_EVT_1000_P0_D: "Pemain yang poinnya berubah",
  T_48_META_EVT_1000_P1_D: "Jenis titik perubahan",
  T_48_META_EVT_1000_P2_D: "Nilai integral setelah perubahan integral",
  T_48_META_EVT_1001_D: "Dipicu ketika poin tim berubah",
  T_48_META_EVT_1001_P0_D: "Tim dengan perubahan poin",
  T_48_META_EVT_1001_P1_D: "Jenis Poin Perubahan",
  T_48_META_EVT_1001_P2_D: "Nilai integral setelah perubahan integral",
  T_48_META_EVT_1002_D: "Dipicu ketika peringkat pemain berubah",
  T_48_META_EVT_1002_P0_D: "Pemain yang peringkatnya berubah",
  T_48_META_EVT_1002_P1_D: "Peringkat demi peringkat berubah",
  T_48_META_EVT_1003_D: "Tidak digunakan lagi",
  T_48_META_EVT_1003_P0_D: "Tidak digunakan lagi",
  T_48_META_EVT_1003_P1_D: "Peringkat demi peringkat berubah",
  T_48_META_EVT_11_D: "Trigger ketika pemain keluar",
  T_48_META_EVT_11_P0_D: "Pemain yang keluar",
  T_48_META_EVT_12_D: "Dipicu ketika pengontrol pemain menyentuh suatu entitas. Ini hanya akan dipicu ketika pengontrol aktif bergerak.",
  T_48_META_EVT_12_P0_D: "Entitas yang ditemui",
  T_48_META_EVT_13_D: "Dipicu sebelum entitas saat ini memberikan kerusakan",
  T_48_META_EVT_13_P0_D: "Entitas menerima kerusakan",
  T_48_META_EVT_13_P1_D: "Jenis kerusakan",
  T_48_META_EVT_13_P2_D: "Jumlah kerusakan yang ditimbulkan",
  T_48_META_EVT_13_P3_D: "Bagian yang terluka",
  T_48_META_EVT_14_D: "Dipicu setiap kali entitas yang dapat diputar berputar. Jika entitas yang dapat dimainkan adalah efek suara, efek khusus, dll., peristiwa ini hanya berlaku pada klien.",
  T_48_META_EVT_2_D: "Dipicu ketika bingkai logis diperbarui. Frekuensi pemicu peristiwa ini akan bervariasi tergantung pada platform dan pengaturan.",
  T_48_META_EVT_2002_D: "Dipicu ketika pemain mati",
  T_48_META_EVT_2002_P0_D: "pemain mati",
  T_48_META_EVT_2003_D: "Dipicu saat pemain memberikan assist",
  T_48_META_EVT_2003_P0_D: "Pemain yang menerima assist",
  T_48_META_EVT_2003_P1_D: "Pemain yang terbunuh",
  T_48_META_EVT_2004_D: "Dipicu ketika pemain memberikan kerusakan",
  T_48_META_EVT_2004_P0_D: "Pemain yang menyebabkan kerusakan",
  T_48_META_EVT_2004_P1_D: "Pemain yang dirugikan",
  T_48_META_EVT_2004_P2_D: "Jenis kerusakan",
  T_48_META_EVT_2004_P3_D: "Kerusakan",
  T_48_META_EVT_2004_P4_D: "Bagian yang terluka",
  T_48_META_EVT_2005_D: "Dipicu ketika seorang pemain menyebabkan pembunuhan",
  T_48_META_EVT_2005_P0_D: "Pemain yang menyebabkan pembunuhan itu",
  T_48_META_EVT_2005_P1_D: "Pemain yang terbunuh",
  T_48_META_EVT_2005_P2_D: "Jenis kerusakan",
  T_48_META_EVT_2006_D: "Dipicu saat pemain bergabung dalam game",
  T_48_META_EVT_2006_P0_D: "Pemain yang bergabung dalam permainan",
  T_48_META_EVT_2007_D: "Dipicu ketika pemain dibangkitkan",
  T_48_META_EVT_2007_P0_D: "pemain yang dibangkitkan",
  T_48_META_EVT_2007_P1_D: "Sumber kebangkitan",
  T_48_META_EVT_2008_D: "Dipicu saat pemain terjatuh",
  T_48_META_EVT_2008_P0_D: "pemain yang terjatuh",
  T_48_META_EVT_2008_P1_D: "Pemain penyerang",
  T_48_META_EVT_2009_D: "Kebakaran ketika pemain terputus",
  T_48_META_EVT_2009_P0_D: "Pemain terputus",
  T_48_META_EVT_2010_D: "Ditembak saat pemain terhubung kembali",
  T_48_META_EVT_2010_P0_D: "Pemain terhubung kembali",
  T_48_META_EVT_2100_D: "Dipicu ketika tim dikeluarkan",
  T_48_META_EVT_2100_P0_D: "tim yang dihapus",
  T_48_META_EVT_2101_D: "Dipicu saat menambahkan tim",
  T_48_META_EVT_2101_P0_D: "Menambahkan tim",
  T_48_META_EVT_2102_D: "Dipicu ketika tim dihancurkan",
  T_48_META_EVT_2102_P0_D: "Tim yang tersingkir",
  T_48_META_EVT_3_D: "Diaktifkan saat game berakhir. Event ini diaktifkan sebelum game berakhir di server.",
  T_48_META_EVT_30_D: "Dipicu ketika adegan berhasil dimuat",
  T_48_META_EVT_30_P0_D: "nama adegan",
  T_48_META_EVT_3000_D: "Diaktifkan setelah entitas saat ini dibuat",
  T_48_META_EVT_3001_D: "Dipicu sebelum entitas saat ini dihancurkan",
  T_48_META_EVT_3002_D: "Menembak saat pemain memasukkan pelatuk",
  T_48_META_EVT_3002_P0_D: "pemain memasuki pemicu",
  T_48_META_EVT_3003_D: "Menembak saat pemain meninggalkan pelatuknya",
  T_48_META_EVT_3003_P0_D: "pemain meninggalkan pemicu",
  T_48_META_EVT_3004_D: "Dipecat setelah mengklik kontrol tombol UI",
  T_48_META_EVT_3004_P0_D: "Pemain yang mengklik",
  T_48_META_EVT_3005_D: "Diaktifkan ketika tombol di UI bawaan diklik",
  T_48_META_EVT_3005_P0_D: "Nama kontrol tombol yang diklik",
  T_48_META_EVT_3006_D: "Dipicu saat pemain menggunakan wakeboard",
  T_48_META_EVT_3007_D: "Diaktifkan setelah entitas saat ini tersedia",
  T_48_META_EVT_3008_D: "Kebakaran setelah entitas saat ini tidak tersedia",
  T_48_META_EVT_3009_D: "Dipicu saat entitas memasuki pemicu. Saat peristiwa pemicu dipicu, kedua pihak menerima peristiwa tersebut. Satu pihak harus berupa rigid body dan pihak lainnya harus berupa pemicu. Secara khusus, saat pemicu adalah objek pemicu kustom, hanya pemicu yang akan menerima peristiwa tersebut.",
  T_48_META_EVT_3009_P0_D: "Entitas pihak lawan ketika peristiwa pemicu terjadi",
  T_48_META_EVT_3010_D: "Dipicu saat entitas meninggalkan pemicu. Saat peristiwa dipicu, kedua pihak menerima peristiwa tersebut. Satu pihak harus berupa rigid body dan pihak lainnya harus berupa pemicu. Secara khusus, saat pemicu adalah objek pemicu kustom, hanya pemicu yang akan menerima peristiwa tersebut.",
  T_48_META_EVT_3010_P0_D: "Entitas pihak lawan ketika peristiwa pemicu terjadi",
  T_48_META_EVT_3011_D: "Dipicu setelah entitas saat ini dihancurkan",
  T_48_META_EVT_3011_P0_D: "Entitas penyerang, mungkin kosong",
  T_48_META_EVT_3011_P1_D: "Jenis kerusakan",
  T_48_META_EVT_3011_P2_D: "Bagian yang terluka",
  T_48_META_EVT_3012_D: "Dipicu setelah entitas saat ini diserang",
  T_48_META_EVT_3012_P0_D: "Entitas penyerang, mungkin kosong",
  T_48_META_EVT_3012_P1_D: "Jenis kerusakan",
  T_48_META_EVT_3012_P2_D: "Jumlah kerusakan yang ditimbulkan",
  T_48_META_EVT_3012_P3_D: "Bagian yang terluka",
  T_48_META_EVT_3013_D: "Dipicu setelah entitas saat ini memberikan kerusakan",
  T_48_META_EVT_3013_P0_D: "Entitas menerima kerusakan",
  T_48_META_EVT_3013_P1_D: "Jenis kerusakan",
  T_48_META_EVT_3013_P2_D: "Jumlah kerusakan yang ditimbulkan",
  T_48_META_EVT_3013_P3_D: "Bagian yang terluka",
  T_48_META_EVT_3014_D: "Dipicu setelah entitas saat ini menghancurkan entitas lain",
  T_48_META_EVT_3014_P0_D: "entitas yang hancur",
  T_48_META_EVT_3014_P1_D: "Bagian yang terluka",
  T_48_META_EVT_3015_D: "Dipicu saat pemain dibangkitkan",
  T_48_META_EVT_3015_P0_D: "Jenis sumber kebangkitan pemain",
  T_48_META_EVT_3016_D: "Kebakaran ketika generator menghasilkan suatu entitas",
  T_48_META_EVT_3016_P0_D: "Daftar entitas yang dihasilkan",
  T_48_META_EVT_3016_P1_D: "Nomor gelombang",
  T_48_META_EVT_3017_D: "Dipanggil ketika pemain memasuki posisi berlutut knockdown",
  T_48_META_EVT_3018_D: "Dipicu ketika semua anggota tim mati",
  T_48_META_EVT_3019_D: "Dipicu saat dilengkapi dengan helm, pelindung tubuh, atau ransel",
  T_48_META_EVT_3019_P0_D: "ID Peralatan",
  T_48_META_EVT_3020_D: "Dipicu saat memegang senjata primer, sekunder, atau jarak dekat, termasuk saat beralih ke tinju",
  T_48_META_EVT_3020_P0_D: "Entitas senjata yang digunakan saat dipicu",
  T_48_META_EVT_3021_D: "Dipicu setelah menggunakan prop. Props yang membutuhkan waktu akan memicu event ini setelah selesai digunakan.",
  T_48_META_EVT_3021_P0_D: "ID pendukung",
  T_48_META_EVT_3021_P1_D: "entitas prop, mungkin kosong",
  T_48_META_EVT_3021_P2_D: "Entitas prop baru yang dibuat menggunakan props, mungkin kosong",
  T_48_META_EVT_3022_D: "Dipicu saat item diperoleh",
  T_48_META_EVT_3022_P0_D: "Jenis barang",
  T_48_META_EVT_3022_P1_D: "Entitas item, mungkin kosong",
  T_48_META_EVT_3023_D: "Dipicu ketika skor entitas berubah",
  T_48_META_EVT_3023_P0_D: "Jenis titik perubahan",
  T_48_META_EVT_3023_P1_D: "Nilai integral setelah perubahan integral",
  T_48_META_EVT_3024_D: "Dipicu ketika peringkat suatu entitas berubah",
  T_48_META_EVT_3024_P0_D: "Peringkat demi peringkat berubah",
  T_48_META_EVT_3025_D: "Dipicu saat bantuan",
  T_48_META_EVT_3025_P0_D: "Objek yang dibunuh",
  T_48_META_EVT_3026_D: "Dipicu ketika suatu entitas memasuki kendaraan, termasuk sebagai pengemudi dan penumpang",
  T_48_META_EVT_3026_P0_D: "Entitas memasuki kendaraan",
  T_48_META_EVT_3026_P1_D: "Memasuki kendaraan",
  T_48_META_EVT_3027_D: "Dipicu ketika entitas meninggalkan kendaraan",
  T_48_META_EVT_3027_P0_D: "Entitas meninggalkan kendaraan",
  T_48_META_EVT_3027_P1_D: "Kendaraan berangkat",
  T_48_META_EVT_3028_D: "Dipicu ketika entitas mengemudikan kendaraan dan menjadi pengemudi di dalam kendaraan.",
  T_48_META_EVT_3028_P0_D: "Entitas yang menggerakkan kendaraan",
  T_48_META_EVT_3028_P1_D: "mengemudi kendaraan",
  T_48_META_EVT_3029_D: "Dipicu ketika kendaraan dimasuki oleh suatu entitas",
  T_48_META_EVT_3029_P0_D: "Entitas pemicu",
  T_48_META_EVT_3030_D: "Dipicu ketika entitas kendaraan pergi",
  T_48_META_EVT_3030_P0_D: "Entitas pemicu",
  T_48_META_EVT_3031_D: "Dipicu ketika kendaraan dikemudikan oleh suatu entitas",
  T_48_META_EVT_3031_P0_D: "Entitas pemicu",
  T_48_META_EVT_3032_D: "Dipicu setelah entitas menggunakan portal untuk berteleportasi (usang, harap gunakan OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Entitas yang menggunakan portal",
  T_48_META_EVT_3032_P1_D: "Portal digunakan",
  T_48_META_EVT_3033_D: "Dipicu ketika entitas terpental",
  T_48_META_EVT_3033_P0_D: "Entitas pemicu",
  T_48_META_EVT_3033_P1_D: "Benda memantul yang digunakan",
  T_48_META_EVT_3034_D: "Dipicu setelah portal menteleportasikan entitas",
  T_48_META_EVT_3034_P0_D: "Entitas transmisi",
  T_48_META_EVT_3035_D: "Dipicu setelah ban memantulkan entitas",
  T_48_META_EVT_3035_P0_D: "Entitas yang terpental",
  T_48_META_EVT_3036_D: "Dipicu ketika mekanisme tersebut menjatuhkan entitas ke udara",
  T_48_META_EVT_3036_P0_D: "Entitas yang tersingkir",
  T_48_META_EVT_3036_P1_D: "Benda mekanis",
  T_48_META_EVT_3037_D: "Diaktifkan ketika suatu entitas memasuki pemicu",
  T_48_META_EVT_3037_P0_D: "pemicu masuk",
  T_48_META_EVT_3038_D: "Dipicu saat entitas meninggalkan pemicunya",
  T_48_META_EVT_3038_P0_D: "pemicu keberangkatan",
  T_48_META_EVT_3039_D: "Dipicu ketika entitas senjata diperoleh",
  T_48_META_EVT_3039_P0_D: "entitas senjata",
  T_48_META_EVT_3040_D: "Dipicu ketika entitas dihempaskan oleh suatu mekanisme",
  T_48_META_EVT_3040_P0_D: "Entitas yang terlempar",
  T_48_META_EVT_3040_P1_D: "Benda mekanis",
  T_48_META_EVT_3041_D: "Dipicu ketika menargetkan entitas yang dapat ditargetkan",
  T_48_META_EVT_3041_P0_D: "entitas yang ditargetkan",
  T_48_META_EVT_3042_D: "Dipicu ketika ditargetkan oleh pemain",
  T_48_META_EVT_3042_P0_D: "Pemain membidik",
  T_48_META_EVT_3043_D: "Dipicu ketika peluru mengenai sasaran",
  T_48_META_EVT_3043_P0_D: "sasaran tercapai",
  T_48_META_EVT_3043_P1_D: "Koordinat dunia di mana peluru itu mengenai",
  T_48_META_EVT_3044_D: "Dipicu saat terkena senjata",
  T_48_META_EVT_3044_P0_D: "lengan",
  T_48_META_EVT_3044_P1_D: "Koordinat dunia dari area yang terkena dampak",
  T_48_META_EVT_3045_D: "Dipicu ketika pemain memilih untuk berubah menjadi objek di level ini",
  T_48_META_EVT_3045_P0_D: "Pemain berubah menjadi suatu entitas, bukan objek adegan itu sendiri",
  T_48_META_EVT_3046_D: "Dipicu ketika pemain bangkit kembali pada titik respawn ini",
  T_48_META_EVT_3046_P0_D: "Pemain dibangkitkan pada titik respawn ini",
  T_48_META_EVT_3047_D: "Dipicu ketika pemain menjatuhkan senjata",
  T_48_META_EVT_3047_P0_D: "entitas senjata yang dibuang",
  T_48_META_EVT_3048_D: "Dipicu ketika pemain menjatuhkan item selain senjata",
  T_48_META_EVT_3048_P0_D: "Jenis barang",
  T_48_META_EVT_3048_P1_D: "Entitas item, mungkin kosong",
  T_48_META_EVT_3049_D: "Dipicu ketika terkena senjata sepak bola",
  T_48_META_EVT_3049_P0_D: "pemain",
  T_48_META_EVT_3049_P1_D: "kecepatan setelah dipukul",
  T_48_META_EVT_3050_D: "Dipicu ketika sepak bola bertabrakan dengan suatu entitas",
  T_48_META_EVT_3050_P0_D: "Benda tumbukan",
  T_48_META_EVT_3050_P1_D: "kecepatan setelah tumbukan",
  T_48_META_EVT_3051_D: "Dipicu ketika pemain berhasil bergabung dengan saluran suara",
  T_48_META_EVT_3051_P0_D: "Entitas saluran suara",
  T_48_META_EVT_3052_D: "Dipicu ketika pemain gagal bergabung dengan saluran suara",
  T_48_META_EVT_3052_P0_D: "Entitas saluran suara",
  T_48_META_EVT_3053_D: "Dipicu ketika pemain keluar dari saluran suara",
  T_48_META_EVT_3053_P0_D: "Entitas saluran suara",
  T_48_META_EVT_3054_D: "Dipicu ketika bola memasuki gawang",
  T_48_META_EVT_3054_P0_D: "sasaran",
  T_48_META_EVT_3054_P1_D: "Pencetak gol, pemain terakhir yang menyentuh bola sebelum mencetak gol",
  T_48_META_EVT_3054_P2_D: "Assister, pemain kedua dari belakang yang menyentuh bola sebelum masuk gawang",
  T_48_META_EVT_3055_D: "Dipicu ketika pemain menekan tombol api",
  T_48_META_EVT_3056_D: "Dipicu saat pemain melompat",
  T_48_META_EVT_3057_D: "Dipicu saat pemain berjongkok",
  T_48_META_EVT_3058_D: "Dipicu saat pemain dalam posisi tengkurap",
  T_48_META_EVT_3059_D: "Dipicu saat pemain berlari",
  T_48_META_EVT_3060_D: "Dipicu ketika item berhasil dibeli di toko",
  T_48_META_EVT_3060_P0_D: "Pemain yang membeli barang",
  T_48_META_EVT_3060_P1_D: "komoditi",
  T_48_META_EVT_3061_D: "Dipicu saat senjata digunakan oleh pemain",
  T_48_META_EVT_3061_P0_D: "Pemain dilengkapi dengan senjata",
  T_48_META_EVT_3062_D: "Dipicu saat unit terbunuh dengan senjata ini",
  T_48_META_EVT_3062_P0_D: "Entitas yang terbunuh",
  T_48_META_EVT_3063_D: "Dipicu ketika senjata ini digunakan untuk merusak suatu unit",
  T_48_META_EVT_3063_P0_D: "Entitas yang dirugikan",
  T_48_META_EVT_3063_P1_D: "Kerusakan",
  T_48_META_EVT_3064_D: "Dipicu saat senjata berganti peluru",
  T_48_META_EVT_3065_D: "Dipicu ketika suatu entitas memasuki kendaraan. Peristiwa ini dapat dipicu sebagai pengemudi atau penumpang.",
  T_48_META_EVT_3065_P0_D: "Memasuki kendaraan",
  T_48_META_EVT_3066_D: "Dipicu ketika entitas meninggalkan kendaraan",
  T_48_META_EVT_3066_P0_D: "Kendaraan berangkat",
  T_48_META_EVT_3067_D: "Dipicu ketika suatu entitas mengendarai kendaraan",
  T_48_META_EVT_3067_P0_D: "mengemudi kendaraan",
  T_48_META_EVT_3068_D: "Dipicu setelah suatu entitas berteleportasi menggunakan portal",
  T_48_META_EVT_3068_P0_D: "Portal digunakan",
  T_48_META_EVT_3069_D: "Dipicu setelah entitas terpental oleh ban",
  T_48_META_EVT_3069_P0_D: "Ban bekas",
  T_48_META_EVT_3070_D: "Dipicu ketika entitas dihempaskan oleh suatu mekanisme",
  T_48_META_EVT_3070_P0_D: "Benda mekanis",
  T_48_META_EVT_3071_D: "Dipicu setelah kontrol tombol UI ditekan oleh pemain",
  T_48_META_EVT_3071_P0_D: "pemain pemicu",
  T_48_META_EVT_3072_D: "Diaktifkan setelah kontrol tombol UI dimunculkan",
  T_48_META_EVT_3072_P0_D: "pemain pemicu",
  T_48_META_EVT_3073_D: "Dipicu setelah kontrol tombol UI diklik dua kali oleh pemain",
  T_48_META_EVT_3073_P0_D: "pemain pemicu",
  T_48_META_EVT_3074_D: "Area pembobolan penjara dimulai",
  T_48_META_EVT_3075_D: "Akhir dari area jailbreak",
  T_48_META_EVT_3076_D: "Dipicu ketika pemain berhenti menggunakan wakeboard",
  T_48_META_EVT_3077_D: "Dipicu ketika konten teks kontrol kotak masukan UI diubah oleh pemutar",
  T_48_META_EVT_3077_P0_D: "pemain pemicu",
  T_48_META_EVT_3077_P1_D: "Konten teks diubah",
  T_48_META_EVT_3078_D: "Diaktifkan saat entitas yang dapat dimainkan mulai diputar",
  T_48_META_EVT_3078_P0_D: "Entitas yang dapat dimainkan",
  T_48_META_EVT_3079_D: "Dipicu ketika entitas yang dapat dimainkan berhenti diputar. Ketika entitas yang dapat dimainkan adalah efek suara, efek khusus, dll., peristiwa ini hanya berlaku pada klien.",
  T_48_META_EVT_3079_P0_D: "Entitas yang dapat dimainkan",
  T_48_META_EVT_3080_D: "Dipicu ketika entitas yang dapat dimainkan terus bermain",
  T_48_META_EVT_3080_P0_D: "Entitas yang dapat dimainkan",
  T_48_META_EVT_3081_D: "Dipicu ketika entitas yang dapat diputar menjeda pemutaran",
  T_48_META_EVT_3081_P0_D: "Entitas yang dapat dimainkan",
  T_48_META_EVT_3082_D: "Pemain yang sudah di-jailbreak bergabung",
  T_48_META_EVT_3082_P0_D: "pemain pemicu",
  T_48_META_EVT_3083_D: "Keluar dari pemain yang sudah di-jailbreak",
  T_48_META_EVT_3083_P0_D: "pemain pemicu",
  T_48_META_EVT_3084_D: "Kebakaran di akhir hitungan mundur",
  T_48_META_EVT_3084_P0_D: "Entitas pemilik",
  T_48_META_EVT_3085_D: "Dipicu saat item diambil",
  T_48_META_EVT_3085_P0_D: "Pemain yang mengambil item tersebut",
  T_48_META_EVT_3086_D: "Dipicu saat item dijatuhkan",
  T_48_META_EVT_3086_P0_D: "Pemain yang menjatuhkan item tersebut",
  T_48_META_EVT_3087_D: "Dipicu saat item ini dipasang",
  T_48_META_EVT_3088_D: "Kebakaran ketika objek dimulai setelah tambang dibuat",
  T_48_META_EVT_3089_D: "Dipicu ketika objek terpicu setelah tambang dibuat",
  T_48_META_EVT_3089_P0_D: "Entitas memicu benda yang diciptakan setelah tambang dibuat",
  T_48_META_EVT_3090_D: "Dipicu sebelum membeli barang di toko",
  T_48_META_EVT_3090_P0_D: "Pemain yang membeli barang",
  T_48_META_EVT_3090_P1_D: "komoditi",
  T_48_META_EVT_3091_D: "Kebakaran saat perangkat ini sedang digunakan",
  T_48_META_EVT_3092_D: "Dipicu saat grapple gun ditembakkan",
  T_48_META_EVT_3093_D: "Dipicu ketika proyektil meledak setelah dilempar",
  T_48_META_EVT_3093_P0_D: "titik ledakan",
  T_48_META_EVT_3094_D: "Terpicu saat terkena pistol semprot",
  T_48_META_EVT_3094_P0_D: "Entitas pistol semprot",
  T_48_META_EVT_3094_P1_D: "titik sasaran",
  T_48_META_EVT_3094_P2_D: "mencapai normal",
  T_48_META_EVT_3095_D: "Dipicu saat dipukul dengan pistol cat",
  T_48_META_EVT_3095_P0_D: "memukul objek",
  T_48_META_EVT_3095_P1_D: "titik sasaran",
  T_48_META_EVT_3095_P2_D: "mencapai normal",
  T_48_META_EVT_3096_D: "Dipicu ketika kendaraan atau tong pewarna meledak",
  T_48_META_EVT_3096_P0_D: "Pemain yang menyebabkan ledakan",
  T_48_META_EVT_3096_P1_D: "Daftar pemain yang terkena dampak ledakan",
  T_48_META_EVT_3097_D: "Menembak ketika senjata berhenti menembak",
  T_48_META_EVT_3097_P0_D: "Jumlah amunisi yang tersisa di magasin saat ini ketika penembakan dihentikan",
  T_48_META_EVT_3098_D: "Dipicu ketika target pengejaran memasuki jangkauan pengejaran",
  T_48_META_EVT_3099_D: "Dipicu ketika target pengejar meninggalkan jangkauan pengejaran",
  T_48_META_EVT_31_D: "Dipicu ketika pergantian adegan berhasil",
  T_48_META_EVT_31_P0_D: "nama adegan",
  T_48_META_EVT_3100_D: "Dipicu ketika target serangan memasuki jangkauan serangan",
  T_48_META_EVT_3101_D: "Dipicu ketika target serangan meninggalkan jangkauan serangan",
  T_48_META_EVT_3102_D: "Peristiwa ini dipicu ketika deteksi sinar kamera dipicu melalui peristiwa klik klien",
  T_48_META_EVT_3102_P0_D: "pemain pemicu",
  T_48_META_EVT_3102_P1_D: "Apakah sinar kamera mengenai objek",
  T_48_META_EVT_3102_P2_D: "Sinar kamera mengenai lokasi",
  T_48_META_EVT_3102_P3_D: "Orientasi kamera klien",
  T_48_META_EVT_3102_P4_D: "Posisi kamera klien",
  T_48_META_EVT_3102_P5_D: "entitas yang terkena",
  T_48_META_EVT_3103_D: "Dipicu ketika antarmuka toko dibuka",
  T_48_META_EVT_3103_P0_D: "pemain pemicu",
  T_48_META_EVT_3104_D: "Dipicu ketika antarmuka toko ditutup",
  T_48_META_EVT_3104_P0_D: "pemain pemicu",
  T_48_META_EVT_3105_D: "Dipicu ketika logika pohon perilaku memasuki node ini",
  T_48_META_EVT_3105_P0_D: "Nama simpul",
  T_48_META_EVT_3105_P1_D: "Entitas pemilik",
  T_48_META_EVT_3106_D: "Dipicu ketika logika pohon perilaku keluar dari node",
  T_48_META_EVT_3106_P0_D: "Nama simpul",
  T_48_META_EVT_3106_P1_D: "Entitas pemilik",
  T_48_META_EVT_3107_D: "Dipicu saat tubuh kaku terbangun",
  T_48_META_EVT_3108_D: "Dipicu saat tubuh kaku hendak tertidur",
  T_48_META_EVT_3109_D: "Dipicu saat pemain bergerak",
  T_48_META_EVT_3109_P0_D: "sikap",
  T_48_META_EVT_3110_D: "Dipicu saat pemain dalam keadaan idle",
  T_48_META_EVT_3110_P0_D: "sikap",
  T_48_META_EVT_3111_D: "Dipicu saat pemain menggunakan skill",
  T_48_META_EVT_3111_P0_D: "Keterampilan yang digunakan",
  T_48_META_EVT_3112_D: "Dipicu saat pemain selesai berlari",
  T_48_META_EVT_3113_D: "Dipicu ketika mendapatkan item yang sesuai dengan slot di bawah enumerasi SwitchEquipSlot",
  T_48_META_EVT_3113_P0_D: "Entitas item yang diperoleh",
  T_48_META_EVT_3114_D: "Dipicu saat berpindah benda genggam, termasuk saat berpindah ke tinju",
  T_48_META_EVT_3114_P0_D: "Entitas item yang dimiliki setelah peralihan",
  T_48_META_EVT_3115_D: "Dipicu ketika pemain di toko meminta orang lain untuk membeli barang",
  T_48_META_EVT_3115_P0_D: "Pemain yang meminta pembelian",
  T_48_META_EVT_3115_P1_D: "komoditi",
  T_48_META_EVT_3116_D: "Dipicu ketika pemain di toko meminta orang lain untuk membeli barang dan permintaan tersebut diterima.",
  T_48_META_EVT_3116_P0_D: "Pemain yang membantu membeli",
  T_48_META_EVT_3116_P1_D: "Pemain meminta bantuan untuk membeli",
  T_48_META_EVT_3116_P2_D: "komoditi",
  T_48_META_EVT_3117_D: "Dipicu ketika bingkai tetap diperbarui, frekuensinya ditetapkan pada 30 kali per detik",
  T_48_META_EVT_3118_D: "Dipicu setelah memanggil API game jeda",
  T_48_META_EVT_3119_D: "Dipicu setelah memanggil API resume game",
  T_48_META_EVT_3120_D: "Dipicu ketika pemain menambah atau menghapus teman",
  T_48_META_EVT_3121_D: "Dipicu saat menerima informasi Persona",
  T_48_META_EVT_3121_P0_D: "Konten informasi",
  T_48_META_EVT_3121_P1_D: "Persona Pengirim",
  T_48_META_EVT_3122_D: "Menembak di akhir lompatan pemain",
  T_48_META_EVT_3123_D: "Dipicu saat pemain terjatuh",
  T_48_META_EVT_3124_D: "Dipicu ketika pemain akhirnya terjatuh",
  T_48_META_EVT_3125_D: "Dipicu saat menerima perilaku Persona",
  T_48_META_EVT_3125_P0_D: "Perilaku",
  T_48_META_EVT_3125_P1_D: "Persona Pengirim",
  T_48_META_EVT_3126_D: "Dipicu ketika informasi anggota berubah",
  T_48_META_EVT_3126_P0_D: "Status anggota setelah perubahan",
  T_48_META_EVT_3127_D: "Dipicu saat memasuki pusat anggota",
  T_48_META_EVT_3128_D: "Dipicu ketika meninggalkan pusat anggota",
  T_48_META_EVT_3129_D: "Dipicu saat pemain memasuki kondisi jatuh",
  T_48_META_EVT_3129_P0_D: "Entitas penyerang, mungkin kosong",
  T_48_META_EVT_3130_D: "Dipicu ketika status Persona diterima",
  T_48_META_EVT_3130_P0_D: "Persona Pengirim",
  T_48_META_EVT_3130_P1_D: "kode kesalahan",
  T_48_META_EVT_3131_D: "Dipicu ketika mengirimkan informasi ke Persona melalui UI",
  T_48_META_EVT_3131_P0_D: "Konten informasi",
  T_48_META_EVT_3131_P1_D: "Persona Pengirim",
  T_48_META_EVT_3132_D: "Dipicu saat menerima akhir Persona",
  T_48_META_EVT_3132_P0_D: "Persona Pengirim",
  T_48_META_EVT_3132_P1_D: "kode kesalahan",
  T_48_META_EVT_32_D: "Dipicu saat pemain berpindah adegan",
  T_48_META_EVT_32_P0_D: "nama adegan",
  T_48_META_EVT_3200_D: "Diaktifkan saat klip animasi selesai diputar",
  T_48_META_EVT_3200_P0_D: "Nama klip animasi",
  T_48_META_EVT_3201_D: "Dipicu ketika pemutaran status animasi selesai",
  T_48_META_EVT_3201_P0_D: "Nama negara bagian animasi",
  T_48_META_EVT_3204_D: "Dipicu ketika status kontrol Toggle berubah",
  T_48_META_EVT_3204_P0_D: "pemain pemicu",
  T_48_META_EVT_3204_P1_D: "negara",
  T_48_META_EVT_3260_D: "Kebakaran ketika touchpad ditekan oleh pemain",
  T_48_META_EVT_3260_P0_D: "pemain pemicu",
  T_48_META_EVT_3260_P1_D: "Posisi tekan",
  T_48_META_EVT_3261_D: "Menyala ketika touchpad dinaikkan",
  T_48_META_EVT_3261_P0_D: "pemain pemicu",
  T_48_META_EVT_3261_P1_D: "posisi terangkat",
  T_48_META_EVT_3262_D: "Menyala ketika touchpad mulai meluncur",
  T_48_META_EVT_3262_P0_D: "pemain pemicu",
  T_48_META_EVT_3262_P1_D: "Mulai posisi meluncur",
  T_48_META_EVT_3263_D: "Dipicu saat panel sentuh digeser. Selama menggeser, peristiwa ini akan dipicu satu kali setiap frame.",
  T_48_META_EVT_3263_P0_D: "pemain pemicu",
  T_48_META_EVT_3263_P1_D: "Mulai posisi meluncur",
  T_48_META_EVT_3263_P2_D: "Pemindahan",
  T_48_META_EVT_3264_D: "Kebakaran di ujung slide touchpad",
  T_48_META_EVT_3264_P0_D: "pemain pemicu",
  T_48_META_EVT_3264_P1_D: "Akhiri posisi geser",
  T_48_META_EVT_3265_D: "Menyala saat JoyStick ditekan",
  T_48_META_EVT_3265_P0_D: "pemain pemicu",
  T_48_META_EVT_3266_D: "Menyala ketika JoyStick diangkat",
  T_48_META_EVT_3266_P0_D: "pemain pemicu",
  T_48_META_EVT_3267_D: "Dipicu saat menggunakan JoyStick",
  T_48_META_EVT_3267_P0_D: "pemain pemicu",
  T_48_META_EVT_3267_P1_D: "Perpindahan keluaran",
  T_48_META_EVT_3268_D: "Dipicu saat pemain berdiri dari posisi lain",
  T_48_META_EVT_3268_P0_D: "Postur pemain sebelum berdiri",
  T_48_META_EVT_3269_D: "Dipicu saat senjata ditembakkan",
  T_48_META_EVT_4_D: "Dipicu di awal setiap putaran",
  T_48_META_EVT_4_P0_D: "Indeks bulat, dimulai dari 0",
  T_48_META_EVT_5_D: "Dipicu di akhir setiap putaran",
  T_48_META_EVT_5_P0_D: "Indeks bulat, dimulai dari 0",
  T_48_META_EVT_6_D: "Dipicu ketika suatu entitas bertabrakan. Hanya entitas dengan komponen benda kaku terpasang yang mendukung peristiwa ini.",
  T_48_META_EVT_6_P0_D: "Entitas yang ditemui",
  T_48_META_EVT_7_D: "Dipicu pada awal setiap fase",
  T_48_META_EVT_7_P0_D: "entitas panggung",
  T_48_META_EVT_8_D: "Dipicu pada akhir setiap fase",
  T_48_META_EVT_8_P0_D: "entitas panggung",
  T_48_META_EVT_9_D: "Dipicu pada akhir tabrakan entitas. Hanya entitas dengan komponen bodi kaku terpasang yang mendukung peristiwa ini.",
  T_48_META_EVT_9_P0_D: "Entitas yang ditemui",
  T_49_META_TYP_10_I1_D: "Daftar Tag",
  T_49_META_TYP_10_I2_D: "Apakah tersedia dengan sendirinya",
  T_49_META_TYP_10_I3_D: "Tersedia di semua orang tua",
  T_49_META_TYP_10_I4_D: "Apakah tersedia di dalam adegan",
  T_49_META_TYP_10_I5_D: "Apakah pembaruan logika diaktifkan, ketika tidak aktif, skrip pada entitas ini berhenti memperbarui setiap frame",
  T_49_META_TYP_10_I6_D: "Nama entitas",
  T_49_META_TYP_10_I7_D: "Opsi pemfilteran wilayah, 0 untuk perhitungan otomatis terkontrol atau tidak, 1 untuk tidak terkontrol selalu tersinkronisasi, 2 untuk terkontrol",
  T_49_META_TYP_100_I0_D: "Mengatur rentang pemicu",
  T_49_META_TYP_100_I1_D: "Visibilitas Model",
  T_49_META_TYP_101_I0_D: "Pemain",
  T_49_META_TYP_101_I1_D: "ID Item Target",
  T_49_META_TYP_101_I2_D: "Rotasi Target",
  T_49_META_TYP_101_I3_D: "Skala Target",
  T_49_META_TYP_1010_I1_D: "Durasi pengaturan waktu dalam detik",
  T_49_META_TYP_1010_I2_D: "Waktu mulai pengaturan waktu, dalam detik dari momen permainan",
  T_49_META_TYP_1010_I3_D: "Jenis pembaruan pengatur waktu, lihat `EUITimeUpdateType`, dapat berupa statis, waktu, atau hitung mundur.",
  T_49_META_TYP_1010_I4_D: "Posisi tampilan, ketika ada target yang harus diikuti, itu adalah offset relatif terhadap asal target, ketika tidak ada target yang harus diikuti, itu adalah koordinat layar.",
  T_49_META_TYP_1011_I10_D: "Nama Ikon Kemajuan",
  T_49_META_TYP_1011_I2_D: "Warna Tema",
  T_49_META_TYP_1011_I3_D: "Apakah akan mengaktifkan tampilan yang dilokalkan",
  T_49_META_TYP_1011_I4_D: "Judul",
  T_49_META_TYP_1011_I5_D: "Deskripsi",
  T_49_META_TYP_1011_I6_D: "Nama sumber daya ikon",
  T_49_META_TYP_1011_I7_D: "Kemajuan Maksimum",
  T_49_META_TYP_1011_I8_D: "Kemajuan Saat Ini",
  T_49_META_TYP_1011_I9_D: "Ikon Kemajuan",
  T_49_META_TYP_1012_I1_D: "Mengaktifkan atau menonaktifkan pelokalan",
  T_49_META_TYP_1012_I2_D: "Teks Hitungan Bulat",
  T_49_META_TYP_1012_I3_D: "Parameter Kunci Putaran",
  T_49_META_TYP_1012_I5_D: "Warna Kiri",
  T_49_META_TYP_1012_I6_D: "Warna Kanan",
  T_49_META_TYP_1013_I2_D: "Teks Hitungan Putaran",
  T_49_META_TYP_1013_I3_D: "Parameter Kunci Putaran",
  T_49_META_TYP_1014_I2_D: "Teks Judul Skor Pertama",
  T_49_META_TYP_1014_I3_D: "Skor Pertama",
  T_49_META_TYP_1014_I4_D: "Parameter Skor Pertama",
  T_49_META_TYP_1014_I5_D: "Teks judul nilai kedua",
  T_49_META_TYP_1014_I6_D: "Nilai skor kedua",
  T_49_META_TYP_1014_I7_D: "Parameter Nilai Skor Kedua",
  T_49_META_TYP_1016_I1_D: "Menampilkan status yang sesuai dengan nilai, Kemenangan (1), Kekalahan (2), Seri (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Tampilkan jika nilai 2 tim benar, jika tidak disembunyikan",
  T_49_META_TYP_1016_I3_D: "Skor Tim Kiri",
  T_49_META_TYP_1016_I4_D: "Skor Tim Kanan",
  T_49_META_TYP_1016_I5_D: "Stempel waktu akhir tahap",
  T_49_META_TYP_1017_I1_D: "Nama Tim Kiri",
  T_49_META_TYP_1017_I2_D: "Deskripsi Tim Kiri",
  T_49_META_TYP_1017_I3_D: "Nama Tim Kanan",
  T_49_META_TYP_1017_I4_D: "Deskripsi Tim Kanan",
  T_49_META_TYP_1018_I1_D: "Nomor Putaran",
  T_49_META_TYP_1018_I4_D: "Skor tim kiri",
  T_49_META_TYP_1018_I6_D: "Skor tim kanan",
  T_49_META_TYP_1019_I1_D: "1 2 3 untuk menang/kalah/ seri",
  T_49_META_TYP_102_I0_D: "Jenis sumber kebangkitan, pemain dibangkitkan dari kematian",
  T_49_META_TYP_102_I1_D: "Jenis sumber kebangkitan, pemain dibangkitkan dari kondisi terjatuh.",
  T_49_META_TYP_1020_I2_D: "Kunci teks yang akan ditampilkan",
  T_49_META_TYP_1020_I3_D: "Larik parameter yang sesuai dengan tombol teks",
  T_49_META_TYP_1021_I1_D: "Waktu dasar dalam detik",
  T_49_META_TYP_1021_I2_D: "Durasi dalam detik",
  T_49_META_TYP_1021_I3_D: "Posisi tampilan, ketika ada target untuk diikuti, itu adalah offset dari asal target, ketika tidak ada target untuk diikuti, itu adalah koordinat layar, defaultnya adalah Vector3 (0).",
  T_49_META_TYP_1022_I2_D: "kunci teks yang akan ditampilkan",
  T_49_META_TYP_1022_I3_D: "Larik parameter yang sesuai dengan tombol teks",
  T_49_META_TYP_1023_I1_D: "menampilkan skor tim jika benar, jika tidak maka akan dimatikan.",
  T_49_META_TYP_1023_I4_D: "Jika status tim benar, maka tampilkan, jika tidak maka akan ditutup.",
  T_49_META_TYP_1023_I5_D: "Larik status pemain kiri, 0: hidup, 1: mati, 2: mati.",
  T_49_META_TYP_1023_I6_D: "Larik status pemain kanan, 0: hidup, 1: mati, 2: turun.",
  T_49_META_TYP_1023_I7_D: "Jumlah Bendera Teman Tim Kiri",
  T_49_META_TYP_1023_I8_D: "Jumlah Bendera Teman Kanan",
  T_49_META_TYP_1024_I2_D: "Offset",
  T_49_META_TYP_1024_I3_D: "Peringkat",
  T_49_META_TYP_1024_I4_D: "Warna Tim",
  T_49_META_TYP_1024_I5_D: "Nama Ikon",
  T_49_META_TYP_1024_I6_D: "Ditampilkan jika batas benar, jika tidak maka akan mati.",
  T_49_META_TYP_1024_I7_D: "Kunci Teks Skor",
  T_49_META_TYP_1024_I8_D: "Parameter Teks Skor",
  T_49_META_TYP_1028_I1_D: "Jumlah Pemain Hidup Kiri",
  T_49_META_TYP_1028_I2_D: "Jumlah Pemain Hidup Kanan",
  T_49_META_TYP_1028_I3_D: "Warna Latar Belakang Kiri",
  T_49_META_TYP_1028_I4_D: "Warna Latar Belakang Kanan",
  T_49_META_TYP_1028_I5_D: "Nama Ikon Kiri",
  T_49_META_TYP_1028_I6_D: "Nama Ikon Kanan",
  T_49_META_TYP_1029_I1_D: "Nama Ikon",
  T_49_META_TYP_1029_I2_D: "Nama Ikon Latar Belakang",
  T_49_META_TYP_103_I0_D: "Senjata Utama A",
  T_49_META_TYP_103_I1_D: "Senjata Utama B",
  T_49_META_TYP_103_I10_D: "Bom Beku",
  T_49_META_TYP_103_I11_D: "Dinding Es",
  T_49_META_TYP_103_I12_D: "Ranjau Tanah",
  T_49_META_TYP_103_I13_D: "Menara Otomatis",
  T_49_META_TYP_103_I14_D: "Granat Palsu",
  T_49_META_TYP_103_I16_D: "Skateboard, Kamuflase ....",
  T_49_META_TYP_103_I2_D: "Senjata Sekunder",
  T_49_META_TYP_103_I3_D: "Senjata Ledakan",
  T_49_META_TYP_103_I5_D: "Senjata Berat",
  T_49_META_TYP_1030_I3_D: "Jumlah Pemain Hidup Kiri",
  T_49_META_TYP_1030_I4_D: "Jumlah Pemain Hidup Kanan",
  T_49_META_TYP_1030_I5_D: "Nama ikon tim kiri",
  T_49_META_TYP_1030_I6_D: "Nama ikon tim kanan",
  T_49_META_TYP_1031_I2_D: "Deskripsi pesan",
  T_49_META_TYP_1031_I3_D: "Cap waktu mulai hitung mundur, dalam detik",
  T_49_META_TYP_1031_I4_D: "Parameter Deskripsi",
  T_49_META_TYP_1032_I1_D: "Jenis Tips",
  T_49_META_TYP_1032_I3_D: "Parameter",
  T_49_META_TYP_1033_I1_D: "Pindah fase, 0 adalah ronde saat ini, 1 adalah awal ronde berikutnya.",
  T_49_META_TYP_1033_I10_D: "Teks prompt Kekalahan, tidak diisi sebagai default",
  T_49_META_TYP_1033_I11_D: "Judul Pendapatan Putaran",
  T_49_META_TYP_1033_I12_D: "Pendapatan Putaran",
  T_49_META_TYP_1033_I13_D: "Judul Detail Penghasilan per Ronde",
  T_49_META_TYP_1033_I14_D: "Daftar detail nilai pendapatan bulat, sesuai dengan daftar judul detail di atas satu per satu",
  T_49_META_TYP_1033_I15_D: "Nama panggilan pemain MVP",
  T_49_META_TYP_1033_I16_D: "Indeks Putaran Berikutnya",
  T_49_META_TYP_1033_I17_D: "Apakah Titik Pertandingan",
  T_49_META_TYP_1033_I18_D: "Apakah Putaran Terakhir",
  T_49_META_TYP_1033_I6_D: "Nama ikon tim kiri",
  T_49_META_TYP_1033_I7_D: "Nama ikon tim kanan",
  T_49_META_TYP_1033_I8_D: "Bergantung pada nilainya, status yang sesuai akan ditampilkan, Kemenangan (1), Kekalahan (2).",
  T_49_META_TYP_1033_I9_D: "Teks prompt kemenangan, default jika tidak diisi",
  T_49_META_TYP_1036_I1_D: "Menunjukkan berapa banyak level yang ada secara total",
  T_49_META_TYP_1036_I2_D: "Menunjukkan level bot saat ini",
  T_49_META_TYP_1037_I1_D: "Menunjukkan berapa banyak poin yang ditampilkan",
  T_49_META_TYP_1039_I3_D: "Stempel waktu mulai hitung mundur, dalam hitungan detik",
  T_49_META_TYP_104_I0_D: "Gaya A",
  T_49_META_TYP_104_I1_D: "Gaya B",
  T_49_META_TYP_104_I2_D: "Gaya C",
  T_49_META_TYP_1040_I10_D: "Deskripsi Kartu",
  T_49_META_TYP_1040_I11_D: "Indeks item yang dipilih, mulai dari 0, kurang dari 0 berarti tidak dipilih.",
  T_49_META_TYP_1040_I12_D: "Nama Tombol",
  T_49_META_TYP_1040_I13_D: "Warna Tombol",
  T_49_META_TYP_1040_I2_D: "Kunci Hitung Mundur",
  T_49_META_TYP_1040_I3_D: "Waktu Hitung Mundur",
  T_49_META_TYP_1040_I4_D: "Kunci Deskripsi",
  T_49_META_TYP_1040_I5_D: "Array parameter deskripsi",
  T_49_META_TYP_1040_I6_D: "Latar Belakang Kartu",
  T_49_META_TYP_1040_I7_D: "Warna Latar Belakang Kartu",
  T_49_META_TYP_1040_I8_D: "Ikon Kartu",
  T_49_META_TYP_1040_I9_D: "Nama Kartu",
  T_49_META_TYP_1041_I2_D: "Posisi",
  T_49_META_TYP_1041_I3_D: "Ikon",
  T_49_META_TYP_1041_I4_D: "Label",
  T_49_META_TYP_1041_I5_D: "Warna Latar Belakang",
  T_49_META_TYP_1042_I1_D: "Posisi Lokal",
  T_49_META_TYP_1043_I4_D: "Warna Teks",
  T_49_META_TYP_1043_I5_D: "Kunci Label",
  T_49_META_TYP_1043_I6_D: "Parameter Label",
  T_49_META_TYP_1045_I2_D: "Ikon tombol",
  T_49_META_TYP_1045_I3_D: "Warna Ikon",
  T_49_META_TYP_1045_I4_D: "Ukuran, lebar dan tinggi yang sama",
  T_49_META_TYP_1045_I5_D: "Posisi relatif terhadap jangkar di sudut kanan bawah",
  T_49_META_TYP_1045_I6_D: "Jumlah muatan, kurang dari 0 berarti tersembunyi",
  T_49_META_TYP_1045_I7_D: "Waktu mulai CD, dalam milidetik",
  T_49_META_TYP_1045_I8_D: "Durasi CD, dalam milidetik",
  T_49_META_TYP_1045_I9_D: "Benar, tombol akan berwarna abu-abu, Salah, tombol akan dipulihkan.",
  T_49_META_TYP_106_I1_D: "Aktifkan",
  T_49_META_TYP_106_I2_D: "Nonaktifkan",
  T_49_META_TYP_109_I0_D: "ID Saluran Chat",
  T_49_META_TYP_109_I1_D: "Daftar Pemain",
  T_49_META_TYP_11_I0_D: "Apakah game saat ini dalam keadaan ilegal, ketika dalam keadaan ilegal, itu berarti game telah kehilangan nilai konfrontasi, dan disarankan untuk mengakhiri game secara langsung.",
  T_49_META_TYP_11_I1_D: "Lamanya permainan saat ini, dalam milidetik.",
  T_49_META_TYP_11_I10_D: "Apakah akan mengatur ulang peralatan setiap giliran",
  T_49_META_TYP_11_I11_D: "Apakah akan mengaktifkan mekanik Cincin Racun atau tidak",
  T_49_META_TYP_11_I12_D: "Ukuran Zona Aman",
  T_49_META_TYP_11_I13_D: "Waktu Mulai Penyusutan",
  T_49_META_TYP_11_I14_D: "Durasi Penyusutan",
  T_49_META_TYP_11_I15_D: "Damage Luar Zona",
  T_49_META_TYP_11_I18_D: "Tipe Revival",
  T_49_META_TYP_11_I2_D: "Indeks giliran saat ini, melalui nilai ini Anda bisa mendapatkan entitas giliran saat ini.",
  T_49_META_TYP_11_I27_D: "Jumlah Total Ronde",
  T_49_META_TYP_11_I3_D: "Indeks tahap saat ini, melalui nilai ini Anda bisa mendapatkan entitas tahap saat ini.",
  T_49_META_TYP_11_I32_D: "Jumlah koin yang diperoleh di awal ronde",
  T_49_META_TYP_11_I33_D: "Jumlah koin untuk membunuh",
  T_49_META_TYP_11_I34_D: "Jumlah koin yang diperoleh saat menang",
  T_49_META_TYP_11_I35_D: "Apakah akan menampilkan UI dompet",
  T_49_META_TYP_11_I36_D: "Entitas Skybox",
  T_49_META_TYP_11_I37_D: "Frame berjalan kumulatif sejak permainan dimulai",
  T_49_META_TYP_11_I38_D: "Dapat Bergerak",
  T_49_META_TYP_11_I39_D: "Apakah akan menyesuaikan penyelesaian",
  T_49_META_TYP_11_I4_D: "ID template dari mode UGC yang telah ditetapkan",
  T_49_META_TYP_11_I40_D: "Apakah akan mengizinkan bergabung di tengah permainan",
  T_49_META_TYP_11_I41_D: "Mengaktifkan mode kecepatan bingkai rendah, game akan berjalan pada 15FPS, jika tidak, 30FPS",
  T_49_META_TYP_11_I42_D: "Interval pembaruan bingkai logis antara dua pembaruan server game",
  T_49_META_TYP_11_I43_D: "Memperbaiki interval pembaruan bingkai dalam milidetik",
  T_49_META_TYP_11_I5_D: "Nonaktifkan kebangkitan pemain jika tidak aktif",
  T_49_META_TYP_11_I6_D: "Nonaktifkan kebangkitan Bot jika tidak aktif",
  T_49_META_TYP_11_I7_D: "Durasi kebangkitan dalam hitungan detik",
  T_49_META_TYP_11_I8_D: "Jumlah total tim dalam permainan",
  T_49_META_TYP_11_I9_D: "Jumlah anggota di setiap tim",
  T_49_META_TYP_110_I0_D: "Kanal A",
  T_49_META_TYP_110_I1_D: "Kanal B",
  T_49_META_TYP_110_I2_D: "Kanal C",
  T_49_META_TYP_110_I3_D: "Kanal D",
  T_49_META_TYP_110_I4_D: "Kanal E",
  T_49_META_TYP_110_I5_D: "Kanal F",
  T_49_META_TYP_111_I1_D: "Lari Cepat (Sprint)",
  T_49_META_TYP_111_I2_D: "Serang",
  T_49_META_TYP_111_I3_D: "Lompat",
  T_49_META_TYP_111_I4_D: "Memanjat",
  T_49_META_TYP_111_I5_D: "Mengemudi",
  T_49_META_TYP_111_I6_D: "Masuk Kendaraan",
  T_49_META_TYP_111_I7_D: "Keluar Kendaraan",
  T_49_META_TYP_111_I8_D: "Kendarai Kendaraan",
  T_49_META_TYP_112_I0_D: "Aktifkan",
  T_49_META_TYP_112_I1_D: "Nonaktifkan",
  T_49_META_TYP_112_I2_D: "Tidak Terlihat",
  T_49_META_TYP_117_I0_D: "Tepuk tangan",
  T_49_META_TYP_117_I1_D: "Hi-Hat",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "Hi-Hat Terbuka",
  T_49_META_TYP_117_I4_D: "Ride",
  T_49_META_TYP_117_I5_D: "Snare",
  T_49_META_TYP_118_I0_D: "Apakah semua anggota kamp dalam keadaan mati",
  T_49_META_TYP_118_I1_D: "Daftar semua anggota tim",
  T_49_META_TYP_118_I2_D: "Faksi Sekutu",
  T_49_META_TYP_118_I3_D: "Faksi yang Bisa Diserang",
  T_49_META_TYP_118_I4_D: "Apakah akan menampilkan nama UI",
  T_49_META_TYP_118_I5_D: "Apakah akan menampilkan informasi peta",
  T_49_META_TYP_118_I6_D: 'Apakah akan "menampilkan" atau tidak',
  T_49_META_TYP_118_I7_D: 'Apakah akan "menampilkan" atau tidak',
  T_49_META_TYP_118_I8_D: "Semua Anggota",
  T_49_META_TYP_118_I9_D: "Tampilkan Pesan Cepat",
  T_49_META_TYP_119_I0_D: "Ya",
  T_49_META_TYP_119_I1_D: "Tidak",
  T_49_META_TYP_120_I1_D: "Entitas target yang akan diikuti, standarnya kosong",
  T_49_META_TYP_120_I2_D: "Warna UI",
  T_49_META_TYP_120_I3_D: "Panjang UI",
  T_49_META_TYP_120_I4_D: "Nilai kemajuan saat ini, 0 hingga 1,0",
  T_49_META_TYP_120_I5_D: "Posisi tampilan, ketika ada target untuk diikuti, itu adalah offset relatif terhadap asal target, ketika tidak ada target untuk diikuti, itu adalah koordinat layar, defaultnya adalah Vector3 (0)",
  T_49_META_TYP_121_I0_D: "3 Detik",
  T_49_META_TYP_121_I1_D: "5 Detik",
  T_49_META_TYP_121_I2_D: "10 Detik",
  T_49_META_TYP_121_I3_D: "15 Detik",
  T_49_META_TYP_121_I4_D: "30 Detik",
  T_49_META_TYP_121_I5_D: "9999 Detik",
  T_49_META_TYP_122_I0_D: "Sumber Kotak Langit",
  T_49_META_TYP_122_I1_D: "Warna Cahaya",
  T_49_META_TYP_122_I10_D: "GUID sub-adegan",
  T_49_META_TYP_122_I11_D: "Sakelar fungsi kabut",
  T_49_META_TYP_122_I12_D: "Mode efek kabut",
  T_49_META_TYP_122_I13_D: "Kepadatan kabut eksponensial",
  T_49_META_TYP_122_I14_D: "Jarak awal kabut linier",
  T_49_META_TYP_122_I15_D: "Jarak akhir kabut linier",
  T_49_META_TYP_122_I16_D: "Mengaktifkan fitur efek kabut",
  T_49_META_TYP_122_I17_D: "Sudut rotasi sumber cahaya utama",
  T_49_META_TYP_122_I18_D: "Mengaktifkan fitur sudut rotasi sumber cahaya utama",
  T_49_META_TYP_122_I2_D: "Intensitas Cahaya",
  T_49_META_TYP_122_I3_D: "Kegelapan",
  T_49_META_TYP_122_I4_D: "Kekuatan Bayangan",
  T_49_META_TYP_122_I5_D: "Kebasahan Medan",
  T_49_META_TYP_122_I6_D: "Lens Flare",
  T_49_META_TYP_122_I7_D: "Warna Kabut",
  T_49_META_TYP_122_I8_D: "Warna Ambiens",
  T_49_META_TYP_123_I0_D: "Hari",
  T_49_META_TYP_123_I1_D: "Malam",
  T_49_META_TYP_123_I2_D: "Senja",
  T_49_META_TYP_123_I3_D: "View Kota",
  T_49_META_TYP_123_I4_D: "Langit Penuh Warna",
  T_49_META_TYP_123_I5_D: "Frost Moon",
  T_49_META_TYP_124_I0_D: "Jarak Dekat",
  T_49_META_TYP_124_I1_D: "Jarak Sedang",
  T_49_META_TYP_124_I2_D: "Jarak jauh",
  T_49_META_TYP_125_I0_D: "Warna Diffuse",
  T_49_META_TYP_125_I2_D: "Teksture Diffuse",
  T_49_META_TYP_125_I4_D: "Alpha Diffuse",
  T_49_META_TYP_126_I1_D: "Nama",
  T_49_META_TYP_126_I2_D: "Nilai kemajuan saat ini",
  T_49_META_TYP_126_I3_D: "Nilai kemajuan maksimum",
  T_49_META_TYP_126_I4_D: "Koordinat layar, standarnya adalah Vector3(0).",
  T_49_META_TYP_126_I5_D: "panjang bilah kemajuan, defaultnya adalah panjang UI pada prefab.",
  T_49_META_TYP_127_I0_D: "Mendulang di sepanjang sumbu, dapat dikombinasikan dalam tiga sumbu",
  T_49_META_TYP_127_I1_D: "Putar sepanjang sumbu, dapat dikombinasikan dalam tiga sumbu",
  T_49_META_TYP_127_I2_D: "Memperbesar sepanjang sumbu, dapat dikombinasikan dengan tiga sumbu",
  T_49_META_TYP_128_I0_D: "Semak",
  T_49_META_TYP_128_I1_D: "Labu",
  T_49_META_TYP_128_I2_D: "Penghuni",
  T_49_META_TYP_128_I3_D: "Lemari",
  T_49_META_TYP_129_I0_D: "Jarahan Acak",
  T_49_META_TYP_129_I1_D: "Amunisi AR",
  T_49_META_TYP_129_I2_D: "Amunisi SMG",
  T_49_META_TYP_129_I3_D: "Amunisi SN",
  T_49_META_TYP_129_I4_D: "Amunisi HG",
  T_49_META_TYP_129_I5_D: "Peluru SG",
  T_49_META_TYP_129_I6_D: "Amunisi Busur",
  T_49_META_TYP_13_I1_D: "Koordinat jangkar relatif terhadap simpul induk.",
  T_49_META_TYP_13_I10_D: "Perbedaan ukuran bingkai widget dan jangkar",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Kedalaman",
  T_49_META_TYP_13_I14_D: "Urutan semua anak dalam simpul induk yang sama",
  T_49_META_TYP_13_I15_D: "ID Induk",
  T_49_META_TYP_13_I16_D: "ID unik",
  T_49_META_TYP_13_I17_D: "Prioritas",
  T_49_META_TYP_13_I18_D: "Posisi Aktual",
  T_49_META_TYP_13_I2_D: "Lebar",
  T_49_META_TYP_13_I4_D: "Sudut rotasi sumbu Z",
  T_49_META_TYP_13_I6_D: "ID internal dari kontrol di prefab",
  T_49_META_TYP_13_I7_D: "Entitas UI di mana ia berada",
  T_49_META_TYP_13_I8_D: "Jangkar Minimum",
  T_49_META_TYP_13_I9_D: "Jangkar Maksimum",
  T_49_META_TYP_130_I0_D: "Harta Karun Habis Pakai Acak",
  T_49_META_TYP_130_I1_D: "Kot Medis",
  T_49_META_TYP_130_I2_D: "Kit Perbaikan",
  T_49_META_TYP_130_I3_D: "Garis Horisontal",
  T_49_META_TYP_130_I4_D: "Inhaler",
  T_49_META_TYP_131_I0_D: "Harta Karun Baju Besi Acak",
  T_49_META_TYP_131_I1_D: "Baju Besi Level 1",
  T_49_META_TYP_131_I2_D: "Baju Besi Sekunder",
  T_49_META_TYP_131_I3_D: "Armor Tingkat 3",
  T_49_META_TYP_132_I0_D: "Harta Karun Objek Lempar Acak",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Pembekuan Cepat",
  T_49_META_TYP_133_I0_D: "Harta Karun Pengganda Acak",
  T_49_META_TYP_133_I1_D: "2x Alcance",
  T_49_META_TYP_133_I2_D: "4x Alcance",
  T_49_META_TYP_133_I3_D: "Cermin Termal",
  T_49_META_TYP_134_I0_D: "Loot Senjata Acak",
  T_49_META_TYP_134_I5_D: "Senapan Pompa",
  T_49_META_TYP_134_I8_D: "Senapan Sepak Bola",
  T_49_META_TYP_135_I0_D: "Poin peluru jarahan",
  T_49_META_TYP_136_I0_D: "Poin Jarahan yang Dapat Dikonsumsi",
  T_49_META_TYP_137_I0_D: "Poin Harta Karun yang Dapat Dikonsumsi",
  T_49_META_TYP_138_I0_D: "Poin Pengganda Harta Karun",
  T_49_META_TYP_139_I0_D: "Menjarah Poin Armor",
  T_49_META_TYP_14_I0_D: "Level darah pemain saat ini",
  T_49_META_TYP_14_I1_D: "Maksimum darah pemain saat ini",
  T_49_META_TYP_14_I11_D: "Kamp pemain",
  T_49_META_TYP_14_I12_D: "Pengganda kerusakan pemain, misalnya 2x dikonfigurasi sebagai 2.0",
  T_49_META_TYP_14_I13_D: "Menggunakan kerangka yang sama persis dengan karakter pria atau wanita, 0 berarti tidak ada penggantian model",
  T_49_META_TYP_14_I14_D: "Tidak bertentangan dengan penskalaan kecepatan yang ada",
  T_49_META_TYP_14_I15_D: "Tidak bertentangan dengan penskalaan tinggi lompatan yang ada",
  T_49_META_TYP_14_I16_D: "Identitas, 0 Pemain Normal, 1 Pemburu, 2 Zombie Matriks, 3 Zombie Normal, 4 Zombie Berevolusi Tipe 1, 5 Zombie Berevolusi Tipe 2, 6 Zombie Berevolusi Tipe 3",
  T_49_META_TYP_14_I17_D: "Tingkat zombie, 1 ~ 3",
  T_49_META_TYP_14_I19_D: "Nama panggilan pemain",
  T_49_META_TYP_14_I2_D: "Tentukan apakah pemain saat ini adalah pemain AI, AI biasanya adalah monster NPC atau PVE.",
  T_49_META_TYP_14_I20_D: "Persentase kerusakan yang diberikan saat menerima kerusakan, dapat dikurangi atau ditingkatkan",
  T_49_META_TYP_14_I21_D: "EP pemain saat ini",
  T_49_META_TYP_14_I22_D: "EP maksimum pemain",
  T_49_META_TYP_14_I23_D: "Senjata utama yang sedang dipegang",
  T_49_META_TYP_14_I24_D: "Hilang saat dieliminasi",
  T_49_META_TYP_14_I26_D: "Jenis Bantuan Bidik",
  T_49_META_TYP_14_I27_D: "Memungkinkan Kunci dengan Bantuan",
  T_49_META_TYP_14_I28_D: "Mengaktifkan/menonaktifkan obrolan suara: benar untuk mematikan suara, salah untuk mengaktifkan suara",
  T_49_META_TYP_14_I29_D: "Mengganti obrolan cepat: benarTutup suara, salahBuka suara",
  T_49_META_TYP_14_I3_D: "Status Pemain",
  T_49_META_TYP_14_I30_D: "Saluran",
  T_49_META_TYP_14_I35_D: "Mengganti pengambilan: benarTidak bisa mengambil, salahBisa mengambil",
  T_49_META_TYP_14_I36_D: "Beralih Buang Item: benarTidak dapat membuang, salahDapat membuang",
  T_49_META_TYP_14_I37_D: "Sasaran yang Bisa Diserang",
  T_49_META_TYP_14_I38_D: "Pemain Teman",
  T_49_META_TYP_14_I39_D: "Faksi",
  T_49_META_TYP_14_I4_D: "Waktu bertahan hidup pemain, jika pemain mati, waktu akan dihitung ulang.",
  T_49_META_TYP_14_I40_D: "Nomor dalam Faksi",
  T_49_META_TYP_14_I41_D: "Kamera yang digunakan pemain",
  T_49_META_TYP_14_I42_D: "Gravitasi Kustom",
  T_49_META_TYP_14_I43_D: "Helm",
  T_49_META_TYP_14_I44_D: "Rompi",
  T_49_META_TYP_14_I5_D: "Ketidakkekalahan pemain",
  T_49_META_TYP_14_I52_D: "UID Pengguna",
  T_49_META_TYP_14_I53_D: "Pengurangan Kerusakan Kepala",
  T_49_META_TYP_14_I54_D: "AVATAR pemain terikat dengan",
  T_49_META_TYP_14_I55_D: "Jenis",
  T_49_META_TYP_14_I56_D: "ID Skin Senjata",
  T_49_META_TYP_14_I57_D: "Titik kelahiran pemain",
  T_49_META_TYP_14_I58_D: "Titik kebangkitan pemain, jika tidak ada pos pemeriksaan yang dicatat maka titik kelahiran yang digunakan, jika tidak, pos pemeriksaan yang digunakan",
  T_49_META_TYP_14_I59_D: "Posisi pemain saat ini",
  T_49_META_TYP_14_I6_D: "Entitas tim tempat pemain berada",
  T_49_META_TYP_14_I60_D: "Orientasi pemain saat ini",
  T_49_META_TYP_14_I61_D: "Node yang digunakan untuk mengakses kerangka yang dikuliti",
  T_49_META_TYP_14_I62_D: "Backpack",
  T_49_META_TYP_14_I63_D: "Poin Perisai Sementara",
  T_49_META_TYP_14_I64_D: "ID Kulit Kendaraan",
  T_49_META_TYP_14_I65_D: "Lewati Animasi Jatuh",
  T_49_META_TYP_14_I66_D: "Tidak ada Damage Jatuh",
  T_49_META_TYP_14_I67_D: "Item yang Sedang Digenggam",
  T_49_META_TYP_14_I68_D: "Daftar Item yang Diban",
  T_49_META_TYP_14_I69_D: "ID sumber daya pemain",
  T_49_META_TYP_14_I7_D: "ID pos pemeriksaan saat ini",
  T_49_META_TYP_14_I70_D: "Target yang menjadi tujuan pengiriman pesan Permintaan untuk Membeli",
  T_49_META_TYP_14_I71_D: "ID sumber daya dari Emote yang sedang dimainkan",
  T_49_META_TYP_14_I72_D: "Apakah Emote yang sedang dimainkan sedang mengulang",
  T_49_META_TYP_14_I73_D: "Penanganan status knockdown",
  T_49_META_TYP_14_I74_D: "Apakah akan mengaktifkan lompatan kerusakan, standarnya adalah True, yang berarti diaktifkan",
  T_49_META_TYP_14_I76_D: "Apakah akan keluar di tengah permainan",
  T_49_META_TYP_14_I77_D: "Informasi pakaian yang akan disimpan saat pemain berubah menjadi karakter lain",
  T_49_META_TYP_14_I8_D: "ID pos pemeriksaan yang dituju oleh target",
  T_49_META_TYP_140_I0_D: "Gelombang 1",
  T_49_META_TYP_140_I1_D: "Gelombang 2",
  T_49_META_TYP_140_I2_D: "Gelombang 3",
  T_49_META_TYP_140_I3_D: "Berkelanjutan",
  T_49_META_TYP_141_I0_D: "Rampasan Sepak Bola Acak",
  T_49_META_TYP_141_I1_D: "Perisai Sepak Bola",
  T_49_META_TYP_141_I2_D: "Granat Beku",
  T_49_META_TYP_142_I0_D: "Loot Sepakbola",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Klasik (Menembak)",
  T_49_META_TYP_147_I1_D: "Orang Ketiga",
  T_49_META_TYP_147_I2_D: "Orang Pertama (Menembak)",
  T_49_META_TYP_147_I3_D: "Tampilan atas",
  T_49_META_TYP_147_I4_D: "Gulir Horisontal",
  T_49_META_TYP_147_I5_D: "Kamera Kustom",
  T_49_META_TYP_147_I6_D: "Pengejaran ke belakang",
  T_49_META_TYP_147_I7_D: "Kamera yang dikendalikan pemain dan bergerak bebas",
  T_49_META_TYP_147_I8_D: "Versi baru kamera tampilan orang pertama",
  T_49_META_TYP_148_I0_D: "Beberapa jenis kamera yang telah ditetapkan sebelumnya, serta jenis kamera khusus.",
  T_49_META_TYP_148_I1_D: "Bidang pandang adalah sudut pandang kamera",
  T_49_META_TYP_148_I10_D: "Jenis animasi peralihan kamera",
  T_49_META_TYP_148_I11_D: "Waktu transisi dalam milidetik untuk beralih ke kamera ini, hanya jika jenis sakelar adalah Smooth",
  T_49_META_TYP_148_I12_D: "Mode gerak kamera apabila ada penghalang antara kamera dan target yang diikuti.",
  T_49_META_TYP_148_I13_D: "Cara kamera merender layar",
  T_49_META_TYP_148_I14_D: "Mengikuti sistem koordinat referensi pergeseran objek",
  T_49_META_TYP_148_I15_D: "Mengamati sistem koordinat referensi pergeseran objek",
  T_49_META_TYP_148_I16_D: "Layer mask rendering kamera, yang memungkinkan penyaringan objek yang dirender oleh kamera berdasarkan tingkat visibilitas",
  T_49_META_TYP_148_I17_D: "Pembatasan Sudut Pandang",
  T_49_META_TYP_148_I2_D: "Umumnya mengacu pada pergeseran posisi kamera dari posisi awal pemain, dengan arti yang berbeda untuk jenis kamera yang berbeda.",
  T_49_META_TYP_148_I3_D: "Fokus kamera adalah pergeseran titik fokus kamera dari posisi awal pemain, yang bervariasi menurut jenis kamera.",
  T_49_META_TYP_148_I4_D: "Sudut rotasi kamera pada arah vertikal",
  T_49_META_TYP_148_I5_D: "Sudut rotasi kamera pada arah horizontal",
  T_49_META_TYP_148_I7_D: "Target yang sedang diikuti kamera",
  T_49_META_TYP_148_I8_D: "Target yang sedang dilihat kamera",
  T_49_META_TYP_148_I9_D: "Pemain yang menggunakan kamera",
  T_49_META_TYP_15_I0_D: "Apakah semua pemain dalam tim saat ini sudah mati",
  T_49_META_TYP_15_I1_D: "Daftar semua pemain dalam tim",
  T_49_META_TYP_15_I3_D: "Daftar tim yang bermusuhan",
  T_49_META_TYP_15_I4_D: "Daftar tim yang bersahabat",
  T_49_META_TYP_15_I5_D: "Nomor tim",
  T_49_META_TYP_150_I0_D: "Daya Tahan",
  T_49_META_TYP_150_I1_D: "Jari-jari belahan pada ujung badan kapsul.",
  T_49_META_TYP_150_I2_D: "Faktor Kerusakan",
  T_49_META_TYP_152_I1_D: "Gravitasi Kustom",
  T_49_META_TYP_152_I2_D: "Jika perlu atau tidak perlu menampilkan pemicu, True adalah tampilkan.",
  T_49_META_TYP_154_I0_D: "Tidak dapat digunakan ganda",
  T_49_META_TYP_154_I1_D: "Hanya dapat digunakan ganda dalam kombinasi dengan senjata yang sama",
  T_49_META_TYP_154_I2_D: "Dapat dikombo dengan senjata lain dan juga dirimu sendiri",
  T_49_META_TYP_155_I0_D: "Level",
  T_49_META_TYP_155_I1_D: "Daya Tahan Maksimum",
  T_49_META_TYP_155_I2_D: "Durabilitas Saat Ini",
  T_49_META_TYP_155_I3_D: "Faktor Pengurangan Damage",
  T_49_META_TYP_155_I4_D: "Faktor Pengurangan Damage Ledakan",
  T_49_META_TYP_155_I5_D: "Bisa Mengurangi Durabilitas",
  T_49_META_TYP_155_I6_D: "Bisa Dihancurkan",
  T_49_META_TYP_156_I1_D: "Daya Tahan Maksimum",
  T_49_META_TYP_156_I2_D: "Durabilitas Saat Ini",
  T_49_META_TYP_156_I3_D: "Faktor Pengurangan Damage",
  T_49_META_TYP_156_I4_D: "Faktor Pengurangan Damage Ledakan",
  T_49_META_TYP_156_I5_D: "Bisa Mengurangi Durabilitas",
  T_49_META_TYP_156_I6_D: "Bisa Dihancurkan",
  T_49_META_TYP_157_I0_D: "Tidak ada animasi",
  T_49_META_TYP_157_I1_D: "Halus",
  T_49_META_TYP_158_I2_D: "Pencacahan jenis jangkar UI, nilai defaultnya adalah 9 (Tengah)",
  T_49_META_TYP_158_I6_D: "Kunci Label",
  T_49_META_TYP_158_I7_D: "Parameter Label",
  T_49_META_TYP_158_I8_D: "Tim Kiri",
  T_49_META_TYP_16_I1_D: "ID item dari entitas",
  T_49_META_TYP_16_I2_D: "Hanya untuk pemuatan objek statis, tentukan apakah ini adalah pembuatan NavMesh statis.",
  T_49_META_TYP_16_I3_D: "Apakah itu pemblokiran dinamis NavMesh atau tidak",
  T_49_META_TYP_16_I4_D: "Pemuatan asinkron",
  T_49_META_TYP_160_I0_D: "Batu A",
  T_49_META_TYP_160_I1_D: "Keramik A",
  T_49_META_TYP_160_I10_D: "Pasir A",
  T_49_META_TYP_160_I11_D: "Salju A",
  T_49_META_TYP_160_I12_D: "Kayu A",
  T_49_META_TYP_160_I13_D: "Nada A",
  T_49_META_TYP_160_I14_D: "Rumput B",
  T_49_META_TYP_160_I15_D: "Batu B",
  T_49_META_TYP_160_I16_D: "Batu C",
  T_49_META_TYP_160_I17_D: "Bersihkan",
  T_49_META_TYP_160_I2_D: "Keramik B",
  T_49_META_TYP_160_I3_D: "Keramik C",
  T_49_META_TYP_160_I4_D: "Bambu A",
  T_49_META_TYP_160_I5_D: "Semen A",
  T_49_META_TYP_160_I6_D: "Kontainer A",
  T_49_META_TYP_160_I7_D: "Rumput A",
  T_49_META_TYP_160_I8_D: "Es A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Apakah akan mengaktifkan tabrakan",
  T_49_META_TYP_165_I1_D: "Apakah akan bertindak sebagai pemicu atau tidak",
  T_49_META_TYP_165_I2_D: "Lapisan fisik, mengonfigurasi lapisan dalam modul fisika, hingga 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "Jenis Tekstur VFX",
  T_49_META_TYP_170_I0_D: "Terlihat atau tidak, klien berhenti merender target ketika tidak terlihat.",
  T_49_META_TYP_170_I1_D: "Tingkat visibilitas, nilai dalam kisaran [0,15], mempengaruhi visibilitas di kamera.",
  T_49_META_TYP_171_I0_D: "Energi",
  T_49_META_TYP_172_I0_D: "Jumlah peluru",
  T_49_META_TYP_173_I0_D: "Kapasitas Tambahan Backpack",
  T_49_META_TYP_173_I1_D: "Konfigurasi kulit di luar stasiun pemain diprioritaskan",
  T_49_META_TYP_173_I2_D: "ID kulit ransel, konfigurasi kulit ransel itu sendiri.",
  T_49_META_TYP_174_I2_D: "Damage Maksimum",
  T_49_META_TYP_174_I4_D: "Kecepatan Lempar",
  T_49_META_TYP_174_I5_D: "Penundaan ledakan, dalam detik",
  T_49_META_TYP_174_I6_D: "Rasio Self-Damage",
  T_49_META_TYP_174_I7_D: "Faktor Damage Friendly Fire",
  T_49_META_TYP_174_I8_D: "Rasio Faktor Kendaraan",
  T_49_META_TYP_174_I9_D: "Kulit",
  T_49_META_TYP_175_I0_D: "Radius Area Beku",
  T_49_META_TYP_175_I1_D: "Durasi area beku dalam detik",
  T_49_META_TYP_176_I0_D: "Jenis utama senjata",
  T_49_META_TYP_176_I1_D: "Tipe Senjata",
  T_49_META_TYP_177_I0_D: "Apabila terdapat rintangan di antara kamera dan objek yang akan diikuti, kamera tidak akan berubah.",
  T_49_META_TYP_177_I1_D: "Apabila terdapat halangan antara kamera dan objek berikut, kamera akan mendorong lebih dekat ke objek berikut.",
  T_49_META_TYP_177_I2_D: "Apabila terdapat halangan antara kamera dan objek, maka halangan tersebut akan menjadi tembus pandang.",
  T_49_META_TYP_178_I0_D: "Apabila kamera melihat objek, objek yang dekat akan terlihat besar dan objek yang jauh akan terlihat kecil",
  T_49_META_TYP_178_I1_D: "Objek yang dekat dan jauh memiliki ukuran yang sama ketika kamera melihatnya.",
  T_49_META_TYP_184_I0_D: "UUID sumber daya yang akan dirender.",
  T_49_META_TYP_185_I0_D: "Model mesh yang akan digunakan untuk rendering",
  T_49_META_TYP_185_I1_D: "Daftar material yang akan digunakan untuk rendering",
  T_49_META_TYP_187_I0_D: "ID item",
  T_49_META_TYP_190_I0_D: "Status terbuka",
  T_49_META_TYP_190_I1_D: "Hasil pencocokan",
  T_49_META_TYP_190_I10_D: "Daftar Skor 1",
  T_49_META_TYP_190_I11_D: "Daftar Skor 2",
  T_49_META_TYP_190_I12_D: "Daftar Skor 3",
  T_49_META_TYP_190_I13_D: "MVP Kemenangan",
  T_49_META_TYP_190_I14_D: "MVP Kekalahan",
  T_49_META_TYP_190_I15_D: "Tampilkan Detail Pertandingan",
  T_49_META_TYP_190_I16_D: "Tampilkan Evaluasi Peta",
  T_49_META_TYP_190_I17_D: "Tampilkan Hadiah",
  T_49_META_TYP_190_I18_D: "Tampilkan Laporan",
  T_49_META_TYP_190_I19_D: "Tampilkan Replay",
  T_49_META_TYP_190_I20_D: "Tampilkan Bagikan",
  T_49_META_TYP_190_I21_D: "Tampilkan Kembali ke Lobi",
  T_49_META_TYP_190_I22_D: "Tampilkan Suka",
  T_49_META_TYP_190_I23_D: "Tampilkan Tambah Teman",
  T_49_META_TYP_190_I24_D: "Tampilkan Ekonomi Eksternal",
  T_49_META_TYP_190_I4_D: "Tim Kanan",
  T_49_META_TYP_190_I5_D: "Judul",
  T_49_META_TYP_190_I6_D: "Peringkat Pemain",
  T_49_META_TYP_190_I9_D: "Judul",
  T_49_META_TYP_191_I0_D: "Jarak Pusat",
  T_49_META_TYP_191_I4_D: "Durasi lampu kilat tengah dalam milidetik",
  T_49_META_TYP_191_I5_D: "Durasi lampu kilat tepi dalam milidetik",
  T_49_META_TYP_191_I6_D: "Sakelar Efek Hit Flashbang",
  T_49_META_TYP_192_I3_D: "Durasi efek, dalam detik",
  T_49_META_TYP_193_I1_D: "Judul Pertandingan Kiri",
  T_49_META_TYP_193_I10_D: "Daftar Skor 1",
  T_49_META_TYP_193_I11_D: "Daftar Skor 2",
  T_49_META_TYP_193_I12_D: "Daftar Skor 3",
  T_49_META_TYP_193_I13_D: "Daftar Skor 4",
  T_49_META_TYP_193_I14_D: "Daftar Skor 5",
  T_49_META_TYP_193_I15_D: "MVP Kemenangan",
  T_49_META_TYP_193_I16_D: "MVP Kekalahan",
  T_49_META_TYP_193_I17_D: "Tampilkan Detail Pertandingan",
  T_49_META_TYP_193_I18_D: "Tampilkan Evaluasi Peta",
  T_49_META_TYP_193_I19_D: "Tampilkan Hadiah",
  T_49_META_TYP_193_I2_D: "Judul Pertandingan Kanan",
  T_49_META_TYP_193_I20_D: "Tampilkan Laporan",
  T_49_META_TYP_193_I21_D: "Tampilkan Replay",
  T_49_META_TYP_193_I22_D: "Tampilkan Bagikan",
  T_49_META_TYP_193_I23_D: "Tampilkan Kembali ke Lobi",
  T_49_META_TYP_193_I24_D: "Tampilkan Suka",
  T_49_META_TYP_193_I25_D: "Tampilkan Tambah Teman",
  T_49_META_TYP_193_I26_D: "Tampilkan Ekonomi Eksternal",
  T_49_META_TYP_193_I3_D: "Hasil pertandingan",
  T_49_META_TYP_193_I4_D: "Peringkat Tim",
  T_49_META_TYP_193_I5_D: "Peringkat Pemain",
  T_49_META_TYP_193_I6_D: "Posisi tim",
  T_49_META_TYP_193_I7_D: "Judul Skor Utama",
  T_49_META_TYP_193_I8_D: "Skor Utama",
  T_49_META_TYP_193_I9_D: "Judul",
  T_49_META_TYP_194_I0_D: "Waktu untuk ranjau mulai berlaku, dalam detik",
  T_49_META_TYP_194_I1_D: "Radius pemicu",
  T_49_META_TYP_194_I2_D: "Lamanya waktu yang dibutuhkan untuk memicu ranjau dalam jangkauannya, dalam detik",
  T_49_META_TYP_194_I3_D: "Dapat memicu sendiri",
  T_49_META_TYP_194_I4_D: "Dapat dipicu oleh tim",
  T_49_META_TYP_194_I5_D: "Bisa Dipicu oleh Kendaraan",
  T_49_META_TYP_194_I6_D: "Durasi keberadaan ranjau, yang secara otomatis meledak ketika berakhir, sejak dijatuhkan, dalam detik",
  T_49_META_TYP_194_I7_D: "Bisa diserang",
  T_49_META_TYP_194_I8_D: "Nilai kehidupan",
  T_49_META_TYP_195_I0_D: "Sekali",
  T_49_META_TYP_195_I2_D: "Timbal balik",
  T_49_META_TYP_197_I0_D: "Apakah gelombang sedang dimainkan atau tidak",
  T_49_META_TYP_197_I1_D: "Tandai bit",
  T_49_META_TYP_197_I2_D: "Jika dicentang, maka akan dimainkan secara otomatis pada saat pembuatan.",
  T_49_META_TYP_198_I0_D: "Id prop dari lampiran",
  T_49_META_TYP_199_I0_D: "EP Maksimum",
  T_49_META_TYP_199_I1_D: "Biaya Energi",
  T_49_META_TYP_199_I10_D: "Rasio Kerusakan Jatuh",
  T_49_META_TYP_199_I11_D: "Energi Saat Ini",
  T_49_META_TYP_199_I2_D: "Biaya Energi Naik",
  T_49_META_TYP_199_I3_D: "Biaya Energi Sprint",
  T_49_META_TYP_199_I4_D: "Biaya Energi Rush",
  T_49_META_TYP_199_I5_D: "Kecepatan Horizontal Dasar",
  T_49_META_TYP_199_I6_D: "Kecepatan Horizontal Sprint",
  T_49_META_TYP_199_I7_D: "Kecepatan Vertikal Dasar",
  T_49_META_TYP_199_I8_D: "Kecepatan Vertikal Sprint",
  T_49_META_TYP_199_I9_D: "Jarak Sprint",
  T_49_META_TYP_200_I0_D: "ID Area",
  T_49_META_TYP_200_I1_D: "ID Game",
  T_49_META_TYP_201_I0_D: "Persentase perlambatan: persentase perlambatan kecepatan gerakan di perairan terbuka untuk objek air",
  T_49_META_TYP_203_I0_D: "entitas sasaran",
  T_49_META_TYP_203_I1_D: "ID Properti",
  T_49_META_TYP_203_I10_D: "Saat server game mulai berdetak",
  T_49_META_TYP_203_I11_D: "Nilai Awal",
  T_49_META_TYP_203_I12_D: "Nilai Akhir",
  T_49_META_TYP_203_I13_D: "Persentase lulus",
  T_49_META_TYP_203_I4_D: "Gaya Transisi",
  T_49_META_TYP_203_I6_D: "Durasi (detik)",
  T_49_META_TYP_203_I7_D: "Balik",
  T_49_META_TYP_203_I8_D: "Titik Kontrol",
  T_49_META_TYP_203_I9_D: "Sinkronisasi paksa dengan status server game",
  T_49_META_TYP_204_I0_D: "Tinggi Lompatan Maksimal",
  T_49_META_TYP_204_I1_D: "Persentase Kerusakan Jatuh",
  T_49_META_TYP_204_I2_D: "Pemulihan Energi",
  T_49_META_TYP_204_I3_D: "Konsumsi energi",
  T_49_META_TYP_204_I4_D: "Energi Maksimum",
  T_49_META_TYP_205_I0_D: "Ketinggian Terbang Minimum",
  T_49_META_TYP_205_I1_D: "Ketinggian Akhir Minimum",
  T_49_META_TYP_205_I2_D: "Kecepatan Horizontal Glide",
  T_49_META_TYP_205_I3_D: "Kecepatan Terbang Vertikal",
  T_49_META_TYP_205_I4_D: "Kecepatan Jatuh",
  T_49_META_TYP_205_I5_D: "Kecepatan Belok",
  T_49_META_TYP_205_I6_D: "Ketinggian Terbang Maksimal",
  T_49_META_TYP_205_I7_D: "Kecepatan Jatuh Setelah Ketinggian Berlebih",
  T_49_META_TYP_205_I8_D: "Akselerasi Perubahan Kecepatan",
  T_49_META_TYP_206_I0_D: "Kecepatan",
  T_49_META_TYP_206_I1_D: "Akselerasi",
  T_49_META_TYP_206_I10_D: "Sudut kemudi maksimum pada kecepatan tinggi",
  T_49_META_TYP_206_I11_D: "Laju dasar yang diinterpolasi untuk sudut kemudi kecepatan tinggi",
  T_49_META_TYP_206_I2_D: "Kecepatan Boost",
  T_49_META_TYP_206_I3_D: "Durasi sprint, dalam detik",
  T_49_META_TYP_206_I4_D: "Cooldown sprint, dalam detik",
  T_49_META_TYP_206_I6_D: "Lompat cd, dalam detik",
  T_49_META_TYP_206_I7_D: "Sprint cd setelah bermain skateboard, dalam detik",
  T_49_META_TYP_206_I8_D: "Tombol CD untuk Boost Naik",
  T_49_META_TYP_206_I9_D: "Naik ke papan cd, dalam hitungan detik",
  T_49_META_TYP_207_I1_D: "Indeks Awal",
  T_49_META_TYP_207_I2_D: "Posisi Akhir",
  T_49_META_TYP_207_I3_D: "ID Geser",
  T_49_META_TYP_207_I4_D: "ID Grup",
  T_49_META_TYP_207_I5_D: "Akhiri atau tidak",
  T_49_META_TYP_21_I0_D: "Tingkat dasar dari UI",
  T_49_META_TYP_210_I1_D: "Kecepatan Awal",
  T_49_META_TYP_210_I2_D: "Akselerasi",
  T_49_META_TYP_210_I3_D: "Perpindahan Maksimal",
  T_49_META_TYP_210_I4_D: "Posisi Dunia Awal",
  T_49_META_TYP_210_I5_D: "Sinkronisasi paksa informasi posisi oleh server game",
  T_49_META_TYP_211_I0_D: "Posisi Lokal",
  T_49_META_TYP_211_I1_D: "Posisi Dunia",
  T_49_META_TYP_212_I0_D: "Diri",
  T_49_META_TYP_212_I2_D: "Koordinat offset",
  T_49_META_TYP_213_I0_D: "Diri",
  T_49_META_TYP_213_I2_D: "Koordinat offset",
  T_49_META_TYP_215_I0_D: "Kemenangan",
  T_49_META_TYP_215_I1_D: "Kekalahan",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Seri",
  T_49_META_TYP_218_I0_D: "Intensitas",
  T_49_META_TYP_218_I1_D: "Jangkauan",
  T_49_META_TYP_218_I2_D: "Warna terang",
  T_49_META_TYP_22_I0_D: "Ditampilkan jika aktif, jika tidak, nonaktif",
  T_49_META_TYP_22_I1_D: "ID Prefab",
  T_49_META_TYP_22_I2_D: "ID dari kontrol terbesar saat ini",
  T_49_META_TYP_22_I3_D: "Tingkat dasar UI",
  T_49_META_TYP_22_I4_D: "Aktifkan Tampilan Pemain",
  T_49_META_TYP_22_I5_D: "Posisi Dunia",
  T_49_META_TYP_22_I6_D: "Apakah itu ada di dalam scene atau tidak",
  T_49_META_TYP_22_I7_D: "Rotasi dalam sistem koordinat dunia",
  T_49_META_TYP_22_I8_D: "Memperbesar sistem koordinat dunia",
  T_49_META_TYP_221_I0_D: "Penundaan pergantian gigi, semakin besar nilainya, semakin lambat kecepatan pergantian gigi",
  T_49_META_TYP_222_I0_D: "Penundaan pergantian gigi, semakin besar nilainya, semakin lambat pergantian gigi.",
  T_49_META_TYP_225_I0_D: "Kerusakan Turret",
  T_49_META_TYP_225_I1_D: "Interval Kerusakan (d)",
  T_49_META_TYP_225_I10_D: "Tembak hanya pada suatu sudut",
  T_49_META_TYP_225_I11_D: "Tingkat Pengurangan Kerusakan",
  T_49_META_TYP_225_I12_D: "Penetrasi Armor",
  T_49_META_TYP_225_I2_D: "Akurasi",
  T_49_META_TYP_225_I3_D: "Jangkauan",
  T_49_META_TYP_225_I4_D: "Kecepatan Sudut",
  T_49_META_TYP_225_I5_D: "Sudut Atas",
  T_49_META_TYP_225_I6_D: "Sudut Bawah",
  T_49_META_TYP_225_I7_D: "HP Maks",
  T_49_META_TYP_225_I8_D: "Waktu Hidup (d)",
  T_49_META_TYP_225_I9_D: "Jumlah Turret Maks",
  T_49_META_TYP_226_I0_D: "Nilai masa pakai turret saat ini",
  T_49_META_TYP_226_I1_D: "Aktifkan Serangan",
  T_49_META_TYP_227_I0_D: "Widget Sederhana",
  T_49_META_TYP_227_I1_D: "Widget Gambar",
  T_49_META_TYP_227_I10_D: "Widget Tekstur",
  T_49_META_TYP_227_I11_D: "Widget Profil",
  T_49_META_TYP_227_I12_D: "Widget Toggle",
  T_49_META_TYP_227_I13_D: "Widget Pad Sentuh",
  T_49_META_TYP_227_I14_D: "Widget Joystick",
  T_49_META_TYP_227_I15_D: "Widget social",
  T_49_META_TYP_227_I2_D: "Widget Label",
  T_49_META_TYP_227_I3_D: "Widget Tombol",
  T_49_META_TYP_227_I4_D: "Widget Label Input",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Panel Gulir",
  T_49_META_TYP_227_I7_D: "Grid",
  T_49_META_TYP_227_I8_D: "Widget Tata Letak",
  T_49_META_TYP_227_I9_D: "Widget Kontainer",
  T_49_META_TYP_231_I0_D: "Pemulihan Durabilitas",
  T_49_META_TYP_231_I1_D: "Interval waktu efektif, dalam detik",
  T_49_META_TYP_233_I2_D: "Waktu untuk kedaluwarsa, dalam detik",
  T_49_META_TYP_233_I4_D: "Nama sumber daya ikon",
  T_49_META_TYP_234_I0_D: "Waktu pemicu, dalam detik",
  T_49_META_TYP_234_I1_D: "Dapat memicu sendiri",
  T_49_META_TYP_234_I10_D: "Nilai masa pakai saat ini",
  T_49_META_TYP_234_I2_D: "Dapat dipicu oleh tim",
  T_49_META_TYP_234_I3_D: "Bisa Dipicu oleh Kendaraan",
  T_49_META_TYP_234_I4_D: "Durasi dalam hitungan detik",
  T_49_META_TYP_234_I5_D: "Bisa diserang",
  T_49_META_TYP_234_I6_D: "Nilai kehidupan",
  T_49_META_TYP_235_I0_D: "Nilai hidup maksimum",
  T_49_META_TYP_235_I2_D: "Jumlah Maksimum",
  T_49_META_TYP_237_I0_D: "Kecepatan Lempar",
  T_49_META_TYP_237_I1_D: "Kecepatan Tarikan Pemain",
  T_49_META_TYP_238_I0_D: "Warna Semprot",
  T_49_META_TYP_239_I0_D: "Kecepatan awal",
  T_49_META_TYP_239_I1_D: "Kecepatan akselerasi (mis. gravitasi)",
  T_49_META_TYP_24_I0_D: "Huru-hara",
  T_49_META_TYP_24_I1_D: "Senjata",
  T_49_META_TYP_24_I10_D: "Kerusakan akibat serangan airdrop, kerusakan akibat bunuh diri monster",
  T_49_META_TYP_24_I11_D: "Kerusakan Terbakar pada Ledakan Kendaraan",
  T_49_META_TYP_24_I12_D: "Ledakan Drum Minyak",
  T_49_META_TYP_24_I13_D: "Senjata Jenis Rudal",
  T_49_META_TYP_24_I14_D: "Monster",
  T_49_META_TYP_24_I15_D: "Zona Kerusakan",
  T_49_META_TYP_24_I17_D: "Keterampilan Karakter",
  T_49_META_TYP_24_I2_D: "Lempar Granat",
  T_49_META_TYP_24_I3_D: "Zona Aman",
  T_49_META_TYP_24_I4_D: "Kendaraan",
  T_49_META_TYP_24_I5_D: "Jatuh",
  T_49_META_TYP_24_I6_D: "Zona Kematian",
  T_49_META_TYP_24_I7_D: "Keluar",
  T_49_META_TYP_24_I8_D: "Terputus",
  T_49_META_TYP_24_I9_D: "Ledakan Kendaraan",
  T_49_META_TYP_241_I0_D: "Kecepatan traksi",
  T_49_META_TYP_241_I1_D: "Kecepatan ayunan",
  T_49_META_TYP_241_I2_D: "Nyalakan tombol traksi",
  T_49_META_TYP_241_I3_D: "Tombol ayun aktif",
  T_49_META_TYP_241_I4_D: "Titik jangkar gerak",
  T_49_META_TYP_241_I5_D: "Akselerasi Keluar dari Ayunan",
  T_49_META_TYP_242_I2_D: "Efek Kiri Aktif",
  T_49_META_TYP_242_I3_D: "Efek Kanan Aktif",
  T_49_META_TYP_242_I4_D: "Garis Tengah Aktif",
  T_49_META_TYP_242_I5_D: "Nilai",
  T_49_META_TYP_242_I7_D: "Posisi UI, hanya komponen XY yang valid",
  T_49_META_TYP_242_I8_D: "Posisi median [0,1]",
  T_49_META_TYP_243_I0_D: "Pakaian Atas",
  T_49_META_TYP_243_I1_D: "Pakaian Bawah",
  T_49_META_TYP_243_I2_D: "Sepatu",
  T_49_META_TYP_243_I3_D: "Rias Wajah",
  T_49_META_TYP_243_I4_D: "Hiasan Kepala",
  T_49_META_TYP_243_I5_D: "Pakaian Terusan",
  T_49_META_TYP_243_I6_D: "Aksesori Wajah",
  T_49_META_TYP_244_I0_D: "Konten teks yang akan ditampilkan",
  T_49_META_TYP_244_I10_D: "Anda dapat melihat daftar pemain dari entitas ini.",
  T_49_META_TYP_244_I11_D: "Tingkat tampilan",
  T_49_META_TYP_244_I2_D: "Ikuti Target",
  T_49_META_TYP_244_I3_D: "Ketika kedalaman diabaikan, maka dapat ditampilkan melalui dinding, jika tidak maka tidak akan berfungsi",
  T_49_META_TYP_244_I4_D: "Selalu Menghadap Kamera",
  T_49_META_TYP_244_I5_D: "Ketika diatur ke true, ketika posisi berada di luar layar, maka akan ditampilkan di dalam layar.",
  T_49_META_TYP_244_I6_D: "Gaya Font",
  T_49_META_TYP_244_I7_D: "Jenis font",
  T_49_META_TYP_244_I8_D: "Ukuran font",
  T_49_META_TYP_245_I0_D: "Jalur Efek Sumber Daya",
  T_49_META_TYP_245_I11_D: "Lapisan Tampilan",
  T_49_META_TYP_245_I3_D: "Ketika mengabaikan kedalaman, ini dapat ditampilkan melalui dinding, jika tidak maka tidak akan berfungsi.",
  T_49_META_TYP_245_I4_D: "Bila diatur ke true (Benar), bila posisinya berada di luar layar, maka akan ditampilkan di dalam layar.",
  T_49_META_TYP_245_I5_D: "Selalu Menghadap Kamera",
  T_49_META_TYP_245_I6_D: "Jenis Render",
  T_49_META_TYP_245_I7_D: "Lebar",
  T_49_META_TYP_246_I0_D: "Jeruk",
  T_49_META_TYP_246_I1_D: "Ungu",
  T_49_META_TYP_246_I2_D: "Merah",
  T_49_META_TYP_246_I3_D: "Hijau",
  T_49_META_TYP_246_I4_D: "Biru",
  T_49_META_TYP_247_I1_D: "Lari cepat",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Obrolan Cepat",
  T_49_META_TYP_247_I16_D: "Pengambilan Item",
  T_49_META_TYP_247_I17_D: "Tampilkan Obrolan Cepat",
  T_49_META_TYP_247_I18_D: "Kesehatan (HP)",
  T_49_META_TYP_247_I19_D: "Energi (EP)",
  T_49_META_TYP_247_I2_D: "Serang",
  T_49_META_TYP_247_I20_D: "Baju Zirah",
  T_49_META_TYP_247_I21_D: "Isi Ulang",
  T_49_META_TYP_247_I22_D: "Tombol Perubahan Cepat",
  T_49_META_TYP_247_I23_D: "Tombol Pembicara Pembawa",
  T_49_META_TYP_247_I24_D: "Tombol mengaktifkan/menonaktifkan suara (mikrofon)",
  T_49_META_TYP_247_I25_D: "Tombol penanda hidup/mati",
  T_49_META_TYP_247_I27_D: "Tombol mengaktifkan/menonaktifkan sinyal jaringan",
  T_49_META_TYP_247_I28_D: "Keterampilan Aktif",
  T_49_META_TYP_247_I29_D: "Bidikan",
  T_49_META_TYP_247_I3_D: "Lompat",
  T_49_META_TYP_247_I30_D: "Keterampilan Pasif",
  T_49_META_TYP_247_I4_D: "Tips Pembunuhan",
  T_49_META_TYP_247_I5_D: "Slot Senjata",
  T_49_META_TYP_247_I6_D: "Peta Mini",
  T_49_META_TYP_247_I7_D: "UI Ransel",
  T_49_META_TYP_247_I8_D: "Alat Medis",
  T_49_META_TYP_247_I9_D: "Ditampilkan ketika True, jika tidak, tidak aktif",
  T_49_META_TYP_249_I3_D: "Senjata Penghancur",
  T_49_META_TYP_249_I5_D: "Senjata Berat",
  T_49_META_TYP_249_I8_D: "Bom Beku",
  T_49_META_TYP_249_I9_D: "Granat Palsu",
  T_49_META_TYP_25_I0_D: "Indeks tahap saat ini, sesuai dengan indeks di editor alur",
  T_49_META_TYP_25_I1_D: "Waktu mulai tahap saat ini, dalam ms",
  T_49_META_TYP_25_I2_D: "Waktu akhir tahap saat ini, dalam ms",
  T_49_META_TYP_25_I3_D: "Durasi tahap saat ini, dalam ms",
  T_49_META_TYP_250_I1_D: "Warna efek khusus, RGBA empat saluran, rentang nilai saluran tunggal 0 ~ 255, disimpan dalam Int32.",
  T_49_META_TYP_250_I3_D: "Jenis Tekstur VFX",
  T_49_META_TYP_250_I4_D: "Alpha Diffuse",
  T_49_META_TYP_2500_I1_D: "Apakah Titik Spawn Default",
  T_49_META_TYP_2500_I3_D: "Apakah pemain sudah lahir di area tempat kelahiran atau belum.",
  T_49_META_TYP_2500_I4_D: "Koordinat lokasi titik kelahiran yang saat ini dapat ditetapkan",
  T_49_META_TYP_2502_I0_D: "Apakah itu pemicu kematian, jika bukan pemicu kematian, itu adalah pemicu tak terkalahkan. (Ini adalah masalah warisan dari OB32, harap pisahkan fungsinya di masa mendatang!)",
  T_49_META_TYP_2502_I1_D: "Apakah akan menampilkan batas pemicu, benar untuk ditampilkan",
  T_49_META_TYP_2503_I0_D: "ID Titik Pemeriksaan",
  T_49_META_TYP_2503_I2_D: "Lokasi pos pemeriksaan",
  T_49_META_TYP_2507_I0_D: "Di kubu mana menara itu berada, jika sama dengan pemain, menara tidak akan menyerang pemain.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "ID Objek",
  T_49_META_TYP_2507_I2_D: "HP Maksimum",
  T_49_META_TYP_2507_I3_D: "Kerusakan serangan, seberapa besar kerusakan yang dapat ditimbulkan oleh satu serangan terhadap pemain.",
  T_49_META_TYP_2507_I4_D: "Interval antara serangan, dalam hitungan detik.",
  T_49_META_TYP_2507_I5_D: "Serangan dapat dilakukan dalam radius pusat menara.",
  T_49_META_TYP_2507_I6_D: "Tingkat pengurangan kerusakan, angka desimal kurang dari 1, kerusakan akhir adalah kerusakan dikalikan dengan (1 - tingkat pengurangan kerusakan)",
  T_49_META_TYP_2507_I7_D: "Target Serangan",
  T_49_META_TYP_2507_I8_D: "Sudut",
  T_49_META_TYP_2507_I9_D: "Status Menara Mini",
  T_49_META_TYP_2508_I0_D: "Berapa banyak zombie yang akan muncul di setiap gelombang",
  T_49_META_TYP_2508_I1_D: "Berapa banyak gelombang zombie yang akan muncul secara total",
  T_49_META_TYP_2508_I2_D: "Apakah akan menelurkan terus menerus, tetapi akan ada batas atas dari layar yang sama.",
  T_49_META_TYP_2508_I3_D: "Berapa banyak gelombang yang akan muncul dalam gelombang saat ini?",
  T_49_META_TYP_2508_I5_D: "Jenis zombie apa yang muncul dalam gelombang saat ini",
  T_49_META_TYP_2508_I6_D: "Apakah AI menjatuhkan peralatan atau item saat mati.",
  T_49_META_TYP_2508_I7_D: "Waktu Mulai Spawn (s)",
  T_49_META_TYP_2508_I8_D: "Interval waktu antara gelombang berikutnya dan gelombang sebelumnya.",
  T_49_META_TYP_2509_I0_D: "Jumlah badan unit yang akan dihasilkan dalam setiap gelombang",
  T_49_META_TYP_2509_I1_D: "Berapa banyak gelombang generator unit yang akan dihasilkan secara total",
  T_49_META_TYP_2509_I2_D: "Berapa banyak gelombang yang saat ini dihasilkan",
  T_49_META_TYP_2509_I4_D: "Entitas mana yang akan digunakan sebagai template untuk menghasilkan setiap gelombang",
  T_49_META_TYP_2509_I5_D: "Kapan unit akan mulai menghasilkan",
  T_49_META_TYP_2509_I6_D: "Apakah mereka akan dibangkitkan secara terus menerus atau tidak, tetapi akan ada batas atas dari layar yang sama",
  T_49_META_TYP_2509_I7_D: "Interval waktu antara gelombang berikutnya dan gelombang sebelumnya.",
  T_49_META_TYP_2509_I8_D: "PrefabID dari templat",
  T_49_META_TYP_2510_I0_D: "Jumlah Titik Spawn",
  T_49_META_TYP_252_I1_D: "Ikon Kiri",
  T_49_META_TYP_252_I2_D: "Teks Kiri",
  T_49_META_TYP_252_I3_D: "Skor Kiri",
  T_49_META_TYP_252_I5_D: "Ikon Kanan",
  T_49_META_TYP_252_I6_D: "Teks Kanan",
  T_49_META_TYP_252_I7_D: "Skor Kanan",
  T_49_META_TYP_252_I8_D: "Progres [0,1]",
  T_49_META_TYP_253_I0_D: "Pilih Ikon",
  T_49_META_TYP_253_I1_D: "Teks",
  T_49_META_TYP_253_I2_D: "Efek Aktif",
  T_49_META_TYP_253_I3_D: "Posisi UI",
  T_49_META_TYP_254_I1_D: "mis. 1,25 berarti 1,25 kali kecepatan normal.",
  T_49_META_TYP_254_I2_D: "Warna",
  T_49_META_TYP_256_I0_D: "Sepenuhnya tidak bergerak. Kinerja Minimum",
  T_49_META_TYP_256_I1_D: "Aplikasi gaya normal. Kinerja paling mahal",
  T_49_META_TYP_256_I2_D: "Gerakan dapat dikontrol dengan skrip dan dapat dianggap sebagai massa tak terbatas",
  T_49_META_TYP_257_I0_D: "Fungsi berbagai jenis benda kaku",
  T_49_META_TYP_257_I1_D: "Gunakan Gravitasi",
  T_49_META_TYP_257_I2_D: "Massa (kg), massa efektif minimum adalah 0,001kg, jika 0, maka ini adalah massa tak terhingga dan tidak akan bergerak di bawah gaya.",
  T_49_META_TYP_257_I3_D: "Posisi pusat gravitasi, sistem koordinat lokal",
  T_49_META_TYP_257_I4_D: "Kecepatan linier gerakan benda tegar",
  T_49_META_TYP_257_I5_D: "Kecepatan sudut gerak benda tegar",
  T_49_META_TYP_257_I6_D: "Koefisien peluruhan alami kecepatan linier, semakin besar koefisiennya, semakin cepat peluruhan kecepatan.",
  T_49_META_TYP_257_I7_D: "Koefisien peluruhan alami kecepatan sudut, semakin besar koefisiennya, semakin cepat penurunan kecepatan.",
  T_49_META_TYP_257_I8_D: "Batasan yang dikenakan pada benda kaku, kumpulan dari RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Latar Belakang",
  T_49_META_TYP_259_I1_D: "Teks",
  T_49_META_TYP_259_I2_D: "Posisi UI",
  T_49_META_TYP_259_I4_D: "Warna Teks",
  T_49_META_TYP_260_I0_D: "Pilih Ikon",
  T_49_META_TYP_260_I1_D: "Warna bilah kemajuan",
  T_49_META_TYP_260_I2_D: "Nilai",
  T_49_META_TYP_260_I3_D: "Kecepatan dalam m/s",
  T_49_META_TYP_260_I4_D: "Apakah akan menampilkan efek khusus",
  T_49_META_TYP_260_I5_D: "Posisi UI [0,1].",
  T_49_META_TYP_260_I6_D: "Kemajuan awal keterampilan, nilai [0, 1], kemajuan akan disinkronkan ke kemajuan saat ini segera setelah UI dibuat.",
  T_49_META_TYP_260_I7_D: "Warna Efek",
  T_49_META_TYP_260_I8_D: "Mengatur nilai skala objek",
  T_49_META_TYP_265_I1_D: "Isi latar belakang atau tidak",
  T_49_META_TYP_265_I2_D: "Nama Latar Belakang",
  T_49_META_TYP_265_I3_D: "Warna Latar Belakang",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Jenis pangkas",
  T_49_META_TYP_265_I7_D: "Jenis topeng adalah nama gambar yang dipilih untuk masking",
  T_49_META_TYP_265_I8_D: "Unit pelembut tepi",
  T_49_META_TYP_267_I0_D: "Titik awal gulir, standarnya adalah sudut kiri atas.",
  T_49_META_TYP_267_I1_D: "Mendukung beberapa arah pengguliran",
  T_49_META_TYP_267_I10_D: "Bar Horizontal",
  T_49_META_TYP_267_I11_D: "Menunjukkan posisi",
  T_49_META_TYP_267_I2_D: "Komponen seret arah XY",
  T_49_META_TYP_267_I3_D: "Mendukung beberapa efek menyeret",
  T_49_META_TYP_267_I4_D: "Faktor scroll, semakin besar nilainya, semakin cepat penggulirannya.",
  T_49_META_TYP_267_I5_D: "Faktor inersia, semakin besar nilainya, semakin besar pula inersia ketika menggulir.",
  T_49_META_TYP_267_I6_D: "Apakah seret dibatasi ke viewport atau tidak, default dicentang.",
  T_49_META_TYP_267_I7_D: "Apabila dicentang, seret akan mulai bergerak secara perlahan, jika tidak dicentang, seret akan mulai bergerak pada kecepatan mouse.",
  T_49_META_TYP_267_I8_D: "Keluar dari menyeret apabila sudah sesuai dengan viewport.",
  T_49_META_TYP_267_I9_D: "Bar Vertikal",
  T_49_META_TYP_268_I0_D: "Default",
  T_49_META_TYP_268_I1_D: "Tutup",
  T_49_META_TYP_268_I2_D: "Tampilkan",
  T_49_META_TYP_269_I0_D: "Pemilik",
  T_49_META_TYP_269_I1_D: "ID setelan",
  T_49_META_TYP_269_I2_D: "ID penutup kepala",
  T_49_META_TYP_269_I3_D: "ID Wajah",
  T_49_META_TYP_269_I4_D: "ID Rias Wajah",
  T_49_META_TYP_269_I5_D: "ID Tubuh Bagian Atas",
  T_49_META_TYP_269_I6_D: "ID Bawah",
  T_49_META_TYP_269_I7_D: "ID Sepatu",
  T_49_META_TYP_272_I0_D: "Perempuan",
  T_49_META_TYP_272_I1_D: "Laki-laki",
  T_49_META_TYP_273_I0_D: "Koordinat dunia dari pusat peta mini",
  T_49_META_TYP_273_I1_D: "Ukuran peta mini, lebar dan tinggi yang sama",
  T_49_META_TYP_273_I2_D: "Mengaktifkan atau menonaktifkan mode tampilan peta kedalaman pada peta mini",
  T_49_META_TYP_274_I1_D: "Ukuran zoom",
  T_49_META_TYP_274_I4_D: "Tingkat tampilan ikon",
  T_49_META_TYP_275_I0_D: "Skala Kerangka",
  T_49_META_TYP_275_I1_D: "Koordinat dunia dari simpul tulang",
  T_49_META_TYP_276_I0_D: "Kepala",
  T_49_META_TYP_276_I1_D: "Lengan Kiri",
  T_49_META_TYP_276_I2_D: "Tangan Kiri",
  T_49_META_TYP_276_I3_D: "Lengan Kanan",
  T_49_META_TYP_276_I4_D: "Tangan Kanan",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Kaki Kiri",
  T_49_META_TYP_276_I7_D: "Kaki Kiri Bawah",
  T_49_META_TYP_276_I8_D: "Kaki Kanan",
  T_49_META_TYP_276_I9_D: "Kaki Kanan Bawah",
  T_49_META_TYP_277_I1_D: "Jarak untuk deteksi sinar kamera",
  T_49_META_TYP_277_I2_D: "Topeng lapisan tabrakan untuk deteksi sinar kamera",
  T_49_META_TYP_277_I3_D: "Offset posisi tombol",
  T_49_META_TYP_277_I4_D: "ID sumber daya ikon",
  T_49_META_TYP_277_I5_D: "Ukuran area klik",
  T_49_META_TYP_277_I6_D: "Apakah objek ditampilkan pada titik target",
  T_49_META_TYP_277_I7_D: "Objek yang ditampilkan pada titik target",
  T_49_META_TYP_278_I0_D: "Entitas target untuk menghasilkan piksel peta",
  T_49_META_TYP_28_I0_D: "Apakah tim dapat diatur ulang setiap ronde atau tidak",
  T_49_META_TYP_280_I0_D: "Jari-jari bola",
  T_49_META_TYP_281_I0_D: "Jari-jari belahan pada ujung kapsul.",
  T_49_META_TYP_29_I0_D: "Bola",
  T_49_META_TYP_29_I1_D: "Sinar Cahaya",
  T_49_META_TYP_29_I10_D: "Pilar cahaya di bawah kaki, sekarang digunakan untuk umpan balik saat memasuki garis finish",
  T_49_META_TYP_29_I11_D: "Membeku",
  T_49_META_TYP_29_I12_D: "Cahaya",
  T_49_META_TYP_29_I13_D: "Aliran Naik",
  T_49_META_TYP_29_I14_D: "Ledakan Gas",
  T_49_META_TYP_29_I15_D: "Pembunuh Tersembunyi",
  T_49_META_TYP_29_I16_D: "Keganasan",
  T_49_META_TYP_29_I17_D: "Kematian Klon",
  T_49_META_TYP_29_I18_D: "Umpan Balik Penembakan",
  T_49_META_TYP_29_I19_D: "Kematian Klon",
  T_49_META_TYP_29_I2_D: "Ledakan",
  T_49_META_TYP_29_I20_D: "Klon",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Asap Granat Flashbang",
  T_49_META_TYP_29_I23_D: "Bola Api",
  T_49_META_TYP_29_I24_D: "Terbakar Berulang",
  T_49_META_TYP_29_I25_D: "Gas Beracun",
  T_49_META_TYP_29_I26_D: "Jantung",
  T_49_META_TYP_29_I29_D: "Pintu",
  T_49_META_TYP_29_I30_D: "Kembang Api",
  T_49_META_TYP_29_I31_D: "Efek Sepatu Lari",
  T_49_META_TYP_29_I32_D: "Efek Ledakan",
  T_49_META_TYP_29_I33_D: "Efek Titik Muncul",
  T_49_META_TYP_29_I34_D: "Efek Laser",
  T_49_META_TYP_29_I35_D: "Efek Penggunaan Keterampilan",
  T_49_META_TYP_29_I36_D: "Efek Peluru",
  T_49_META_TYP_29_I37_D: "Efek Kena Peluru",
  T_49_META_TYP_29_I38_D: "Efek Penembakan",
  T_49_META_TYP_29_I39_D: "Efek Keterampilan",
  T_49_META_TYP_29_I40_D: "Aura",
  T_49_META_TYP_29_I41_D: "Gelembung",
  T_49_META_TYP_29_I42_D: "Asap dan Debu",
  T_49_META_TYP_29_I43_D: "Puing Terbang",
  T_49_META_TYP_29_I44_D: "Garis",
  T_49_META_TYP_29_I45_D: "Berkedip",
  T_49_META_TYP_29_I47_D: "Partikel Naik",
  T_49_META_TYP_29_I48_D: "Asap",
  T_49_META_TYP_29_I49_D: "Jimat",
  T_49_META_TYP_29_I50_D: "Area Beku",
  T_49_META_TYP_29_I51_D: "Kabut",
  T_49_META_TYP_29_I52_D: "Serpihan Salju",
  T_49_META_TYP_29_I53_D: "Api",
  T_49_META_TYP_29_I54_D: "Sinar Cahaya",
  T_49_META_TYP_29_I55_D: "Penyebaran Gas Beracun",
  T_49_META_TYP_29_I56_D: "Gas Beracun",
  T_49_META_TYP_29_I57_D: "Nyala Ledakan",
  T_49_META_TYP_29_I58_D: "Efek Cahaya",
  T_49_META_TYP_29_I59_D: "Bintang",
  T_49_META_TYP_29_I6_D: "Halo Kaki",
  T_49_META_TYP_29_I60_D: "Api Unggun",
  T_49_META_TYP_29_I61_D: "Percikan Air",
  T_49_META_TYP_29_I62_D: "Kejut Listrik",
  T_49_META_TYP_29_I63_D: "Efek Tinta",
  T_49_META_TYP_29_I64_D: "Efek Lubang Hitam",
  T_49_META_TYP_29_I65_D: "Efek Ledakan Lubang Hitam",
  T_49_META_TYP_29_I66_D: "Efek Bola Kristal",
  T_49_META_TYP_29_I67_D: "Efek peluru laser",
  T_49_META_TYP_29_I68_D: "Efek seret",
  T_49_META_TYP_29_I69_D: "Awan",
  T_49_META_TYP_29_I7_D: "Penanda Tanah",
  T_49_META_TYP_29_I8_D: "Asap",
  T_49_META_TYP_29_I9_D: "Ledakan Jimat",
  T_49_META_TYP_290_I0_D: "Interval penyegaran, semakin besar angkanya, semakin lambat penyegarannya, dalam milidetik.",
  T_49_META_TYP_290_I1_D: "Apakah akan mengaktifkan debugging",
  T_49_META_TYP_291_I0_D: "NodeKondisi",
  T_49_META_TYP_291_I1_D: "NodeAksi",
  T_49_META_TYP_293_I0_D: "ID Pohon Perilaku",
  T_49_META_TYP_293_I1_D: "Target Terpasang",
  T_49_META_TYP_294_I1_D: "Jenis Tata Letak",
  T_49_META_TYP_294_I10_D: "Jenis Pengurutan",
  T_49_META_TYP_294_I2_D: "Asal Konten",
  T_49_META_TYP_294_I3_D: "Arah perataan",
  T_49_META_TYP_294_I4_D: "Lebar dan tinggi kisi sub-item",
  T_49_META_TYP_294_I5_D: "Jarak Sel",
  T_49_META_TYP_294_I6_D: "Kendala",
  T_49_META_TYP_294_I7_D: "Jumlah Kendala",
  T_49_META_TYP_294_I8_D: "Pergeseran vertikal",
  T_49_META_TYP_294_I9_D: "Pergeseran horizontal",
  T_49_META_TYP_295_I2_D: "Kecepatan Putar",
  T_49_META_TYP_296_I1_D: "Panjang Klip",
  T_49_META_TYP_297_I0_D: "Objek yang terikat",
  T_49_META_TYP_297_I4_D: "ID Sumber Daya",
  T_49_META_TYP_298_I0_D: "Default",
  T_49_META_TYP_298_I2_D: "Sekali",
  T_49_META_TYP_30_I0_D: "Kotak",
  T_49_META_TYP_30_I1_D: "Segi Empat",
  T_49_META_TYP_30_I10_D: "Panah",
  T_49_META_TYP_30_I11_D: "Panggilan",
  T_49_META_TYP_30_I12_D: "Batu",
  T_49_META_TYP_30_I13_D: "Gunting",
  T_49_META_TYP_30_I14_D: "Kertas",
  T_49_META_TYP_30_I15_D: "Suka",
  T_49_META_TYP_30_I16_D: "Benar",
  T_49_META_TYP_30_I17_D: "Salah",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Petir",
  T_49_META_TYP_30_I2_D: "Trapesium Siku-Siku",
  T_49_META_TYP_30_I20_D: "Hati",
  T_49_META_TYP_30_I21_D: "Bintang",
  T_49_META_TYP_30_I22_D: "Bulan",
  T_49_META_TYP_30_I23_D: "Matahari",
  T_49_META_TYP_30_I24_D: "Kacamata",
  T_49_META_TYP_30_I25_D: "Kunci",
  T_49_META_TYP_30_I26_D: "Piala",
  T_49_META_TYP_30_I27_D: "Bendera",
  T_49_META_TYP_30_I28_D: "Jam Pasir",
  T_49_META_TYP_30_I29_D: "Folder",
  T_49_META_TYP_30_I3_D: "Trapesium",
  T_49_META_TYP_30_I30_D: "Folder Terbuka",
  T_49_META_TYP_30_I31_D: "Rumah",
  T_49_META_TYP_30_I32_D: "Istirahat",
  T_49_META_TYP_30_I33_D: "Segarkan",
  T_49_META_TYP_30_I34_D: "Siklus",
  T_49_META_TYP_30_I35_D: "Kaca Pembesar",
  T_49_META_TYP_30_I36_D: "Tempat Sampah",
  T_49_META_TYP_30_I37_D: "Kembali",
  T_49_META_TYP_30_I38_D: "Berlian",
  T_49_META_TYP_30_I39_D: "Pelampung",
  T_49_META_TYP_30_I4_D: "Segi Enam",
  T_49_META_TYP_30_I40_D: "Uang",
  T_49_META_TYP_30_I41_D: "Kunci",
  T_49_META_TYP_30_I42_D: "Pengaturan",
  T_49_META_TYP_30_I43_D: "Keluar",
  T_49_META_TYP_30_I44_D: "Dialog",
  T_49_META_TYP_30_I45_D: "Bidikan",
  T_49_META_TYP_30_I46_D: "Senjata",
  T_49_META_TYP_30_I47_D: "Pedang",
  T_49_META_TYP_30_I48_D: "Ledakan",
  T_49_META_TYP_30_I49_D: "Bidik",
  T_49_META_TYP_30_I5_D: "Lingkaran",
  T_49_META_TYP_30_I50_D: "Salib",
  T_49_META_TYP_30_I51_D: "Pertahanan",
  T_49_META_TYP_30_I52_D: "Monster",
  T_49_META_TYP_30_I53_D: "Daur Ulang",
  T_49_META_TYP_30_I54_D: "Hadiah",
  T_49_META_TYP_30_I55_D: "Pakaian",
  T_49_META_TYP_30_I56_D: "Permainan",
  T_49_META_TYP_30_I57_D: "Pemain",
  T_49_META_TYP_30_I58_D: "Toko",
  T_49_META_TYP_30_I59_D: "Keluar",
  T_49_META_TYP_30_I6_D: "Segitiga",
  T_49_META_TYP_30_I60_D: "Peringatan",
  T_49_META_TYP_30_I61_D: "Teks",
  T_49_META_TYP_30_I62_D: "Objek Pengatur Waktu",
  T_49_META_TYP_30_I63_D: "Bel",
  T_49_META_TYP_30_I64_D: "Peliharaan",
  T_49_META_TYP_30_I65_D: "Bom",
  T_49_META_TYP_30_I66_D: "Perbaikan",
  T_49_META_TYP_30_I67_D: "Wajah Tersenyum",
  T_49_META_TYP_30_I68_D: "Speaker",
  T_49_META_TYP_30_I7_D: "Tanda Seru",
  T_49_META_TYP_30_I70_D: "Mahkota",
  T_49_META_TYP_30_I71_D: "Pertarungan",
  T_49_META_TYP_30_I72_D: "Guild",
  T_49_META_TYP_30_I73_D: "Detak Jantung",
  T_49_META_TYP_30_I74_D: "Musik",
  T_49_META_TYP_30_I75_D: "Kendaraan",
  T_49_META_TYP_30_I76_D: "Senjata Tempur Jarak Dekat",
  T_49_META_TYP_30_I77_D: "Pistol",
  T_49_META_TYP_30_I78_D: "Senapan",
  T_49_META_TYP_30_I79_D: "Senapan Sniper",
  T_49_META_TYP_30_I8_D: "Tanda Tanya",
  T_49_META_TYP_30_I80_D: "Senapan Scatter",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Senapan Penyembuh",
  T_49_META_TYP_30_I83_D: "Hancurkan Armor",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Keterampilan 1",
  T_49_META_TYP_30_I86_D: "Keterampilan 2",
  T_49_META_TYP_30_I87_D: "Keterampilan 3",
  T_49_META_TYP_30_I88_D: "Keterampilan 4",
  T_49_META_TYP_30_I89_D: "Keterampilan 5",
  T_49_META_TYP_30_I9_D: "Markah",
  T_49_META_TYP_30_I90_D: "Keterampilan 6",
  T_49_META_TYP_30_I91_D: "Keterampilan 7",
  T_49_META_TYP_30_I92_D: "Keterampilan 8",
  T_49_META_TYP_30_I93_D: "Keterampilan 9",
  T_49_META_TYP_30_I94_D: "Keterampilan 10",
  T_49_META_TYP_300_I0_D: "ID Sumber Daya",
  T_49_META_TYP_300_I2_D: "Rotasi",
  T_49_META_TYP_300_I3_D: "Entitas yang Diciptakan",
  T_49_META_TYP_301_I1_D: "Ledakan Sendiri",
  T_49_META_TYP_301_I2_D: "Serangan Dash",
  T_49_META_TYP_301_I3_D: "Gelombang Kejut",
  T_49_META_TYP_301_I4_D: "Serangan Angin",
  T_49_META_TYP_301_I5_D: "Serangan Lompat",
  T_49_META_TYP_301_I6_D: "Angkat Perisai",
  T_49_META_TYP_301_I7_D: "Perisai Pecah",
  T_49_META_TYP_302_I5_D: "Tas",
  T_49_META_TYP_302_I7_D: "Skateboard, Kamuflase ....",
  T_49_META_TYP_303_I0_D: "Tambah HP Maks. Pemain",
  T_49_META_TYP_303_I1_D: "Terus Memulihkan HP Pemain",
  T_49_META_TYP_305_I0_D: "Selesai",
  T_49_META_TYP_305_I1_D: "Sedang Berjalan",
  T_49_META_TYP_307_I0_D: "Exp per Damage",
  T_49_META_TYP_307_I1_D: "Exp per Mil yang Ditempuh",
  T_49_META_TYP_307_I2_D: "EXP per Detik",
  T_49_META_TYP_307_I3_D: "Pengalaman Per Cip",
  T_49_META_TYP_307_I4_D: "Batas Maksimum Muatan",
  T_49_META_TYP_308_I0_D: "Pembuat Gel",
  T_49_META_TYP_31_I0_D: "Ledakan Granat",
  T_49_META_TYP_31_I1_D: "Suara Senjata",
  T_49_META_TYP_31_I10_D: "Suara Kerusakan Pukulan",
  T_49_META_TYP_31_I11_D: "Suara Peningkatan",
  T_49_META_TYP_31_I12_D: "Efek suara pukulan kelemahan",
  T_49_META_TYP_31_I13_D: "Efek suara pemain melangkah",
  T_49_META_TYP_31_I14_D: "Suara Perbaikan Peralatan",
  T_49_META_TYP_31_I15_D: "Suara Perbaikan Peralatan",
  T_49_META_TYP_31_I16_D: "Efek suara yang hilang atau hilang",
  T_49_META_TYP_31_I17_D: "Suara Pengingat",
  T_49_META_TYP_31_I18_D: "Suara Jatuhkan Sepak Bola",
  T_49_META_TYP_31_I19_D: "Efek Suara Tepuk Tangan",
  T_49_META_TYP_31_I2_D: "Bunyi Hitung Mundur",
  T_49_META_TYP_31_I20_D: "Suara Peringatan Bom",
  T_49_META_TYP_31_I21_D: "Efek Suara Bom Sebelum Ledakan",
  T_49_META_TYP_31_I22_D: "Efek Suara Penampilan Pemburu",
  T_49_META_TYP_31_I23_D: "Efek Suara BGM Terakhir",
  T_49_META_TYP_31_I24_D: "Efek Suara Penyegaran Kotak Isi Ulang",
  T_49_META_TYP_31_I25_D: "Suara Akselerator",
  T_49_META_TYP_31_I26_D: "Suara Menghilang",
  T_49_META_TYP_31_I27_D: "Efek Visual",
  T_49_META_TYP_31_I28_D: "Serangga Malam",
  T_49_META_TYP_31_I29_D: "Efek suara perkusi tumpul",
  T_49_META_TYP_31_I3_D: "UI Tap",
  T_49_META_TYP_31_I30_D: "Efek Suara Tanggapan",
  T_49_META_TYP_31_I31_D: "Efek suara Penemuan Kejutan",
  T_49_META_TYP_31_I32_D: "Efek suara hantu bermain",
  T_49_META_TYP_31_I33_D: "Efek Suara Mulai Panggung",
  T_49_META_TYP_31_I34_D: "Efek suara zombie",
  T_49_META_TYP_31_I35_D: "Efek suara menakutkan",
  T_49_META_TYP_31_I36_D: "Efek Suara Transformasi",
  T_49_META_TYP_31_I37_D: "Suara Detak Jantung Cepat",
  T_49_META_TYP_31_I38_D: "Suara Detak Jantung Sedang",
  T_49_META_TYP_31_I39_D: "Efek suara detak jantung lambat",
  T_49_META_TYP_31_I4_D: "Jeritan Wanita Saat Terkena",
  T_49_META_TYP_31_I40_D: "Efek suara serbuan",
  T_49_META_TYP_31_I41_D: "Suara Mengklik",
  T_49_META_TYP_31_I42_D: "Suara Pemulihan Keterampilan",
  T_49_META_TYP_31_I43_D: "Efek Suara Bergabung dengan Game",
  T_49_META_TYP_31_I44_D: "Suara Gema Mekanisme",
  T_49_META_TYP_31_I45_D: "Efek suara nyamuk",
  T_49_META_TYP_31_I46_D: "Efek suara dentingan 1",
  T_49_META_TYP_31_I47_D: "Efek Suara Dentingan 2",
  T_49_META_TYP_31_I48_D: "Efek suara pembuka mekanisme",
  T_49_META_TYP_31_I49_D: "Mengisi 1 efek suara",
  T_49_META_TYP_31_I5_D: "Jeritan Pria Saat Terkena",
  T_49_META_TYP_31_I50_D: "Efek suara langkah kaki",
  T_49_META_TYP_31_I51_D: "Efek suara Keberhasilan Misi 1",
  T_49_META_TYP_31_I52_D: "Efek suara Nada Bahaya 1",
  T_49_META_TYP_31_I53_D: "Efek suara Nada Bahaya 2",
  T_49_META_TYP_31_I54_D: "Efek suara hitung mundur 3",
  T_49_META_TYP_31_I55_D: "Efek suara Show Tips",
  T_49_META_TYP_31_I56_D: "Efek suara ambien burung gagak berkokok",
  T_49_META_TYP_31_I57_D: "Efek suara berteleportasi ke area yang salah dengan titik teleportasi",
  T_49_META_TYP_31_I58_D: "Efek suara berteleportasi ke area yang benar dengan titik teleportasi",
  T_49_META_TYP_31_I59_D: "Efek suara teleportasi",
  T_49_META_TYP_31_I6_D: "Efek suara pengambilan emas",
  T_49_META_TYP_31_I60_D: "Efek suara sengatan listrik",
  T_49_META_TYP_31_I61_D: "Mendapatkan efek suara alat peraga",
  T_49_META_TYP_31_I62_D: "Efek Suara Musik Latar Belakang Lucu Fantasi Elektronik",
  T_49_META_TYP_31_I63_D: "Efek Suara Musik Latar Belakang Game Santai",
  T_49_META_TYP_31_I64_D: "Buka Kotak",
  T_49_META_TYP_31_I65_D: "Naik Pangkat",
  T_49_META_TYP_31_I66_D: "Level Maksimum",
  T_49_META_TYP_31_I67_D: "Tombol Ketuk",
  T_49_META_TYP_31_I68_D: "Hitung Mundur",
  T_49_META_TYP_31_I69_D: "Kalahkan Musuh",
  T_49_META_TYP_31_I7_D: "Efek suara pemicu balapan melewati garis finis",
  T_49_META_TYP_31_I70_D: "Akhir",
  T_49_META_TYP_31_I71_D: "Maju",
  T_49_META_TYP_31_I72_D: "Kemenangan",
  T_49_META_TYP_31_I73_D: "Pos Pemeriksaan Basis Pelatihan",
  T_49_META_TYP_31_I74_D: "Hitung Mundur",
  T_49_META_TYP_31_I75_D: "Mulai Permainan",
  T_49_META_TYP_31_I76_D: "Dapatkan Emas Besar",
  T_49_META_TYP_31_I77_D: "Dapatkan Emas Sedang",
  T_49_META_TYP_31_I78_D: "Dapatkan Emas Kecil",
  T_49_META_TYP_31_I79_D: "Bergabung dalam Pertempuran",
  T_49_META_TYP_31_I8_D: "Suara Pemicu Pemicu",
  T_49_META_TYP_31_I80_D: "Supply Guild",
  T_49_META_TYP_31_I81_D: "Speaker",
  T_49_META_TYP_31_I82_D: "Menggulingkan Pemimpin Guild",
  T_49_META_TYP_31_I83_D: "Simpan Gudang",
  T_49_META_TYP_31_I84_D: "Suara Senjata Khusus",
  T_49_META_TYP_31_I85_D: "Hantaman Peluru",
  T_49_META_TYP_31_I86_D: "Bergerak",
  T_49_META_TYP_31_I87_D: "Ketuk Tombol Nonaktif",
  T_49_META_TYP_31_I88_D: "Pengisian Keterampilan Selesai",
  T_49_META_TYP_31_I89_D: "Keterampilan Laser",
  T_49_META_TYP_31_I9_D: "Suara Degradasi",
  T_49_META_TYP_31_I90_D: "Dapatkan Barang Konsumsi 2",
  T_49_META_TYP_31_I91_D: "Hitung Mundur 3",
  T_49_META_TYP_31_I92_D: "Permainan Selesai 2",
  T_49_META_TYP_31_I93_D: "Peringatan Pembunuhan",
  T_49_META_TYP_31_I94_D: "Ledakan",
  T_49_META_TYP_31_I95_D: "Keterampilan Orb Energi",
  T_49_META_TYP_31_I96_D: "Keterampilan Kolam Darah",
  T_49_META_TYP_311_I1_D: "Damage Maksimum",
  T_49_META_TYP_311_I3_D: "Kecepatan proyektil setelah dilepaskan, dalam m/s.",
  T_49_META_TYP_311_I4_D: "Interval waktu antara saat proyektil dilepaskan dan saat proyektil mulai berlaku, dalam detik.",
  T_49_META_TYP_313_I0_D: "Radius Zona",
  T_49_META_TYP_313_I1_D: "Durasi area penanggulangan, dalam detik",
  T_49_META_TYP_314_I0_D: "ID sumber daya pengontrol animasi",
  T_49_META_TYP_314_I1_D: "Kontroler Animasi",
  T_49_META_TYP_315_I0_D: "Pemilik ransel",
  T_49_META_TYP_315_I1_D: "Ruang tas ransel",
  T_49_META_TYP_315_I2_D: "Kapasitas Terpakai",
  T_49_META_TYP_315_I3_D: "Semua Supply",
  T_49_META_TYP_316_I0_D: "Sumber Tekstur",
  T_49_META_TYP_316_I1_D: "Nama Shader",
  T_49_META_TYP_316_I11_D: "Metode balik",
  T_49_META_TYP_316_I2_D: "Offset UV",
  T_49_META_TYP_316_I3_D: "Ukuran UV",
  T_49_META_TYP_316_I4_D: "Jenis Pengisian",
  T_49_META_TYP_316_I5_D: "Border Kiri Kanan",
  T_49_META_TYP_316_I6_D: "Border Atas Bawah",
  T_49_META_TYP_317_I0_D: "Tidak Ada",
  T_49_META_TYP_317_I1_D: "Bekukan Posisi X",
  T_49_META_TYP_317_I2_D: "Bekukan Posisi Y",
  T_49_META_TYP_317_I3_D: "Bekukan Posisi Z",
  T_49_META_TYP_317_I4_D: "Rotasi terbatas di sekitar sumbu X",
  T_49_META_TYP_317_I5_D: "Pembatasan rotasi di sekitar sumbu Y",
  T_49_META_TYP_317_I6_D: "Batasi rotasi di sekitar sumbu Z",
  T_49_META_TYP_317_I7_D: "Bekukan Posisi",
  T_49_META_TYP_317_I8_D: "Bekukan Rotasi",
  T_49_META_TYP_317_I9_D: "Bekukan Semua",
  T_49_META_TYP_318_I0_D: "Jangkauan",
  T_49_META_TYP_318_I1_D: "Jarak Kerusakan Penuh",
  T_49_META_TYP_318_I10_D: "Faktor Kecepatan Aim Pemain",
  T_49_META_TYP_318_I11_D: "Rasio Zoom Scope",
  T_49_META_TYP_318_I12_D: "Pembesaran FOV",
  T_49_META_TYP_318_I13_D: "Pembesaran ADS",
  T_49_META_TYP_318_I14_D: "Waktu Pembesaran ADS (detik)",
  T_49_META_TYP_318_I15_D: "Waktu Pemulihan ADS (detik)",
  T_49_META_TYP_318_I16_D: "Faktor koreksi rentang kerusakan minimum untuk cakupan",
  T_49_META_TYP_318_I17_D: "Izinkan ADS Aim Assist",
  T_49_META_TYP_318_I18_D: "Rasio Daya Tarik Bidikan Bantuan pada Layar (0-1)",
  T_49_META_TYP_318_I19_D: "Koefisien Reduksi Jarak Bantuan Membidik (0-1)",
  T_49_META_TYP_318_I2_D: "Jarak Kerusakan Minimum",
  T_49_META_TYP_318_I20_D: "Izinkan Prioritas Jarak Bantuan Membidik",
  T_49_META_TYP_318_I21_D: "Jarak Minimum Prioritas Aim Assist",
  T_49_META_TYP_318_I22_D: "Jarak Maksimum Prioritas Bantuan Membidik",
  T_49_META_TYP_318_I23_D: "Koefisien Dampak Prioritas Jarak Aim Assist (>=1)",
  T_49_META_TYP_318_I24_D: "Sensitivitas Putaran ADS",
  T_49_META_TYP_318_I25_D: "Laju Penyusutan",
  T_49_META_TYP_318_I3_D: "Ukuran Klip Peluru",
  T_49_META_TYP_318_I4_D: "Interval Serangan",
  T_49_META_TYP_318_I5_D: "Kecepatan Reload",
  T_49_META_TYP_318_I6_D: "Kecepatan Reload Otomatis",
  T_49_META_TYP_318_I7_D: "Kecepatan Penyebaran",
  T_49_META_TYP_318_I8_D: "Tingkat hamburan saat berjongkok dan berbaring, per 0,1 berarti peningkatan jangkauan 10% per putaran tabrakan",
  T_49_META_TYP_318_I9_D: "Penyebaran Maksimum",
  T_49_META_TYP_319_I0_D: "Sederhana",
  T_49_META_TYP_319_I1_D: "Irisan",
  T_49_META_TYP_319_I2_D: "Berlapis",
  T_49_META_TYP_319_I3_D: "Terisi",
  T_49_META_TYP_319_I4_D: "Cocok",
  T_49_META_TYP_32_I0_D: "Pemain dalam keadaan aktif normal",
  T_49_META_TYP_32_I1_D: "Pemain dirobohkan",
  T_49_META_TYP_32_I2_D: "Pemain mati",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertikal",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "Jarak maksimum di mana bantuan penargetan akan dipicu.",
  T_49_META_TYP_321_I1_D: "Offset kolimator saat memicu penargetan, jika titik offset tidak berada dalam solid, penargetan akan dinonaktifkan.",
  T_49_META_TYP_322_I0_D: "Tidak",
  T_49_META_TYP_322_I1_D: "Kepala",
  T_49_META_TYP_322_I2_D: "Tubuh",
  T_49_META_TYP_322_I3_D: "Anggota Tubuh",
  T_49_META_TYP_323_I0_D: "Skala",
  T_49_META_TYP_323_I1_D: "ID Akun",
  T_49_META_TYP_323_I2_D: "Informasi Profil Pemain",
  T_49_META_TYP_323_I3_D: "Gaya",
  T_49_META_TYP_323_I4_D: "Tampilkan Peringkat",
  T_49_META_TYP_323_I5_D: "Tampilkan Pin",
  T_49_META_TYP_323_I6_D: "Tampilkan Nama Panggilan",
  T_49_META_TYP_324_I0_D: "Menghasilkan gaya dengan besaran tertentu",
  T_49_META_TYP_324_I1_D: "Menghasilkan percepatan dengan besaran tertentu",
  T_49_META_TYP_324_I2_D: "Menghasilkan impuls dengan besaran tertentu",
  T_49_META_TYP_324_I3_D: "Menghasilkan jumlah kecepatan tertentu",
  T_49_META_TYP_326_I0_D: "ID Akun",
  T_49_META_TYP_326_I1_D: "ID Avatar",
  T_49_META_TYP_326_I2_D: "ID Spanduk",
  T_49_META_TYP_326_I3_D: "ID Pin",
  T_49_META_TYP_326_I4_D: "Nama panggilan pemain",
  T_49_META_TYP_326_I5_D: "Peringkat BR",
  T_49_META_TYP_326_I6_D: "Peringkat BR Tertinggi",
  T_49_META_TYP_326_I7_D: "Peringkat CS",
  T_49_META_TYP_326_I8_D: "Peringkat CS Tertinggi",
  T_49_META_TYP_327_I0_D: "ID sumber daya",
  T_49_META_TYP_327_I1_D: "Part Mask 1",
  T_49_META_TYP_327_I2_D: "Part Mask 2",
  T_49_META_TYP_327_I3_D: "Part Mask 3",
  T_49_META_TYP_327_I4_D: "Part Mask 4",
  T_49_META_TYP_329_I0_D: "Pengemudi",
  T_49_META_TYP_329_I1_D: "Penumpang A",
  T_49_META_TYP_329_I2_D: "Penumpang B",
  T_49_META_TYP_329_I3_D: "Penumpang C",
  T_49_META_TYP_33_I0_D: "Urutan menaik mengabaikan nilai nol, nilai nol berada di urutan terakhir",
  T_49_META_TYP_33_I1_D: "Urutan menurun, besar ke kecil",
  T_49_META_TYP_33_I2_D: "Menaik, terkecil ke terbesar",
  T_49_META_TYP_330_I4_D: "Durasi efek tak terkalahkan (dalam detik)",
  T_49_META_TYP_330_I5_D: "Poin Kontrol",
  T_49_META_TYP_330_I8_D: "Nilai Delta",
  T_49_META_TYP_332_I0_D: "Apakah Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Jalur sumber daya, standarnya kosong",
  T_49_META_TYP_335_I1_D: "Hitungan permainan, standarnya adalah 1",
  T_49_META_TYP_335_I2_D: "Volume, standarnya adalah 50",
  T_49_META_TYP_335_I3_D: "Jarak Maksimum",
  T_49_META_TYP_335_I4_D: "Jarak Minimum",
  T_49_META_TYP_335_I5_D: "Apakah musiknya 3D atau tidak",
  T_49_META_TYP_335_I6_D: "Prioritas",
  T_49_META_TYP_335_I7_D: "Waktu tunggu sebelum memulai, dalam hitungan detik",
  T_49_META_TYP_335_I8_D: "Sedang Diputar",
  T_49_META_TYP_338_I0_D: "Status gerakan",
  T_49_META_TYP_338_I1_D: "Lari cepat",
  T_49_META_TYP_338_I2_D: "Menyerang",
  T_49_META_TYP_338_I3_D: "Melompat",
  T_49_META_TYP_338_I4_D: "Menyerbu",
  T_49_META_TYP_338_I5_D: "Memasuki kendaraan (pengemudi)",
  T_49_META_TYP_338_I6_D: "Memasuki Kendaraan (Penumpang)",
  T_49_META_TYP_338_I7_D: "Keluar Kendaraan",
  T_49_META_TYP_338_I8_D: "Mengemudi",
  T_49_META_TYP_339_I0_D: "Rasio Damage Limb",
  T_49_META_TYP_339_I1_D: "Rasio Damage Kepala",
  T_49_META_TYP_339_I2_D: "Rasio Ketahanan Maksimum",
  T_49_META_TYP_339_I3_D: "Rasio HP Tambahan",
  T_49_META_TYP_339_I4_D: "Faktor Pengurangan Kerusakan Ledakan Tambahan (%)",
  T_49_META_TYP_339_I5_D: "Kapasitas Tambahan Backpack",
  T_49_META_TYP_339_I6_D: "Prioritas Penggantian",
  T_49_META_TYP_34_I0_D: "Tinju Default",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Senapan",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Meriam Tangan",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Senjata Perisai",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Pistol Perisai",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Pistol Granat Api",
  T_49_META_TYP_34_I133_D: "Granat Penyilau",
  T_49_META_TYP_34_I134_D: "Granat Asap",
  T_49_META_TYP_34_I135_D: "Granat Beku",
  T_49_META_TYP_34_I136_D: "Rompi Antipeluru Lv1",
  T_49_META_TYP_34_I137_D: "Rompi Antipeluru Lv2",
  T_49_META_TYP_34_I138_D: "Pelindung tubuh Lv3",
  T_49_META_TYP_34_I139_D: "Helm Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Helm Lv2",
  T_49_META_TYP_34_I141_D: "Helm Lv3",
  T_49_META_TYP_34_I142_D: "Baju Besi Tahan Ledakan",
  T_49_META_TYP_34_I143_D: "Ransel Lv1",
  T_49_META_TYP_34_I144_D: "Ransel Lv2",
  T_49_META_TYP_34_I145_D: "Ransel Lv3",
  T_49_META_TYP_34_I146_D: "Moncong Lv1",
  T_49_META_TYP_34_I147_D: "Moncong Lv2",
  T_49_META_TYP_34_I148_D: "Moncong Lv3",
  T_49_META_TYP_34_I149_D: "Peredam suara",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Moncong Penyerang",
  T_49_META_TYP_34_I151_D: "Moncong Lebar",
  T_49_META_TYP_34_I152_D: "Majalah Lv1",
  T_49_META_TYP_34_I153_D: "Majalah Lv2",
  T_49_META_TYP_34_I154_D: "Majalah Lv3",
  T_49_META_TYP_34_I155_D: "Majalah Bundel Ganda",
  T_49_META_TYP_34_I156_D: "Majalah Rantai",
  T_49_META_TYP_34_I157_D: "Pegangan Lv1",
  T_49_META_TYP_34_I158_D: "Grip Lv2",
  T_49_META_TYP_34_I159_D: "Pegangan Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Braket Lipat",
  T_49_META_TYP_34_I161_D: "Pegangan Senapan Penembak",
  T_49_META_TYP_34_I162_D: "Stok Senapan",
  T_49_META_TYP_34_I163_D: "Stok Penembak Jitu",
  T_49_META_TYP_34_I164_D: "Lingkup Pencitraan Termal",
  T_49_META_TYP_34_I165_D: "Persediaan Senapan Lv1",
  T_49_META_TYP_34_I166_D: "Stok Lv2",
  T_49_META_TYP_34_I167_D: "Stok Lv3",
  T_49_META_TYP_34_I168_D: "Perisai Ekspander",
  T_49_META_TYP_34_I169_D: "Pelindung Seluruh Tubuh",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Jaket Berlebih",
  T_49_META_TYP_34_I171_D: "Jaket Tahan Ledakan",
  T_49_META_TYP_34_I172_D: "Perluasan Ransel",
  T_49_META_TYP_34_I173_D: "Penyembuhan Pernapasan",
  T_49_META_TYP_34_I174_D: "Garis Horisontal",
  T_49_META_TYP_34_I175_D: "Kot Medis",
  T_49_META_TYP_34_I176_D: "Kit perbaikan pertahanan",
  T_49_META_TYP_34_I177_D: "Menara penjaga AI yang terbuat dari bahan berteknologi tinggi yang secara aktif mencari dan menyerang musuh dalam jarak tertentu",
  T_49_META_TYP_34_I178_D: "Jamur Level 1",
  T_49_META_TYP_34_I179_D: "Jamur Level 2",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Jamur Level 3",
  T_49_META_TYP_34_I181_D: "Jamur Level 4",
  T_49_META_TYP_34_I182_D: "UAV Pribadi",
  T_49_META_TYP_34_I184_D: "Ranjau Sensor",
  T_49_META_TYP_34_I185_D: "Sepatu Terbang Jet",
  T_49_META_TYP_34_I186_D: "Sepatu Daya Pantul",
  T_49_META_TYP_34_I187_D: "Pesawat layang",
  T_49_META_TYP_34_I188_D: "Granat Umpan",
  T_49_META_TYP_34_I189_D: "Papan Luncur Maglev",
  T_49_META_TYP_34_I19_D: "Elang Gurun",
  T_49_META_TYP_34_I190_D: "Tang Penjinak Bom",
  T_49_META_TYP_34_I191_D: "Peningkat Senjata",
  T_49_META_TYP_34_I192_D: "Amunisi Senapan",
  T_49_META_TYP_34_I193_D: "Amunisi Pistol",
  T_49_META_TYP_34_I194_D: "Amunisi Senapan Sniper",
  T_49_META_TYP_34_I195_D: "Amunisi Senapan",
  T_49_META_TYP_34_I196_D: "Amunisi SMG",
  T_49_META_TYP_34_I197_D: "Panah",
  T_49_META_TYP_34_I198_D: "Granat M79",
  T_49_META_TYP_34_I199_D: "Peluru Penyembur Api",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "LEMPARAN2",
  T_49_META_TYP_34_I201_D: "Kait",
  T_49_META_TYP_34_I202_D: "Senapan Sepak Bola",
  T_49_META_TYP_34_I203_D: "Tinju",
  T_49_META_TYP_34_I204_D: "Senapan Api",
  T_49_META_TYP_34_I205_D: "Kartu Monkeygod",
  T_49_META_TYP_34_I206_D: "Kartu MadeManACard",
  T_49_META_TYP_34_I207_D: "Kartu Djmale",
  T_49_META_TYP_34_I208_D: "Kartu Graffitist",
  T_49_META_TYP_34_I209_D: "Kartu Detektif",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "Kartu Profesor",
  T_49_META_TYP_34_I211_D: "Kartu BountyHunter",
  T_49_META_TYP_34_I212_D: "Kartu Superstar",
  T_49_META_TYP_34_I213_D: "Kartu Xtreme",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "Kartu Santino",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "Kartu Penjahat",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "LUKA-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Perisai Sepak Bola",
  T_49_META_TYP_34_I30_D: "Pistol Energi Super Panas",
  T_49_META_TYP_34_I31_D: "Pistol Super Panas-I",
  T_49_META_TYP_34_I32_D: "Pistol Super Panas-II",
  T_49_META_TYP_34_I33_D: "Pistol Super Panas-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Sembuhkan Pistol-Y",
  T_49_META_TYP_34_I36_D: "Menyembuhkan Penembak Jitu",
  T_49_META_TYP_34_I37_D: "Sembuhkan Pistol",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Panci",
  T_49_META_TYP_34_I44_D: "Parang",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Pemukul Baseball",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Pedang Samurai",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Pistol Pengait Daya",
  T_49_META_TYP_34_I71_D: "Pisau FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3-Putaran 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Burung Pelatuk",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Sabit",
  T_49_META_TYP_34_I87_D: "Palu Kepala Besar",
  T_49_META_TYP_34_I88_D: "Belati Terbang (dapat dipilih)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Mudah",
  T_49_META_TYP_340_I1_D: "Sederhana",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Sedang",
  T_49_META_TYP_340_I4_D: "Sulit",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Mulai Acara",
  T_49_META_TYP_342_I1_D: "Hentikan Acara",
  T_49_META_TYP_342_I2_D: "Jeda Acara",
  T_49_META_TYP_342_I3_D: "Berapa lama menunggu setelah dibuat untuk memulai pengatur waktu, dalam milidetik",
  T_49_META_TYP_342_I4_D: "Jumlah Putaran",
  T_49_META_TYP_342_I5_D: "Acara",
  T_49_META_TYP_342_I6_D: "Hitung mundur atau waktu positif",
  T_49_META_TYP_342_I7_D: "Status Pemain",
  T_49_META_TYP_342_I8_D: "Waktu akhir pengaturan waktu dalam detik",
  T_49_META_TYP_345_I10_D: "Meriam Tangan",
  T_49_META_TYP_345_I12_D: "Pistol Dinding Es",
  T_49_META_TYP_345_I13_D: "Senapan Api",
  T_49_META_TYP_345_I4_D: "Senapan",
  T_49_META_TYP_345_I6_D: "Senjata Khusus",
  T_49_META_TYP_345_I8_D: "Akumulator",
  T_49_META_TYP_346_I0_D: "Amunisi Senapan",
  T_49_META_TYP_346_I1_D: "Amunisi Pistol",
  T_49_META_TYP_346_I2_D: "Amunisi Senapan Sniper",
  T_49_META_TYP_346_I3_D: "Amunisi Senapan",
  T_49_META_TYP_346_I4_D: "Amunisi SMG",
  T_49_META_TYP_346_I5_D: "Panah",
  T_49_META_TYP_346_I6_D: "Granat M79",
  T_49_META_TYP_346_I7_D: "Kait",
  T_49_META_TYP_346_I8_D: "Granat Khusus M79",
  T_49_META_TYP_347_I3_D: "Dapat dikombinasikan dengan Gerakan Relatif jika benar, harus dikombinasikan dengan Gerakan Mutlak jika salah, jika tidak, atribut tidak akan berlaku dengan benar.",
  T_49_META_TYP_347_I6_D: "Nilai Delta",
  T_49_META_TYP_350_I0_D: "Mobil Sport",
  T_49_META_TYP_350_I1_D: "Sepeda Motor",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Truk Monster",
  T_49_META_TYP_350_I5_D: "Truk Mutan",
  T_49_META_TYP_352_I1_D: "Sprite Tidak Terpilih",
  T_49_META_TYP_352_I2_D: "Jenis gambar yang tidak dicentang",
  T_49_META_TYP_352_I3_D: "Warna Tidak Terpilih",
  T_49_META_TYP_352_I4_D: "Sprite Terpilih",
  T_49_META_TYP_352_I5_D: "Jenis Gambar Dipilih",
  T_49_META_TYP_352_I6_D: "Warna Terpilih",
  T_49_META_TYP_353_I0_D: "Jumlah Pemulihan HP",
  T_49_META_TYP_353_I1_D: "Kecepatan Pemulihan HP (ms)",
  T_49_META_TYP_353_I2_D: "Waktu yang Diperlukan (ms)",
  T_49_META_TYP_354_I0_D: "Jumlah Pemulihan EP",
  T_49_META_TYP_355_I0_D: "Jumlah Pemulihan HP",
  T_49_META_TYP_355_I1_D: "Jumlah Pemulihan EP",
  T_49_META_TYP_355_I2_D: "Waktu yang Diperlukan (ms)",
  T_49_META_TYP_356_I0_D: "Barang Jatuh",
  T_49_META_TYP_356_I1_D: "Waktu jatuhnya kotak drop ms",
  T_49_META_TYP_356_I2_D: "Status Jatuh Udara",
  T_49_META_TYP_357_I0_D: "Permukaan",
  T_49_META_TYP_357_I1_D: "Batas",
  T_49_META_TYP_359_I0_D: "Apakah akan menggunakan pengontrol pemain dengan efek fisika",
  T_49_META_TYP_359_I1_D: "Ditempatkan di lereng di atas sudut ini, maka akan meluncur ke bawah",
  T_49_META_TYP_359_I10_D: "Akselerasi gravitasi hanya untuk pengontrol pemutar ini",
  T_49_META_TYP_359_I11_D: "Massa dalam kg",
  T_49_META_TYP_359_I12_D: "Jika kemiringan melebihi sudut menanjak maksimum, kapsul akan meluncur ke bawah.",
  T_49_META_TYP_359_I16_D: "Ketika diaktifkan, gerakan dikendalikan oleh tupel atau skrip sisi server.",
  T_49_META_TYP_359_I17_D: "Ketika diaktifkan, gaya yang diberikan ketika karakter mendorong pada benda yang kaku dapat disesuaikan.",
  T_49_META_TYP_359_I18_D: "Jumlah gaya yang diberikan saat karakter mendorong benda kaku",
  T_49_META_TYP_359_I19_D: "Benar ketika bagian bawah tubuh menyentuh benda tabrakan, biasanya digunakan untuk menentukan apakah pemain berada di tanah atau tidak.",
  T_49_META_TYP_359_I2_D: "Hanya rintangan di atas ketinggian ini yang akan memiliki efek pemblokiran, dalam kisaran [0, Tinggi]",
  T_49_META_TYP_359_I20_D: "Tingkat fisika yang dapat disesuaikan, nilai [0,15].",
  T_49_META_TYP_359_I21_D: "Mengaktifkan Putar dengan Gravitasi",
  T_49_META_TYP_359_I3_D: "Memungkinkan penyematan untuk mengubah kedalaman badan kapsul. Dapat mencegah karakter tersangkut atau berguncang, tidak disarankan untuk diubah tanpa kebutuhan khusus. Kisaran nilai (0,Radius]",
  T_49_META_TYP_359_I4_D: "Jarak gerakan minimum, gerakan apa pun yang kurang dari nilai ini tidak akan dieksekusi. Jika tidak ada kebutuhan khusus, disarankan untuk mempertahankannya pada 0.",
  T_49_META_TYP_359_I5_D: "Pergeseran pusat kotak tabrakan dari asal koordinat lokal.",
  T_49_META_TYP_359_I6_D: "Radius kapsul, nilai minimum 0,01.",
  T_49_META_TYP_359_I7_D: "Tinggi total kapsul, termasuk belahan atas dan bawah, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Kecepatan linier saat ini, dalam m/s",
  T_49_META_TYP_360_I0_D: "Sudut Tembak Kiri",
  T_49_META_TYP_360_I1_D: "Sudut Tembak Kanan",
  T_49_META_TYP_360_I2_D: "Sudut Elevasi Minimum",
  T_49_META_TYP_360_I3_D: "Sudut Depresi Maksimum",
  T_49_META_TYP_360_I4_D: "Kecepatan Muzzle",
  T_49_META_TYP_362_I0_D: "Waktu pembekuan yang disebabkan oleh memukul pemain, dalam detik",
  T_49_META_TYP_363_I0_D: "Menonaktifkan Permintaan Pembelian Hud",
  T_49_META_TYP_363_I1_D: "Meminta bantuan dari tim untuk membeli",
  T_49_META_TYP_363_I2_D: "Membeli dengan meminta bantuan dari kamp",
  T_49_META_TYP_364_I0_D: "Apakah Posisi Pusat",
  T_49_META_TYP_364_I1_D: "Apakah akan mengulang",
  T_49_META_TYP_364_I2_D: "Nama animasi",
  T_49_META_TYP_364_I3_D: "Apakah akan diputar otomatis atau tidak",
  T_49_META_TYP_364_I4_D: "Gunakan Sumber Kustom",
  T_49_META_TYP_366_I0_D: "Menentukan UUID sumber daya Batch yang akan dirender.",
  T_49_META_TYP_367_I1_D: "Tampilkan Label",
  T_49_META_TYP_367_I2_D: "Gaya ikon untuk target penanda",
  T_49_META_TYP_367_I3_D: "Warna hamparan ikon yang ditampilkan pada target yang ditandai",
  T_49_META_TYP_367_I4_D: "Gaya ikon yang ditampilkan pada skala",
  T_49_META_TYP_367_I5_D: "Warna hamparan ikon yang ditampilkan dalam skala",
  T_49_META_TYP_367_I6_D: "Selalu Tampilkan Tandai",
  T_49_META_TYP_370_I0_D: "Judul utama",
  T_49_META_TYP_370_I1_D: "Subjudul",
  T_49_META_TYP_370_I2_D: "Warna latar belakang atas",
  T_49_META_TYP_370_I3_D: "Warna latar belakang bawah",
  T_49_META_TYP_371_I2_D: "Skor Kiri",
  T_49_META_TYP_371_I3_D: "Skor Kanan",
  T_49_META_TYP_371_I4_D: "Nilai terakhir di sebelah kiri, digunakan untuk memainkan animasi pengalihan nilai",
  T_49_META_TYP_371_I5_D: "Skor terakhir di sebelah kanan, untuk animasi pengalihan skor",
  T_49_META_TYP_372_I0_D: "Berdiri",
  T_49_META_TYP_372_I1_D: "Tampilkan Jongkok",
  T_49_META_TYP_372_I10_D: "Jatuh tinggi",
  T_49_META_TYP_372_I11_D: "Jatuh rendah, misalnya melompat",
  T_49_META_TYP_372_I12_D: "Sepatu terbang",
  T_49_META_TYP_372_I13_D: "Dua lompatan lompatan",
  T_49_META_TYP_372_I14_D: "Duduk di atas kursi",
  T_49_META_TYP_372_I15_D: "Dilontarkan dengan ketapel",
  T_49_META_TYP_372_I16_D: "Tahap persiapan ketapel",
  T_49_META_TYP_372_I17_D: "Alat peraga meluncur meluncur",
  T_49_META_TYP_372_I18_D: "Jatuhkan alat peraga meluncur",
  T_49_META_TYP_372_I19_D: "Dipantulkan oleh ban",
  T_49_META_TYP_372_I2_D: "Berlari",
  T_49_META_TYP_372_I20_D: "Dipantulkan oleh ban manusia",
  T_49_META_TYP_372_I21_D: "Aksi di zona pesta",
  T_49_META_TYP_372_I22_D: "Menaiki Mesin Terbang",
  T_49_META_TYP_372_I23_D: "Memasuki Meriam",
  T_49_META_TYP_372_I24_D: "Saat keluar dari Meriam, Pengangkut, dll., ini adalah keadaan jika objek wahana sedang terbang",
  T_49_META_TYP_372_I25_D: "Setelah melompat dari papan loncatan",
  T_49_META_TYP_372_I26_D: "Setelah turun dari zipline",
  T_49_META_TYP_372_I27_D: "Tidak digunakan",
  T_49_META_TYP_372_I3_D: "Turun dan Merangkak",
  T_49_META_TYP_372_I4_D: "Berenang",
  T_49_META_TYP_372_I5_D: "Jatuh secara vertikal",
  T_49_META_TYP_372_I6_D: "Melewati dinding",
  T_49_META_TYP_372_I7_D: "Tidak digunakan",
  T_49_META_TYP_372_I8_D: "Terjatuh tapi tidak mati",
  T_49_META_TYP_372_I9_D: "Skateboard Air",
  T_49_META_TYP_374_I0_D: "Warna kehidupan, level, dan goresan",
  T_49_META_TYP_374_I1_D: "Ketika nyawa berkurang, bagian yang hilang ditampilkan secara singkat dalam warna ini.",
  T_49_META_TYP_374_I10_D: "Offset relatif terhadap target yang akan diikuti",
  T_49_META_TYP_374_I11_D: "Jumlah nyawa di antara setiap baris, jika kurang dari atau sama dengan 0, maka tidak akan ditampilkan.",
  T_49_META_TYP_374_I12_D: "HP Total",
  T_49_META_TYP_374_I13_D: "HP Saat Ini",
  T_49_META_TYP_374_I14_D: "Ketika diaktifkan, perubahan darah akan diberi warna yang berbeda.",
  T_49_META_TYP_374_I15_D: "Ketika diaktifkan, atribut offset ditransfer ke sistem koordinat dunia menggunakan sistem koordinat lokal.",
  T_49_META_TYP_374_I2_D: "Warna ini ditampilkan secara singkat untuk bagian yang bertambah dari nilai nyawa apabila nilai nyawa meningkat",
  T_49_META_TYP_374_I3_D: "Warna batas nilai kehidupan dan bagian bawah sketsa.",
  T_49_META_TYP_374_I4_D: "Kisaran 0~1, transparansi UI secara keseluruhan.",
  T_49_META_TYP_374_I5_D: "Menentukan penskalaan UI secara keseluruhan, dan penskalaan font juga.",
  T_49_META_TYP_374_I6_D: "Menunjukkan nama pemilik noda darah saat ini",
  T_49_META_TYP_374_I8_D: "Panjang bagian noda darah pada layar",
  T_49_META_TYP_374_I9_D: "Harus mengikuti entitas dengan komponen Transform.",
  T_49_META_TYP_375_I1_D: "Entitas Pertempuran",
  T_49_META_TYP_376_I1_D: "Entitas Pertempuran",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Default",
  T_49_META_TYP_382_I1_D: "Melewati status knockdown dan mati begitu saja",
  T_49_META_TYP_382_I2_D: "Tidak Lewati Jatuh",
  T_49_META_TYP_387_I1_D: "Izinkan Tekan di Luar",
  T_49_META_TYP_389_I0_D: "Pergeseran default dari dasar",
  T_49_META_TYP_389_I1_D: "Sprite Latar Belakang",
  T_49_META_TYP_389_I10_D: "Alfa Tidak Aktif",
  T_49_META_TYP_389_I2_D: "Radius Latar Belakang",
  T_49_META_TYP_389_I3_D: "Gambar Cap Joystick",
  T_49_META_TYP_389_I4_D: "Radius Cap Joystick",
  T_49_META_TYP_389_I5_D: "Radius Tarik Cap Joystick",
  T_49_META_TYP_389_I6_D: "Sprite Panah",
  T_49_META_TYP_389_I7_D: "Ukuran Panah",
  T_49_META_TYP_389_I8_D: "Offset Panah",
  T_49_META_TYP_389_I9_D: "Alfa Aktif",
  T_49_META_TYP_39_I1_D: "Bentuk Sprite",
  T_49_META_TYP_39_I10_D: "Gradien Atas",
  T_49_META_TYP_39_I11_D: "Gradien Bawah",
  T_49_META_TYP_39_I12_D: "Alfa Atas",
  T_49_META_TYP_39_I13_D: "Alfa Bawah",
  T_49_META_TYP_39_I3_D: "Pembalik",
  T_49_META_TYP_39_I4_D: "Terisi",
  T_49_META_TYP_39_I5_D: "Tengah Tidak Terlihat",
  T_49_META_TYP_39_I6_D: "Arah Pengisian",
  T_49_META_TYP_39_I7_D: "Nilai Pengisian",
  T_49_META_TYP_39_I8_D: "Balik Pengisian",
  T_49_META_TYP_39_I9_D: "Gradien",
  T_49_META_TYP_392_I0_D: "Waktu default untuk zona aman muncul dalam permainan per giliran adalah 0, dalam ms.",
  T_49_META_TYP_392_I1_D: "Waktu yang dibutuhkan untuk mengecilkan lingkaran, dalam ms",
  T_49_META_TYP_392_I10_D: "Waktu akhir lingkaran, dalam ms",
  T_49_META_TYP_392_I12_D: "Jari-jari lingkaran akhir",
  T_49_META_TYP_392_I13_D: "Waktu Mulai Penyusutan",
  T_49_META_TYP_392_I14_D: "Interval Kerusakan (ms)",
  T_49_META_TYP_392_I3_D: "Jumlah kerusakan yang diberikan kepada pemain di dalam lingkaran beracun dalam satu giliran.",
  T_49_META_TYP_392_I4_D: "Daftar pemain di zona aman",
  T_49_META_TYP_392_I5_D: "Waktu menghilangnya zona aman, tidak ada zona aman yang akan dihasilkan ketika waktu menghilangnya zona aman kurang dari waktu efektif.",
  T_49_META_TYP_392_I6_D: "ID Grup",
  T_49_META_TYP_392_I7_D: "Jari-jari lingkaran awal",
  T_49_META_TYP_392_I8_D: "Status akhir",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "Nilai sekitar 3.1416",
  T_49_META_TYP_394_I1_D: "Nilai sekitar 2.7183",
  T_49_META_TYP_396_I0_D: "Judul",
  T_49_META_TYP_396_I1_D: "Konten",
  T_49_META_TYP_396_I2_D: "Opsi",
  T_49_META_TYP_396_I3_D: "Tampilkan Latar Belakang",
  T_49_META_TYP_399_I0_D: "Tinggi Lonjakan",
  T_49_META_TYP_399_I1_D: "Jumlah lompatan berurutan yang dapat dilakukan sebelum mendarat",
  T_49_META_TYP_399_I2_D: "Berapa banyak lompatan lagi yang dapat dilakukan sebelum mendarat",
  T_49_META_TYP_399_I3_D: "Apakah Dapat Bergerak di Udara",
  T_49_META_TYP_40_I1_D: "Label",
  T_49_META_TYP_40_I10_D: "Jarak Baris",
  T_49_META_TYP_40_I11_D: "Metode luapan",
  T_49_META_TYP_40_I12_D: "Gaya Font",
  T_49_META_TYP_40_I13_D: "Terapkan Bayangan",
  T_49_META_TYP_40_I14_D: "Warna Bayangan",
  T_49_META_TYP_40_I15_D: "Offset Bayangan",
  T_49_META_TYP_40_I3_D: "Kunci yang dilokalkan, dapat digunakan dalam berbagai bahasa",
  T_49_META_TYP_40_I5_D: "Metode penyelarasan",
  T_49_META_TYP_40_I6_D: "Penyelarasan Vertikal",
  T_49_META_TYP_40_I7_D: "Tebal",
  T_49_META_TYP_40_I8_D: "Miring",
  T_49_META_TYP_40_I9_D: "Garis Bawah",
  T_49_META_TYP_400_I0_D: "Aktif",
  T_49_META_TYP_400_I1_D: "Pasif",
  T_49_META_TYP_400_I2_D: "Tidak Menyerang",
  T_49_META_TYP_401_I0_D: "Tidak bisa menembak.",
  T_49_META_TYP_401_I1_D: "Dapat menembak terus menerus",
  T_49_META_TYP_401_I2_D: "Menembak sekali per perintah serangan",
  T_49_META_TYP_401_I3_D: "Tiga kali per perintah serangan.",
  T_49_META_TYP_401_I4_D: "Menembak dua kali per perintah serangan",
  T_49_META_TYP_401_I5_D: "Menangkis",
  T_49_META_TYP_402_I0_D: "Target ke teman",
  T_49_META_TYP_402_I1_D: "Jenis Fungsi",
  T_49_META_TYP_402_I2_D: "Gaya",
  T_49_META_TYP_403_I0_D: "Tambah Teman",
  T_49_META_TYP_403_I1_D: "Laporkan",
  T_49_META_TYP_404_I0_D: "Terang",
  T_49_META_TYP_404_I1_D: "Gelap",
  T_49_META_TYP_405_I0_D: "Berdasarkan hierarki",
  T_49_META_TYP_405_I1_D: "Berdasarkan prioritas tinggi ke rendah",
  T_49_META_TYP_405_I2_D: "Berdasarkan prioritas rendah ke tinggi",
  T_49_META_TYP_406_I0_D: "Mengontrol jarak gerakan penyerbuan pemain",
  T_49_META_TYP_406_I1_D: "Mengontrol ketinggian gerakan tubuh pemain selama melompat.",
  T_49_META_TYP_407_I0_D: "Lokal",
  T_49_META_TYP_407_I1_D: "Klien",
  T_49_META_TYP_407_I2_D: "Server",
  T_49_META_TYP_407_I3_D: "Keduanya",
  T_49_META_TYP_409_I0_D: "Tidak ada kesalahan",
  T_49_META_TYP_409_I1_D: "Batas waktu penyimpanan data, terutama untuk operasi baca",
  T_49_META_TYP_409_I10_D: "Perubahan tim gagal - tim target tidak valid",
  T_49_META_TYP_409_I11_D: "Perubahan tim gagal - Pemain yang sudah mati tidak diizinkan untuk mengubah tim",
  T_49_META_TYP_409_I12_D: "Perubahan tim gagal - tidak diizinkan untuk mengubah tim di operator",
  T_49_META_TYP_409_I2_D: "Frekuensi baca dan tulis penyimpanan data melebihi batas",
  T_49_META_TYP_409_I3_D: "Pengecualian Parameter",
  T_49_META_TYP_409_I4_D: "Gagal membuat ruang: tidak ada PersonaID yang valid",
  T_49_META_TYP_409_I5_D: "Status kesalahan tidak terdefinisi",
  T_49_META_TYP_409_I6_D: "Layanan yang dikomersialkan ditutup, pengguna tidak lagi memiliki akses ke layanan pengembang",
  T_49_META_TYP_409_I7_D: "Gagal mengubah tim - mode tidak didukung",
  T_49_META_TYP_409_I8_D: "Perubahan tim gagal-Saat ini sudah berada di tim target",
  T_49_META_TYP_409_I9_D: "Perubahan antrean gagal-target tidak valid",
  T_49_META_TYP_41_I0_D: "Bentuk Sprite",
  T_49_META_TYP_41_I19_D: "Nonaktifkan kotak tabrakan",
  T_49_META_TYP_41_I3_D: "Warna Dinonaktifkan",
  T_49_META_TYP_41_I4_D: "Warna Ditekan",
  T_49_META_TYP_41_I5_D: "Jenis Pengisian",
  T_49_META_TYP_41_I6_D: "Apakah Tombol FE",
  T_49_META_TYP_41_I7_D: "Sprite Ditekan",
  T_49_META_TYP_41_I8_D: "Jenis Sprite Ditekan",
  T_49_META_TYP_41_I9_D: "Jenis Balik",
  T_49_META_TYP_411_I0_D: "Kecepatan Maju",
  T_49_META_TYP_411_I1_D: "Kecepatan Mundur",
  T_49_META_TYP_411_I2_D: "Kecepatan Naik",
  T_49_META_TYP_411_I3_D: "Kecepatan Turun",
  T_49_META_TYP_411_I4_D: "Kerusakan Minimum Granat",
  T_49_META_TYP_411_I5_D: "Kerusakan Maksimum Granat",
  T_49_META_TYP_411_I6_D: "Jangkauan Granat",
  T_49_META_TYP_412_I0_D: "Tenaga kuda yang diperoleh kendaraan saat menggunakan tombol gas",
  T_49_META_TYP_412_I1_D: "Tenaga kuda yang diperoleh kendaraan saat menggunakan tombol mundur/rem",
  T_49_META_TYP_412_I2_D: "Sudut kemudi maksimum pada kecepatan tinggi",
  T_49_META_TYP_412_I3_D: "Ambang batas kecepatan yang diterapkan pada sudut kemudi maksimum pada kecepatan tinggi",
  T_49_META_TYP_412_I4_D: "Setelah mencapai kecepatan maksimum, pengangkut tidak memberikan tenaga kuda lagi, tetapi pengangkut dapat melebihi kecepatan maksimum tersebut (misalnya melalui jalan menurun)",
  T_49_META_TYP_412_I5_D: "Ketika pengangkut tidak bermanuver, pengangkut diperlambat dengan mengalikan IdleBrakeInput dengan BrakeTorque",
  T_49_META_TYP_412_I6_D: "Perhitungan kerusakan untuk tabrakan, dengan menerapkan parameter rumus kerusakan",
  T_49_META_TYP_412_I7_D: "Perhitungan kerusakan untuk serudukan, kerusakan tidak akan bertambah meskipun kecepatannya terlampaui",
  T_49_META_TYP_412_I8_D: "Perhitungan kerusakan untuk serudukan, kerusakan minimum",
  T_49_META_TYP_412_I9_D: "Perhitungan kerusakan untuk serudukan, kerusakan maksimum",
  T_49_META_TYP_413_I0_D: "Kostum yang diubah Pemain (NPC)",
  T_49_META_TYP_414_I1_D: "Rentang Luas",
  T_49_META_TYP_415_I0_D: "ID Persona",
  T_49_META_TYP_415_I1_D: "Nama Panggilan",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "Persona yang terikat dengannya",
  T_49_META_TYP_416_I2_D: "Offset",
  T_49_META_TYP_416_I3_D: "Tinggi",
  T_49_META_TYP_416_I4_D: "Apakah akan membalas pesan sistem",
  T_49_META_TYP_416_I5_D: "Nama panggilan Persona",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Nama panggilan pengguna",
  T_49_META_TYP_416_I8_D: "UserAvatar",
  T_49_META_TYP_417_I0_D: "ID Sumber Daya",
  T_49_META_TYP_418_I0_D: "Masa berlaku keanggotaan berakhir",
  T_49_META_TYP_418_I1_D: "Menjadi anggota",
  T_49_META_TYP_418_I2_D: "Memperbarui keanggotaan",
  T_49_META_TYP_42_I0_D: "Teks Default",
  T_49_META_TYP_42_I1_D: "Teks Aktif",
  T_49_META_TYP_42_I10_D: "Panjang Maksimum",
  T_49_META_TYP_42_I14_D: "Warna Ditekan",
  T_49_META_TYP_42_I16_D: "Kunci yang dilokalkan, tersedia dalam berbagai bahasa",
  T_49_META_TYP_42_I3_D: "Metode perataan",
  T_49_META_TYP_42_I4_D: "Penyelarasan Vertikal",
  T_49_META_TYP_42_I5_D: "Tebal",
  T_49_META_TYP_42_I6_D: "Miring",
  T_49_META_TYP_42_I7_D: "Garis Bawah",
  T_49_META_TYP_42_I8_D: "Jarak Baris",
  T_49_META_TYP_42_I9_D: "Pembungkusan Kata",
  T_49_META_TYP_424_I0_D: "Kabut Linier",
  T_49_META_TYP_424_I1_D: "Kabut Eksponensial",
  T_49_META_TYP_424_I2_D: "Kabut Persegi Eksponensial",
  T_49_META_TYP_426_I0_D: "Intensitas",
  T_49_META_TYP_426_I1_D: "Jangkauan",
  T_49_META_TYP_426_I2_D: "Sudut kerucut dalam derajat",
  T_49_META_TYP_426_I3_D: "Warna terang",
  T_49_META_TYP_428_I0_D: "ID Skin Senjata",
  T_49_META_TYP_428_I2_D: "ID Setelan",
  T_49_META_TYP_428_I3_D: "ID Penutup Kepala",
  T_49_META_TYP_428_I4_D: "ID Wajah",
  T_49_META_TYP_428_I5_D: "ID Riasan",
  T_49_META_TYP_428_I6_D: "ID Tubuh Bagian Atas",
  T_49_META_TYP_428_I7_D: "ID Bawah",
  T_49_META_TYP_428_I8_D: "ID Sepatu",
  T_49_META_TYP_431_I1_D: "Lintasan entitas target",
  T_49_META_TYP_431_I3_D: "Kecepatan gerakan, satuan m/s",
  T_49_META_TYP_431_I4_D: `Apakah objek akan bergerak mengikuti garis singgung jalur atau tidak?
Secara default, nilainya adalah False, objek tidak akan mengubah arah.
Jika disetel ke True, objek akan menghadap ke arah depan jalur.`,
  T_49_META_TYP_431_I5_D: "Persentase Dimainkan",
  T_49_META_TYP_432_I0_D: "Sudut rollover, mempengaruhi rotasi radial jalur dari kedua sisi titik ini",
  T_49_META_TYP_432_I1_D: "Posisi relatif titik kontrol garis singgung terhadap titik jalan, yang menentukan garis singgung jalur.",
  T_49_META_TYP_433_I0_D: "Interpolasi linier antara titik-titik jalur",
  T_49_META_TYP_433_I1_D: "Interpolasi kurva antara titik jalur untuk pergerakan yang mulus",
  T_49_META_TYP_433_I2_D: "Mendukung penyesuaian manual garis singgung ke titik-titik kurva",
  T_49_META_TYP_434_I0_D: "Jenis jalur",
  T_49_META_TYP_434_I1_D: "Panjang total jalur",
  T_49_META_TYP_434_I2_D: "Apakah jalur dimulai dan berakhir pada waktu yang sama atau tidak",
  T_49_META_TYP_434_I3_D: "Kumpulan titik jalan",
  T_49_META_TYP_437_I3_D: "Pemain Kiri",
  T_49_META_TYP_437_I4_D: "Pemain Kanan",
  T_49_META_TYP_437_I5_D: "Larik nama jenis poin",
  T_49_META_TYP_437_I6_D: "Larik poin kiri (Daftar 1D: pemain; Daftar 2D: data poin yang diisi sesuai dengan jenis poin khusus)",
  T_49_META_TYP_437_I7_D: "Larik poin di sebelah kanan (Daftar 1D: pemain; Daftar 2D: data poin yang diisi menurut jenis poin khusus)",
  T_49_META_TYP_438_I1_D: "Larik pemain yang dikelompokkan",
  T_49_META_TYP_438_I2_D: "Larik Peringkat yang dikelompokkan",
  T_49_META_TYP_438_I3_D: "Larik skor yang dikelompokkan",
  T_49_META_TYP_438_I4_D: "Larik nama jenis poin",
  T_49_META_TYP_438_I5_D: "Larik warna kelompok",
  T_49_META_TYP_438_I6_D: "Larik poin pemain (sesuai dengan urutan mereka saat tidak dikelompokkan)",
  T_49_META_TYP_442_I1_D: "Skor Kiri",
  T_49_META_TYP_442_I10_D: "Ikon kematian kanan",
  T_49_META_TYP_442_I2_D: "Skor Kanan",
  T_49_META_TYP_442_I3_D: "Jumlah penyintas di sebelah kiri",
  T_49_META_TYP_442_I4_D: "Orang yang selamat di sebelah kanan",
  T_49_META_TYP_442_I5_D: "Kematian Kiri",
  T_49_META_TYP_442_I6_D: "Kematian Kanan",
  T_49_META_TYP_442_I7_D: "Ikon penyintas di sebelah kiri",
  T_49_META_TYP_442_I8_D: "Ikon Bertahan Hidup Kanan",
  T_49_META_TYP_442_I9_D: "Ikon Mati Kiri",
  T_49_META_TYP_444_I0_D: "Bahasa Inggris",
  T_49_META_TYP_444_I1_D: "Bahasa Mandarin Sederhana",
  T_49_META_TYP_444_I10_D: "Bahasa Prancis",
  T_49_META_TYP_444_I11_D: "Bahasa Jerman",
  T_49_META_TYP_444_I12_D: "Bahasa Turki",
  T_49_META_TYP_444_I13_D: "Bahasa Hindi",
  T_49_META_TYP_444_I14_D: "Bahasa Jepang",
  T_49_META_TYP_444_I15_D: "Bahasa Rumania",
  T_49_META_TYP_444_I16_D: "Bahasa Rumania",
  T_49_META_TYP_444_I17_D: "Bahasa Burma",
  T_49_META_TYP_444_I18_D: "Bahasa Urdu",
  T_49_META_TYP_444_I19_D: "Bahasa Bengali",
  T_49_META_TYP_444_I2_D: "Bahasa Tionghoa Tradisional",
  T_49_META_TYP_444_I3_D: "Bahasa Thailand",
  T_49_META_TYP_444_I4_D: "Bahasa Vietnam",
  T_49_META_TYP_444_I5_D: "Bahasa Indonesia",
  T_49_META_TYP_444_I6_D: "Bahasa Mandarin (Sederhana)",
  T_49_META_TYP_444_I7_D: "Bahasa Spanyol",
  T_49_META_TYP_444_I8_D: "Bahasa Rusia",
  T_49_META_TYP_444_I9_D: "Bahasa Korea",
  T_49_META_TYP_51_I0_D: "Zombie Normal",
  T_49_META_TYP_51_I1_D: "Zombie Penebang Kayu",
  T_49_META_TYP_51_I10_D: "Lebah Bom Terbang",
  T_49_META_TYP_51_I11_D: "Naga Zombie",
  T_49_META_TYP_51_I2_D: "Zombie Lempar",
  T_49_META_TYP_51_I3_D: "Zombie Peledak",
  T_49_META_TYP_51_I4_D: "Zombie Tiran",
  T_49_META_TYP_51_I5_D: "Zombie Lempar Merah",
  T_49_META_TYP_51_I6_D: "Mr. V",
  T_49_META_TYP_51_I7_D: "Zombie Tank",
  T_49_META_TYP_51_I8_D: "Zombie Bor",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Penundaan Ledakan",
  T_49_META_TYP_56_I11_D: "Jangkauan Ledakan",
  T_49_META_TYP_56_I12_D: "Kerusakan Ledakan",
  T_49_META_TYP_56_I13_D: "Waktu Terbakar",
  T_49_META_TYP_56_I14_D: "Kerusakan Terbakar",
  T_49_META_TYP_56_I15_D: "Interval Kerusakan Terbakar",
  T_49_META_TYP_56_I17_D: "Pilot Kendaraan",
  T_49_META_TYP_56_I18_D: "Semua penumpang di dalam kendaraan",
  T_49_META_TYP_56_I19_D: "ID Kulit Kendaraan",
  T_49_META_TYP_56_I20_D: "Prioritas Konfigurasi Pemain",
  T_49_META_TYP_56_I21_D: "HP Maksimum",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Apakah akan berteleportasi secara manual atau otomatis (defaultnya adalah manual)",
  T_49_META_TYP_58_I0_D: "Jenis buff yang dihasilkan",
  T_49_META_TYP_58_I1_D: "Waktu dalam detik dari saat buff diambil hingga buff berikutnya dihasilkan.",
  T_49_META_TYP_59_I0_D: "Jenis Gerakan",
  T_49_META_TYP_59_I1_D: "Nilai Gerakan X",
  T_49_META_TYP_59_I2_D: "Nilai Gerakan Y",
  T_49_META_TYP_59_I3_D: "Nilai Gerakan Z",
  T_49_META_TYP_59_I4_D: "Durasi Gerakan",
  T_49_META_TYP_59_I5_D: "Durasi Berhenti",
  T_49_META_TYP_59_I6_D: "Nonaktifkan Gerakan Bolak-Balik",
  T_49_META_TYP_60_I0_D: "Poin senjata jarahan",
  T_49_META_TYP_61_I0_D: "Uang Terikat",
  T_49_META_TYP_61_I1_D: "Mengatur rentang pemicu",
  T_49_META_TYP_61_I2_D: "Visibilitas Model",
  T_49_META_TYP_62_I0_D: "Kecepatan XZ",
  T_49_META_TYP_62_I1_D: "Kecepatan Y",
  T_49_META_TYP_64_I0_D: "Jenis komponen musik",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Titik Jalur",
  T_49_META_TYP_68_I0_D: "Level darah AI saat ini",
  T_49_META_TYP_68_I1_D: "Level darah maksimum AI saat ini",
  T_49_META_TYP_68_I10_D: "Apakah AI menjatuhkan peralatan atau item saat mati.",
  T_49_META_TYP_68_I11_D: "Apakah AI saat ini tidak terkalahkan",
  T_49_META_TYP_68_I12_D: "Persentase kerusakan yang diberikan kepada AI saat menerima kerusakan, baik berkurang atau bertambah.",
  T_49_META_TYP_68_I13_D: "Jenis AI",
  T_49_META_TYP_68_I14_D: "Apakah akan mencari musuh secara otomatis",
  T_49_META_TYP_68_I15_D: "0 adalah serangan otomatis, 1 adalah serangan pertahanan, 2 adalah tidak ada serangan sama sekali.",
  T_49_META_TYP_68_I16_D: "ID Jalur",
  T_49_META_TYP_68_I17_D: "Sasaran Kejar",
  T_49_META_TYP_68_I18_D: "Target Serangan",
  T_49_META_TYP_68_I19_D: "Koordinat titik kelahiran AI",
  T_49_META_TYP_68_I2_D: "Mendapatkan entitas tim AI.",
  T_49_META_TYP_68_I20_D: "Nomor kamp tim",
  T_49_META_TYP_68_I4_D: "Hanya dapat memodifikasi kekuatan serangan dari serangan normal, bukan serangan skill.",
  T_49_META_TYP_68_I7_D: "Jangkauan pergerakan bebas AI, hanya dapat mengubah nilai dasar, jika ada bonus tambahan, maka akan ditambahkan di atas nilai tersebut.",
  T_49_META_TYP_68_I8_D: "Jangkauan AI untuk mendeteksi musuh, hanya dapat mengubah nilai dasar, jika ada bonus tambahan, maka akan ditambahkan di atas nilai tersebut.",
  T_49_META_TYP_68_I9_D: "Kecepatan gerakan sebenarnya, jika ada akselerasi skill maka akan dikalikan dengan nilai tersebut.",
  T_49_META_TYP_70_I0_D: "ID entitas target yang digunakan rumus, digunakan oleh implementasi internal, tidak terlihat oleh pemain.",
  T_49_META_TYP_70_I1_D: "ID atribut dari entitas target tempat rumus bekerja, digunakan oleh implementasi internal, tidak terlihat oleh pemain.",
  T_49_META_TYP_70_I2_D: "Nilai minimum yang diizinkan",
  T_49_META_TYP_70_I3_D: "Nilai maksimum yang diizinkan",
  T_49_META_TYP_70_I4_D: "Koefisien Dasar",
  T_49_META_TYP_70_I5_D: "Pra-Akumulasi",
  T_49_META_TYP_70_I6_D: "Pengganda",
  T_49_META_TYP_70_I7_D: "Kalikan dan Kumpulkan",
  T_49_META_TYP_70_I8_D: "Pasca-Akumulasi",
  T_49_META_TYP_71_I0_D: "Nomor produk",
  T_49_META_TYP_71_I1_D: "Harga",
  T_49_META_TYP_71_I10_D: "Item Toko",
  T_49_META_TYP_71_I2_D: "Jenis Uang",
  T_49_META_TYP_71_I3_D: "Batas keseluruhan",
  T_49_META_TYP_71_I4_D: "Batas keseluruhan saat ini",
  T_49_META_TYP_71_I5_D: "Nama Produk",
  T_49_META_TYP_71_I6_D: "Deskripsi",
  T_49_META_TYP_71_I7_D: "Daftar Item",
  T_49_META_TYP_71_I8_D: "Dapat Dibeli",
  T_49_META_TYP_71_I9_D: "Jalur, kosong secara default",
  T_49_META_TYP_72_I1_D: "Rak",
  T_49_META_TYP_73_I1_D: "Nonaktifkan Penutupan Manual",
  T_49_META_TYP_74_I0_D: "Senjata",
  T_49_META_TYP_74_I1_D: "Helm",
  T_49_META_TYP_74_I2_D: "Rompi",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "Satu Arah",
  T_49_META_TYP_75_I1_D: "Bolak-Balik",
  T_49_META_TYP_76_I0_D: "Hanya untuk patroli. Tidak boleh menyerang target di sepanjang jalan.",
  T_49_META_TYP_76_I1_D: "Patroli Sambil Menyerang",
  T_49_META_TYP_79_I0_D: "Kekuatan Senjata",
  T_49_META_TYP_79_I1_D: "Jangkauan Serangan",
  T_49_META_TYP_79_I10_D: "Hitungan Awal Penyebaran Peluru",
  T_49_META_TYP_79_I11_D: "ID Senjata",
  T_49_META_TYP_79_I12_D: "Waktu tunggu minimum dalam detik di antara tembakan, beberapa tembakan dapat ditembakkan per tembakan tergantung pada jenis tembakan",
  T_49_META_TYP_79_I13_D: "Pemain yang memiliki senjata",
  T_49_META_TYP_79_I14_D: "Konsumsi Amunisi",
  T_49_META_TYP_79_I15_D: "Jenis penggunaan ganda (0 bukan penggunaan ganda 1 dan diri sendiri 2 dan senjata apa pun)",
  T_49_META_TYP_79_I16_D: "Faktor kerusakan baju besi",
  T_49_META_TYP_79_I17_D: "Efek kecepatan gerakan pemain",
  T_49_META_TYP_79_I18_D: "Persentase kerusakan yang mengenai tubuh",
  T_49_META_TYP_79_I19_D: "Persentase kerusakan yang mengenai kepala",
  T_49_META_TYP_79_I2_D: "Jumlah waktu untuk menunggu di antara tembakan, dalam detik.",
  T_49_META_TYP_79_I20_D: "Persentase kerusakan yang mengenai anggota tubuh",
  T_49_META_TYP_79_I21_D: "Kerusakan Ekstra (Kendaraan, Tong Minyak, Dinding Es)",
  T_49_META_TYP_79_I22_D: "Terlihat di Punggung",
  T_49_META_TYP_79_I23_D: "Kerusakan ekstra karena mengenai tanah",
  T_49_META_TYP_79_I24_D: "Peluru per Tembakan",
  T_49_META_TYP_79_I25_D: "Kecepatan pergantian peluru (kecepatan dasar * faktor)",
  T_49_META_TYP_79_I26_D: "Jumlah Amunisi Saat Ini",
  T_49_META_TYP_79_I27_D: "ID Kulit Senjata",
  T_49_META_TYP_79_I28_D: "Ketika konfigurasi pemain diutamakan, konfigurasi kulit senjata pada pemain mengesampingkan properti kulit senjata dari senjata itu sendiri",
  T_49_META_TYP_79_I29_D: "Saat menulis kulit senjata ke properti senjata, nilai dasar senjata dipengaruhi oleh kulit senjata",
  T_49_META_TYP_79_I3_D: "Ukuran Mag Ammunisi",
  T_49_META_TYP_79_I30_D: "Kecepatan peningkatan difusi (0,1 = 10% pelebaran kolimasi untuk setiap ledakan tambahan)",
  T_49_META_TYP_79_I31_D: "Kecepatan pemulihan difusi",
  T_49_META_TYP_79_I32_D: "Efek kecepatan pemain saat menembak",
  T_49_META_TYP_79_I33_D: "Ukuran difusi jika terjadi pergerakan (1,5 = 1,5 * ukuran kolimator dasar)",
  T_49_META_TYP_79_I34_D: "Jenis Senjata",
  T_49_META_TYP_79_I36_D: "Jenis Api",
  T_49_META_TYP_79_I37_D: "Apakah Tembakan Tunggal",
  T_49_META_TYP_79_I38_D: "Apakah Senyap",
  T_49_META_TYP_79_I39_D: "Faktor Sensitivitas ADS",
  T_49_META_TYP_79_I4_D: "Jumlah Peluru Awal",
  T_49_META_TYP_79_I5_D: "Penetrasi Armor",
  T_49_META_TYP_79_I6_D: "Jarak Kerusakan Penuh",
  T_49_META_TYP_79_I7_D: "Jarak Kerusakan Minimum",
  T_49_META_TYP_79_I8_D: "Kerusakan Minimum",
  T_49_META_TYP_79_I9_D: "Jumlah peluru yang dapat ditembakkan sebelum hamburan dimulai.",
  T_49_META_TYP_80_I1_D: "Jika benar, penonaktifan manual dinonaktifkan.",
  T_49_META_TYP_80_I2_D: "Entitas toko yang terikat",
  T_49_META_TYP_80_I4_D: "ID Dompet Terikat",
  T_49_META_TYP_80_I5_D: "Jenis Permintaan",
  T_49_META_TYP_80_I6_D: "Jenis target untuk permintaan pemain UI saat ini",
  T_49_META_TYP_80_I7_D: "ID Pemain Pemicu",
  T_49_META_TYP_81_I0_D: "Buff Acak",
  T_49_META_TYP_81_I1_D: "Buff HP",
  T_49_META_TYP_81_I2_D: "Buff Peluru",
  T_49_META_TYP_81_I3_D: "Buff Armor",
  T_49_META_TYP_82_I1_D: "Ikon tombol",
  T_49_META_TYP_82_I3_D: "Posisi relatif terhadap titik jangkar",
  T_49_META_TYP_83_I1_D: "Uang",
  T_49_META_TYP_83_I2_D: "Parameter yang dilewati",
  T_49_META_TYP_86_I0_D: "Min",
  T_49_META_TYP_86_I1_D: "Maksimum",
  T_49_META_TYP_86_I2_D: "Koefisien dasar, dikalikan dengan nilai asli sebelum semua perhitungan dilakukan.",
  T_49_META_TYP_86_I3_D: "Pra-akumulator, terakumulasi sebelum perkalian, berpartisipasi dalam perhitungan perkalian",
  T_49_META_TYP_86_I4_D: "Pengganda berurutan, misalnya (dikurangi menjadi 90%, diperkuat menjadi 110%) memiliki efek Nilai * 90% * 110%.",
  T_49_META_TYP_86_I5_D: "Akumulator perkalian, misalnya (tambahkan 10%, tambahkan 5%) efeknya adalah Nilai*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Akumulator pos, tidak terlibat dalam perhitungan perkalian, ditumpuk di bagian akhir",
  T_49_META_TYP_88_I0_D: "Jenis dasar, mata uang dalam game yang paling dasar, jenis harga item umum dalam versi saat ini",
  T_49_META_TYP_89_I0_D: "Hanya mata uang dasar yang tersedia dalam versi saat ini",
  T_49_META_TYP_89_I1_D: "kuantitas mata uang",
  T_49_META_TYP_89_I2_D: "Ikon mata uang",
  T_49_META_TYP_89_I3_D: "Warna ikon mata uang",
  T_49_META_TYP_90_I0_D: "Isi dompet adalah sekumpulan mata uang",
  T_49_META_TYP_92_I0_D: "Kotak Kayu Persegi",
  T_49_META_TYP_92_I1_D: "Kotak Kayu Panjang",
  T_49_META_TYP_92_I10_D: "Menara Pengawas",
  T_49_META_TYP_92_I100_D: "Tangga",
  T_49_META_TYP_92_I101_D: "Pendaratan tangga B",
  T_49_META_TYP_92_I102_D: "Pendaratan tangga A",
  T_49_META_TYP_92_I103_D: "Bilik Telepon",
  T_49_META_TYP_92_I104_D: "Dinding bertema BIS",
  T_49_META_TYP_92_I105_D: "Tempat tidur bunga bertema BIS",
  T_49_META_TYP_92_I106_D: "Mesin penjual otomatis",
  T_49_META_TYP_92_I107_D: "Entitas Monster",
  T_49_META_TYP_92_I108_D: "Generator unit",
  T_49_META_TYP_92_I109_D: "Mobil Sport",
  T_49_META_TYP_92_I11_D: "Pos Keamanan",
  T_49_META_TYP_92_I110_D: "Tuk-tuk",
  T_49_META_TYP_92_I111_D: "Kotak kayu yang dapat dihancurkan",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Sepeda Motor",
  T_49_META_TYP_92_I114_D: "Truk Monster",
  T_49_META_TYP_92_I115_D: "Generator emas",
  T_49_META_TYP_92_I116_D: "Pendaratan tangga C",
  T_49_META_TYP_92_I117_D: "Tanda",
  T_49_META_TYP_92_I118_D: "Pagar",
  T_49_META_TYP_92_I119_D: "Mesin jersi",
  T_49_META_TYP_92_I12_D: "Rumah Dua Lantai",
  T_49_META_TYP_92_I121_D: "Pilar beton",
  T_49_META_TYP_92_I122_D: "Kotak Loot Sepak Bola",
  T_49_META_TYP_92_I123_D: "Drum Minyak",
  T_49_META_TYP_92_I124_D: "Area Gravitasi Rendah",
  T_49_META_TYP_92_I125_D: "Senjata",
  T_49_META_TYP_92_I126_D: "Pagar B",
  T_49_META_TYP_92_I127_D: "Rumah kecil A",
  T_49_META_TYP_92_I128_D: "Truk rusak",
  T_49_META_TYP_92_I129_D: "Bola Dasar",
  T_49_META_TYP_92_I13_D: "Patung Pasir",
  T_49_META_TYP_92_I130_D: "Kerucut dasar",
  T_49_META_TYP_92_I131_D: "Silinder dasar",
  T_49_META_TYP_92_I132_D: "Generator barang konsumsi",
  T_49_META_TYP_92_I133_D: "Badan air khusus",
  T_49_META_TYP_92_I134_D: "Panah",
  T_49_META_TYP_92_I135_D: "Blok berwarna",
  T_49_META_TYP_92_I136_D: "Drum berwarna",
  T_49_META_TYP_92_I137_D: "Teks",
  T_49_META_TYP_92_I138_D: "Ikon",
  T_49_META_TYP_92_I139_D: "Boneka es",
  T_49_META_TYP_92_I14_D: "Air Mancur",
  T_49_META_TYP_92_I140_D: "Pemicu Kapsul",
  T_49_META_TYP_92_I141_D: "Pemicu tabrakan bola",
  T_49_META_TYP_92_I142_D: "Blok warna solid reflektif 1",
  T_49_META_TYP_92_I143_D: "Pabrikan mobil bumper",
  T_49_META_TYP_92_I144_D: "Blok taman hiburan kotak-kotak",
  T_49_META_TYP_92_I145_D: "Layar besar",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Lolipop raksasa",
  T_49_META_TYP_92_I148_D: "Truk makanan B",
  T_49_META_TYP_92_I15_D: "Bunga Sakura",
  T_49_META_TYP_92_I16_D: "Rumah Satu Lantai",
  T_49_META_TYP_92_I17_D: "Rumah Tiga Lantai",
  T_49_META_TYP_92_I18_D: "Pohon Pisang",
  T_49_META_TYP_92_I19_D: "Toilet",
  T_49_META_TYP_92_I2_D: "Kotak Kayu Panjang Berpohon",
  T_49_META_TYP_92_I20_D: "Pagar",
  T_49_META_TYP_92_I21_D: "Kontainer yang Dapat Hancur",
  T_49_META_TYP_92_I22_D: "Pagar yang Dapat Hancur",
  T_49_META_TYP_92_I23_D: "Ban",
  T_49_META_TYP_92_I24_D: "Mobil Derak",
  T_49_META_TYP_92_I25_D: "Kendaraan Amphibi",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Tempat Sampah",
  T_49_META_TYP_92_I28_D: "Tenda Medis",
  T_49_META_TYP_92_I29_D: "Garasi",
  T_49_META_TYP_92_I3_D: "Tumpukan Jerami",
  T_49_META_TYP_92_I30_D: "Dinding Berwarna",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Platform Besi",
  T_49_META_TYP_92_I33_D: "Rumah Kontainer",
  T_49_META_TYP_92_I34_D: "Trailer",
  T_49_META_TYP_92_I35_D: "Dinding A",
  T_49_META_TYP_92_I36_D: "Catatan Musik - Piano",
  T_49_META_TYP_92_I37_D: "Catatan Musik - Piano",
  T_49_META_TYP_92_I38_D: "Catatan Musik - Drum",
  T_49_META_TYP_92_I39_D: "Catatan Musik - Drum",
  T_49_META_TYP_92_I4_D: "Mobil Rusak",
  T_49_META_TYP_92_I40_D: "Catatan Musik - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Catatan Musik - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Catatan Musik - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Catatan Musik - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Catatan Musik - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Catatan Musik - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Pembuat Buff",
  T_49_META_TYP_92_I47_D: "Mekanisme Baling-baling",
  T_49_META_TYP_92_I48_D: "Pan Loot",
  T_49_META_TYP_92_I49_D: "Harta Karun Kubus",
  T_49_META_TYP_92_I5_D: "Bus Rusak",
  T_49_META_TYP_92_I50_D: "Harta Karun Lingkaran",
  T_49_META_TYP_92_I51_D: "Mesin Palu",
  T_49_META_TYP_92_I52_D: "Papan Pindah",
  T_49_META_TYP_92_I53_D: "Target Bergerak",
  T_49_META_TYP_92_I54_D: "Dinding yang Dapat Ditarik",
  T_49_META_TYP_92_I55_D: "Komponen Senjata Titik Jarahan",
  T_49_META_TYP_92_I56_D: "Komponen Peluru Loot Point",
  T_49_META_TYP_92_I57_D: "Komponen Item yang Dapat Dihabiskan Loot Point",
  T_49_META_TYP_92_I58_D: "Komponen Item yang Dapat Dilempar Loot Point",
  T_49_META_TYP_92_I59_D: "Pengganda Loot Point",
  T_49_META_TYP_92_I6_D: "Kontainer A",
  T_49_META_TYP_92_I60_D: "Komponen Armor Loot Point",
  T_49_META_TYP_92_I61_D: "Pipa I",
  T_49_META_TYP_92_I62_D: "Pipa T",
  T_49_META_TYP_92_I63_D: "Pipa Silang",
  T_49_META_TYP_92_I64_D: "Pipa Siku",
  T_49_META_TYP_92_I65_D: "Kelompok Jamur Raksasa",
  T_49_META_TYP_92_I66_D: "Rak Pengering",
  T_49_META_TYP_92_I67_D: "Jembatan Kayu",
  T_49_META_TYP_92_I68_D: "Layar Kisi",
  T_49_META_TYP_92_I69_D: "Kolom Beton",
  T_49_META_TYP_92_I7_D: "Kontainer B",
  T_49_META_TYP_92_I70_D: "Kaktus",
  T_49_META_TYP_92_I71_D: "Kayu Mati",
  T_49_META_TYP_92_I72_D: "Lentera Batu",
  T_49_META_TYP_92_I73_D: "Lampu Jalan",
  T_49_META_TYP_92_I74_D: "Panel Surya",
  T_49_META_TYP_92_I75_D: "AC",
  T_49_META_TYP_92_I76_D: "Kotak",
  T_49_META_TYP_92_I77_D: "Kemiringan",
  T_49_META_TYP_92_I78_D: "Truk makanan",
  T_49_META_TYP_92_I79_D: "Pemicu Kematian atau Kewalahan",
  T_49_META_TYP_92_I8_D: "Kontainer C",
  T_49_META_TYP_92_I80_D: "Titik pemeriksaan",
  T_49_META_TYP_92_I81_D: "Posisi Akhir",
  T_49_META_TYP_92_I82_D: "Dadu",
  T_49_META_TYP_92_I83_D: "Bangku",
  T_49_META_TYP_92_I84_D: "Halte Bus",
  T_49_META_TYP_92_I85_D: "Rumah anjing",
  T_49_META_TYP_92_I86_D: "Billboard",
  T_49_META_TYP_92_I87_D: "Tangki Air",
  T_49_META_TYP_92_I88_D: "Dinding grafiti",
  T_49_META_TYP_92_I89_D: "Kandang",
  T_49_META_TYP_92_I9_D: "Kabin",
  T_49_META_TYP_92_I90_D: "Jembatan lengkung batu",
  T_49_META_TYP_92_I91_D: "Set patio dengan payung",
  T_49_META_TYP_92_I92_D: "Spanduk finish",
  T_49_META_TYP_92_I93_D: "Benteng",
  T_49_META_TYP_92_I94_D: "Titik Spawn Monster",
  T_49_META_TYP_92_I95_D: "Markah",
  T_49_META_TYP_92_I97_D: "Pemicu khusus",
  T_49_META_TYP_92_I98_D: "Pintu ganda",
  T_49_META_TYP_92_I99_D: "Barrikade",
  T_49_META_TYP_94_I0_D: "Tambah",
  T_49_META_TYP_94_I1_D: "Kalikan",
  T_49_META_TYP_95_I0_D: "Jenis Uang",
  T_49_META_TYP_95_I1_D: "kuantitas mata uang",
  T_49_META_TYP_96_I0_D: "Dapatkan Dompet",
  T_49_META_TYP_96_I1_D: "Posisi tampilan (jangkar di pojok kanan atas)",
  T_49_META_TYP_97_I0_D: "Posisi dalam sistem koordinat dunia",
  T_49_META_TYP_97_I1_D: "Sudut rotasi dalam sistem koordinat dunia, komponen XYZ adalah pitch, yaw, dan roll, dan urutan rotasi YXZ.",
  T_49_META_TYP_97_I10_D: "Orientasi sumbu x sumbu lokal",
  T_49_META_TYP_97_I11_D: "Orientasi sumbu z sumbu lokal",
  T_49_META_TYP_97_I2_D: "Ukuran penskalaan dalam sistem koordinat dunia",
  T_49_META_TYP_97_I3_D: "Simpul induk dari simpul ini",
  T_49_META_TYP_97_I4_D: "Rotasi dalam sistem koordinat dunia, dinyatakan dalam kuaternion",
  T_49_META_TYP_97_I5_D: "Posisi dalam sistem koordinat lokal",
  T_49_META_TYP_97_I6_D: "Rotasi dalam sistem koordinat lokal, dinyatakan sebagai kuaternion",
  T_49_META_TYP_97_I7_D: "Sudut rotasi dalam sistem koordinat lokal, dengan komponen XYZ untuk pitch, yaw, dan roll, dan urutan rotasi YXZ.",
  T_49_META_TYP_97_I8_D: "Dimensi penskalaan dalam sistem koordinat lokal",
  T_49_META_TYP_97_I9_D: "Orientasi sumbu y sumbu koordinat lokal",
  T_49_META_TYP_99_I0_D: "Radius sepak bola",
  T_49_META_TYP_99_I1_D: "Koefisien gesekan pada kondisi normal",
  T_49_META_TYP_99_I2_D: "Gesekan Benturan",
  T_49_META_TYP_99_I3_D: "Sudut Tembak Minimum",
  T_49_META_TYP_99_I4_D: "Sudut Elevasi Minimum",
  T_49_META_TYP_99_I5_D: "Waktu Reset",
  T_49_META_TYP_99_I6_D: "Sudut Tembak Maksimum",
  T_49_META_TYP_99_I7_D: "Posisi Reset",
  T_49_META_TYPE_0_D: "Objek, akar dari hirarki tipe",
  T_49_META_TYPE_1_D: "Wadah untuk sekumpulan data dalam sebuah daftar",
  T_49_META_TYPE_10_D: "Komponen dasar entitas, semua komponen akan menggabungkan komponen ini",
  T_49_META_TYPE_100_D: "Mesin Jersey",
  T_49_META_TYPE_101_D: "Objek Morf",
  T_49_META_TYPE_1010_D: "Info Timer",
  T_49_META_TYPE_1011_D: "Spanduk Pembukaan",
  T_49_META_TYPE_1012_D: "Entitas spanduk dimulai pada ronde dua tim, memodifikasi atribut entitas akan memengaruhi apa yang ditampilkan pada UI terkait.",
  T_49_META_TYPE_1013_D: "Entitas spanduk mulai ronde umum, memodifikasi atribut entitas akan memengaruhi konten tampilan pada UI terkait.",
  T_49_META_TYPE_1014_D: "Entitas banner skor ronde tim, memodifikasi atribut entitas akan mempengaruhi tampilan pada UI terkait.",
  T_49_META_TYPE_1015_D: "Entitas Checkpoint Manager, memodifikasi atribut entitas akan mempengaruhi tampilan pada UI terkait.",
  T_49_META_TYPE_1016_D: "Entitas tampilan akhir giliran, memodifikasi atribut entitas akan mempengaruhi tampilan pada UI yang sesuai.",
  T_49_META_TYPE_1017_D: "Jika ada dua tim di awal ronde, tampilkan banner persaingan kedua tim.",
  T_49_META_TYPE_1018_D: "Skor ronde dari kedua tim",
  T_49_META_TYPE_1019_D: "Hasil akhir adalah seri menang/kalah",
  T_49_META_TYPE_102_D: "Jenis sumber kebangkitan: mati, turun",
  T_49_META_TYPE_1020_D: "Entitas penghitungan ronde, memodifikasi atribut entitas akan mempengaruhi konten tampilan pada UI yang sesuai.",
  T_49_META_TYPE_1021_D: "Entitas hitung mundur babak, memodifikasi atribut entitas akan memengaruhi konten tampilan pada UI terkait.",
  T_49_META_TYPE_1022_D: "Entitas subjudul informasi pertandingan, memodifikasi atribut entitas akan memengaruhi konten tampilan pada UI terkait.",
  T_49_META_TYPE_1023_D: "Dua tim mencocokkan entitas informasi, memodifikasi atribut entitas untuk mempengaruhi konten tampilan pada UI yang sesuai.",
  T_49_META_TYPE_1024_D: "Entitas UI informasi kecocokan tim, memodifikasi atribut entitas untuk memengaruhi konten tampilan pada UI yang sesuai",
  T_49_META_TYPE_1027_D: "Menjelaskan jenis tipe dan mengembalikan tipe tersebut ketika Typeof digunakan",
  T_49_META_TYPE_1028_D: "Entitas informasi kamp, memodifikasi atribut entitas untuk memengaruhi konten tampilan pada UI terkait.",
  T_49_META_TYPE_1029_D: "Entitas informasi petunjuk ikon, memodifikasi atribut entitas akan memengaruhi konten yang ditampilkan pada UI terkait.",
  T_49_META_TYPE_103_D: "Pencacahan slot item",
  T_49_META_TYPE_1030_D: "Entitas informasi pertandingan dua tim versi singkat, memodifikasi atribut entitas akan memengaruhi konten yang ditampilkan pada UI terkait.",
  T_49_META_TYPE_1031_D: "Entitas antarmuka petunjuk waktu, memodifikasi properti entitas akan memengaruhi konten yang ditampilkan di UI terkait.",
  T_49_META_TYPE_1032_D: "Entitas prompt kata mengambang, memodifikasi atribut entitas akan mempengaruhi konten tampilan pada UI yang sesuai.",
  T_49_META_TYPE_1033_D: "Entitas peralihan ronde, termasuk penyelesaian ronde saat ini dan informasi awal ronde berikutnya, memodifikasi properti entitas akan memengaruhi konten tampilan pada UI terkait.",
  T_49_META_TYPE_1035_D: "Entitas UI tombol papan skor, memodifikasi atribut entitas akan mempengaruhi konten tampilan pada UI yang sesuai.",
  T_49_META_TYPE_1036_D: "Mode terinfeksi, menampilkan UI level zombie saat ini.",
  T_49_META_TYPE_1037_D: "Menambahkan entitas UI animasi poin, memodifikasi atribut entitas akan mempengaruhi konten tampilan pada UI yang sesuai.",
  T_49_META_TYPE_1038_D: "Efek UI zombie mode terinfeksi",
  T_49_META_TYPE_1039_D: "Entitas hitung mundur, memodifikasi properti entitas akan mempengaruhi konten tampilan pada UI yang sesuai.",
  T_49_META_TYPE_104_D: "Gaya Jersey",
  T_49_META_TYPE_1040_D: "UI Panel Pemilihan Kartu",
  T_49_META_TYPE_1041_D: "UI Notifikasi Identitas",
  T_49_META_TYPE_1042_D: "UI Hitung Mundur 5 Detik",
  T_49_META_TYPE_1043_D: "UI Banner Title",
  T_49_META_TYPE_1044_D: "Sakelar Bawaan UI",
  T_49_META_TYPE_1045_D: "UI Tombol Skill",
  T_49_META_TYPE_105_D: "Gol Sepak Bola",
  T_49_META_TYPE_106_D: "Jenis bantuan yang membidik",
  T_49_META_TYPE_107_D: "Entitas yang dapat ditargetkan dan dipukul, tidak harus rusak",
  T_49_META_TYPE_108_D: "Jenis bilangan bulat, bilangan bulat bertanda 64-bit",
  T_49_META_TYPE_109_D: "Entitas saluran obrolan adalah sebuah wadah yang berisi ID saluran dan pemainnya.",
  T_49_META_TYPE_11_D: "Entitas global, unik untuk seluruh permainan",
  T_49_META_TYPE_110_D: "Saluran suara tidak aktif",
  T_49_META_TYPE_111_D: "Jenis perilaku",
  T_49_META_TYPE_112_D: "Jenis Status Perilaku Pemain",
  T_49_META_TYPE_113_D: "Musik Drum",
  T_49_META_TYPE_114_D: "Musik Lead1",
  T_49_META_TYPE_115_D: "Musik Lead2",
  T_49_META_TYPE_116_D: "Musik Lead3",
  T_49_META_TYPE_117_D: "Jenis komponen musik ketukan drum",
  T_49_META_TYPE_118_D: "Faksi",
  T_49_META_TYPE_119_D: "Opsi yang dapat diserang",
  T_49_META_TYPE_12_D: "Entitas tempur, dapat menyerang, menerima serangan, membunuh, dll.",
  T_49_META_TYPE_120_D: "UI Bar Progress",
  T_49_META_TYPE_121_D: "Interval antara gelombang",
  T_49_META_TYPE_122_D: "Kotak Langit",
  T_49_META_TYPE_123_D: "Pencacahan tipe dasar skybox",
  T_49_META_TYPE_124_D: "Rentang Klaim Musuh",
  T_49_META_TYPE_125_D: "Dapat memodifikasi tampilan dasar objek, seperti pemetaan dan transparansi",
  T_49_META_TYPE_126_D: "Bar Kesehatan",
  T_49_META_TYPE_127_D: "Cara memindahkan objek",
  T_49_META_TYPE_128_D: "Objek yang Dapat Dimorf",
  T_49_META_TYPE_129_D: "Jenis Amunisi Loot",
  T_49_META_TYPE_13_D: "Entitas kontrol UI",
  T_49_META_TYPE_130_D: "Jenis Konsumable Loot",
  T_49_META_TYPE_131_D: "Jenis Armor Loot",
  T_49_META_TYPE_132_D: "Jenis Barang Lempar Loot",
  T_49_META_TYPE_133_D: "Jenis Scope Loot",
  T_49_META_TYPE_134_D: "Jenis Senjata Loot",
  T_49_META_TYPE_135_D: "Menghasilkan drop amunisi dari jenis yang dipilih",
  T_49_META_TYPE_136_D: "Menghasilkan jenis drop prop yang dipilih",
  T_49_META_TYPE_137_D: "Menghasilkan jenis drop proyektil yang dipilih",
  T_49_META_TYPE_138_D: "Menghasilkan drop cakupan dari jenis yang dipilih",
  T_49_META_TYPE_139_D: "Menghasilkan drop pertahanan dari jenis yang dipilih.",
  T_49_META_TYPE_14_D: "Entitas pemain dalam game, satu per pengguna",
  T_49_META_TYPE_140_D: "Gelombang",
  T_49_META_TYPE_141_D: "Jenis Loot Sepak Bola",
  T_49_META_TYPE_142_D: "Kotak Loot Sepak Bola",
  T_49_META_TYPE_143_D: "Jenis komponen musik Lead1",
  T_49_META_TYPE_144_D: "Jenis Komponen Musik Lead2",
  T_49_META_TYPE_145_D: "Jenis Komponen Musik Lead3",
  T_49_META_TYPE_146_D: "Jenis Komponen Musik Kunci",
  T_49_META_TYPE_147_D: "Tersedia beberapa jenis kamera prasetel, serta jenis kamera khusus",
  T_49_META_TYPE_148_D: "Komponen kamera",
  T_49_META_TYPE_149_D: "Localization Key",
  T_49_META_TYPE_15_D: "Entitas tim dalam game, satu per tim",
  T_49_META_TYPE_150_D: "Drum Minyak",
  T_49_META_TYPE_151_D: "Quaternion adalah vektor empat dimensi khusus, yang hanya digunakan untuk merepresentasikan rotasi",
  T_49_META_TYPE_152_D: "Area Gravitasi Rendah",
  T_49_META_TYPE_153_D: "Wadah entitas, yang menghasilkan entitas dengan tipe yang sesuai di lokasi.",
  T_49_META_TYPE_154_D: "Jenis Senjata Ganda",
  T_49_META_TYPE_155_D: "Entitas helm",
  T_49_META_TYPE_156_D: "Pelindung tubuh",
  T_49_META_TYPE_157_D: "Jenis Transisi Kamera",
  T_49_META_TYPE_158_D: "Antarmuka prompt teks",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Entitas objek level",
  T_49_META_TYPE_160_D: "Jenis Tekstur",
  T_49_META_TYPE_161_D: "VFX Tekstur yang Tidak Dapat Diganti",
  T_49_META_TYPE_162_D: "Daftar Tipe",
  T_49_META_TYPE_163_D: "Tipe atau Daftar Tipe",
  T_49_META_TYPE_164_D: "Komponen adalah kelas dasar dari semua komponen entitas atau kelas komponen tertentu.",
  T_49_META_TYPE_165_D: "Komponen kotak tabrakan",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "Entitas efek khusus mewakili efek khusus yang ditampilkan (dihapus, dapat digunakan kembali).",
  T_49_META_TYPE_17_D: "Daftar Objek Level",
  T_49_META_TYPE_170_D: "Menunjukkan apakah visibilitas dapat diatur",
  T_49_META_TYPE_171_D: "Jamur",
  T_49_META_TYPE_172_D: "Amunisi",
  T_49_META_TYPE_173_D: "Ransel",
  T_49_META_TYPE_174_D: "Komponen Granat",
  T_49_META_TYPE_175_D: "Granat Pembeku",
  T_49_META_TYPE_176_D: "Generator Senjata",
  T_49_META_TYPE_177_D: "Mode gerak kamera ketika ada penghalang antara kamera dan objek yang diikuti",
  T_49_META_TYPE_178_D: "Gaya penggambaran kamera saat merender layar",
  T_49_META_TYPE_179_D: "Bola Dasar",
  T_49_META_TYPE_18_D: "(Sudah tidak digunakan lagi, jangan gunakan)",
  T_49_META_TYPE_180_D: "merujuk ke properti dari sebuah komponen",
  T_49_META_TYPE_181_D: "Tipe yang digunakan untuk mendeskripsikan aset mesh",
  T_49_META_TYPE_182_D: "Tipe yang digunakan untuk mendeskripsikan aset material",
  T_49_META_TYPE_183_D: "Tipe untuk mendeskripsikan aset tekstur",
  T_49_META_TYPE_184_D: "Komponen rendering yang dijembatani untuk rendering dengan sumber daya model bawaan",
  T_49_META_TYPE_185_D: "Komponen rendering khusus untuk rendering dengan sumber daya model khusus",
  T_49_META_TYPE_186_D: "Rakitan objek kosong yang dapat digunakan bersama dengan rakitan penyaji, rakitan penabrak, dll.",
  T_49_META_TYPE_187_D: "Kontainer",
  T_49_META_TYPE_188_D: "Silinder atau Kerucut Dasar",
  T_49_META_TYPE_189_D: "Daftar string yang dilokalkan",
  T_49_META_TYPE_19_D: "Templat daftar, jenis konten dapat ditentukan oleh T",
  T_49_META_TYPE_190_D: "Panel Skor Dua Tim",
  T_49_META_TYPE_191_D: "Senjata lemparan taktis yang membutakan musuh dalam jarak tertentu untuk waktu yang singkat.",
  T_49_META_TYPE_192_D: "Ketika digunakan, dapat menghasilkan asap yang mengaburkan kejadian, alat yang berguna untuk mengganggu serangan musuh.",
  T_49_META_TYPE_193_D: "Panel Hasil Multi-Tim",
  T_49_META_TYPE_194_D: "Ranjau sensor yang dapat ditempatkan di tanah dan akan meledak ketika musuh mendekat, berhati-hatilah agar tidak menginjaknya sendiri",
  T_49_META_TYPE_195_D: "Permainan Gerakan Interpolasi",
  T_49_META_TYPE_197_D: "Komponen yang Dapat Dimainkan",
  T_49_META_TYPE_198_D: "Basis Barang",
  T_49_META_TYPE_199_D: "Membantu dalam pertempuran udara, tetapi Anda harus selalu waspada terhadap konsumsi energi.",
  T_49_META_TYPE_2_D: "Tipe Boolean, digunakan untuk menunjukkan benar, salah, atau ya atau tidak",
  T_49_META_TYPE_20_D: "Enumerasi tipe antarmuka bawaan, yang secara otomatis dihasilkan oleh sistem tipe.",
  T_49_META_TYPE_200_D: "Area jailbreak",
  T_49_META_TYPE_201_D: "Area di mana Anda bisa berenang setelah masuk",
  T_49_META_TYPE_202_D: "ID Collider",
  T_49_META_TYPE_203_D: "Gerakan Interpolasi",
  T_49_META_TYPE_204_D: "Sepatu yang dilengkapi dengan power-up teknologi yang memungkinkan Anda untuk melompat di udara dalam dua tahap",
  T_49_META_TYPE_205_D: "Pesawat layang yang bisa terbang di langit, gunakan untuk mendarat dari tempat yang tinggi untuk bergerak lebih jauh",
  T_49_META_TYPE_206_D: "Skateboard",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "Daftar yang Dapat Dimainkan",
  T_49_META_TYPE_209_D: "Dapat Dimainkan atau Daftar Dapat Dimainkan",
  T_49_META_TYPE_21_D: "Entitas antarmuka bawaan, yang merangkum fungsionalitas tertentu.",
  T_49_META_TYPE_210_D: "Animasi balistik adalah simulasi gerakan balistik.",
  T_49_META_TYPE_211_D: "Sistem Koordinat",
  T_49_META_TYPE_212_D: "Sebuah objek mengikuti objek lain",
  T_49_META_TYPE_213_D: "Wajah depan objek selalu menghadap objek lain.",
  T_49_META_TYPE_214_D: "ID untuk mendeskripsikan aset sprite galeri",
  T_49_META_TYPE_215_D: "hasil pertandingan",
  T_49_META_TYPE_216_D: "Wadah data kamus, elemen datanya berupa pasangan Key, Value",
  T_49_META_TYPE_217_D: "Templat data kamus, jenis konten dapat ditentukan oleh T1, T2",
  T_49_META_TYPE_218_D: "Jenis sumber cahaya yang memancarkan cahaya dengan intensitas yang sama ke segala arah dari posisi sumber cahaya.",
  T_49_META_TYPE_219_D: "Pengangkut sepeda motor",
  T_49_META_TYPE_22_D: "Antarmuka khusus, yang dibuat oleh pemain melalui editor antarmuka.",
  T_49_META_TYPE_220_D: "Pengangkut kendaraan serbu (roda tiga)",
  T_49_META_TYPE_221_D: "Kendaraan Sepeda Motor Amfibi/Senapan Mesin",
  T_49_META_TYPE_222_D: "Kendaraan roda empat",
  T_49_META_TYPE_224_D: "Daftar Tipe Skill",
  T_49_META_TYPE_225_D: "Turret AI yang terbuat dari bahan berteknologi tinggi yang secara aktif mencari dan menyerang musuh dalam jarak tertentu.",
  T_49_META_TYPE_226_D: "Turret yang dihasilkan dengan menggunakan alat peraga turret",
  T_49_META_TYPE_227_D: "Pencacahan jenis kontrol UI khusus",
  T_49_META_TYPE_23_D: "Enumerasi jenis objek level, yang secara otomatis dihasilkan berdasarkan jenisnya.",
  T_49_META_TYPE_231_D: "Kit Perbaikan",
  T_49_META_TYPE_233_D: "Lingkaran Progres",
  T_49_META_TYPE_234_D: "Landmine yang Dibuat",
  T_49_META_TYPE_235_D: "Dinding Gel",
  T_49_META_TYPE_236_D: "Dinding Es yang Dibuat",
  T_49_META_TYPE_237_D: "Senjata Hook",
  T_49_META_TYPE_238_D: "Pistol Cat Pelangi",
  T_49_META_TYPE_239_D: "Senapan Semprot",
  T_49_META_TYPE_24_D: "Jenis kerusakan yang ditentukan sistem saat ini",
  T_49_META_TYPE_240_D: "Entitas adalah pembawa semua komponen, dan komponen harus dilampirkan ke entitas untuk menghasilkan instance",
  T_49_META_TYPE_241_D: "Pistol Pengait Daya",
  T_49_META_TYPE_242_D: "Bar Skor",
  T_49_META_TYPE_243_D: "Slot pakaian",
  T_49_META_TYPE_244_D: "Entitas teks mewakili teks yang ditampilkan",
  T_49_META_TYPE_245_D: "Entitas ikon mewakili ikon yang ditampilkan",
  T_49_META_TYPE_246_D: "Warna Semprot",
  T_49_META_TYPE_247_D: "Jenis UI Pemain",
  T_49_META_TYPE_248_D: "Entitas sakelar UI umum",
  T_49_META_TYPE_249_D: "Beralih Slot Perlengkapan",
  T_49_META_TYPE_25_D: "Fase-fase permainan, seperti awal permainan, persiapan permainan, akhir permainan, dll.",
  T_49_META_TYPE_250_D: "Entitas efek mewakili efek khusus yang ditampilkan",
  T_49_META_TYPE_2500_D: "Titik kelahiran pemain",
  T_49_META_TYPE_2501_D: "Pemicu untuk memicu peristiwa masuk-keluar pemain (atau objek lain)",
  T_49_META_TYPE_2502_D: "Pemicu kematian atau tak terkalahkan yang mengontrol apakah pemain mati atau tak terkalahkan saat masuk berdasarkan atribut",
  T_49_META_TYPE_2503_D: "Pos pemeriksaan mode balapan",
  T_49_META_TYPE_2504_D: "Biasanya digunakan dalam Mode Balapan untuk mengenali saat pemain memasuki garis finis yang ditentukan. Ini adalah pemicu khusus, pemicu khusus akan dibuka di kemudian hari, titik akhir ini hanyalah pembungkus untuk pemicu khusus.",
  T_49_META_TYPE_2505_D: "Pagar di sekitar titik lahir, tutup untuk meninggalkan titik lahir",
  T_49_META_TYPE_2507_D: "Menara",
  T_49_META_TYPE_2508_D: "Spawn Monster",
  T_49_META_TYPE_2509_D: "Contoh dari tipe ini dapat dibuat sesuai permintaan",
  T_49_META_TYPE_251_D: "Kontainer Efek",
  T_49_META_TYPE_2510_D: "Area kelahiran pemain (persegi panjang)",
  T_49_META_TYPE_252_D: "UI Hasil Spray",
  T_49_META_TYPE_253_D: "Tombol Petunjuk",
  T_49_META_TYPE_254_D: "Efek Detak Jantung",
  T_49_META_TYPE_255_D: "String Lokalisasi Cap Waktu",
  T_49_META_TYPE_256_D: "Tipe Rigidbody",
  T_49_META_TYPE_257_D: "Komponen tubuh yang kaku",
  T_49_META_TYPE_258_D: "Jenis Gaya Format Timestamp",
  T_49_META_TYPE_259_D: "Tips",
  T_49_META_TYPE_26_D: "Giliran dalam permainan, sering kali permainan kecil dengan beberapa fase.",
  T_49_META_TYPE_260_D: "Tombol Skill Progres",
  T_49_META_TYPE_261_D: "ID unik",
  T_49_META_TYPE_262_D: "ID Skin Senjata",
  T_49_META_TYPE_263_D: "ID Pakaian",
  T_49_META_TYPE_264_D: "ID alat peraga, ketika versi hanya memiliki ID senjata",
  T_49_META_TYPE_265_D: "Entitas panel UI",
  T_49_META_TYPE_267_D: "Entitas tampilan gulir UI, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_268_D: "Sakelar dengan tiga status, dengan opsi untuk mempertahankan logika asli kecuali untuk hidup dan mati.",
  T_49_META_TYPE_269_D: "Pakaian yang digunakan pemain",
  T_49_META_TYPE_270_D: "ID Prefab atau Entitas",
  T_49_META_TYPE_271_D: "Entitas panel UI, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_272_D: "Pencacahan jenis kelamin",
  T_49_META_TYPE_273_D: "Mini Peta",
  T_49_META_TYPE_274_D: "Ikon yang ditampilkan pada peta mini untuk mengikuti target",
  T_49_META_TYPE_275_D: "Node bagian individual dalam kerangka",
  T_49_META_TYPE_276_D: "Node yang digunakan untuk mengakses kerangka yang dikuliti",
  T_49_META_TYPE_277_D: "Deteksi sinar kamera sisi klien",
  T_49_META_TYPE_278_D: "Blok piksel yang ditampilkan pada peta mini, mewakili ukuran tabrakan objek di lokasi tersebut.",
  T_49_META_TYPE_279_D: "Drum Warna",
  T_49_META_TYPE_28_D: "Setel ulang di awal setiap giliran.",
  T_49_META_TYPE_280_D: "Pemicu Bola",
  T_49_META_TYPE_281_D: "Pemicu Kapsul",
  T_49_META_TYPE_282_D: "Jenis yang menjelaskan ID konfigurasi aset, digunakan untuk menunjukkan bahwa paket induk dilengkapi dengan ID konfigurasi aset, yang perlu diuraikan melalui tabel konfigurasi sebelum dimuat",
  T_49_META_TYPE_283_D: "Jenis aset, digunakan untuk menunjukkan pengenal aset, yang dapat dimuat secara langsung.",
  T_49_META_TYPE_284_D: "Menunjukkan sumber daya model humanoid yang dapat diganti dengan karakter pemain",
  T_49_META_TYPE_285_D: "Daftar atau kamus, yang dapat dilalui secara siklis",
  T_49_META_TYPE_286_D: "ID untuk mendeskripsikan aset skrip",
  T_49_META_TYPE_287_D: "untuk mendeskripsikan ID aset skrip statis",
  T_49_META_TYPE_288_D: "untuk mendeskripsikan ID aset antarmuka kustom",
  T_49_META_TYPE_289_D: "ID untuk mendeskripsikan badan aset yang telah dikonfigurasi sebelumnya",
  T_49_META_TYPE_29_D: "Efek khusus",
  T_49_META_TYPE_290_D: "Pohon Perilaku",
  T_49_META_TYPE_291_D: "Jenis Node Pohon Perilaku",
  T_49_META_TYPE_292_D: "Node Kustom Pohon Perilaku",
  T_49_META_TYPE_293_D: "Entitas yang Dapat Ditempelkan ke Pohon Perilaku",
  T_49_META_TYPE_294_D: "Entitas tata letak UI, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_295_D: "Status",
  T_49_META_TYPE_296_D: "Klip Animasi",
  T_49_META_TYPE_297_D: "Kontroler Animasi",
  T_49_META_TYPE_298_D: "Jenis Loop",
  T_49_META_TYPE_3_D: "Tipe bilangan bulat, bilangan bulat bertanda 32-bit",
  T_49_META_TYPE_30_D: "Ikon",
  T_49_META_TYPE_300_D: "Entitas UI3DContainer, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_301_D: "Jenis Keterampilan AI",
  T_49_META_TYPE_302_D: "Pencacahan slot peralatan",
  T_49_META_TYPE_303_D: "Sesuai dengan kolom Id di BuffData.csv, silakan periksa dengan GPP sebelum menambahkan item baru.",
  T_49_META_TYPE_304_D: "Daftar Tipe Buff",
  T_49_META_TYPE_305_D: "Status Node Pohon Perilaku",
  T_49_META_TYPE_306_D: "Dapat menambahkan buff, menghapus buff, mendapatkan daftar buff yang sudah ditambahkan",
  T_49_META_TYPE_307_D: "Pembuat Dinding Es",
  T_49_META_TYPE_308_D: "Jenis ID Barang Khusus",
  T_49_META_TYPE_309_D: "Alat Peraga Objek yang Dilempar",
  T_49_META_TYPE_31_D: "Efek Suara",
  T_49_META_TYPE_310_D: "Busur silang",
  T_49_META_TYPE_311_D: "Dasar Granat",
  T_49_META_TYPE_312_D: "Alat peraga objek yang dilempar",
  T_49_META_TYPE_313_D: "Granat DeIce Wall",
  T_49_META_TYPE_314_D: "Mengelola pengontrol animasi dan sumber daya",
  T_49_META_TYPE_315_D: "Tas Pemain",
  T_49_META_TYPE_316_D: "Entitas UITexture, UI pemain yang diedit oleh editor UI",
  T_49_META_TYPE_317_D: "Batasan gerak benda kaku, yang masing-masing dapat digunakan dalam kombinasi",
  T_49_META_TYPE_318_D: "Aksesori",
  T_49_META_TYPE_319_D: "Pencacahan jenis isian",
  T_49_META_TYPE_32_D: "Jenis status pemain",
  T_49_META_TYPE_320_D: "Arah pengisian",
  T_49_META_TYPE_321_D: "Entitas yang dapat dibantu dengan target",
  T_49_META_TYPE_322_D: "Jenis Bagian Tubuh yang Rusak",
  T_49_META_TYPE_323_D: "Entitas UIProfileInfo, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_324_D: "Beberapa efek yang berbeda dari gaya benda kaku. Perhatikan bahwa ini hanya tersedia untuk tipe Dinamis.",
  T_49_META_TYPE_325_D: "untuk mendeskripsikan ID kontrol dalam aset antarmuka kustom",
  T_49_META_TYPE_326_D: "Informasi profil pemain",
  T_49_META_TYPE_327_D: "Mengonfigurasi balutan sesuai dengan masing-masing komponen",
  T_49_META_TYPE_328_D: "ID Pohon Perilaku",
  T_49_META_TYPE_329_D: "Jenis Kursi",
  T_49_META_TYPE_33_D: "Urutkan berdasarkan: naik, abaikan nilai nol, turun, naik",
  T_49_META_TYPE_330_D: "Gerakan relatif terhadap dirinya sendiri",
  T_49_META_TYPE_331_D: "Kurva Bezier",
  T_49_META_TYPE_332_D: "Komponen yang dapat diulang",
  T_49_META_TYPE_333_D: "Jenis Font",
  T_49_META_TYPE_334_D: "ID Skin Kendaraan",
  T_49_META_TYPE_335_D: "Entitas suara mewakili efek suara yang dimainkan",
  T_49_META_TYPE_336_D: "Daftar Efek Suara",
  T_49_META_TYPE_337_D: "Efek Suara atau Daftar Efek Suara",
  T_49_META_TYPE_338_D: "Entitas sinkronisasi atribut perilaku pemain",
  T_49_META_TYPE_339_D: "Aksesori Peralatan",
  T_49_META_TYPE_34_D: "ID Item",
  T_49_META_TYPE_340_D: "Jenis Kesulitan Bot",
  T_49_META_TYPE_341_D: "Kamus bilangan bulat",
  T_49_META_TYPE_342_D: "Objek pengatur waktu",
  T_49_META_TYPE_343_D: "Belati Terbang (dapat diambil)",
  T_49_META_TYPE_344_D: "Pisau Lempar",
  T_49_META_TYPE_345_D: "Jenis Senjata",
  T_49_META_TYPE_346_D: "Jenis Amunisi",
  T_49_META_TYPE_347_D: "Gerakan Relatif Sendiri per Frame",
  T_49_META_TYPE_348_D: "Penunjuk fungsi ke instance fungsi, digunakan untuk mengimplementasikan fungsi tiruan atau mekanisme pendelegasian.",
  T_49_META_TYPE_349_D: "Pegangan ke sebuah thread, yang dapat digunakan untuk melakukan beberapa operasi pegangan.",
  T_49_META_TYPE_350_D: "Pencacahan kendaraan",
  T_49_META_TYPE_351_D: "Menjelaskan jenis objek",
  T_49_META_TYPE_352_D: "Entitas UIToggle, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_353_D: "Kot Pertolongan Pertama",
  T_49_META_TYPE_354_D: "Inhaler",
  T_49_META_TYPE_355_D: "Garis Horisontal",
  T_49_META_TYPE_356_D: "Airdrops, akan mulai dijatuhkan dari tempat yang tinggi setelah waktu persiapan selesai",
  T_49_META_TYPE_357_D: "Warna deskriptif untuk objek, misalnya batas, permukaan, dll. (dihapus, dapat digunakan kembali)",
  T_49_META_TYPE_358_D: "Mengacu pada sebuah peristiwa",
  T_49_META_TYPE_359_D: "Pengontrol pemain dengan efek fisika, yang dapat menerapkan gaya ke gaya",
  T_49_META_TYPE_360_D: "Peluncur Roket",
  T_49_META_TYPE_361_D: "Meriam yang dilipat, ketika dibuka dapat digunakan untuk meluncurkan orang keluar, hati-hati jangan sampai Anda keluar dari zona aman!",
  T_49_META_TYPE_362_D: "Pertarungan bola salju! Pukul!",
  T_49_META_TYPE_363_D: "Pembelian permintaan toko",
  T_49_META_TYPE_364_D: "Pemicu Animasi",
  T_49_META_TYPE_365_D: "Komponen Antarmuka Pemicu Animasi",
  T_49_META_TYPE_366_D: "Batch Combine Render",
  T_49_META_TYPE_367_D: "Kompas Atas",
  T_49_META_TYPE_368_D: "ID sumber daya peran khusus",
  T_49_META_TYPE_369_D: "ID sumber daya animasi khusus",
  T_49_META_TYPE_370_D: "Informasi yang ditampilkan di awal ronde",
  T_49_META_TYPE_371_D: "Di akhir setiap ronde, hasilnya ditampilkan",
  T_49_META_TYPE_372_D: "Jenis Sikap Pemain",
  T_49_META_TYPE_373_D: "ID koleksi, digunakan untuk pengumpulan informasi sumber daya",
  T_49_META_TYPE_374_D: "Bilah Kesehatan Ikuti",
  T_49_META_TYPE_375_D: "Jenis target monster",
  T_49_META_TYPE_376_D: "Jenis target serangan menara pertahanan",
  T_49_META_TYPE_377_D: "Alias mengacu pada jenis entitas pemain atau entitas kendaraan",
  T_49_META_TYPE_378_D: "untuk mendeskripsikan ID aset audio",
  T_49_META_TYPE_379_D: "ID untuk mendeskripsikan aset tabel konfigurasi",
  T_49_META_TYPE_38_D: "Entitas UI Widget Kosong, UI yang diedit oleh pemain melalui editor UI.",
  T_49_META_TYPE_380_D: "ID untuk mendeskripsikan aset efek",
  T_49_META_TYPE_381_D: "ID untuk mendeskripsikan aset pengontrol animasi",
  T_49_META_TYPE_382_D: "Penanganan status knockdown",
  T_49_META_TYPE_383_D: "Permukaan atau dekorasi pada peta itu sendiri",
  T_49_META_TYPE_384_D: "Barang",
  T_49_META_TYPE_385_D: "ID Keterampilan Karakter",
  T_49_META_TYPE_386_D: "Daftar ID Skill",
  T_49_META_TYPE_387_D: "Entitas UITouchPad, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_388_D: "ID Skin Tas",
  T_49_META_TYPE_389_D: "Entitas Joystick, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_39_D: "Entitas gambar UI, UI yang diedit oleh pemain melalui editor UI.",
  T_49_META_TYPE_390_D: "Hierarkis",
  T_49_META_TYPE_391_D: "UI Kustom atau Widget",
  T_49_META_TYPE_392_D: "Objek cincin racun yang dapat ditempatkan",
  T_49_META_TYPE_393_D: "Entitas dengan komponen PhysicalCCT atau Rigidbody.",
  T_49_META_TYPE_394_D: "Konstanta matematika",
  T_49_META_TYPE_395_D: "Entitas dengan komponen PhysicalCCT atau PlayerCCT dapat bergerak bersama mereka.",
  T_49_META_TYPE_396_D: "Konfigurasi Keluar Pertengahan Permainan",
  T_49_META_TYPE_397_D: "Komponen yang digunakan untuk menggambarkan bentuk tabrakan",
  T_49_META_TYPE_398_D: "String atau String Lokalisasi",
  T_49_META_TYPE_399_D: "Pengontrol Karakter dengan Efek Fisik, hanya untuk karakter FF.",
  T_49_META_TYPE_4_D: "Jenis titik mengambang, angka titik mengambang presisi tunggal 32-bit",
  T_49_META_TYPE_40_D: "Entitas Teks UI, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_400_D: "Cara melakukan perilaku serangan",
  T_49_META_TYPE_401_D: "Jenis Api",
  T_49_META_TYPE_402_D: "Widget Tombol Sosial",
  T_49_META_TYPE_403_D: "Jenis Tombol Sosial",
  T_49_META_TYPE_404_D: "Gaya tombol sosial",
  T_49_META_TYPE_405_D: "Jenis Pengurutan Tata Letak",
  T_49_META_TYPE_406_D: "Dapat dipicu untuk melewati rintangan",
  T_49_META_TYPE_407_D: "Jenis Platform",
  T_49_META_TYPE_408_D: "Alias Data Dasar",
  T_49_META_TYPE_409_D: "Pencacahan kode kesalahan",
  T_49_META_TYPE_41_D: "Entitas tombol UI, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_410_D: "Alias yang merujuk ke entitas pemain atau tipe entitas Transform",
  T_49_META_TYPE_411_D: "Pengangkut Helikopter",
  T_49_META_TYPE_412_D: "Komponen Kendaraan, yang merupakan perpanjangan dari komponen Carrier.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Membatasi rentang sudut rotasi kamera",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Antarmuka jendela obrolan Persona",
  T_49_META_TYPE_417_D: "Komponen Entitas Partikel",
  T_49_META_TYPE_418_D: "Pencacahan status anggota",
  T_49_META_TYPE_419_D: "Jenis kulit senjata",
  T_49_META_TYPE_42_D: "Entitas input UI, UI yang diedit oleh pemain melalui editor UI",
  T_49_META_TYPE_420_D: "Jenis kulit kendaraan",
  T_49_META_TYPE_421_D: "Jenis kulit",
  T_49_META_TYPE_422_D: "Jenis Kulit Ransel",
  T_49_META_TYPE_423_D: "ID Persona",
  T_49_META_TYPE_424_D: "Tipe dasar efek kabut",
  T_49_META_TYPE_425_D: "ID aset partikel",
  T_49_META_TYPE_426_D: "Jenis sumber cahaya yang memancarkan kerucut cahaya pada arah sumbu Y negatif dari sumber cahaya, yang mengarah ke tanah.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Informasi pakaian yang akan dipertahankan saat pemain berubah menjadi karakter lain.",
  T_49_META_TYPE_429_D: "Entitas pemain atau NPC",
  T_49_META_TYPE_43_D: "Daftar tipe elemen yang harus berupa entitas pemain",
  T_49_META_TYPE_430_D: "penghasil angka acak",
  T_49_META_TYPE_431_D: "Objek gerak yang bergerak di sepanjang jalur khusus",
  T_49_META_TYPE_432_D: "Titik jalan jalur kurva khusus",
  T_49_META_TYPE_433_D: "Jenis titik jalan jalur kurva khusus",
  T_49_META_TYPE_434_D: "Jalur kurva khusus",
  T_49_META_TYPE_435_D: "Daftar pengenal pemain yang unik",
  T_49_META_TYPE_436_D: "Daftar kode kesalahan",
  T_49_META_TYPE_437_D: "Entitas UI detail pertandingan dua tim, memodifikasi atribut entitas untuk memengaruhi konten tampilan pada UI yang sesuai.",
  T_49_META_TYPE_438_D: "Entitas UI detail pertandingan multi-tim, memodifikasi atribut entitas akan memengaruhi konten tampilan pada UI terkait.",
  T_49_META_TYPE_439_D: "Gabungkan",
  T_49_META_TYPE_44_D: "Daftar entitas yang tipe elemennya harus berupa entitas tim",
  T_49_META_TYPE_440_D: "Garis waktu",
  T_49_META_TYPE_441_D: "ID Sumber Daya Garis Waktu",
  T_49_META_TYPE_442_D: "Komponen entitas versi pendek informasi pertandingan dua tim yang baru, mendukung jumlah orang yang dapat disesuaikan sepenuhnya untuk ditampilkan",
  T_49_META_TYPE_443_D: "ID aset aliran dialog",
  T_49_META_TYPE_444_D: "Jenis Bahasa",
  T_49_META_TYPE_45_D: "Daftar Bool",
  T_49_META_TYPE_46_D: "Daftar Int",
  T_49_META_TYPE_47_D: "Daftar Float",
  T_49_META_TYPE_48_D: "Daftar String",
  T_49_META_TYPE_49_D: "Daftar Vector3",
  T_49_META_TYPE_5_D: "Jenis string, nilai adalah konten teks",
  T_49_META_TYPE_50_D: "Daftar tipe elemen yang harus berupa entitas",
  T_49_META_TYPE_51_D: "Jenis Zombie",
  T_49_META_TYPE_53_D: "Objek Level Umum",
  T_49_META_TYPE_54_D: "Objek yang Dapat Dirusak",
  T_49_META_TYPE_55_D: "Titik Spawn Umum",
  T_49_META_TYPE_56_D: "Kendaraan",
  T_49_META_TYPE_57_D: "Pemain dapat diteleportasi ke lokasi tertentu saat masuk",
  T_49_META_TYPE_58_D: "Buff dapat dihasilkan sesuai permintaan",
  T_49_META_TYPE_59_D: "Platform Gerak",
  T_49_META_TYPE_6_D: "Vektor tiga dimensi, yang dapat mewakili koordinat spasial atau arah spasial",
  T_49_META_TYPE_60_D: "Menghasilkan drop senjata dari jenis yang dipilih",
  T_49_META_TYPE_61_D: "Memasuki jangkauan pemicu akan membuka Toko Terikat",
  T_49_META_TYPE_62_D: "Dadu Melenting",
  T_49_META_TYPE_63_D: "Pemain menginjaknya dan mereka akan terpental ke lokasi tertentu.",
  T_49_META_TYPE_64_D: "Pemain akan mengeluarkan suara saat menginjaknya",
  T_49_META_TYPE_65_D: "Dasar yang Dapat Diperbesar",
  T_49_META_TYPE_66_D: "Jalur Kustom",
  T_49_META_TYPE_67_D: "Titik Jalur",
  T_49_META_TYPE_68_D: "Entitas monster AI, seperti zombie",
  T_49_META_TYPE_69_D: "Bilangan besar adalah bilangan titik mengambang presisi tinggi",
  T_49_META_TYPE_7_D: "Bilangan adalah nama alias tipe yang mengacu pada tipe bilangan bulat, bilangan bulat 64-bit, atau titik mengambang.",
  T_49_META_TYPE_70_D: "Rumus atribut digunakan untuk menghitung nilai atribut entitas, hanya beberapa atribut pemain dan atribut senjata yang didukung untuk saat ini.",
  T_49_META_TYPE_71_D: "Hanya digunakan untuk entitas yang dijual di toko, konsep komoditas berbeda dengan konsep item yang diperoleh dengan membeli komoditas.",
  T_49_META_TYPE_72_D: "Berisi beberapa item",
  T_49_META_TYPE_73_D: "Berisi beberapa rak",
  T_49_META_TYPE_74_D: "ID Item",
  T_49_META_TYPE_75_D: "Kembali",
  T_49_META_TYPE_76_D: "Gaya patroli",
  T_49_META_TYPE_77_D: "Entitas generator yang dapat menghasilkan dan menyegarkan objek.",
  T_49_META_TYPE_78_D: "Entitas unit yang dapat digunakan oleh generator unit untuk menyerap dan menghasilkan unit secara berkelompok.",
  T_49_META_TYPE_79_D: "Senjata",
  T_49_META_TYPE_8_D: "Kondisional adalah tipe Bool khusus",
  T_49_META_TYPE_80_D: "Antarmuka toko",
  T_49_META_TYPE_81_D: "Jenis Buff",
  T_49_META_TYPE_82_D: "UI Detak Jantung",
  T_49_META_TYPE_83_D: "Tombol Interaksi",
  T_49_META_TYPE_84_D: "Entitas yang dapat diberi peringkat, dapat diberi peringkat",
  T_49_META_TYPE_85_D: "Entitas yang dapat diberi skor, memiliki skornya sendiri",
  T_49_META_TYPE_86_D: "Rumus Atribut Jenis Faktor Atribut",
  T_49_META_TYPE_87_D: "Menggambarkan jenis warna RGBA, setiap saluran mengambil nilai dalam kisaran 0 hingga 255",
  T_49_META_TYPE_88_D: "Jenis mata uang, saat ini hanya jenis mata uang dasar",
  T_49_META_TYPE_89_D: "Entitas mata uang, yang menjelaskan jenis dan jumlah mata uang.",
  T_49_META_TYPE_9_D: "Sekumpulan kondisi",
  T_49_META_TYPE_90_D: "Entitas dompet adalah wadah untuk sekumpulan entitas mata uang",
  T_49_META_TYPE_91_D: "Menunjukkan jenis larik bilangan bulat atau bilangan bulat.",
  T_49_META_TYPE_92_D: "Jenis Objek yang Dapat Dibuat Secara Dinamis",
  T_49_META_TYPE_93_D: "Entitas dengan atribut yang dapat dirumuskan",
  T_49_META_TYPE_94_D: "Modifikasi atribut",
  T_49_META_TYPE_95_D: "Generator emas",
  T_49_META_TYPE_96_D: "Dompet",
  T_49_META_TYPE_97_D: "Penskalaan rotasi posisi, mendukung struktur induk-anak",
  T_49_META_TYPE_98_D: "Mencantumkan semua tipe yang tersedia",
  T_49_META_TYPE_99_D: "Sepak Bola"
};
export {
  _ as default
};
